import Storage from '@octadesk/storage';
import Hubspot from 'hubspot';
import axios from 'axios';
import Socket from 'socket.io-client';

var fails = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

// Thank's IE8 for his funny defineProperty
var descriptors = !fails(function () {
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, basedir, module) {
	return module = {
	  path: basedir,
	  exports: {},
	  require: function (path, base) {
      return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
    }
	}, fn(module, module.exports), module.exports;
}

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global_1 =
  // eslint-disable-next-line no-undef
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func
  Function('return this')();

var isObject = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var document$1 = global_1.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document$1) && isObject(document$1.createElement);

var documentCreateElement = function (it) {
  return EXISTS ? document$1.createElement(it) : {};
};

// Thank's IE8 for his funny defineProperty
var ie8DomDefine = !descriptors && !fails(function () {
  return Object.defineProperty(documentCreateElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var anObject = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};

// `ToPrimitive` abstract operation
// https://tc39.github.io/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var toPrimitive = function (input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var nativeDefineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
var f = descriptors ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (ie8DomDefine) try {
    return nativeDefineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var objectDefineProperty = {
	f: f
};

var defineProperty = objectDefineProperty.f;

var FunctionPrototype = Function.prototype;
var FunctionPrototypeToString = FunctionPrototype.toString;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// Function instances `.name` property
// https://tc39.github.io/ecma262/#sec-function-instances-name
if (descriptors && !(NAME in FunctionPrototype)) {
  defineProperty(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return FunctionPrototypeToString.call(this).match(nameRE)[1];
      } catch (error) {
        return '';
      }
    }
  });
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable
var f$1 = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable;

var objectPropertyIsEnumerable = {
	f: f$1
};

var createPropertyDescriptor = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var toString = {}.toString;

var classofRaw = function (it) {
  return toString.call(it).slice(8, -1);
};

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classofRaw(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;

// `RequireObjectCoercible` abstract operation
// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings



var toIndexedObject = function (it) {
  return indexedObject(requireObjectCoercible(it));
};

var hasOwnProperty = {}.hasOwnProperty;

var has = function (it, key) {
  return hasOwnProperty.call(it, key);
};

var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
var f$2 = descriptors ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (ie8DomDefine) try {
    return nativeGetOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!objectPropertyIsEnumerable.f.call(O, P), O[P]);
};

var objectGetOwnPropertyDescriptor = {
	f: f$2
};

var createNonEnumerableProperty = descriptors ? function (object, key, value) {
  return objectDefineProperty.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var setGlobal = function (key, value) {
  try {
    createNonEnumerableProperty(global_1, key, value);
  } catch (error) {
    global_1[key] = value;
  } return value;
};

var SHARED = '__core-js_shared__';
var store = global_1[SHARED] || setGlobal(SHARED, {});

var sharedStore = store;

var functionToString = Function.toString;

// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof sharedStore.inspectSource != 'function') {
  sharedStore.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

var inspectSource = sharedStore.inspectSource;

var WeakMap = global_1.WeakMap;

var nativeWeakMap = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));

var shared = createCommonjsModule(function (module) {
(module.exports = function (key, value) {
  return sharedStore[key] || (sharedStore[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.6.5',
  mode:  'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});
});

var id = 0;
var postfix = Math.random();

var uid = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};

var keys = shared('keys');

var sharedKey = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys = {};

var WeakMap$1 = global_1.WeakMap;
var set, get, has$1;

var enforce = function (it) {
  return has$1(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (nativeWeakMap) {
  var store$1 = new WeakMap$1();
  var wmget = store$1.get;
  var wmhas = store$1.has;
  var wmset = store$1.set;
  set = function (it, metadata) {
    wmset.call(store$1, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store$1, it) || {};
  };
  has$1 = function (it) {
    return wmhas.call(store$1, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return has(it, STATE) ? it[STATE] : {};
  };
  has$1 = function (it) {
    return has(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has$1,
  enforce: enforce,
  getterFor: getterFor
};

var redefine = createCommonjsModule(function (module) {
var getInternalState = internalState.get;
var enforceInternalState = internalState.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has(value, 'name')) createNonEnumerableProperty(value, 'name', key);
    enforceInternalState(value).source = TEMPLATE.join(typeof key == 'string' ? key : '');
  }
  if (O === global_1) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
});
});

var path = global_1;

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

var getBuiltIn = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global_1[namespace])
    : path[namespace] && path[namespace][method] || global_1[namespace] && global_1[namespace][method];
};

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.github.io/ecma262/#sec-tointeger
var toInteger = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.github.io/ecma262/#sec-tolength
var toLength = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var max = Math.max;
var min$1 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
};

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};

var indexOf = arrayIncludes.indexOf;


var objectKeysInternal = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var hiddenKeys$1 = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertynames
var f$3 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return objectKeysInternal(O, hiddenKeys$1);
};

var objectGetOwnPropertyNames = {
	f: f$3
};

var f$4 = Object.getOwnPropertySymbols;

var objectGetOwnPropertySymbols = {
	f: f$4
};

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = objectGetOwnPropertyNames.f(anObject(it));
  var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};

var copyConstructorProperties = function (target, source) {
  var keys = ownKeys$1(source);
  var defineProperty = objectDefineProperty.f;
  var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

var isForced_1 = isForced;

var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;






/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global_1;
  } else if (STATIC) {
    target = global_1[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global_1[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor$1(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced_1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};

var aFunction$1 = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};

// optional / simple context binding
var functionBindContext = function (fn, that, length) {
  aFunction$1(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

// `ToObject` abstract operation
// https://tc39.github.io/ecma262/#sec-toobject
var toObject = function (argument) {
  return Object(requireObjectCoercible(argument));
};

// `IsArray` abstract operation
// https://tc39.github.io/ecma262/#sec-isarray
var isArray = Array.isArray || function isArray(arg) {
  return classofRaw(arg) == 'Array';
};

var nativeSymbol = !!Object.getOwnPropertySymbols && !fails(function () {
  // Chrome 38 Symbol has incorrect toString conversion
  // eslint-disable-next-line no-undef
  return !String(Symbol());
});

var useSymbolAsUid = nativeSymbol
  // eslint-disable-next-line no-undef
  && !Symbol.sham
  // eslint-disable-next-line no-undef
  && typeof Symbol.iterator == 'symbol';

var WellKnownSymbolsStore = shared('wks');
var Symbol$1 = global_1.Symbol;
var createWellKnownSymbol = useSymbolAsUid ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid;

var wellKnownSymbol = function (name) {
  if (!has(WellKnownSymbolsStore, name)) {
    if (nativeSymbol && has(Symbol$1, name)) WellKnownSymbolsStore[name] = Symbol$1[name];
    else WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};

var SPECIES = wellKnownSymbol('species');

// `ArraySpeciesCreate` abstract operation
// https://tc39.github.io/ecma262/#sec-arrayspeciescreate
var arraySpeciesCreate = function (originalArray, length) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex }` methods implementation
var createMethod$1 = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = indexedObject(O);
    var boundFunction = functionBindContext(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else if (IS_EVERY) return false;  // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

var arrayIteration = {
  // `Array.prototype.forEach` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
  forEach: createMethod$1(0),
  // `Array.prototype.map` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.map
  map: createMethod$1(1),
  // `Array.prototype.filter` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.filter
  filter: createMethod$1(2),
  // `Array.prototype.some` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.some
  some: createMethod$1(3),
  // `Array.prototype.every` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.every
  every: createMethod$1(4),
  // `Array.prototype.find` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.find
  find: createMethod$1(5),
  // `Array.prototype.findIndex` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod$1(6)
};

var engineUserAgent = getBuiltIn('navigator', 'userAgent') || '';

var process$1 = global_1.process;
var versions = process$1 && process$1.versions;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] + match[1];
} else if (engineUserAgent) {
  match = engineUserAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = engineUserAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

var engineV8Version = version && +version;

var SPECIES$1 = wellKnownSymbol('species');

var arrayMethodHasSpeciesSupport = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return engineV8Version >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES$1] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};

var defineProperty$1 = Object.defineProperty;
var cache = {};

var thrower = function (it) { throw it; };

var arrayMethodUsesToLength = function (METHOD_NAME, options) {
  if (has(cache, METHOD_NAME)) return cache[METHOD_NAME];
  if (!options) options = {};
  var method = [][METHOD_NAME];
  var ACCESSORS = has(options, 'ACCESSORS') ? options.ACCESSORS : false;
  var argument0 = has(options, 0) ? options[0] : thrower;
  var argument1 = has(options, 1) ? options[1] : undefined;

  return cache[METHOD_NAME] = !!method && !fails(function () {
    if (ACCESSORS && !descriptors) return true;
    var O = { length: -1 };

    if (ACCESSORS) defineProperty$1(O, 1, { enumerable: true, get: thrower });
    else O[1] = 1;

    method.call(O, argument0, argument1);
  });
};

var $filter = arrayIteration.filter;



var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');
// Edge 14- issue
var USES_TO_LENGTH = arrayMethodUsesToLength('filter');

// `Array.prototype.filter` method
// https://tc39.github.io/ecma262/#sec-array.prototype.filter
// with adding support of @@species
_export({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

/*!
 * vuex v3.5.1
 * (c) 2020 Evan You
 * @license MIT
 */
function applyMixin (Vue) {
  var version = Number(Vue.version.split('.')[0]);

  if (version >= 2) {
    Vue.mixin({ beforeCreate: vuexInit });
  } else {
    // override init and inject vuex init procedure
    // for 1.x backwards compatibility.
    var _init = Vue.prototype._init;
    Vue.prototype._init = function (options) {
      if ( options === void 0 ) options = {};

      options.init = options.init
        ? [vuexInit].concat(options.init)
        : vuexInit;
      _init.call(this, options);
    };
  }

  /**
   * Vuex init hook, injected into each instances init hooks list.
   */

  function vuexInit () {
    var options = this.$options;
    // store injection
    if (options.store) {
      this.$store = typeof options.store === 'function'
        ? options.store()
        : options.store;
    } else if (options.parent && options.parent.$store) {
      this.$store = options.parent.$store;
    }
  }
}

var target = typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
    ? global
    : {};
var devtoolHook = target.__VUE_DEVTOOLS_GLOBAL_HOOK__;

function devtoolPlugin (store) {
  if (!devtoolHook) { return }

  store._devtoolHook = devtoolHook;

  devtoolHook.emit('vuex:init', store);

  devtoolHook.on('vuex:travel-to-state', function (targetState) {
    store.replaceState(targetState);
  });

  store.subscribe(function (mutation, state) {
    devtoolHook.emit('vuex:mutation', mutation, state);
  }, { prepend: true });

  store.subscribeAction(function (action, state) {
    devtoolHook.emit('vuex:action', action, state);
  }, { prepend: true });
}

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
function find (list, f) {
  return list.filter(f)[0]
}

/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */
function deepCopy (obj, cache) {
  if ( cache === void 0 ) cache = [];

  // just return if obj is immutable value
  if (obj === null || typeof obj !== 'object') {
    return obj
  }

  // if obj is hit, it is in circular structure
  var hit = find(cache, function (c) { return c.original === obj; });
  if (hit) {
    return hit.copy
  }

  var copy = Array.isArray(obj) ? [] : {};
  // put the copy into cache at first
  // because we want to refer it in recursive deepCopy
  cache.push({
    original: obj,
    copy: copy
  });

  Object.keys(obj).forEach(function (key) {
    copy[key] = deepCopy(obj[key], cache);
  });

  return copy
}

/**
 * forEach for object
 */
function forEachValue (obj, fn) {
  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
}

function isObject$1 (obj) {
  return obj !== null && typeof obj === 'object'
}

function isPromise (val) {
  return val && typeof val.then === 'function'
}

function partial (fn, arg) {
  return function () {
    return fn(arg)
  }
}

// Base data struct for store's module, package with some attribute and method
var Module = function Module (rawModule, runtime) {
  this.runtime = runtime;
  // Store some children item
  this._children = Object.create(null);
  // Store the origin module object which passed by programmer
  this._rawModule = rawModule;
  var rawState = rawModule.state;

  // Store the origin module's state
  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};

var prototypeAccessors = { namespaced: { configurable: true } };

prototypeAccessors.namespaced.get = function () {
  return !!this._rawModule.namespaced
};

Module.prototype.addChild = function addChild (key, module) {
  this._children[key] = module;
};

Module.prototype.removeChild = function removeChild (key) {
  delete this._children[key];
};

Module.prototype.getChild = function getChild (key) {
  return this._children[key]
};

Module.prototype.hasChild = function hasChild (key) {
  return key in this._children
};

Module.prototype.update = function update (rawModule) {
  this._rawModule.namespaced = rawModule.namespaced;
  if (rawModule.actions) {
    this._rawModule.actions = rawModule.actions;
  }
  if (rawModule.mutations) {
    this._rawModule.mutations = rawModule.mutations;
  }
  if (rawModule.getters) {
    this._rawModule.getters = rawModule.getters;
  }
};

Module.prototype.forEachChild = function forEachChild (fn) {
  forEachValue(this._children, fn);
};

Module.prototype.forEachGetter = function forEachGetter (fn) {
  if (this._rawModule.getters) {
    forEachValue(this._rawModule.getters, fn);
  }
};

Module.prototype.forEachAction = function forEachAction (fn) {
  if (this._rawModule.actions) {
    forEachValue(this._rawModule.actions, fn);
  }
};

Module.prototype.forEachMutation = function forEachMutation (fn) {
  if (this._rawModule.mutations) {
    forEachValue(this._rawModule.mutations, fn);
  }
};

Object.defineProperties( Module.prototype, prototypeAccessors );

var ModuleCollection = function ModuleCollection (rawRootModule) {
  // register root module (Vuex.Store options)
  this.register([], rawRootModule, false);
};

ModuleCollection.prototype.get = function get (path) {
  return path.reduce(function (module, key) {
    return module.getChild(key)
  }, this.root)
};

ModuleCollection.prototype.getNamespace = function getNamespace (path) {
  var module = this.root;
  return path.reduce(function (namespace, key) {
    module = module.getChild(key);
    return namespace + (module.namespaced ? key + '/' : '')
  }, '')
};

ModuleCollection.prototype.update = function update$1 (rawRootModule) {
  update([], this.root, rawRootModule);
};

ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
    var this$1 = this;
    if ( runtime === void 0 ) runtime = true;

  var newModule = new Module(rawModule, runtime);
  if (path.length === 0) {
    this.root = newModule;
  } else {
    var parent = this.get(path.slice(0, -1));
    parent.addChild(path[path.length - 1], newModule);
  }

  // register nested modules
  if (rawModule.modules) {
    forEachValue(rawModule.modules, function (rawChildModule, key) {
      this$1.register(path.concat(key), rawChildModule, runtime);
    });
  }
};

ModuleCollection.prototype.unregister = function unregister (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  var child = parent.getChild(key);

  if (!child) {
    return
  }

  if (!child.runtime) {
    return
  }

  parent.removeChild(key);
};

ModuleCollection.prototype.isRegistered = function isRegistered (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];

  return parent.hasChild(key)
};

function update (path, targetModule, newModule) {

  // update target module
  targetModule.update(newModule);

  // update nested modules
  if (newModule.modules) {
    for (var key in newModule.modules) {
      if (!targetModule.getChild(key)) {
        return
      }
      update(
        path.concat(key),
        targetModule.getChild(key),
        newModule.modules[key]
      );
    }
  }
}

var Vue; // bind on install

var Store = function Store (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #731
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
  var strict = options.strict; if ( strict === void 0 ) strict = false;

  // store internal state
  this._committing = false;
  this._actions = Object.create(null);
  this._actionSubscribers = [];
  this._mutations = Object.create(null);
  this._wrappedGetters = Object.create(null);
  this._modules = new ModuleCollection(options);
  this._modulesNamespaceMap = Object.create(null);
  this._subscribers = [];
  this._watcherVM = new Vue();
  this._makeLocalGettersCache = Object.create(null);

  // bind commit and dispatch to self
  var store = this;
  var ref = this;
  var dispatch = ref.dispatch;
  var commit = ref.commit;
  this.dispatch = function boundDispatch (type, payload) {
    return dispatch.call(store, type, payload)
  };
  this.commit = function boundCommit (type, payload, options) {
    return commit.call(store, type, payload, options)
  };

  // strict mode
  this.strict = strict;

  var state = this._modules.root.state;

  // init root module.
  // this also recursively registers all sub-modules
  // and collects all module getters inside this._wrappedGetters
  installModule(this, state, [], this._modules.root);

  // initialize the store vm, which is responsible for the reactivity
  // (also registers _wrappedGetters as computed properties)
  resetStoreVM(this, state);

  // apply plugins
  plugins.forEach(function (plugin) { return plugin(this$1); });

  var useDevtools = options.devtools !== undefined ? options.devtools : Vue.config.devtools;
  if (useDevtools) {
    devtoolPlugin(this);
  }
};

var prototypeAccessors$1 = { state: { configurable: true } };

prototypeAccessors$1.state.get = function () {
  return this._vm._data.$$state
};

prototypeAccessors$1.state.set = function (v) {
};

Store.prototype.commit = function commit (_type, _payload, _options) {
    var this$1 = this;

  // check object-style commit
  var ref = unifyObjectStyle(_type, _payload, _options);
    var type = ref.type;
    var payload = ref.payload;

  var mutation = { type: type, payload: payload };
  var entry = this._mutations[type];
  if (!entry) {
    return
  }
  this._withCommit(function () {
    entry.forEach(function commitIterator (handler) {
      handler(payload);
    });
  });

  this._subscribers
    .slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
    .forEach(function (sub) { return sub(mutation, this$1.state); });
};

Store.prototype.dispatch = function dispatch (_type, _payload) {
    var this$1 = this;

  // check object-style dispatch
  var ref = unifyObjectStyle(_type, _payload);
    var type = ref.type;
    var payload = ref.payload;

  var action = { type: type, payload: payload };
  var entry = this._actions[type];
  if (!entry) {
    return
  }

  try {
    this._actionSubscribers
      .slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
      .filter(function (sub) { return sub.before; })
      .forEach(function (sub) { return sub.before(action, this$1.state); });
  } catch (e) {
  }

  var result = entry.length > 1
    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
    : entry[0](payload);

  return new Promise(function (resolve, reject) {
    result.then(function (res) {
      try {
        this$1._actionSubscribers
          .filter(function (sub) { return sub.after; })
          .forEach(function (sub) { return sub.after(action, this$1.state); });
      } catch (e) {
      }
      resolve(res);
    }, function (error) {
      try {
        this$1._actionSubscribers
          .filter(function (sub) { return sub.error; })
          .forEach(function (sub) { return sub.error(action, this$1.state, error); });
      } catch (e) {
      }
      reject(error);
    });
  })
};

Store.prototype.subscribe = function subscribe (fn, options) {
  return genericSubscribe(fn, this._subscribers, options)
};

Store.prototype.subscribeAction = function subscribeAction (fn, options) {
  var subs = typeof fn === 'function' ? { before: fn } : fn;
  return genericSubscribe(subs, this._actionSubscribers, options)
};

Store.prototype.watch = function watch (getter, cb, options) {
    var this$1 = this;
  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
};

Store.prototype.replaceState = function replaceState (state) {
    var this$1 = this;

  this._withCommit(function () {
    this$1._vm._data.$$state = state;
  });
};

Store.prototype.registerModule = function registerModule (path, rawModule, options) {
    if ( options === void 0 ) options = {};

  if (typeof path === 'string') { path = [path]; }

  this._modules.register(path, rawModule);
  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
  // reset store to update getters...
  resetStoreVM(this, this.state);
};

Store.prototype.unregisterModule = function unregisterModule (path) {
    var this$1 = this;

  if (typeof path === 'string') { path = [path]; }

  this._modules.unregister(path);
  this._withCommit(function () {
    var parentState = getNestedState(this$1.state, path.slice(0, -1));
    Vue.delete(parentState, path[path.length - 1]);
  });
  resetStore(this);
};

Store.prototype.hasModule = function hasModule (path) {
  if (typeof path === 'string') { path = [path]; }

  return this._modules.isRegistered(path)
};

Store.prototype.hotUpdate = function hotUpdate (newOptions) {
  this._modules.update(newOptions);
  resetStore(this, true);
};

Store.prototype._withCommit = function _withCommit (fn) {
  var committing = this._committing;
  this._committing = true;
  fn();
  this._committing = committing;
};

Object.defineProperties( Store.prototype, prototypeAccessors$1 );

function genericSubscribe (fn, subs, options) {
  if (subs.indexOf(fn) < 0) {
    options && options.prepend
      ? subs.unshift(fn)
      : subs.push(fn);
  }
  return function () {
    var i = subs.indexOf(fn);
    if (i > -1) {
      subs.splice(i, 1);
    }
  }
}

function resetStore (store, hot) {
  store._actions = Object.create(null);
  store._mutations = Object.create(null);
  store._wrappedGetters = Object.create(null);
  store._modulesNamespaceMap = Object.create(null);
  var state = store.state;
  // init all modules
  installModule(store, state, [], store._modules.root, true);
  // reset vm
  resetStoreVM(store, state, hot);
}

function resetStoreVM (store, state, hot) {
  var oldVm = store._vm;

  // bind store public getters
  store.getters = {};
  // reset local getters cache
  store._makeLocalGettersCache = Object.create(null);
  var wrappedGetters = store._wrappedGetters;
  var computed = {};
  forEachValue(wrappedGetters, function (fn, key) {
    // use computed to leverage its lazy-caching mechanism
    // direct inline function use will lead to closure preserving oldVm.
    // using partial to return function with only arguments preserved in closure environment.
    computed[key] = partial(fn, store);
    Object.defineProperty(store.getters, key, {
      get: function () { return store._vm[key]; },
      enumerable: true // for local getters
    });
  });

  // use a Vue instance to store the state tree
  // suppress warnings just in case the user has added
  // some funky global mixins
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  store._vm = new Vue({
    data: {
      $$state: state
    },
    computed: computed
  });
  Vue.config.silent = silent;

  // enable strict mode for new vm
  if (store.strict) {
    enableStrictMode(store);
  }

  if (oldVm) {
    if (hot) {
      // dispatch changes in all subscribed watchers
      // to force getter re-evaluation for hot reloading.
      store._withCommit(function () {
        oldVm._data.$$state = null;
      });
    }
    Vue.nextTick(function () { return oldVm.$destroy(); });
  }
}

function installModule (store, rootState, path, module, hot) {
  var isRoot = !path.length;
  var namespace = store._modules.getNamespace(path);

  // register in namespace map
  if (module.namespaced) {
    if (store._modulesNamespaceMap[namespace] && ("production" !== 'production')) {
      console.error(("[vuex] duplicate namespace " + namespace + " for the namespaced module " + (path.join('/'))));
    }
    store._modulesNamespaceMap[namespace] = module;
  }

  // set state
  if (!isRoot && !hot) {
    var parentState = getNestedState(rootState, path.slice(0, -1));
    var moduleName = path[path.length - 1];
    store._withCommit(function () {
      Vue.set(parentState, moduleName, module.state);
    });
  }

  var local = module.context = makeLocalContext(store, namespace, path);

  module.forEachMutation(function (mutation, key) {
    var namespacedType = namespace + key;
    registerMutation(store, namespacedType, mutation, local);
  });

  module.forEachAction(function (action, key) {
    var type = action.root ? key : namespace + key;
    var handler = action.handler || action;
    registerAction(store, type, handler, local);
  });

  module.forEachGetter(function (getter, key) {
    var namespacedType = namespace + key;
    registerGetter(store, namespacedType, getter, local);
  });

  module.forEachChild(function (child, key) {
    installModule(store, rootState, path.concat(key), child, hot);
  });
}

/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */
function makeLocalContext (store, namespace, path) {
  var noNamespace = namespace === '';

  var local = {
    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
      }

      return store.dispatch(type, payload)
    },

    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
      }

      store.commit(type, payload, options);
    }
  };

  // getters and state object must be gotten lazily
  // because they will be changed by vm update
  Object.defineProperties(local, {
    getters: {
      get: noNamespace
        ? function () { return store.getters; }
        : function () { return makeLocalGetters(store, namespace); }
    },
    state: {
      get: function () { return getNestedState(store.state, path); }
    }
  });

  return local
}

function makeLocalGetters (store, namespace) {
  if (!store._makeLocalGettersCache[namespace]) {
    var gettersProxy = {};
    var splitPos = namespace.length;
    Object.keys(store.getters).forEach(function (type) {
      // skip if the target getter is not match this namespace
      if (type.slice(0, splitPos) !== namespace) { return }

      // extract local getter type
      var localType = type.slice(splitPos);

      // Add a port to the getters proxy.
      // Define as getter property because
      // we do not want to evaluate the getters in this time.
      Object.defineProperty(gettersProxy, localType, {
        get: function () { return store.getters[type]; },
        enumerable: true
      });
    });
    store._makeLocalGettersCache[namespace] = gettersProxy;
  }

  return store._makeLocalGettersCache[namespace]
}

function registerMutation (store, type, handler, local) {
  var entry = store._mutations[type] || (store._mutations[type] = []);
  entry.push(function wrappedMutationHandler (payload) {
    handler.call(store, local.state, payload);
  });
}

function registerAction (store, type, handler, local) {
  var entry = store._actions[type] || (store._actions[type] = []);
  entry.push(function wrappedActionHandler (payload) {
    var res = handler.call(store, {
      dispatch: local.dispatch,
      commit: local.commit,
      getters: local.getters,
      state: local.state,
      rootGetters: store.getters,
      rootState: store.state
    }, payload);
    if (!isPromise(res)) {
      res = Promise.resolve(res);
    }
    if (store._devtoolHook) {
      return res.catch(function (err) {
        store._devtoolHook.emit('vuex:error', err);
        throw err
      })
    } else {
      return res
    }
  });
}

function registerGetter (store, type, rawGetter, local) {
  if (store._wrappedGetters[type]) {
    return
  }
  store._wrappedGetters[type] = function wrappedGetter (store) {
    return rawGetter(
      local.state, // local state
      local.getters, // local getters
      store.state, // root state
      store.getters // root getters
    )
  };
}

function enableStrictMode (store) {
  store._vm.$watch(function () { return this._data.$$state }, function () {
  }, { deep: true, sync: true });
}

function getNestedState (state, path) {
  return path.reduce(function (state, key) { return state[key]; }, state)
}

function unifyObjectStyle (type, payload, options) {
  if (isObject$1(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }

  return { type: type, payload: payload, options: options }
}

function install (_Vue) {
  if (Vue && _Vue === Vue) {
    return
  }
  Vue = _Vue;
  applyMixin(Vue);
}

/**
 * Reduce the code which written in Vue.js for getting the state.
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} states # Object's item can be a function which accept state and getters for param, you can do something for state and getters in it.
 * @param {Object}
 */
var mapState = normalizeNamespace(function (namespace, states) {
  var res = {};
  normalizeMap(states).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedState () {
      var state = this.$store.state;
      var getters = this.$store.getters;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
        if (!module) {
          return
        }
        state = module.context.state;
        getters = module.context.getters;
      }
      return typeof val === 'function'
        ? val.call(this, state, getters)
        : state[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for committing the mutation
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} mutations # Object's item can be a function which accept `commit` function as the first param, it can accept anthor params. You can commit mutation and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */
var mapMutations = normalizeNamespace(function (namespace, mutations) {
  var res = {};
  normalizeMap(mutations).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedMutation () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      // Get the commit method from store
      var commit = this.$store.commit;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
        if (!module) {
          return
        }
        commit = module.context.commit;
      }
      return typeof val === 'function'
        ? val.apply(this, [commit].concat(args))
        : commit.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for getting the getters
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} getters
 * @return {Object}
 */
var mapGetters = normalizeNamespace(function (namespace, getters) {
  var res = {};
  normalizeMap(getters).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    // The namespace has been mutated by normalizeNamespace
    val = namespace + val;
    res[key] = function mappedGetter () {
      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
        return
      }
      return this.$store.getters[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for dispatch the action
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} actions # Object's item can be a function which accept `dispatch` function as the first param, it can accept anthor params. You can dispatch action and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */
var mapActions = normalizeNamespace(function (namespace, actions) {
  var res = {};
  normalizeMap(actions).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedAction () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      // get dispatch function from store
      var dispatch = this.$store.dispatch;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
        if (!module) {
          return
        }
        dispatch = module.context.dispatch;
      }
      return typeof val === 'function'
        ? val.apply(this, [dispatch].concat(args))
        : dispatch.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

/**
 * Rebinding namespace param for mapXXX function in special scoped, and return them by simple object
 * @param {String} namespace
 * @return {Object}
 */
var createNamespacedHelpers = function (namespace) { return ({
  mapState: mapState.bind(null, namespace),
  mapGetters: mapGetters.bind(null, namespace),
  mapMutations: mapMutations.bind(null, namespace),
  mapActions: mapActions.bind(null, namespace)
}); };

/**
 * Normalize the map
 * normalizeMap([1, 2, 3]) => [ { key: 1, val: 1 }, { key: 2, val: 2 }, { key: 3, val: 3 } ]
 * normalizeMap({a: 1, b: 2, c: 3}) => [ { key: 'a', val: 1 }, { key: 'b', val: 2 }, { key: 'c', val: 3 } ]
 * @param {Array|Object} map
 * @return {Object}
 */
function normalizeMap (map) {
  if (!isValidMap(map)) {
    return []
  }
  return Array.isArray(map)
    ? map.map(function (key) { return ({ key: key, val: key }); })
    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
}

/**
 * Validate whether given map is valid or not
 * @param {*} map
 * @return {Boolean}
 */
function isValidMap (map) {
  return Array.isArray(map) || isObject$1(map)
}

/**
 * Return a function expect two param contains namespace and map. it will normalize the namespace and then the param's function will handle the new namespace and the map.
 * @param {Function} fn
 * @return {Function}
 */
function normalizeNamespace (fn) {
  return function (namespace, map) {
    if (typeof namespace !== 'string') {
      map = namespace;
      namespace = '';
    } else if (namespace.charAt(namespace.length - 1) !== '/') {
      namespace += '/';
    }
    return fn(namespace, map)
  }
}

/**
 * Search a special module from store by namespace. if module not exist, print error message.
 * @param {Object} store
 * @param {String} helper
 * @param {String} namespace
 * @return {Object}
 */
function getModuleByNamespace (store, helper, namespace) {
  var module = store._modulesNamespaceMap[namespace];
  return module
}

// Credits: borrowed code from fcomb/redux-logger

function createLogger (ref) {
  if ( ref === void 0 ) ref = {};
  var collapsed = ref.collapsed; if ( collapsed === void 0 ) collapsed = true;
  var filter = ref.filter; if ( filter === void 0 ) filter = function (mutation, stateBefore, stateAfter) { return true; };
  var transformer = ref.transformer; if ( transformer === void 0 ) transformer = function (state) { return state; };
  var mutationTransformer = ref.mutationTransformer; if ( mutationTransformer === void 0 ) mutationTransformer = function (mut) { return mut; };
  var actionFilter = ref.actionFilter; if ( actionFilter === void 0 ) actionFilter = function (action, state) { return true; };
  var actionTransformer = ref.actionTransformer; if ( actionTransformer === void 0 ) actionTransformer = function (act) { return act; };
  var logMutations = ref.logMutations; if ( logMutations === void 0 ) logMutations = true;
  var logActions = ref.logActions; if ( logActions === void 0 ) logActions = true;
  var logger = ref.logger; if ( logger === void 0 ) logger = console;

  return function (store) {
    var prevState = deepCopy(store.state);

    if (typeof logger === 'undefined') {
      return
    }

    if (logMutations) {
      store.subscribe(function (mutation, state) {
        var nextState = deepCopy(state);

        if (filter(mutation, prevState, nextState)) {
          var formattedTime = getFormattedTime();
          var formattedMutation = mutationTransformer(mutation);
          var message = "mutation " + (mutation.type) + formattedTime;

          startMessage(logger, message, collapsed);
          logger.log('%c prev state', 'color: #9E9E9E; font-weight: bold', transformer(prevState));
          logger.log('%c mutation', 'color: #03A9F4; font-weight: bold', formattedMutation);
          logger.log('%c next state', 'color: #4CAF50; font-weight: bold', transformer(nextState));
          endMessage(logger);
        }

        prevState = nextState;
      });
    }

    if (logActions) {
      store.subscribeAction(function (action, state) {
        if (actionFilter(action, state)) {
          var formattedTime = getFormattedTime();
          var formattedAction = actionTransformer(action);
          var message = "action " + (action.type) + formattedTime;

          startMessage(logger, message, collapsed);
          logger.log('%c action', 'color: #03A9F4; font-weight: bold', formattedAction);
          endMessage(logger);
        }
      });
    }
  }
}

function startMessage (logger, message, collapsed) {
  var startMessage = collapsed
    ? logger.groupCollapsed
    : logger.group;

  // render
  try {
    startMessage.call(logger, message);
  } catch (e) {
    logger.log(message);
  }
}

function endMessage (logger) {
  try {
    logger.groupEnd();
  } catch (e) {
    logger.log('—— log end ——');
  }
}

function getFormattedTime () {
  var time = new Date();
  return (" @ " + (pad(time.getHours(), 2)) + ":" + (pad(time.getMinutes(), 2)) + ":" + (pad(time.getSeconds(), 2)) + "." + (pad(time.getMilliseconds(), 3)))
}

function repeat (str, times) {
  return (new Array(times + 1)).join(str)
}

function pad (num, maxLength) {
  return repeat('0', maxLength - num.toString().length) + num
}

var index = {
  Store: Store,
  install: install,
  version: '3.5.1',
  mapState: mapState,
  mapMutations: mapMutations,
  mapGetters: mapGetters,
  mapActions: mapActions,
  createNamespacedHelpers: createNamespacedHelpers,
  createLogger: createLogger
};

//
//
//
//
//
//
//
//
//

var script = {
  
  name: 'PulseLoader',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: { 
      type: String,
      default: '#5dc596'
    },
    size: {
      type: String,
      default: '15px'
    },
    margin: {
      type: String,
      default: '2px'
    },
    radius: {
      type: String,
      default: '100%'
    }
  },
  data () {
    return {
      spinnerStyle: {
      	backgroundColor: this.color,
      	width: this.size,
        height: this.size,
      	margin: this.margin,
      	borderRadius: this.radius,
        display: 'inline-block',
        animationName: 'v-pulseStretchDelay',
        animationDuration: '0.75s',
        animationIterationCount: 'infinite',
        animationTimingFunction: 'cubic-bezier(.2,.68,.18,1.08)',
        animationFillMode: 'both'
      },
      spinnerDelay1: {
        animationDelay: '0.12s'
      },
      spinnerDelay2: {
        animationDelay: '0.24s'
      },
      spinnerDelay3: {
        animationDelay: '0.36s'
      }
    }
  }

};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "v-spinner"
    },
    [
      _c("div", {
        staticClass: "v-pulse v-pulse1",
        style: [_vm.spinnerStyle, _vm.spinnerDelay1]
      }),
      _c("div", {
        staticClass: "v-pulse v-pulse2",
        style: [_vm.spinnerStyle, _vm.spinnerDelay2]
      }),
      _c("div", {
        staticClass: "v-pulse v-pulse3",
        style: [_vm.spinnerStyle, _vm.spinnerDelay3]
      })
    ]
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-39364cf0_0", { source: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/*.v-spinner\n{\n    margin: 100px auto;\n    text-align: center;\n}\n*/\n@-webkit-keyframes v-pulseStretchDelay\n{\n0%,\n    80%\n    {\n        -webkit-transform: scale(1);\n                transform: scale(1);\n        -webkit-opacity: 1;             \n                opacity: 1;\n}\n45%\n    {\n        -webkit-transform: scale(0.1);\n                transform: scale(0.1);\n        -webkit-opacity: 0.7;             \n                opacity: 0.7;\n}\n}\n@keyframes v-pulseStretchDelay\n{\n0%,\n    80%\n    {\n        -webkit-transform: scale(1);\n                transform: scale(1);\n        -webkit-opacity: 1;             \n                opacity: 1;\n}\n45%\n    {\n        -webkit-transform: scale(0.1);\n                transform: scale(0.1);\n        -webkit-opacity: 0.7;             \n                opacity: 0.7;\n}\n}\n", map: {"version":3,"sources":["E:\\Octadesk\\octa-whatsapp-client\\node_modules\\vue-spinner\\src\\PulseLoader.vue"],"names":[],"mappings":";;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;AAmEA;;;;;CAKA;AAEA;;AAEA;;;QAGA,2BAAA;gBACA,mBAAA;QACA,kBAAA;gBACA,UAAA;AACA;AACA;;QAEA,6BAAA;gBACA,qBAAA;QACA,oBAAA;gBACA,YAAA;AACA;AACA;AAEA;;AAEA;;;QAGA,2BAAA;gBACA,mBAAA;QACA,kBAAA;gBACA,UAAA;AACA;AACA;;QAEA,6BAAA;gBACA,qBAAA;QACA,oBAAA;gBACA,YAAA;AACA;AACA","file":"PulseLoader.vue","sourcesContent":["<template>\n<div class=\"v-spinner\" v-show=\"loading\">\n    <div class=\"v-pulse v-pulse1\" v-bind:style=\"[spinnerStyle,spinnerDelay1]\">\n    </div><div class=\"v-pulse v-pulse2\" v-bind:style=\"[spinnerStyle,spinnerDelay2]\">\n    </div><div class=\"v-pulse v-pulse3\" v-bind:style=\"[spinnerStyle,spinnerDelay3]\">\n    </div>\n  </div>\n</template>\n\n<script>\nexport default {\n  \n  name: 'PulseLoader',\n\n  props: {\n    loading: {\n      type: Boolean,\n      default: true\n    },\n    color: { \n      type: String,\n      default: '#5dc596'\n    },\n    size: {\n      type: String,\n      default: '15px'\n    },\n    margin: {\n      type: String,\n      default: '2px'\n    },\n    radius: {\n      type: String,\n      default: '100%'\n    }\n  },\n  data () {\n    return {\n      spinnerStyle: {\n      \tbackgroundColor: this.color,\n      \twidth: this.size,\n        height: this.size,\n      \tmargin: this.margin,\n      \tborderRadius: this.radius,\n        display: 'inline-block',\n        animationName: 'v-pulseStretchDelay',\n        animationDuration: '0.75s',\n        animationIterationCount: 'infinite',\n        animationTimingFunction: 'cubic-bezier(.2,.68,.18,1.08)',\n        animationFillMode: 'both'\n      },\n      spinnerDelay1: {\n        animationDelay: '0.12s'\n      },\n      spinnerDelay2: {\n        animationDelay: '0.24s'\n      },\n      spinnerDelay3: {\n        animationDelay: '0.36s'\n      }\n    }\n  }\n\n}\n</script>\n\n<style>\n/*.v-spinner\n{\n    margin: 100px auto;\n    text-align: center;\n}\n*/\n\n@-webkit-keyframes v-pulseStretchDelay\n{\n    0%,\n    80%\n    {\n        -webkit-transform: scale(1);\n                transform: scale(1);\n        -webkit-opacity: 1;             \n                opacity: 1;\n    }\n    45%\n    {\n        -webkit-transform: scale(0.1);\n                transform: scale(0.1);\n        -webkit-opacity: 0.7;             \n                opacity: 0.7;\n    }\n}\n\n@keyframes v-pulseStretchDelay\n{\n    0%,\n    80%\n    {\n        -webkit-transform: scale(1);\n                transform: scale(1);\n        -webkit-opacity: 1;             \n                opacity: 1;\n    }\n    45%\n    {\n        -webkit-transform: scale(0.1);\n                transform: scale(0.1);\n        -webkit-opacity: 0.7;             \n                opacity: 0.7;\n    }\n}\n</style>"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

//
var script$1 = {
  props: ['classProp'],
  components: {
    PulseLoader: __vue_component__
  }
};

/* script */
var __vue_script__$1 = script$1;
/* template */

var __vue_render__$1 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    staticClass: "loader-container"
  }, [_c("div", {
    staticClass: "loader",
    class: this.classProp
  }, [_c("pulse-loader", {
    staticClass: "text-primary",
    attrs: {
      loading: true
    }
  })], 1)]);
};

var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;
/* style */

var __vue_inject_styles__$1 = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-9991f78a_0", {
    source: "\n.v-pulse[data-v-9991f78a] {\n  background-color: #5da9dd !important;\n}\n.loader-container[data-v-9991f78a] {\n  position: absolute;\n  z-index: 2;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n",
    map: {
      "version": 3,
      "sources": ["E:\\Octadesk\\octa-whatsapp-client\\src\\app\\shared-components\\GenericLoader.vue"],
      "names": [],
      "mappings": ";AAoBA;EACA,oCAAA;AACA;AACA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACA",
      "file": "GenericLoader.vue",
      "sourcesContent": ["<template>\r\n  <div class=\"loader-container\">\r\n    <div class=\"loader\" :class=\"this.classProp\">\r\n      <pulse-loader :loading=\"true\" class=\"text-primary\"></pulse-loader>\r\n    </div>\r\n  </div>\r\n</template>\r\n\r\n<script>\r\n  import PulseLoader from 'vue-spinner/src/PulseLoader.vue'\r\n\r\n  export default {\r\n    props: ['classProp'],\r\n    components: {\r\n      PulseLoader\r\n    }\r\n  }\r\n</script>\r\n\r\n<style scoped>\r\n  .v-pulse {\r\n    background-color: #5da9dd !important;\r\n  }\r\n  .loader-container {\r\n    position: absolute;\r\n    z-index: 2;\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n</style>\r\n"]
    },
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$1 = "data-v-9991f78a";
/* module identifier */

var __vue_module_identifier__$1 = undefined;
/* functional template */

var __vue_is_functional_template__$1 = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, createInjector, undefined, undefined);

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.github.io/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classofRaw(it) == 'RegExp');
};

var notARegexp = function (it) {
  if (isRegexp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  } return it;
};

var MATCH$1 = wellKnownSymbol('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (e) {
    try {
      regexp[MATCH$1] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (f) { /* empty */ }
  } return false;
};

var getOwnPropertyDescriptor$2 = objectGetOwnPropertyDescriptor.f;






var nativeStartsWith = ''.startsWith;
var min$2 = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegexpLogic('startsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG =  !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor$2(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.startsWith` method
// https://tc39.github.io/ecma262/#sec-string.prototype.startswith
_export({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = String(requireObjectCoercible(this));
    notARegexp(searchString);
    var index = toLength(min$2(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return nativeStartsWith
      ? nativeStartsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});

/*!
 * Vue.js v2.6.11
 * (c) 2014-2019 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject$2 (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise$1 (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString$1 (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty$1.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject$1 (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject$2(a);
  var isObjectB = isObject$2(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;

/*  */

var uid$1 = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid$1++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors$2 = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors$2.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors$2 );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject$2(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set$1 (target, key, val) {
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set$1(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".");
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child);
  normalizeInject(child);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise$1(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e);
      }
    }
  }
  logError(err);
}

function logError (err, vm, info) {
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject$2(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) ; else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject$2(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject$2(value)) ; else {
      if (Array.isArray(value)) {
        value = toObject$1(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) ; else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString$1;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject$2(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject$2(data.style)) {
    traverse(data.style);
  }
  if (isObject$2(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject$2(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject$2(res)) {
      if (isPromise$1(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise$1(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target$1;

function add (event, fn) {
  target$1.$on(event, fn);
}

function remove$1 (event, fn) {
  target$1.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target$1;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target$1 = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target$1 = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

var queue = [];
var activatedChildren = [];
var has$2 = {};
var waiting = false;
var flushing = false;
var index$1 = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index$1 = queue.length = activatedChildren.length = 0;
  has$2 = {};
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index$1 = 0; index$1 < queue.length; index$1++) {
    watcher = queue[index$1];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has$2[id] = null;
    watcher.run();
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has$2[id] == null) {
    has$2[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index$1 && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject$2(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (props && hasOwn(props, key)) ; else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set$1;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue$1 (options) {
  this._init(options);
}

initMixin(Vue$1);
stateMixin(Vue$1);
eventsMixin(Vue$1);
lifecycleMixin(Vue$1);
renderMixin(Vue$1);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set$1;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue$1);

Object.defineProperty(Vue$1.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue$1.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue$1, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue$1.version = '2.6.11';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject$2(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

/*  */

/*  */

/*  */

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecesarry `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject$1(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize$1(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize$1 = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject$2(duration)
      ? duration.enter
      : duration
  );

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject$2(duration)
      ? duration.leave
      : duration
  );

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    var mode = this.mode;

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue$1.config.mustUseProp = mustUseProp;
Vue$1.config.isReservedTag = isReservedTag;
Vue$1.config.isReservedAttr = isReservedAttr;
Vue$1.config.getTagNamespace = getTagNamespace;
Vue$1.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue$1.options.directives, platformDirectives);
extend(Vue$1.options.components, platformComponents);

// install platform patch function
Vue$1.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue$1.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue$1);
      }
    }
  }, 0);
}

/*!
 * vue-i18n v8.18.2 
 * (c) 2020 kazuya kawaguchi
 * Released under the MIT License.
 */
/*  */

/**
 * constants
 */

var numberFormatKeys = [
  'style',
  'currency',
  'currencyDisplay',
  'useGrouping',
  'minimumIntegerDigits',
  'minimumFractionDigits',
  'maximumFractionDigits',
  'minimumSignificantDigits',
  'maximumSignificantDigits',
  'localeMatcher',
  'formatMatcher',
  'unit'
];

/**
 * utilities
 */

function warn$1 (msg, err) {
  if (typeof console !== 'undefined') {
    console.warn('[vue-i18n] ' + msg);
    /* istanbul ignore if */
    if (err) {
      console.warn(err.stack);
    }
  }
}

function error (msg, err) {
  if (typeof console !== 'undefined') {
    console.error('[vue-i18n] ' + msg);
    /* istanbul ignore if */
    if (err) {
      console.error(err.stack);
    }
  }
}

var isArray$1 = Array.isArray;

function isObject$3 (obj) {
  return obj !== null && typeof obj === 'object'
}

function isBoolean (val) {
  return typeof val === 'boolean'
}

function isString (val) {
  return typeof val === 'string'
}

var toString$2 = Object.prototype.toString;
var OBJECT_STRING = '[object Object]';
function isPlainObject$1 (obj) {
  return toString$2.call(obj) === OBJECT_STRING
}

function isNull (val) {
  return val === null || val === undefined
}

function parseArgs () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  var locale = null;
  var params = null;
  if (args.length === 1) {
    if (isObject$3(args[0]) || Array.isArray(args[0])) {
      params = args[0];
    } else if (typeof args[0] === 'string') {
      locale = args[0];
    }
  } else if (args.length === 2) {
    if (typeof args[0] === 'string') {
      locale = args[0];
    }
    /* istanbul ignore if */
    if (isObject$3(args[1]) || Array.isArray(args[1])) {
      params = args[1];
    }
  }

  return { locale: locale, params: params }
}

function looseClone (obj) {
  return JSON.parse(JSON.stringify(obj))
}

function remove$3 (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

function includes (arr, item) {
  return !!~arr.indexOf(item)
}

var hasOwnProperty$2 = Object.prototype.hasOwnProperty;
function hasOwn$1 (obj, key) {
  return hasOwnProperty$2.call(obj, key)
}

function merge (target) {
  var arguments$1 = arguments;

  var output = Object(target);
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments$1[i];
    if (source !== undefined && source !== null) {
      var key = (void 0);
      for (key in source) {
        if (hasOwn$1(source, key)) {
          if (isObject$3(source[key])) {
            output[key] = merge(output[key], source[key]);
          } else {
            output[key] = source[key];
          }
        }
      }
    }
  }
  return output
}

function looseEqual$1 (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject$3(a);
  var isObjectB = isObject$3(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual$1(e, b[i])
        })
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual$1(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/*  */

function extend$1 (Vue) {
  if (!Vue.prototype.hasOwnProperty('$i18n')) {
    // $FlowFixMe
    Object.defineProperty(Vue.prototype, '$i18n', {
      get: function get () { return this._i18n }
    });
  }

  Vue.prototype.$t = function (key) {
    var values = [], len = arguments.length - 1;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 1 ];

    var i18n = this.$i18n;
    return i18n._t.apply(i18n, [ key, i18n.locale, i18n._getMessages(), this ].concat( values ))
  };

  Vue.prototype.$tc = function (key, choice) {
    var values = [], len = arguments.length - 2;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 2 ];

    var i18n = this.$i18n;
    return i18n._tc.apply(i18n, [ key, i18n.locale, i18n._getMessages(), this, choice ].concat( values ))
  };

  Vue.prototype.$te = function (key, locale) {
    var i18n = this.$i18n;
    return i18n._te(key, i18n.locale, i18n._getMessages(), locale)
  };

  Vue.prototype.$d = function (value) {
    var ref;

    var args = [], len = arguments.length - 1;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];
    return (ref = this.$i18n).d.apply(ref, [ value ].concat( args ))
  };

  Vue.prototype.$n = function (value) {
    var ref;

    var args = [], len = arguments.length - 1;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];
    return (ref = this.$i18n).n.apply(ref, [ value ].concat( args ))
  };
}

/*  */

var mixin = {
  beforeCreate: function beforeCreate () {
    var options = this.$options;
    options.i18n = options.i18n || (options.__i18n ? {} : null);

    if (options.i18n) {
      if (options.i18n instanceof VueI18n) {
        // init locale messages via custom blocks
        if (options.__i18n) {
          try {
            var localeMessages = {};
            options.__i18n.forEach(function (resource) {
              localeMessages = merge(localeMessages, JSON.parse(resource));
            });
            Object.keys(localeMessages).forEach(function (locale) {
              options.i18n.mergeLocaleMessage(locale, localeMessages[locale]);
            });
          } catch (e) {
          }
        }
        this._i18n = options.i18n;
        this._i18nWatcher = this._i18n.watchI18nData();
      } else if (isPlainObject$1(options.i18n)) {
        var rootI18n = this.$root && this.$root.$i18n && this.$root.$i18n instanceof VueI18n
          ? this.$root.$i18n
          : null;
        // component local i18n
        if (rootI18n) {
          options.i18n.root = this.$root;
          options.i18n.formatter = rootI18n.formatter;
          options.i18n.fallbackLocale = rootI18n.fallbackLocale;
          options.i18n.formatFallbackMessages = rootI18n.formatFallbackMessages;
          options.i18n.silentTranslationWarn = rootI18n.silentTranslationWarn;
          options.i18n.silentFallbackWarn = rootI18n.silentFallbackWarn;
          options.i18n.pluralizationRules = rootI18n.pluralizationRules;
          options.i18n.preserveDirectiveContent = rootI18n.preserveDirectiveContent;
        }

        // init locale messages via custom blocks
        if (options.__i18n) {
          try {
            var localeMessages$1 = {};
            options.__i18n.forEach(function (resource) {
              localeMessages$1 = merge(localeMessages$1, JSON.parse(resource));
            });
            options.i18n.messages = localeMessages$1;
          } catch (e) {
          }
        }

        var ref = options.i18n;
        var sharedMessages = ref.sharedMessages;
        if (sharedMessages && isPlainObject$1(sharedMessages)) {
          options.i18n.messages = merge(options.i18n.messages, sharedMessages);
        }

        this._i18n = new VueI18n(options.i18n);
        this._i18nWatcher = this._i18n.watchI18nData();

        if (options.i18n.sync === undefined || !!options.i18n.sync) {
          this._localeWatcher = this.$i18n.watchLocale();
        }

        if (rootI18n) {
          rootI18n.onComponentInstanceCreated(this._i18n);
        }
      }
    } else if (this.$root && this.$root.$i18n && this.$root.$i18n instanceof VueI18n) {
      // root i18n
      this._i18n = this.$root.$i18n;
    } else if (options.parent && options.parent.$i18n && options.parent.$i18n instanceof VueI18n) {
      // parent i18n
      this._i18n = options.parent.$i18n;
    }
  },

  beforeMount: function beforeMount () {
    var options = this.$options;
    options.i18n = options.i18n || (options.__i18n ? {} : null);

    if (options.i18n) {
      if (options.i18n instanceof VueI18n) {
        // init locale messages via custom blocks
        this._i18n.subscribeDataChanging(this);
        this._subscribing = true;
      } else if (isPlainObject$1(options.i18n)) {
        this._i18n.subscribeDataChanging(this);
        this._subscribing = true;
      }
    } else if (this.$root && this.$root.$i18n && this.$root.$i18n instanceof VueI18n) {
      this._i18n.subscribeDataChanging(this);
      this._subscribing = true;
    } else if (options.parent && options.parent.$i18n && options.parent.$i18n instanceof VueI18n) {
      this._i18n.subscribeDataChanging(this);
      this._subscribing = true;
    }
  },

  beforeDestroy: function beforeDestroy () {
    if (!this._i18n) { return }

    var self = this;
    this.$nextTick(function () {
      if (self._subscribing) {
        self._i18n.unsubscribeDataChanging(self);
        delete self._subscribing;
      }

      if (self._i18nWatcher) {
        self._i18nWatcher();
        self._i18n.destroyVM();
        delete self._i18nWatcher;
      }

      if (self._localeWatcher) {
        self._localeWatcher();
        delete self._localeWatcher;
      }
    });
  }
};

/*  */

var interpolationComponent = {
  name: 'i18n',
  functional: true,
  props: {
    tag: {
      type: [String, Boolean],
      default: 'span'
    },
    path: {
      type: String,
      required: true
    },
    locale: {
      type: String
    },
    places: {
      type: [Array, Object]
    }
  },
  render: function render (h, ref) {
    var data = ref.data;
    var parent = ref.parent;
    var props = ref.props;
    var slots = ref.slots;

    var $i18n = parent.$i18n;
    if (!$i18n) {
      return
    }

    var path = props.path;
    var locale = props.locale;
    var places = props.places;
    var params = slots();
    var children = $i18n.i(
      path,
      locale,
      onlyHasDefaultPlace(params) || places
        ? useLegacyPlaces(params.default, places)
        : params
    );

    var tag = (!!props.tag && props.tag !== true) || props.tag === false ? props.tag : 'span';
    return tag ? h(tag, data, children) : children
  }
};

function onlyHasDefaultPlace (params) {
  var prop;
  for (prop in params) {
    if (prop !== 'default') { return false }
  }
  return Boolean(prop)
}

function useLegacyPlaces (children, places) {
  var params = places ? createParamsFromPlaces(places) : {};

  if (!children) { return params }

  // Filter empty text nodes
  children = children.filter(function (child) {
    return child.tag || child.text.trim() !== ''
  });

  var everyPlace = children.every(vnodeHasPlaceAttribute);

  return children.reduce(
    everyPlace ? assignChildPlace : assignChildIndex,
    params
  )
}

function createParamsFromPlaces (places) {

  return Array.isArray(places)
    ? places.reduce(assignChildIndex, {})
    : Object.assign({}, places)
}

function assignChildPlace (params, child) {
  if (child.data && child.data.attrs && child.data.attrs.place) {
    params[child.data.attrs.place] = child;
  }
  return params
}

function assignChildIndex (params, child, index) {
  params[index] = child;
  return params
}

function vnodeHasPlaceAttribute (vnode) {
  return Boolean(vnode.data && vnode.data.attrs && vnode.data.attrs.place)
}

/*  */

var numberComponent = {
  name: 'i18n-n',
  functional: true,
  props: {
    tag: {
      type: [String, Boolean],
      default: 'span'
    },
    value: {
      type: Number,
      required: true
    },
    format: {
      type: [String, Object]
    },
    locale: {
      type: String
    }
  },
  render: function render (h, ref) {
    var props = ref.props;
    var parent = ref.parent;
    var data = ref.data;

    var i18n = parent.$i18n;

    if (!i18n) {
      return null
    }

    var key = null;
    var options = null;

    if (isString(props.format)) {
      key = props.format;
    } else if (isObject$3(props.format)) {
      if (props.format.key) {
        key = props.format.key;
      }

      // Filter out number format options only
      options = Object.keys(props.format).reduce(function (acc, prop) {
        var obj;

        if (includes(numberFormatKeys, prop)) {
          return Object.assign({}, acc, ( obj = {}, obj[prop] = props.format[prop], obj ))
        }
        return acc
      }, null);
    }

    var locale = props.locale || i18n.locale;
    var parts = i18n._ntp(props.value, locale, key, options);

    var values = parts.map(function (part, index) {
      var obj;

      var slot = data.scopedSlots && data.scopedSlots[part.type];
      return slot ? slot(( obj = {}, obj[part.type] = part.value, obj.index = index, obj.parts = parts, obj )) : part.value
    });

    var tag = (!!props.tag && props.tag !== true) || props.tag === false ? props.tag : 'span';
    return tag
      ? h(tag, {
        attrs: data.attrs,
        'class': data['class'],
        staticClass: data.staticClass
      }, values)
      : values
  }
};

/*  */

function bind$1 (el, binding, vnode) {
  if (!assert(el, vnode)) { return }

  t(el, binding, vnode);
}

function update$1 (el, binding, vnode, oldVNode) {
  if (!assert(el, vnode)) { return }

  var i18n = vnode.context.$i18n;
  if (localeEqual(el, vnode) &&
    (looseEqual$1(binding.value, binding.oldValue) &&
     looseEqual$1(el._localeMessage, i18n.getLocaleMessage(i18n.locale)))) { return }

  t(el, binding, vnode);
}

function unbind (el, binding, vnode, oldVNode) {
  var vm = vnode.context;
  if (!vm) {
    warn$1('Vue instance does not exists in VNode context');
    return
  }

  var i18n = vnode.context.$i18n || {};
  if (!binding.modifiers.preserve && !i18n.preserveDirectiveContent) {
    el.textContent = '';
  }
  el._vt = undefined;
  delete el['_vt'];
  el._locale = undefined;
  delete el['_locale'];
  el._localeMessage = undefined;
  delete el['_localeMessage'];
}

function assert (el, vnode) {
  var vm = vnode.context;
  if (!vm) {
    warn$1('Vue instance does not exists in VNode context');
    return false
  }

  if (!vm.$i18n) {
    warn$1('VueI18n instance does not exists in Vue instance');
    return false
  }

  return true
}

function localeEqual (el, vnode) {
  var vm = vnode.context;
  return el._locale === vm.$i18n.locale
}

function t (el, binding, vnode) {
  var ref$1, ref$2;

  var value = binding.value;

  var ref = parseValue(value);
  var path = ref.path;
  var locale = ref.locale;
  var args = ref.args;
  var choice = ref.choice;
  if (!path && !locale && !args) {
    warn$1('value type not supported');
    return
  }

  if (!path) {
    warn$1('`path` is required in v-t directive');
    return
  }

  var vm = vnode.context;
  if (choice != null) {
    el._vt = el.textContent = (ref$1 = vm.$i18n).tc.apply(ref$1, [ path, choice ].concat( makeParams(locale, args) ));
  } else {
    el._vt = el.textContent = (ref$2 = vm.$i18n).t.apply(ref$2, [ path ].concat( makeParams(locale, args) ));
  }
  el._locale = vm.$i18n.locale;
  el._localeMessage = vm.$i18n.getLocaleMessage(vm.$i18n.locale);
}

function parseValue (value) {
  var path;
  var locale;
  var args;
  var choice;

  if (isString(value)) {
    path = value;
  } else if (isPlainObject$1(value)) {
    path = value.path;
    locale = value.locale;
    args = value.args;
    choice = value.choice;
  }

  return { path: path, locale: locale, args: args, choice: choice }
}

function makeParams (locale, args) {
  var params = [];

  locale && params.push(locale);
  if (args && (Array.isArray(args) || isPlainObject$1(args))) {
    params.push(args);
  }

  return params
}

var Vue$2;

function install$1 (_Vue) {
  install$1.installed = true;

  Vue$2 = _Vue;

  var version = (Vue$2.version && Number(Vue$2.version.split('.')[0])) || -1;

  extend$1(Vue$2);
  Vue$2.mixin(mixin);
  Vue$2.directive('t', { bind: bind$1, update: update$1, unbind: unbind });
  Vue$2.component(interpolationComponent.name, interpolationComponent);
  Vue$2.component(numberComponent.name, numberComponent);

  // use simple mergeStrategies to prevent i18n instance lose '__proto__'
  var strats = Vue$2.config.optionMergeStrategies;
  strats.i18n = function (parentVal, childVal) {
    return childVal === undefined
      ? parentVal
      : childVal
  };
}

/*  */

var BaseFormatter = function BaseFormatter () {
  this._caches = Object.create(null);
};

BaseFormatter.prototype.interpolate = function interpolate (message, values) {
  if (!values) {
    return [message]
  }
  var tokens = this._caches[message];
  if (!tokens) {
    tokens = parse(message);
    this._caches[message] = tokens;
  }
  return compile(tokens, values)
};



var RE_TOKEN_LIST_VALUE = /^(?:\d)+/;
var RE_TOKEN_NAMED_VALUE = /^(?:\w)+/;

function parse (format) {
  var tokens = [];
  var position = 0;

  var text = '';
  while (position < format.length) {
    var char = format[position++];
    if (char === '{') {
      if (text) {
        tokens.push({ type: 'text', value: text });
      }

      text = '';
      var sub = '';
      char = format[position++];
      while (char !== undefined && char !== '}') {
        sub += char;
        char = format[position++];
      }
      var isClosed = char === '}';

      var type = RE_TOKEN_LIST_VALUE.test(sub)
        ? 'list'
        : isClosed && RE_TOKEN_NAMED_VALUE.test(sub)
          ? 'named'
          : 'unknown';
      tokens.push({ value: sub, type: type });
    } else if (char === '%') {
      // when found rails i18n syntax, skip text capture
      if (format[(position)] !== '{') {
        text += char;
      }
    } else {
      text += char;
    }
  }

  text && tokens.push({ type: 'text', value: text });

  return tokens
}

function compile (tokens, values) {
  var compiled = [];
  var index = 0;

  var mode = Array.isArray(values)
    ? 'list'
    : isObject$3(values)
      ? 'named'
      : 'unknown';
  if (mode === 'unknown') { return compiled }

  while (index < tokens.length) {
    var token = tokens[index];
    switch (token.type) {
      case 'text':
        compiled.push(token.value);
        break
      case 'list':
        compiled.push(values[parseInt(token.value, 10)]);
        break
      case 'named':
        if (mode === 'named') {
          compiled.push((values)[token.value]);
        }
        break
    }
    index++;
  }

  return compiled
}

/*  */

/**
 *  Path parser
 *  - Inspired:
 *    Vue.js Path parser
 */

// actions
var APPEND = 0;
var PUSH = 1;
var INC_SUB_PATH_DEPTH = 2;
var PUSH_SUB_PATH = 3;

// states
var BEFORE_PATH = 0;
var IN_PATH = 1;
var BEFORE_IDENT = 2;
var IN_IDENT = 3;
var IN_SUB_PATH = 4;
var IN_SINGLE_QUOTE = 5;
var IN_DOUBLE_QUOTE = 6;
var AFTER_PATH = 7;
var ERROR = 8;

var pathStateMachine = [];

pathStateMachine[BEFORE_PATH] = {
  'ws': [BEFORE_PATH],
  'ident': [IN_IDENT, APPEND],
  '[': [IN_SUB_PATH],
  'eof': [AFTER_PATH]
};

pathStateMachine[IN_PATH] = {
  'ws': [IN_PATH],
  '.': [BEFORE_IDENT],
  '[': [IN_SUB_PATH],
  'eof': [AFTER_PATH]
};

pathStateMachine[BEFORE_IDENT] = {
  'ws': [BEFORE_IDENT],
  'ident': [IN_IDENT, APPEND],
  '0': [IN_IDENT, APPEND],
  'number': [IN_IDENT, APPEND]
};

pathStateMachine[IN_IDENT] = {
  'ident': [IN_IDENT, APPEND],
  '0': [IN_IDENT, APPEND],
  'number': [IN_IDENT, APPEND],
  'ws': [IN_PATH, PUSH],
  '.': [BEFORE_IDENT, PUSH],
  '[': [IN_SUB_PATH, PUSH],
  'eof': [AFTER_PATH, PUSH]
};

pathStateMachine[IN_SUB_PATH] = {
  "'": [IN_SINGLE_QUOTE, APPEND],
  '"': [IN_DOUBLE_QUOTE, APPEND],
  '[': [IN_SUB_PATH, INC_SUB_PATH_DEPTH],
  ']': [IN_PATH, PUSH_SUB_PATH],
  'eof': ERROR,
  'else': [IN_SUB_PATH, APPEND]
};

pathStateMachine[IN_SINGLE_QUOTE] = {
  "'": [IN_SUB_PATH, APPEND],
  'eof': ERROR,
  'else': [IN_SINGLE_QUOTE, APPEND]
};

pathStateMachine[IN_DOUBLE_QUOTE] = {
  '"': [IN_SUB_PATH, APPEND],
  'eof': ERROR,
  'else': [IN_DOUBLE_QUOTE, APPEND]
};

/**
 * Check if an expression is a literal value.
 */

var literalValueRE = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function isLiteral (exp) {
  return literalValueRE.test(exp)
}

/**
 * Strip quotes from a string
 */

function stripQuotes (str) {
  var a = str.charCodeAt(0);
  var b = str.charCodeAt(str.length - 1);
  return a === b && (a === 0x22 || a === 0x27)
    ? str.slice(1, -1)
    : str
}

/**
 * Determine the type of a character in a keypath.
 */

function getPathCharType (ch) {
  if (ch === undefined || ch === null) { return 'eof' }

  var code = ch.charCodeAt(0);

  switch (code) {
    case 0x5B: // [
    case 0x5D: // ]
    case 0x2E: // .
    case 0x22: // "
    case 0x27: // '
      return ch

    case 0x5F: // _
    case 0x24: // $
    case 0x2D: // -
      return 'ident'

    case 0x09: // Tab
    case 0x0A: // Newline
    case 0x0D: // Return
    case 0xA0:  // No-break space
    case 0xFEFF:  // Byte Order Mark
    case 0x2028:  // Line Separator
    case 0x2029:  // Paragraph Separator
      return 'ws'
  }

  return 'ident'
}

/**
 * Format a subPath, return its plain form if it is
 * a literal string or number. Otherwise prepend the
 * dynamic indicator (*).
 */

function formatSubPath (path) {
  var trimmed = path.trim();
  // invalid leading 0
  if (path.charAt(0) === '0' && isNaN(path)) { return false }

  return isLiteral(trimmed) ? stripQuotes(trimmed) : '*' + trimmed
}

/**
 * Parse a string path into an array of segments
 */

function parse$1 (path) {
  var keys = [];
  var index = -1;
  var mode = BEFORE_PATH;
  var subPathDepth = 0;
  var c;
  var key;
  var newChar;
  var type;
  var transition;
  var action;
  var typeMap;
  var actions = [];

  actions[PUSH] = function () {
    if (key !== undefined) {
      keys.push(key);
      key = undefined;
    }
  };

  actions[APPEND] = function () {
    if (key === undefined) {
      key = newChar;
    } else {
      key += newChar;
    }
  };

  actions[INC_SUB_PATH_DEPTH] = function () {
    actions[APPEND]();
    subPathDepth++;
  };

  actions[PUSH_SUB_PATH] = function () {
    if (subPathDepth > 0) {
      subPathDepth--;
      mode = IN_SUB_PATH;
      actions[APPEND]();
    } else {
      subPathDepth = 0;
      if (key === undefined) { return false }
      key = formatSubPath(key);
      if (key === false) {
        return false
      } else {
        actions[PUSH]();
      }
    }
  };

  function maybeUnescapeQuote () {
    var nextChar = path[index + 1];
    if ((mode === IN_SINGLE_QUOTE && nextChar === "'") ||
      (mode === IN_DOUBLE_QUOTE && nextChar === '"')) {
      index++;
      newChar = '\\' + nextChar;
      actions[APPEND]();
      return true
    }
  }

  while (mode !== null) {
    index++;
    c = path[index];

    if (c === '\\' && maybeUnescapeQuote()) {
      continue
    }

    type = getPathCharType(c);
    typeMap = pathStateMachine[mode];
    transition = typeMap[type] || typeMap['else'] || ERROR;

    if (transition === ERROR) {
      return // parse error
    }

    mode = transition[0];
    action = actions[transition[1]];
    if (action) {
      newChar = transition[2];
      newChar = newChar === undefined
        ? c
        : newChar;
      if (action() === false) {
        return
      }
    }

    if (mode === AFTER_PATH) {
      return keys
    }
  }
}





var I18nPath = function I18nPath () {
  this._cache = Object.create(null);
};

/**
 * External parse that check for a cache hit first
 */
I18nPath.prototype.parsePath = function parsePath (path) {
  var hit = this._cache[path];
  if (!hit) {
    hit = parse$1(path);
    if (hit) {
      this._cache[path] = hit;
    }
  }
  return hit || []
};

/**
 * Get path value from path string
 */
I18nPath.prototype.getPathValue = function getPathValue (obj, path) {
  if (!isObject$3(obj)) { return null }

  var paths = this.parsePath(path);
  if (paths.length === 0) {
    return null
  } else {
    var length = paths.length;
    var last = obj;
    var i = 0;
    while (i < length) {
      var value = last[paths[i]];
      if (value === undefined) {
        return null
      }
      last = value;
      i++;
    }

    return last
  }
};

/*  */



var htmlTagMatcher = /<\/?[\w\s="/.':;#-\/]+>/;
var linkKeyMatcher = /(?:@(?:\.[a-z]+)?:(?:[\w\-_|.]+|\([\w\-_|.]+\)))/g;
var linkKeyPrefixMatcher = /^@(?:\.([a-z]+))?:/;
var bracketsMatcher = /[()]/g;
var defaultModifiers = {
  'upper': function (str) { return str.toLocaleUpperCase(); },
  'lower': function (str) { return str.toLocaleLowerCase(); },
  'capitalize': function (str) { return ("" + (str.charAt(0).toLocaleUpperCase()) + (str.substr(1))); }
};

var defaultFormatter = new BaseFormatter();

var VueI18n = function VueI18n (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #290
  /* istanbul ignore if */
  if (!Vue$2 && typeof window !== 'undefined' && window.Vue) {
    install$1(window.Vue);
  }

  var locale = options.locale || 'en-US';
  var fallbackLocale = options.fallbackLocale === false
    ? false
    : options.fallbackLocale || 'en-US';
  var messages = options.messages || {};
  var dateTimeFormats = options.dateTimeFormats || {};
  var numberFormats = options.numberFormats || {};

  this._vm = null;
  this._formatter = options.formatter || defaultFormatter;
  this._modifiers = options.modifiers || {};
  this._missing = options.missing || null;
  this._root = options.root || null;
  this._sync = options.sync === undefined ? true : !!options.sync;
  this._fallbackRoot = options.fallbackRoot === undefined
    ? true
    : !!options.fallbackRoot;
  this._formatFallbackMessages = options.formatFallbackMessages === undefined
    ? false
    : !!options.formatFallbackMessages;
  this._silentTranslationWarn = options.silentTranslationWarn === undefined
    ? false
    : options.silentTranslationWarn;
  this._silentFallbackWarn = options.silentFallbackWarn === undefined
    ? false
    : !!options.silentFallbackWarn;
  this._dateTimeFormatters = {};
  this._numberFormatters = {};
  this._path = new I18nPath();
  this._dataListeners = [];
  this._componentInstanceCreatedListener = options.componentInstanceCreatedListener || null;
  this._preserveDirectiveContent = options.preserveDirectiveContent === undefined
    ? false
    : !!options.preserveDirectiveContent;
  this.pluralizationRules = options.pluralizationRules || {};
  this._warnHtmlInMessage = options.warnHtmlInMessage || 'off';
  this._postTranslation = options.postTranslation || null;

  /**
   * @param choice {number} a choice index given by the input to $tc: `$tc('path.to.rule', choiceIndex)`
   * @param choicesLength {number} an overall amount of available choices
   * @returns a final choice index
  */
  this.getChoiceIndex = function (choice, choicesLength) {
    var thisPrototype = Object.getPrototypeOf(this$1);
    if (thisPrototype && thisPrototype.getChoiceIndex) {
      var prototypeGetChoiceIndex = (thisPrototype.getChoiceIndex);
      return (prototypeGetChoiceIndex).call(this$1, choice, choicesLength)
    }

    // Default (old) getChoiceIndex implementation - english-compatible
    var defaultImpl = function (_choice, _choicesLength) {
      _choice = Math.abs(_choice);

      if (_choicesLength === 2) {
        return _choice
          ? _choice > 1
            ? 1
            : 0
          : 1
      }

      return _choice ? Math.min(_choice, 2) : 0
    };

    if (this$1.locale in this$1.pluralizationRules) {
      return this$1.pluralizationRules[this$1.locale].apply(this$1, [choice, choicesLength])
    } else {
      return defaultImpl(choice, choicesLength)
    }
  };


  this._exist = function (message, key) {
    if (!message || !key) { return false }
    if (!isNull(this$1._path.getPathValue(message, key))) { return true }
    // fallback for flat key
    if (message[key]) { return true }
    return false
  };

  if (this._warnHtmlInMessage === 'warn' || this._warnHtmlInMessage === 'error') {
    Object.keys(messages).forEach(function (locale) {
      this$1._checkLocaleMessage(locale, this$1._warnHtmlInMessage, messages[locale]);
    });
  }

  this._initVM({
    locale: locale,
    fallbackLocale: fallbackLocale,
    messages: messages,
    dateTimeFormats: dateTimeFormats,
    numberFormats: numberFormats
  });
};

var prototypeAccessors$3 = { vm: { configurable: true },messages: { configurable: true },dateTimeFormats: { configurable: true },numberFormats: { configurable: true },availableLocales: { configurable: true },locale: { configurable: true },fallbackLocale: { configurable: true },formatFallbackMessages: { configurable: true },missing: { configurable: true },formatter: { configurable: true },silentTranslationWarn: { configurable: true },silentFallbackWarn: { configurable: true },preserveDirectiveContent: { configurable: true },warnHtmlInMessage: { configurable: true },postTranslation: { configurable: true } };

VueI18n.prototype._checkLocaleMessage = function _checkLocaleMessage (locale, level, message) {
  var paths = [];

  var fn = function (level, locale, message, paths) {
    if (isPlainObject$1(message)) {
      Object.keys(message).forEach(function (key) {
        var val = message[key];
        if (isPlainObject$1(val)) {
          paths.push(key);
          paths.push('.');
          fn(level, locale, val, paths);
          paths.pop();
          paths.pop();
        } else {
          paths.push(key);
          fn(level, locale, val, paths);
          paths.pop();
        }
      });
    } else if (Array.isArray(message)) {
      message.forEach(function (item, index) {
        if (isPlainObject$1(item)) {
          paths.push(("[" + index + "]"));
          paths.push('.');
          fn(level, locale, item, paths);
          paths.pop();
          paths.pop();
        } else {
          paths.push(("[" + index + "]"));
          fn(level, locale, item, paths);
          paths.pop();
        }
      });
    } else if (isString(message)) {
      var ret = htmlTagMatcher.test(message);
      if (ret) {
        var msg = "Detected HTML in message '" + message + "' of keypath '" + (paths.join('')) + "' at '" + locale + "'. Consider component interpolation with '<i18n>' to avoid XSS. See https://bit.ly/2ZqJzkp";
        if (level === 'warn') {
          warn$1(msg);
        } else if (level === 'error') {
          error(msg);
        }
      }
    }
  };

  fn(level, locale, message, paths);
};

VueI18n.prototype._initVM = function _initVM (data) {
  var silent = Vue$2.config.silent;
  Vue$2.config.silent = true;
  this._vm = new Vue$2({ data: data });
  Vue$2.config.silent = silent;
};

VueI18n.prototype.destroyVM = function destroyVM () {
  this._vm.$destroy();
};

VueI18n.prototype.subscribeDataChanging = function subscribeDataChanging (vm) {
  this._dataListeners.push(vm);
};

VueI18n.prototype.unsubscribeDataChanging = function unsubscribeDataChanging (vm) {
  remove$3(this._dataListeners, vm);
};

VueI18n.prototype.watchI18nData = function watchI18nData () {
  var self = this;
  return this._vm.$watch('$data', function () {
    var i = self._dataListeners.length;
    while (i--) {
      Vue$2.nextTick(function () {
        self._dataListeners[i] && self._dataListeners[i].$forceUpdate();
      });
    }
  }, { deep: true })
};

VueI18n.prototype.watchLocale = function watchLocale () {
  /* istanbul ignore if */
  if (!this._sync || !this._root) { return null }
  var target = this._vm;
  return this._root.$i18n.vm.$watch('locale', function (val) {
    target.$set(target, 'locale', val);
    target.$forceUpdate();
  }, { immediate: true })
};

VueI18n.prototype.onComponentInstanceCreated = function onComponentInstanceCreated (newI18n) {
  if (this._componentInstanceCreatedListener) {
    this._componentInstanceCreatedListener(newI18n, this);
  }
};

prototypeAccessors$3.vm.get = function () { return this._vm };

prototypeAccessors$3.messages.get = function () { return looseClone(this._getMessages()) };
prototypeAccessors$3.dateTimeFormats.get = function () { return looseClone(this._getDateTimeFormats()) };
prototypeAccessors$3.numberFormats.get = function () { return looseClone(this._getNumberFormats()) };
prototypeAccessors$3.availableLocales.get = function () { return Object.keys(this.messages).sort() };

prototypeAccessors$3.locale.get = function () { return this._vm.locale };
prototypeAccessors$3.locale.set = function (locale) {
  this._vm.$set(this._vm, 'locale', locale);
};

prototypeAccessors$3.fallbackLocale.get = function () { return this._vm.fallbackLocale };
prototypeAccessors$3.fallbackLocale.set = function (locale) {
  this._localeChainCache = {};
  this._vm.$set(this._vm, 'fallbackLocale', locale);
};

prototypeAccessors$3.formatFallbackMessages.get = function () { return this._formatFallbackMessages };
prototypeAccessors$3.formatFallbackMessages.set = function (fallback) { this._formatFallbackMessages = fallback; };

prototypeAccessors$3.missing.get = function () { return this._missing };
prototypeAccessors$3.missing.set = function (handler) { this._missing = handler; };

prototypeAccessors$3.formatter.get = function () { return this._formatter };
prototypeAccessors$3.formatter.set = function (formatter) { this._formatter = formatter; };

prototypeAccessors$3.silentTranslationWarn.get = function () { return this._silentTranslationWarn };
prototypeAccessors$3.silentTranslationWarn.set = function (silent) { this._silentTranslationWarn = silent; };

prototypeAccessors$3.silentFallbackWarn.get = function () { return this._silentFallbackWarn };
prototypeAccessors$3.silentFallbackWarn.set = function (silent) { this._silentFallbackWarn = silent; };

prototypeAccessors$3.preserveDirectiveContent.get = function () { return this._preserveDirectiveContent };
prototypeAccessors$3.preserveDirectiveContent.set = function (preserve) { this._preserveDirectiveContent = preserve; };

prototypeAccessors$3.warnHtmlInMessage.get = function () { return this._warnHtmlInMessage };
prototypeAccessors$3.warnHtmlInMessage.set = function (level) {
    var this$1 = this;

  var orgLevel = this._warnHtmlInMessage;
  this._warnHtmlInMessage = level;
  if (orgLevel !== level && (level === 'warn' || level === 'error')) {
    var messages = this._getMessages();
    Object.keys(messages).forEach(function (locale) {
      this$1._checkLocaleMessage(locale, this$1._warnHtmlInMessage, messages[locale]);
    });
  }
};

prototypeAccessors$3.postTranslation.get = function () { return this._postTranslation };
prototypeAccessors$3.postTranslation.set = function (handler) { this._postTranslation = handler; };

VueI18n.prototype._getMessages = function _getMessages () { return this._vm.messages };
VueI18n.prototype._getDateTimeFormats = function _getDateTimeFormats () { return this._vm.dateTimeFormats };
VueI18n.prototype._getNumberFormats = function _getNumberFormats () { return this._vm.numberFormats };

VueI18n.prototype._warnDefault = function _warnDefault (locale, key, result, vm, values, interpolateMode) {
  if (!isNull(result)) { return result }
  if (this._missing) {
    var missingRet = this._missing.apply(null, [locale, key, vm, values]);
    if (isString(missingRet)) {
      return missingRet
    }
  }

  if (this._formatFallbackMessages) {
    var parsedArgs = parseArgs.apply(void 0, values);
    return this._render(key, interpolateMode, parsedArgs.params, key)
  } else {
    return key
  }
};

VueI18n.prototype._isFallbackRoot = function _isFallbackRoot (val) {
  return !val && !isNull(this._root) && this._fallbackRoot
};

VueI18n.prototype._isSilentFallbackWarn = function _isSilentFallbackWarn (key) {
  return this._silentFallbackWarn instanceof RegExp
    ? this._silentFallbackWarn.test(key)
    : this._silentFallbackWarn
};

VueI18n.prototype._isSilentFallback = function _isSilentFallback (locale, key) {
  return this._isSilentFallbackWarn(key) && (this._isFallbackRoot() || locale !== this.fallbackLocale)
};

VueI18n.prototype._isSilentTranslationWarn = function _isSilentTranslationWarn (key) {
  return this._silentTranslationWarn instanceof RegExp
    ? this._silentTranslationWarn.test(key)
    : this._silentTranslationWarn
};

VueI18n.prototype._interpolate = function _interpolate (
  locale,
  message,
  key,
  host,
  interpolateMode,
  values,
  visitedLinkStack
) {
  if (!message) { return null }

  var pathRet = this._path.getPathValue(message, key);
  if (Array.isArray(pathRet) || isPlainObject$1(pathRet)) { return pathRet }

  var ret;
  if (isNull(pathRet)) {
    /* istanbul ignore else */
    if (isPlainObject$1(message)) {
      ret = message[key];
      if (!isString(ret)) {
        return null
      }
    } else {
      return null
    }
  } else {
    /* istanbul ignore else */
    if (isString(pathRet)) {
      ret = pathRet;
    } else {
      return null
    }
  }

  // Check for the existence of links within the translated string
  if (ret.indexOf('@:') >= 0 || ret.indexOf('@.') >= 0) {
    ret = this._link(locale, message, ret, host, 'raw', values, visitedLinkStack);
  }

  return this._render(ret, interpolateMode, values, key)
};

VueI18n.prototype._link = function _link (
  locale,
  message,
  str,
  host,
  interpolateMode,
  values,
  visitedLinkStack
) {
  var ret = str;

  // Match all the links within the local
  // We are going to replace each of
  // them with its translation
  var matches = ret.match(linkKeyMatcher);
  for (var idx in matches) {
    // ie compatible: filter custom array
    // prototype method
    if (!matches.hasOwnProperty(idx)) {
      continue
    }
    var link = matches[idx];
    var linkKeyPrefixMatches = link.match(linkKeyPrefixMatcher);
    var linkPrefix = linkKeyPrefixMatches[0];
      var formatterName = linkKeyPrefixMatches[1];

    // Remove the leading @:, @.case: and the brackets
    var linkPlaceholder = link.replace(linkPrefix, '').replace(bracketsMatcher, '');

    if (includes(visitedLinkStack, linkPlaceholder)) {
      return ret
    }
    visitedLinkStack.push(linkPlaceholder);

    // Translate the link
    var translated = this._interpolate(
      locale, message, linkPlaceholder, host,
      interpolateMode === 'raw' ? 'string' : interpolateMode,
      interpolateMode === 'raw' ? undefined : values,
      visitedLinkStack
    );

    if (this._isFallbackRoot(translated)) {
      /* istanbul ignore if */
      if (!this._root) { throw Error('unexpected error') }
      var root = this._root.$i18n;
      translated = root._translate(
        root._getMessages(), root.locale, root.fallbackLocale,
        linkPlaceholder, host, interpolateMode, values
      );
    }
    translated = this._warnDefault(
      locale, linkPlaceholder, translated, host,
      Array.isArray(values) ? values : [values],
      interpolateMode
    );

    if (this._modifiers.hasOwnProperty(formatterName)) {
      translated = this._modifiers[formatterName](translated);
    } else if (defaultModifiers.hasOwnProperty(formatterName)) {
      translated = defaultModifiers[formatterName](translated);
    }

    visitedLinkStack.pop();

    // Replace the link with the translated
    ret = !translated ? ret : ret.replace(link, translated);
  }

  return ret
};

VueI18n.prototype._render = function _render (message, interpolateMode, values, path) {
  var ret = this._formatter.interpolate(message, values, path);

  // If the custom formatter refuses to work - apply the default one
  if (!ret) {
    ret = defaultFormatter.interpolate(message, values, path);
  }

  // if interpolateMode is **not** 'string' ('row'),
  // return the compiled data (e.g. ['foo', VNode, 'bar']) with formatter
  return interpolateMode === 'string' && !isString(ret) ? ret.join('') : ret
};

VueI18n.prototype._appendItemToChain = function _appendItemToChain (chain, item, blocks) {
  var follow = false;
  if (!includes(chain, item)) {
    follow = true;
    if (item) {
      follow = item[item.length - 1] !== '!';
      item = item.replace(/!/g, '');
      chain.push(item);
      if (blocks && blocks[item]) {
        follow = blocks[item];
      }
    }
  }
  return follow
};

VueI18n.prototype._appendLocaleToChain = function _appendLocaleToChain (chain, locale, blocks) {
  var follow;
  var tokens = locale.split('-');
  do {
    var item = tokens.join('-');
    follow = this._appendItemToChain(chain, item, blocks);
    tokens.splice(-1, 1);
  } while (tokens.length && (follow === true))
  return follow
};

VueI18n.prototype._appendBlockToChain = function _appendBlockToChain (chain, block, blocks) {
  var follow = true;
  for (var i = 0; (i < block.length) && (isBoolean(follow)); i++) {
    var locale = block[i];
    if (isString(locale)) {
      follow = this._appendLocaleToChain(chain, locale, blocks);
    }
  }
  return follow
};

VueI18n.prototype._getLocaleChain = function _getLocaleChain (start, fallbackLocale) {
  if (start === '') { return [] }

  if (!this._localeChainCache) {
    this._localeChainCache = {};
  }

  var chain = this._localeChainCache[start];
  if (!chain) {
    if (!fallbackLocale) {
      fallbackLocale = this.fallbackLocale;
    }
    chain = [];

    // first block defined by start
    var block = [start];

    // while any intervening block found
    while (isArray$1(block)) {
      block = this._appendBlockToChain(
        chain,
        block,
        fallbackLocale
      );
    }

    // last block defined by default
    var defaults;
    if (isArray$1(fallbackLocale)) {
      defaults = fallbackLocale;
    } else if (isObject$3(fallbackLocale)) {
      /* $FlowFixMe */
      if (fallbackLocale['default']) {
        defaults = fallbackLocale['default'];
      } else {
        defaults = null;
      }
    } else {
      defaults = fallbackLocale;
    }

    // convert defaults to array
    if (isString(defaults)) {
      block = [defaults];
    } else {
      block = defaults;
    }
    if (block) {
      this._appendBlockToChain(
        chain,
        block,
        null
      );
    }
    this._localeChainCache[start] = chain;
  }
  return chain
};

VueI18n.prototype._translate = function _translate (
  messages,
  locale,
  fallback,
  key,
  host,
  interpolateMode,
  args
) {
  var chain = this._getLocaleChain(locale, fallback);
  var res;
  for (var i = 0; i < chain.length; i++) {
    var step = chain[i];
    res =
      this._interpolate(step, messages[step], key, host, interpolateMode, args, [key]);
    if (!isNull(res)) {
      if (step !== locale && "production" !== 'production' && !this._isSilentTranslationWarn(key) && !this._isSilentFallbackWarn(key)) {
        warn$1(("Fall back to translate the keypath '" + key + "' with '" + step + "' locale."));
      }
      return res
    }
  }
  return null
};

VueI18n.prototype._t = function _t (key, _locale, messages, host) {
    var ref;

    var values = [], len = arguments.length - 4;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 4 ];
  if (!key) { return '' }

  var parsedArgs = parseArgs.apply(void 0, values);
  var locale = parsedArgs.locale || _locale;

  var ret = this._translate(
    messages, locale, this.fallbackLocale, key,
    host, 'string', parsedArgs.params
  );
  if (this._isFallbackRoot(ret)) {
    /* istanbul ignore if */
    if (!this._root) { throw Error('unexpected error') }
    return (ref = this._root).$t.apply(ref, [ key ].concat( values ))
  } else {
    ret = this._warnDefault(locale, key, ret, host, values, 'string');
    if (this._postTranslation && ret !== null && ret !== undefined) {
      ret = this._postTranslation(ret, key);
    }
    return ret
  }
};

VueI18n.prototype.t = function t (key) {
    var ref;

    var values = [], len = arguments.length - 1;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 1 ];
  return (ref = this)._t.apply(ref, [ key, this.locale, this._getMessages(), null ].concat( values ))
};

VueI18n.prototype._i = function _i (key, locale, messages, host, values) {
  var ret =
    this._translate(messages, locale, this.fallbackLocale, key, host, 'raw', values);
  if (this._isFallbackRoot(ret)) {
    if (!this._root) { throw Error('unexpected error') }
    return this._root.$i18n.i(key, locale, values)
  } else {
    return this._warnDefault(locale, key, ret, host, [values], 'raw')
  }
};

VueI18n.prototype.i = function i (key, locale, values) {
  /* istanbul ignore if */
  if (!key) { return '' }

  if (!isString(locale)) {
    locale = this.locale;
  }

  return this._i(key, locale, this._getMessages(), null, values)
};

VueI18n.prototype._tc = function _tc (
  key,
  _locale,
  messages,
  host,
  choice
) {
    var ref;

    var values = [], len = arguments.length - 5;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 5 ];
  if (!key) { return '' }
  if (choice === undefined) {
    choice = 1;
  }

  var predefined = { 'count': choice, 'n': choice };
  var parsedArgs = parseArgs.apply(void 0, values);
  parsedArgs.params = Object.assign(predefined, parsedArgs.params);
  values = parsedArgs.locale === null ? [parsedArgs.params] : [parsedArgs.locale, parsedArgs.params];
  return this.fetchChoice((ref = this)._t.apply(ref, [ key, _locale, messages, host ].concat( values )), choice)
};

VueI18n.prototype.fetchChoice = function fetchChoice (message, choice) {
  /* istanbul ignore if */
  if (!message && !isString(message)) { return null }
  var choices = message.split('|');

  choice = this.getChoiceIndex(choice, choices.length);
  if (!choices[choice]) { return message }
  return choices[choice].trim()
};

VueI18n.prototype.tc = function tc (key, choice) {
    var ref;

    var values = [], len = arguments.length - 2;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 2 ];
  return (ref = this)._tc.apply(ref, [ key, this.locale, this._getMessages(), null, choice ].concat( values ))
};

VueI18n.prototype._te = function _te (key, locale, messages) {
    var args = [], len = arguments.length - 3;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 3 ];

  var _locale = parseArgs.apply(void 0, args).locale || locale;
  return this._exist(messages[_locale], key)
};

VueI18n.prototype.te = function te (key, locale) {
  return this._te(key, this.locale, this._getMessages(), locale)
};

VueI18n.prototype.getLocaleMessage = function getLocaleMessage (locale) {
  return looseClone(this._vm.messages[locale] || {})
};

VueI18n.prototype.setLocaleMessage = function setLocaleMessage (locale, message) {
  if (this._warnHtmlInMessage === 'warn' || this._warnHtmlInMessage === 'error') {
    this._checkLocaleMessage(locale, this._warnHtmlInMessage, message);
  }
  this._vm.$set(this._vm.messages, locale, message);
};

VueI18n.prototype.mergeLocaleMessage = function mergeLocaleMessage (locale, message) {
  if (this._warnHtmlInMessage === 'warn' || this._warnHtmlInMessage === 'error') {
    this._checkLocaleMessage(locale, this._warnHtmlInMessage, message);
  }
  this._vm.$set(this._vm.messages, locale, merge({}, this._vm.messages[locale] || {}, message));
};

VueI18n.prototype.getDateTimeFormat = function getDateTimeFormat (locale) {
  return looseClone(this._vm.dateTimeFormats[locale] || {})
};

VueI18n.prototype.setDateTimeFormat = function setDateTimeFormat (locale, format) {
  this._vm.$set(this._vm.dateTimeFormats, locale, format);
  this._clearDateTimeFormat(locale, format);
};

VueI18n.prototype.mergeDateTimeFormat = function mergeDateTimeFormat (locale, format) {
  this._vm.$set(this._vm.dateTimeFormats, locale, merge(this._vm.dateTimeFormats[locale] || {}, format));
  this._clearDateTimeFormat(locale, format);
};

VueI18n.prototype._clearDateTimeFormat = function _clearDateTimeFormat (locale, format) {
  for (var key in format) {
    var id = locale + "__" + key;

    if (!this._dateTimeFormatters.hasOwnProperty(id)) {
      continue
    }

    delete this._dateTimeFormatters[id];
  }
};

VueI18n.prototype._localizeDateTime = function _localizeDateTime (
  value,
  locale,
  fallback,
  dateTimeFormats,
  key
) {
  var _locale = locale;
  var formats = dateTimeFormats[_locale];

  var chain = this._getLocaleChain(locale, fallback);
  for (var i = 0; i < chain.length; i++) {
    var current = _locale;
    var step = chain[i];
    formats = dateTimeFormats[step];
    _locale = step;
    // fallback locale
    if (isNull(formats) || isNull(formats[key])) {
      if (step !== locale && "production" !== 'production' && !this._isSilentTranslationWarn(key) && !this._isSilentFallbackWarn(key)) {
        warn$1(("Fall back to '" + step + "' datetime formats from '" + current + "' datetime formats."));
      }
    } else {
      break
    }
  }

  if (isNull(formats) || isNull(formats[key])) {
    return null
  } else {
    var format = formats[key];
    var id = _locale + "__" + key;
    var formatter = this._dateTimeFormatters[id];
    if (!formatter) {
      formatter = this._dateTimeFormatters[id] = new Intl.DateTimeFormat(_locale, format);
    }
    return formatter.format(value)
  }
};

VueI18n.prototype._d = function _d (value, locale, key) {

  if (!key) {
    return new Intl.DateTimeFormat(locale).format(value)
  }

  var ret =
    this._localizeDateTime(value, locale, this.fallbackLocale, this._getDateTimeFormats(), key);
  if (this._isFallbackRoot(ret)) {
    /* istanbul ignore if */
    if (!this._root) { throw Error('unexpected error') }
    return this._root.$i18n.d(value, key, locale)
  } else {
    return ret || ''
  }
};

VueI18n.prototype.d = function d (value) {
    var args = [], len = arguments.length - 1;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];

  var locale = this.locale;
  var key = null;

  if (args.length === 1) {
    if (isString(args[0])) {
      key = args[0];
    } else if (isObject$3(args[0])) {
      if (args[0].locale) {
        locale = args[0].locale;
      }
      if (args[0].key) {
        key = args[0].key;
      }
    }
  } else if (args.length === 2) {
    if (isString(args[0])) {
      key = args[0];
    }
    if (isString(args[1])) {
      locale = args[1];
    }
  }

  return this._d(value, locale, key)
};

VueI18n.prototype.getNumberFormat = function getNumberFormat (locale) {
  return looseClone(this._vm.numberFormats[locale] || {})
};

VueI18n.prototype.setNumberFormat = function setNumberFormat (locale, format) {
  this._vm.$set(this._vm.numberFormats, locale, format);
  this._clearNumberFormat(locale, format);
};

VueI18n.prototype.mergeNumberFormat = function mergeNumberFormat (locale, format) {
  this._vm.$set(this._vm.numberFormats, locale, merge(this._vm.numberFormats[locale] || {}, format));
  this._clearNumberFormat(locale, format);
};

VueI18n.prototype._clearNumberFormat = function _clearNumberFormat (locale, format) {
  for (var key in format) {
    var id = locale + "__" + key;

    if (!this._numberFormatters.hasOwnProperty(id)) {
      continue
    }

    delete this._numberFormatters[id];
  }
};

VueI18n.prototype._getNumberFormatter = function _getNumberFormatter (
  value,
  locale,
  fallback,
  numberFormats,
  key,
  options
) {
  var _locale = locale;
  var formats = numberFormats[_locale];

  var chain = this._getLocaleChain(locale, fallback);
  for (var i = 0; i < chain.length; i++) {
    var current = _locale;
    var step = chain[i];
    formats = numberFormats[step];
    _locale = step;
    // fallback locale
    if (isNull(formats) || isNull(formats[key])) {
      if (step !== locale && "production" !== 'production' && !this._isSilentTranslationWarn(key) && !this._isSilentFallbackWarn(key)) {
        warn$1(("Fall back to '" + step + "' number formats from '" + current + "' number formats."));
      }
    } else {
      break
    }
  }

  if (isNull(formats) || isNull(formats[key])) {
    return null
  } else {
    var format = formats[key];

    var formatter;
    if (options) {
      // If options specified - create one time number formatter
      formatter = new Intl.NumberFormat(_locale, Object.assign({}, format, options));
    } else {
      var id = _locale + "__" + key;
      formatter = this._numberFormatters[id];
      if (!formatter) {
        formatter = this._numberFormatters[id] = new Intl.NumberFormat(_locale, format);
      }
    }
    return formatter
  }
};

VueI18n.prototype._n = function _n (value, locale, key, options) {
  /* istanbul ignore if */
  if (!VueI18n.availabilities.numberFormat) {
    return ''
  }

  if (!key) {
    var nf = !options ? new Intl.NumberFormat(locale) : new Intl.NumberFormat(locale, options);
    return nf.format(value)
  }

  var formatter = this._getNumberFormatter(value, locale, this.fallbackLocale, this._getNumberFormats(), key, options);
  var ret = formatter && formatter.format(value);
  if (this._isFallbackRoot(ret)) {
    /* istanbul ignore if */
    if (!this._root) { throw Error('unexpected error') }
    return this._root.$i18n.n(value, Object.assign({}, { key: key, locale: locale }, options))
  } else {
    return ret || ''
  }
};

VueI18n.prototype.n = function n (value) {
    var args = [], len = arguments.length - 1;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];

  var locale = this.locale;
  var key = null;
  var options = null;

  if (args.length === 1) {
    if (isString(args[0])) {
      key = args[0];
    } else if (isObject$3(args[0])) {
      if (args[0].locale) {
        locale = args[0].locale;
      }
      if (args[0].key) {
        key = args[0].key;
      }

      // Filter out number format options only
      options = Object.keys(args[0]).reduce(function (acc, key) {
          var obj;

        if (includes(numberFormatKeys, key)) {
          return Object.assign({}, acc, ( obj = {}, obj[key] = args[0][key], obj ))
        }
        return acc
      }, null);
    }
  } else if (args.length === 2) {
    if (isString(args[0])) {
      key = args[0];
    }
    if (isString(args[1])) {
      locale = args[1];
    }
  }

  return this._n(value, locale, key, options)
};

VueI18n.prototype._ntp = function _ntp (value, locale, key, options) {
  /* istanbul ignore if */
  if (!VueI18n.availabilities.numberFormat) {
    return []
  }

  if (!key) {
    var nf = !options ? new Intl.NumberFormat(locale) : new Intl.NumberFormat(locale, options);
    return nf.formatToParts(value)
  }

  var formatter = this._getNumberFormatter(value, locale, this.fallbackLocale, this._getNumberFormats(), key, options);
  var ret = formatter && formatter.formatToParts(value);
  if (this._isFallbackRoot(ret)) {
    /* istanbul ignore if */
    if (!this._root) { throw Error('unexpected error') }
    return this._root.$i18n._ntp(value, locale, key, options)
  } else {
    return ret || []
  }
};

Object.defineProperties( VueI18n.prototype, prototypeAccessors$3 );

var availabilities;
// $FlowFixMe
Object.defineProperty(VueI18n, 'availabilities', {
  get: function get () {
    if (!availabilities) {
      var intlDefined = typeof Intl !== 'undefined';
      availabilities = {
        dateTimeFormat: intlDefined && typeof Intl.DateTimeFormat !== 'undefined',
        numberFormat: intlDefined && typeof Intl.NumberFormat !== 'undefined'
      };
    }

    return availabilities
  }
});

VueI18n.install = install$1;
VueI18n.version = '8.18.2';

var sharedComponents = {
	headerMenu: {
		title: "Conversation settings"
	}
};
var connectionBar = {
	untitled: "Untitled",
	selectPlaceholder: "Phones list",
	disconnectedNumbers: {
		onlyNumber: "Your WhatsApp is disconnected. It is necessary to scan the QR Code to reconnect your cell phone <strong>{name}</strong>",
		multipleNumbers: "Your WhatsApp is disconnected. Scan the QR Code to reconnect your cell phones",
		button: "Read QR Code"
	},
	connectingNumbers: {
		onlyNumber: "<strong>Phone not connected.</strong> Make sure the phone {name} ({number}) is connected to the internet. <a href=\"https://help.octadesk.com/kb/article/desconexao-whatsapp\" target=\"_blank\">How do I solve this?</a>",
		multipleNumbers: "<strong>Phones not connected.</strong> Make sure that the phones are connected to the internet. <a href=\"https://help.octadesk.com/kb/article/desconexao-whatsapp\" target=\"_blank\">How do I solve this?</a>"
	},
	connected: "connected"
};
var integrations = {
	web: {
		label: "Add WEB number"
	},
	api: {
		label: "Add API number"
	}
};
var listNumbers = {
	readQrCode: "Read QR code",
	type: "Type",
	types: {
		web: "WEB",
		api: "API"
	},
	status: "Status",
	title: "Manage your WhatsApp numbers ",
	addNewNumber: "Register number",
	updated: "Updated:",
	connectNow: "connect now",
	nameNickname: "Name / Nickname",
	country: "Country",
	number: "Number",
	battery: {
		title: "Battery level",
		updated: "Device battery levels aparelhos <br/> are updated every 5 minutes",
		unknown: "Cannot display battery level",
		"less-than-20": {
			charge: "⚠️ Your device is charging, <br/> while the battery is low it can <br/> stop transmitting your messages.",
			notCharging: "⚠️ Your device is not charging, with the battery <br/> low it can stop transmitting your messages! <br/> Connect it to a charger.<br/> <a href=\"https://help.octadesk.com/kb/article/desconexao-whatsapp\" target=\"_blank\">Why is it important?</a>"
		},
		"between-20-80": {
			charge: "Your device is charging, but it can still <br/> take a long time to transmit your messages ⏱️",
			notCharging: "Your device is not charging and it can <br/> take a long time to transmit your messages ⏱️<br/> Connect it to a charger.<br/> <a href=\"https://help.octadesk.com/kb/article/desconexao-whatsapp\" target=\"_blank\">Why is it important?</a>"
		},
		"between-80-99": {
			charge: "Your device is charging, soon it <br/> will be working at full capacity.",
			notCharging: "Your device is not charging, <br/> connect it to a charger so that <br/> it works at its full capacity. <br/> <a href=\"https://help.octadesk.com/kb/article/desconexao-whatsapp\" target=\"_blank\">Why is it important?</a>"
		},
		"bt-100": {
			charge: "Your device is charging and transmitting <br/> your messages in real time, congratulations! 🎉",
			notCharging: "Your device is not charging, but it is <br/> transmitting your messages in real time."
		}
	},
	integrationWhatsAppNotEnabled: "Whatsapp Integration is not enabled",
	integrationNotEnabled: "Your account does not have this integration<br/>Please contact our support active this integration ",
	addWhatsApp: "You have no numbers registered yet",
	description: "How about registering your WhatsApp numbers and organize all your conversations ?",
	startNow: "Register number",
	item: {
		active: "Active",
		inactive: "Inactive",
		reconnect: "Reconnect",
		deleteNumber: {
			title: "Are you sure you want to delete the number?",
			yes: "Yes",
			no: "No"
		},
		connected: "connected",
		connecting: "connecting",
		unplugged: "disconnected",
		rename: "Rename",
		changeName: {
			success: "Saved!",
			error: "Error"
		}
	}
};
var whatsappApiModal = {
	integrationInfo: {
		title: "To add your new WhatsApp Business API<br/> number you just need to enter an API Key, the number and the name of the phone",
		cancel: "Cancel",
		add: "Add",
		helpLink: "Questions on filling?",
		form: {
			required: "Oops, this field is required",
			apiKey: {
				label: "API Key",
				placeholder: "Enter the generated key here"
			},
			name: {
				label: "Telephone identification name",
				placeholder: "After Sales Commercial",
				tooltip: "It is how the number will be identified in Octadesk. This name will not be displayed to your customers."
			}
		}
	},
	responseStates: {
		error: {
			footer: {
				primary: "Yes",
				secondary: "No"
			},
			message: "Can you try again?",
			integrationInfo: {
				title: "We were unable to add your number."
			},
			profileInfo: {
				title: "We were unable to update your number."
			}
		},
		success: {
			integrationInfo: {
				title: "Registered number!",
				message: "Also edit your profile information to let your<br/> customers know they’re chatting with you.",
				footer: {
					primary: "Edit profile",
					secondary: "Add another number"
				}
			},
			profileInfo: {
				title: "Updated profile",
				message: "Your customers can already know more about your<br/> company by accessing your WhatsApp profile."
			}
		}
	},
	profileInfo: {
		headerTitle: "Complete your profile",
		helpLink: "Questions on filling?",
		steps: {
			first: "Photo and Description",
			second: "Business details"
		},
		personaInfo: {
			description: "What will your customers see when they talk to you on WhatsApp?",
			profilePicture: {
				title: "Profile picture",
				description: ".Png or .jpg files with 640x640px and up to 5MB. Images less than 192px in height or width can cause display problems.",
				editPicture: "Change or remove image",
				dropzone: {
					dictFileTooBig: "The file is larger than {maxFilesize} MB",
					dictResponseError: "Use .jpg or .png files",
					dictCancelUploadConfirmation: "Do you really want to cancel sending?",
					dictInvalidFileType: "Use .jpg or .png files",
					dictMaxFilesExceeded: "You can upload up to {maxFiles} files at a time."
				}
			},
			aboutDescription: {
				title: "Business description",
				description: "Describe in one sentence what your company can do for your customersDescribe in one sentence what your company can do for your customersDescribe in one sentence what your company can do for your customersDescribe in one sentence what your company can do for your customersDescribe in one sentence what your company can do for your customersDescribe in one sentence what your company can do for your customersDescribe in one sentence what your company can do for your customersDescribe in one sentence what your company can do for your customersDescribe in one sentence what your company can do for your customers",
				placeholder: "Type here",
				error: "Your description can be a maximum of 256 characters"
			}
		},
		businessInfo: {
			description: "Enter your address, email and website so your customers can get to know you better",
			address: {
				label: "Business address",
				placeholder: "Type here",
				error: "Your address can be a maximum of 256 characters"
			},
			vertical: {
				label: "Business vertical",
				placeholder: "Select an option",
				options: {
					Automotive: "Automotive",
					"Beauty, Spa and Salon": "Beauty, Spa and Salon",
					"Clothing and Apparel": "Clothing and Apparel",
					Education: "Education",
					Entertainment: "Entertainment",
					"Event Planning and Service": "Event Planning and Service",
					"Finance and Banking": "Finance and Banking",
					"Food and Grocery": "Food and Grocery",
					"Public Service": "Public Service",
					"Hotel and Lodging": "Hotel and Lodging",
					"Medical and Health": "Medical and Health",
					"Non-profit": "Non-profit",
					"Professional Services": "Professional Services",
					"Shopping and Retail": "Shopping and Retail",
					"Travel and Transportation": "Travel and Transportation",
					Restaurant: "Restaurant",
					Other: "Other"
				}
			},
			email: {
				label: "Email",
				placeholder: "youremail@website.com",
				error: "Oops, this is not a valid email or has more than 128 characters"
			},
			websites: {
				label: "Website",
				placeholder: "www.website.com",
				error: "Oops, this is not a valid website or has more than 256 characters. Remember to include http:// or https://"
			}
		},
		footer: {
			cancel: "Cancel",
			advance: "Advance",
			"return": "Return",
			finish: "Conclude"
		}
	}
};
var modal = {
	animation: {
		title: "We are Octa!",
		description: "Earn more agility <br /> and integration in your <br /> customer service. <br />"
	}
};
var qrCode = {
	title: "Almost there!",
	weAreAlmostThere: "You just need to open WhatsApp on your phone and read the code above.",
	errorReadingQRCode: {
		title: "Well, this is awkward...",
		description: "It looks like you were unable to read the QR Code.",
		button: {
			no: "Cancel",
			yes: "Read again"
		}
	},
	errorDifferentNumber: "Number that read the QrCode differs from what was passed",
	wppInstructions: {
		step1: "To read this QR Code on your WhatsApp",
		step2: "1. Open WhatsApp on your phone",
		step3: "2. Tap Menu <i class=\"icon-interactions\"></i> or Settings <i class=\"icon-cog\"></i> and select WhatsApp Web",
		whatsAppTerms: "By registering your number, you agree to the <a href=\"https://www.whatsapp.com/legal/?lang=en_us#terms-of-service\" target=\"_blank\">WhatsApp Ban Terms</a>"
	},
	successReadQrCode: {
		title: "You've made it!",
		description: "Now you can talk to your customers much faster and in a more organized way.",
		button: {
			start: "Start using",
			anotherNumber: "Register another number",
			manageNumbers: "Manage my numbers"
		}
	},
	availableConflict: {
		title: "Hey, I think I remember this number...",
		description: "This number has been registered before, if you choose to use it, any previous registration will be erased. Do you really want to continue?",
		button: {
			no: "No, keep previous registrations.",
			yes: "Yes, delete previous registrations."
		}
	}
};
var enUS = {
	sharedComponents: sharedComponents,
	connectionBar: connectionBar,
	integrations: integrations,
	listNumbers: listNumbers,
	whatsappApiModal: whatsappApiModal,
	modal: modal,
	qrCode: qrCode
};

var sharedComponents$1 = {
	headerMenu: {
		title: "Configurações de conversas"
	}
};
var connectionBar$1 = {
	untitled: "Sem nome",
	selectPlaceholder: "Lista de telefones",
	disconnectedNumbers: {
		onlyNumber: "Seu WhatsApp está desconectado. É necessário ler o QR Code para reconectar o telefone <strong>{name}</strong>",
		multipleNumbers: "Seu WhatsApp está desconectado. Leia o QR Code para reconectar os telefones",
		button: "Ler QR Code"
	},
	connectingNumbers: {
		onlyNumber: "<strong>Telefone desconectado.</strong> Certifique-se que o telefone {name} ({number}) está conectado com a internet. <a href=\"https://help.octadesk.com/kb/article/desconexao-whatsapp\" target=\"_blank\">Como resolvo isso?</a>",
		multipleNumbers: "<strong>Telefones desconectados.</strong> Certifique-se que os telefones estão conectados com a internet. <a href=\"https://help.octadesk.com/kb/article/desconexao-whatsapp\" target=\"_blank\">Como resolvo isso?</a>"
	},
	connected: "conectado"
};
var integrations$1 = {
	web: {
		label: "Adicionar número WEB"
	},
	api: {
		label: "Adicionar número API"
	}
};
var listNumbers$1 = {
	readQrCode: "Ler QR code",
	type: "Tipo",
	types: {
		web: "WEB",
		api: "API"
	},
	status: "Status",
	title: "Gerencie seus números de WhatsApp",
	addNewNumber: "Cadastrar número",
	updated: "Atualizado em:",
	connectNow: "Conectar agora",
	nameNickname: "Nome / Apelido",
	country: "País",
	number: "Número",
	battery: {
		title: "Nível de bateria",
		updated: "Os níveis de bateria dos aparelhos 📱<br/> são atualizados a cada 5 minutos.",
		unknown: "Não é possível exibir o nível da bateria",
		"less-than-20": {
			charge: "⚠️ Seu aparelho está carregando,<br/> enquanto a bateria estiver baixa ele pode<br/> parar de transmitir suas mensagens.",
			notCharging: "⚠️ Seu aparelho não está carregando, com a bateria<br/> baixa ele pode parar de transmitir suas mensagens!<br/> Conecte-o a um carregador.<br/> <a href=\"https://help.octadesk.com/kb/article/desconexao-whatsapp\" target=\"_blank\">Porque isso é importante?</a>"
		},
		"between-20-80": {
			charge: "Seu aparelho está carregando, mas ainda pode<br/> demorar para transmitir suas mensagens ⏱️",
			notCharging: "Seu aparelho não está carregando e pode<br/> demorar para transmitir suas mensagens ⏱️<br/> Conecte-o a um carregador.<br/> <a href=\"https://help.octadesk.com/kb/article/desconexao-whatsapp\" target=\"_blank\">Porque isso é importante?</a>"
		},
		"between-80-99": {
			charge: "Seu aparelho está carregando, em breve ele<br/> estará trabalhando na sua capacidade total.",
			notCharging: "Seu aparelho não está carregando,<br/> conecte-o a um carregador para que<br/> ele trabalhe em sua capacidade total.<br/> <a href=\"https://help.octadesk.com/kb/article/desconexao-whatsapp\" target=\"_blank\">Porque isso é importante?</a>"
		},
		"bt-100": {
			charge: "Seu aparelho está carregando e transmitindo<br/> suas mensagens em tempo real, parabéns! 🎉",
			notCharging: "Seu aparelho não está carregando, mas está<br/> transmitindo suas mensagens em tempo real."
		}
	},
	integrationWhatsAppNotEnabled: "Integração Whatsapp não habilitada",
	integrationNotEnabled: "Seu ambiente não possui essa integração habilitada<br/>Entre em contato com nosso suporte para habilita-lá",
	addWhatsApp: "Você ainda não tem números cadastrados",
	description: "Que tal cadastrar seus números de WhatsApp e organizar todas as suas conversas?",
	startNow: "Cadastrar número",
	item: {
		active: "Ativo",
		inactive: "Inativo",
		reconnect: "Reconectar",
		deleteNumber: {
			title: "Tem certeza que deseja apagar o número?",
			yes: "Sim",
			no: "Não"
		},
		connected: "conectado",
		connecting: "conectando",
		unplugged: "desconectado",
		rename: "Renomear",
		changeName: {
			success: "Salvo!",
			error: "Erro"
		}
	}
};
var whatsappApiModal$1 = {
	integrationInfo: {
		title: "Para adicionar seu novo número WhatsApp Business API<br/> você só precisa inserir a API Key, o número e o nome do telefone",
		cancel: "Cancelar",
		add: "Adicionar",
		helpLink: "Dúvidas no preenchimento?",
		form: {
			required: "Ops, esse campo é obrigatório",
			apiKey: {
				label: "API Key",
				placeholder: "Insira a chave gerada aqui"
			},
			name: {
				label: "Nome de identificação do telefone",
				placeholder: "Ex.: Comercial Pós-vendas",
				tooltip: "É como o número será identificado no Octadesk. Esse nome não será exibido para seus clientes."
			}
		}
	},
	responseStates: {
		error: {
			footer: {
				primary: "Sim",
				secondary: "Não"
			},
			message: "Você pode tentar novamente?",
			integrationInfo: {
				title: "Não conseguimos adicionar seu número."
			},
			profileInfo: {
				title: "Não conseguimos atualizar seu número."
			}
		},
		success: {
			integrationInfo: {
				title: "Número cadastrado!",
				message: "Edite também as informações do seu perfil para que seus<br/> clientes  saibam que estão conversando com você.",
				footer: {
					primary: "Editar perfil",
					secondary: "Adicionar outro número"
				}
			},
			profileInfo: {
				title: "Perfil atualizado",
				message: "Seus clientes já podem saber mais sobre sua<br/> empresa acessando seu perfil no WhatsApp."
			}
		}
	},
	profileInfo: {
		headerTitle: "Complete o seu perfil",
		helpLink: "Dúvidas no preenchimento?",
		steps: {
			first: "Foto e Descrição",
			second: "Detalhes do negócio"
		},
		personaInfo: {
			description: "O que os seus clientes vão ver ao falar com você pelo WhatsApp?",
			profilePicture: {
				title: "Foto de perfil",
				description: "Arquivos .png ou .jpg com 640x640px e até 5MB. Imagens com menos de 192px de altura ou largura podem causar problemas de exibição.",
				editPicture: "Trocar ou remover imagem",
				dropzone: {
					dictFileTooBig: "O arquivo é maior do que {maxFilesize} MB",
					dictResponseError: "Use arquivos tipo .jpg ou .png",
					dictCancelUploadConfirmation: "Deseja mesmo cancelar o envio?",
					dictInvalidFileType: "Use arquivos tipo .jpg ou .png",
					dictMaxFilesExceeded: "Você pode enviar até {maxFiles} arquivos por vez."
				}
			},
			aboutDescription: {
				title: "Descrição do negócio",
				description: "Descreva em uma frase o que sua empresa pode fazer por seus clientes",
				placeholder: "Digite aqui",
				error: "Sua descrição pode ter, no máximo, 256 caracteres"
			}
		},
		businessInfo: {
			description: "Informe seu endereço, email e site para que seu clientes possam conhecê-lo melhor",
			address: {
				label: "Endereço comercial",
				placeholder: "Digite aqui",
				error: "Seu endereço pode ter, no máximo, 256 caracteres"
			},
			vertical: {
				label: "Vertical de negócio",
				placeholder: "Selecione uma opção",
				options: {
					"Food and Grocery": "Alimentos e Mantimentos",
					Automotive: "Automotivo",
					"Beauty, Spa and Salon": "Beleza, Spa e Estética",
					"Shopping and Retail": "Compras e Varejo",
					Education: "Educação",
					Entertainment: "Entretenimento",
					"Finance and Banking": "Finanças e Serviços Bancários",
					"Hotel and Lodging": "Hotelaria e Hospedagem",
					"Event Planning and Service": "Planejamento e serviço de eventos",
					"Medical and Health": "Médica e Saúde",
					Restaurant: "Restaurante",
					"Clothing and Apparel": "Roupas e Vestuário",
					"Non-profit": "Sem Fins Lucrativos",
					"Professional Services": "Serviços Profissionais",
					"Public Service": "Serviços Públicos",
					"Travel and Transportation": "Viagens e Transporte",
					Other: "Outros"
				}
			},
			email: {
				label: "Email",
				placeholder: "seuemail@site.com",
				error: "Ops, esse não é um email válido ou tem mais de 128 caracteres"
			},
			websites: {
				label: "Site",
				placeholder: "www.site.com.br",
				error: "Ops, esse não é um site válido ou tem mais de 256 caracteres. Lembre-se de incluir http:// ou https://"
			}
		},
		footer: {
			cancel: "Cancelar",
			advance: "Avançar",
			"return": "Voltar",
			finish: "Concluir"
		}
	}
};
var modal$1 = {
	animation: {
		title: "We are Octa!",
		description: "Ganhe mais agilidade <br />e integração no seu <br />atendimento.<br />"
	}
};
var qrCode$1 = {
	title: "Quase lá!",
	weAreAlmostThere: "Você só precisa abrir o WhatsApp no seu telefone e ler o código acima.",
	errorReadingQRCode: {
		title: "Hum, isso é estranho!",
		description: "Parece que você não conseguiu ler o QR Code.",
		button: {
			no: "Cancelar",
			yes: "Ler novamente"
		}
	},
	errorDifferentNumber: "Número que leu o QrCode difere do que foi passado",
	wppInstructions: {
		step1: "Para ler este código QR no seu WhatsApp",
		step2: "1. Abra o WhatsApp no seu telefone",
		step3: "2. Toque em Mais opções <i class=\"icon-interactions\"></i> ou Ajustes <i class=\"icon-cog\"></i> e selecione WhatsApp Web",
		whatsAppTerms: "Ao registrar seu número, você concorda com os <a href=\"https://www.whatsapp.com/legal/?lang=pt_br#terms-of-service\" target=\"_blank\">Termos de banimento do WhatsApp</a>"
	},
	successReadQrCode: {
		title: "Você conseguiu!",
		description: "Agora você pode conversar com seus clientes muito mais rapidamente e de maneira mais organizada.",
		button: {
			start: "Começar a usar",
			anotherNumber: "Cadastrar outro número",
			manageNumbers: "Gerenciar meus números"
		}
	},
	availableConflict: {
		title: "Ei, acho que me lembro desse número...",
		description: "Esse número já foi registrado antes. Se você optar por usá-lo, qualquer registro anterior será apagado. Você realmente quer continuar?",
		button: {
			no: "Não, mantenha os registros anteriores.",
			yes: "Sim, exclua registros anteriores."
		}
	}
};
var ptBR = {
	sharedComponents: sharedComponents$1,
	connectionBar: connectionBar$1,
	integrations: integrations$1,
	listNumbers: listNumbers$1,
	whatsappApiModal: whatsappApiModal$1,
	modal: modal$1,
	qrCode: qrCode$1
};

var messages = {
  'en-US': _objectSpread2({}, enUS),
  'pt-BR': _objectSpread2({}, ptBR)
};

var dayjs_min = createCommonjsModule(function (module, exports) {
!function(t,e){module.exports=e();}(commonjsGlobal,function(){var t="millisecond",e="second",n="minute",r="hour",i="day",s="week",u="month",a="quarter",o="year",f="date",h=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[^0-9]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?.?(\d+)?$/,c=/\[([^\]]+)]|Y{2,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,d={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_")},$=function(t,e,n){var r=String(t);return !r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},l={s:$,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return (e<=0?"+":"-")+$(r,2,"0")+":"+$(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return -t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,u),s=n-i<0,a=e.clone().add(r+(s?-1:1),u);return +(-(r+(n-i)/(s?i-a:a-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(h){return {M:u,y:o,w:s,d:i,D:f,h:r,m:n,s:e,ms:t,Q:a}[h]||String(h||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},y="en",M={};M[y]=d;var m=function(t){return t instanceof S},D=function(t,e,n){var r;if(!t)return y;if("string"==typeof t)M[t]&&(r=t),e&&(M[t]=e,r=t);else {var i=t.name;M[i]=t,r=i;}return !n&&r&&(y=r),r||!n&&y},v=function(t,e){if(m(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new S(n)},g=l;g.l=D,g.i=m,g.w=function(t,e){return v(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var S=function(){function d(t){this.$L=this.$L||D(t.locale,null,!0),this.parse(t);}var $=d.prototype;return $.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(g.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match(h);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.$x=t.x||{},this.init();},$.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds();},$.$utils=function(){return g},$.isValid=function(){return !("Invalid Date"===this.$d.toString())},$.isSame=function(t,e){var n=v(t);return this.startOf(e)<=n&&n<=this.endOf(e)},$.isAfter=function(t,e){return v(t)<this.startOf(e)},$.isBefore=function(t,e){return this.endOf(e)<v(t)},$.$g=function(t,e,n){return g.u(t)?this[e]:this.set(n,t)},$.unix=function(){return Math.floor(this.valueOf()/1e3)},$.valueOf=function(){return this.$d.getTime()},$.startOf=function(t,a){var h=this,c=!!g.u(a)||a,d=g.p(t),$=function(t,e){var n=g.w(h.$u?Date.UTC(h.$y,e,t):new Date(h.$y,e,t),h);return c?n:n.endOf(i)},l=function(t,e){return g.w(h.toDate()[t].apply(h.toDate("s"),(c?[0,0,0,0]:[23,59,59,999]).slice(e)),h)},y=this.$W,M=this.$M,m=this.$D,D="set"+(this.$u?"UTC":"");switch(d){case o:return c?$(1,0):$(31,11);case u:return c?$(1,M):$(0,M+1);case s:var v=this.$locale().weekStart||0,S=(y<v?y+7:y)-v;return $(c?m-S:m+(6-S),M);case i:case f:return l(D+"Hours",0);case r:return l(D+"Minutes",1);case n:return l(D+"Seconds",2);case e:return l(D+"Milliseconds",3);default:return this.clone()}},$.endOf=function(t){return this.startOf(t,!1)},$.$set=function(s,a){var h,c=g.p(s),d="set"+(this.$u?"UTC":""),$=(h={},h[i]=d+"Date",h[f]=d+"Date",h[u]=d+"Month",h[o]=d+"FullYear",h[r]=d+"Hours",h[n]=d+"Minutes",h[e]=d+"Seconds",h[t]=d+"Milliseconds",h)[c],l=c===i?this.$D+(a-this.$W):a;if(c===u||c===o){var y=this.clone().set(f,1);y.$d[$](l),y.init(),this.$d=y.set(f,Math.min(this.$D,y.daysInMonth())).$d;}else $&&this.$d[$](l);return this.init(),this},$.set=function(t,e){return this.clone().$set(t,e)},$.get=function(t){return this[g.p(t)]()},$.add=function(t,a){var f,h=this;t=Number(t);var c=g.p(a),d=function(e){var n=v(h);return g.w(n.date(n.date()+Math.round(e*t)),h)};if(c===u)return this.set(u,this.$M+t);if(c===o)return this.set(o,this.$y+t);if(c===i)return d(1);if(c===s)return d(7);var $=(f={},f[n]=6e4,f[r]=36e5,f[e]=1e3,f)[c]||1,l=this.$d.getTime()+t*$;return g.w(l,this)},$.subtract=function(t,e){return this.add(-1*t,e)},$.format=function(t){var e=this;if(!this.isValid())return "Invalid Date";var n=t||"YYYY-MM-DDTHH:mm:ssZ",r=g.z(this),i=this.$locale(),s=this.$H,u=this.$m,a=this.$M,o=i.weekdays,f=i.months,h=function(t,r,i,s){return t&&(t[r]||t(e,n))||i[r].substr(0,s)},d=function(t){return g.s(s%12||12,t,"0")},$=i.meridiem||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r},l={YY:String(this.$y).slice(-2),YYYY:this.$y,M:a+1,MM:g.s(a+1,2,"0"),MMM:h(i.monthsShort,a,f,3),MMMM:h(f,a),D:this.$D,DD:g.s(this.$D,2,"0"),d:String(this.$W),dd:h(i.weekdaysMin,this.$W,o,2),ddd:h(i.weekdaysShort,this.$W,o,3),dddd:o[this.$W],H:String(s),HH:g.s(s,2,"0"),h:d(1),hh:d(2),a:$(s,u,!0),A:$(s,u,!1),m:String(u),mm:g.s(u,2,"0"),s:String(this.$s),ss:g.s(this.$s,2,"0"),SSS:g.s(this.$ms,3,"0"),Z:r};return n.replace(c,function(t,e){return e||l[t]||r.replace(":","")})},$.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},$.diff=function(t,f,h){var c,d=g.p(f),$=v(t),l=6e4*($.utcOffset()-this.utcOffset()),y=this-$,M=g.m(this,$);return M=(c={},c[o]=M/12,c[u]=M,c[a]=M/3,c[s]=(y-l)/6048e5,c[i]=(y-l)/864e5,c[r]=y/36e5,c[n]=y/6e4,c[e]=y/1e3,c)[d]||y,h?M:g.a(M)},$.daysInMonth=function(){return this.endOf(u).$D},$.$locale=function(){return M[this.$L]},$.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=D(t,e,!0);return r&&(n.$L=r),n},$.clone=function(){return g.w(this.$d,this)},$.toDate=function(){return new Date(this.valueOf())},$.toJSON=function(){return this.isValid()?this.toISOString():null},$.toISOString=function(){return this.$d.toISOString()},$.toString=function(){return this.$d.toUTCString()},d}(),p=S.prototype;return v.prototype=p,[["$ms",t],["$s",e],["$m",n],["$H",r],["$W",i],["$M",u],["$y",o],["$D",f]].forEach(function(t){p[t[1]]=function(e){return this.$g(e,t[0],t[1])};}),v.extend=function(t,e){return t(e,S,v),v},v.locale=D,v.isDayjs=m,v.unix=function(t){return v(1e3*t)},v.en=M[y],v.Ls=M,v});
});

var ptBr = createCommonjsModule(function (module, exports) {
!function(e,o){module.exports=o(dayjs_min);}(commonjsGlobal,function(e){e=e&&e.hasOwnProperty("default")?e.default:e;var o={name:"pt-br",weekdays:"Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado".split("_"),weekdaysShort:"Dom_Seg_Ter_Qua_Qui_Sex_Sáb".split("_"),weekdaysMin:"Do_2ª_3ª_4ª_5ª_6ª_Sá".split("_"),months:"Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split("_"),monthsShort:"Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split("_"),ordinal:function(e){return e+"º"},formats:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY [às] HH:mm",LLLL:"dddd, D [de] MMMM [de] YYYY [às] HH:mm"},relativeTime:{future:"em %s",past:"há %s",s:"poucos segundos",m:"um minuto",mm:"%d minutos",h:"uma hora",hh:"%d horas",d:"um dia",dd:"%d dias",M:"um mês",MM:"%d meses",y:"um ano",yy:"%d anos"}};return e.locale(o,null,!0),o});
});

Vue$1.use(VueI18n);
var language = Storage.getItem('language') || 'pt-BR';
var i18n = new VueI18n({
  locale: language,
  fallbackLocale: 'pt-BR',
  messages: messages
});

if (language) {
  if (language.startsWith('en')) {
    dayjs_min.locale('en');
  } else {
    dayjs_min.locale(language.toLowerCase());
  }
}

//
var script$2 = {
  i18n: i18n
};

/* script */
var __vue_script__$2 = script$2;
/* template */

var __vue_render__$2 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", [_c("header", {
    staticClass: "header header-sm"
  }, [_c("div", {
    staticClass: "col-sm-12"
  }, [_c("h1", [_vm._v(_vm._s(_vm.$t("sharedComponents.headerMenu.title")))])])])]);
};

var __vue_staticRenderFns__$2 = [];
__vue_render__$2._withStripped = true;
/* style */

var __vue_inject_styles__$2 = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-1fe6e39c_0", {
    source: "\n.clear-padding-bottom[data-v-1fe6e39c] {\n  padding-bottom: 0;\n}\n.beta-label[data-v-1fe6e39c] {\n  background: red;\n  color: #fff;\n  padding: 2px;\n}\n.nav-tabs.nav-subarea > li.active > a.clickable-tab[data-v-1fe6e39c]:hover {\n  border-bottom: 6px solid #5da9dd !important;\n}\n",
    map: {
      "version": 3,
      "sources": ["E:\\Octadesk\\octa-whatsapp-client\\src\\app\\shared-components\\HeaderMenu.vue"],
      "names": [],
      "mappings": ";AAmBA;EACA,iBAAA;AACA;AACA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AACA;AACA;EACA,2CAAA;AACA",
      "file": "HeaderMenu.vue",
      "sourcesContent": ["<template>\r\n  <div>\r\n    <header class=\"header header-sm\">\r\n      <div class=\"col-sm-12\">\r\n        <h1>{{ $t('sharedComponents.headerMenu.title') }}</h1>\r\n      </div>\r\n    </header>\r\n  </div>\r\n</template>\r\n\r\n<script>\r\n  import i18n from '@/i18n'\r\n\r\n  export default {\r\n    i18n\r\n  }\r\n</script>\r\n\r\n<style scoped>\r\n  .clear-padding-bottom {\r\n    padding-bottom: 0;\r\n  }\r\n  .beta-label {\r\n    background: red;\r\n    color: #fff;\r\n    padding: 2px;\r\n  }\r\n  .nav-tabs.nav-subarea > li.active > a.clickable-tab:hover {\r\n    border-bottom: 6px solid #5da9dd !important;\r\n  }\r\n</style>\r\n"]
    },
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$2 = "data-v-1fe6e39c";
/* module identifier */

var __vue_module_identifier__$2 = undefined;
/* functional template */

var __vue_is_functional_template__$2 = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$2 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, createInjector, undefined, undefined);

var aPossiblePrototype = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};

// `Object.setPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

// makes subclassing work correct for wrapped built-ins
var inheritIfRequired = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    objectSetPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    typeof (NewTarget = dummy.constructor) == 'function' &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) objectSetPrototypeOf($this, NewTargetPrototype);
  return $this;
};

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
var objectKeys = Object.keys || function keys(O) {
  return objectKeysInternal(O, enumBugKeys);
};

// `Object.defineProperties` method
// https://tc39.github.io/ecma262/#sec-object.defineproperties
var objectDefineProperties = descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) objectDefineProperty.f(O, key = keys[index++], Properties[key]);
  return O;
};

var html = getBuiltIn('document', 'documentElement');

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    /* global ActiveXObject */
    activeXDocument = document.domain && new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.github.io/ecma262/#sec-object.create
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : objectDefineProperties(result, Properties);
};

// a string of all valid unicode whitespaces
// eslint-disable-next-line max-len
var whitespaces = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod$2 = function (TYPE) {
  return function ($this) {
    var string = String(requireObjectCoercible($this));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimstart
  start: createMethod$2(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimend
  end: createMethod$2(2),
  // `String.prototype.trim` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.trim
  trim: createMethod$2(3)
};

var getOwnPropertyNames = objectGetOwnPropertyNames.f;
var getOwnPropertyDescriptor$3 = objectGetOwnPropertyDescriptor.f;
var defineProperty$2 = objectDefineProperty.f;
var trim = stringTrim.trim;

var NUMBER = 'Number';
var NativeNumber = global_1[NUMBER];
var NumberPrototype = NativeNumber.prototype;

// Opera ~12 has broken Object#toString
var BROKEN_CLASSOF = classofRaw(objectCreate(NumberPrototype)) == NUMBER;

// `ToNumber` abstract operation
// https://tc39.github.io/ecma262/#sec-tonumber
var toNumber$1 = function (argument) {
  var it = toPrimitive(argument, false);
  var first, third, radix, maxCode, digits, length, index, code;
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = it.charCodeAt(0);
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
        default: return +it;
      }
      digits = it.slice(2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = digits.charCodeAt(index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

// `Number` constructor
// https://tc39.github.io/ecma262/#sec-number-constructor
if (isForced_1(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
  var NumberWrapper = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var dummy = this;
    return dummy instanceof NumberWrapper
      // check on 1..constructor(foo) case
      && (BROKEN_CLASSOF ? fails(function () { NumberPrototype.valueOf.call(dummy); }) : classofRaw(dummy) != NUMBER)
        ? inheritIfRequired(new NativeNumber(toNumber$1(it)), dummy, NumberWrapper) : toNumber$1(it);
  };
  for (var keys$1 = descriptors ? getOwnPropertyNames(NativeNumber) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys$1.length > j; j++) {
    if (has(NativeNumber, key = keys$1[j]) && !has(NumberWrapper, key)) {
      defineProperty$2(NumberWrapper, key, getOwnPropertyDescriptor$3(NativeNumber, key));
    }
  }
  NumberWrapper.prototype = NumberPrototype;
  NumberPrototype.constructor = NumberWrapper;
  redefine(global_1, NUMBER, NumberWrapper);
}

//
//
//
//
//
//
//
//
var script$3 = {
  props: {
    time: {
      type: Number,
      required: true,
      default: 4000
    },
    type: {
      type: String,
      required: true,
      default: 'success'
    }
  },
  data: function data() {
    return {
      showingMessage: false
    };
  },
  methods: {
    showMessage: function showMessage() {
      var _this = this;

      this.showingMessage = true;
      window.setTimeout(function () {
        _this.showingMessage = false;
      }, this.time);
    }
  },
  mounted: function mounted() {
    this.showMessage();
  }
};

/* script */
var __vue_script__$3 = script$3;
/* template */

var __vue_render__$3 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("transition", {
    attrs: {
      name: "fade"
    }
  }, [_c("div", {
    staticClass: "toasts-component",
    class: _vm.type
  }, [_vm._t("default", null, null, _vm.$slots)], 2)]);
};

var __vue_staticRenderFns__$3 = [];
__vue_render__$3._withStripped = true;
/* style */

var __vue_inject_styles__$3 = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-19b424ae_0", {
    source: "div.toasts-component {\n  position: absolute;\n  top: 20px;\n  right: 40px;\n  width: 400px;\n  border-radius: 10px;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  font-size: 15px;\n  padding: 15px;\n}\ndiv.toasts-component strong {\n  margin: 0px 4px;\n}\ndiv.toasts-component i {\n  margin-right: 6px;\n}\ndiv.toasts-component.success {\n  color: #1bdd85;\n  border: 1px solid #5ae2a4;\n  background-color: #def9ed;\n}\ndiv.toasts-component.info {\n  color: #2775d3;\n  border: 1px solid #4b9bfc;\n  background-color: #d4e7ff;\n}\n\n/*# sourceMappingURL=Toasts.vue.map */",
    map: {
      "version": 3,
      "sources": ["E:\\Octadesk\\octa-whatsapp-client\\src\\app\\shared-components\\Toasts.vue", "Toasts.vue"],
      "names": [],
      "mappings": "AA2CA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;AC1CA;AD2CA;EACA,eAAA;ACzCA;AD2CA;EACA,iBAAA;ACzCA;AD2CA;EACA,cAAA;EACA,yBAAA;EACA,yBAAA;ACzCA;AD2CA;EACA,cAAA;EACA,yBAAA;EACA,yBAAA;ACzCA;;AAEA,qCAAqC",
      "file": "Toasts.vue",
      "sourcesContent": ["<template>\r\n  <transition name=\"fade\">\r\n    <div class=\"toasts-component\" :class=\"type\">\r\n      <slot v-bind=\"$slots\" />\r\n    </div>\r\n  </transition>\r\n</template>\r\n\r\n<script>\r\n  export default {\r\n    props: {\r\n      time: {\r\n        type: Number,\r\n        required: true,\r\n        default: 4000\r\n      },\r\n      type: {\r\n        type: String,\r\n        required: true,\r\n        default: 'success'\r\n      }\r\n    },\r\n    data() {\r\n      return {\r\n        showingMessage: false\r\n      }\r\n    },\r\n    methods: {\r\n      showMessage() {\r\n        this.showingMessage = true\r\n\r\n        window.setTimeout(() => {\r\n          this.showingMessage = false\r\n        }, this.time)\r\n      }\r\n    },\r\n    mounted() {\r\n      this.showMessage()\r\n    }\r\n  }\r\n</script>\r\n\r\n<style lang=\"scss\">\r\n  div.toasts-component {\r\n    position: absolute;\r\n    top: 20px;\r\n    right: 40px;\r\n    width: 400px;\r\n    border-radius: 10px;\r\n    display: flex;\r\n    justify-content: flex-start;\r\n    align-items: center;\r\n    font-size: 15px;\r\n    padding: 15px;\r\n    strong {\r\n      margin: 0px 4px;\r\n    }\r\n    i {\r\n      margin-right: 6px;\r\n    }\r\n    &.success {\r\n      color: #1bdd85;\r\n      border: 1px solid #5ae2a4;\r\n      background-color: #def9ed;\r\n    }\r\n    &.info {\r\n      color: #2775d3;\r\n      border: 1px solid #4b9bfc;\r\n      background-color: #d4e7ff;\r\n    }\r\n  }\r\n</style>\r\n", "div.toasts-component {\n  position: absolute;\n  top: 20px;\n  right: 40px;\n  width: 400px;\n  border-radius: 10px;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  font-size: 15px;\n  padding: 15px;\n}\ndiv.toasts-component strong {\n  margin: 0px 4px;\n}\ndiv.toasts-component i {\n  margin-right: 6px;\n}\ndiv.toasts-component.success {\n  color: #1bdd85;\n  border: 1px solid #5ae2a4;\n  background-color: #def9ed;\n}\ndiv.toasts-component.info {\n  color: #2775d3;\n  border: 1px solid #4b9bfc;\n  background-color: #d4e7ff;\n}\n\n/*# sourceMappingURL=Toasts.vue.map */"]
    },
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$3 = undefined;
/* module identifier */

var __vue_module_identifier__$3 = undefined;
/* functional template */

var __vue_is_functional_template__$3 = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$3 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, createInjector, undefined, undefined);

function isExist(obj) {
  return typeof obj !== 'undefined' && obj !== null;
}

function isFunction(obj) {
  return typeof obj === 'function';
}

function isNumber(obj) {
  return typeof obj === 'number';
}

function isString$1(obj) {
  return typeof obj === 'string';
}

function isBoolean$1(obj) {
  return typeof obj === 'boolean';
}

function isPromiseSupported() {
  return typeof window !== 'undefined' && isExist(window.Promise);
}

var Carousel = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "carousel slide", attrs: { "data-ride": "carousel" }, on: { "mouseenter": _vm.stopInterval, "mouseleave": _vm.startInterval } }, [_vm.indicators ? _vm._t("indicators", [_c('ol', { staticClass: "carousel-indicators" }, _vm._l(_vm.slides, function (slide, index) {
      return _c('li', { class: { active: index === _vm.activeIndex }, on: { "click": function click($event) {
            return _vm.select(index);
          } } });
    }), 0)], { "select": _vm.select, "activeIndex": _vm.activeIndex }) : _vm._e(), _vm._v(" "), _c('div', { staticClass: "carousel-inner", attrs: { "role": "listbox" } }, [_vm._t("default")], 2), _vm._v(" "), _vm.controls ? _c('a', { staticClass: "left carousel-control", attrs: { "href": "#", "role": "button" }, on: { "click": function click($event) {
          $event.preventDefault();return _vm.prev();
        } } }, [_c('span', { class: _vm.iconControlLeft, attrs: { "aria-hidden": "true" } }), _vm._v(" "), _c('span', { staticClass: "sr-only" }, [_vm._v("Previous")])]) : _vm._e(), _vm._v(" "), _vm.controls ? _c('a', { staticClass: "right carousel-control", attrs: { "href": "#", "role": "button" }, on: { "click": function click($event) {
          $event.preventDefault();return _vm.next();
        } } }, [_c('span', { class: _vm.iconControlRight, attrs: { "aria-hidden": "true" } }), _vm._v(" "), _c('span', { staticClass: "sr-only" }, [_vm._v("Next")])]) : _vm._e()], 2);
  }, staticRenderFns: [],
  props: {
    value: Number,
    indicators: {
      type: Boolean,
      default: true
    },
    controls: {
      type: Boolean,
      default: true
    },
    interval: {
      type: Number,
      default: 5000
    },
    iconControlLeft: {
      type: String,
      default: 'glyphicon glyphicon-chevron-left'
    },
    iconControlRight: {
      type: String,
      default: 'glyphicon glyphicon-chevron-right'
    }
  },
  data: function data() {
    return {
      slides: [],
      activeIndex: 0, // Make v-model not required
      timeoutId: 0,
      intervalId: 0
    };
  },

  watch: {
    interval: function interval() {
      this.startInterval();
    },
    value: function value(index, oldValue) {
      this.run(index, oldValue);
      this.activeIndex = index;
    }
  },
  mounted: function mounted() {
    if (isExist(this.value)) {
      this.activeIndex = this.value;
    }
    if (this.slides.length > 0) {
      this.$select(this.activeIndex);
    }
    this.startInterval();
  },
  beforeDestroy: function beforeDestroy() {
    this.stopInterval();
  },

  methods: {
    run: function run(newIndex, oldIndex) {
      var _this = this;

      var currentActiveIndex = oldIndex || 0;
      var direction = void 0;
      if (newIndex > currentActiveIndex) {
        direction = ['next', 'left'];
      } else {
        direction = ['prev', 'right'];
      }
      this.slides[newIndex].slideClass[direction[0]] = true;
      this.$nextTick(function () {
        _this.slides[newIndex].$el.offsetHeight;
        _this.slides.forEach(function (slide, i) {
          if (i === currentActiveIndex) {
            slide.slideClass.active = true;
            slide.slideClass[direction[1]] = true;
          } else if (i === newIndex) {
            slide.slideClass[direction[1]] = true;
          }
        });
        _this.timeoutId = setTimeout(function () {
          _this.$select(newIndex);
          _this.$emit('change', newIndex);
          _this.timeoutId = 0;
        }, 600);
      });
    },
    startInterval: function startInterval() {
      var _this2 = this;

      this.stopInterval();
      if (this.interval > 0) {
        this.intervalId = setInterval(function () {
          _this2.next();
        }, this.interval);
      }
    },
    stopInterval: function stopInterval() {
      clearInterval(this.intervalId);
      this.intervalId = 0;
    },
    resetAllSlideClass: function resetAllSlideClass() {
      this.slides.forEach(function (slide) {
        slide.slideClass.active = false;
        slide.slideClass.left = false;
        slide.slideClass.right = false;
        slide.slideClass.next = false;
        slide.slideClass.prev = false;
      });
    },
    $select: function $select(index) {
      this.resetAllSlideClass();
      this.slides[index].slideClass.active = true;
    },
    select: function select(index) {
      if (this.timeoutId !== 0 || index === this.activeIndex) {
        return;
      }
      if (isExist(this.value)) {
        this.$emit('input', index);
      } else {
        this.run(index, this.activeIndex);
        this.activeIndex = index;
      }
    },
    prev: function prev() {
      this.select(this.activeIndex === 0 ? this.slides.length - 1 : this.activeIndex - 1);
    },
    next: function next() {
      this.select(this.activeIndex === this.slides.length - 1 ? 0 : this.activeIndex + 1);
    }
  }
};

function spliceIfExist(arr, item) {
  if (Array.isArray(arr)) {
    var index = arr.indexOf(item);
    if (index >= 0) {
      arr.splice(index, 1);
    }
  }
}

function range(end) {
  var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  var arr = [];
  for (var i = start; i < end; i += step) {
    arr.push(i);
  }
  return arr;
}

function nodeListToArray(nodeList) {
  return Array.prototype.slice.call(nodeList || []);
}

function onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}

var Slide = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "item", class: _vm.slideClass }, [_vm._t("default")], 2);
  }, staticRenderFns: [],
  data: function data() {
    return {
      slideClass: {
        active: false,
        prev: false,
        next: false,
        left: false,
        right: false
      }
    };
  },
  created: function created() {
    try {
      this.$parent.slides.push(this);
    } catch (e) {
      throw new Error('Slide parent must be Carousel.');
    }
  },
  beforeDestroy: function beforeDestroy() {
    var slides = this.$parent && this.$parent.slides;
    spliceIfExist(slides, this);
  }
};

var EVENTS = {
  MOUSE_ENTER: 'mouseenter',
  MOUSE_LEAVE: 'mouseleave',
  FOCUS: 'focus',
  BLUR: 'blur',
  CLICK: 'click',
  INPUT: 'input',
  KEY_DOWN: 'keydown',
  KEY_UP: 'keyup',
  KEY_PRESS: 'keypress',
  RESIZE: 'resize',
  SCROLL: 'scroll',
  TOUCH_START: 'touchstart',
  TOUCH_END: 'touchend'
};

var TRIGGERS = {
  CLICK: 'click',
  HOVER: 'hover',
  FOCUS: 'focus',
  HOVER_FOCUS: 'hover-focus',
  OUTSIDE_CLICK: 'outside-click',
  MANUAL: 'manual'
};

var PLACEMENTS = {
  TOP: 'top',
  RIGHT: 'right',
  BOTTOM: 'bottom',
  LEFT: 'left'
};

function isIE11() {
  return !!window.MSInputMethodContext && !!document.documentMode;
}

function isIE10() {
  return window.navigator.appVersion.indexOf('MSIE 10') !== -1;
}

function getComputedStyle(el) {
  return window.getComputedStyle(el);
}

function getViewportSize() {
  var width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  var height = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
  return { width: width, height: height };
}

var scrollbarWidth = null;
var savedScreenSize = null;

function getScrollbarWidth() {
  var recalculate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var screenSize = getViewportSize();
  // return directly when already calculated & not force recalculate & screen size not changed
  if (scrollbarWidth !== null && !recalculate && screenSize.height === savedScreenSize.height && screenSize.width === savedScreenSize.width) {
    return scrollbarWidth;
  }
  if (document.readyState === 'loading') {
    return null;
  }
  var div1 = document.createElement('div');
  var div2 = document.createElement('div');
  div1.style.width = div2.style.width = div1.style.height = div2.style.height = '100px';
  div1.style.overflow = 'scroll';
  div2.style.overflow = 'hidden';
  document.body.appendChild(div1);
  document.body.appendChild(div2);
  scrollbarWidth = Math.abs(div1.scrollHeight - div2.scrollHeight);
  document.body.removeChild(div1);
  document.body.removeChild(div2);
  // save new screen size
  savedScreenSize = screenSize;
  return scrollbarWidth;
}

function on(element, event, handler) {
  element.addEventListener(event, handler);
}

function off(element, event, handler) {
  element.removeEventListener(event, handler);
}

function isElement(el) {
  return el && el.nodeType === Node.ELEMENT_NODE;
}

function removeFromDom(el) {
  isElement(el) && isElement(el.parentNode) && el.parentNode.removeChild(el);
}

function ensureElementMatchesFunction() {
  if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function (s) {
      var matches = (this.document || this.ownerDocument).querySelectorAll(s);
      var i = matches.length;
      while (--i >= 0 && matches.item(i) !== this) {}
      return i > -1;
    };
  }
}

function addClass$1(el, className) {
  if (!isElement(el)) {
    return;
  }
  if (el.className) {
    var classes = el.className.split(' ');
    if (classes.indexOf(className) < 0) {
      classes.push(className);
      el.className = classes.join(' ');
    }
  } else {
    el.className = className;
  }
}

function removeClass$1(el, className) {
  if (!isElement(el)) {
    return;
  }
  if (el.className) {
    var classes = el.className.split(' ');
    var newClasses = [];
    for (var i = 0, l = classes.length; i < l; i++) {
      if (classes[i] !== className) {
        newClasses.push(classes[i]);
      }
    }
    el.className = newClasses.join(' ');
  }
}

function hasClass(el, className) {
  if (!isElement(el)) {
    return false;
  }
  var classes = el.className.split(' ');
  for (var i = 0, l = classes.length; i < l; i++) {
    if (classes[i] === className) {
      return true;
    }
  }
  return false;
}

function setDropdownPosition(dropdown, trigger) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var doc = document.documentElement;
  var containerScrollLeft = (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
  var containerScrollTop = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
  var rect = trigger.getBoundingClientRect();
  var dropdownRect = dropdown.getBoundingClientRect();
  dropdown.style.right = 'auto';
  dropdown.style.bottom = 'auto';
  if (options.menuRight) {
    dropdown.style.left = containerScrollLeft + rect.left + rect.width - dropdownRect.width + 'px';
  } else {
    dropdown.style.left = containerScrollLeft + rect.left + 'px';
  }
  if (options.dropup) {
    dropdown.style.top = containerScrollTop + rect.top - dropdownRect.height - 4 + 'px';
  } else {
    dropdown.style.top = containerScrollTop + rect.top + rect.height + 'px';
  }
}

function isAvailableAtPosition(trigger, popup, placement) {
  var triggerRect = trigger.getBoundingClientRect();
  var popupRect = popup.getBoundingClientRect();
  var viewPortSize = getViewportSize();
  var top = true;
  var right = true;
  var bottom = true;
  var left = true;
  switch (placement) {
    case PLACEMENTS.TOP:
      top = triggerRect.top >= popupRect.height;
      left = triggerRect.left + triggerRect.width / 2 >= popupRect.width / 2;
      right = triggerRect.right - triggerRect.width / 2 + popupRect.width / 2 <= viewPortSize.width;
      break;
    case PLACEMENTS.BOTTOM:
      bottom = triggerRect.bottom + popupRect.height <= viewPortSize.height;
      left = triggerRect.left + triggerRect.width / 2 >= popupRect.width / 2;
      right = triggerRect.right - triggerRect.width / 2 + popupRect.width / 2 <= viewPortSize.width;
      break;
    case PLACEMENTS.RIGHT:
      right = triggerRect.right + popupRect.width <= viewPortSize.width;
      top = triggerRect.top + triggerRect.height / 2 >= popupRect.height / 2;
      bottom = triggerRect.bottom - triggerRect.height / 2 + popupRect.height / 2 <= viewPortSize.height;
      break;
    case PLACEMENTS.LEFT:
      left = triggerRect.left >= popupRect.width;
      top = triggerRect.top + triggerRect.height / 2 >= popupRect.height / 2;
      bottom = triggerRect.bottom - triggerRect.height / 2 + popupRect.height / 2 <= viewPortSize.height;
      break;
  }
  return top && right && bottom && left;
}

function setTooltipPosition(tooltip, trigger, placement, auto, appendToSelector, viewport) {
  if (!isElement(tooltip) || !isElement(trigger)) {
    return;
  }
  var isPopover = tooltip && tooltip.className && tooltip.className.indexOf('popover') >= 0;
  var containerScrollTop = void 0;
  var containerScrollLeft = void 0;
  if (!isExist(appendToSelector) || appendToSelector === 'body') {
    var doc = document.documentElement;
    containerScrollLeft = (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
    containerScrollTop = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
  } else {
    var container = document.querySelector(appendToSelector);
    containerScrollLeft = container.scrollLeft;
    containerScrollTop = container.scrollTop;
  }
  // auto adjust placement
  if (auto) {
    // Try: right -> bottom -> left -> top
    // Cause the default placement is top
    var placements = [PLACEMENTS.RIGHT, PLACEMENTS.BOTTOM, PLACEMENTS.LEFT, PLACEMENTS.TOP];
    // The class switch helper function
    var changePlacementClass = function changePlacementClass(placement) {
      // console.log(placement)
      placements.forEach(function (placement) {
        removeClass$1(tooltip, placement);
      });
      addClass$1(tooltip, placement);
    };
    // No need to adjust if the default placement fits
    if (!isAvailableAtPosition(trigger, tooltip, placement)) {
      for (var i = 0, l = placements.length; i < l; i++) {
        // Re-assign placement class
        changePlacementClass(placements[i]);
        // Break if new placement fits
        if (isAvailableAtPosition(trigger, tooltip, placements[i])) {
          placement = placements[i];
          break;
        }
      }
      changePlacementClass(placement);
    }
  }
  // fix left and top for tooltip
  var rect = trigger.getBoundingClientRect();
  var tooltipRect = tooltip.getBoundingClientRect();
  var top = void 0;
  var left = void 0;
  if (placement === PLACEMENTS.BOTTOM) {
    top = containerScrollTop + rect.top + rect.height;
    left = containerScrollLeft + rect.left + rect.width / 2 - tooltipRect.width / 2;
  } else if (placement === PLACEMENTS.LEFT) {
    top = containerScrollTop + rect.top + rect.height / 2 - tooltipRect.height / 2;
    left = containerScrollLeft + rect.left - tooltipRect.width;
  } else if (placement === PLACEMENTS.RIGHT) {
    top = containerScrollTop + rect.top + rect.height / 2 - tooltipRect.height / 2;
    // https://github.com/wxsms/uiv/issues/272
    // add 1px to fix above issue
    left = containerScrollLeft + rect.left + rect.width + 1;
  } else {
    top = containerScrollTop + rect.top - tooltipRect.height;
    left = containerScrollLeft + rect.left + rect.width / 2 - tooltipRect.width / 2;
  }
  var viewportEl = void 0;
  // viewport option
  if (isString$1(viewport)) {
    viewportEl = document.querySelector(viewport);
  } else if (isFunction(viewport)) {
    viewportEl = viewport(trigger);
  }
  if (isElement(viewportEl)) {
    var popoverFix = isPopover ? 11 : 0;
    var viewportReact = viewportEl.getBoundingClientRect();
    var viewportTop = containerScrollTop + viewportReact.top;
    var viewportLeft = containerScrollLeft + viewportReact.left;
    var viewportBottom = viewportTop + viewportReact.height;
    var viewportRight = viewportLeft + viewportReact.width;
    // fix top
    if (top < viewportTop) {
      top = viewportTop;
    } else if (top + tooltipRect.height > viewportBottom) {
      top = viewportBottom - tooltipRect.height;
    }
    // fix left
    if (left < viewportLeft) {
      left = viewportLeft;
    } else if (left + tooltipRect.width > viewportRight) {
      left = viewportRight - tooltipRect.width;
    }
    // fix for popover pointer
    if (placement === PLACEMENTS.BOTTOM) {
      top -= popoverFix;
    } else if (placement === PLACEMENTS.LEFT) {
      left += popoverFix;
    } else if (placement === PLACEMENTS.RIGHT) {
      left -= popoverFix;
    } else {
      top += popoverFix;
    }
  }
  // set position finally
  tooltip.style.top = top + 'px';
  tooltip.style.left = left + 'px';
}

function hasScrollbar(el) {
  var SCROLL = 'scroll';
  var hasVScroll = el.scrollHeight > el.clientHeight;
  var style = getComputedStyle(el);
  return hasVScroll || style.overflow === SCROLL || style.overflowY === SCROLL;
}

function toggleBodyOverflow(enable) {
  var MODAL_OPEN = 'modal-open';
  var body = document.body;
  if (enable) {
    removeClass$1(body, MODAL_OPEN);
    body.style.paddingRight = null;
  } else {
    var browsersWithFloatingScrollbar = isIE10() || isIE11();
    var documentHasScrollbar = hasScrollbar(document.documentElement) || hasScrollbar(document.body);
    if (documentHasScrollbar && !browsersWithFloatingScrollbar) {
      body.style.paddingRight = getScrollbarWidth() + 'px';
    }
    addClass$1(body, MODAL_OPEN);
  }
}

function getClosest(el, selector) {
  ensureElementMatchesFunction();
  var parent = void 0;
  var _el = el;
  while (_el) {
    parent = _el.parentElement;
    if (parent && parent.matches(selector)) {
      return parent;
    }
    _el = parent;
  }
  return null;
}

function getParents(el, selector) {
  var until = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  ensureElementMatchesFunction();
  var parents = [];
  var parent = el.parentElement;
  while (parent) {
    if (parent.matches(selector)) {
      parents.push(parent);
    } else if (until && (until === parent || parent.matches(until))) {
      break;
    }
    parent = parent.parentElement;
  }
  return parents;
}

function focus(el) {
  if (!isElement(el)) {
    return;
  }
  el.getAttribute('tabindex') ? null : el.setAttribute('tabindex', '-1');
  el.focus();
}

var COLLAPSE = 'collapse';
var IN = 'in';
var COLLAPSING = 'collapsing';

var Collapse = {
  render: function render(h) {
    return h(this.tag, {}, this.$slots.default);
  },

  props: {
    tag: {
      type: String,
      default: 'div'
    },
    value: {
      type: Boolean,
      default: false
    },
    transitionDuration: {
      type: Number,
      default: 350
    }
  },
  data: function data() {
    return {
      timeoutId: 0
    };
  },

  watch: {
    value: function value(show) {
      this.toggle(show);
    }
  },
  mounted: function mounted() {
    var el = this.$el;
    addClass$1(el, COLLAPSE);
    if (this.value) {
      addClass$1(el, IN);
    }
  },

  methods: {
    toggle: function toggle(show) {
      var _this = this;

      clearTimeout(this.timeoutId);
      var el = this.$el;
      if (show) {
        this.$emit('show');
        removeClass$1(el, COLLAPSE);
        el.style.height = 'auto';
        var height = window.getComputedStyle(el).height;
        el.style.height = null;
        addClass$1(el, COLLAPSING);
        el.offsetHeight; // force repaint
        el.style.height = height;
        this.timeoutId = setTimeout(function () {
          removeClass$1(el, COLLAPSING);
          addClass$1(el, COLLAPSE);
          addClass$1(el, IN);
          el.style.height = null;
          _this.timeoutId = 0;
          _this.$emit('shown');
        }, this.transitionDuration);
      } else {
        this.$emit('hide');
        el.style.height = window.getComputedStyle(el).height;
        removeClass$1(el, IN);
        removeClass$1(el, COLLAPSE);
        el.offsetHeight;
        el.style.height = null;
        addClass$1(el, COLLAPSING);
        this.timeoutId = setTimeout(function () {
          addClass$1(el, COLLAPSE);
          removeClass$1(el, COLLAPSING);
          el.style.height = null;
          _this.timeoutId = 0;
          _this.$emit('hidden');
        }, this.transitionDuration);
      }
    }
  }
};

var DEFAULT_TAG = 'div';

var Dropdown = {
  render: function render(h) {
    return h(this.tag, {
      class: {
        'btn-group': this.tag === DEFAULT_TAG,
        dropdown: !this.dropup,
        dropup: this.dropup,
        open: this.show
      }
    }, [this.$slots.default, h('ul', {
      class: {
        'dropdown-menu': true,
        'dropdown-menu-right': this.menuRight
      },
      ref: 'dropdown'
    }, [this.$slots.dropdown])]);
  },

  props: {
    tag: {
      type: String,
      default: DEFAULT_TAG
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    value: Boolean,
    dropup: {
      type: Boolean,
      default: false
    },
    menuRight: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    notCloseElements: Array,
    positionElement: null
  },
  data: function data() {
    return {
      show: false,
      triggerEl: undefined
    };
  },

  watch: {
    value: function value(v) {
      this.toggle(v);
    }
  },
  mounted: function mounted() {
    this.initTrigger();
    if (this.triggerEl) {
      on(this.triggerEl, EVENTS.CLICK, this.toggle);
      on(this.triggerEl, EVENTS.KEY_DOWN, this.onKeyPress);
    }
    on(this.$refs.dropdown, EVENTS.KEY_DOWN, this.onKeyPress);
    on(window, EVENTS.CLICK, this.windowClicked);
    on(window, EVENTS.TOUCH_END, this.windowClicked);
    if (this.value) {
      this.toggle(true);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.removeDropdownFromBody();
    if (this.triggerEl) {
      off(this.triggerEl, EVENTS.CLICK, this.toggle);
      off(this.triggerEl, EVENTS.KEY_DOWN, this.onKeyPress);
    }
    off(this.$refs.dropdown, EVENTS.KEY_DOWN, this.onKeyPress);
    off(window, EVENTS.CLICK, this.windowClicked);
    off(window, EVENTS.TOUCH_END, this.windowClicked);
  },

  methods: {
    onKeyPress: function onKeyPress(event) {
      if (this.show) {
        var dropdownEl = this.$refs.dropdown;
        var keyCode = event.keyCode || event.which;
        if (keyCode === 27) {
          this.toggle(false);
          this.triggerEl && this.triggerEl.focus();
        } else if (keyCode === 13) {
          var currentFocus = dropdownEl.querySelector('li > a:focus');
          currentFocus && currentFocus.click();
        } else if (keyCode === 38 || keyCode === 40) {
          event.preventDefault();
          event.stopPropagation();
          var _currentFocus = dropdownEl.querySelector('li > a:focus');
          var items = dropdownEl.querySelectorAll('li:not(.disabled) > a');
          if (!_currentFocus) {
            focus(items[0]);
          } else {
            for (var i = 0; i < items.length; i++) {
              if (_currentFocus === items[i]) {
                if (keyCode === 38 && i < items.length > 0) {
                  focus(items[i - 1]);
                } else if (keyCode === 40 && i < items.length - 1) {
                  focus(items[i + 1]);
                }
                break;
              }
            }
          }
        }
      }
    },
    initTrigger: function initTrigger() {
      var trigger = this.$el.querySelector('[data-role="trigger"]') || this.$el.querySelector('.dropdown-toggle') || this.$el.firstChild;
      this.triggerEl = trigger && trigger !== this.$refs.dropdown ? trigger : null;
    },
    toggle: function toggle(show) {
      if (this.disabled) {
        return;
      }
      if (isBoolean$1(show)) {
        this.show = show;
      } else {
        this.show = !this.show;
      }
      if (this.appendToBody) {
        this.show ? this.appendDropdownToBody() : this.removeDropdownFromBody();
      }
      this.$emit('input', this.show);
    },
    windowClicked: function windowClicked(event) {
      var target = event.target;
      if (this.show && target) {
        var targetInNotCloseElements = false;
        if (this.notCloseElements) {
          for (var i = 0, l = this.notCloseElements.length; i < l; i++) {
            var isTargetInElement = this.notCloseElements[i].contains(target);
            var shouldBreak = isTargetInElement;
            if (this.appendToBody) {
              var isTargetInDropdown = this.$refs.dropdown.contains(target);
              var isElInElements = this.notCloseElements.indexOf(this.$el) >= 0;
              shouldBreak = isTargetInElement || isTargetInDropdown && isElInElements;
            }
            if (shouldBreak) {
              targetInNotCloseElements = true;
              break;
            }
          }
        }
        var targetInDropdownBody = this.$refs.dropdown.contains(target);
        var targetInTrigger = this.$el.contains(target) && !targetInDropdownBody;
        // normally, a dropdown select event is handled by @click that trigger after @touchend
        // then @touchend event have to be ignore in this case
        var targetInDropdownAndIsTouchEvent = targetInDropdownBody && event.type === 'touchend';
        if (!targetInTrigger && !targetInNotCloseElements && !targetInDropdownAndIsTouchEvent) {
          this.toggle(false);
        }
      }
    },
    appendDropdownToBody: function appendDropdownToBody() {
      try {
        var el = this.$refs.dropdown;
        el.style.display = 'block';
        document.body.appendChild(el);
        var positionElement = this.positionElement || this.$el;
        setDropdownPosition(el, positionElement, this);
      } catch (e) {
        // Silent
      }
    },
    removeDropdownFromBody: function removeDropdownFromBody() {
      try {
        var el = this.$refs.dropdown;
        el.removeAttribute('style');
        this.$el.appendChild(el);
      } catch (e) {
        // Silent
      }
    }
  }
};

var defaultLang = {
  uiv: {
    datePicker: {
      clear: 'Clear',
      today: 'Today',
      month: 'Month',
      month1: 'January',
      month2: 'February',
      month3: 'March',
      month4: 'April',
      month5: 'May',
      month6: 'June',
      month7: 'July',
      month8: 'August',
      month9: 'September',
      month10: 'October',
      month11: 'November',
      month12: 'December',
      year: 'Year',
      week1: 'Mon',
      week2: 'Tue',
      week3: 'Wed',
      week4: 'Thu',
      week5: 'Fri',
      week6: 'Sat',
      week7: 'Sun'
    },
    timePicker: {
      am: 'AM',
      pm: 'PM'
    },
    modal: {
      cancel: 'Cancel',
      ok: 'OK'
    },
    multiSelect: {
      placeholder: 'Select...',
      filterPlaceholder: 'Search...'
    }
  }
};

// https://github.com/ElemeFE/element/blob/dev/src/locale/index.js
var lang = defaultLang;

var i18nHandler = function i18nHandler() {
  var vuei18n = Object.getPrototypeOf(this).$t;
  if (isFunction(vuei18n)) {
    try {
      return vuei18n.apply(this, arguments);
    } catch (err) {
      //  vuei18n.apply doesn't work with 7.3.3 of vue-i18n
      return this.$t.apply(this, arguments);
    }
  }
};

var t$1 = function t(path, options) {
  options = options || {};

  var value = i18nHandler.apply(this, arguments);
  if (isExist(value) && !options.$$locale) {
    return value;
  }
  var array = path.split('.');
  var current = options.$$locale || lang;

  for (var i = 0, j = array.length; i < j; i++) {
    var property = array[i];
    value = current[property];
    if (i === j - 1) return value;
    if (!value) return '';
    current = value;
  }
  return '';
};

var defineProperty$3 = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var Local = {
  methods: {
    t: function t$$1() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      args[1] = _extends({ $$locale: this.locale }, args[1]);
      return t$1.apply(this, args);
    }
  },
  props: {
    locale: Object
  }
};

function mergeData$1() {
  for (var e, a, s = {}, t = arguments.length; t--;) {
    for (var r = 0, c = Object.keys(arguments[t]); r < c.length; r++) {
      switch (e = c[r]) {case "class":case "style":case "directives":
          Array.isArray(s[e]) || (s[e] = []), s[e] = s[e].concat(arguments[t][e]);break;case "staticClass":
          if (!arguments[t][e]) break;void 0 === s[e] && (s[e] = ""), s[e] && (s[e] += " "), s[e] += arguments[t][e].trim();break;case "on":case "nativeOn":
          s[e] || (s[e] = {});for (var o = 0, n = Object.keys(arguments[t][e]); o < n.length; o++) {
            a = n[o], s[e][a] ? s[e][a] = [].concat(s[e][a], arguments[t][e][a]) : s[e][a] = arguments[t][e][a];
          }break;case "attrs":case "props":case "domProps":case "scopedSlots":case "staticStyle":case "hook":case "transition":
          s[e] || (s[e] = {}), s[e] = __assign({}, arguments[t][e], s[e]);break;case "slot":case "key":case "ref":case "tag":case "show":case "keepAlive":default:
          s[e] || (s[e] = arguments[t][e]);}
    }
  }return s;
}var __assign = Object.assign || function (e) {
  for (var a, s = 1, t = arguments.length; s < t; s++) {
    a = arguments[s];for (var r in a) {
      Object.prototype.hasOwnProperty.call(a, r) && (e[r] = a[r]);
    }
  }return e;
};

var linkMixin = {
  props: {
    // <a> props
    href: String,
    target: String,
    // <router-link> props
    to: null,
    replace: {
      type: Boolean,
      default: false
    },
    append: {
      type: Boolean,
      default: false
    },
    exact: {
      type: Boolean,
      default: false
    }
  }
};

var BtnGroup = {
  functional: true,
  render: function render(h, _ref) {
    var props = _ref.props,
        children = _ref.children,
        data = _ref.data;

    return h('div', mergeData$1(data, {
      class: defineProperty$3({
        'btn-group': !props.vertical,
        'btn-group-vertical': props.vertical,
        'btn-group-justified': props.justified
      }, 'btn-group-' + props.size, props.size),
      attrs: {
        role: 'group',
        'data-toggle': 'buttons'
      }
    }), children);
  },

  props: {
    size: String,
    vertical: {
      type: Boolean,
      default: false
    },
    justified: {
      type: Boolean,
      default: false
    }
  }
};

var INPUT_TYPE_CHECKBOX = 'checkbox';
var INPUT_TYPE_RADIO = 'radio';

var Btn = {
  functional: true,
  mixins: [linkMixin],
  render: function render(h, _ref) {
    var _classes;

    var children = _ref.children,
        props = _ref.props,
        data = _ref.data;

    // event listeners
    var listeners = data.on || {};
    // checkbox: model contain inputValue
    // radio: model === inputValue
    var isInputActive = props.inputType === INPUT_TYPE_CHECKBOX ? props.value.indexOf(props.inputValue) >= 0 : props.value === props.inputValue;
    // button class
    var classes = (_classes = {
      btn: true,
      active: props.inputType ? isInputActive : props.active,
      disabled: props.disabled,
      'btn-block': props.block
    }, defineProperty$3(_classes, 'btn-' + props.type, Boolean(props.type)), defineProperty$3(_classes, 'btn-' + props.size, Boolean(props.size)), _classes);
    // prevent event for disabled links
    var on = {
      click: function click(e) {
        if (props.disabled && e instanceof Event) {
          e.preventDefault();
          e.stopPropagation();
        }
      }
    };
    // render params
    var tag = void 0,
        options = void 0,
        slot = void 0;

    if (props.href) {
      // is native link
      tag = 'a';
      slot = children;
      options = mergeData$1(data, {
        on: on,
        class: classes,
        attrs: {
          role: 'button',
          href: props.href,
          target: props.target
        }
      });
    } else if (props.to) {
      // is vue router link
      tag = 'router-link';
      slot = children;
      options = mergeData$1(data, {
        nativeOn: on,
        class: classes,
        props: {
          event: props.disabled ? '' : 'click', // prevent nav while disabled
          to: props.to,
          replace: props.replace,
          append: props.append,
          exact: props.exact
        },
        attrs: {
          role: 'button'
        }
      });
    } else if (props.inputType) {
      // is input checkbox or radio
      tag = 'label';
      options = mergeData$1(data, {
        on: on,
        class: classes
      });
      slot = [h('input', {
        attrs: {
          autocomplete: 'off',
          type: props.inputType,
          checked: isInputActive ? 'checked' : null,
          disabled: props.disabled
        },
        domProps: {
          checked: isInputActive // required
        },
        on: {
          input: function input(evt) {
            evt.stopPropagation();
          },
          change: function change() {
            if (props.inputType === INPUT_TYPE_CHECKBOX) {
              var valueCopied = props.value.slice();
              if (isInputActive) {
                valueCopied.splice(valueCopied.indexOf(props.inputValue), 1);
              } else {
                valueCopied.push(props.inputValue);
              }
              listeners['input'](valueCopied);
            } else {
              listeners['input'](props.inputValue);
            }
          }
        }
      }), children];
    } else if (props.justified) {
      // is in justified btn-group
      tag = BtnGroup;
      options = {};
      slot = [h('button', mergeData$1(data, {
        on: on,
        class: classes,
        attrs: {
          type: props.nativeType,
          disabled: props.disabled
        }
      }), children)];
    } else {
      // is button
      tag = 'button';
      slot = children;
      options = mergeData$1(data, {
        on: on,
        class: classes,
        attrs: {
          type: props.nativeType,
          disabled: props.disabled
        }
      });
    }

    return h(tag, options, slot);
  },

  props: {
    justified: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'default'
    },
    nativeType: {
      type: String,
      default: 'button'
    },
    size: String,
    block: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    // <input> props
    value: null,
    inputValue: null,
    inputType: {
      type: String,
      validator: function validator(value) {
        return value === INPUT_TYPE_CHECKBOX || value === INPUT_TYPE_RADIO;
      }
    }
  }
};

var MODAL_BACKDROP = 'modal-backdrop';
var IN$1 = 'in';
var getOpenModals = function getOpenModals() {
  return document.querySelectorAll('.' + MODAL_BACKDROP);
};
var getOpenModalNum = function getOpenModalNum() {
  return getOpenModals().length;
};

var Modal = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "modal", class: { fade: _vm.transitionDuration > 0 }, attrs: { "tabindex": "-1", "role": "dialog" }, on: { "mousedown": function mousedown($event) {
          if ($event.target !== $event.currentTarget) {
            return null;
          }return _vm.backdropClicked($event);
        } } }, [_c('div', { ref: "dialog", staticClass: "modal-dialog", class: _vm.modalSizeClass, attrs: { "role": "document" } }, [_c('div', { staticClass: "modal-content" }, [_vm.header ? _c('div', { staticClass: "modal-header" }, [_vm._t("header", [_vm.dismissBtn ? _c('button', { staticClass: "close", staticStyle: { "position": "relative", "z-index": "1060" }, attrs: { "type": "button", "aria-label": "Close" }, on: { "click": function click($event) {
          return _vm.toggle(false);
        } } }, [_c('span', { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]) : _vm._e(), _vm._v(" "), _c('h4', { staticClass: "modal-title" }, [_vm._t("title", [_vm._v(_vm._s(_vm.title))])], 2)])], 2) : _vm._e(), _vm._v(" "), _c('div', { staticClass: "modal-body" }, [_vm._t("default")], 2), _vm._v(" "), _vm.footer ? _c('div', { staticClass: "modal-footer" }, [_vm._t("footer", [_c('btn', { attrs: { "type": _vm.cancelType }, on: { "click": function click($event) {
          return _vm.toggle(false, 'cancel');
        } } }, [_c('span', [_vm._v(_vm._s(_vm.cancelText || _vm.t('uiv.modal.cancel')))])]), _vm._v(" "), _c('btn', { attrs: { "type": _vm.okType, "data-action": "auto-focus" }, on: { "click": function click($event) {
          return _vm.toggle(false, 'ok');
        } } }, [_c('span', [_vm._v(_vm._s(_vm.okText || _vm.t('uiv.modal.ok')))])])])], 2) : _vm._e()])]), _vm._v(" "), _c('div', { ref: "backdrop", staticClass: "modal-backdrop", class: { fade: _vm.transitionDuration > 0 } })]);
  }, staticRenderFns: [],
  mixins: [Local],
  components: { Btn: Btn },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: String,
    size: String,
    backdrop: {
      type: Boolean,
      default: true
    },
    footer: {
      type: Boolean,
      default: true
    },
    header: {
      type: Boolean,
      default: true
    },
    cancelText: String,
    cancelType: {
      type: String,
      default: 'default'
    },
    okText: String,
    okType: {
      type: String,
      default: 'primary'
    },
    dismissBtn: {
      type: Boolean,
      default: true
    },
    transitionDuration: {
      type: Number,
      default: 150
    },
    autoFocus: {
      type: Boolean,
      default: false
    },
    keyboard: {
      type: Boolean,
      default: true
    },
    beforeClose: Function,
    zOffset: {
      type: Number,
      default: 20
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    displayStyle: {
      type: String,
      default: 'block'
    }
  },
  data: function data() {
    return {
      msg: '',
      timeoutId: 0
    };
  },

  computed: {
    modalSizeClass: function modalSizeClass() {
      return defineProperty$3({}, 'modal-' + this.size, Boolean(this.size));
    }
  },
  watch: {
    value: function value(v) {
      this.$toggle(v);
    }
  },
  mounted: function mounted() {
    removeFromDom(this.$refs.backdrop);
    on(window, EVENTS.KEY_UP, this.onKeyPress);
    if (this.value) {
      this.$toggle(true);
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearTimeout(this.timeoutId);
    removeFromDom(this.$refs.backdrop);
    removeFromDom(this.$el);
    if (getOpenModalNum() === 0) {
      toggleBodyOverflow(true);
    }
    off(window, EVENTS.KEY_UP, this.onKeyPress);
  },

  methods: {
    onKeyPress: function onKeyPress(event) {
      if (this.keyboard && this.value && event.keyCode === 27) {
        var thisModal = this.$refs.backdrop;
        var thisZIndex = thisModal.style.zIndex;
        thisZIndex = thisZIndex && thisZIndex !== 'auto' ? parseInt(thisZIndex) : 0;
        // Find out if this modal is the top most one.
        var modals = getOpenModals();
        var modalsLength = modals.length;
        for (var i = 0; i < modalsLength; i++) {
          if (modals[i] !== thisModal) {
            var zIndex = modals[i].style.zIndex;
            zIndex = zIndex && zIndex !== 'auto' ? parseInt(zIndex) : 0;
            // if any existing modal has higher zIndex, ignore
            if (zIndex > thisZIndex) {
              return;
            }
          }
        }
        this.toggle(false);
      }
    },
    toggle: function toggle(show, msg) {
      var _this = this;

      var shouldClose = true;
      if (isFunction(this.beforeClose)) {
        shouldClose = this.beforeClose(msg);
      }

      if (isPromiseSupported()) {
        // Skip the hiding when beforeClose returning falsely value or returned Promise resolves to falsely value
        // Use Promise.resolve to accept both Boolean values and Promises
        Promise.resolve(shouldClose).then(function (shouldClose) {
          // Skip the hiding while show===false
          if (!show && shouldClose) {
            _this.msg = msg;
            _this.$emit('input', show);
          }
        });
      } else {
        // Fallback to old version if promise is not supported
        // skip the hiding while show===false & beforeClose returning falsely value
        if (!show && !shouldClose) {
          return;
        }

        this.msg = msg;
        this.$emit('input', show);
      }
    },
    $toggle: function $toggle(show) {
      var _this2 = this;

      var modal = this.$el;
      var backdrop = this.$refs.backdrop;
      clearTimeout(this.timeoutId);
      if (show) {
        var alreadyOpenModalNum = getOpenModalNum();
        document.body.appendChild(backdrop);
        if (this.appendToBody) {
          document.body.appendChild(modal);
        }
        modal.style.display = this.displayStyle;
        modal.scrollTop = 0;
        backdrop.offsetHeight; // force repaint
        toggleBodyOverflow(false);
        addClass$1(backdrop, IN$1);
        addClass$1(modal, IN$1);
        // fix z-index for nested modals
        // no need to calculate if no modal is already open
        if (alreadyOpenModalNum > 0) {
          var modalBaseZ = parseInt(getComputedStyle(modal).zIndex) || 1050; // 1050 is default modal z-Index
          var backdropBaseZ = parseInt(getComputedStyle(backdrop).zIndex) || 1040; // 1040 is default backdrop z-Index
          var offset = alreadyOpenModalNum * this.zOffset;
          modal.style.zIndex = '' + (modalBaseZ + offset);
          backdrop.style.zIndex = '' + (backdropBaseZ + offset);
        }
        // z-index fix end
        this.timeoutId = setTimeout(function () {
          if (_this2.autoFocus) {
            var btn = _this2.$el.querySelector('[data-action="auto-focus"]');
            if (btn) {
              btn.focus();
            }
          }
          _this2.$emit('show');
          _this2.timeoutId = 0;
        }, this.transitionDuration);
      } else {
        removeClass$1(backdrop, IN$1);
        removeClass$1(modal, IN$1);
        this.timeoutId = setTimeout(function () {
          modal.style.display = 'none';
          removeFromDom(backdrop);
          if (_this2.appendToBody) {
            removeFromDom(modal);
          }
          if (getOpenModalNum() === 0) {
            toggleBodyOverflow(true);
          }
          _this2.$emit('hide', _this2.msg || 'dismiss');
          _this2.msg = '';
          _this2.timeoutId = 0;
          // restore z-index for nested modals
          modal.style.zIndex = '';
          backdrop.style.zIndex = '';
          // z-index fix end
        }, this.transitionDuration);
      }
    },
    backdropClicked: function backdropClicked(event) {
      if (this.backdrop) {
        this.toggle(false);
      }
    }
  }
};

var ACTIVE_CLASS = 'active';
var IN_CLASS = 'in';

var Tab = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "tab-pane", class: { fade: _vm.transition > 0 }, attrs: { "role": "tabpanel" } }, [_vm._t("default")], 2);
  }, staticRenderFns: [],
  props: {
    title: {
      type: String,
      default: 'Tab Title'
    },
    htmlTitle: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    'tab-classes': {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    group: String,
    pullRight: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      active: true,
      transition: 150
    };
  },

  watch: {
    active: function active(_active) {
      var _this = this;

      if (_active) {
        setTimeout(function () {
          addClass$1(_this.$el, ACTIVE_CLASS);
          _this.$el.offsetHeight;
          addClass$1(_this.$el, IN_CLASS);
          try {
            _this.$parent.$emit('after-change', _this.$parent.activeIndex);
          } catch (e) {
            throw new Error('<tab> parent must be <tabs>.');
          }
        }, this.transition);
      } else {
        removeClass$1(this.$el, IN_CLASS);
        setTimeout(function () {
          removeClass$1(_this.$el, ACTIVE_CLASS);
        }, this.transition);
      }
    }
  },
  created: function created() {
    try {
      this.$parent.tabs.push(this);
    } catch (e) {
      throw new Error('<tab> parent must be <tabs>.');
    }
  },
  beforeDestroy: function beforeDestroy() {
    var tabs = this.$parent && this.$parent.tabs;
    spliceIfExist(tabs, this);
  },

  methods: {
    show: function show() {
      var _this2 = this;

      this.$nextTick(function () {
        addClass$1(_this2.$el, ACTIVE_CLASS);
        addClass$1(_this2.$el, IN_CLASS);
      });
    }
  }
};

var BEFORE_CHANGE_EVENT = 'before-change';

var Tabs = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('section', [_c('ul', { class: _vm.navClasses, attrs: { "role": "tablist" } }, [_vm._l(_vm.groupedTabs, function (tab, index) {
      return [tab.tabs ? _c('dropdown', { class: _vm.getTabClasses(tab), attrs: { "role": "presentation", "tag": "li" } }, [_c('a', { staticClass: "dropdown-toggle", attrs: { "role": "tab", "href": "#" }, on: { "click": function click($event) {
            $event.preventDefault();
          } } }, [_vm._v(_vm._s(tab.group) + " "), _c('span', { staticClass: "caret" })]), _vm._v(" "), _c('template', { slot: "dropdown" }, _vm._l(tab.tabs, function (subTab) {
        return _c('li', { class: _vm.getTabClasses(subTab, true) }, [_c('a', { attrs: { "href": "#" }, on: { "click": function click($event) {
              $event.preventDefault();_vm.select(_vm.tabs.indexOf(subTab));
            } } }, [_vm._v(_vm._s(subTab.title))])]);
      }), 0)], 2) : _c('li', { class: _vm.getTabClasses(tab), attrs: { "role": "presentation" } }, [tab.htmlTitle ? _c('a', { attrs: { "role": "tab", "href": "#" }, domProps: { "innerHTML": _vm._s(tab.title) }, on: { "click": function click($event) {
            $event.preventDefault();_vm.select(_vm.tabs.indexOf(tab));
          } } }) : _c('a', { attrs: { "role": "tab", "href": "#" }, domProps: { "textContent": _vm._s(tab.title) }, on: { "click": function click($event) {
            $event.preventDefault();_vm.select(_vm.tabs.indexOf(tab));
          } } })])];
    }), _vm._v(" "), !_vm.justified && _vm.$slots['nav-right'] ? _c('li', { staticClass: "pull-right" }, [_vm._t("nav-right")], 2) : _vm._e()], 2), _vm._v(" "), _c('div', { class: _vm.contentClasses }, [_vm._t("default")], 2)]);
  }, staticRenderFns: [],
  components: { Dropdown: Dropdown },
  props: {
    value: {
      type: Number,
      validator: function validator(v) {
        return v >= 0;
      }
    },
    transitionDuration: {
      type: Number,
      default: 150
    },
    justified: Boolean,
    pills: Boolean,
    stacked: Boolean,
    customNavClass: null,
    customContentClass: null
  },
  data: function data() {
    return {
      tabs: [],
      activeIndex: 0 // Make v-model not required
    };
  },

  watch: {
    value: {
      immediate: true,
      handler: function handler(value) {
        if (isNumber(value)) {
          this.activeIndex = value;
          this.selectCurrent();
        }
      }
    },
    tabs: function tabs(_tabs) {
      var _this = this;

      _tabs.forEach(function (tab, index) {
        tab.transition = _this.transitionDuration;
        if (index === _this.activeIndex) {
          tab.show();
        }
      });
      this.selectCurrent();
    }
  },
  computed: {
    navClasses: function navClasses() {
      var tabClasses = {
        'nav': true,
        'nav-justified': this.justified,
        'nav-tabs': !this.pills,
        'nav-pills': this.pills,
        'nav-stacked': this.stacked && this.pills
      };
      var customNavClass = this.customNavClass;
      if (isExist(customNavClass)) {
        if (isString$1(customNavClass)) {
          return _extends({}, tabClasses, defineProperty$3({}, customNavClass, true));
        } else {
          return _extends({}, tabClasses, customNavClass);
        }
      } else {
        return tabClasses;
      }
    },
    contentClasses: function contentClasses() {
      var contentClasses = {
        'tab-content': true
      };
      var customContentClass = this.customContentClass;
      if (isExist(customContentClass)) {
        if (isString$1(customContentClass)) {
          return _extends({}, contentClasses, defineProperty$3({}, customContentClass, true));
        } else {
          return _extends({}, contentClasses, customContentClass);
        }
      } else {
        return contentClasses;
      }
    },
    groupedTabs: function groupedTabs() {
      var tabs = [];
      var hash = {};
      this.tabs.forEach(function (tab) {
        if (tab.group) {
          if (hash.hasOwnProperty(tab.group)) {
            tabs[hash[tab.group]].tabs.push(tab);
          } else {
            tabs.push({
              tabs: [tab],
              group: tab.group
            });
            hash[tab.group] = tabs.length - 1;
          }
          if (tab.active) {
            tabs[hash[tab.group]].active = true;
          }
          if (tab.pullRight) {
            tabs[hash[tab.group]].pullRight = true;
          }
        } else {
          tabs.push(tab);
        }
      });
      return tabs;
    }
  },
  methods: {
    getTabClasses: function getTabClasses(tab) {
      var isSubTab = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var defaultClasses = {
        active: tab.active,
        disabled: tab.disabled,
        'pull-right': tab.pullRight && !isSubTab

        // return with new classes added to tab
      };return _extends(defaultClasses, tab['tabClasses']);
    },
    selectCurrent: function selectCurrent() {
      var _this2 = this;

      var found = false;
      this.tabs.forEach(function (tab, index) {
        if (index === _this2.activeIndex) {
          found = !tab.active;
          tab.active = true;
        } else {
          tab.active = false;
        }
      });
      if (found) {
        this.$emit('change', this.activeIndex);
      }
    },
    selectValidate: function selectValidate(index) {
      var _this3 = this;

      if (isFunction(this.$listeners[BEFORE_CHANGE_EVENT])) {
        this.$emit(BEFORE_CHANGE_EVENT, this.activeIndex, index, function (result) {
          if (!isExist(result)) {
            _this3.$select(index);
          }
        });
      } else {
        this.$select(index);
      }
    },
    select: function select(index) {
      if (!this.tabs[index].disabled && index !== this.activeIndex) {
        this.selectValidate(index);
      }
    },
    $select: function $select(index) {
      if (isNumber(this.value)) {
        this.$emit('input', index);
      } else {
        this.activeIndex = index;
        this.selectCurrent();
      }
    }
  }
};

function pad$1(value, num) {
  value = value + '';
  for (var i = num - value.length; i > 0; i--) {
    value = '0' + value;
  }
  return value;
}

var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

function daysInMonth(month, year) {
  return new Date(year, month + 1, 0).getDate();
}

function stringify(date, format) {
  try {
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDate();
    var monthName = monthNames[month - 1];
    return format.replace(/yyyy/g, year).replace(/MMMM/g, monthName).replace(/MMM/g, monthName.substring(0, 3)).replace(/MM/g, pad$1(month, 2)).replace(/dd/g, pad$1(day, 2)).replace(/yy/g, year).replace(/M(?!a)/g, month).replace(/d/g, day);
  } catch (e) {
    return '';
  }
}

function convertDateToUTC(date) {
  return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
}

/* https://stackoverflow.com/questions/6117814/get-week-of-year-in-javascript-like-in-php
 *
 * For a given date, get the ISO week number
 *
 * Based on information at:
 *
 *    http://www.merlyn.demon.co.uk/weekcalc.htm#WNR
 *
 * Algorithm is to find nearest thursday, it's year
 * is the year of the week number. Then get weeks
 * between that date and the first day of that year.
 *
 * Note that dates in one year can be weeks of previous
 * or next year, overlap is up to 3 days.
 *
 * e.g. 2014/12/29 is Monday in week  1 of 2015
 *      2012/1/1   is Sunday in week 52 of 2011
 */
function getWeekNumber(d) {
  // Copy date so don't modify original
  d = new Date(Date.UTC(d.year, d.month, d.date));
  // Set to nearest Thursday: current date + 4 - current day number
  // Make Sunday's day number 7
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
  // Get first day of year
  var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  // Calculate full weeks to nearest Thursday
  return Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
}

var DateView = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('table', { staticStyle: { "width": "100%" }, attrs: { "role": "grid" } }, [_c('thead', [_c('tr', [_c('td', [_c('btn', { staticClass: "uiv-datepicker-pager-prev", staticStyle: { "border": "none" }, attrs: { "block": "", "size": "sm" }, on: { "click": _vm.goPrevMonth } }, [_c('i', { class: _vm.iconControlLeft })])], 1), _vm._v(" "), _c('td', { attrs: { "colspan": _vm.weekNumbers ? 6 : 5 } }, [_c('btn', { staticClass: "uiv-datepicker-title", staticStyle: { "border": "none" }, attrs: { "block": "", "size": "sm" }, on: { "click": _vm.changeView } }, [_c('b', [_vm._v(_vm._s(_vm.yearMonthStr))])])], 1), _vm._v(" "), _c('td', [_c('btn', { staticClass: "uiv-datepicker-pager-next", staticStyle: { "border": "none" }, attrs: { "block": "", "size": "sm" }, on: { "click": _vm.goNextMonth } }, [_c('i', { class: _vm.iconControlRight })])], 1)]), _vm._v(" "), _c('tr', { attrs: { "align": "center" } }, [_vm.weekNumbers ? _c('td') : _vm._e(), _vm._v(" "), _vm._l(_vm.weekDays, function (day) {
      return _c('td', { attrs: { "width": "14.2857142857%" } }, [_c('small', { staticClass: "uiv-datepicker-week" }, [_vm._v(_vm._s(_vm.tWeekName(day === 0 ? 7 : day)))])]);
    })], 2)]), _vm._v(" "), _c('tbody', _vm._l(_vm.monthDayRows, function (row) {
      return _c('tr', [_vm.weekNumbers ? _c('td', { staticClass: "text-center", staticStyle: { "border-right": "1px solid #eee" } }, [_c('small', { staticClass: "text-muted" }, [_vm._v(_vm._s(_vm.getWeekNumber(row[_vm.weekStartsWith])))])]) : _vm._e(), _vm._v(" "), _vm._l(row, function (date) {
        return _c('td', [_c('btn', { class: date.classes, staticStyle: { "border": "none" }, attrs: { "block": "", "size": "sm", "data-action": "select", "type": _vm.getBtnType(date), "disabled": date.disabled }, on: { "click": function click($event) {
              return _vm.select(date);
            } } }, [_c('span', { class: { 'text-muted': _vm.month !== date.month }, attrs: { "data-action": "select" } }, [_vm._v(_vm._s(date.date))])])], 1);
      })], 2);
    }), 0)]);
  }, staticRenderFns: [],
  mixins: [Local],
  props: {
    month: Number,
    year: Number,
    date: Date,
    today: Date,
    limit: Object,
    weekStartsWith: Number,
    iconControlLeft: String,
    iconControlRight: String,
    dateClass: Function,
    yearMonthFormatter: Function,
    weekNumbers: Boolean
  },
  components: { Btn: Btn },
  computed: {
    weekDays: function weekDays() {
      var days = [];
      var firstDay = this.weekStartsWith;
      while (days.length < 7) {
        days.push(firstDay++);
        if (firstDay > 6) {
          firstDay = 0;
        }
      }
      return days;
    },
    yearMonthStr: function yearMonthStr() {
      if (this.yearMonthFormatter) {
        return this.yearMonthFormatter(this.year, this.month);
      } else {
        return isExist(this.month) ? this.year + ' ' + this.t('uiv.datePicker.month' + (this.month + 1)) : this.year;
      }
    },
    monthDayRows: function monthDayRows() {
      var rows = [];
      var firstDay = new Date(this.year, this.month, 1);
      var prevMonthLastDate = new Date(this.year, this.month, 0).getDate();
      var startIndex = firstDay.getDay();
      // console.log(startIndex)
      var daysNum = daysInMonth(this.month, this.year);
      var weekOffset = 0;
      if (this.weekStartsWith > startIndex) {
        weekOffset = 7 - this.weekStartsWith;
      } else {
        weekOffset = 0 - this.weekStartsWith;
      }
      // console.log(prevMonthLastDate, startIndex, daysNum)
      for (var i = 0; i < 6; i++) {
        rows.push([]);
        for (var j = 0 - weekOffset; j < 7 - weekOffset; j++) {
          var currentIndex = i * 7 + j;
          var date = { year: this.year, disabled: false
            // date in and not in current month
          };if (currentIndex < startIndex) {
            date.date = prevMonthLastDate - startIndex + currentIndex + 1;
            if (this.month > 0) {
              date.month = this.month - 1;
            } else {
              date.month = 11;
              date.year--;
            }
          } else if (currentIndex < startIndex + daysNum) {
            date.date = currentIndex - startIndex + 1;
            date.month = this.month;
          } else {
            date.date = currentIndex - startIndex - daysNum + 1;
            if (this.month < 11) {
              date.month = this.month + 1;
            } else {
              date.month = 0;
              date.year++;
            }
          }
          // process limit dates
          var dateObj = new Date(date.year, date.month, date.date);
          var afterFrom = true;
          var beforeTo = true;
          if (this.limit && this.limit.from) {
            afterFrom = dateObj >= this.limit.from;
          }
          if (this.limit && this.limit.to) {
            beforeTo = dateObj < this.limit.to;
          }
          date.disabled = !afterFrom || !beforeTo;
          date.classes = isFunction(this.dateClass) ? this.dateClass(dateObj, {
            currentMonth: this.month,
            currentYear: this.year
          }) : '';
          rows[i].push(date);
        }
      }
      return rows;
    }
  },
  methods: {
    getWeekNumber: getWeekNumber,
    tWeekName: function tWeekName(index) {
      return this.t('uiv.datePicker.week' + index);
    },
    getBtnType: function getBtnType(date) {
      if (this.date && date.date === this.date.getDate() && date.month === this.date.getMonth() && date.year === this.date.getFullYear()) {
        return 'primary';
      } else if (date.date === this.today.getDate() && date.month === this.today.getMonth() && date.year === this.today.getFullYear()) {
        return 'info';
      } else {
        return 'default';
      }
    },
    select: function select(date) {
      this.$emit('date-change', date);
    },
    goPrevMonth: function goPrevMonth() {
      var month = this.month;
      var year = this.year;
      if (this.month > 0) {
        month--;
      } else {
        month = 11;
        year--;
        this.$emit('year-change', year);
      }
      this.$emit('month-change', month);
    },
    goNextMonth: function goNextMonth() {
      var month = this.month;
      var year = this.year;
      if (this.month < 11) {
        month++;
      } else {
        month = 0;
        year++;
        this.$emit('year-change', year);
      }
      this.$emit('month-change', month);
    },
    changeView: function changeView() {
      this.$emit('view-change', 'm');
    }
  }
};

var MonthView = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('table', { staticStyle: { "width": "100%" }, attrs: { "role": "grid" } }, [_c('thead', [_c('tr', [_c('td', [_c('btn', { staticClass: "uiv-datepicker-pager-prev", staticStyle: { "border": "none" }, attrs: { "block": "", "size": "sm" }, on: { "click": _vm.goPrevYear } }, [_c('i', { class: _vm.iconControlLeft })])], 1), _vm._v(" "), _c('td', { attrs: { "colspan": "4" } }, [_c('btn', { staticClass: "uiv-datepicker-title", staticStyle: { "border": "none" }, attrs: { "block": "", "size": "sm" }, on: { "click": function click($event) {
          return _vm.changeView();
        } } }, [_c('b', [_vm._v(_vm._s(_vm.year))])])], 1), _vm._v(" "), _c('td', [_c('btn', { staticClass: "uiv-datepicker-pager-next", staticStyle: { "border": "none" }, attrs: { "block": "", "size": "sm" }, on: { "click": _vm.goNextYear } }, [_c('i', { class: _vm.iconControlRight })])], 1)])]), _vm._v(" "), _c('tbody', _vm._l(_vm.rows, function (row, i) {
      return _c('tr', _vm._l(row, function (month, j) {
        return _c('td', { attrs: { "colspan": "2", "width": "33.333333%" } }, [_c('btn', { staticStyle: { "border": "none" }, attrs: { "block": "", "size": "sm", "type": _vm.getBtnClass(i * 3 + j) }, on: { "click": function click($event) {
              return _vm.changeView(i * 3 + j);
            } } }, [_c('span', [_vm._v(_vm._s(_vm.tCell(month)))])])], 1);
      }), 0);
    }), 0)]);
  }, staticRenderFns: [],
  components: { Btn: Btn },
  mixins: [Local],
  props: {
    month: Number,
    year: Number,
    iconControlLeft: String,
    iconControlRight: String
  },
  data: function data() {
    return {
      rows: []
    };
  },
  mounted: function mounted() {
    for (var i = 0; i < 4; i++) {
      this.rows.push([]);
      for (var j = 0; j < 3; j++) {
        this.rows[i].push(i * 3 + j + 1);
      }
    }
  },

  methods: {
    tCell: function tCell(cell) {
      return this.t('uiv.datePicker.month' + cell);
    },
    getBtnClass: function getBtnClass(month) {
      if (month === this.month) {
        return 'primary';
      } else {
        return 'default';
      }
    },
    goPrevYear: function goPrevYear() {
      this.$emit('year-change', this.year - 1);
    },
    goNextYear: function goNextYear() {
      this.$emit('year-change', this.year + 1);
    },
    changeView: function changeView(monthIndex) {
      if (isExist(monthIndex)) {
        this.$emit('month-change', monthIndex);
        this.$emit('view-change', 'd');
      } else {
        this.$emit('view-change', 'y');
      }
    }
  }
};

var YearView = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('table', { staticStyle: { "width": "100%" }, attrs: { "role": "grid" } }, [_c('thead', [_c('tr', [_c('td', [_c('btn', { staticClass: "uiv-datepicker-pager-prev", staticStyle: { "border": "none" }, attrs: { "block": "", "size": "sm" }, on: { "click": _vm.goPrevYear } }, [_c('i', { class: _vm.iconControlLeft })])], 1), _vm._v(" "), _c('td', { attrs: { "colspan": "3" } }, [_c('btn', { staticClass: "uiv-datepicker-title", staticStyle: { "border": "none" }, attrs: { "block": "", "size": "sm" } }, [_c('b', [_vm._v(_vm._s(_vm.yearStr))])])], 1), _vm._v(" "), _c('td', [_c('btn', { staticClass: "uiv-datepicker-pager-next", staticStyle: { "border": "none" }, attrs: { "block": "", "size": "sm" }, on: { "click": _vm.goNextYear } }, [_c('i', { class: _vm.iconControlRight })])], 1)])]), _vm._v(" "), _c('tbody', _vm._l(_vm.rows, function (row) {
      return _c('tr', _vm._l(row, function (year) {
        return _c('td', { attrs: { "width": "20%" } }, [_c('btn', { staticStyle: { "border": "none" }, attrs: { "block": "", "size": "sm", "type": _vm.getBtnClass(year) }, on: { "click": function click($event) {
              return _vm.changeView(year);
            } } }, [_c('span', [_vm._v(_vm._s(year))])])], 1);
      }), 0);
    }), 0)]);
  }, staticRenderFns: [],
  components: { Btn: Btn },
  props: {
    year: Number,
    iconControlLeft: String,
    iconControlRight: String
  },
  computed: {
    rows: function rows() {
      var rows = [];
      var yearGroupStart = this.year - this.year % 20;
      for (var i = 0; i < 4; i++) {
        rows.push([]);
        for (var j = 0; j < 5; j++) {
          rows[i].push(yearGroupStart + i * 5 + j);
        }
      }
      return rows;
    },
    yearStr: function yearStr() {
      var start = this.year - this.year % 20;
      return start + ' ~ ' + (start + 19);
    }
  },
  methods: {
    getBtnClass: function getBtnClass(year) {
      if (year === this.year) {
        return 'primary';
      } else {
        return 'default';
      }
    },
    goPrevYear: function goPrevYear() {
      this.$emit('year-change', this.year - 20);
    },
    goNextYear: function goNextYear() {
      this.$emit('year-change', this.year + 20);
    },
    changeView: function changeView(year) {
      this.$emit('year-change', year);
      this.$emit('view-change', 'm');
    }
  }
};

var DatePicker = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { class: _vm.pickerClass, style: _vm.pickerStyle, attrs: { "data-role": "date-picker" }, on: { "click": _vm.onPickerClick } }, [_c('date-view', { directives: [{ name: "show", rawName: "v-show", value: _vm.view === 'd', expression: "view==='d'" }], attrs: { "month": _vm.currentMonth, "year": _vm.currentYear, "date": _vm.valueDateObj, "today": _vm.now, "limit": _vm.limit, "week-starts-with": _vm.weekStartsWith, "icon-control-left": _vm.iconControlLeft, "icon-control-right": _vm.iconControlRight, "date-class": _vm.dateClass, "year-month-formatter": _vm.yearMonthFormatter, "week-numbers": _vm.weekNumbers, "locale": _vm.locale }, on: { "month-change": _vm.onMonthChange, "year-change": _vm.onYearChange, "date-change": _vm.onDateChange, "view-change": _vm.onViewChange } }), _vm._v(" "), _c('month-view', { directives: [{ name: "show", rawName: "v-show", value: _vm.view === 'm', expression: "view==='m'" }], attrs: { "month": _vm.currentMonth, "year": _vm.currentYear, "icon-control-left": _vm.iconControlLeft, "icon-control-right": _vm.iconControlRight, "locale": _vm.locale }, on: { "month-change": _vm.onMonthChange, "year-change": _vm.onYearChange, "view-change": _vm.onViewChange } }), _vm._v(" "), _c('year-view', { directives: [{ name: "show", rawName: "v-show", value: _vm.view === 'y', expression: "view==='y'" }], attrs: { "year": _vm.currentYear, "icon-control-left": _vm.iconControlLeft, "icon-control-right": _vm.iconControlRight }, on: { "year-change": _vm.onYearChange, "view-change": _vm.onViewChange } }), _vm._v(" "), _vm.todayBtn || _vm.clearBtn ? _c('div', [_c('br'), _vm._v(" "), _c('div', { staticClass: "text-center" }, [_vm.todayBtn ? _c('btn', { attrs: { "data-action": "select", "type": "info", "size": "sm" }, domProps: { "textContent": _vm._s(_vm.t('uiv.datePicker.today')) }, on: { "click": _vm.selectToday } }) : _vm._e(), _vm._v(" "), _vm.clearBtn ? _c('btn', { attrs: { "data-action": "select", "size": "sm" }, domProps: { "textContent": _vm._s(_vm.t('uiv.datePicker.clear')) }, on: { "click": _vm.clearSelect } }) : _vm._e()], 1)]) : _vm._e()], 1);
  }, staticRenderFns: [],
  mixins: [Local],
  components: { DateView: DateView, MonthView: MonthView, YearView: YearView, Btn: Btn },
  props: {
    value: null,
    width: {
      type: Number,
      default: 270
    },
    todayBtn: {
      type: Boolean,
      default: true
    },
    clearBtn: {
      type: Boolean,
      default: true
    },
    closeOnSelected: {
      type: Boolean,
      default: true
    },
    limitFrom: null,
    limitTo: null,
    format: {
      type: String,
      default: 'yyyy-MM-dd'
    },
    initialView: {
      type: String,
      default: 'd'
    },
    dateParser: {
      type: Function,
      default: Date.parse
    },
    dateClass: Function,
    yearMonthFormatter: Function,
    weekStartsWith: {
      type: Number,
      default: 0,
      validator: function validator(value) {
        return value >= 0 && value <= 6;
      }
    },
    weekNumbers: Boolean,
    iconControlLeft: {
      type: String,
      default: 'glyphicon glyphicon-chevron-left'
    },
    iconControlRight: {
      type: String,
      default: 'glyphicon glyphicon-chevron-right'
    }
  },
  data: function data() {
    return {
      show: false,
      now: new Date(),
      currentMonth: 0,
      currentYear: 0,
      view: 'd'
    };
  },

  computed: {
    valueDateObj: function valueDateObj() {
      var ts = this.dateParser(this.value);
      if (isNaN(ts)) {
        return null;
      } else {
        var date = new Date(ts);
        if (date.getHours() !== 0) {
          date = new Date(ts + date.getTimezoneOffset() * 60 * 1000);
        }
        return date;
      }
    },
    pickerStyle: function pickerStyle() {
      return {
        width: this.width + 'px'
      };
    },
    pickerClass: function pickerClass() {
      return {
        'uiv-datepicker': true,
        'uiv-datepicker-date': this.view === 'd',
        'uiv-datepicker-month': this.view === 'm',
        'uiv-datepicker-year': this.view === 'y'
      };
    },
    limit: function limit() {
      var limit = {};
      if (this.limitFrom) {
        var limitFrom = this.dateParser(this.limitFrom);
        if (!isNaN(limitFrom)) {
          limitFrom = convertDateToUTC(new Date(limitFrom));
          limitFrom.setHours(0, 0, 0, 0);
          limit.from = limitFrom;
        }
      }
      if (this.limitTo) {
        var limitTo = this.dateParser(this.limitTo);
        if (!isNaN(limitTo)) {
          limitTo = convertDateToUTC(new Date(limitTo));
          limitTo.setHours(0, 0, 0, 0);
          limit.to = limitTo;
        }
      }
      return limit;
    }
  },
  mounted: function mounted() {
    if (this.value) {
      this.setMonthAndYearByValue(this.value);
    } else {
      this.currentMonth = this.now.getMonth();
      this.currentYear = this.now.getFullYear();
      this.view = this.initialView;
    }
  },

  watch: {
    value: function value(val, oldVal) {
      this.setMonthAndYearByValue(val, oldVal);
    }
  },
  methods: {
    setMonthAndYearByValue: function setMonthAndYearByValue(val, oldVal) {
      var ts = this.dateParser(val);
      if (!isNaN(ts)) {
        var date = new Date(ts);
        if (date.getHours() !== 0) {
          date = new Date(ts + date.getTimezoneOffset() * 60 * 1000);
        }
        if (this.limit && (this.limit.from && date < this.limit.from || this.limit.to && date >= this.limit.to)) {
          this.$emit('input', oldVal || '');
        } else {
          this.currentMonth = date.getMonth();
          this.currentYear = date.getFullYear();
        }
      }
    },
    onMonthChange: function onMonthChange(month) {
      this.currentMonth = month;
    },
    onYearChange: function onYearChange(year) {
      this.currentYear = year;
      this.currentMonth = undefined;
    },
    onDateChange: function onDateChange(date) {
      if (date && isNumber(date.date) && isNumber(date.month) && isNumber(date.year)) {
        var _date = new Date(date.year, date.month, date.date);
        this.$emit('input', this.format ? stringify(_date, this.format) : _date);
        // if the input event trigger nothing (same value)
        // manually correct
        this.currentMonth = date.month;
        this.currentYear = date.year;
      } else {
        this.$emit('input', '');
      }
    },
    onViewChange: function onViewChange(view) {
      this.view = view;
    },
    selectToday: function selectToday() {
      this.view = 'd';
      this.onDateChange({
        date: this.now.getDate(),
        month: this.now.getMonth(),
        year: this.now.getFullYear()
      });
    },
    clearSelect: function clearSelect() {
      this.currentMonth = this.now.getMonth();
      this.currentYear = this.now.getFullYear();
      this.view = this.initialView;
      this.onDateChange();
    },
    onPickerClick: function onPickerClick(event) {
      if (event.target.getAttribute('data-action') !== 'select' || !this.closeOnSelected) {
        event.stopPropagation();
      }
    }
  }
};

var HANDLER = '_uiv_scroll_handler';
var events$1 = [EVENTS.RESIZE, EVENTS.SCROLL];

var bind$2 = function bind(el, binding) {
  var callback = binding.value;
  if (!isFunction(callback)) {
    return;
  }
  unbind$1(el);
  el[HANDLER] = callback;
  events$1.forEach(function (event) {
    on(window, event, el[HANDLER]);
  });
};

var unbind$1 = function unbind(el) {
  events$1.forEach(function (event) {
    off(window, event, el[HANDLER]);
  });
  delete el[HANDLER];
};

var update$2 = function update(el, binding) {
  if (binding.value !== binding.oldValue) {
    bind$2(el, binding);
  }
};

var scroll = { bind: bind$2, unbind: unbind$1, update: update$2 };

var Affix = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "hidden-print" }, [_c('div', { directives: [{ name: "scroll", rawName: "v-scroll", value: _vm.onScroll, expression: "onScroll" }], class: _vm.classes, style: _vm.styles }, [_vm._t("default")], 2)]);
  }, staticRenderFns: [],
  directives: {
    scroll: scroll
  },
  props: {
    offset: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      affixed: false
    };
  },

  computed: {
    classes: function classes() {
      return {
        affix: this.affixed
      };
    },
    styles: function styles() {
      return {
        top: this.affixed ? this.offset + 'px' : null
      };
    }
  },
  methods: {
    // from https://github.com/ant-design/ant-design/blob/master/components/affix/index.jsx#L20
    onScroll: function onScroll() {
      var _this = this;

      // if is hidden don't calculate anything
      if (!(this.$el.offsetWidth || this.$el.offsetHeight || this.$el.getClientRects().length)) {
        return;
      }
      // get window scroll and element position to detect if have to be normal or affixed
      var scroll$$1 = {};
      var element = {};
      var rect = this.$el.getBoundingClientRect();
      var body = document.body;
      var _arr = ['Top', 'Left'];
      for (var _i = 0; _i < _arr.length; _i++) {
        var type = _arr[_i];
        var t = type.toLowerCase();
        scroll$$1[t] = window['page' + (type === 'Top' ? 'Y' : 'X') + 'Offset'];
        element[t] = scroll$$1[t] + rect[t] - (this.$el['client' + type] || body['client' + type] || 0);
      }
      var fix = scroll$$1.top > element.top - this.offset;
      if (this.affixed !== fix) {
        this.affixed = fix;
        if (this.affixed) {
          this.$emit('affix');
          this.$nextTick(function () {
            _this.$emit('affixed');
          });
        }
      }
    }
  }
};

var Alert = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { class: _vm.alertClass, attrs: { "role": "alert" } }, [_vm.dismissible ? _c('button', { staticClass: "close", attrs: { "type": "button", "aria-label": "Close" }, on: { "click": _vm.closeAlert } }, [_c('span', { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2);
  }, staticRenderFns: [],
  props: {
    dismissible: {
      type: Boolean,
      default: false
    },
    duration: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      default: 'info'
    }
  },
  data: function data() {
    return {
      timeout: 0
    };
  },

  computed: {
    alertClass: function alertClass() {
      var _ref;

      return _ref = {
        'alert': true
      }, defineProperty$3(_ref, "alert-" + this.type, Boolean(this.type)), defineProperty$3(_ref, 'alert-dismissible', this.dismissible), _ref;
    }
  },
  methods: {
    closeAlert: function closeAlert() {
      clearTimeout(this.timeout);
      this.$emit('dismissed');
    }
  },
  mounted: function mounted() {
    if (this.duration > 0) {
      this.timeout = setTimeout(this.closeAlert, this.duration);
    }
  },
  destroyed: function destroyed() {
    clearTimeout(this.timeout);
  }
};

var Pagination = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('nav', { class: _vm.navClasses, attrs: { "aria-label": "Page navigation" } }, [_c('ul', { staticClass: "pagination", class: _vm.classes }, [_vm.boundaryLinks ? _c('li', { class: { disabled: _vm.value <= 1 || _vm.disabled } }, [_c('a', { attrs: { "href": "#", "role": "button", "aria-label": "First" }, on: { "click": function click($event) {
          $event.preventDefault();return _vm.onPageChange(1);
        } } }, [_c('span', { attrs: { "aria-hidden": "true" } }, [_vm._v("«")])])]) : _vm._e(), _vm._v(" "), _vm.directionLinks ? _c('li', { class: { disabled: _vm.value <= 1 || _vm.disabled } }, [_c('a', { attrs: { "href": "#", "role": "button", "aria-label": "Previous" }, on: { "click": function click($event) {
          $event.preventDefault();return _vm.onPageChange(_vm.value - 1);
        } } }, [_c('span', { attrs: { "aria-hidden": "true" } }, [_vm._v("‹")])])]) : _vm._e(), _vm._v(" "), _vm.sliceStart > 0 ? _c('li', { class: { disabled: _vm.disabled } }, [_c('a', { attrs: { "href": "#", "role": "button", "aria-label": "Previous group" }, on: { "click": function click($event) {
          $event.preventDefault();return _vm.toPage(1);
        } } }, [_c('span', { attrs: { "aria-hidden": "true" } }, [_vm._v("…")])])]) : _vm._e(), _vm._v(" "), _vm._l(_vm.sliceArray, function (item) {
      return _c('li', { key: item, class: { active: _vm.value === item + 1, disabled: _vm.disabled } }, [_c('a', { attrs: { "href": "#", "role": "button" }, on: { "click": function click($event) {
            $event.preventDefault();return _vm.onPageChange(item + 1);
          } } }, [_vm._v(_vm._s(item + 1))])]);
    }), _vm._v(" "), _vm.sliceStart < _vm.totalPage - _vm.maxSize ? _c('li', { class: { disabled: _vm.disabled } }, [_c('a', { attrs: { "href": "#", "role": "button", "aria-label": "Next group" }, on: { "click": function click($event) {
          $event.preventDefault();return _vm.toPage(0);
        } } }, [_c('span', { attrs: { "aria-hidden": "true" } }, [_vm._v("…")])])]) : _vm._e(), _vm._v(" "), _vm.directionLinks ? _c('li', { class: { disabled: _vm.value >= _vm.totalPage || _vm.disabled } }, [_c('a', { attrs: { "href": "#", "role": "button", "aria-label": "Next" }, on: { "click": function click($event) {
          $event.preventDefault();return _vm.onPageChange(_vm.value + 1);
        } } }, [_c('span', { attrs: { "aria-hidden": "true" } }, [_vm._v("›")])])]) : _vm._e(), _vm._v(" "), _vm.boundaryLinks ? _c('li', { class: { disabled: _vm.value >= _vm.totalPage || _vm.disabled } }, [_c('a', { attrs: { "href": "#", "role": "button", "aria-label": "Last" }, on: { "click": function click($event) {
          $event.preventDefault();return _vm.onPageChange(_vm.totalPage);
        } } }, [_c('span', { attrs: { "aria-hidden": "true" } }, [_vm._v("»")])])]) : _vm._e()], 2)]);
  }, staticRenderFns: [],
  props: {
    value: {
      type: Number,
      required: true,
      validator: function validator(v) {
        return v >= 1;
      }
    },
    boundaryLinks: {
      type: Boolean,
      default: false
    },
    directionLinks: {
      type: Boolean,
      default: true
    },
    size: String,
    align: String,
    totalPage: {
      type: Number,
      required: true,
      validator: function validator(v) {
        return v >= 0;
      }
    },
    maxSize: {
      type: Number,
      default: 5,
      validator: function validator(v) {
        return v >= 0;
      }
    },
    disabled: Boolean
  },
  data: function data() {
    return {
      sliceStart: 0
    };
  },

  computed: {
    navClasses: function navClasses() {
      return defineProperty$3({}, 'text-' + this.align, Boolean(this.align));
    },
    classes: function classes() {
      return defineProperty$3({}, 'pagination-' + this.size, Boolean(this.size));
    },
    sliceArray: function sliceArray() {
      return range(this.totalPage).slice(this.sliceStart, this.sliceStart + this.maxSize);
    }
  },
  methods: {
    calculateSliceStart: function calculateSliceStart() {
      var currentPage = this.value;
      var chunkSize = this.maxSize;
      var currentChunkStart = this.sliceStart;
      var currentChunkEnd = currentChunkStart + chunkSize;
      if (currentPage > currentChunkEnd) {
        var lastChunkStart = this.totalPage - chunkSize;
        if (currentPage > lastChunkStart) {
          this.sliceStart = lastChunkStart;
        } else {
          this.sliceStart = currentPage - 1;
        }
      } else if (currentPage < currentChunkStart + 1) {
        if (currentPage > chunkSize) {
          this.sliceStart = currentPage - chunkSize;
        } else {
          this.sliceStart = 0;
        }
      }
    },
    onPageChange: function onPageChange(page) {
      if (!this.disabled && page > 0 && page <= this.totalPage && page !== this.value) {
        this.$emit('input', page);
        this.$emit('change', page);
      }
    },
    toPage: function toPage(pre) {
      if (this.disabled) {
        return;
      }
      var chunkSize = this.maxSize;
      var currentChunkStart = this.sliceStart;
      var lastChunkStart = this.totalPage - chunkSize;
      var start = pre ? currentChunkStart - chunkSize : currentChunkStart + chunkSize;
      if (start < 0) {
        this.sliceStart = 0;
      } else if (start > lastChunkStart) {
        this.sliceStart = lastChunkStart;
      } else {
        this.sliceStart = start;
      }
    }
  },
  created: function created() {
    this.$watch(function (vm) {
      return [vm.value, vm.maxSize, vm.totalPage].join();
    }, this.calculateSliceStart, {
      immediate: true
    });
  }
};

var SHOW_CLASS = 'in';

var popupMixin = {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    tag: {
      type: String,
      default: 'span'
    },
    placement: {
      type: String,
      default: PLACEMENTS.TOP
    },
    autoPlacement: {
      type: Boolean,
      default: true
    },
    appendTo: {
      type: String,
      default: 'body'
    },
    transitionDuration: {
      type: Number,
      default: 150
    },
    hideDelay: {
      type: Number,
      default: 0
    },
    showDelay: {
      type: Number,
      default: 0
    },
    enable: {
      type: Boolean,
      default: true
    },
    enterable: {
      type: Boolean,
      default: true
    },
    target: null,
    viewport: null,
    customClass: String
  },
  data: function data() {
    return {
      triggerEl: null,
      hideTimeoutId: 0,
      showTimeoutId: 0,
      transitionTimeoutId: 0,
      autoTimeoutId: 0
    };
  },

  watch: {
    value: function value(v) {
      v ? this.show() : this.hide();
    },
    trigger: function trigger() {
      this.clearListeners();
      this.initListeners();
    },
    target: function target(value) {
      this.clearListeners();
      this.initTriggerElByTarget(value);
      this.initListeners();
    },
    allContent: function allContent(value) {
      var _this = this;

      // can not use value because it can not detect slot changes
      if (this.isNotEmpty()) {
        // reset position while content changed & is shown
        // nextTick is required
        this.$nextTick(function () {
          if (_this.isShown()) {
            _this.resetPosition();
          }
        });
      } else {
        this.hide();
      }
    },
    enable: function enable(value) {
      // hide if enable changed to false
      if (!value) {
        this.hide();
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    ensureElementMatchesFunction();
    removeFromDom(this.$refs.popup);
    this.$nextTick(function () {
      _this2.initTriggerElByTarget(_this2.target);
      _this2.initListeners();
      if (_this2.value) {
        _this2.show();
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.clearListeners();
    removeFromDom(this.$refs.popup);
  },

  methods: {
    initTriggerElByTarget: function initTriggerElByTarget(target) {
      if (target) {
        // target exist
        if (isString$1(target)) {
          // is selector
          this.triggerEl = document.querySelector(target);
        } else if (isElement(target)) {
          // is element
          this.triggerEl = target;
        } else if (isElement(target.$el)) {
          // is component
          this.triggerEl = target.$el;
        }
      } else {
        // find special element
        var trigger = this.$el.querySelector('[data-role="trigger"]');
        if (trigger) {
          this.triggerEl = trigger;
        } else {
          // use the first child
          var firstChild = this.$el.firstChild;
          this.triggerEl = firstChild === this.$refs.popup ? null : firstChild;
        }
      }
    },
    initListeners: function initListeners() {
      if (this.triggerEl) {
        if (this.trigger === TRIGGERS.HOVER) {
          on(this.triggerEl, EVENTS.MOUSE_ENTER, this.show);
          on(this.triggerEl, EVENTS.MOUSE_LEAVE, this.hide);
        } else if (this.trigger === TRIGGERS.FOCUS) {
          on(this.triggerEl, EVENTS.FOCUS, this.show);
          on(this.triggerEl, EVENTS.BLUR, this.hide);
        } else if (this.trigger === TRIGGERS.HOVER_FOCUS) {
          on(this.triggerEl, EVENTS.MOUSE_ENTER, this.handleAuto);
          on(this.triggerEl, EVENTS.MOUSE_LEAVE, this.handleAuto);
          on(this.triggerEl, EVENTS.FOCUS, this.handleAuto);
          on(this.triggerEl, EVENTS.BLUR, this.handleAuto);
        } else if (this.trigger === TRIGGERS.CLICK || this.trigger === TRIGGERS.OUTSIDE_CLICK) {
          on(this.triggerEl, EVENTS.CLICK, this.toggle);
        }
      }
      on(window, EVENTS.CLICK, this.windowClicked);
    },
    clearListeners: function clearListeners() {
      if (this.triggerEl) {
        off(this.triggerEl, EVENTS.FOCUS, this.show);
        off(this.triggerEl, EVENTS.BLUR, this.hide);
        off(this.triggerEl, EVENTS.MOUSE_ENTER, this.show);
        off(this.triggerEl, EVENTS.MOUSE_LEAVE, this.hide);
        off(this.triggerEl, EVENTS.CLICK, this.toggle);
        off(this.triggerEl, EVENTS.MOUSE_ENTER, this.handleAuto);
        off(this.triggerEl, EVENTS.MOUSE_LEAVE, this.handleAuto);
        off(this.triggerEl, EVENTS.FOCUS, this.handleAuto);
        off(this.triggerEl, EVENTS.BLUR, this.handleAuto);
      }
      off(window, EVENTS.CLICK, this.windowClicked);
      this.clearTimeouts();
    },
    clearTimeouts: function clearTimeouts() {
      if (this.hideTimeoutId) {
        clearTimeout(this.hideTimeoutId);
        this.hideTimeoutId = 0;
      }
      if (this.showTimeoutId) {
        clearTimeout(this.showTimeoutId);
        this.showTimeoutId = 0;
      }
      if (this.transitionTimeoutId) {
        clearTimeout(this.transitionTimeoutId);
        this.transitionTimeoutId = 0;
      }
      if (this.autoTimeoutId) {
        clearTimeout(this.autoTimeoutId);
        this.autoTimeoutId = 0;
      }
    },
    resetPosition: function resetPosition() {
      var popup = this.$refs.popup;
      if (popup) {
        setTooltipPosition(popup, this.triggerEl, this.placement, this.autoPlacement, this.appendTo, this.viewport);
        popup.offsetHeight;
      }
    },
    hideOnLeave: function hideOnLeave() {
      if (this.trigger === TRIGGERS.HOVER || this.trigger === TRIGGERS.HOVER_FOCUS && !this.triggerEl.matches(':focus')) {
        this.$hide();
      }
    },
    toggle: function toggle() {
      if (this.isShown()) {
        this.hide();
      } else {
        this.show();
      }
    },
    show: function show() {
      var _this3 = this;

      if (this.enable && this.triggerEl && this.isNotEmpty() && !this.isShown()) {
        var popUpAppendedContainer = this.hideTimeoutId > 0; // weird condition
        if (popUpAppendedContainer) {
          clearTimeout(this.hideTimeoutId);
          this.hideTimeoutId = 0;
        }
        if (this.transitionTimeoutId > 0) {
          clearTimeout(this.transitionTimeoutId);
          this.transitionTimeoutId = 0;
        }
        clearTimeout(this.showTimeoutId);
        this.showTimeoutId = setTimeout(function () {
          _this3.showTimeoutId = 0;
          var popup = _this3.$refs.popup;
          if (popup) {
            // add to dom
            if (!popUpAppendedContainer) {
              popup.className = _this3.name + ' ' + _this3.placement + ' ' + (_this3.customClass ? _this3.customClass : '') + ' fade';
              var container = document.querySelector(_this3.appendTo);
              container.appendChild(popup);
              _this3.resetPosition();
            }
            addClass$1(popup, SHOW_CLASS);
            _this3.$emit('input', true);
            _this3.$emit('show');
          }
        }, this.showDelay);
      }
    },
    hide: function hide() {
      var _this4 = this;

      if (this.showTimeoutId > 0) {
        clearTimeout(this.showTimeoutId);
        this.showTimeoutId = 0;
      }

      if (!this.isShown()) {
        return;
      }
      if (this.enterable && (this.trigger === TRIGGERS.HOVER || this.trigger === TRIGGERS.HOVER_FOCUS)) {
        clearTimeout(this.hideTimeoutId);
        this.hideTimeoutId = setTimeout(function () {
          _this4.hideTimeoutId = 0;
          var popup = _this4.$refs.popup;
          if (popup && !popup.matches(':hover')) {
            _this4.$hide();
          }
        }, 100);
      } else {
        this.$hide();
      }
    },
    $hide: function $hide() {
      var _this5 = this;

      if (this.isShown()) {
        clearTimeout(this.hideTimeoutId);
        this.hideTimeoutId = setTimeout(function () {
          _this5.hideTimeoutId = 0;
          removeClass$1(_this5.$refs.popup, SHOW_CLASS);
          // gives fade out time
          _this5.transitionTimeoutId = setTimeout(function () {
            _this5.transitionTimeoutId = 0;
            removeFromDom(_this5.$refs.popup);
            _this5.$emit('input', false);
            _this5.$emit('hide');
          }, _this5.transitionDuration);
        }, this.hideDelay);
      }
    },
    isShown: function isShown() {
      return hasClass(this.$refs.popup, SHOW_CLASS);
    },
    windowClicked: function windowClicked(event) {
      if (this.triggerEl && isFunction(this.triggerEl.contains) && !this.triggerEl.contains(event.target) && this.trigger === TRIGGERS.OUTSIDE_CLICK && !(this.$refs.popup && this.$refs.popup.contains(event.target)) && this.isShown()) {
        this.hide();
      }
    },
    handleAuto: function handleAuto() {
      var _this6 = this;

      clearTimeout(this.autoTimeoutId);
      this.autoTimeoutId = setTimeout(function () {
        _this6.autoTimeoutId = 0;
        if (_this6.triggerEl.matches(':hover, :focus')) {
          _this6.show();
        } else {
          _this6.hide();
        }
      }, 20); // 20ms make firefox happy
    }
  }
};

var Tooltip = {
  mixins: [popupMixin],
  data: function data() {
    return {
      name: 'tooltip'
    };
  },
  render: function render(h) {
    return h(this.tag, [this.$slots.default, h('div', {
      ref: 'popup',
      attrs: {
        role: 'tooltip'
      },
      on: {
        mouseleave: this.hideOnLeave
      }
    }, [h('div', { 'class': 'tooltip-arrow' }), h('div', {
      'class': 'tooltip-inner',
      domProps: { innerHTML: this.text }
    })])]);
  },

  props: {
    text: {
      type: String,
      default: ''
    },
    trigger: {
      type: String,
      default: TRIGGERS.HOVER_FOCUS
    }
  },
  computed: {
    allContent: function allContent() {
      return this.text;
    }
  },
  methods: {
    isNotEmpty: function isNotEmpty() {
      return this.text;
    }
  }
};

var Popover = {
  mixins: [popupMixin],
  data: function data() {
    return {
      name: 'popover'
    };
  },
  render: function render(h) {
    return h(this.tag, [this.$slots.default, h('div', {
      style: {
        display: 'block'
      },
      ref: 'popup',
      on: {
        mouseleave: this.hideOnLeave
      }
    }, [h('div', { 'class': 'arrow' }), h('h3', {
      'class': 'popover-title',
      directives: [{ name: 'show', value: this.title }]
    }, this.title), h('div', { 'class': 'popover-content' }, [this.content || this.$slots.popover])])]);
  },

  props: {
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    trigger: {
      type: String,
      default: TRIGGERS.OUTSIDE_CLICK
    }
  },
  computed: {
    allContent: function allContent() {
      return this.title + this.content;
    }
  },
  methods: {
    isNotEmpty: function isNotEmpty() {
      return this.title || this.content || this.$slots.popover;
    }
  }
};

var maxHours = 23;
var zero = 0;
var maxMinutes = 59;
var cutUpAmAndPm = 12;

var TimePicker = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('section', { on: { "click": function click($event) {
          $event.stopPropagation();
        } } }, [_c('table', [_c('tbody', [_vm.controls ? _c('tr', { staticClass: "text-center" }, [_c('td', [_c('btn', { attrs: { "type": "link", "size": "sm", "disabled": _vm.readonly }, on: { "click": function click($event) {
          return _vm.changeTime(1, 1);
        } } }, [_c('i', { class: _vm.iconControlUp })])], 1), _vm._v(" "), _c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', [_c('btn', { attrs: { "type": "link", "size": "sm", "disabled": _vm.readonly }, on: { "click": function click($event) {
          return _vm.changeTime(0, 1);
        } } }, [_c('i', { class: _vm.iconControlUp })])], 1), _vm._v(" "), _vm.showMeridian ? _c('td') : _vm._e()]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', { staticClass: "form-group" }, [_c('input', { directives: [{ name: "model", rawName: "v-model.lazy", value: _vm.hoursText, expression: "hoursText", modifiers: { "lazy": true } }], ref: "hoursInput", staticClass: "form-control text-center", style: _vm.inputStyles, attrs: { "type": "tel", "pattern": "\\d*", "placeholder": "HH", "readonly": _vm.readonly, "maxlength": "2", "size": "2" }, domProps: { "value": _vm.hoursText }, on: { "mouseup": _vm.selectInputValue, "keydown": [function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) {
            return null;
          }$event.preventDefault();return _vm.changeTime(1, 1);
        }, function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) {
            return null;
          }$event.preventDefault();return _vm.changeTime(1, 0);
        }], "wheel": function wheel($event) {
          return _vm.onWheel($event, true);
        }, "change": function change($event) {
          _vm.hoursText = $event.target.value;
        } } })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('td', { staticClass: "form-group" }, [_c('input', { directives: [{ name: "model", rawName: "v-model.lazy", value: _vm.minutesText, expression: "minutesText", modifiers: { "lazy": true } }], ref: "minutesInput", staticClass: "form-control text-center", style: _vm.inputStyles, attrs: { "type": "tel", "pattern": "\\d*", "placeholder": "MM", "readonly": _vm.readonly, "maxlength": "2", "size": "2" }, domProps: { "value": _vm.minutesText }, on: { "mouseup": _vm.selectInputValue, "keydown": [function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) {
            return null;
          }$event.preventDefault();return _vm.changeTime(0, 1);
        }, function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) {
            return null;
          }$event.preventDefault();return _vm.changeTime(0, 0);
        }], "wheel": function wheel($event) {
          return _vm.onWheel($event, false);
        }, "change": function change($event) {
          _vm.minutesText = $event.target.value;
        } } })]), _vm._v(" "), _vm.showMeridian ? _c('td', [_vm._v("   "), _c('btn', { attrs: { "data-action": "toggleMeridian", "disabled": _vm.readonly }, domProps: { "textContent": _vm._s(_vm.meridian ? _vm.t('uiv.timePicker.am') : _vm.t('uiv.timePicker.pm')) }, on: { "click": _vm.toggleMeridian } })], 1) : _vm._e()]), _vm._v(" "), _vm.controls ? _c('tr', { staticClass: "text-center" }, [_c('td', [_c('btn', { attrs: { "type": "link", "size": "sm", "disabled": _vm.readonly }, on: { "click": function click($event) {
          return _vm.changeTime(1, 0);
        } } }, [_c('i', { class: _vm.iconControlDown })])], 1), _vm._v(" "), _c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', [_c('btn', { attrs: { "type": "link", "size": "sm", "disabled": _vm.readonly }, on: { "click": function click($event) {
          return _vm.changeTime(0, 0);
        } } }, [_c('i', { class: _vm.iconControlDown })])], 1), _vm._v(" "), _vm.showMeridian ? _c('td') : _vm._e()]) : _vm._e()])])]);
  }, staticRenderFns: [function () {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('td', [_vm._v(" "), _c('b', [_vm._v(":")]), _vm._v(" ")]);
  }],
  components: { Btn: Btn },
  mixins: [Local],
  props: {
    value: {
      type: Date,
      required: true
    },
    showMeridian: {
      type: Boolean,
      default: true
    },
    min: Date,
    max: Date,
    hourStep: {
      type: Number,
      default: 1
    },
    minStep: {
      type: Number,
      default: 1
    },
    readonly: {
      type: Boolean,
      default: false
    },
    controls: {
      type: Boolean,
      default: true
    },
    iconControlUp: {
      type: String,
      default: 'glyphicon glyphicon-chevron-up'
    },
    iconControlDown: {
      type: String,
      default: 'glyphicon glyphicon-chevron-down'
    },
    inputWidth: {
      type: Number,
      default: 50
    }
  },
  data: function data() {
    return {
      hours: 0,
      minutes: 0,
      meridian: true,
      hoursText: '',
      minutesText: ''
    };
  },
  mounted: function mounted() {
    this.updateByValue(this.value);
  },

  computed: {
    inputStyles: function inputStyles() {
      return {
        width: this.inputWidth + 'px'
      };
    }
  },
  watch: {
    value: function value(_value) {
      this.updateByValue(_value);
    },
    showMeridian: function showMeridian(value) {
      this.setTime();
    },
    hoursText: function hoursText(value) {
      if (this.hours === 0 && value === '') {
        // Prevent a runtime reset from being overwritten
        return;
      }
      var hour = parseInt(value);
      if (this.showMeridian) {
        if (hour >= 1 && hour <= cutUpAmAndPm) {
          if (this.meridian) {
            this.hours = hour === cutUpAmAndPm ? 0 : hour;
          } else {
            this.hours = hour === cutUpAmAndPm ? cutUpAmAndPm : hour + cutUpAmAndPm;
          }
        }
      } else if (hour >= zero && hour <= maxHours) {
        this.hours = hour;
      }
      this.setTime();
    },
    minutesText: function minutesText(value) {
      if (this.minutes === 0 && value === '') {
        // Prevent a runtime reset from being overwritten
        return;
      }
      var minutesStr = parseInt(value);
      if (minutesStr >= zero && minutesStr <= maxMinutes) {
        this.minutes = minutesStr;
      }
      this.setTime();
    }
  },
  methods: {
    updateByValue: function updateByValue(value) {
      if (isNaN(value.getTime())) {
        this.hours = 0;
        this.minutes = 0;
        this.hoursText = '';
        this.minutesText = '';
        this.meridian = true;
        return;
      }
      this.hours = value.getHours();
      this.minutes = value.getMinutes();
      if (!this.showMeridian) {
        this.hoursText = pad$1(this.hours, 2);
      } else {
        if (this.hours >= cutUpAmAndPm) {
          if (this.hours === cutUpAmAndPm) {
            this.hoursText = this.hours + '';
          } else {
            this.hoursText = pad$1(this.hours - cutUpAmAndPm, 2);
          }
          this.meridian = false;
        } else {
          if (this.hours === zero) {
            this.hoursText = cutUpAmAndPm.toString();
          } else {
            this.hoursText = pad$1(this.hours, 2);
          }
          this.meridian = true;
        }
      }
      this.minutesText = pad$1(this.minutes, 2);
      // lazy model won't update when using keyboard up/down
      this.$refs.hoursInput.value = this.hoursText;
      this.$refs.minutesInput.value = this.minutesText;
    },
    addHour: function addHour(step) {
      step = step || this.hourStep;
      this.hours = this.hours >= maxHours ? zero : this.hours + step;
    },
    reduceHour: function reduceHour(step) {
      step = step || this.hourStep;
      this.hours = this.hours <= zero ? maxHours : this.hours - step;
    },
    addMinute: function addMinute() {
      if (this.minutes >= maxMinutes) {
        this.minutes = zero;
        this.addHour(1);
      } else {
        this.minutes += this.minStep;
      }
    },
    reduceMinute: function reduceMinute() {
      if (this.minutes <= zero) {
        this.minutes = maxMinutes + 1 - this.minStep;
        this.reduceHour(1);
      } else {
        this.minutes -= this.minStep;
      }
    },
    changeTime: function changeTime(isHour, isPlus) {
      if (!this.readonly) {
        if (isHour && isPlus) {
          this.addHour();
        } else if (isHour && !isPlus) {
          this.reduceHour();
        } else if (!isHour && isPlus) {
          this.addMinute();
        } else {
          this.reduceMinute();
        }
        this.setTime();
      }
    },
    toggleMeridian: function toggleMeridian() {
      this.meridian = !this.meridian;
      if (this.meridian) {
        this.hours -= cutUpAmAndPm;
      } else {
        this.hours += cutUpAmAndPm;
      }
      this.setTime();
    },
    onWheel: function onWheel(e, isHour) {
      if (!this.readonly) {
        e.preventDefault();
        this.changeTime(isHour, e.deltaY < 0);
      }
    },
    setTime: function setTime() {
      var time = this.value;
      if (isNaN(time.getTime())) {
        time = new Date();
        time.setHours(0);
        time.setMinutes(0);
      }
      time.setHours(this.hours);
      time.setMinutes(this.minutes);
      if (this.max) {
        var max = new Date(time);
        max.setHours(this.max.getHours());
        max.setMinutes(this.max.getMinutes());
        time = time > max ? max : time;
      }
      if (this.min) {
        var min = new Date(time);
        min.setHours(this.min.getHours());
        min.setMinutes(this.min.getMinutes());
        time = time < min ? min : time;
      }
      this.$emit('input', new Date(time));
    },
    selectInputValue: function selectInputValue(e) {
      // mouseup should be prevented!
      // See various comments in https://stackoverflow.com/questions/3272089/programmatically-selecting-text-in-an-input-field-on-ios-devices-mobile-safari
      e.target.setSelectionRange(0, 2);
    }
  }
};

function getRequest(url) {
  var request = new window.XMLHttpRequest();
  var data = {};
  var p = {
    then: function then(fn1, fn2) {
      return p.done(fn1).fail(fn2);
    },
    catch: function _catch(fn) {
      return p.fail(fn);
    },
    always: function always(fn) {
      return p.done(fn).fail(fn);
    }
  };
  var statuses = ['done', 'fail'];
  statuses.forEach(function (name) {
    data[name] = [];
    p[name] = function (fn) {
      if (fn instanceof Function) data[name].push(fn);
      return p;
    };
  });
  p.done(JSON.parse);
  request.onreadystatechange = function () {
    if (request.readyState === 4) {
      var e = { status: request.status };
      if (request.status === 200) {
        var response = request.responseText;
        for (var i in data.done) {
          if (data.done.hasOwnProperty(i) && isFunction(data.done[i])) {
            var value = data.done[i](response);
            if (isExist(value)) {
              response = value;
            }
          }
        }
      } else {
        data.fail.forEach(function (fail) {
          return fail(e);
        });
      }
    }
  };
  request.open('GET', url);
  request.setRequestHeader('Accept', 'application/json');
  request.send();
  return p;
}

var Typeahead = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('dropdown', { ref: "dropdown", attrs: { "tag": "section", "append-to-body": _vm.appendToBody, "not-close-elements": _vm.elements, "position-element": _vm.inputEl }, model: { value: _vm.open, callback: function callback($$v) {
          _vm.open = $$v;
        }, expression: "open" } }, [_c('template', { slot: "dropdown" }, [_vm._t("item", _vm._l(_vm.items, function (item, index) {
      return _c('li', { class: { active: _vm.activeIndex === index } }, [_c('a', { attrs: { "href": "#" }, on: { "click": function click($event) {
            $event.preventDefault();return _vm.selectItem(item);
          } } }, [_c('span', { domProps: { "innerHTML": _vm._s(_vm.highlight(item)) } })])]);
    }), { "items": _vm.items, "activeIndex": _vm.activeIndex, "select": _vm.selectItem, "highlight": _vm.highlight }), _vm._v(" "), !_vm.items || _vm.items.length === 0 ? _vm._t("empty") : _vm._e()], 2)], 2);
  }, staticRenderFns: [],
  components: { Dropdown: Dropdown },
  props: {
    value: {
      required: true
    },
    data: Array,
    itemKey: String,
    appendToBody: {
      type: Boolean,
      default: false
    },
    ignoreCase: {
      type: Boolean,
      default: true
    },
    matchStart: {
      type: Boolean,
      default: false
    },
    forceSelect: {
      type: Boolean,
      default: false
    },
    forceClear: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: 10
    },
    asyncSrc: String,
    asyncKey: String,
    asyncFunction: Function,
    debounce: {
      type: Number,
      default: 200
    },
    openOnFocus: {
      type: Boolean,
      default: true
    },
    openOnEmpty: {
      type: Boolean,
      default: false
    },
    target: {
      required: true
    },
    preselect: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      inputEl: null,
      items: [],
      activeIndex: 0,
      timeoutID: 0,
      elements: [],
      open: false,
      dropdownMenuEl: null
    };
  },

  computed: {
    regexOptions: function regexOptions() {
      var options = '';
      if (this.ignoreCase) {
        options += 'i';
      }
      if (!this.matchStart) {
        options += 'g';
      }
      return options;
    }
  },
  mounted: function mounted() {
    var _this = this;

    ensureElementMatchesFunction();
    this.$nextTick(function () {
      _this.initInputElByTarget(_this.target);
      _this.initListeners();
      _this.dropdownMenuEl = _this.$refs.dropdown.$el.querySelector('.dropdown-menu');
      // set input text if v-model not empty
      if (_this.value) {
        _this.setInputTextByValue(_this.value);
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.removeListeners();
  },

  watch: {
    target: function target(el) {
      this.removeListeners();
      this.initInputElByTarget(el);
      this.initListeners();
    },
    value: function value(_value) {
      this.setInputTextByValue(_value);
    }
  },
  methods: {
    setInputTextByValue: function setInputTextByValue(value) {
      if (isString$1(value)) {
        // direct
        this.inputEl.value = value;
      } else if (value) {
        // is object
        this.inputEl.value = this.itemKey ? value[this.itemKey] : value;
      } else if (value === null) {
        // is null or undefined or something else not valid
        this.inputEl.value = '';
      }
    },
    hasEmptySlot: function hasEmptySlot() {
      return !!this.$slots['empty'] || !!this.$scopedSlots['empty'];
    },
    initInputElByTarget: function initInputElByTarget(target) {
      if (!target) {
        return;
      }
      if (isString$1(target)) {
        // is selector
        this.inputEl = document.querySelector(target);
      } else if (isElement(target)) {
        // is element
        this.inputEl = target;
      } else if (isElement(target.$el)) {
        // is component
        this.inputEl = target.$el;
      }
    },
    initListeners: function initListeners() {
      if (this.inputEl) {
        this.elements = [this.inputEl];
        on(this.inputEl, EVENTS.FOCUS, this.inputFocused);
        on(this.inputEl, EVENTS.BLUR, this.inputBlured);
        on(this.inputEl, EVENTS.INPUT, this.inputChanged);
        on(this.inputEl, EVENTS.KEY_DOWN, this.inputKeyPressed);
      }
    },
    removeListeners: function removeListeners() {
      this.elements = [];
      if (this.inputEl) {
        off(this.inputEl, EVENTS.FOCUS, this.inputFocused);
        off(this.inputEl, EVENTS.BLUR, this.inputBlured);
        off(this.inputEl, EVENTS.INPUT, this.inputChanged);
        off(this.inputEl, EVENTS.KEY_DOWN, this.inputKeyPressed);
      }
    },
    prepareItems: function prepareItems(data) {
      var disableFilters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (disableFilters) {
        this.items = data.slice(0, this.limit);
        return;
      }
      this.items = [];
      this.activeIndex = this.preselect ? 0 : -1;
      for (var i = 0, l = data.length; i < l; i++) {
        var item = data[i];
        var key = this.itemKey ? item[this.itemKey] : item;
        key = key.toString();
        var index = -1;
        if (this.ignoreCase) {
          index = key.toLowerCase().indexOf(this.inputEl.value.toLowerCase());
        } else {
          index = key.indexOf(this.inputEl.value);
        }
        if (this.matchStart ? index === 0 : index >= 0) {
          this.items.push(item);
        }
        if (this.items.length >= this.limit) {
          break;
        }
      }
    },
    fetchItems: function fetchItems(value, debounce) {
      var _this2 = this;

      clearTimeout(this.timeoutID);
      if (value === '' && !this.openOnEmpty) {
        this.open = false;
      } else if (this.data) {
        this.prepareItems(this.data);
        this.open = this.hasEmptySlot() || Boolean(this.items.length);
      } else if (this.asyncSrc) {
        this.timeoutID = setTimeout(function () {
          _this2.$emit('loading');
          getRequest(_this2.asyncSrc + encodeURIComponent(value)).then(function (data) {
            if (_this2.inputEl.matches(':focus')) {
              _this2.prepareItems(_this2.asyncKey ? data[_this2.asyncKey] : data, true);
              _this2.open = _this2.hasEmptySlot() || Boolean(_this2.items.length);
            }
            _this2.$emit('loaded');
          }).catch(function (err) {
            console.error(err);
            _this2.$emit('loaded-error');
          });
        }, debounce);
      } else if (this.asyncFunction) {
        var cb = function cb(data) {
          if (_this2.inputEl.matches(':focus')) {
            _this2.prepareItems(data, true);
            _this2.open = _this2.hasEmptySlot() || Boolean(_this2.items.length);
          }
          _this2.$emit('loaded');
        };
        this.timeoutID = setTimeout(function () {
          _this2.$emit('loading');
          _this2.asyncFunction(value, cb);
        }, debounce);
      }
    },
    inputChanged: function inputChanged() {
      var value = this.inputEl.value;
      this.fetchItems(value, this.debounce);
      this.$emit('input', this.forceSelect ? undefined : value);
    },
    inputFocused: function inputFocused() {
      if (this.openOnFocus) {
        var value = this.inputEl.value;
        this.fetchItems(value, 0);
      }
    },
    inputBlured: function inputBlured() {
      var _this3 = this;

      if (!this.dropdownMenuEl.matches(':hover')) {
        this.open = false;
      }
      if (this.inputEl && this.forceClear) {
        this.$nextTick(function () {
          if (typeof _this3.value === 'undefined') {
            _this3.inputEl.value = '';
          }
        });
      }
    },
    inputKeyPressed: function inputKeyPressed(event) {
      event.stopPropagation();
      if (this.open) {
        switch (event.keyCode) {
          case 13:
            if (this.activeIndex >= 0) {
              this.selectItem(this.items[this.activeIndex]);
            } else {
              this.open = false;
            }
            event.preventDefault();
            break;
          case 27:
            this.open = false;
            break;
          case 38:
            this.activeIndex = this.activeIndex > 0 ? this.activeIndex - 1 : 0;
            break;
          case 40:
            var maxIndex = this.items.length - 1;
            this.activeIndex = this.activeIndex < maxIndex ? this.activeIndex + 1 : maxIndex;
            break;
        }
      }
    },
    selectItem: function selectItem(item) {
      this.$emit('input', item);
      this.open = false;
    },
    highlight: function highlight(item) {
      var value = this.itemKey ? item[this.itemKey] : item;
      var inputValue = this.inputEl.value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
      return value.replace(new RegExp('' + inputValue, this.regexOptions), '<b>$&</b>');
    }
  }
};

var ProgressBarStack = {
  functional: true,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data;

    return h('div', mergeData$1(data, {
      class: defineProperty$3({
        'progress-bar': true,
        'progress-bar-striped': props.striped,
        'active': props.striped && props.active
      }, 'progress-bar-' + props.type, Boolean(props.type)),
      style: {
        minWidth: props.minWidth ? '2em' : null,
        width: props.value + '%'
      },
      attrs: {
        role: 'progressbar',
        'aria-valuemin': 0,
        'aria-valuenow': props.value,
        'aria-valuemax': 100
      }
    }), props.label ? props.labelText ? props.labelText : props.value + '%' : null);
  },

  props: {
    value: {
      type: Number,
      required: true,
      validator: function validator(value) {
        return value >= 0 && value <= 100;
      }
    },
    labelText: String,
    type: String,
    label: {
      type: Boolean,
      default: false
    },
    minWidth: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    }
  }
};

var ProgressBar = {
  functional: true,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    return h('div', mergeData$1(data, { class: 'progress' }), children && children.length ? children : [h(ProgressBarStack, { props: props })]);
  }
};

var BreadcrumbItem = {
  functional: true,
  mixins: [linkMixin],
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    var slot = void 0;
    if (props.active) {
      slot = children;
    } else if (props.to) {
      slot = [h('router-link', {
        props: {
          to: props.to,
          replace: props.replace,
          append: props.append,
          exact: props.exact
        }
      }, children)];
    } else {
      slot = [h('a', {
        attrs: {
          href: props.href,
          target: props.target
        }
      }, children)];
    }
    return h('li', mergeData$1(data, { class: { active: props.active } }), slot);
  },

  props: {
    active: {
      type: Boolean,
      default: false
    }
  }
};

var Breadcrumbs = {
  functional: true,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    var slot = [];
    if (children && children.length) {
      slot = children;
    } else if (props.items) {
      slot = props.items.map(function (item, index) {
        return h(BreadcrumbItem, {
          key: item.hasOwnProperty('key') ? item.key : index,
          props: {
            active: item.hasOwnProperty('active') ? item.active : index === props.items.length - 1,
            href: item.href,
            target: item.target,
            to: item.to,
            replace: item.replace,
            append: item.append,
            exact: item.exact
          }
        }, item.text);
      });
    }
    return h('ol', mergeData$1(data, { class: 'breadcrumb' }), slot);
  },

  props: {
    items: Array
  }
};

var BtnToolbar = {
  functional: true,
  render: function render(h, _ref) {
    var children = _ref.children,
        data = _ref.data;

    return h('div', mergeData$1(data, {
      class: {
        'btn-toolbar': true
      },
      attrs: {
        role: 'toolbar'
      }
    }), children);
  }
};

var MultiSelect = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('dropdown', { ref: "dropdown", style: _vm.containerStyles, attrs: { "not-close-elements": _vm.els, "append-to-body": _vm.appendToBody, "disabled": _vm.disabled }, nativeOn: { "keydown": function keydown($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) {
            return null;
          }_vm.showDropdown = false;
        } }, model: { value: _vm.showDropdown, callback: function callback($$v) {
          _vm.showDropdown = $$v;
        }, expression: "showDropdown" } }, [_c('div', { staticClass: "form-control dropdown-toggle clearfix", class: _vm.selectClasses, attrs: { "disabled": _vm.disabled, "tabindex": "0", "data-role": "trigger" }, on: { "focus": function focus($event) {
          return _vm.$emit('focus', $event);
        }, "blur": function blur($event) {
          return _vm.$emit('blur', $event);
        }, "keydown": [function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) {
            return null;
          }$event.preventDefault();$event.stopPropagation();return _vm.goNextOption($event);
        }, function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) {
            return null;
          }$event.preventDefault();$event.stopPropagation();return _vm.goPrevOption($event);
        }, function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
            return null;
          }$event.preventDefault();$event.stopPropagation();return _vm.selectOption($event);
        }] } }, [_c('div', { class: _vm.selectTextClasses, staticStyle: { "display": "inline-block", "vertical-align": "middle" } }, [_vm._v(_vm._s(_vm.selectedText))]), _vm._v(" "), _c('div', { staticClass: "pull-right", staticStyle: { "display": "inline-block", "vertical-align": "middle" } }, [_c('span', [_vm._v(" ")]), _vm._v(" "), _c('span', { staticClass: "caret" })])]), _vm._v(" "), _c('template', { slot: "dropdown" }, [_vm.filterable ? _c('li', { staticStyle: { "padding": "4px 8px" } }, [_c('input', { directives: [{ name: "model", rawName: "v-model", value: _vm.filterInput, expression: "filterInput" }], ref: "filterInput", staticClass: "form-control input-sm", attrs: { "aria-label": "Filter...", "type": "text", "placeholder": _vm.filterPlaceholder || _vm.t('uiv.multiSelect.filterPlaceholder') }, domProps: { "value": _vm.filterInput }, on: { "keydown": [function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) {
            return null;
          }$event.preventDefault();$event.stopPropagation();return _vm.goNextOption($event);
        }, function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) {
            return null;
          }$event.preventDefault();$event.stopPropagation();return _vm.goPrevOption($event);
        }, function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
            return null;
          }$event.preventDefault();$event.stopPropagation();return _vm.selectOption($event);
        }], "input": function input($event) {
          if ($event.target.composing) {
            return;
          }_vm.filterInput = $event.target.value;
        } } })]) : _vm._e(), _vm._v(" "), _vm._l(_vm.groupedOptions, function (item) {
      return [item.$group ? _c('li', { staticClass: "dropdown-header", domProps: { "textContent": _vm._s(item.$group) } }) : _vm._e(), _vm._v(" "), _vm._l(item.options, function (_item) {
        return [_c('li', { class: _vm.itemClasses(_item), staticStyle: { "outline": "0" }, on: { "keydown": [function ($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) {
                return null;
              }$event.preventDefault();$event.stopPropagation();return _vm.goNextOption($event);
            }, function ($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) {
                return null;
              }$event.preventDefault();$event.stopPropagation();return _vm.goPrevOption($event);
            }, function ($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
                return null;
              }$event.preventDefault();$event.stopPropagation();return _vm.selectOption($event);
            }], "click": function click($event) {
              $event.stopPropagation();return _vm.toggle(_item);
            }, "mouseenter": function mouseenter($event) {
              _vm.currentActive = -1;
            } } }, [_vm.isItemSelected(_item) ? _c('a', { staticStyle: { "outline": "0" }, attrs: { "role": "button" } }, [_c('b', [_vm._v(_vm._s(_item[_vm.labelKey]))]), _vm._v(" "), _vm.selectedIcon ? _c('span', { class: _vm.selectedIconClasses }) : _vm._e()]) : _c('a', { staticStyle: { "outline": "0" }, attrs: { "role": "button" } }, [_c('span', [_vm._v(_vm._s(_item[_vm.labelKey]))])])])];
      })];
    })], 2)], 2);
  }, staticRenderFns: [],
  mixins: [Local],
  components: { Dropdown: Dropdown },
  props: {
    value: {
      type: Array,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    labelKey: {
      type: String,
      default: 'label'
    },
    valueKey: {
      type: String,
      default: 'value'
    },
    limit: {
      type: Number,
      default: 0
    },
    size: String,
    placeholder: String,
    split: {
      type: String,
      default: ', '
    },
    disabled: {
      type: Boolean,
      default: false
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    block: {
      type: Boolean,
      default: false
    },
    collapseSelected: {
      type: Boolean,
      default: false
    },
    filterable: {
      type: Boolean,
      default: false
    },
    filterAutoFocus: {
      type: Boolean,
      default: true
    },
    filterFunction: Function,
    filterPlaceholder: String,
    selectedIcon: {
      type: String,
      default: 'glyphicon glyphicon-ok'
    },
    itemSelectedClass: String
  },
  data: function data() {
    return {
      showDropdown: false,
      els: [],
      filterInput: '',
      currentActive: -1
    };
  },

  computed: {
    containerStyles: function containerStyles() {
      return {
        width: this.block ? '100%' : ''
      };
    },
    filteredOptions: function filteredOptions() {
      var _this = this;

      if (this.filterable && this.filterInput) {
        if (this.filterFunction) {
          return this.filterFunction(this.filterInput);
        } else {
          var filterInput = this.filterInput.toLowerCase();
          return this.options.filter(function (v) {
            return v[_this.valueKey].toString().toLowerCase().indexOf(filterInput) >= 0 || v[_this.labelKey].toString().toLowerCase().indexOf(filterInput) >= 0;
          });
        }
      } else {
        return this.options;
      }
    },
    groupedOptions: function groupedOptions() {
      var _this2 = this;

      return this.filteredOptions.map(function (v) {
        return v.group;
      }).filter(onlyUnique).map(function (v) {
        return {
          options: _this2.filteredOptions.filter(function (option) {
            return option.group === v;
          }),
          $group: v
        };
      });
    },
    flatternGroupedOptions: function flatternGroupedOptions() {
      if (this.groupedOptions && this.groupedOptions.length) {
        var result = [];
        this.groupedOptions.forEach(function (v) {
          result = result.concat(v.options);
        });
        return result;
      } else {
        return [];
      }
    },
    selectClasses: function selectClasses() {
      return defineProperty$3({}, 'input-' + this.size, this.size);
    },
    selectedIconClasses: function selectedIconClasses() {
      var _ref2;

      return _ref2 = {}, defineProperty$3(_ref2, this.selectedIcon, true), defineProperty$3(_ref2, 'pull-right', true), _ref2;
    },
    selectTextClasses: function selectTextClasses() {
      return {
        'text-muted': this.value.length === 0
      };
    },
    labelValue: function labelValue() {
      var _this3 = this;

      var optionsByValue = this.options.map(function (v) {
        return v[_this3.valueKey];
      });
      return this.value.map(function (v) {
        var index = optionsByValue.indexOf(v);
        return index >= 0 ? _this3.options[index][_this3.labelKey] : v;
      });
    },
    selectedText: function selectedText() {
      if (this.value.length) {
        var labelValue = this.labelValue;
        if (this.collapseSelected) {
          var str = labelValue[0];
          str += labelValue.length > 1 ? this.split + '+' + (labelValue.length - 1) : '';
          return str;
        } else {
          return labelValue.join(this.split);
        }
      } else {
        return this.placeholder || this.t('uiv.multiSelect.placeholder');
      }
    }
  },
  watch: {
    showDropdown: function showDropdown(v) {
      var _this4 = this;

      // clear filter input when dropdown toggles
      this.filterInput = '';
      this.currentActive = -1;
      this.$emit('visible-change', v);
      if (v && this.filterable && this.filterAutoFocus) {
        this.$nextTick(function () {
          _this4.$refs.filterInput.focus();
        });
      }
    }
  },
  mounted: function mounted() {
    this.els = [this.$el];
  },

  methods: {
    goPrevOption: function goPrevOption() {
      if (!this.showDropdown) {
        return;
      }
      this.currentActive > 0 ? this.currentActive-- : this.currentActive = this.flatternGroupedOptions.length - 1;
    },
    goNextOption: function goNextOption() {
      if (!this.showDropdown) {
        return;
      }
      this.currentActive < this.flatternGroupedOptions.length - 1 ? this.currentActive++ : this.currentActive = 0;
    },
    selectOption: function selectOption() {
      var index = this.currentActive;
      var options = this.flatternGroupedOptions;
      if (!this.showDropdown) {
        this.showDropdown = true;
      } else if (index >= 0 && index < options.length) {
        this.toggle(options[index]);
      }
    },
    itemClasses: function itemClasses(item) {
      var result = {
        disabled: item.disabled,
        active: this.currentActive === this.flatternGroupedOptions.indexOf(item)
      };
      if (this.itemSelectedClass) {
        result[this.itemSelectedClass] = this.isItemSelected(item);
      }
      return result;
    },
    isItemSelected: function isItemSelected(item) {
      return this.value.indexOf(item[this.valueKey]) >= 0;
    },
    toggle: function toggle(item) {
      if (item.disabled) {
        return;
      }
      var value = item[this.valueKey];
      var index = this.value.indexOf(value);
      if (this.limit === 1) {
        var newValue = index >= 0 ? [] : [value];
        this.$emit('input', newValue);
        this.$emit('change', newValue);
      } else {
        if (index >= 0) {
          var newVal = this.value.slice();
          newVal.splice(index, 1);
          this.$emit('input', newVal);
          this.$emit('change', newVal);
        } else if (this.limit === 0 || this.value.length < this.limit) {
          var _newVal = this.value.slice();
          _newVal.push(value);
          this.$emit('input', _newVal);
          this.$emit('change', _newVal);
        } else {
          this.$emit('limit-exceed');
        }
      }
    }
  }
};

var Navbar = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('nav', { class: _vm.navClasses }, [_c('div', { class: _vm.fluid ? 'container-fluid' : 'container' }, [_c('div', { staticClass: "navbar-header" }, [_vm._t("collapse-btn", [_c('button', { staticClass: "navbar-toggle collapsed", attrs: { "type": "button" }, on: { "click": _vm.toggle } }, [_c('span', { staticClass: "sr-only" }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', { staticClass: "icon-bar" }), _vm._v(" "), _c('span', { staticClass: "icon-bar" }), _vm._v(" "), _c('span', { staticClass: "icon-bar" })])]), _vm._v(" "), _vm._t("brand")], 2), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('collapse', { staticClass: "navbar-collapse", model: { value: _vm.show, callback: function callback($$v) {
          _vm.show = $$v;
        }, expression: "show" } }, [_vm._t("collapse")], 2)], 2)]);
  }, staticRenderFns: [],
  components: { Collapse: Collapse },
  props: {
    value: Boolean,
    fluid: {
      type: Boolean,
      default: true
    },
    fixedTop: Boolean,
    fixedBottom: Boolean,
    staticTop: Boolean,
    inverse: Boolean
  },
  data: function data() {
    return {
      show: false
    };
  },

  computed: {
    navClasses: function navClasses() {
      return {
        navbar: true,
        'navbar-default': !this.inverse,
        'navbar-inverse': this.inverse,
        'navbar-static-top': this.staticTop,
        'navbar-fixed-bottom': this.fixedBottom,
        'navbar-fixed-top': this.fixedTop
      };
    }
  },
  mounted: function mounted() {
    this.show = !!this.value;
  },

  watch: {
    value: function value(v) {
      this.show = v;
    }
  },
  methods: {
    toggle: function toggle() {
      this.show = !this.show;
      this.$emit('input', this.show);
    }
  }
};

var NavbarNav = {
  functional: true,
  render: function render(h, _ref) {
    var children = _ref.children,
        data = _ref.data,
        props = _ref.props;

    return h('ul', mergeData$1(data, {
      class: {
        nav: true,
        'navbar-nav': true,
        'navbar-left': props.left,
        'navbar-right': props.right
      }
    }), children);
  },

  props: {
    left: Boolean,
    right: Boolean
  }
};

var NavbarForm = {
  functional: true,
  render: function render(h, _ref) {
    var children = _ref.children,
        data = _ref.data,
        props = _ref.props;

    return h('form', mergeData$1(data, {
      class: {
        'navbar-form': true,
        'navbar-left': props.left,
        'navbar-right': props.right
      }
    }), children);
  },

  props: {
    left: Boolean,
    right: Boolean
  }
};

var NavbarText = {
  functional: true,
  render: function render(h, _ref) {
    var children = _ref.children,
        data = _ref.data,
        props = _ref.props;

    return h('p', mergeData$1(data, {
      class: {
        'navbar-text': true,
        'navbar-left': props.left,
        'navbar-right': props.right
      }
    }), children);
  },

  props: {
    left: Boolean,
    right: Boolean
  }
};



var components = Object.freeze({
	Carousel: Carousel,
	Slide: Slide,
	Collapse: Collapse,
	Dropdown: Dropdown,
	Modal: Modal,
	Tab: Tab,
	Tabs: Tabs,
	DatePicker: DatePicker,
	Affix: Affix,
	Alert: Alert,
	Pagination: Pagination,
	Tooltip: Tooltip,
	Popover: Popover,
	TimePicker: TimePicker,
	Typeahead: Typeahead,
	ProgressBar: ProgressBar,
	ProgressBarStack: ProgressBarStack,
	Breadcrumbs: Breadcrumbs,
	BreadcrumbItem: BreadcrumbItem,
	Btn: Btn,
	BtnGroup: BtnGroup,
	BtnToolbar: BtnToolbar,
	MultiSelect: MultiSelect,
	Navbar: Navbar,
	NavbarNav: NavbarNav,
	NavbarForm: NavbarForm,
	NavbarText: NavbarText
});

var INSTANCE = '_uiv_tooltip_instance';

var bind$1$1 = function bind(el, binding) {
  // console.log('bind')
  unbind$1$1(el);
  var Constructor = Vue$1.extend(Tooltip);
  var vm = new Constructor({
    propsData: {
      target: el,
      appendTo: binding.arg && '#' + binding.arg,
      text: typeof binding.value === 'string' ? binding.value && binding.value.toString() : binding.value && binding.value.text && binding.value.text.toString(),
      viewport: binding.value && binding.value.viewport && binding.value.viewport.toString(),
      customClass: binding.value && binding.value.customClass && binding.value.customClass.toString(),
      showDelay: binding.value && binding.value.showDelay,
      hideDelay: binding.value && binding.value.hideDelay
    }
  });
  var options = [];
  for (var key in binding.modifiers) {
    if (binding.modifiers.hasOwnProperty(key) && binding.modifiers[key]) {
      options.push(key);
    }
  }
  options.forEach(function (option) {
    if (/(top)|(left)|(right)|(bottom)/.test(option)) {
      vm.placement = option;
    } else if (/(hover)|(focus)|(click)/.test(option)) {
      vm.trigger = option;
    } else if (/unenterable/.test(option)) {
      vm.enterable = false;
    }
  });
  vm.$mount();
  el[INSTANCE] = vm;
};

var unbind$1$1 = function unbind(el) {
  // console.log('unbind')
  var vm = el[INSTANCE];
  if (vm) {
    vm.$destroy();
  }
  delete el[INSTANCE];
};

var update$1$1 = function update(el, binding) {
  // console.log('update')
  if (binding.value !== binding.oldValue) {
    bind$1$1(el, binding);
  }
};

var tooltip = { bind: bind$1$1, unbind: unbind$1$1, update: update$1$1 };

var INSTANCE$1 = '_uiv_popover_instance';

var bind$2$1 = function bind(el, binding) {
  // console.log('bind')
  unbind$2(el);
  var Constructor = Vue$1.extend(Popover);
  var vm = new Constructor({
    propsData: {
      target: el,
      appendTo: binding.arg && '#' + binding.arg,
      title: binding.value && binding.value.title && binding.value.title.toString(),
      content: binding.value && binding.value.content && binding.value.content.toString(),
      viewport: binding.value && binding.value.viewport && binding.value.viewport.toString(),
      customClass: binding.value && binding.value.customClass && binding.value.customClass.toString()
    }
  });
  var options = [];
  for (var key in binding.modifiers) {
    if (binding.modifiers.hasOwnProperty(key) && binding.modifiers[key]) {
      options.push(key);
    }
  }
  options.forEach(function (option) {
    if (/(top)|(left)|(right)|(bottom)/.test(option)) {
      vm.placement = option;
    } else if (/(hover)|(focus)|(click)/.test(option)) {
      vm.trigger = option;
    } else if (/unenterable/.test(option)) {
      vm.enterable = false;
    }
  });
  vm.$mount();
  el[INSTANCE$1] = vm;
};

var unbind$2 = function unbind(el) {
  // console.log('unbind')
  var vm = el[INSTANCE$1];
  if (vm) {
    vm.$destroy();
  }
  delete el[INSTANCE$1];
};

var update$2$1 = function update(el, binding) {
  // console.log('update')
  if (binding.value !== binding.oldValue) {
    bind$2$1(el, binding);
  }
};

var popover = { bind: bind$2$1, unbind: unbind$2, update: update$2$1 };

function ScrollSpy(element) {
  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'body';
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  this.el = element;
  this.opts = _extends({}, ScrollSpy.DEFAULTS, options);
  this.opts.target = target;
  if (target === 'body') {
    this.scrollElement = window;
  } else {
    this.scrollElement = document.querySelector('[id=' + target + ']');
  }
  this.selector = 'li > a';
  this.offsets = [];
  this.targets = [];
  this.activeTarget = null;
  this.scrollHeight = 0;
  if (this.scrollElement) {
    this.refresh();
    this.process();
  }
}

ScrollSpy.DEFAULTS = {
  offset: 10,
  callback: function callback(ele) {
    return 0;
  }
};

ScrollSpy.prototype.getScrollHeight = function () {
  return this.scrollElement.scrollHeight || Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
};

ScrollSpy.prototype.refresh = function () {
  var _this = this;

  this.offsets = [];
  this.targets = [];
  this.scrollHeight = this.getScrollHeight();
  var list = nodeListToArray(this.el.querySelectorAll(this.selector));
  var isWindow = this.scrollElement === window;
  list.map(function (ele) {
    var href = ele.getAttribute('href');
    if (/^#./.test(href)) {
      var doc = document.documentElement;
      var rootEl = isWindow ? document : _this.scrollElement;
      var hrefEl = rootEl.querySelector('[id=\'' + href.slice(1) + '\']');
      var windowScrollTop = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
      var offset = isWindow ? hrefEl.getBoundingClientRect().top + windowScrollTop : hrefEl.offsetTop + _this.scrollElement.scrollTop;
      return [offset, href];
    } else {
      return null;
    }
  }).filter(function (item) {
    return item;
  }).sort(function (a, b) {
    return a[0] - b[0];
  }).forEach(function (item) {
    _this.offsets.push(item[0]);
    _this.targets.push(item[1]);
  });
  // console.log(this.offsets, this.targets)
};

ScrollSpy.prototype.process = function () {
  var isWindow = this.scrollElement === window;
  var scrollTop = (isWindow ? window.pageYOffset : this.scrollElement.scrollTop) + this.opts.offset;
  var scrollHeight = this.getScrollHeight();
  var scrollElementHeight = isWindow ? getViewportSize().height : this.scrollElement.getBoundingClientRect().height;
  var maxScroll = this.opts.offset + scrollHeight - scrollElementHeight;
  var offsets = this.offsets;
  var targets = this.targets;
  var activeTarget = this.activeTarget;
  var i = void 0;
  if (this.scrollHeight !== scrollHeight) {
    this.refresh();
  }
  if (scrollTop >= maxScroll) {
    return activeTarget !== (i = targets[targets.length - 1]) && this.activate(i);
  }
  if (activeTarget && scrollTop < offsets[0]) {
    this.activeTarget = null;
    return this.clear();
  }
  for (i = offsets.length; i--;) {
    activeTarget !== targets[i] && scrollTop >= offsets[i] && (offsets[i + 1] === undefined || scrollTop < offsets[i + 1]) && this.activate(targets[i]);
  }
};

ScrollSpy.prototype.activate = function (target) {
  this.activeTarget = target;
  this.clear();
  var selector = this.selector + '[data-target="' + target + '"],' + this.selector + '[href="' + target + '"]';
  var activeCallback = this.opts.callback;
  var active = nodeListToArray(this.el.querySelectorAll(selector));
  active.forEach(function (ele) {
    getParents(ele, 'li').forEach(function (item) {
      addClass$1(item, 'active');
      activeCallback(item);
    });
    if (getParents(ele, '.dropdown-menu').length) {
      addClass$1(getClosest(ele, 'li.dropdown'), 'active');
    }
  });
};

ScrollSpy.prototype.clear = function () {
  var _this2 = this;

  var list = nodeListToArray(this.el.querySelectorAll(this.selector));
  list.forEach(function (ele) {
    getParents(ele, '.active', _this2.opts.target).forEach(function (item) {
      removeClass$1(item, 'active');
    });
  });
};

var INSTANCE$2 = '_uiv_scrollspy_instance';
var events$1$1 = [EVENTS.RESIZE, EVENTS.SCROLL];

var bind$3 = function bind(el, binding) {
  // console.log('bind')
  unbind$3(el);
};

var inserted = function inserted(el, binding) {
  // console.log('inserted')
  var scrollSpy = new ScrollSpy(el, binding.arg, binding.value);
  if (scrollSpy.scrollElement) {
    scrollSpy.handler = function () {
      scrollSpy.process();
    };
    events$1$1.forEach(function (event) {
      on(scrollSpy.scrollElement, event, scrollSpy.handler);
    });
  }
  el[INSTANCE$2] = scrollSpy;
};

var unbind$3 = function unbind(el) {
  // console.log('unbind')
  var instance = el[INSTANCE$2];
  if (instance && instance.scrollElement) {
    events$1$1.forEach(function (event) {
      off(instance.scrollElement, event, instance.handler);
    });
    delete el[INSTANCE$2];
  }
};

var update$3 = function update(el, binding) {
  // console.log('update')
  var isArgUpdated = binding.arg !== binding.oldArg;
  var isValueUpdated = binding.value !== binding.oldValue;
  if (isArgUpdated || isValueUpdated) {
    bind$3(el);
    inserted(el, binding);
  }
};

var scrollspy = { bind: bind$3, unbind: unbind$3, update: update$3, inserted: inserted };



var directives$1 = Object.freeze({
	tooltip: tooltip,
	popover: popover,
	scrollspy: scrollspy
});

var TYPES = {
  ALERT: 0,
  CONFIRM: 1,
  PROMPT: 2
};

var MessageBox = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('modal', { ref: "modal", class: _vm.customClass, attrs: { "auto-focus": "", "size": _vm.size, "title": _vm.title, "header": !!_vm.title, "backdrop": _vm.closeOnBackdropClick, "cancel-text": _vm.cancelText, "ok-text": _vm.okText }, on: { "hide": _vm.cb }, model: { value: _vm.show, callback: function callback($$v) {
          _vm.show = $$v;
        }, expression: "show" } }, [_vm.html ? _c('div', { domProps: { "innerHTML": _vm._s(_vm.content) } }) : _c('p', [_vm._v(_vm._s(_vm.content))]), _vm._v(" "), _vm.type === _vm.TYPES.PROMPT ? _c('div', [_c('div', { staticClass: "form-group", class: { 'has-error': _vm.inputNotValid } }, [_vm.inputType === 'checkbox' ? _c('input', { directives: [{ name: "model", rawName: "v-model", value: _vm.input, expression: "input" }], ref: "input", staticClass: "form-control", attrs: { "required": "", "data-action": "auto-focus", "type": "checkbox" }, domProps: { "checked": Array.isArray(_vm.input) ? _vm._i(_vm.input, null) > -1 : _vm.input }, on: { "change": [function ($event) {
          var $$a = _vm.input,
              $$el = $event.target,
              $$c = $$el.checked ? true : false;if (Array.isArray($$a)) {
            var $$v = null,
                $$i = _vm._i($$a, $$v);if ($$el.checked) {
              $$i < 0 && (_vm.input = $$a.concat([$$v]));
            } else {
              $$i > -1 && (_vm.input = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.input = $$c;
          }
        }, function ($event) {
          _vm.dirty = true;
        }], "keyup": function keyup($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
            return null;
          }return _vm.validate($event);
        } } }) : _vm.inputType === 'radio' ? _c('input', { directives: [{ name: "model", rawName: "v-model", value: _vm.input, expression: "input" }], ref: "input", staticClass: "form-control", attrs: { "required": "", "data-action": "auto-focus", "type": "radio" }, domProps: { "checked": _vm._q(_vm.input, null) }, on: { "change": [function ($event) {
          _vm.input = null;
        }, function ($event) {
          _vm.dirty = true;
        }], "keyup": function keyup($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
            return null;
          }return _vm.validate($event);
        } } }) : _c('input', { directives: [{ name: "model", rawName: "v-model", value: _vm.input, expression: "input" }], ref: "input", staticClass: "form-control", attrs: { "required": "", "data-action": "auto-focus", "type": _vm.inputType }, domProps: { "value": _vm.input }, on: { "change": function change($event) {
          _vm.dirty = true;
        }, "keyup": function keyup($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
            return null;
          }return _vm.validate($event);
        }, "input": function input($event) {
          if ($event.target.composing) {
            return;
          }_vm.input = $event.target.value;
        } } }), _vm._v(" "), _c('span', { directives: [{ name: "show", rawName: "v-show", value: _vm.inputNotValid, expression: "inputNotValid" }], staticClass: "help-block" }, [_vm._v(_vm._s(_vm.inputError))])])]) : _vm._e(), _vm._v(" "), _vm.type === _vm.TYPES.ALERT ? _c('template', { slot: "footer" }, [_c('btn', { attrs: { "type": _vm.okType, "data-action": _vm.autoFocus === 'ok' ? 'auto-focus' : '' }, domProps: { "textContent": _vm._s(_vm.okBtnText) }, on: { "click": function click($event) {
          return _vm.toggle(false, 'ok');
        } } })], 1) : _c('template', { slot: "footer" }, [_c('btn', { attrs: { "type": _vm.cancelType, "data-action": _vm.autoFocus === 'cancel' ? 'auto-focus' : '' }, domProps: { "textContent": _vm._s(_vm.cancelBtnText) }, on: { "click": function click($event) {
          return _vm.toggle(false, 'cancel');
        } } }), _vm._v(" "), _vm.type === _vm.TYPES.CONFIRM ? _c('btn', { attrs: { "type": _vm.okType, "data-action": _vm.autoFocus === 'ok' ? 'auto-focus' : '' }, domProps: { "textContent": _vm._s(_vm.okBtnText) }, on: { "click": function click($event) {
          return _vm.toggle(false, 'ok');
        } } }) : _c('btn', { attrs: { "type": _vm.okType }, domProps: { "textContent": _vm._s(_vm.okBtnText) }, on: { "click": _vm.validate } })], 1)], 2);
  }, staticRenderFns: [],
  mixins: [Local],
  components: { Modal: Modal, Btn: Btn },
  props: {
    backdrop: null,
    title: String,
    content: String,
    html: {
      type: Boolean,
      default: false
    },
    okText: String,
    okType: {
      type: String,
      default: 'primary'
    },
    cancelText: String,
    cancelType: {
      type: String,
      default: 'default'
    },
    type: {
      type: Number,
      default: TYPES.ALERT
    },
    size: {
      type: String,
      default: 'sm'
    },
    cb: {
      type: Function,
      required: true
    },
    validator: {
      type: Function,
      default: function _default() {
        return null;
      }
    },
    customClass: null,
    defaultValue: String,
    inputType: {
      type: String,
      default: 'text'
    },
    autoFocus: {
      type: String,
      default: 'ok'
    }
  },
  data: function data() {
    return {
      TYPES: TYPES,
      show: false,
      input: '',
      dirty: false
    };
  },
  mounted: function mounted() {
    if (this.defaultValue) {
      this.input = this.defaultValue;
    }
  },

  computed: {
    closeOnBackdropClick: function closeOnBackdropClick() {
      // use backdrop prop if exist
      // otherwise, only not available if render as alert
      return isExist(this.backdrop) ? Boolean(this.backdrop) : this.type !== TYPES.ALERT;
    },
    inputError: function inputError() {
      return this.validator(this.input);
    },
    inputNotValid: function inputNotValid() {
      return this.dirty && this.inputError;
    },
    okBtnText: function okBtnText() {
      return this.okText || this.t('uiv.modal.ok');
    },
    cancelBtnText: function cancelBtnText() {
      return this.cancelText || this.t('uiv.modal.cancel');
    }
  },
  methods: {
    toggle: function toggle(show, msg) {
      this.$refs.modal.toggle(show, msg);
    },
    validate: function validate() {
      this.dirty = true;
      if (!isExist(this.inputError)) {
        this.toggle(false, { value: this.input });
      }
    }
  }
};

var queue$1 = [];

var destroy = function destroy(instance) {
  // console.log('destroyModal')
  removeFromDom(instance.$el);
  instance.$destroy();
  spliceIfExist(queue$1, instance);
};

// handel cancel or ok for confirm & prompt
var shallResolve = function shallResolve(type, msg) {
  if (type === TYPES.CONFIRM) {
    // is confirm
    return msg === 'ok';
  } else {
    // is prompt
    return isExist(msg) && isString$1(msg.value);
  }
};

var init = function init(type, options, _cb) {
  var resolve = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var reject = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

  var i18n = this.$i18n;
  var instance = new Vue$1({
    extends: MessageBox,
    i18n: i18n,
    propsData: _extends({
      type: type
    }, options, {
      cb: function cb(msg) {
        destroy(instance);
        if (isFunction(_cb)) {
          if (type === TYPES.CONFIRM) {
            shallResolve(type, msg) ? _cb(null, msg) : _cb(msg);
          } else if (type === TYPES.PROMPT) {
            shallResolve(type, msg) ? _cb(null, msg.value) : _cb(msg);
          } else {
            _cb(msg);
          }
        } else if (resolve && reject) {
          if (type === TYPES.CONFIRM) {
            shallResolve(type, msg) ? resolve(msg) : reject(msg);
          } else if (type === TYPES.PROMPT) {
            shallResolve(type, msg) ? resolve(msg.value) : reject(msg);
          } else {
            resolve(msg);
          }
        }
      }
    })
  });
  instance.$mount();
  document.body.appendChild(instance.$el);
  instance.show = true;
  queue$1.push(instance);
};

var initModal = function initModal(type) {
  var _this = this;

  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var cb = arguments[2];

  if (isPromiseSupported()) {
    return new Promise(function (resolve, reject) {
      init.apply(_this, [type, options, cb, resolve, reject]);
    });
  } else {
    init.apply(this, [type, options, cb]);
  }
};

var alert$1 = function alert(options, cb) {
  return initModal.apply(this, [TYPES.ALERT, options, cb]);
};

var confirm = function confirm(options, cb) {
  return initModal.apply(this, [TYPES.CONFIRM, options, cb]);
};

var prompt = function prompt(options, cb) {
  return initModal.apply(this, [TYPES.PROMPT, options, cb]);
};

var messageBox = { alert: alert$1, confirm: confirm, prompt: prompt };

var TYPES$1 = {
  SUCCESS: 'success',
  INFO: 'info',
  DANGER: 'danger',
  WARNING: 'warning'
};

var PLACEMENTS$1 = {
  TOP_LEFT: 'top-left',
  TOP_RIGHT: 'top-right',
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_RIGHT: 'bottom-right'
};

var IN_CLASS$1 = 'in';
var ICON = 'glyphicon';
var WIDTH = 300;
var TRANSITION_DURATION = 300;

var Notification = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('alert', { staticClass: "fade", class: _vm.customClass, style: _vm.styles, attrs: { "type": _vm.type, "duration": _vm.duration, "dismissible": _vm.dismissible }, on: { "dismissed": _vm.onDismissed } }, [_c('div', { staticClass: "media", staticStyle: { "margin": "0" } }, [_vm.icons ? _c('div', { staticClass: "media-left" }, [_c('span', { class: _vm.icons, staticStyle: { "font-size": "1.5em" } })]) : _vm._e(), _vm._v(" "), _c('div', { staticClass: "media-body" }, [_vm.title ? _c('div', { staticClass: "media-heading" }, [_c('b', [_vm._v(_vm._s(_vm.title))])]) : _vm._e(), _vm._v(" "), _vm.html ? _c('div', { domProps: { "innerHTML": _vm._s(_vm.content) } }) : _c('div', [_vm._v(_vm._s(_vm.content))])])])]);
  }, staticRenderFns: [],
  components: { Alert: Alert },
  props: {
    title: String,
    content: String,
    html: {
      type: Boolean,
      default: false
    },
    duration: {
      type: Number,
      default: 5000
    },
    dismissible: {
      type: Boolean,
      default: true
    },
    type: String,
    placement: String,
    icon: String,
    customClass: null,
    cb: {
      type: Function,
      required: true
    },
    queue: {
      type: Array,
      required: true
    },
    offsetY: {
      type: Number,
      default: 15
    },
    offsetX: {
      type: Number,
      default: 15
    },
    offset: {
      type: Number,
      default: 15
    }
  },
  data: function data() {
    return {
      height: 0,
      top: 0,
      horizontal: this.placement === PLACEMENTS$1.TOP_LEFT || this.placement === PLACEMENTS$1.BOTTOM_LEFT ? 'left' : 'right',
      vertical: this.placement === PLACEMENTS$1.TOP_LEFT || this.placement === PLACEMENTS$1.TOP_RIGHT ? 'top' : 'bottom'
    };
  },
  created: function created() {
    // get prev notifications total height in the queue
    this.top = this.getTotalHeightOfQueue(this.queue);
  },
  mounted: function mounted() {
    var _this = this;

    var el = this.$el;
    el.style[this.vertical] = this.top + 'px';
    this.$nextTick(function () {
      el.style[_this.horizontal] = '-' + WIDTH + 'px';
      _this.height = el.offsetHeight;
      el.style[_this.horizontal] = _this.offsetX + 'px';
      addClass$1(el, IN_CLASS$1);
    });
  },

  computed: {
    styles: function styles() {
      var _ref;

      var queue = this.queue;
      var thisIndex = queue.indexOf(this);
      return _ref = {
        position: 'fixed'
      }, defineProperty$3(_ref, this.vertical, this.getTotalHeightOfQueue(queue, thisIndex) + 'px'), defineProperty$3(_ref, 'width', WIDTH + 'px'), defineProperty$3(_ref, 'transition', 'all ' + TRANSITION_DURATION / 1000 + 's ease-in-out'), _ref;
    },
    icons: function icons() {
      if (isString$1(this.icon)) {
        return this.icon;
      }
      switch (this.type) {
        case TYPES$1.INFO:
        case TYPES$1.WARNING:
          return ICON + ' ' + ICON + '-info-sign';
        case TYPES$1.SUCCESS:
          return ICON + ' ' + ICON + '-ok-sign';
        case TYPES$1.DANGER:
          return ICON + ' ' + ICON + '-remove-sign';
        default:
          return null;
      }
    }
  },
  methods: {
    getTotalHeightOfQueue: function getTotalHeightOfQueue(queue) {
      var lastIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : queue.length;

      var totalHeight = this.offsetY;
      for (var i = 0; i < lastIndex; i++) {
        totalHeight += queue[i].height + this.offset;
      }
      return totalHeight;
    },
    onDismissed: function onDismissed() {
      removeClass$1(this.$el, IN_CLASS$1);
      setTimeout(this.cb, TRANSITION_DURATION);
    }
  }
};

var _queues;

var queues = (_queues = {}, defineProperty$3(_queues, PLACEMENTS$1.TOP_LEFT, []), defineProperty$3(_queues, PLACEMENTS$1.TOP_RIGHT, []), defineProperty$3(_queues, PLACEMENTS$1.BOTTOM_LEFT, []), defineProperty$3(_queues, PLACEMENTS$1.BOTTOM_RIGHT, []), _queues);

var destroy$1 = function destroy(queue, instance) {
  // console.log('destroyNotification')
  removeFromDom(instance.$el);
  instance.$destroy();
  spliceIfExist(queue, instance);
};

var init$1 = function init(options, _cb) {
  var resolve = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var reject = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var placement = options.placement;
  var queue = queues[placement];
  // check if placement is valid
  if (!isExist(queue)) {
    return;
  }
  /* istanbul ignore else */
  // `error` alias of `danger`
  if (options.type === 'error') {
    options.type = 'danger';
  }
  var instance = new Vue$1({
    extends: Notification,
    propsData: _extends({
      queue: queue,
      placement: placement
    }, options, {
      cb: function cb(msg) {
        destroy$1(queue, instance);
        if (isFunction(_cb)) {
          _cb(msg);
        } else if (resolve && reject) {
          resolve(msg);
        }
      }
    })
  });
  instance.$mount();
  document.body.appendChild(instance.$el);
  queue.push(instance);
};

var _notify = function _notify() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var cb = arguments[1];

  // simplify usage: pass string as option.content
  if (isString$1(options)) {
    options = {
      content: options
    };
  }
  // set default placement as top-right
  if (!isExist(options.placement)) {
    options.placement = PLACEMENTS$1.TOP_RIGHT;
  }
  if (isPromiseSupported()) {
    return new Promise(function (resolve, reject) {
      init$1(options, cb, resolve, reject);
    });
  } else {
    init$1(options, cb);
  }
};

function _notify2(type, args) {
  if (isString$1(args)) {
    _notify({
      content: args,
      type: type
    });
  } else {
    _notify(_extends({}, args, {
      type: type
    }));
  }
}

var notify = Object.defineProperties(_notify, {
  success: {
    configurable: false,
    writable: false,
    value: function value(args) {
      _notify2('success', args);
    }
  },
  info: {
    configurable: false,
    writable: false,
    value: function value(args) {
      _notify2('info', args);
    }
  },
  warning: {
    configurable: false,
    writable: false,
    value: function value(args) {
      _notify2('warning', args);
    }
  },
  danger: {
    configurable: false,
    writable: false,
    value: function value(args) {
      _notify2('danger', args);
    }
  },
  error: {
    configurable: false,
    writable: false,
    value: function value(args) {
      _notify2('danger', args);
    }
  },
  dismissAll: {
    configurable: false,
    writable: false,
    value: function value() {
      for (var key in queues) {
        /* istanbul ignore else */
        if (queues.hasOwnProperty(key)) {
          queues[key].forEach(function (instance) {
            instance.onDismissed();
          });
        }
      }
    }
  }
});

var notification = { notify: notify };



var services = Object.freeze({
	MessageBox: messageBox,
	Notification: notification
});

const img = "data:image/png;base64,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";

/* script */

/* template */
var __vue_render__$4 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("svg", {
    attrs: {
      id: "edit-svg",
      "mi-view-box": "0 0 1024 1024",
      viewBox: "0 0 1024 1024"
    }
  }, [_c("rect", {
    attrs: {
      fill: "white",
      x: "0",
      y: "0",
      "mi-width": "1024",
      "mi-height": "1024",
      width: "1024",
      height: "1024"
    }
  }), _vm._v(" "), _c("g", [_c("path", {
    staticClass: "cursor-pointer",
    attrs: {
      "ng-repeat": "path in icon.paths track by tempIds[$index]",
      "mi-d": "M302.080 414.72l-71.68 71.68 230.4 230.4 512-512-71.68-71.68-440.32 440.32-158.72-158.72zM921.6 512c0 225.28-184.32 409.6-409.6 409.6s-409.6-184.32-409.6-409.6c0-225.28 184.32-409.6 409.6-409.6 40.96 0 76.8 5.12 112.64 15.36l81.922-81.92c-61.442-20.48-128.002-35.84-194.562-35.84-281.6 0-512 230.4-512 512s230.4 512 512 512c281.6 0 512-230.4 512-512h-102.4z",
      "mi-fill": "rgb(77, 160, 148)",
      "mi-stroke": "inherit",
      "mi-stroke-width": "inherit",
      "mi-stroke-linejoin": "inherit",
      "mi-stroke-linecap": "inherit",
      "mi-stroke-miterlimit": "inherit",
      "mi-opacity": "1",
      "ng-click": "selectPath($index)",
      "mi-absorb-clicks": "",
      d: "M302.080 414.72l-71.68 71.68 230.4 230.4 512-512-71.68-71.68-440.32 440.32-158.72-158.72zM921.6 512c0 225.28-184.32 409.6-409.6 409.6s-409.6-184.32-409.6-409.6c0-225.28 184.32-409.6 409.6-409.6 40.96 0 76.8 5.12 112.64 15.36l81.922-81.92c-61.442-20.48-128.002-35.84-194.562-35.84-281.6 0-512 230.4-512 512s230.4 512 512 512c281.6 0 512-230.4 512-512h-102.4z",
      fill: "rgb(77, 160, 148)",
      stroke: "inherit",
      "stroke-width": "inherit",
      "stroke-linejoin": "inherit",
      "stroke-linecap": "inherit",
      "stroke-miterlimit": "inherit",
      opacity: "1"
    }
  })]), _vm._v(" "), _c("g", {
    staticClass: "edit-grid ng-hide",
    attrs: {
      "ng-show": "pref.showGrid"
    }
  }, [_c("g", {
    staticClass: "hLines"
  }), _vm._v(" "), _c("g", {
    staticClass: "vLines"
  })])]);
};

var __vue_staticRenderFns__$4 = [];
__vue_render__$4._withStripped = true;
/* style */

var __vue_inject_styles__$4 = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-7720f22e_0", {
    source: "\nsvg[data-v-7720f22e] {\n  width: 50%;\n  height: 60%;\n}\n",
    map: {
      "version": 3,
      "sources": ["E:\\Octadesk\\octa-whatsapp-client\\src\\app\\multi-color-icons\\IconTick.vue"],
      "names": [],
      "mappings": ";AA2CA;EACA,UAAA;EACA,WAAA;AACA",
      "file": "IconTick.vue",
      "sourcesContent": ["<template>\r\n  <svg id=\"edit-svg\" mi-view-box=\"0 0 1024 1024\" viewBox=\"0 0 1024 1024\">\r\n    <rect\r\n      fill=\"white\"\r\n      x=\"0\"\r\n      y=\"0\"\r\n      mi-width=\"1024\"\r\n      mi-height=\"1024\"\r\n      width=\"1024\"\r\n      height=\"1024\"\r\n    ></rect>\r\n    <g>\r\n      <path\r\n        class=\"cursor-pointer\"\r\n        ng-repeat=\"path in icon.paths track by tempIds[$index]\"\r\n        mi-d=\"M302.080 414.72l-71.68 71.68 230.4 230.4 512-512-71.68-71.68-440.32 440.32-158.72-158.72zM921.6 512c0 225.28-184.32 409.6-409.6 409.6s-409.6-184.32-409.6-409.6c0-225.28 184.32-409.6 409.6-409.6 40.96 0 76.8 5.12 112.64 15.36l81.922-81.92c-61.442-20.48-128.002-35.84-194.562-35.84-281.6 0-512 230.4-512 512s230.4 512 512 512c281.6 0 512-230.4 512-512h-102.4z\"\r\n        mi-fill=\"rgb(77, 160, 148)\"\r\n        mi-stroke=\"inherit\"\r\n        mi-stroke-width=\"inherit\"\r\n        mi-stroke-linejoin=\"inherit\"\r\n        mi-stroke-linecap=\"inherit\"\r\n        mi-stroke-miterlimit=\"inherit\"\r\n        mi-opacity=\"1\"\r\n        ng-click=\"selectPath($index)\"\r\n        mi-absorb-clicks=\"\"\r\n        d=\"M302.080 414.72l-71.68 71.68 230.4 230.4 512-512-71.68-71.68-440.32 440.32-158.72-158.72zM921.6 512c0 225.28-184.32 409.6-409.6 409.6s-409.6-184.32-409.6-409.6c0-225.28 184.32-409.6 409.6-409.6 40.96 0 76.8 5.12 112.64 15.36l81.922-81.92c-61.442-20.48-128.002-35.84-194.562-35.84-281.6 0-512 230.4-512 512s230.4 512 512 512c281.6 0 512-230.4 512-512h-102.4z\"\r\n        fill=\"rgb(77, 160, 148)\"\r\n        stroke=\"inherit\"\r\n        stroke-width=\"inherit\"\r\n        stroke-linejoin=\"inherit\"\r\n        stroke-linecap=\"inherit\"\r\n        stroke-miterlimit=\"inherit\"\r\n        opacity=\"1\"\r\n      ></path>\r\n    </g>\r\n    <g ng-show=\"pref.showGrid\" class=\"edit-grid ng-hide\">\r\n      <g class=\"hLines\"></g>\r\n      <g class=\"vLines\"></g>\r\n    </g>\r\n  </svg>\r\n</template>\r\n\r\n<style scoped>\r\n  svg {\r\n    width: 50%;\r\n    height: 60%;\r\n  }\r\n</style>\r\n"]
    },
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$4 = "data-v-7720f22e";
/* module identifier */

var __vue_module_identifier__$4 = undefined;
/* functional template */

var __vue_is_functional_template__$4 = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$4 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$4, {}, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, false, createInjector, undefined, undefined);

/* script */

/* template */
var __vue_render__$5 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("span", [_c("svg", {
    attrs: {
      width: "100px",
      height: "39px",
      viewBox: "0 0 169 39",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c("title", [_vm._v("logo_octadesk branco")]), _vm._v(" "), _c("desc", [_vm._v("Created with Sketch.")]), _vm._v(" "), _c("g", {
    attrs: {
      id: "cadastro-numero-whatsapp",
      stroke: "none",
      "stroke-width": "1",
      fill: "none",
      "fill-rule": "evenodd"
    }
  }, [_c("g", {
    attrs: {
      id: "1.1",
      transform: "translate(-507.000000, -290.000000)"
    }
  }, [_c("image", {
    attrs: {
      id: "logo_octadesk-branco",
      x: "507",
      y: "290",
      width: "169",
      height: "39",
      "xlink:href": "data:image/png;base64,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"
    }
  })])])])]);
};

var __vue_staticRenderFns__$5 = [];
__vue_render__$5._withStripped = true;
/* style */

var __vue_inject_styles__$5 = undefined;
/* scoped */

var __vue_scope_id__$5 = undefined;
/* module identifier */

var __vue_module_identifier__$5 = undefined;
/* functional template */

var __vue_is_functional_template__$5 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$5 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5,
  staticRenderFns: __vue_staticRenderFns__$5
}, __vue_inject_styles__$5, {}, __vue_scope_id__$5, __vue_is_functional_template__$5, __vue_module_identifier__$5, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$4 = {
  props: {
    width: {
      type: String,
      required: false,
      default: '100px'
    },
    height: {
      type: String,
      required: false,
      default: '39px'
    }
  }
};

/* script */
var __vue_script__$4 = script$4;
/* template */

var __vue_render__$6 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("span", [_c("svg", {
    attrs: {
      width: "100px",
      height: "39px",
      viewBox: "0 0 168 39",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c("title", [_vm._v("whatsapp-white copy 3")]), _vm._v(" "), _c("desc", [_vm._v("Created with Sketch.")]), _vm._v(" "), _c("g", {
    attrs: {
      id: "cadastro-numero-whatsapp",
      stroke: "none",
      "stroke-width": "1",
      fill: "none",
      "fill-rule": "evenodd"
    }
  }, [_c("g", {
    attrs: {
      id: "1.1",
      transform: "translate(-507.000000, -350.000000)",
      fill: "#FFFFFF",
      "fill-rule": "nonzero"
    }
  }, [_c("g", {
    attrs: {
      id: "whatsapp-white-copy-3",
      transform: "translate(507.000000, 350.000000)"
    }
  }, [_c("path", {
    attrs: {
      d: "M0,39 C1.07512781,35.5814707 2.32117643,32.3303952 3.46084777,28.9754336 C-4.09164121,15.9664229 5.25461993,1.32083834 17.9141154,0.104517615 C29.8666202,-1.04440958 39.6667777,7.41127081 39.6964216,18.9511615 C39.7277355,31.1270235 27.7375803,41.3514161 14.2497762,37.1956781 C13.2329169,36.8825484 11.9737205,35.8610508 10.7892273,35.7918915 C9.13350655,35.6962457 6.96412693,36.8666564 5.29256913,37.3955043 C3.46054895,37.9764424 1.86757888,38.5579691 0,39 L0,39 Z M11.1965089,32.1832478 C22.0879301,38.6930504 35.1296069,31.3915946 36.2355124,20.7551891 C37.2371323,11.126155 29.4309514,2.55893689 18.9318712,3.31203748 C6.94679579,4.17167281 -0.253393102,18.2625115 7.12488812,28.5743097 C6.46313436,30.3617003 5.85212383,32.1669202 5.29256913,33.987864 C7.292522,33.4175205 9.13589705,32.6932608 11.1965089,32.1832478 L11.1965089,32.1832478 Z",
      id: "Shape"
    }
  }), _vm._v(" "), _c("path", {
    attrs: {
      d: "M14.4202849,9.69577206 C15.5631109,12.0700421 17.3310037,15.5814157 14.4202849,17.1581441 C15.8984472,20.2618656 18.3423779,22.4061097 21.5279235,23.8137972 C22.5875861,23.1175026 23.282999,22.0609228 24.1673925,21.1923308 C26.0166603,21.9105327 27.7449089,22.7483362 29.2442346,23.8137972 C29.3983403,27.2834287 26.4545349,28.5667779 23.9644023,28.452505 C18.7116949,28.2121176 11.4916815,21.621298 9.74972134,16.7549327 C8.71569332,13.867323 9.90472121,8.34462888 14.4202849,9.69577206 L14.4202849,9.69577206 Z",
      id: "Path"
    }
  }), _vm._v(" "), _c("g", {
    attrs: {
      id: "Group",
      transform: "translate(44.919704, 11.594595)"
    }
  }, [_c("path", {
    attrs: {
      d: "M4.44930112,17.3396746 L0.102416718,0.044561522 L3.8654645,0.044561522 L6.61078448,11.9247216 L9.93932781,0.044561522 L14.3110498,0.044561522 L17.503753,12.125394 L20.2984415,0.044561522 L23.9998553,0.044561522 L19.5775382,17.3396746 L15.6771171,17.3396746 L12.0508294,4.40955192 L8.4368071,17.3396746 L4.44930112,17.3396746 Z M29.0737757,0.044561522 L29.0737757,6.40346159 C30.200053,5.15282646 31.5458822,4.52780014 33.1109569,4.52780014 C33.9137322,4.52780014 34.6380085,4.668766 35.2850123,4.95186273 C35.9301763,5.23554196 36.4165024,5.59727667 36.7442973,6.03764936 C37.0703417,6.47689767 37.2986352,6.97469621 37.4152187,7.50060704 C37.5351138,8.03592781 37.5952146,8.86599538 37.5952146,9.99022724 L37.5952146,17.3399659 L34.1050736,17.3399659 L34.1050736,10.7212692 C34.1050736,9.40801494 34.0382268,8.57386984 33.9060663,8.22058144 C33.7786862,7.87259075 33.5316555,7.57547379 33.2047878,7.37711629 C32.8696336,7.16887127 32.4489278,7.06431188 31.9442035,7.06431188 C31.3646598,7.06431188 30.8476701,7.1982877 30.3920077,7.46536558 C29.9369585,7.73244346 29.6033376,8.13611842 29.3923714,8.67464296 C29.1810986,9.21375 29.0759222,10.0097411 29.0759222,11.0631988 L29.0759222,17.3396746 L25.5851679,17.3396746 L25.5851679,0.044561522 L29.0737757,0.044561522 Z M43.4881621,8.63328521 L40.3212165,8.09068314 C40.6775285,6.87965825 41.290189,5.98289403 42.1595045,5.40068172 C43.0288201,4.81846942 44.3206813,4.52809139 46.0350881,4.52809139 C47.5918835,4.52809139 48.7503576,4.70284246 49.5132702,5.05234459 C50.2743429,5.40272048 50.8109575,5.8471707 51.1215806,6.38569523 C51.4322038,6.92451102 51.5876687,7.91389331 51.5876687,9.3532596 L51.5499523,13.2225395 C51.5499523,14.3237624 51.6060669,15.1354812 51.7179893,15.6588606 C51.8296052,16.18224 52.0387315,16.742026 52.3450618,17.3396746 L48.8920239,17.3396746 C48.8003394,17.1197795 48.6887236,16.7932863 48.5565631,16.3610686 C48.4989154,16.1638912 48.457826,16.0342841 48.4326818,15.9713738 C47.8368864,16.5218396 47.1993883,16.9348346 46.5201876,17.2100676 C45.8406803,17.4855917 45.1167106,17.6227713 44.3458255,17.6227713 C42.9877308,17.6227713 41.917568,17.2732692 41.1353374,16.5730999 C40.3524934,15.8732219 39.9615314,14.988399 39.9615314,13.9186312 C39.9615314,13.2105982 40.1393808,12.5791643 40.4953862,12.0249122 C40.8516983,11.4703688 41.3499832,11.0457237 41.9920808,10.7506856 C42.6335652,10.4556476 43.5586886,10.1984723 44.7680645,9.97828592 C46.3996793,9.68703414 47.5299428,9.41558748 48.1591617,9.16394595 L48.1591617,8.83424893 C48.1591617,8.19699004 47.9935778,7.74234602 47.66241,7.47119061 C47.3309355,7.19974395 46.7057029,7.06402063 45.7870188,7.06402063 C45.1663858,7.06402063 44.6818995,7.18023009 44.33356,7.41235775 C43.9858338,7.64419417 43.7040345,8.05136415 43.4881621,8.63328521 L43.4881621,8.63328521 Z M48.1591617,11.3229954 C47.7120852,11.4642525 47.0034473,11.6331785 46.0347814,11.8306472 C45.0658089,12.0272422 44.4326037,12.2197596 44.1348593,12.4084908 C43.6795036,12.7151789 43.4513657,13.1045825 43.4513657,13.5764104 C43.4513657,14.0406657 43.6338147,14.4417194 43.9980993,14.7798627 C44.3623839,15.1182973 44.8254056,15.2878058 45.3893108,15.2878058 C46.0179164,15.2878058 46.618618,15.0906284 47.1895759,14.698021 C47.6121215,14.3991967 47.8896279,14.0333844 48.022095,13.6008755 C48.1134728,13.3174876 48.1588551,12.7795455 48.1588551,11.9847194 L48.1591617,11.3229954 L48.1591617,11.3229954 Z M60.8217317,4.81089687 L60.8217317,7.45400676 L58.4376299,7.45400676 L58.4376299,12.5028563 C58.4376299,13.5260238 58.4600144,14.1216337 58.5066232,14.2905597 C58.5513922,14.4600683 58.6547288,14.5995779 58.8169397,14.7096711 C58.9782307,14.8191817 59.1750916,14.8745196 59.4066025,14.8745196 C59.7297977,14.8745196 60.197419,14.7682127 60.8100795,14.5564726 L61.1081305,17.1276433 C60.2967693,17.4582141 59.377472,17.6233538 58.351465,17.6233538 C57.7213262,17.6233538 57.1546612,17.522872 56.649017,17.322782 C56.1442927,17.1224008 55.7738754,16.8626042 55.5374583,16.5445573 C55.3010413,16.2253453 55.1376038,15.7954577 55.0468393,15.2522731 C54.9720199,14.866947 54.9349168,14.088431 54.9349168,12.9161426 L54.9349168,7.45400676 L53.3327392,7.45400676 L53.3327392,4.81060562 L54.9349168,4.81060562 L54.9349168,2.32127667 L58.4376299,0.38649111 L58.4376299,4.81031437 L60.8217317,4.81031437 L60.8217317,4.81089687 L60.8217317,4.81089687 Z M61.7597339,13.7654328 L65.2630602,13.2580722 C65.4117791,13.9026124 65.7147363,14.3922066 66.1691722,14.7262724 C66.624528,15.0606294 67.262026,15.2280992 68.0819731,15.2280992 C68.984712,15.2280992 69.6639127,15.070532 70.1192685,14.7556888 C70.426212,14.5355025 70.5792238,14.2404644 70.5792238,13.8711572 C70.5792238,13.6192244 70.4961252,13.4109794 70.3305413,13.2458396 C70.1569848,13.0882724 69.7669427,12.9426465 69.1622548,12.8089619 C66.346715,12.2191771 64.562395,11.6809438 63.8089881,11.1928058 C62.7655028,10.5171017 62.2439135,9.57664972 62.2439135,8.37348862 C62.2439135,7.28770199 62.695283,6.37521017 63.5974087,5.63630441 C64.499841,4.8971074 65.8996384,4.52721764 67.7958808,4.52721764 C69.6007455,4.52721764 70.9425885,4.80652809 71.8198766,5.36485775 C72.6968581,5.92318741 73.3021593,6.74917745 73.6333271,7.84195413 L70.3421935,8.4200889 C70.2011405,7.93282468 69.9340598,7.5588574 69.5409513,7.29964331 C69.1481495,7.04013798 68.587004,6.90994844 67.8584348,6.90994844 C66.9391374,6.90994844 66.280788,7.03198293 65.8839999,7.27576067 C65.618759,7.44876422 65.4862919,7.67302809 65.4862919,7.94826102 C65.4862919,8.18446622 65.6015873,8.38484744 65.8337115,8.54940469 C66.1483209,8.76988229 67.235042,9.08064794 69.094488,9.48228414 C70.9533208,9.88333784 72.2513147,10.3746796 72.9884698,10.9566006 C73.717039,11.5460942 74.0813236,12.3685893 74.0813236,13.4220469 C74.0813236,14.570744 73.5765993,15.5577962 72.5659241,16.3832038 C71.5555556,17.2091938 70.0613141,17.6218976 68.0819731,17.6218976 C66.2860008,17.6218976 64.8628991,17.2758905 63.8154275,16.5841675 C62.7682626,15.8927358 62.0832358,14.9531575 61.7597339,13.7654328 L61.7597339,13.7654328 Z M93.3280006,17.3396746 L89.3285358,17.3396746 L87.7386236,13.4112706 L80.4605972,13.4112706 L78.9571566,17.3396746 L75.0570421,17.3396746 L82.1495532,0.044561522 L86.0370955,0.044561522 L93.3280006,17.3396746 L93.3280006,17.3396746 Z M86.5580716,10.4975878 L84.0491686,4.0792724 L81.5896342,10.4975878 L86.5580716,10.4975878 L86.5580716,10.4975878 Z M94.8995146,4.81089687 L98.1538518,4.81089687 L98.1538518,6.65160811 C98.5757842,6.02221302 99.1470487,5.5113574 99.8676453,5.11787624 C100.588242,4.7249776 101.387031,4.52838265 102.264932,4.52838265 C103.796584,4.52838265 105.096111,5.09865363 106.165047,6.23948684 C107.233063,7.37973755 107.767531,8.96880725 107.767531,11.0052397 C107.767531,13.0975925 107.229077,14.7233599 106.152781,15.883707 C105.076179,17.0434716 103.771746,17.6233538 102.240095,17.6233538 C101.511219,17.6233538 100.85103,17.4864655 100.258607,17.2106501 C99.6658783,16.9357084 99.0430988,16.4641718 98.388429,15.7951664 L98.388429,22.1065925 L94.8982881,22.1065925 L94.8982881,4.81089687 L94.8995146,4.81089687 L94.8995146,4.81089687 Z M98.3519392,10.8631088 C98.3519392,12.2710199 98.6463106,13.3113713 99.2341335,13.9838716 C99.8216498,14.6566632 100.537954,14.993059 101.383351,14.993059 C102.194713,14.993059 102.869314,14.6840409 103.407768,14.0662959 C103.945916,13.4491334 104.21545,12.4364509 104.21545,11.0285398 C104.21545,9.71557681 103.938557,8.73959211 103.382931,8.10291572 C102.828224,7.46565683 102.140745,7.14731863 101.320798,7.14731863 C100.468347,7.14731863 99.7597091,7.45983179 99.1964172,8.08514936 C98.6337385,8.71017568 98.3519392,9.63635633 98.3519392,10.8631088 L98.3519392,10.8631088 Z M110.183217,4.81089687 L113.43786,4.81089687 L113.43786,6.65160811 C113.859793,6.02221302 114.431057,5.5113574 115.151654,5.11787624 C115.872557,4.7249776 116.67104,4.52838265 117.548941,4.52838265 C119.080899,4.52838265 120.380119,5.09865363 121.449362,6.23948684 C122.517072,7.37973755 123.05154,8.96880725 123.05154,11.0052397 C123.05154,13.0975925 122.513086,14.7233599 121.43679,15.883707 C120.360495,17.0434716 119.056061,17.6233538 117.524103,17.6233538 C116.795534,17.6233538 116.134732,17.4864655 115.542923,17.2106501 C114.949887,16.9357084 114.327414,16.4641718 113.672744,15.7951664 L113.672744,22.1065925 L110.182603,22.1065925 L110.183217,4.81089687 L110.183217,4.81089687 Z M113.636561,10.8631088 C113.636561,12.2710199 113.930319,13.3113713 114.518755,13.9838716 C115.106578,14.6566632 115.822269,14.993059 116.667053,14.993059 C117.478415,14.993059 118.153936,14.6840409 118.691777,14.0662959 C119.230231,13.4491334 119.499152,12.4364509 119.499152,11.0285398 C119.499152,9.71557681 119.222259,8.73959211 118.666939,8.10291572 C118.112233,7.46565683 117.424753,7.14731863 116.605113,7.14731863 C115.752356,7.14731863 115.044024,7.45983179 114.481039,8.08514936 C113.918054,8.71046693 113.636561,9.63635633 113.636561,10.8631088 L113.636561,10.8631088 Z",
      id: "Shape"
    }
  })])])])])])]);
};

var __vue_staticRenderFns__$6 = [];
__vue_render__$6._withStripped = true;
/* style */

var __vue_inject_styles__$6 = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-0a47321a_0", {
    source: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n",
    map: {
      "version": 3,
      "sources": [],
      "names": [],
      "mappings": "",
      "file": "LogoWhatsapp.vue"
    },
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$6 = undefined;
/* module identifier */

var __vue_module_identifier__$6 = undefined;
/* functional template */

var __vue_is_functional_template__$6 = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$6 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6,
  staticRenderFns: __vue_staticRenderFns__$6
}, __vue_inject_styles__$6, __vue_script__$4, __vue_scope_id__$6, __vue_is_functional_template__$6, __vue_module_identifier__$6, false, createInjector, undefined, undefined);

/* script */

/* template */
var __vue_render__$7 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("span", [_c("svg", {
    attrs: {
      width: "54",
      height: "95",
      xmlns: "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c("defs", [_c("path", {
    attrs: {
      id: "a",
      d: "M0 .33266334h53.669825V94.8850575H0z"
    }
  })]), _vm._v(" "), _c("g", {
    attrs: {
      fill: "none",
      "fill-rule": "evenodd"
    }
  }, [_c("g", [_c("mask", {
    attrs: {
      id: "b",
      fill: "#fff"
    }
  }, [_c("use", {
    attrs: {
      "xlink:href": "#a"
    }
  })]), _vm._v(" "), _c("path", {
    attrs: {
      d: "M15.392575.65895046C14.81645 1.3245873 6.0082 6.23973873 6.0082 6.23973873S4.609825 7.64605291 2.63395 14.469178C.658075 21.2895238-.00055 27.9458923-.00055 27.3622441c0-.5822585 3.86925-5.0749598 3.86925-5.0749598s-1.728375 8.4031441-1.810875 16.0558834c-.0825 7.6541289.98725 14.6412314.90475 13.7268492-.0825-.9143821 2.4695-7.403994 2.4695-7.403994s.823625 9.1507696 3.95175 17.4705354c3.128125 8.3197658 5.432625 12.6457105 5.267625 11.4811934-.163625-1.1645171 2.140875-9.1521592 2.140875-9.1521592s1.31725 11.4811934 5.92625 21.6297234c1.703625 3.7534137 3.070375 6.6396929 4.11675 8.7908533 1.046375-2.1511604 2.41175-5.0374396 4.11675-8.7908533 4.609-10.14853 5.92625-21.6297234 5.92625-21.6297234s2.3045 7.9876421 2.140875 9.1521592c-.165 1.1645171 2.1395-3.1614276 5.267625-11.4811934s3.95175-17.4705354 3.95175-17.4705354 2.552 6.4896119 2.4695 7.403994c-.0825.9143822.98725-6.0727203.90475-13.7268492-.0825-7.6527393-1.810875-16.0558834-1.810875-16.0558834s3.867875 4.4927013 3.867875 5.0749598c0 .5836482-.65725-6.0727203-2.633125-12.8930661-1.975875-6.82312509-3.37425-8.22943927-3.37425-8.22943927S38.8542 1.32458731 38.278075.65895046L26.835325.3323854l-11.44275.32656505z",
      fill: "#F9B059",
      mask: "url(#b)"
    }
  })]), _vm._v(" "), _c("path", {
    attrs: {
      d: "M6.50399379 13.2906153l3.33749119-3.74229654L7.00724432 23.3718758c-.59726437 2.9172778-1.0880719 6.0473744-1.39499942 9.15536l1.54016785-3.9288586 1.4876307 15.9116701c.49219009 5.2651957 1.87751165 11.4742572 3.74119765 16.3787663.1894103.4974988.3815856.9963795.5751435 1.4938783l4.961995-16.899758 2.1360496 18.636858c.7548758 6.5006511 2.9337848 14.4716875 5.6366826 20.3601386.2281218.4961169.4562436.9908518.6857479 1.4855867.2295044-.4947349.4590088-.9894698.685748-1.4855867 2.7042804-5.8884511 4.8831893-13.8581056 5.6380651-20.3587566l2.1360497-18.63824 4.9619949 16.899758c.1935579-.4974988.3843507-.9963795.573761-1.4938783 1.8650686-4.9045091 3.2503901-11.1135706 3.7411976-16.3787663l1.4876307-15.9116701 1.5415504 3.9288586c-.30831-3.1079856-.797735-6.2380822-1.3963819-9.15536L42.9122345 9.54831876l3.3388738 3.74229654c-.4562437-1.3570662-1.0078837-2.8260696-1.5360202-3.73953266-1.3645832-.7559218-2.7250187-1.52428106-4.079924-2.29955003-.9249303-.52928346-2.6821595-1.47729507-4.042595-2.38799427l-10.2157094-.2888257-10.2157093.2888257c-1.359053.9106992-3.1176648 1.85871081-4.042595 2.38799427-1.3535227.77526897-2.71395825 1.54362823-4.07992399 2.29955003-.52675399.91346306-1.07977656 2.38246646-1.53463762 3.73953266",
      fill: "#F7CE78"
    }
  }), _vm._v(" "), _c("path", {
    attrs: {
      d: "M26.3551642 72.5862069c.8451015-3.1111263 1.4719317-6.2650409 1.8077336-9.1594649l4.758593-40.9857067 6.6894539 22.4818209 1.9196675-20.2775314-2.7829583-13.3968906c-.0867488-.0483094-.1720985-.0966188-.2588473-.1463085-1.0717678-.6059381-2.1477331-1.18841161-3.1985132-1.81919453l-8.9351292-.24844841-8.93373.24844841c-1.0507801.63078292-2.1267454 1.21325643-3.1985132 1.81919453-.0867488.0496897-.1734976.0979991-.2602465.1463085L11.2748601 24.189836c-.0153909.2553498-.0377777.6625291-.0503703.9178789l1.874894 19.8151413 6.6894539-22.4832012 4.7585929 40.9857067c.3358019 2.8944241.9640313 6.0483387 1.8077336 9.1608452",
      fill: "#F6F0EB"
    }
  })])])]);
};

var __vue_staticRenderFns__$7 = [];
__vue_render__$7._withStripped = true;
/* style */

var __vue_inject_styles__$7 = undefined;
/* scoped */

var __vue_scope_id__$7 = undefined;
/* module identifier */

var __vue_module_identifier__$7 = undefined;
/* functional template */

var __vue_is_functional_template__$7 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$7 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7,
  staticRenderFns: __vue_staticRenderFns__$7
}, __vue_inject_styles__$7, {}, __vue_scope_id__$7, __vue_is_functional_template__$7, __vue_module_identifier__$7, false, undefined, undefined, undefined);

/* script */

/* template */
var __vue_render__$8 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("span", [_c("svg", {
    attrs: {
      width: "127px",
      height: "191px",
      viewBox: "0 0 127 191",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c("title", [_vm._v("foguete")]), _vm._v(" "), _c("desc", [_vm._v("Created with Sketch.")]), _vm._v(" "), _c("defs", [_c("path", {
    attrs: {
      d: "M1.72128659,7.89432558 C-1.21916542,14.1395349 1.24864602,21.6905426 7.23415861,24.7595659 L7.23415861,24.7595659 C13.2215732,27.8295814 20.4576338,25.2527132 23.3990368,19.0065116 L23.3990368,19.0065116 C26.3413907,12.7613023 23.8707263,5.21128682 17.8861647,2.14226357 L17.8861647,2.14226357 C16.172486,1.26313178 14.3570517,0.847379845 12.5691961,0.847379845 L12.5691961,0.847379845 C8.10906671,0.847379845 3.82106603,3.43615504 1.72128659,7.89432558",
      id: "path-1"
    }
  })]), _vm._v(" "), _c("g", {
    attrs: {
      id: "Page-1",
      stroke: "none",
      "stroke-width": "1",
      fill: "none",
      "fill-rule": "evenodd"
    }
  }, [_c("g", {
    attrs: {
      id: "1.1",
      transform: "translate(-524.000000, -513.000000)"
    }
  }, [_c("g", {
    attrs: {
      id: "foguete",
      transform: "translate(524.000000, 513.000000)"
    }
  }, [_c("g", {
    attrs: {
      id: "Group-19"
    }
  }, [_c("path", {
    attrs: {
      d: "M22.5274,117.273656 L4.5174,135.190602 C4.5174,135.190602 2.4684,132.980631 0.6974,134.276062 C-4.8676,138.343253 24.7104,190.952425 24.7104,190.952425 L18.8514,171.024496 C18.8514,171.024496 19.4344,152.010101 37.0814,150.73075 L22.5274,117.273656 Z",
      id: "Fill-1",
      fill: "#EAA607"
    }
  }), _vm._v(" "), _c("path", {
    attrs: {
      d: "M104.463,117.273656 L122.474,135.190602 C122.474,135.190602 124.521,132.980631 126.293,134.276062 C131.858,138.343253 102.28,190.952425 102.28,190.952425 L108.138,171.024496 C108.138,171.024496 107.556,152.010101 89.909,150.73075 L104.463,117.273656 Z",
      id: "Fill-3",
      fill: "#EAA607"
    }
  }), _vm._v(" "), _c("polygon", {
    attrs: {
      id: "Fill-5",
      fill: "#CACAC9",
      points: "79.9503 169.565553 47.0403 169.565553 44.1293 160.626174 82.8603 160.626174"
    }
  }), _vm._v(" "), _c("path", {
    attrs: {
      d: "M85.8224,161.546242 C99.3784,146.644263 108.5164,118.61612 108.5164,86.4715423 C108.5164,38.7134528 82.5054,0.000265702772 63.4954,0.000265702772 C44.4864,0.000265702772 18.4734,38.7134528 18.4734,86.4715423 C18.4734,118.61612 27.6124,146.644263 41.1674,161.546242 L85.8224,161.546242 Z",
      id: "Fill-7",
      fill: "#E4E4E4"
    }
  }), _vm._v(" "), _c("path", {
    attrs: {
      d: "M63.4957,0.000265702772 C56.4317,0.000265702772 48.4017,5.35384291 41.0977,14.5233639 C41.0977,14.5233639 37.3337,17.4488874 63.4957,17.4488874 C89.6567,17.4488874 85.8927,14.5233639 85.8927,14.5233639 C78.5887,5.35384291 70.5587,0.000265702772 63.4957,0.000265702772 Z",
      id: "Fill-9",
      fill: "#F3A43A"
    }
  }), _vm._v(" "), _c("path", {
    attrs: {
      d: "M18.8809,76.3194434 C18.6229,79.6509824 18.4739,83.0347809 18.4739,86.4718438 C18.4739,91.1088637 18.6859,95.6473948 19.0509,100.087437 C19.0509,100.087437 19.8179,104.540544 63.4949,104.540544 C107.1709,104.540544 107.9399,100.087437 107.9399,100.087437 C108.3049,95.6473948 108.5169,91.1088637 108.5169,86.4718438 C108.5169,83.0347809 108.3659,79.6509824 108.1109,76.3194434 C108.1109,76.3194434 108.4559,80.7735553 63.4949,80.7735553 C18.5329,80.7735553 18.8809,76.3194434 18.8809,76.3194434",
      id: "Fill-11",
      fill: "#F3A43A"
    }
  }), _vm._v(" "), _c("path", {
    attrs: {
      d: "M67.1768,151.325603 C67.1768,173.161002 63.4948,190.861876 63.4948,190.861876 C63.4948,190.861876 59.8148,173.161002 59.8148,151.325603 C59.8148,129.489198 61.4608,111.788325 63.4948,111.788325 C65.5298,111.788325 67.1768,129.489198 67.1768,151.325603",
      id: "Fill-13",
      fill: "#F3A43A"
    }
  }), _vm._v(" "), _c("path", {
    attrs: {
      d: "M80.5597,47.7979518 C80.5597,57.2699745 72.9187,64.9480916 63.4957,64.9480916 C54.0707,64.9480916 46.4297,57.2699745 46.4297,47.7979518 C46.4297,38.325929 54.0707,30.6488169 63.4957,30.6488169 C72.9187,30.6488169 80.5597,38.325929 80.5597,47.7979518",
      id: "Fill-15",
      fill: "#CACAC9"
    }
  }), _vm._v(" "), _c("path", {
    attrs: {
      d: "M74.8917,53.425489 C71.7987,59.7508907 64.1897,62.3618525 57.8957,59.2524161 C51.6007,56.1439847 49.0057,48.4960172 52.0977,42.1706155 C55.1907,35.8442088 62.7997,33.235257 69.0947,36.3436884 C75.3897,39.4531248 77.9857,47.1000873 74.8917,53.425489",
      id: "Fill-17",
      fill: "#FFFFFF"
    }
  })]), _vm._v(" "), _c("g", {
    attrs: {
      id: "Group-22",
      transform: "translate(51.699115, 33.604651)"
    }
  }, [_c("mask", {
    attrs: {
      id: "mask-2",
      fill: "white"
    }
  }, [_c("use", {
    attrs: {
      "xlink:href": "#path-1"
    }
  })]), _vm._v(" "), _c("g", {
    attrs: {
      id: "Clip-21"
    }
  }), _vm._v(" "), _c("path", {
    attrs: {
      d: "M14.9549373,19.3004155 C14.2607167,19.3004155 13.6986834,18.4351752 13.6986834,17.3675163 C13.6986834,16.3008496 14.2607167,15.4346171 14.9549373,15.4346171 C15.6482069,15.4346171 16.2092892,16.3008496 16.2092892,17.3675163 C16.2092892,18.4351752 15.6482069,19.3004155 14.9549373,19.3004155 M10.7287508,19.3004155 C10.0345302,19.3004155 9.47344786,18.4351752 9.47344786,17.3675163 C9.47344786,16.3008496 10.0345302,15.4346171 10.7287508,15.4346171 C11.4220204,15.4346171 11.9840537,16.3008496 11.9840537,17.3675163 C11.9840537,18.4351752 11.4220204,19.3004155 10.7287508,19.3004155 M27.5317413,27.250307 C27.0067964,26.9188961 25.5651,27.4457798 23.1220142,26.5666481 C20.9271361,25.7788031 19.2619577,23.4668651 18.9994853,21.1360744 C18.8653961,19.9562915 19.3104581,18.8003225 19.6147739,18.1513922 C20.3708086,16.5409736 21.4596888,15.2054078 21.4596888,12.3517023 C21.4596888,7.91536124 18.4536187,3.81340775 12.8589618,3.81340775 C7.3527467,3.81340775 4.25918577,7.91536124 4.25918577,12.3517023 C4.25918577,15.2093767 5.36613472,16.5379969 6.10695364,18.158338 C6.40366161,18.8052837 6.81543901,19.9602605 6.68420279,21.1360744 C6.42077937,23.4668651 5.73892165,25.5912682 3.47842539,26.1330357 C-0.0925310415,26.9873612 -0.610818993,22.2930357 -1.13386188,22.6244465 C-1.26224513,22.7038264 -1.43912873,22.9181519 -1.60460048,23.2346791 C-2.1247904,24.2338729 -2.51849905,26.2600434 -0.816232199,28.3755163 C1.04580048,30.6874543 6.07937502,30.6576868 8.3379693,26.9546171 C8.3379693,26.9546171 7.47447304,29.4362295 5.35472287,30.9970357 C2.95443152,32.7672062 2.0148563,32.5012837 1.69342267,33.1085395 C1.25882158,33.9281364 3.55640633,35.1992062 6.13072832,34.7953612 C11.5427957,33.9479814 12.7990496,29.1197023 12.7990496,29.1197023 L12.8827365,29.1197023 C12.8827365,29.1197023 14.1408924,33.9479814 19.5529598,34.7953612 C22.1263308,35.1992062 24.4239155,33.9281364 23.9893144,33.1085395 C23.6688318,32.5012837 22.7292566,32.7672062 20.3280142,30.9970357 C18.2082641,29.4362295 17.3447678,26.9546171 17.3447678,26.9546171 C19.6033621,30.6576868 23.284633,30.5286946 25.2541272,29.9254078 C27.5754867,29.2149581 28.0595391,27.5827101 27.5317413,27.250307",
      id: "Fill-20",
      fill: "#3B8DC6",
      mask: "url(#mask-2)"
    }
  })])])])])])]);
};

var __vue_staticRenderFns__$8 = [];
__vue_render__$8._withStripped = true;
/* style */

var __vue_inject_styles__$8 = undefined;
/* scoped */

var __vue_scope_id__$8 = undefined;
/* module identifier */

var __vue_module_identifier__$8 = undefined;
/* functional template */

var __vue_is_functional_template__$8 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$8 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8,
  staticRenderFns: __vue_staticRenderFns__$8
}, __vue_inject_styles__$8, {}, __vue_scope_id__$8, __vue_is_functional_template__$8, __vue_module_identifier__$8, false, undefined, undefined, undefined);

//
//
//
//
//
var script$5 = {};

/* script */
var __vue_script__$5 = script$5;
/* template */

var __vue_render__$9 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm._m(0);
};

var __vue_staticRenderFns__$9 = [function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("span", {
    staticClass: "icon-wp-whatsapp"
  }, [_c("span", {
    staticClass: "path1"
  }), _c("span", {
    staticClass: "path2"
  })]);
}];
__vue_render__$9._withStripped = true;
/* style */

var __vue_inject_styles__$9 = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-46f769ac_0", {
    source: "\n\n/*# sourceMappingURL=IconWhatsApp.vue.map */",
    map: {
      "version": 3,
      "sources": ["IconWhatsApp.vue"],
      "names": [],
      "mappings": ";;AAEA,2CAA2C",
      "file": "IconWhatsApp.vue"
    },
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$9 = "data-v-46f769ac";
/* module identifier */

var __vue_module_identifier__$9 = undefined;
/* functional template */

var __vue_is_functional_template__$9 = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$9 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9,
  staticRenderFns: __vue_staticRenderFns__$9
}, __vue_inject_styles__$9, __vue_script__$5, __vue_scope_id__$9, __vue_is_functional_template__$9, __vue_module_identifier__$9, false, createInjector, undefined, undefined);

//
var script$6 = {
  i18n: i18n,
  props: ['showQrcode', 'success'],
  components: {
    RocketIcon: __vue_component__$8,
    RocketFire: __vue_component__$7,
    LogoOcta: __vue_component__$5,
    LogoWhatsapp: __vue_component__$6
  },
  data: function data() {
    return {
      bgNight: img
    };
  }
};

const img$1 = "data:image/png;base64,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";

const img$2 = "data:image/png;base64,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";

/* script */
var __vue_script__$6 = script$6;

var __vue_render__$a = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    staticClass: "modal-animation-container text-center",
    class: {
      "bg-night": _vm.showQrcode && _vm.success,
      "bg-dayli": !_vm.success
    },
    style: _vm.showQrcode && _vm.success ? "background: url(" + _vm.bgNight + ")" : ""
  }, [_c("img", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showQrcode && !_vm.success,
      expression: "showQrcode && !success"
    }],
    staticClass: "clouds-animation",
    attrs: {
      src: img$1,
      alt: "clouds"
    }
  }), _vm._v(" "), !_vm.showQrcode ? _c("div", {
    staticClass: "container-logo-octa-wpp"
  }, [_c("LogoOcta"), _vm._v(" "), _c("LogoWhatsapp")], 1) : _vm._e(), _vm._v(" "), _vm.showQrcode && !_vm.success ? _c("div", {
    staticStyle: {
      position: "absolute",
      bottom: "50px",
      "text-align": "center",
      width: "100%",
      display: "flex",
      "flex-direction": "column",
      "justify-content": "center"
    }
  }, [_c("p", {
    staticClass: "we-are-octa"
  }, [_vm._v(_vm._s(_vm.$t("modal.animation.title")))]), _vm._v(" "), _c("span", {
    staticStyle: {
      "font-style": "normal",
      "font-weight": "normal",
      "font-size": "16px",
      "line-height": "22px",
      color: "#fff"
    },
    domProps: {
      innerHTML: _vm._s(_vm.$t("modal.animation.description"))
    }
  }), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showQrcode,
      expression: "showQrcode"
    }],
    staticClass: "container-logo-octa-wpp show-qrcode"
  }, [_c("LogoOcta"), _vm._v(" "), _c("LogoWhatsapp")], 1), _vm._v(" "), _c("div", {
    staticClass: "cloud-container"
  }, [_c("img", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.showQrcode && !_vm.success,
      expression: "!showQrcode && !success"
    }],
    staticClass: "cloud-icon cloud-animation-1",
    attrs: {
      src: img$2,
      alt: "nuvem-icon"
    }
  }), _vm._v(" "), _c("img", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.showQrcode && !_vm.success,
      expression: "!showQrcode && !success"
    }],
    staticClass: "cloud-icon cloud-animation-2",
    attrs: {
      src: img$2,
      alt: "nuvem-icon"
    }
  })]), _vm._v(" "), _c("RocketIcon", {
    staticClass: "rocket",
    class: {
      "position-1": !_vm.showQrcode && !_vm.success,
      "position-2": _vm.showQrcode
    }
  }), _vm._v(" "), _c("RocketFire", {
    staticClass: "rocket-fire",
    class: {
      "position-1": !_vm.showQrcode && !_vm.success,
      "position-2": _vm.showQrcode
    }
  })], 1);
};

var __vue_staticRenderFns__$a = [function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    staticClass: "wpp-divider divider-white"
  }, [_c("span")]);
}];
__vue_render__$a._withStripped = true;
/* style */

var __vue_inject_styles__$a = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-4a52b725_0", {
    source: "@import url(\"https://fonts.googleapis.com/css?family=Gloria+Hallelujah&display=swap\");\n@keyframes space-move-data-v-4a52b725 {\n0% {\n    transform: translateY(0);\n}\n100% {\n    transform: translateY(100%);\n}\n}\n@keyframes clouds-moving-data-v-4a52b725 {\n0% {\n    transform: translateY(0);\n    opacity: 0.7;\n}\n100% {\n    transform: translateY(350%);\n    opacity: 0;\n}\n}\n@keyframes bg-move-data-v-4a52b725 {\n0% {\n    background-position: 25% 100%;\n}\n100% {\n    background-position: 25% 0%;\n}\n}\n@keyframes rocket-fire-data-v-4a52b725 {\nfrom {\n    transform: scale(1);\n}\nto {\n    transform: scale(1.2);\n}\n}\n@keyframes cloud-moving-1-data-v-4a52b725 {\nfrom {\n    height: 134px;\n}\nto {\n    height: 144px;\n}\n}\n@keyframes cloud-moving-2-data-v-4a52b725 {\nfrom {\n    bottom: 15px;\n}\nto {\n    bottom: 30px;\n}\n}\ndiv.modal-animation-container[data-v-4a52b725] {\n  width: 350px;\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  height: 100%;\n  min-height: 520px;\n  overflow: hidden;\n  transition: all 2s;\n}\ndiv.modal-animation-container div.container-logo-octa-wpp[data-v-4a52b725] {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 120px;\n}\ndiv.modal-animation-container div.container-logo-octa-wpp span[data-v-4a52b725] {\n  margin: 0px 10px;\n}\ndiv.modal-animation-container div.container-logo-octa-wpp span[data-v-4a52b725]:last-child {\n  margin-top: -5px;\n}\ndiv.modal-animation-container div.container-logo-octa-wpp.show-qrcode[data-v-4a52b725] {\n  position: absolute;\n  width: 100%;\n  bottom: 25px;\n}\ndiv.modal-animation-container img.clouds-animation[data-v-4a52b725] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  animation: clouds-moving-data-v-4a52b725 5s linear 0s infinite;\n  transition: transform 2s;\n}\ndiv.modal-animation-container p.we-are-octa[data-v-4a52b725] {\n  font-family: \"Gloria Hallelujah\";\n  color: #fff;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 30px;\n  line-height: 33px;\n}\ndiv.modal-animation-container div.cloud-container[data-v-4a52b725] {\n  position: absolute;\n  bottom: 0px;\n  left: -1px;\n  border: none;\n  margin: 0;\n  transition: all 1s;\n}\ndiv.modal-animation-container div.cloud-container img.cloud-icon[data-v-4a52b725] {\n  width: calc(100% + 1px);\n  height: 134px;\n  bottom: -1px;\n  left: -1px;\n  border: none;\n  margin: 0;\n  z-index: 0;\n  position: relative;\n}\ndiv.modal-animation-container div.cloud-container img.cloud-icon.cloud-animation-1[data-v-4a52b725] {\n  animation: cloud-moving-1-data-v-4a52b725 2s linear 0s infinite alternate;\n}\ndiv.modal-animation-container div.cloud-container img.cloud-icon.cloud-animation-2[data-v-4a52b725] {\n  opacity: 0.7;\n  position: absolute;\n  width: calc(100% + 1px);\n  height: 134px;\n  bottom: 15px;\n  left: -1px;\n  border: none;\n  margin: 0;\n  z-index: 0;\n  animation: cloud-moving-2-data-v-4a52b725 2s linear 0s infinite alternate;\n}\ndiv.modal-animation-container span.rocket[data-v-4a52b725] {\n  font-size: 80px;\n  position: absolute;\n  left: calc(50% - 63px);\n  z-index: 3;\n  transition: all 1s;\n}\ndiv.modal-animation-container span.rocket.position-1[data-v-4a52b725] {\n  bottom: 0;\n}\ndiv.modal-animation-container span.rocket.position-2[data-v-4a52b725] {\n  bottom: 260px;\n}\ndiv.modal-animation-container span.rocket-fire[data-v-4a52b725] {\n  font-size: 60px;\n  position: absolute;\n  left: calc(50% - 25px);\n  z-index: 2;\n  transition: all 1s;\n  bottom: 25px;\n  animation: rocket-fire-data-v-4a52b725 1s linear 0s infinite alternate;\n}\ndiv.modal-animation-container span.rocket-fire.position-1[data-v-4a52b725] {\n  bottom: 0px;\n}\ndiv.modal-animation-container span.rocket-fire.position-2[data-v-4a52b725] {\n  bottom: 210px;\n}\ndiv.modal-animation-container.bg-night[data-v-4a52b725] {\n  background-size: 700%;\n  animation: bg-move-data-v-4a52b725 10s infinite linear;\n  top: 0 !important;\n}\ndiv.modal-animation-container.bg-dayli[data-v-4a52b725] {\n  background: linear-gradient(to bottom, #00558d 0%, #008ac0 100%);\n}\n@media screen and (max-width: 520px) {\ndiv.modal-animation-container .modal-animation-container[data-v-4a52b725] {\n    display: none;\n}\n}\n@media screen and (max-height: 520px) {\ndiv.modal-animation-container .modal-animation-container[data-v-4a52b725] {\n    display: none;\n}\n}\n\n/*# sourceMappingURL=Animation.vue.map */",
    map: {
      "version": 3,
      "sources": ["E:\\Octadesk\\octa-whatsapp-client\\src\\app\\modal\\components\\Animation.vue", "Animation.vue"],
      "names": [],
      "mappings": "AAuHA,qFAAA;AAEA;AACA;IACA,wBAAA;ACvHE;ADyHF;IACA,2BAAA;ACvHE;AACF;ADyHA;AACA;IACA,wBAAA;IACA,YAAA;ACvHE;ADyHF;IACA,2BAAA;IACA,UAAA;ACvHE;AACF;ADyHA;AACA;IACA,6BAAA;ACvHE;ADyHF;IACA,2BAAA;ACvHE;AACF;ADyHA;AACA;IACA,mBAAA;ACvHE;ADyHF;IACA,qBAAA;ACvHE;AACF;ADyHA;AACA;IACA,aAAA;ACvHE;ADyHF;IACA,aAAA;ACvHE;AACF;ADyHA;AACA;IACA,YAAA;ACvHE;ADyHF;IACA,YAAA;ACvHE;AACF;ADyHA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;ACvHA;ADwHA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;ACtHA;ADuHA;EACA,gBAAA;ACrHA;ADsHA;EACA,gBAAA;ACpHA;ADuHA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;ACrHA;ADwHA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8DAAA;EACA,wBAAA;ACtHA;ADwHA;EACA,gCAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;ACtHA;ADwHA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;ACtHA;ADuHA;EACA,uBAAA;EACA,aAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;ACrHA;ADsHA;EACA,yEAAA;ACpHA;ADsHA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,aAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,yEAAA;ACpHA;ADwHA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,UAAA;EACA,kBAAA;ACtHA;ADuHA;EACA,SAAA;ACrHA;ADuHA;EACA,aAAA;ACrHA;ADwHA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;EACA,sEAAA;ACtHA;ADuHA;EACA,WAAA;ACrHA;ADwHA;EACA,aAAA;ACtHA;ADyHA;EACA,qBAAA;EACA,sDAAA;EACA,iBAAA;ACvHA;ADyHA;EACA,gEAAA;ACvHA;AD6HA;AACA;IACA,aAAA;AC3HE;AACF;AD6HA;AACA;IACA,aAAA;AC3HE;AACF;;AAEA,wCAAwC",
      "file": "Animation.vue",
      "sourcesContent": ["<template>\r\n  <div\r\n    class=\"modal-animation-container text-center\"\r\n    :class=\"{ 'bg-night': showQrcode && success, 'bg-dayli': !success }\"\r\n    :style=\"showQrcode && success ? `background: url(${bgNight})` : ''\"\r\n  >\r\n    <img\r\n      :src=\"require('@/assets/images/clouds-multiple.png')\"\r\n      v-show=\"showQrcode && !success\"\r\n      alt=\"clouds\"\r\n      class=\"clouds-animation\"\r\n    />\r\n\r\n    <div class=\"container-logo-octa-wpp\" v-if=\"!showQrcode\">\r\n      <LogoOcta />\r\n\r\n      <LogoWhatsapp />\r\n    </div>\r\n\r\n    <div\r\n      v-if=\"showQrcode && !success\"\r\n      style=\"\r\n        position: absolute;\r\n        bottom: 50px;\r\n        text-align: center;\r\n        width: 100%;\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: center;\r\n      \"\r\n    >\r\n      <p class=\"we-are-octa\">{{ $t('modal.animation.title') }}</p>\r\n\r\n      <span\r\n        style=\"\r\n          font-style: normal;\r\n          font-weight: normal;\r\n          font-size: 16px;\r\n          line-height: 22px;\r\n          color: #fff;\r\n        \"\r\n        v-html=\"$t('modal.animation.description')\"\r\n      />\r\n\r\n      <div class=\"wpp-divider divider-white\">\r\n        <span />\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"container-logo-octa-wpp show-qrcode\" v-show=\"showQrcode\">\r\n      <LogoOcta />\r\n\r\n      <LogoWhatsapp />\r\n    </div>\r\n\r\n    <div class=\"cloud-container\">\r\n      <img\r\n        v-show=\"!showQrcode && !success\"\r\n        :src=\"require('@/assets/images/clouds.png')\"\r\n        alt=\"nuvem-icon\"\r\n        class=\"cloud-icon cloud-animation-1\"\r\n      />\r\n\r\n      <img\r\n        :src=\"require('@/assets/images/clouds.png')\"\r\n        alt=\"nuvem-icon\"\r\n        v-show=\"!showQrcode && !success\"\r\n        class=\"cloud-icon cloud-animation-2\"\r\n      />\r\n    </div>\r\n\r\n    <RocketIcon\r\n      class=\"rocket\"\r\n      :class=\"{\r\n        'position-1': !showQrcode && !success,\r\n        'position-2': showQrcode\r\n      }\"\r\n    />\r\n\r\n    <RocketFire\r\n      class=\"rocket-fire\"\r\n      :class=\"{\r\n        'position-1': !showQrcode && !success,\r\n        'position-2': showQrcode\r\n      }\"\r\n    />\r\n  </div>\r\n</template>\r\n\r\n<script>\r\n  import bgNight from '@/assets/images/background-night.png'\r\n\r\n  import {\r\n    LogoOcta,\r\n    LogoWhatsapp,\r\n    RocketFire,\r\n    RocketIcon\r\n  } from '@/app/multi-color-icons'\r\n\r\n  import i18n from '@/i18n'\r\n\r\n  export default {\r\n    i18n,\r\n    props: ['showQrcode', 'success'],\r\n    components: {\r\n      RocketIcon,\r\n      RocketFire,\r\n      LogoOcta,\r\n      LogoWhatsapp\r\n    },\r\n    data() {\r\n      return {\r\n        bgNight\r\n      }\r\n    }\r\n  }\r\n</script>\r\n\r\n<style scoped lang=\"scss\">\r\n  @import url('https://fonts.googleapis.com/css?family=Gloria+Hallelujah&display=swap');\r\n\r\n  @keyframes space-move {\r\n    0% {\r\n      transform: translateY(0);\r\n    }\r\n    100% {\r\n      transform: translateY(100%);\r\n    }\r\n  }\r\n  @keyframes clouds-moving {\r\n    0% {\r\n      transform: translateY(0);\r\n      opacity: 0.7;\r\n    }\r\n    100% {\r\n      transform: translateY(350%);\r\n      opacity: 0;\r\n    }\r\n  }\r\n  @keyframes bg-move {\r\n    0% {\r\n      background-position: 25% 100%;\r\n    }\r\n    100% {\r\n      background-position: 25% 0%;\r\n    }\r\n  }\r\n  @keyframes rocket-fire {\r\n    from {\r\n      transform: scale(1);\r\n    }\r\n    to {\r\n      transform: scale(1.2);\r\n    }\r\n  }\r\n  @keyframes cloud-moving-1 {\r\n    from {\r\n      height: 134px;\r\n    }\r\n    to {\r\n      height: 144px;\r\n    }\r\n  }\r\n  @keyframes cloud-moving-2 {\r\n    from {\r\n      bottom: 15px;\r\n    }\r\n    to {\r\n      bottom: 30px;\r\n    }\r\n  }\r\n  div.modal-animation-container {\r\n    width: 350px;\r\n    position: absolute;\r\n    top: 0px;\r\n    left: 0px;\r\n    height: 100%;\r\n    min-height: 520px;\r\n    overflow: hidden;\r\n    transition: all 2s;\r\n    div.container-logo-octa-wpp {\r\n      width: 100%;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      margin-top: 120px;\r\n      span {\r\n        margin: 0px 10px;\r\n        &:last-child {\r\n          margin-top: -5px;\r\n        }\r\n      }\r\n      &.show-qrcode {\r\n        position: absolute;\r\n        width: 100%;\r\n        bottom: 25px;\r\n      }\r\n    }\r\n    img.clouds-animation {\r\n      position: absolute;\r\n      top: 0;\r\n      left: 0;\r\n      right: 0;\r\n      bottom: 0;\r\n      animation: clouds-moving 5s linear 0s infinite;\r\n      transition: transform 2s;\r\n    }\r\n    p.we-are-octa {\r\n      font-family: 'Gloria Hallelujah';\r\n      color: #fff;\r\n      font-style: normal;\r\n      font-weight: normal;\r\n      font-size: 30px;\r\n      line-height: 33px;\r\n    }\r\n    div.cloud-container {\r\n      position: absolute;\r\n      bottom: 0px;\r\n      left: -1px;\r\n      border: none;\r\n      margin: 0;\r\n      transition: all 1s;\r\n      img.cloud-icon {\r\n        width: calc(100% + 1px);\r\n        height: 134px;\r\n        bottom: -1px;\r\n        left: -1px;\r\n        border: none;\r\n        margin: 0;\r\n        z-index: 0;\r\n        position: relative;\r\n        &.cloud-animation-1 {\r\n          animation: cloud-moving-1 2s linear 0s infinite alternate;\r\n        }\r\n        &.cloud-animation-2 {\r\n          opacity: 0.7;\r\n          position: absolute;\r\n          width: calc(100% + 1px);\r\n          height: 134px;\r\n          bottom: 15px;\r\n          left: -1px;\r\n          border: none;\r\n          margin: 0;\r\n          z-index: 0;\r\n          animation: cloud-moving-2 2s linear 0s infinite alternate;\r\n        }\r\n      }\r\n    }\r\n    span.rocket {\r\n      font-size: 80px;\r\n      position: absolute;\r\n      left: calc(50% - 63px);\r\n      z-index: 3;\r\n      transition: all 1s;\r\n      &.position-1 {\r\n        bottom: 0;\r\n      }\r\n      &.position-2 {\r\n        bottom: 260px;\r\n      }\r\n    }\r\n    span.rocket-fire {\r\n      font-size: 60px;\r\n      position: absolute;\r\n      left: calc(50% - 25px);\r\n      z-index: 2;\r\n      transition: all 1s;\r\n      bottom: 25px;\r\n      animation: rocket-fire 1s linear 0s infinite alternate;\r\n      &.position-1 {\r\n        bottom: 0px;\r\n      }\r\n\r\n      &.position-2 {\r\n        bottom: 210px;\r\n      }\r\n    }\r\n    &.bg-night {\r\n      background-size: 700%;\r\n      animation: bg-move 10s infinite linear;\r\n      top: 0 !important;\r\n    }\r\n    &.bg-dayli {\r\n      background: linear-gradient(\r\n        to bottom,\r\n        rgba(0, 85, 141, 1) 0%,\r\n        rgba(0, 138, 192, 1) 100%\r\n      );\r\n    }\r\n    @media screen and (max-width: 520px) {\r\n      .modal-animation-container {\r\n        display: none;\r\n      }\r\n    }\r\n    @media screen and (max-height: 520px) {\r\n      .modal-animation-container {\r\n        display: none;\r\n      }\r\n    }\r\n  }\r\n</style>\r\n", "@import url(\"https://fonts.googleapis.com/css?family=Gloria+Hallelujah&display=swap\");\n@keyframes space-move {\n  0% {\n    transform: translateY(0);\n  }\n  100% {\n    transform: translateY(100%);\n  }\n}\n@keyframes clouds-moving {\n  0% {\n    transform: translateY(0);\n    opacity: 0.7;\n  }\n  100% {\n    transform: translateY(350%);\n    opacity: 0;\n  }\n}\n@keyframes bg-move {\n  0% {\n    background-position: 25% 100%;\n  }\n  100% {\n    background-position: 25% 0%;\n  }\n}\n@keyframes rocket-fire {\n  from {\n    transform: scale(1);\n  }\n  to {\n    transform: scale(1.2);\n  }\n}\n@keyframes cloud-moving-1 {\n  from {\n    height: 134px;\n  }\n  to {\n    height: 144px;\n  }\n}\n@keyframes cloud-moving-2 {\n  from {\n    bottom: 15px;\n  }\n  to {\n    bottom: 30px;\n  }\n}\ndiv.modal-animation-container {\n  width: 350px;\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  height: 100%;\n  min-height: 520px;\n  overflow: hidden;\n  transition: all 2s;\n}\ndiv.modal-animation-container div.container-logo-octa-wpp {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 120px;\n}\ndiv.modal-animation-container div.container-logo-octa-wpp span {\n  margin: 0px 10px;\n}\ndiv.modal-animation-container div.container-logo-octa-wpp span:last-child {\n  margin-top: -5px;\n}\ndiv.modal-animation-container div.container-logo-octa-wpp.show-qrcode {\n  position: absolute;\n  width: 100%;\n  bottom: 25px;\n}\ndiv.modal-animation-container img.clouds-animation {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  animation: clouds-moving 5s linear 0s infinite;\n  transition: transform 2s;\n}\ndiv.modal-animation-container p.we-are-octa {\n  font-family: \"Gloria Hallelujah\";\n  color: #fff;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 30px;\n  line-height: 33px;\n}\ndiv.modal-animation-container div.cloud-container {\n  position: absolute;\n  bottom: 0px;\n  left: -1px;\n  border: none;\n  margin: 0;\n  transition: all 1s;\n}\ndiv.modal-animation-container div.cloud-container img.cloud-icon {\n  width: calc(100% + 1px);\n  height: 134px;\n  bottom: -1px;\n  left: -1px;\n  border: none;\n  margin: 0;\n  z-index: 0;\n  position: relative;\n}\ndiv.modal-animation-container div.cloud-container img.cloud-icon.cloud-animation-1 {\n  animation: cloud-moving-1 2s linear 0s infinite alternate;\n}\ndiv.modal-animation-container div.cloud-container img.cloud-icon.cloud-animation-2 {\n  opacity: 0.7;\n  position: absolute;\n  width: calc(100% + 1px);\n  height: 134px;\n  bottom: 15px;\n  left: -1px;\n  border: none;\n  margin: 0;\n  z-index: 0;\n  animation: cloud-moving-2 2s linear 0s infinite alternate;\n}\ndiv.modal-animation-container span.rocket {\n  font-size: 80px;\n  position: absolute;\n  left: calc(50% - 63px);\n  z-index: 3;\n  transition: all 1s;\n}\ndiv.modal-animation-container span.rocket.position-1 {\n  bottom: 0;\n}\ndiv.modal-animation-container span.rocket.position-2 {\n  bottom: 260px;\n}\ndiv.modal-animation-container span.rocket-fire {\n  font-size: 60px;\n  position: absolute;\n  left: calc(50% - 25px);\n  z-index: 2;\n  transition: all 1s;\n  bottom: 25px;\n  animation: rocket-fire 1s linear 0s infinite alternate;\n}\ndiv.modal-animation-container span.rocket-fire.position-1 {\n  bottom: 0px;\n}\ndiv.modal-animation-container span.rocket-fire.position-2 {\n  bottom: 210px;\n}\ndiv.modal-animation-container.bg-night {\n  background-size: 700%;\n  animation: bg-move 10s infinite linear;\n  top: 0 !important;\n}\ndiv.modal-animation-container.bg-dayli {\n  background: linear-gradient(to bottom, #00558d 0%, #008ac0 100%);\n}\n@media screen and (max-width: 520px) {\n  div.modal-animation-container .modal-animation-container {\n    display: none;\n  }\n}\n@media screen and (max-height: 520px) {\n  div.modal-animation-container .modal-animation-container {\n    display: none;\n  }\n}\n\n/*# sourceMappingURL=Animation.vue.map */"]
    },
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$a = "data-v-4a52b725";
/* module identifier */

var __vue_module_identifier__$a = undefined;
/* functional template */

var __vue_is_functional_template__$a = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$a = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a,
  staticRenderFns: __vue_staticRenderFns__$a
}, __vue_inject_styles__$a, __vue_script__$6, __vue_scope_id__$a, __vue_is_functional_template__$a, __vue_module_identifier__$a, false, createInjector, undefined, undefined);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG$1 = wellKnownSymbol('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof = toStringTagSupport ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG$1)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};

// `Object.prototype.toString` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
var objectToString = toStringTagSupport ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};

// `Object.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
if (!toStringTagSupport) {
  redefine(Object.prototype, 'toString', objectToString, { unsafe: true });
}

// `RegExp.prototype.flags` getter implementation
// https://tc39.github.io/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = nativeToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  redefine(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var p = String(R.source);
    var rf = R.flags;
    var f = String(rf === undefined && R instanceof RegExp && !('flags' in RegExpPrototype) ? regexpFlags.call(R) : rf);
    return '/' + p + '/' + f;
  }, { unsafe: true });
}

var runtime_1 = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}
});

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var createProperty = function (object, key, value) {
  var propertyKey = toPrimitive(key);
  if (propertyKey in object) objectDefineProperty.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = engineV8Version >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.github.io/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
_export({ target: 'Array', proto: true, forced: FORCED }, {
  concat: function concat(arg) { // eslint-disable-line no-unused-vars
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = toLength(E.length);
        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});

var arrayMethodIsStrict = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal
    method.call(null, argument || function () { throw 1; }, 1);
  });
};

var $indexOf = arrayIncludes.indexOf;



var nativeIndexOf = [].indexOf;

var NEGATIVE_ZERO = !!nativeIndexOf && 1 / [1].indexOf(1, -0) < 0;
var STRICT_METHOD = arrayMethodIsStrict('indexOf');
var USES_TO_LENGTH$1 = arrayMethodUsesToLength('indexOf', { ACCESSORS: true, 1: 0 });

// `Array.prototype.indexOf` method
// https://tc39.github.io/ecma262/#sec-array.prototype.indexof
_export({ target: 'Array', proto: true, forced: NEGATIVE_ZERO || !STRICT_METHOD || !USES_TO_LENGTH$1 }, {
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? nativeIndexOf.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var state = {
  wppUserLogged: undefined,
  wppUserToken: undefined,
  wppSubDomainStatus: undefined,
  settings: {},
  company: undefined
};

var WPP_SET_USER_LOGGED = 'octadesk/chat/settings/setUserLogged';
var WPP_SET_USER_TOKEN = 'octadesk/chat/settings/setUserToken';
var WPP_SET_SUBDOMAIN_STATUS = 'WPP_SET_SUBDOMAIN_STATUS';
var SET_SETTINGS = 'octadesk/chat/setSettings';
var SET_COMPANY = 'SET_COMPANY';

var _types$WPP_SET_USER_L;
var mutations = (_types$WPP_SET_USER_L = {}, _defineProperty(_types$WPP_SET_USER_L, WPP_SET_USER_LOGGED, function (state, userLogged) {
  if (!userLogged) {
    state.wppUserLogged = Storage.getItem('userLogged');
  } else {
    Storage.setItem('userLogged', userLogged);
    Storage.setItem('company', userLogged.subDomain);
    state.wppUserLogged = userLogged;
  }
}), _defineProperty(_types$WPP_SET_USER_L, WPP_SET_USER_TOKEN, function (state, userToken) {
  if (!userToken) {
    state.wppUserToken = Storage.getItem('userToken');
  } else {
    Storage.setItem('userToken', userToken);
    state.wppUserToken = userToken;
  }
}), _defineProperty(_types$WPP_SET_USER_L, WPP_SET_SUBDOMAIN_STATUS, function (state, status) {
  if (!status) {
    state.wppSubDomainStatus = Storage.getItem('status');
  } else {
    Storage.setItem('status', status);
    state.wppSubDomainStatus = status;
  }
}), _defineProperty(_types$WPP_SET_USER_L, SET_SETTINGS, function (state, settings) {
  state.settings = settings;
}), _defineProperty(_types$WPP_SET_USER_L, SET_COMPANY, function (state, company) {
  state.company = company;
}), _types$WPP_SET_USER_L);

var loadParameterHeader = function loadParameterHeader() {
  var headers = {
    'Content-Type': 'application/json',
    AppSubDomain: Storage.getItem('company'),
    Authorization: "Bearer ".concat(Storage.getItem('userToken'))
  };
  return {
    headers: headers
  };
};

var _hubspot;

var API_KEY = 'a5136025-4fd9-4518-a937-a479c2bde8fc';

var getHubspotClient = function getHubspotClient() {
  if (!_hubspot) {

    _hubspot = new Hubspot({
      apiKey: API_KEY
    });
  }

  return _hubspot;
};

var submitForm = function submitForm(data) {
  var hubspot = getHubspotClient();
  var portalId = '5475045';
  var formId = '5840b318-15c9-46e9-869a-1fb7038f8df2';
  return hubspot.forms.submit(portalId, formId, data).then(function () {
    return true;
  }).catch(function () {
    return false;
  });
};

var chatApiUrl = function chatApiUrl() {
  if (window && window.octadesk && window.octadesk.apis && window.octadesk.apis.chatUrl) {
    return window.octadesk.apis.chatUrl;
  } else {
    return 'https://chat.qaoctadesk.services/api';
  }
};

var createClient = function createClient() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return axios.create(Object.assign({
    baseURL: chatApiUrl()
  }, options));
};
var http = createClient();

var getSettings = function getSettings() {
  return http.get('configs', loadParameterHeader()).then(function (res) {
    return res.data;
  });
};

var settings = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getSettings: getSettings
});

var getChatSocketInstance = function getChatSocketInstance() {
  return window.octadesk && window.octadesk.chat && window.octadesk.chat.socket && window.octadesk.chat.socket.instance;
};

var setChatSocketInstance = function setChatSocketInstance(socket) {
  window.octadesk = window.octadesk || {};
  window.octadesk.chat = window.octadesk.chat || {};
  window.octadesk.chat.socket = window.octadesk.chat.socket || {};
  return window.octadesk.chat.socket.instance = socket;
};

var getSocketURL = function getSocketURL() {
  if (window.octadesk && window.octadesk.chat && window.octadesk.chat.socket) {
    return window.octadesk.chat.socket;
  }

  window.octadesk = window.octadesk || {};
  var socketUrl = process.env.VUE_APP_SOCKET_URL || "https://".concat(window.octadesk.isPreprd ? 'preprd-' : '', "chat.").concat(window.octadesk.prefix || '', "octadesk.services");
  window.octadesk.chat = {
    socket: {
      instance: null,
      url: socketUrl,
      basePath: process.env.VUE_APP_SOCKET_BASE_PATH || '/socket',
      path: process.env.VUE_APP_SOCKET_PATH || '/socket/socket.io'
    }
  };
  return window.octadesk.chat.socket;
};

var setSocket = function setSocket(socketInstance, context) {
  var socket = setChatSocketInstance(socketInstance);

  if (socket) {
    socket.onevent = function (packet) {
      context.dispatch(packet.data[0], packet.data[1]);
    };
  }
};

var connectSocket = function connectSocket(company, context) {
  if (!company) {
    console.info('socket not connected...');
    return;
  }

  var socketInstance = getChatSocketInstance();

  if (!socketInstance) {
    var socketURL = getSocketURL();
    socketInstance = Socket("".concat(socketURL.url, "/").concat(company), {
      query: {
        sd: company
      },
      path: socketURL.path,
      transports: ['websocket'],
      reconnection: true
    });
    setSocket(socketInstance, context);
  }
};

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  objectDefineProperty.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: objectCreate(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};

var $find = arrayIteration.find;



var FIND = 'find';
var SKIPS_HOLES = true;

var USES_TO_LENGTH$2 = arrayMethodUsesToLength(FIND);

// Shouldn't skip holes
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

// `Array.prototype.find` method
// https://tc39.github.io/ecma262/#sec-array.prototype.find
_export({ target: 'Array', proto: true, forced: SKIPS_HOLES || !USES_TO_LENGTH$2 }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);

var nativeJoin = [].join;

var ES3_STRINGS = indexedObject != Object;
var STRICT_METHOD$1 = arrayMethodIsStrict('join', ',');

// `Array.prototype.join` method
// https://tc39.github.io/ecma262/#sec-array.prototype.join
_export({ target: 'Array', proto: true, forced: ES3_STRINGS || !STRICT_METHOD$1 }, {
  join: function join(separator) {
    return nativeJoin.call(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});

// babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError,
// so we use an intermediate function.
function RE(s, f) {
  return RegExp(s, f);
}

var UNSUPPORTED_Y = fails(function () {
  // babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
  var re = RE('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

var BROKEN_CARET = fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = RE('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});

var regexpStickyHelpers = {
	UNSUPPORTED_Y: UNSUPPORTED_Y,
	BROKEN_CARET: BROKEN_CARET
};

var SPECIES$2 = wellKnownSymbol('species');

var setSpecies = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = objectDefineProperty.f;

  if (descriptors && Constructor && !Constructor[SPECIES$2]) {
    defineProperty(Constructor, SPECIES$2, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

var defineProperty$4 = objectDefineProperty.f;
var getOwnPropertyNames$1 = objectGetOwnPropertyNames.f;





var setInternalState = internalState.set;



var MATCH$2 = wellKnownSymbol('match');
var NativeRegExp = global_1.RegExp;
var RegExpPrototype$1 = NativeRegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;

// "new" should create a new object, old webkit bug
var CORRECT_NEW = new NativeRegExp(re1) !== re1;

var UNSUPPORTED_Y$1 = regexpStickyHelpers.UNSUPPORTED_Y;

var FORCED$1 = descriptors && isForced_1('RegExp', (!CORRECT_NEW || UNSUPPORTED_Y$1 || fails(function () {
  re2[MATCH$2] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return NativeRegExp(re1) != re1 || NativeRegExp(re2) == re2 || NativeRegExp(re1, 'i') != '/a/i';
})));

// `RegExp` constructor
// https://tc39.github.io/ecma262/#sec-regexp-constructor
if (FORCED$1) {
  var RegExpWrapper = function RegExp(pattern, flags) {
    var thisIsRegExp = this instanceof RegExpWrapper;
    var patternIsRegExp = isRegexp(pattern);
    var flagsAreUndefined = flags === undefined;
    var sticky;

    if (!thisIsRegExp && patternIsRegExp && pattern.constructor === RegExpWrapper && flagsAreUndefined) {
      return pattern;
    }

    if (CORRECT_NEW) {
      if (patternIsRegExp && !flagsAreUndefined) pattern = pattern.source;
    } else if (pattern instanceof RegExpWrapper) {
      if (flagsAreUndefined) flags = regexpFlags.call(pattern);
      pattern = pattern.source;
    }

    if (UNSUPPORTED_Y$1) {
      sticky = !!flags && flags.indexOf('y') > -1;
      if (sticky) flags = flags.replace(/y/g, '');
    }

    var result = inheritIfRequired(
      CORRECT_NEW ? new NativeRegExp(pattern, flags) : NativeRegExp(pattern, flags),
      thisIsRegExp ? this : RegExpPrototype$1,
      RegExpWrapper
    );

    if (UNSUPPORTED_Y$1 && sticky) setInternalState(result, { sticky: sticky });

    return result;
  };
  var proxy$1 = function (key) {
    key in RegExpWrapper || defineProperty$4(RegExpWrapper, key, {
      configurable: true,
      get: function () { return NativeRegExp[key]; },
      set: function (it) { NativeRegExp[key] = it; }
    });
  };
  var keys$2 = getOwnPropertyNames$1(NativeRegExp);
  var index$2 = 0;
  while (keys$2.length > index$2) proxy$1(keys$2[index$2++]);
  RegExpPrototype$1.constructor = RegExpWrapper;
  RegExpWrapper.prototype = RegExpPrototype$1;
  redefine(global_1, 'RegExp', RegExpWrapper);
}

// https://tc39.github.io/ecma262/#sec-get-regexp-@@species
setSpecies('RegExp');

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y$2 = regexpStickyHelpers.UNSUPPORTED_Y || regexpStickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y$2;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;
    var sticky = UNSUPPORTED_Y$2 && re.sticky;
    var flags = regexpFlags.call(re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = flags.replace('y', '');
      if (flags.indexOf('g') === -1) {
        flags += 'g';
      }

      strCopy = String(str).slice(re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && str[re.lastIndex - 1] !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = nativeExec.call(sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = match.input.slice(charsAdded);
        match[0] = match[0].slice(charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

var regexpExec = patchedExec;

_export({ target: 'RegExp', proto: true, forced: /./.exec !== regexpExec }, {
  exec: regexpExec
});

// TODO: Remove from `core-js@4` since it's moved to entry points







var SPECIES$3 = wellKnownSymbol('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  return 'a'.replace(/./, '$0') === '$0';
})();

var REPLACE = wellKnownSymbol('replace');
// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

var fixRegexpWellKnownSymbolLogic = function (KEY, length, exec, sham) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES$3] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !(
      REPLACE_SUPPORTS_NAMED_GROUPS &&
      REPLACE_KEEPS_$0 &&
      !REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
    )) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      if (regexp.exec === regexpExec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
        }
        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
      }
      return { done: false };
    }, {
      REPLACE_KEEPS_$0: REPLACE_KEEPS_$0,
      REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
    });
    var stringMethod = methods[0];
    var regexMethod = methods[1];

    redefine(String.prototype, KEY, stringMethod);
    redefine(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return regexMethod.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return regexMethod.call(string, this); }
    );
  }

  if (sham) createNonEnumerableProperty(RegExp.prototype[SYMBOL], 'sham', true);
};

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod$3 = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod$3(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod$3(true)
};

var charAt = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
var advanceStringIndex = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};

// `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }

  if (classofRaw(R) !== 'RegExp') {
    throw TypeError('RegExp#exec called on incompatible receiver');
  }

  return regexpExec.call(R, S);
};

var max$1 = Math.max;
var min$3 = Math.min;
var floor$1 = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
fixRegexpWellKnownSymbolLogic('replace', 2, function (REPLACE, nativeReplace, maybeCallNative, reason) {
  var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = reason.REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE;
  var REPLACE_KEEPS_$0 = reason.REPLACE_KEEPS_$0;
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = searchValue == undefined ? undefined : searchValue[REPLACE];
      return replacer !== undefined
        ? replacer.call(searchValue, O, replaceValue)
        : nativeReplace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      if (
        (!REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE && REPLACE_KEEPS_$0) ||
        (typeof replaceValue === 'string' && replaceValue.indexOf(UNSAFE_SUBSTITUTE) === -1)
      ) {
        var res = maybeCallNative(nativeReplace, regexp, this, replaceValue);
        if (res.done) return res.value;
      }

      var rx = anObject(regexp);
      var S = String(this);

      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regexpExecAbstract(rx, S);
        if (result === null) break;

        results.push(result);
        if (!global) break;

        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = String(result[0]);
        var position = max$1(min$3(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

  // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return nativeReplace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor$1(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});

var SPECIES$4 = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.github.io/ecma262/#sec-speciesconstructor
var speciesConstructor = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES$4]) == undefined ? defaultConstructor : aFunction$1(S);
};

var arrayPush = [].push;
var min$4 = Math.min;
var MAX_UINT32 = 0xFFFFFFFF;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { return !RegExp(MAX_UINT32, 'y'); });

// @@split logic
fixRegexpWellKnownSymbolLogic('split', 2, function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] == 'c' ||
    'test'.split(/(?:)/, -1).length != 4 ||
    'ab'.split(/(?:ab)*/).length != 2 ||
    '.'.split(/(.?)(.?)/).length != 4 ||
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(requireObjectCoercible(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegexp(separator)) {
        return nativeSplit.call(string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) arrayPush.apply(output, match.slice(1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output.length > lim ? output.slice(0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : nativeSplit.call(this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== nativeSplit);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return regexpExecAbstract(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = regexpExecAbstract(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = min$4(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
}, !SUPPORTS_Y);

var chatApiUrl$1 = function chatApiUrl() {
  if (window && window.octadesk && window.octadesk.apis && window.octadesk.apis.chatUrl) {
    return window.octadesk.apis.chatUrl;
  } else {
    return 'https://chat.qaoctadesk.services/api';
  }
};

var createClient$1 = function createClient() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return axios.create(Object.assign({
    baseURL: chatApiUrl$1()
  }, options));
};
var http$1 = createClient$1();

// @@match logic
fixRegexpWellKnownSymbolLogic('match', 1, function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = regexp == undefined ? undefined : regexp[MATCH];
      return matcher !== undefined ? matcher.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative(nativeMatch, regexp, this);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);

      if (!rx.global) return regexpExecAbstract(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regexpExecAbstract(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});

var WHATSAPP_SET_QRCODE = 'whatsapp/qrcode/set';
var WHATSAPP_QRCODE_LOGGED = 'whatsapp/qrcode/logged';
var WHATSAPP_QRCODE_SUCCESS = 'whatsapp/qrcode/success';
var WHATSAPP_QRCODE_ERROR = 'whatsapp/qrcode/error';
var WHATSAPP_SET_QRCODE_READING = 'whatsapp/qrcode/reading';
var WHATSAPP_QRCODE_RESET = 'whatsapp/qrcode/reset';
var ADD_AUTO_RETRY = 'ADD_AUTO_RETRY';
var RESET_AUTO_RETRY = 'RESET_AUTO_RETRY';

var types = /*#__PURE__*/Object.freeze({
  __proto__: null,
  WHATSAPP_SET_QRCODE: WHATSAPP_SET_QRCODE,
  WHATSAPP_QRCODE_LOGGED: WHATSAPP_QRCODE_LOGGED,
  WHATSAPP_QRCODE_SUCCESS: WHATSAPP_QRCODE_SUCCESS,
  WHATSAPP_QRCODE_ERROR: WHATSAPP_QRCODE_ERROR,
  WHATSAPP_SET_QRCODE_READING: WHATSAPP_SET_QRCODE_READING,
  WHATSAPP_QRCODE_RESET: WHATSAPP_QRCODE_RESET,
  ADD_AUTO_RETRY: ADD_AUTO_RETRY,
  RESET_AUTO_RETRY: RESET_AUTO_RETRY
});

var openQRCodeWS = function openQRCodeWS(context, contact) {
  context.commit(WHATSAPP_QRCODE_ERROR, null);
  context.commit(WHATSAPP_QRCODE_SUCCESS, null);
  context.commit(WHATSAPP_SET_QRCODE, '');
  context.commit(WHATSAPP_SET_QRCODE_READING);
  openQRCodeWS$1(contact, context);
  var _context$getters = context.getters,
      autoRetries = _context$getters.autoRetries,
      maxRetries = _context$getters.maxRetries;

  if (autoRetries >= maxRetries) {
    context.dispatch('resetAutoRetry');
  }
};
var confirmQRCodeOverrideWS = function confirmQRCodeOverrideWS(_ref, _ref2) {
  var commit = _ref.commit,
      dispatch = _ref.dispatch;
  var confirmed = _ref2.confirmed;
  commit(WHATSAPP_QRCODE_ERROR, null);
  commit(WHATSAPP_QRCODE_SUCCESS, null);
  confirmQRCodeOverrideWS$1({
    confirmed: confirmed
  });

  if (!confirmed) {
    dispatch('closeQRCodeWS');
  }
};
var closeQRCodeWS = function closeQRCodeWS(context) {
  closeQRCodeWS$1();
  context.commit(WHATSAPP_QRCODE_RESET);
};
var retryQrCode = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(context, contact) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return context.dispatch('closeQRCodeWS');

          case 2:
            _context.next = 4;
            return context.dispatch('openQRCodeWS', contact);

          case 4:
            _context.next = 6;
            return context.dispatch('addAutoRetry');

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function retryQrCode(_x, _x2) {
    return _ref3.apply(this, arguments);
  };
}();
/* eslint-disable @typescript-eslint/camelcase */

var ws_error = function ws_error(context, payload) {
  var _context$getters2 = context.getters,
      autoRetries = _context$getters2.autoRetries,
      maxRetries = _context$getters2.maxRetries;
  var data = payload.data,
      contact = payload.contact;

  if (data && data.match(/error during login: login timed out/) && autoRetries < maxRetries) {
    context.dispatch('retryQrCode', contact);
  } else {
    context.commit(WHATSAPP_QRCODE_ERROR, data);
  }
};
var ws_qrcode = function ws_qrcode(context, payload) {
  context.commit(WHATSAPP_SET_QRCODE, payload.data);
};
var ws_logged = function ws_logged(context, session) {
  context.commit(WHATSAPP_QRCODE_LOGGED, session.data);
};
var ws_creatingSuccess = function ws_creatingSuccess(context, payload) {
  try {
    var client = JSON.parse(payload.data);

    if (client && client.id) {
      context.dispatch('numberConnectInterval', client.id);
    }
  } catch (err) {
    console.error('err ws_creatingSuccess', err);
  }

  context.commit(WHATSAPP_QRCODE_SUCCESS, payload.data);
};
var addAutoRetry = function addAutoRetry(context) {
  context.commit(ADD_AUTO_RETRY);
};
var resetAutoRetry = function resetAutoRetry(context) {
  context.commit(RESET_AUTO_RETRY);
};

var qrCodeActions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  openQRCodeWS: openQRCodeWS,
  confirmQRCodeOverrideWS: confirmQRCodeOverrideWS,
  closeQRCodeWS: closeQRCodeWS,
  retryQrCode: retryQrCode,
  ws_error: ws_error,
  ws_qrcode: ws_qrcode,
  ws_logged: ws_logged,
  ws_creatingSuccess: ws_creatingSuccess,
  addAutoRetry: addAutoRetry,
  resetAutoRetry: resetAutoRetry
});

Vue$1.use(VueI18n);
var language$1 = Storage.getItem('language') || 'pt-BR';
var i18n$1 = new VueI18n({
  locale: language$1,
  fallbackLocale: 'pt-BR',
  messages: messages
});

if (language$1) {
  if (language$1.startsWith('en')) {
    dayjs_min.locale('en');
  } else {
    dayjs_min.locale(language$1.toLowerCase());
  }
}

var getWhatsappUrl = function getWhatsappUrl() {
  if (window && window.octadesk && window.octadesk.apis && window.octadesk.apis.whatsapp) {
    return window.octadesk.apis.whatsapp;
  } else {
    return 'https://whatsapp.qaoctadesk.services/api';
  }
};
var getClient = function getClient() {
  var _loadParameterHeader = loadParameterHeader(),
      headers = _loadParameterHeader.headers;

  return createClient$1({
    baseURL: getWhatsappUrl(),
    headers: headers
  });
};
var getWhatsappNumbers = function getWhatsappNumbers() {
  var client = getClient();
  return client.get('/numbers').then(function (r) {
    return r.data;
  });
};
var conn;
var closeQRCodeWS$1 = function closeQRCodeWS() {
  if (conn) {
    conn.close();
  }
};
var openQRCodeWS$1 = function openQRCodeWS(contact, context) {
  var subDomain = Storage.getItem('company');

  if (!subDomain || !subDomain.length) {
    throw new Error('SubDomain not provided');
  }

  var basePath = getWhatsappUrl().replace(/^https:\/\//, 'wss://').replace(/^http:\/\//, 'ws://');

  if (contact) {
    conn = new WebSocket("".concat(basePath, "/qrcode/").concat(contact.number, "?sb=").concat(subDomain, "&user=").concat(context.getters.wppUserLogged.id));
  } else {
    conn = new WebSocket("".concat(basePath, "/qrcode?sb=").concat(subDomain, "&user=").concat(context.getters.wppUserLogged.id));
  }

  conn.onmessage = function (message) {
    try {
      var data = JSON.parse(message.data);

      if (data) {
        var actionName = 'ws_' + data.Command;

        for (var namespaced in qrCodeActions) {
          var action = namespaced.split('/').pop();

          if (action.startsWith('ws_') && action === actionName) {
            var wsInfo = {
              data: data.Data,
              contact: contact
            };
            context.dispatch(namespaced, wsInfo);
          }
        }
      }
    } catch (ex) {
      if (ex) {
        console.error('Error on qrcode on message', ex);
      }
    }
  };
};
var confirmQRCodeOverrideWS$1 = function confirmQRCodeOverrideWS(_ref) {
  var confirmed = _ref.confirmed;

  if (!conn) {
    throw new Error('Socket disconnected');
  }

  var data = {
    Command: 'confirm',
    Data: confirmed.toString().toLowerCase()
  };
  conn.send(JSON.stringify(data));
};
var getNumberStatus = function getNumberStatus(numberId) {
  var client = getClient();
  return client.get("/numbers/".concat(numberId)).then(function (r) {
    return r.data;
  });
};
var updateNumberName = function updateNumberName(number, userLogged) {
  var client = getClient();
  return client.patch("/numbers/".concat(number.id, "/name?user=").concat(userLogged), {
    name: number.name
  }).then(function (r) {
    return r.data;
  });
};
var enableNumber = function enableNumber(id) {
  var client = getClient();
  return client.patch("/numbers/".concat(id, "/enable")).then(function (r) {
    return r.data;
  });
};
var getNumber = function getNumber(id) {
  var client = getClient();
  return client.get("/numbers/".concat(id)).then(function (r) {
    return r.data;
  });
};
var disableNumber = function disableNumber(id) {
  var client = getClient();
  return client.patch("/numbers/".concat(id, "/disable")).then(function (r) {
    return r.data;
  });
};
var deleteNumber = function deleteNumber(id, userLogged) {
  var client = getClient();
  return client.delete("/numbers/".concat(id, "?user=").concat(userLogged)).then(function (r) {
    return r.data;
  });
};
var translateName = function translateName() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (!name.startsWith('untitled')) {
    return name;
  } else {
    var splittedName = name.split('-');
    return [i18n$1.t("connectionBar.".concat(splittedName[0])), splittedName[1]].join(' ');
  }
};
var isLostQRCodeError = function isLostQRCodeError(errorMessage) {
  var disconnectionCauses = {
    lostQrCodeErrors: ['401', '419', 'unknown error', 'unpaired from phone']
  };
  return !!disconnectionCauses.lostQrCodeErrors.find(function (code) {
    var regex = new RegExp(code);
    return regex.test(errorMessage);
  });
};
var getChatBotsFluxes = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var response;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return http$1.get('flux', loadParameterHeader());

          case 2:
            response = _context.sent;

            if (!(response && response.data)) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return", response.data.filter(function (flux) {
              return flux.botId;
            }));

          case 5:
            return _context.abrupt("return", []);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getChatBotsFluxes() {
    return _ref2.apply(this, arguments);
  };
}();
var inactivateFluxes = function inactivateFluxes(fluxes) {
  http$1.put("flux/inactive", fluxes, loadParameterHeader());
};

var _window$octadesk, _window$octadesk$apis, _window$octadesk2, _window$octadesk2$api;

var configs = {
  apis: {
    analytics: (_window$octadesk = window.octadesk) === null || _window$octadesk === void 0 ? void 0 : (_window$octadesk$apis = _window$octadesk.apis) === null || _window$octadesk$apis === void 0 ? void 0 : _window$octadesk$apis.analytics,
    integrator: "".concat((_window$octadesk2 = window.octadesk) === null || _window$octadesk2 === void 0 ? void 0 : (_window$octadesk2$api = _window$octadesk2.apis) === null || _window$octadesk2$api === void 0 ? void 0 : _window$octadesk2$api.chatUrl, "/integrator")
  }
};

var getClient$1 = function getClient() {
  var _loadParameterHeader = loadParameterHeader(),
      headers = _loadParameterHeader.headers;

  return createClient({
    baseURL: configs.apis.integrator,
    headers: headers
  });
};

var getIntegratorWhatsappNumbers = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var response;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return getClient$1().get('/whatsapp/numbers');

          case 3:
            response = _context.sent;

            if (!response.data) {
              _context.next = 8;
              break;
            }

            return _context.abrupt("return", response.data);

          case 8:
            throw new Error('Error on getIntegratorWhatsappNumbers');

          case 9:
            _context.next = 14;
            break;

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](0);
            console.error(_context.t0);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 11]]);
  }));

  return function getIntegratorWhatsappNumbers() {
    return _ref.apply(this, arguments);
  };
}();
var addWhatsappApiNumber = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(number) {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", getClient$1().post('/whatsapp/360dialog/numbers/', number));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function addWhatsappApiNumber(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var updateWhatsappApiNumber = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(number) {
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", getClient$1().put("/whatsapp/numbers/".concat(number.id), number));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function updateWhatsappApiNumber(_x2) {
    return _ref3.apply(this, arguments);
  };
}();
var deleteWhatsappApiNumber = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(numberId) {
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", getClient$1().delete("/whatsapp/numbers/".concat(numberId)));

          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function deleteWhatsappApiNumber(_x3) {
    return _ref4.apply(this, arguments);
  };
}();

var getMainUrl = function getMainUrl() {
  var _window, _window$octadesk, _window$octadesk$apis;

  return (_window = window) === null || _window === void 0 ? void 0 : (_window$octadesk = _window.octadesk) === null || _window$octadesk === void 0 ? void 0 : (_window$octadesk$apis = _window$octadesk.apis) === null || _window$octadesk$apis === void 0 ? void 0 : _window$octadesk$apis.main;
};

var getClient$2 = function getClient() {
  var _loadParameterHeader = loadParameterHeader(),
      headers = _loadParameterHeader.headers;

  return createClient$1({
    baseURL: getMainUrl(),
    headers: headers
  });
};

var getCompany = function getCompany() {
  var client = getClient$2();
  return client.get("/company/getCompanyModel").then(function (r) {
    return r.data;
  });
};

var wppSetUserLogged = function wppSetUserLogged(context, userLogged) {
  context.commit(WPP_SET_USER_LOGGED, userLogged);
};
var wppSetUserToken = function wppSetUserToken(context, userToken) {
  context.commit(WPP_SET_USER_TOKEN, userToken);
};
var wppSetSubdomainStatus = function wppSetSubdomainStatus(_ref, status) {
  var commit = _ref.commit;
  return commit(WPP_SET_SUBDOMAIN_STATUS, status);
};
var fetchSettings = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(context) {
    var getSettings$1;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getSettings();

          case 2:
            getSettings$1 = _context.sent;
            context.commit(SET_SETTINGS, getSettings$1);
            return _context.abrupt("return", settings);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchSettings(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var setCompany = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(context) {
    var companyModel;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getCompany();

          case 2:
            companyModel = _context2.sent;
            context.commit(SET_COMPANY, companyModel);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function setCompany(_x2) {
    return _ref3.apply(this, arguments);
  };
}();

var actions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  wppSetUserLogged: wppSetUserLogged,
  wppSetUserToken: wppSetUserToken,
  wppSetSubdomainStatus: wppSetSubdomainStatus,
  fetchSettings: fetchSettings,
  setCompany: setCompany
});

var $includes = arrayIncludes.includes;



var USES_TO_LENGTH$3 = arrayMethodUsesToLength('indexOf', { ACCESSORS: true, 1: 0 });

// `Array.prototype.includes` method
// https://tc39.github.io/ecma262/#sec-array.prototype.includes
_export({ target: 'Array', proto: true, forced: !USES_TO_LENGTH$3 }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');

// `String.prototype.includes` method
// https://tc39.github.io/ecma262/#sec-string.prototype.includes
_export({ target: 'String', proto: true, forced: !correctIsRegexpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~String(requireObjectCoercible(this))
      .indexOf(notARegexp(searchString), arguments.length > 1 ? arguments[1] : undefined);
  }
});

var isDebug = function isDebug() {
  return !window.location.href.startsWith('https://') || window.location.href.includes('qaoctadesk') || ['localhost', '127.0.0.1'].includes(window.location.hostname) || window.location.port === '8080';
};
var wppUserLogged = function wppUserLogged(_ref) {
  var wppUserLogged = _ref.wppUserLogged;
  return wppUserLogged || Storage.getItem('userLogged');
};
var wppUserToken = function wppUserToken(_ref2) {
  var wppUserToken = _ref2.wppUserToken;
  return wppUserToken || Storage.getItem('userToken');
};
var wppSubDomainStatus = function wppSubDomainStatus(_ref3) {
  var wppSubDomainStatus = _ref3.wppSubDomainStatus;
  return wppSubDomainStatus || Storage.getItem('status');
};
var settings$1 = function settings(_ref4) {
  var settings = _ref4.settings;
  return settings;
};
var company = function company(_ref5) {
  var company = _ref5.company;
  return company;
};
var availableFeatures = function availableFeatures(_ref6) {
  var _company$companyDTO;

  var company = _ref6.company;
  return company === null || company === void 0 ? void 0 : (_company$companyDTO = company.companyDTO) === null || _company$companyDTO === void 0 ? void 0 : _company$companyDTO.features;
};

var getters = /*#__PURE__*/Object.freeze({
  __proto__: null,
  isDebug: isDebug,
  wppUserLogged: wppUserLogged,
  wppUserToken: wppUserToken,
  wppSubDomainStatus: wppSubDomainStatus,
  settings: settings$1,
  company: company,
  availableFeatures: availableFeatures
});

var state$1 = {
  disconnectedNumbers: [],
  recentConnectedNumbers: [],
  connectingNumbers: [],
  socketEventsQueue: {},
  canShowBar: false,
  inLoaderShowBar: false,
  disableReconnectingReOpen: false
};

var $forEach = arrayIteration.forEach;



var STRICT_METHOD$2 = arrayMethodIsStrict('forEach');
var USES_TO_LENGTH$4 = arrayMethodUsesToLength('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.github.io/ecma262/#sec-array.prototype.foreach
var arrayForEach = (!STRICT_METHOD$2 || !USES_TO_LENGTH$4) ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
} : [].forEach;

// `Array.prototype.forEach` method
// https://tc39.github.io/ecma262/#sec-array.prototype.foreach
_export({ target: 'Array', proto: true, forced: [].forEach != arrayForEach }, {
  forEach: arrayForEach
});

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

for (var COLLECTION_NAME in domIterables) {
  var Collection = global_1[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== arrayForEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', arrayForEach);
  } catch (error) {
    CollectionPrototype.forEach = arrayForEach;
  }
}

var CAN_SHOW_BAR = 'CAN_SHOW_BAR';
var DISABLE_REOPEN = 'DISABLE_REOPEN';
var REMOVE_FROM_SOCKET_QUEUE = 'REMOVE_FROM_SOCKET_QUEUE';
var REMOVE_NUMBER = 'REMOVE_NUMBER';
var ADD_NUMBER = 'ADD_NUMBER';
var SET_LOADER_SHOW_BAR = 'SET_LOADER_SHOW_BAR';

var types$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  CAN_SHOW_BAR: CAN_SHOW_BAR,
  DISABLE_REOPEN: DISABLE_REOPEN,
  REMOVE_FROM_SOCKET_QUEUE: REMOVE_FROM_SOCKET_QUEUE,
  REMOVE_NUMBER: REMOVE_NUMBER,
  ADD_NUMBER: ADD_NUMBER,
  SET_LOADER_SHOW_BAR: SET_LOADER_SHOW_BAR
});

// This file is a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239
var metadata = {"version":"1.7.54","country_calling_codes":{"1":["US","AG","AI","AS","BB","BM","BS","CA","DM","DO","GD","GU","JM","KN","KY","LC","MP","MS","PR","SX","TC","TT","VC","VG","VI"],"7":["RU","KZ"],"20":["EG"],"27":["ZA"],"30":["GR"],"31":["NL"],"32":["BE"],"33":["FR"],"34":["ES"],"36":["HU"],"39":["IT","VA"],"40":["RO"],"41":["CH"],"43":["AT"],"44":["GB","GG","IM","JE"],"45":["DK"],"46":["SE"],"47":["NO","SJ"],"48":["PL"],"49":["DE"],"51":["PE"],"52":["MX"],"53":["CU"],"54":["AR"],"55":["BR"],"56":["CL"],"57":["CO"],"58":["VE"],"60":["MY"],"61":["AU","CC","CX"],"62":["ID"],"63":["PH"],"64":["NZ"],"65":["SG"],"66":["TH"],"81":["JP"],"82":["KR"],"84":["VN"],"86":["CN"],"90":["TR"],"91":["IN"],"92":["PK"],"93":["AF"],"94":["LK"],"95":["MM"],"98":["IR"],"211":["SS"],"212":["MA","EH"],"213":["DZ"],"216":["TN"],"218":["LY"],"220":["GM"],"221":["SN"],"222":["MR"],"223":["ML"],"224":["GN"],"225":["CI"],"226":["BF"],"227":["NE"],"228":["TG"],"229":["BJ"],"230":["MU"],"231":["LR"],"232":["SL"],"233":["GH"],"234":["NG"],"235":["TD"],"236":["CF"],"237":["CM"],"238":["CV"],"239":["ST"],"240":["GQ"],"241":["GA"],"242":["CG"],"243":["CD"],"244":["AO"],"245":["GW"],"246":["IO"],"247":["AC"],"248":["SC"],"249":["SD"],"250":["RW"],"251":["ET"],"252":["SO"],"253":["DJ"],"254":["KE"],"255":["TZ"],"256":["UG"],"257":["BI"],"258":["MZ"],"260":["ZM"],"261":["MG"],"262":["RE","YT"],"263":["ZW"],"264":["NA"],"265":["MW"],"266":["LS"],"267":["BW"],"268":["SZ"],"269":["KM"],"290":["SH","TA"],"291":["ER"],"297":["AW"],"298":["FO"],"299":["GL"],"350":["GI"],"351":["PT"],"352":["LU"],"353":["IE"],"354":["IS"],"355":["AL"],"356":["MT"],"357":["CY"],"358":["FI","AX"],"359":["BG"],"370":["LT"],"371":["LV"],"372":["EE"],"373":["MD"],"374":["AM"],"375":["BY"],"376":["AD"],"377":["MC"],"378":["SM"],"380":["UA"],"381":["RS"],"382":["ME"],"383":["XK"],"385":["HR"],"386":["SI"],"387":["BA"],"389":["MK"],"420":["CZ"],"421":["SK"],"423":["LI"],"500":["FK"],"501":["BZ"],"502":["GT"],"503":["SV"],"504":["HN"],"505":["NI"],"506":["CR"],"507":["PA"],"508":["PM"],"509":["HT"],"590":["GP","BL","MF"],"591":["BO"],"592":["GY"],"593":["EC"],"594":["GF"],"595":["PY"],"596":["MQ"],"597":["SR"],"598":["UY"],"599":["CW","BQ"],"670":["TL"],"672":["NF"],"673":["BN"],"674":["NR"],"675":["PG"],"676":["TO"],"677":["SB"],"678":["VU"],"679":["FJ"],"680":["PW"],"681":["WF"],"682":["CK"],"683":["NU"],"685":["WS"],"686":["KI"],"687":["NC"],"688":["TV"],"689":["PF"],"690":["TK"],"691":["FM"],"692":["MH"],"850":["KP"],"852":["HK"],"853":["MO"],"855":["KH"],"856":["LA"],"880":["BD"],"886":["TW"],"960":["MV"],"961":["LB"],"962":["JO"],"963":["SY"],"964":["IQ"],"965":["KW"],"966":["SA"],"967":["YE"],"968":["OM"],"970":["PS"],"971":["AE"],"972":["IL"],"973":["BH"],"974":["QA"],"975":["BT"],"976":["MN"],"977":["NP"],"992":["TJ"],"993":["TM"],"994":["AZ"],"995":["GE"],"996":["KG"],"998":["UZ"]},"countries":{"AC":["247","00","(?:[01589]\\d|[46])\\d{4}",[5,6]],"AD":["376","00","(?:1|6\\d)\\d{7}|[135-9]\\d{5}",[6,8,9],[["(\\d{3})(\\d{3})","$1 $2",["[135-9]"]],["(\\d{4})(\\d{4})","$1 $2",["1"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]]],"AE":["971","00","(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",[5,6,7,8,9,10,11,12],[["(\\d{3})(\\d{2,9})","$1 $2",["60|8"]],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[236]|[479][2-8]"],"0$1"],["(\\d{3})(\\d)(\\d{5})","$1 $2 $3",["[479]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"]],"0"],"AF":["93","00","[2-7]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"]],"0"],"AG":["1","011","(?:268|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([457]\\d{6})$","268$1",0,"268"],"AI":["1","011","(?:264|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2457]\\d{6})$","264$1",0,"264"],"AL":["355","00","(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",[6,7,8,9],[["(\\d{3})(\\d{3,4})","$1 $2",["80|9"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["4[2-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2358][2-5]|4"],"0$1"],["(\\d{3})(\\d{5})","$1 $2",["[23578]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["6"],"0$1"]],"0"],"AM":["374","00","(?:[1-489]\\d|55|60|77)\\d{6}",[8],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[89]0"],"0 $1"],["(\\d{3})(\\d{5})","$1 $2",["2|3[12]"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["1|47"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["[3-9]"],"0$1"]],"0"],"AO":["244","00","[29]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[29]"]]]],"AR":["54","00","11\\d{8}|(?:[2368]|9\\d)\\d{9}",[10,11],[["(\\d{4})(\\d{2})(\\d{4})","$1 $2-$3",["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])","2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)","2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],"0$1",1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["1"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[68]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2-$3",["[23]"],"0$1",1],["(\\d)(\\d{4})(\\d{2})(\\d{4})","$2 15-$3-$4",["9(?:2[2-469]|3[3-578])","9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))","9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)","9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],"0$1",0,"$1 $2 $3-$4"],["(\\d)(\\d{2})(\\d{4})(\\d{4})","$2 15-$3-$4",["91"],"0$1",0,"$1 $2 $3-$4"],["(\\d)(\\d{3})(\\d{3})(\\d{4})","$2 15-$3-$4",["9"],"0$1",0,"$1 $2 $3-$4"]],"0",0,"0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?","9$1"],"AS":["1","011","(?:[58]\\d\\d|684|900)\\d{7}",[10],0,"1",0,"1|([267]\\d{6})$","684$1",0,"684"],"AT":["43","00","1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",[4,5,6,7,8,9,10,11,12,13],[["(\\d)(\\d{3,12})","$1 $2",["1(?:11|[2-9])"],"0$1"],["(\\d{3})(\\d{2})","$1 $2",["517"],"0$1"],["(\\d{2})(\\d{3,5})","$1 $2",["5[079]"],"0$1"],["(\\d{3})(\\d{3,10})","$1 $2",["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"],"0$1"],["(\\d{4})(\\d{3,9})","$1 $2",["[2-467]|5[2-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["5"],"0$1"],["(\\d{2})(\\d{4})(\\d{4,7})","$1 $2 $3",["5"],"0$1"]],"0"],"AU":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d{7,8}|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",[5,6,7,8,9,10],[["(\\d{2})(\\d{3,4})","$1 $2",["16"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,4})","$1 $2 $3",["16"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["14|4"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[2378]"],"(0$1)"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:30|[89])"]]],"0",0,"0|(183[12])",0,0,0,[["8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-7]|3[2-4]|[4-6]\\d))|91(?:[0-57-9]\\d|6[0135-9])\\d)\\d{3}|(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8])|8(?:6[0-8]|[78]\\d|9[02-9]))\\d{6}",[9]],["4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,["163\\d{2,6}",[5,6,7,8,9]],["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}",[6,8,10]]],"0011"],"AW":["297","00","(?:[25-79]\\d\\d|800)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[25-9]"]]]],"AX":["358","00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))","2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",[5,6,7,8,9,10,11,12],0,"0",0,0,0,0,"18",0,"00"],"AZ":["994","00","365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["90"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[28]|2|365|46","1[28]|2|365|46","1[28]|2|365(?:[0-46-9]|5[0-35-9])|46"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[13-9]"],"0$1"]],"0"],"BA":["387","00","6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["6[1-3]|[7-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2-$3",["[3-5]|6[56]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["6"],"0$1"]],"0"],"BB":["1","011","(?:246|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-9]\\d{6})$","246$1",0,"246"],"BD":["880","00","1\\d{9}|2\\d{7,8}|88\\d{4,6}|(?:8[0-79]|9\\d)\\d{4,8}|(?:[346]\\d|[57])\\d{5,8}",[6,7,8,9,10],[["(\\d{2})(\\d{4,6})","$1-$2",["31[5-8]|[459]1"],"0$1"],["(\\d{3})(\\d{3,7})","$1-$2",["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:28|4[14]|5)|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"],"0$1"],["(\\d{4})(\\d{3,6})","$1-$2",["[13-9]"],"0$1"],["(\\d)(\\d{7,8})","$1-$2",["2"],"0$1"]],"0"],"BE":["32","00","4\\d{8}|[1-9]\\d{7}",[8,9],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:80|9)0"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[239]|4[23]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[15-8]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4"],"0$1"]],"0"],"BF":["226","00","[025-7]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[025-7]"]]]],"BG":["359","00","[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",[6,7,8,9],[["(\\d)(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["2"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["43[1-6]|70[1-9]"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:70|8)0"],"0$1"],["(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["43[1-7]|7"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[48]|9[08]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"]],"0"],"BH":["973","00","[136-9]\\d{7}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[13679]|8[047]"]]]],"BI":["257","00","(?:[267]\\d|31)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2367]"]]]],"BJ":["229","00","(?:[2689]\\d|51)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[25689]"]]]],"BL":["590","00","(?:590|69\\d|976)\\d{6}",[9],0,"0",0,0,0,0,0,[["590(?:2[7-9]|5[12]|87)\\d{4}"],["69(?:0\\d\\d|1(?:2[29]|3[0-5]))\\d{4}"],0,0,0,0,0,0,["976[01]\\d{5}"]]],"BM":["1","011","(?:441|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-8]\\d{6})$","441$1",0,"441"],"BN":["673","00","[2-578]\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-578]"]]]],"BO":["591","00(?:1\\d)?","(?:[2-467]\\d\\d|8001)\\d{5}",[8,9],[["(\\d)(\\d{7})","$1 $2",["[23]|4[46]"]],["(\\d{8})","$1",["[67]"]],["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["8"]]],"0",0,"0(1\\d)?"],"BQ":["599","00","(?:[34]1|7\\d)\\d{5}",[7],0,0,0,0,0,0,"[347]"],"BR":["55","00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)","(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-24679]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",[8,9,10,11],[["(\\d{4})(\\d{4})","$1-$2",["300|4(?:0[02]|37)","4(?:02|37)0|[34]00"]],["(\\d{3})(\\d{2,3})(\\d{4})","$1 $2 $3",["(?:[358]|90)0"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"],"($1)"],["(\\d{2})(\\d{5})(\\d{4})","$1 $2-$3",["[16][1-9]|[2-57-9]"],"($1)"]],"0",0,"(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?","$2"],"BS":["1","011","(?:242|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([3-8]\\d{6})$","242$1",0,"242"],"BT":["975","00","[17]\\d{7}|[2-8]\\d{6}",[7,8],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[2-68]|7[246]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[67]|7"]]]],"BW":["267","00","90\\d{5}|(?:[2-6]|7\\d)\\d{6}",[7,8],[["(\\d{2})(\\d{5})","$1 $2",["90"]],["(\\d{3})(\\d{4})","$1 $2",["[2-6]"]],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["7"]]]],"BY":["375","810","(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",[6,7,8,9,10,11],[["(\\d{3})(\\d{3})","$1 $2",["800"],"8 $1"],["(\\d{3})(\\d{2})(\\d{2,4})","$1 $2 $3",["800"],"8 $1"],["(\\d{4})(\\d{2})(\\d{3})","$1 $2-$3",["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])","1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"],"8 0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["1(?:[56]|7[467])|2[1-3]"],"8 0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-4]"],"8 0$1"],["(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["[89]"],"8 $1"]],"8",0,"0|80?",0,0,0,0,"8~10"],"BZ":["501","00","(?:0800\\d|[2-8])\\d{6}",[7,11],[["(\\d{3})(\\d{4})","$1-$2",["[2-8]"]],["(\\d)(\\d{3})(\\d{4})(\\d{3})","$1-$2-$3-$4",["0"]]]],"CA":["1","011","(?:[2-8]\\d|90)\\d{8}",[10],0,"1",0,0,0,0,0,[["(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|6[57])|4(?:03|1[68]|3[178]|50)|5(?:06|1[49]|48|79|8[17])|6(?:04|13|39|47|72)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}"],[""],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["900[2-9]\\d{6}"],["52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|(?:5(?:00|2[12]|33|44|66|77|88)|622)[2-9]\\d{6}"],0,0,0,["600[2-9]\\d{6}"]]],"CC":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d|8[0-24-9])\\d{7}|[148]\\d{8}|1\\d{5,7}",[6,7,8,9,10],0,"0",0,"0|([59]\\d{7})$","8$1",0,0,[["8(?:51(?:0(?:02|31|60|89)|118)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",[9]],["4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,0,["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}",[6,8,10]]],"0011"],"CD":["243","00","[189]\\d{8}|[1-68]\\d{6}",[7,9],[["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["88"],"0$1"],["(\\d{2})(\\d{5})","$1 $2",["[1-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]"],"0$1"]],"0"],"CF":["236","00","(?:[27]\\d{3}|8776)\\d{4}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[278]"]]]],"CG":["242","00","222\\d{6}|(?:0\\d|80)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["801"]],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["8"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[02]"]]]],"CH":["41","00","8\\d{11}|[2-9]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8[047]|90"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-79]|81"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["8"],"0$1"]],"0"],"CI":["225","00","[02-9]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[02-9]"]]]],"CK":["682","00","[2-578]\\d{4}",[5],[["(\\d{2})(\\d{3})","$1 $2",["[2-578]"]]]],"CL":["56","(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0","12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",[9,10,11],[["(\\d{5})(\\d{4})","$1 $2",["219","2196"],"($1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["44"]],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2[1-3]"],"($1)"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["9[2-9]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"],"($1)"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["60|8"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(\\d{3})(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3 $4",["60"]]]],"CM":["237","00","(?:[26]\\d\\d|88)\\d{6}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["88"]],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[26]"]]]],"CN":["86","00|1(?:[12]\\d|79)\\d\\d00","1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}",[7,8,9,10,11,12],[["(\\d{2})(\\d{5,6})","$1 $2",["(?:10|2[0-57-9])[19]","(?:10|2[0-57-9])(?:10|9[56])","(?:10|2[0-57-9])(?:100|9[56])"],"0$1"],["(\\d{3})(\\d{5,6})","$1 $2",["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]","(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]","85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])","85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["(?:4|80)0"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["10|2(?:[02-57-9]|1[1-9])","10|2(?:[02-57-9]|1[1-9])","10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"],"0$1",1],["(\\d{3})(\\d{7,8})","$1 $2",["9"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["80"],"0$1",1],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[3-578]"],"0$1",1],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["1[3-9]"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3 $4",["[12]"],"0$1",1]],"0",0,"0|(1(?:[12]\\d|79)\\d\\d)",0,0,0,0,"00"],"CO":["57","00(?:4(?:[14]4|56)|[579])","(?:1\\d|3)\\d{9}|[124-8]\\d{7}",[8,10,11],[["(\\d)(\\d{7})","$1 $2",["[14][2-9]|[25-8]"],"($1)"],["(\\d{3})(\\d{7})","$1 $2",["3"]],["(\\d)(\\d{3})(\\d{7})","$1-$2-$3",["1"],"0$1",0,"$1 $2 $3"]],"0",0,"0([3579]|4(?:[14]4|56))?"],"CR":["506","00","(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",[8,10],[["(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[3-9]"]],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[89]"]]],0,0,"(19(?:0[0-2468]|1[09]|20|66|77|99))"],"CU":["53","119","[27]\\d{6,7}|[34]\\d{5,7}|(?:5|8\\d\\d)\\d{7}",[6,7,8,10],[["(\\d{2})(\\d{4,6})","$1 $2",["2[1-4]|[34]"],"(0$1)"],["(\\d)(\\d{6,7})","$1 $2",["7"],"(0$1)"],["(\\d)(\\d{7})","$1 $2",["5"],"0$1"],["(\\d{3})(\\d{7})","$1 $2",["8"],"0$1"]],"0"],"CV":["238","0","(?:[2-59]\\d\\d|800)\\d{4}",[7],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[2-589]"]]]],"CW":["599","00","(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["[3467]"]],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["9[4-8]"]]],0,0,0,0,0,"[69]"],"CX":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d|8[0-24-9])\\d{7}|[148]\\d{8}|1\\d{5,7}",[6,7,8,9,10],0,"0",0,"0|([59]\\d{7})$","8$1",0,0,[["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|235)|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",[9]],["4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,0,["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}",[6,8,10]]],"0011"],"CY":["357","00","(?:[279]\\d|[58]0)\\d{6}",[8],[["(\\d{2})(\\d{6})","$1 $2",["[257-9]"]]]],"CZ":["420","00","(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]|9[015-7]"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]]],"DE":["49","00","[2579]\\d{5,14}|49(?:[05]\\d{10}|[46][1-8]\\d{4,9})|49(?:[0-25]\\d|3[1-689]|7[1-7])\\d{4,8}|49(?:[0-2579]\\d|[34][1-9]|6[0-8])\\d{3}|49\\d{3,4}|(?:1|[368]\\d|4[0-8])\\d{3,13}",[4,5,6,7,8,9,10,11,12,13,14,15],[["(\\d{2})(\\d{3,13})","$1 $2",["3[02]|40|[68]9"],"0$1"],["(\\d{3})(\\d{3,12})","$1 $2",["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1","2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"],"0$1"],["(\\d{4})(\\d{2,11})","$1 $2",["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]","[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["138"],"0$1"],["(\\d{5})(\\d{2,10})","$1 $2",["3"],"0$1"],["(\\d{3})(\\d{5,11})","$1 $2",["181"],"0$1"],["(\\d{3})(\\d)(\\d{4,10})","$1 $2 $3",["1(?:3|80)|9"],"0$1"],["(\\d{3})(\\d{7,8})","$1 $2",["1[67]"],"0$1"],["(\\d{3})(\\d{7,12})","$1 $2",["8"],"0$1"],["(\\d{5})(\\d{6})","$1 $2",["185","1850","18500"],"0$1"],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{4})(\\d{7})","$1 $2",["18[68]"],"0$1"],["(\\d{5})(\\d{6})","$1 $2",["15[0568]"],"0$1"],["(\\d{4})(\\d{7})","$1 $2",["15[1279]"],"0$1"],["(\\d{3})(\\d{8})","$1 $2",["18"],"0$1"],["(\\d{3})(\\d{2})(\\d{7,8})","$1 $2 $3",["1(?:6[023]|7)"],"0$1"],["(\\d{4})(\\d{2})(\\d{7})","$1 $2 $3",["15[279]"],"0$1"],["(\\d{3})(\\d{2})(\\d{8})","$1 $2 $3",["15"],"0$1"]],"0"],"DJ":["253","00","(?:2\\d|77)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[27]"]]]],"DK":["45","00","[2-9]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-9]"]]]],"DM":["1","011","(?:[58]\\d\\d|767|900)\\d{7}",[10],0,"1",0,"1|([2-7]\\d{6})$","767$1",0,"767"],"DO":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,0,0,0,"8[024]9"],"DZ":["213","00","(?:[1-4]|[5-79]\\d|80)\\d{7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-4]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["9"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-8]"],"0$1"]],"0"],"EC":["593","00","1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",[8,9,10,11],[["(\\d)(\\d{3})(\\d{4})","$1 $2-$3",["[2-7]"],"(0$1)",0,"$1-$2-$3"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["9"],"0$1"],["(\\d{4})(\\d{3})(\\d{3,4})","$1 $2 $3",["1"]]],"0"],"EE":["372","00","8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",[7,8,10],[["(\\d{3})(\\d{4})","$1 $2",["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88","[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]],["(\\d{4})(\\d{3,4})","$1 $2",["[45]|8(?:00|[1-49])","[45]|8(?:00[1-9]|[1-49])"]],["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["7"]],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]]],"EG":["20","00","[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",[8,9,10],[["(\\d)(\\d{7,8})","$1 $2",["[23]"],"0$1"],["(\\d{2})(\\d{6,7})","$1 $2",["1[35]|[4-6]|8[2468]|9[235-7]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[189]"],"0$1"]],"0"],"EH":["212","00","[5-8]\\d{8}",[9],0,"0",0,0,0,0,"528[89]"],"ER":["291","00","[178]\\d{6}",[7],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[178]"],"0$1"]],"0"],"ES":["34","00","[5-9]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]00"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-9]"]]]],"ET":["251","00","(?:11|[2-59]\\d)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-59]"],"0$1"]],"0"],"FI":["358","00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))","[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",[5,6,7,8,9,10,11,12],[["(\\d)(\\d{4,9})","$1 $2",["[2568][1-8]|3(?:0[1-9]|[1-9])|9"],"0$1"],["(\\d{3})(\\d{3,7})","$1 $2",["[12]00|[368]|70[07-9]"],"0$1"],["(\\d{2})(\\d{4,8})","$1 $2",["[1245]|7[135]"],"0$1"],["(\\d{2})(\\d{6,10})","$1 $2",["7"],"0$1"]],"0",0,0,0,0,"1[03-79]|[2-9]",0,"00"],"FJ":["679","0(?:0|52)","45\\d{5}|(?:0800\\d|[235-9])\\d{6}",[7,11],[["(\\d{3})(\\d{4})","$1 $2",["[235-9]|45"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]]],0,0,0,0,0,0,0,"00"],"FK":["500","00","[2-7]\\d{4}",[5]],"FM":["691","00","(?:[39]\\d\\d|820)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[389]"]]]],"FO":["298","00","(?:[2-8]\\d|90)\\d{4}",[6],[["(\\d{6})","$1",["[2-9]"]]],0,0,"(10(?:01|[12]0|88))"],"FR":["33","00","[1-9]\\d{8}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0 $1"],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[1-79]"],"0$1"]],"0"],"GA":["241","00","(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",[7,8],[["(\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-7]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["11|[67]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]]],0,0,"0(11\\d{6}|6[256]\\d{6}|7[47]\\d{6})","$1"],"GB":["44","00","[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",[7,9,10],[["(\\d{3})(\\d{4})","$1 $2",["800","8001","80011","800111","8001111"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["845","8454","84546","845464"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["800"],"0$1"],["(\\d{5})(\\d{4,5})","$1 $2",["1(?:38|5[23]|69|76|94)","1(?:(?:38|69)7|5(?:24|39)|768|946)","1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"],"0$1"],["(\\d{4})(\\d{5,6})","$1 $2",["1(?:[2-69][02-9]|[78])"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[25]|7(?:0|6[02-9])","[25]|7(?:0|6(?:[03-9]|2[356]))"],"0$1"],["(\\d{4})(\\d{6})","$1 $2",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[1389]"],"0$1"]],"0",0,0,0,0,0,[["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[03])|(?:4[0-5]|5[0-26-9]|6[0-4]|[78][0-49])\\d\\d)|2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d\\d|1(?:[0-7]\\d\\d|8(?:0\\d|20)))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",[9,10]],["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",[10]],["80[08]\\d{7}|800\\d{6}|8001111"],["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",[7,10]],["70\\d{8}",[10]],0,["(?:3[0347]|55)\\d{8}",[10]],["76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}",[10]],["56\\d{8}",[10]]],0," x"],"GD":["1","011","(?:473|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-9]\\d{6})$","473$1",0,"473"],"GE":["995","00","(?:[3-57]\\d\\d|800)\\d{6}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["32"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[57]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[348]"],"0$1"]],"0"],"GF":["594","00","(?:[56]94|976)\\d{6}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[569]"],"0$1"]],"0"],"GG":["44","00","(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",[7,9,10],0,"0",0,"0|([25-9]\\d{5})$","1481$1",0,0,[["1481[25-9]\\d{5}",[10]],["7(?:(?:781|839)\\d|911[17])\\d{5}",[10]],["80[08]\\d{7}|800\\d{6}|8001111"],["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",[7,10]],["70\\d{8}",[10]],0,["(?:3[0347]|55)\\d{8}",[10]],["76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}",[10]],["56\\d{8}",[10]]]],"GH":["233","00","(?:[235]\\d{3}|800)\\d{5}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["8"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[235]"],"0$1"]],"0"],"GI":["350","00","[256]\\d{7}",[8],[["(\\d{3})(\\d{5})","$1 $2",["2"]]]],"GL":["299","00","(?:19|[2-689]\\d)\\d{4}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["19|[2-689]"]]]],"GM":["220","00","[2-9]\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]]],"GN":["224","00","722\\d{6}|(?:3|6\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["3"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[67]"]]]],"GP":["590","00","(?:590|69\\d|976)\\d{6}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[569]"],"0$1"]],"0",0,0,0,0,0,[["590(?:0[1-68]|1[0-2]|2[0-68]|3[1289]|4[0-24-9]|5[3-579]|6[0189]|7[08]|8[0-689]|9\\d)\\d{4}"],["69(?:0\\d\\d|1(?:2[29]|3[0-5]))\\d{4}"],0,0,0,0,0,0,["976[01]\\d{5}"]]],"GQ":["240","00","222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235]"]],["(\\d{3})(\\d{6})","$1 $2",["[89]"]]]],"GR":["30","00","5005000\\d{3}|(?:[2689]\\d|70)\\d{8}",[10],[["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["21|7"]],["(\\d{4})(\\d{6})","$1 $2",["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2689]"]]]],"GT":["502","00","(?:1\\d{3}|[2-7])\\d{7}",[8,11],[["(\\d{4})(\\d{4})","$1 $2",["[2-7]"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]]],"GU":["1","011","(?:[58]\\d\\d|671|900)\\d{7}",[10],0,"1",0,"1|([3-9]\\d{6})$","671$1",0,"671"],"GW":["245","00","[49]\\d{8}|4\\d{6}",[7,9],[["(\\d{3})(\\d{4})","$1 $2",["40"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"]]]],"GY":["592","001","(?:862\\d|9008)\\d{3}|(?:[2-46]\\d|77)\\d{5}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-46-9]"]]]],"HK":["852","00(?:30|5[09]|[126-9]?)","8[0-46-9]\\d{6,7}|9\\d{4}(?:\\d(?:\\d(?:\\d{4})?)?)?|(?:[235-79]\\d|46)\\d{6}",[5,6,7,8,9,11],[["(\\d{3})(\\d{2,5})","$1 $2",["900","9003"]],["(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]],["(\\d{3})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]],0,0,0,0,0,0,0,"00"],"HN":["504","00","8\\d{10}|[237-9]\\d{7}",[8,11],[["(\\d{4})(\\d{4})","$1-$2",["[237-9]"]]]],"HR":["385","00","(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",[6,7,8,9],[["(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["6[01]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{4})(\\d{3})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[67]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-5]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"]],"0"],"HT":["509","00","[2-489]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[2-489]"]]]],"HU":["36","00","[2357]\\d{8}|[1-9]\\d{7}",[8,9],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"(06 $1)"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"],"(06 $1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-57-9]"],"06 $1"]],"06"],"ID":["62","00[189]","(?:(?:007803|8\\d{4})\\d|[1-36])\\d{6}|[1-9]\\d{8,10}|[2-9]\\d{7}",[7,8,9,10,11,12,13],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["15"]],["(\\d{2})(\\d{5,9})","$1 $2",["2[124]|[36]1"],"(0$1)"],["(\\d{3})(\\d{5,7})","$1 $2",["800"],"0$1"],["(\\d{3})(\\d{5,8})","$1 $2",["[2-79]"],"(0$1)"],["(\\d{3})(\\d{3,4})(\\d{3})","$1-$2-$3",["8[1-35-9]"],"0$1"],["(\\d{3})(\\d{6,8})","$1 $2",["1"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["804"],"0$1"],["(\\d{3})(\\d)(\\d{3})(\\d{3})","$1 $2 $3 $4",["80"],"0$1"],["(\\d{3})(\\d{4})(\\d{4,5})","$1-$2-$3",["8"],"0$1"]],"0"],"IE":["353","00","(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",[7,8,9,10],[["(\\d{2})(\\d{5})","$1 $2",["2[24-9]|47|58|6[237-9]|9[35-9]"],"(0$1)"],["(\\d{3})(\\d{5})","$1 $2",["[45]0"],"(0$1)"],["(\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["1"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2569]|4[1-69]|7[14]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["81"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[78]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["4"],"(0$1)"],["(\\d{2})(\\d)(\\d{3})(\\d{4})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"IL":["972","0(?:0|1[2-9])","1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",[7,8,9,10,11,12],[["(\\d{4})(\\d{3})","$1-$2",["125"]],["(\\d{4})(\\d{2})(\\d{2})","$1-$2-$3",["121"]],["(\\d)(\\d{3})(\\d{4})","$1-$2-$3",["[2-489]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1-$2-$3",["12"]],["(\\d{4})(\\d{6})","$1-$2",["159"]],["(\\d)(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3-$4",["1[7-9]"]],["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})","$1-$2 $3-$4",["15"]]],"0"],"IM":["44","00","1624\\d{6}|(?:[3578]\\d|90)\\d{8}",[10],0,"0",0,"0|([5-8]\\d{5})$","1624$1",0,"74576|(?:16|7[56])24"],"IN":["91","00","(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",[8,9,10,11,12,13],[["(\\d{8})","$1",["5(?:0|2[23]|3[03]|[67]1|88)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"],0,1],["(\\d{4})(\\d{4,5})","$1 $2",["180","1800"],0,1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["140"],0,1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["11|2[02]|33|4[04]|79[1-7]|80[2-46]","11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])","11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]","1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]","1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"],"0$1",1],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807","1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]","1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"],"0$1",1],["(\\d{5})(\\d{5})","$1 $2",["[6-9]"],"0$1",1],["(\\d{4})(\\d{2,4})(\\d{4})","$1 $2 $3",["1(?:6|8[06])","1(?:6|8[06]0)"],0,1],["(\\d{4})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["18"],0,1]],"0"],"IO":["246","00","3\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["3"]]]],"IQ":["964","00","(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-6]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"]],"0"],"IR":["98","00","[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",[4,5,6,7,10],[["(\\d{4,5})","$1",["96"],"0$1"],["(\\d{2})(\\d{4,5})","$1 $2",["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[1-8]"],"0$1"]],"0"],"IS":["354","00|1(?:0(?:01|[12]0)|100)","(?:38\\d|[4-9])\\d{6}",[7,9],[["(\\d{3})(\\d{4})","$1 $2",["[4-9]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["3"]]],0,0,0,0,0,0,0,"00"],"IT":["39","00","0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",[6,7,8,9,10,11],[["(\\d{2})(\\d{4,6})","$1 $2",["0[26]"]],["(\\d{3})(\\d{3,6})","$1 $2",["0[13-57-9][0159]|8(?:03|4[17]|9[245])","0[13-57-9][0159]|8(?:03|4[17]|9(?:2|[45][0-4]))"]],["(\\d{4})(\\d{2,6})","$1 $2",["0(?:[13-579][2-46-8]|8[236-8])"]],["(\\d{4})(\\d{4})","$1 $2",["894"]],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[26]|5"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["1[4679]|[38]"]],["(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[13-57-9][0159]"]],["(\\d{2})(\\d{4})(\\d{5})","$1 $2 $3",["0[26]"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]],["(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["3"]]],0,0,0,0,0,0,[["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"],["3[1-9]\\d{8}|3[2-9]\\d{7}",[9,10]],["80(?:0\\d{3}|3)\\d{3}",[6,9]],["(?:0878\\d\\d|89(?:2|4[5-9]\\d))\\d{3}|89[45][0-4]\\d\\d|(?:1(?:44|6[346])|89(?:5[5-9]|9))\\d{6}",[6,8,9,10]],["1(?:78\\d|99)\\d{6}",[9,10]],0,0,0,["55\\d{8}",[10]],["84(?:[08]\\d{3}|[17])\\d{3}",[6,9]]]],"JE":["44","00","1534\\d{6}|(?:[3578]\\d|90)\\d{8}",[10],0,"0",0,"0|([0-24-8]\\d{5})$","1534$1",0,0,[["1534[0-24-8]\\d{5}"],["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"],["80(?:07(?:35|81)|8901)\\d{4}"],["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"],["701511\\d{4}"],0,["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"],["76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}"],["56\\d{8}"]]],"JM":["1","011","(?:[58]\\d\\d|658|900)\\d{7}",[10],0,"1",0,0,0,0,"658|876"],"JO":["962","00","(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",[8,9],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2356]|87"],"(0$1)"],["(\\d{3})(\\d{5,6})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["70"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["7"],"0$1"]],"0"],"JP":["81","010","00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",[8,9,10,11,12,13,14,15,16,17],[["(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3",["(?:12|57|99)0"],"0$1"],["(\\d{4})(\\d)(\\d{4})","$1-$2-$3",["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:49|80|9[16])","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[78]|96)|477|51[24]|636)|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[78]|96[2457-9])|477|51[24]|636[457-9])|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1-$2-$3",["[36]|4(?:2[09]|7[01])","[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[279]|49|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[0468][01]|[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|2[01]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9])|5(?:2|3[045]|4[0-369]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|49|6(?:[0-24]|36|5[0-3589]|72|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:49|55|83)[29]|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:47[59]|59[89]|8(?:6[68]|9))[019]","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[0468][01]|[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|2[01]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|7(?:[017-9]|6[6-8]))|49|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[0468][01]|[1-3]|5[0-69]|7[015-9]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17|3[015-9]))|4(?:2(?:[13-79]|2[01]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9(?:[019]|4[1-3]|6(?:[0-47-9]|5[01346-9])))|3(?:[29]|7(?:[017-9]|6[6-8]))|49|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:223|8699)[014-9]|(?:48|829(?:2|66)|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"],"0$1"],["(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["[14]|[29][2-9]|5[3-9]|7[2-4679]|8(?:[246-9]|3[3-8]|5[2-9])","[14]|[29][2-9]|5[3-9]|7[2-4679]|8(?:[246-9]|3(?:[3-6][2-9]|7|8[2-5])|5[2-9])"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["800"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[2579]|80"],"0$1"]],"0"],"KE":["254","000","(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",[7,8,9,10],[["(\\d{2})(\\d{5,7})","$1 $2",["[24-6]"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["[17]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],"0"],"KG":["996","00","8\\d{9}|(?:[235-8]\\d|99)\\d{7}",[9,10],[["(\\d{4})(\\d{5})","$1 $2",["3(?:1[346]|[24-79])"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235-79]|88"],"0$1"],["(\\d{3})(\\d{3})(\\d)(\\d{2,3})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"KH":["855","00[14-9]","1\\d{9}|[1-9]\\d{7,8}",[8,9,10],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-9]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"KI":["686","00","(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",[5,8],0,"0"],"KM":["269","00","[3478]\\d{6}",[7],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[3478]"]]]],"KN":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-7]\\d{6})$","869$1",0,"869"],"KP":["850","00|99","85\\d{6}|(?:19\\d|[2-7])\\d{7}",[8,10],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"]],"0"],"KR":["82","00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))","00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",[5,6,8,9,10,11,12,13,14],[["(\\d{2})(\\d{3,4})","$1-$2",["(?:3[1-3]|[46][1-4]|5[1-5])1"],"0$1"],["(\\d{4})(\\d{4})","$1-$2",["1"]],["(\\d)(\\d{3,4})(\\d{4})","$1-$2-$3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60|8"],"0$1"],["(\\d{2})(\\d{3,4})(\\d{4})","$1-$2-$3",["[1346]|5[1-5]"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],["(\\d{2})(\\d{5})(\\d{4})","$1-$2-$3",["5"],"0$1"]],"0",0,"0(8(?:[1-46-8]|5\\d\\d))?"],"KW":["965","00","(?:18|[2569]\\d\\d)\\d{5}",[7,8],[["(\\d{4})(\\d{3,4})","$1 $2",["[169]|2(?:[235]|4[1-35-9])|52"]],["(\\d{3})(\\d{5})","$1 $2",["[25]"]]]],"KY":["1","011","(?:345|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-9]\\d{6})$","345$1",0,"345"],"KZ":["7","810","33622\\d{5}|(?:7\\d|80)\\d{8}",[10],0,"8",0,0,0,0,"33|7",0,"8~10"],"LA":["856","00","[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",[8,9,10],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2[13]|3[14]|[4-8]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["30[013-9]"],"0$1"],["(\\d{2})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[23]"],"0$1"]],"0"],"LB":["961","00","[7-9]\\d{7}|[13-9]\\d{6}",[7,8],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[7-9]"]]],"0"],"LC":["1","011","(?:[58]\\d\\d|758|900)\\d{7}",[10],0,"1",0,"1|([2-8]\\d{6})$","758$1",0,"758"],"LI":["423","00","90\\d{5}|(?:[2378]|6\\d\\d)\\d{6}",[7,9],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[237-9]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["69"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]],"0",0,"0|(1001)"],"LK":["94","00","[1-9]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[1-689]"],"0$1"]],"0"],"LR":["231","00","(?:2|33|5\\d|77|88)\\d{7}|[4-6]\\d{6}",[7,8,9],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[4-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3578]"],"0$1"]],"0"],"LS":["266","00","(?:[256]\\d\\d|800)\\d{5}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[2568]"]]]],"LT":["370","00","(?:[3469]\\d|52|[78]0)\\d{6}",[8],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["52[0-7]"],"(8-$1)",1],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[7-9]"],"8 $1",1],["(\\d{2})(\\d{6})","$1 $2",["37|4(?:[15]|6[1-8])"],"(8-$1)",1],["(\\d{3})(\\d{5})","$1 $2",["[3-6]"],"(8-$1)",1]],"8",0,"[08]"],"LU":["352","00","35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",[4,5,6,7,8,9,10,11],[["(\\d{2})(\\d{3})","$1 $2",["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]],["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["20[2-689]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4",["2(?:[0367]|4[3-8])"]],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["80[01]|90[015]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["20"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4 $5",["2(?:[0367]|4[3-8])"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})","$1 $2 $3 $4",["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]],0,0,"(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"],"LV":["371","00","(?:[268]\\d|90)\\d{6}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[269]|8[01]"]]]],"LY":["218","00","[2-9]\\d{8}",[9],[["(\\d{2})(\\d{7})","$1-$2",["[2-9]"],"0$1"]],"0"],"MA":["212","00","[5-8]\\d{8}",[9],[["(\\d{5})(\\d{4})","$1-$2",["5(?:29|38)","5(?:29|38)[89]","5(?:29|38)[89]0"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5[45]"],"0$1"],["(\\d{4})(\\d{5})","$1-$2",["5(?:2[2-489]|3[5-9]|9)|892","5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|892"],"0$1"],["(\\d{2})(\\d{7})","$1-$2",["8"],"0$1"],["(\\d{3})(\\d{6})","$1-$2",["[5-7]"],"0$1"]],"0",0,0,0,0,0,[["5(?:29(?:[189][05]|2[29]|3[01])|38[89][05])\\d{4}|5(?:2(?:[015-7]\\d|2[02-9]|3[0-578]|4[02-46-8]|8[0235-7]|90)|3(?:[0-47]\\d|5[02-9]|6[02-8]|80|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"],["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:0[016-8]|6[1267]|7[0-27]))\\d{6}"],["80\\d{7}"],["89\\d{7}"],0,0,0,0,["592(?:4[0-2]|93)\\d{4}"]]],"MC":["377","00","870\\d{5}|(?:[349]|6\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["4"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[39]"]],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["6"],"0$1"]],"0"],"MD":["373","00","(?:[235-7]\\d|[89]0)\\d{6}",[8],[["(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["22|3"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[25-7]"],"0$1"]],"0"],"ME":["382","00","(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"],"0$1"]],"0"],"MF":["590","00","(?:590|69\\d|976)\\d{6}",[9],0,"0",0,0,0,0,0,[["590(?:0[079]|[14]3|[27][79]|30|5[0-268]|87)\\d{4}"],["69(?:0\\d\\d|1(?:2[29]|3[0-5]))\\d{4}"],0,0,0,0,0,0,["976[01]\\d{5}"]]],"MG":["261","00","[23]\\d{8}",[9],[["(\\d{2})(\\d{2})(\\d{3})(\\d{2})","$1 $2 $3 $4",["[23]"],"0$1"]],"0",0,"0|([24-9]\\d{6})$","20$1"],"MH":["692","011","329\\d{4}|(?:[256]\\d|45)\\d{5}",[7],[["(\\d{3})(\\d{4})","$1-$2",["[2-6]"]]],"1"],"MK":["389","00","[2-578]\\d{7}",[8],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[347]"],"0$1"],["(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["[58]"],"0$1"]],"0"],"ML":["223","00","[24-9]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24-9]"]]]],"MM":["95","00","1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",[6,7,8,9,10],[["(\\d)(\\d{2})(\\d{3})","$1 $2 $3",["16|2"],"0$1"],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[4-7]|8[1-35]"],"0$1"],["(\\d)(\\d{3})(\\d{4,6})","$1 $2 $3",["9(?:2[0-4]|[35-9]|4[137-9])"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["92"],"0$1"],["(\\d)(\\d{5})(\\d{4})","$1 $2 $3",["9"],"0$1"]],"0"],"MN":["976","001","[12]\\d{7,9}|[57-9]\\d{7}",[8,9,10],[["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[12]1"],"0$1"],["(\\d{4})(\\d{4})","$1 $2",["[57-9]"]],["(\\d{3})(\\d{5,6})","$1 $2",["[12]2[1-3]"],"0$1"],["(\\d{4})(\\d{5,6})","$1 $2",["[12](?:27|3[2-8]|4[2-68]|5[1-4689])","[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"],"0$1"],["(\\d{5})(\\d{4,5})","$1 $2",["[12]"],"0$1"]],"0"],"MO":["853","00","(?:28|[68]\\d)\\d{6}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[268]"]]]],"MP":["1","011","[58]\\d{9}|(?:67|90)0\\d{7}",[10],0,"1",0,"1|([2-9]\\d{6})$","670$1",0,"670"],"MQ":["596","00","69\\d{7}|(?:59|97)6\\d{6}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[569]"],"0$1"]],"0"],"MR":["222","00","(?:[2-4]\\d\\d|800)\\d{5}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-48]"]]]],"MS":["1","011","(?:[58]\\d\\d|664|900)\\d{7}",[10],0,"1",0,"1|([34]\\d{6})$","664$1",0,"664"],"MT":["356","00","3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[2357-9]"]]]],"MU":["230","0(?:0|[24-7]0|3[03])","(?:[2-468]|5\\d)\\d{6}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["[2-46]|8[013]"]],["(\\d{4})(\\d{4})","$1 $2",["5"]]],0,0,0,0,0,0,0,"020"],"MV":["960","0(?:0|19)","(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",[7,10],[["(\\d{3})(\\d{4})","$1-$2",["[3467]|9[13-9]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"]]],0,0,0,0,0,0,0,"00"],"MW":["265","00","1\\d{6}(?:\\d{2})?|(?:[23]1|77|88|99)\\d{7}",[7,9],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["1[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[137-9]"],"0$1"]],"0"],"MX":["52","0[09]","(?:1(?:[01467]\\d|[2359][1-9]|8[1-79])|[2-9]\\d)\\d{8}",[10,11],[["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["33|5[56]|81"],0,1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2-9]"],0,1],["(\\d)(\\d{2})(\\d{4})(\\d{4})","$2 $3 $4",["1(?:33|5[56]|81)"],0,1],["(\\d)(\\d{3})(\\d{3})(\\d{4})","$2 $3 $4",["1"],0,1]],"01",0,"0(?:[12]|4[45])|1",0,0,0,0,"00"],"MY":["60","00","1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1-$2 $3",["[4-79]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1-$2 $3",["1(?:[02469]|[378][1-9])|8"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1-$2 $3",["3"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3-$4",["1[36-8]"]],["(\\d{3})(\\d{3})(\\d{4})","$1-$2 $3",["15"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2 $3",["1"],"0$1"]],"0"],"MZ":["258","00","(?:2|8\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["2|8[2-79]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]]],"NA":["264","00","[68]\\d{7,8}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["88"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["6"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["87"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"]],"0"],"NC":["687","00","[2-57-9]\\d{5}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1.$2.$3",["[2-57-9]"]]]],"NE":["227","00","[0289]\\d{7}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["08"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[089]|2[013]"]]]],"NF":["672","00","[13]\\d{5}",[6],[["(\\d{2})(\\d{4})","$1 $2",["1[0-3]"]],["(\\d)(\\d{5})","$1 $2",["[13]"]]],0,0,"([0-258]\\d{4})$","3$1"],"NG":["234","009","(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}",[7,8,10,11,12,13,14],[["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["78"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]|9(?:0[3-9]|[1-9])"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[3-7]|8[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[7-9]"],"0$1"],["(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["[78]"],"0$1"],["(\\d{3})(\\d{5})(\\d{5,6})","$1 $2 $3",["[78]"],"0$1"]],"0"],"NI":["505","00","(?:1800|[25-8]\\d{3})\\d{4}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[125-8]"]]]],"NL":["31","00","(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|[89]\\d{6,9}|1\\d{4,5}",[5,6,7,8,9,10],[["(\\d{3})(\\d{4,7})","$1 $2",["[89]0"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["66"],"0$1"],["(\\d)(\\d{8})","$1 $2",["6"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-57-9]"],"0$1"]],"0"],"NO":["47","00","(?:0|[2-9]\\d{3})\\d{4}",[5,8],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[489]|5[89]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[235-7]"]]],0,0,0,0,0,"[02-689]|7[0-8]"],"NP":["977","00","9\\d{9}|[1-9]\\d{7}",[8,10],[["(\\d)(\\d{7})","$1-$2",["1[2-6]"],"0$1"],["(\\d{2})(\\d{6})","$1-$2",["[1-8]|9(?:[1-579]|6[2-6])"],"0$1"],["(\\d{3})(\\d{7})","$1-$2",["9"]]],"0"],"NR":["674","00","(?:444|(?:55|8\\d)\\d|666)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[4-68]"]]]],"NU":["683","00","(?:[47]|888\\d)\\d{3}",[4,7],[["(\\d{3})(\\d{4})","$1 $2",["8"]]]],"NZ":["64","0(?:0|161)","[29]\\d{7,9}|50\\d{5}(?:\\d{2,3})?|6[0-35-9]\\d{6}|7\\d{7,8}|8\\d{4,9}|(?:11\\d|[34])\\d{7}",[5,6,7,8,9,10],[["(\\d{2})(\\d{3,8})","$1 $2",["83"],"0$1"],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["50[0367]|[89]0"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1-$2 $3",["24|[346]|7[2-57-9]|9[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:10|74)|[59]|80"],"0$1"],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["1|2[028]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,5})","$1 $2 $3",["2(?:[169]|7[0-35-9])|7|86"],"0$1"]],"0",0,0,0,0,0,0,"00"],"OM":["968","00","(?:1505|[279]\\d{3}|500)\\d{4}|8007\\d{4,5}",[7,8,9],[["(\\d{3})(\\d{4,6})","$1 $2",["[58]"]],["(\\d{2})(\\d{6})","$1 $2",["2"]],["(\\d{4})(\\d{4})","$1 $2",["[179]"]]]],"PA":["507","00","(?:[1-57-9]|6\\d)\\d{6}",[7,8],[["(\\d{3})(\\d{4})","$1-$2",["[1-57-9]"]],["(\\d{4})(\\d{4})","$1-$2",["6"]]]],"PE":["51","19(?:1[124]|77|90)00","(?:[14-8]|9\\d)\\d{7}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["80"],"(0$1)"],["(\\d)(\\d{7})","$1 $2",["1"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["[4-8]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"]]],"0",0,0,0,0,0,0,0," Anexo "],"PF":["689","00","[48]\\d{7}|4\\d{5}",[6,8],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["44"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[48]"]]]],"PG":["675","00|140[1-3]","(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["18|[2-69]|85"]],["(\\d{4})(\\d{4})","$1 $2",["[78]"]]],0,0,0,0,0,0,0,"00"],"PH":["63","00","1800\\d{7,9}|(?:2|[89]\\d{4})\\d{5}|[2-8]\\d{8}|[28]\\d{7}",[6,8,9,10,11,12,13],[["(\\d)(\\d{5})","$1 $2",["2"],"(0$1)"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"(0$1)"],["(\\d{4})(\\d{4,6})","$1 $2",["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2","3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"],"(0$1)"],["(\\d{5})(\\d{4})","$1 $2",["346|4(?:27|9[35])|883","3469|4(?:279|9(?:30|56))|8834"],"(0$1)"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3-7]|8[2-8]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})","$1 $2 $3 $4",["1"]]],"0"],"PK":["92","00","122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",[8,9,10,11,12],[["(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["[89]0"],"0$1"],["(\\d{4})(\\d{5})","$1 $2",["1"]],["(\\d{3})(\\d{6,7})","$1 $2",["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])","9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"],"(0$1)"],["(\\d{2})(\\d{7,8})","$1 $2",["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"],"(0$1)"],["(\\d{5})(\\d{5})","$1 $2",["58"],"(0$1)"],["(\\d{3})(\\d{7})","$1 $2",["3"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[24-9]"],"(0$1)"]],"0"],"PL":["48","00","6\\d{5}(?:\\d{2})?|8\\d{9}|[1-9]\\d{6}(?:\\d{2})?",[6,7,8,9,10],[["(\\d{5})","$1",["19"]],["(\\d{3})(\\d{3})","$1 $2",["11|64"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1","(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["64"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[2-8]|[2-7]|8[1-79]|9[145]"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["8"]]]],"PM":["508","00","[45]\\d{5}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[45]"],"0$1"]],"0"],"PR":["1","011","(?:[589]\\d\\d|787)\\d{7}",[10],0,"1",0,0,0,0,"787|939"],"PS":["970","00","[2489]2\\d{6}|(?:1\\d|5)\\d{8}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2489]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["5"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"PT":["351","00","(?:[26-9]\\d|30)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["2[12]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[236-9]"]]]],"PW":["680","01[12]","(?:[24-8]\\d\\d|345|900)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]]],"PY":["595","00","59\\d{4,6}|(?:[2-46-9]\\d|5[0-8])\\d{4,7}",[6,7,8,9],[["(\\d{3})(\\d{3,6})","$1 $2",["[2-9]0"],"0$1"],["(\\d{2})(\\d{5})","$1 $2",["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"],"(0$1)"],["(\\d{3})(\\d{4,5})","$1 $2",["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["87"]],["(\\d{3})(\\d{6})","$1 $2",["9"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]"],"0$1"]],"0"],"QA":["974","00","[2-7]\\d{7}|(?:2\\d\\d|800)\\d{4}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["2[126]|8"]],["(\\d{4})(\\d{4})","$1 $2",["[2-7]"]]]],"RE":["262","00","9769\\d{5}|(?:26|[68]\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2689]"],"0$1"]],"0",0,0,0,0,"26[23]|69|[89]"],"RO":["40","00","(?:[237]\\d|[89]0)\\d{7}|[23]\\d{5}",[6,9],[["(\\d{3})(\\d{3})","$1 $2",["2[3-6]","2[3-6]\\d9"],"0$1"],["(\\d{2})(\\d{4})","$1 $2",["219|31"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[23]1"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[237-9]"],"0$1"]],"0",0,0,0,0,0,0,0," int "],"RS":["381","00","38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",[6,7,8,9,10,11,12],[["(\\d{3})(\\d{3,9})","$1 $2",["(?:2[389]|39)0|[7-9]"],"0$1"],["(\\d{2})(\\d{5,10})","$1 $2",["[1-36]"],"0$1"]],"0"],"RU":["7","810","[347-9]\\d{9}",[10],[["(\\d{4})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-8]|2[1-9])","7(?:1(?:[0-6]2|7|8[27])|2(?:1[23]|[2-9]2))","7(?:1(?:[0-6]2|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"],"8 ($1)",1],["(\\d{5})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-68]|2[1-9])","7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))","7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"],"8 ($1)",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"8 ($1)",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[3489]"],"8 ($1)",1]],"8",0,0,0,0,"3[04-689]|[489]",0,"8~10"],"RW":["250","00","(?:06|[27]\\d\\d|[89]00)\\d{6}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[7-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"]]],"0"],"SA":["966","00","92\\d{7}|(?:[15]|8\\d)\\d{8}",[9,10],[["(\\d{4})(\\d{5})","$1 $2",["9"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["81"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]]],"0"],"SB":["677","0[01]","(?:[1-6]|[7-9]\\d\\d)\\d{4}",[5,7],[["(\\d{2})(\\d{5})","$1 $2",["7|8[4-9]|9(?:[1-8]|9[0-8])"]]]],"SC":["248","010|0[0-2]","8000\\d{3}|(?:[249]\\d|64)\\d{5}",[7],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[246]|9[57]"]]],0,0,0,0,0,0,0,"00"],"SD":["249","00","[19]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[19]"],"0$1"]],"0"],"SE":["46","00","(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",[6,7,8,9,10],[["(\\d{2})(\\d{2,3})(\\d{2})","$1-$2 $3",["20"],"0$1",0,"$1 $2 $3"],["(\\d{3})(\\d{4})","$1-$2",["9(?:00|39|44)"],"0$1",0,"$1 $2"],["(\\d{2})(\\d{3})(\\d{2})","$1-$2 $3",["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"],"0$1",0,"$1 $2 $3"],["(\\d)(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["8"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2,3})(\\d{2})","$1-$2 $3",["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],"0$1",0,"$1 $2 $3"],["(\\d{3})(\\d{2,3})(\\d{3})","$1-$2 $3",["9(?:00|39|44)"],"0$1",0,"$1 $2 $3"],["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"],"0$1",0,"$1 $2 $3 $4"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["10|7"],"0$1",0,"$1 $2 $3 $4"],["(\\d)(\\d{3})(\\d{3})(\\d{2})","$1-$2 $3 $4",["8"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1-$2 $3 $4",["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{2})(\\d{3})","$1-$2 $3 $4",["9"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4 $5",["[26]"],"0$1",0,"$1 $2 $3 $4 $5"]],"0"],"SG":["65","0[0-3]\\d","(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",[8,10,11],[["(\\d{4})(\\d{4})","$1 $2",["[369]|8(?:01|[1-9])"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]],["(\\d{4})(\\d{4})(\\d{3})","$1 $2 $3",["7"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]]],"SH":["290","00","(?:[256]\\d|8)\\d{3}",[4,5],0,0,0,0,0,0,"[256]"],"SI":["386","00|10(?:22|66|88|99)","[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",[5,6,7,8],[["(\\d{2})(\\d{3,6})","$1 $2",["8[09]|9"],"0$1"],["(\\d{3})(\\d{5})","$1 $2",["59|8"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[37][01]|4[0139]|51|6"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-57]"],"(0$1)"]],"0",0,0,0,0,0,0,"00"],"SJ":["47","00","0\\d{4}|(?:[4589]\\d|79)\\d{6}",[5,8],0,0,0,0,0,0,"79"],"SK":["421","00","[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",[6,7,9],[["(\\d)(\\d{2})(\\d{3,4})","$1 $2 $3",["21"],"0$1"],["(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["[3-5][1-8]1","[3-5][1-8]1[67]"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{2})","$1/$2 $3 $4",["2"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[689]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1/$2 $3 $4",["[3-5]"],"0$1"]],"0"],"SL":["232","00","(?:[2378]\\d|66|99)\\d{6}",[8],[["(\\d{2})(\\d{6})","$1 $2",["[236-9]"],"(0$1)"]],"0"],"SM":["378","00","(?:0549|[5-7]\\d)\\d{6}",[8,10],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-7]"]],["(\\d{4})(\\d{6})","$1 $2",["0"]]],0,0,"([89]\\d{5})$","0549$1"],"SN":["221","00","(?:[378]\\d{4}|93330)\\d{4}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[379]"]]]],"SO":["252","00","[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",[6,7,8,9],[["(\\d{2})(\\d{4})","$1 $2",["8[125]"]],["(\\d{6})","$1",["[134]"]],["(\\d)(\\d{6})","$1 $2",["[15]|2[0-79]|3[0-46-8]|4[0-7]"]],["(\\d)(\\d{7})","$1 $2",["24|[67]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[3478]|64|90"]],["(\\d{2})(\\d{5,7})","$1 $2",["1|28|6[1-35-9]|9[2-9]"]]],"0"],"SR":["597","00","(?:[2-5]|68|[78]\\d)\\d{5}",[6,7],[["(\\d{2})(\\d{2})(\\d{2})","$1-$2-$3",["56"]],["(\\d{3})(\\d{3})","$1-$2",["[2-5]"]],["(\\d{3})(\\d{4})","$1-$2",["[6-8]"]]]],"SS":["211","00","[19]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[19]"],"0$1"]],"0"],"ST":["239","00","(?:22|9\\d)\\d{5}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[29]"]]]],"SV":["503","00","[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?",[7,8,11],[["(\\d{3})(\\d{4})","$1 $2",["[89]"]],["(\\d{4})(\\d{4})","$1 $2",["[267]"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[89]"]]]],"SX":["1","011","7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|(5\\d{6})$","721$1",0,"721"],"SY":["963","00","[1-39]\\d{8}|[1-5]\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-5]"],"0$1",1],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1",1]],"0"],"SZ":["268","00","0800\\d{4}|(?:[237]\\d|900)\\d{6}",[8,9],[["(\\d{4})(\\d{4})","$1 $2",["[0237]"]],["(\\d{5})(\\d{4})","$1 $2",["9"]]]],"TA":["290","00","8\\d{3}",[4],0,0,0,0,0,0,"8"],"TC":["1","011","(?:[58]\\d\\d|649|900)\\d{7}",[10],0,"1",0,"1|([2-479]\\d{6})$","649$1",0,"649"],"TD":["235","00|16","(?:22|[69]\\d|77)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2679]"]]],0,0,0,0,0,0,0,"00"],"TG":["228","00","[279]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[279]"]]]],"TH":["66","00[1-9]","1\\d{9}|[1689]\\d{8}|[1-57]\\d{7}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[13-9]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"TJ":["992","810","(?:00|11|[3-57-9]\\d)\\d{7}",[9],[["(\\d{6})(\\d)(\\d{2})","$1 $2 $3",["331","3317"],0,1],["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["[34]7|91[78]"],0,1],["(\\d{4})(\\d)(\\d{4})","$1 $2 $3",["3"],0,1],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[0457-9]|11"],0,1]],"8",0,0,0,0,0,0,"8~10"],"TK":["690","00","[2-47]\\d{3,6}",[4,5,6,7]],"TL":["670","00","7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["[2-489]|70"]],["(\\d{4})(\\d{4})","$1 $2",["7"]]]],"TM":["993","810","[1-6]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["12"],"(8 $1)"],["(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-5]"],"(8 $1)"],["(\\d{2})(\\d{6})","$1 $2",["6"],"8 $1"]],"8",0,0,0,0,0,0,"8~10"],"TN":["216","00","[2-57-9]\\d{7}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-57-9]"]]]],"TO":["676","00","(?:0800|[5-8]\\d{3})\\d{3}|[2-8]\\d{4}",[5,7],[["(\\d{2})(\\d{3})","$1-$2",["[2-4]|50|6[09]|7[0-24-69]|8[05]"]],["(\\d{4})(\\d{3})","$1 $2",["0"]],["(\\d{3})(\\d{4})","$1 $2",["[5-8]"]]]],"TR":["90","00","(?:4|8\\d{5})\\d{6}|(?:[2-58]\\d\\d|900)\\d{7}",[7,10,12],[["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["512|8[0589]|90"],"0$1",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5(?:[0-59]|61)","5(?:[0-59]|616)","5(?:[0-59]|6161)"],"0$1",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24][1-8]|3[1-9]"],"(0$1)",1],["(\\d{3})(\\d{3})(\\d{6})","$1 $2 $3",["80"],"0$1",1]],"0"],"TT":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-46-8]\\d{6})$","868$1",0,"868"],"TV":["688","00","(?:2|7\\d\\d|90)\\d{4}",[5,6,7],[["(\\d{2})(\\d{3})","$1 $2",["2"]],["(\\d{2})(\\d{4})","$1 $2",["90"]],["(\\d{2})(\\d{5})","$1 $2",["7"]]]],"TW":["886","0(?:0[25-79]|19)","[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",[7,8,9,10,11],[["(\\d{2})(\\d)(\\d{4})","$1 $2 $3",["202"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[258]0"],"0$1"],["(\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]","[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"],"0$1"],["(\\d{2})(\\d{4})(\\d{4,5})","$1 $2 $3",["7"],"0$1"]],"0",0,0,0,0,0,0,0,"#"],"TZ":["255","00[056]","(?:[26-8]\\d|41|90)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[24]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[67]"],"0$1"]],"0"],"UA":["380","00","[89]\\d{9}|[3-9]\\d{8}",[9,10],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]","6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["4[45][0-5]|5(?:0|6[37])|6(?:[12][018]|[36-8])|7|89|9[1-9]|(?:48|57)[0137-9]","4[45][0-5]|5(?:0|6(?:3[14-7]|7))|6(?:[12][018]|[36-8])|7|89|9[1-9]|(?:48|57)[0137-9]"],"0$1"],["(\\d{4})(\\d{5})","$1 $2",["[3-6]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],"0",0,0,0,0,0,0,"0~0"],"UG":["256","00[057]","800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",[9],[["(\\d{4})(\\d{5})","$1 $2",["202","2024"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["[27-9]|4(?:6[45]|[7-9])"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["[34]"],"0$1"]],"0"],"US":["1","011","[2-9]\\d{9}",[10],[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",["[2-9]"],0,1,"$1-$2-$3"]],"1",0,0,0,0,0,[["(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[0135]|3[0-24679]|4[167]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[0235]|58|6[39]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[013-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[0179]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[02-59]|8[156])|8(?:0[1-68]|1[02-8]|2[08]|3[0-28]|4[3578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[0179]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"],[""],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["900[2-9]\\d{6}"],["52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"]]],"UY":["598","0(?:0|1[3-9]\\d)","(?:[249]\\d\\d|80)\\d{5}|9\\d{6}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["8|90"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"],["(\\d{4})(\\d{4})","$1 $2",["[24]"]]],"0",0,0,0,0,0,0,"00"," int. "],"UZ":["998","810","55501\\d{4}|(?:[679]\\d|88)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-9]"],"8 $1"]],"8",0,0,0,0,0,0,"8~10"],"VA":["39","00","0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",[6,7,8,9,10,11],0,0,0,0,0,0,"06698"],"VC":["1","011","(?:[58]\\d\\d|784|900)\\d{7}",[10],0,"1",0,"1|([2-7]\\d{6})$","784$1",0,"784"],"VE":["58","00","[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",[10],[["(\\d{3})(\\d{7})","$1-$2",["[24-689]"],"0$1"]],"0"],"VG":["1","011","(?:284|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-578]\\d{6})$","284$1",0,"284"],"VI":["1","011","[58]\\d{9}|(?:34|90)0\\d{7}",[10],0,"1",0,"1|([2-9]\\d{6})$","340$1",0,"340"],"VN":["84","00","[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",[7,8,9,10],[["(\\d{2})(\\d{5})","$1 $2",["80"],"0$1",1],["(\\d{4})(\\d{4,6})","$1 $2",["1"],0,1],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[69]"],"0$1",1],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[3578]"],"0$1",1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["2[48]"],"0$1",1],["(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["2"],"0$1",1]],"0"],"VU":["678","00","(?:[23]\\d|[48]8)\\d{3}|(?:[57]\\d|90)\\d{5}",[5,7],[["(\\d{3})(\\d{4})","$1 $2",["[579]"]]]],"WF":["681","00","(?:[45]0|68|72|8\\d)\\d{4}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[4-8]"]]]],"WS":["685","0","(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",[5,6,7,10],[["(\\d{5})","$1",["[2-5]|6[1-9]"]],["(\\d{3})(\\d{3,7})","$1 $2",["[68]"]],["(\\d{2})(\\d{5})","$1 $2",["7"]]]],"XK":["383","00","[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-4]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[23]"],"0$1"]],"0"],"YE":["967","00","(?:1|7\\d)\\d{7}|[1-7]\\d{6}",[7,8,9],[["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-6]|7[24-68]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["7"],"0$1"]],"0"],"YT":["262","00","80\\d{7}|(?:26|63)9\\d{6}",[9],0,"0",0,0,0,0,"269|63"],"ZA":["27","00","[1-79]\\d{8}|8\\d{4,9}",[5,6,7,8,9,10],[["(\\d{2})(\\d{3,4})","$1 $2",["8[1-4]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["8[1-4]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["860"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"]],"0"],"ZM":["260","00","(?:63|80)0\\d{6}|(?:21|[79]\\d)\\d{7}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[28]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["[79]"],"0$1"]],"0"],"ZW":["263","00","2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",[5,6,7,8,9,10],[["(\\d{3})(\\d{3,5})","$1 $2",["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"],"0$1"],["(\\d)(\\d{3})(\\d{2,4})","$1 $2 $3",["[49]"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["80"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2","2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)","2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"],"0$1"],["(\\d{4})(\\d{6})","$1 $2",["8"],"0$1"],["(\\d{2})(\\d{3,5})","$1 $2",["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["29[013-9]|39|54"],"0$1"],["(\\d{4})(\\d{3,5})","$1 $2",["(?:25|54)8","258|5483"],"0$1"]],"0"]},"nonGeographic":{"800":["800",0,"[1-9]\\d{7}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[1-9]"]]],0,0,0,0,0,0,[0,0,["[1-9]\\d{7}"]]],"808":["808",0,"[1-9]\\d{7}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[1-9]"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,0,["[1-9]\\d{7}"]]],"870":["870",0,"[35-7]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[35-7]"]]],0,0,0,0,0,0,[0,["(?:[356]\\d|7[6-8])\\d{7}"]]],"878":["878",0,"10\\d{10}",[12],[["(\\d{2})(\\d{5})(\\d{5})","$1 $2 $3",["1"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,["10\\d{10}"]]],"881":["881",0,"[0-36-9]\\d{8}",[9],[["(\\d)(\\d{3})(\\d{5})","$1 $2 $3",["[0-36-9]"]]],0,0,0,0,0,0,[0,["[0-36-9]\\d{8}"]]],"882":["882",0,"[13]\\d{6}(?:\\d{2,5})?|285\\d{9}|[19]\\d{7}",[7,8,9,10,11,12],[["(\\d{2})(\\d{5})","$1 $2",["16|342"]],["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[19]"]],["(\\d{2})(\\d{4})(\\d{3})","$1 $2 $3",["3[23]"]],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["1"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["34[57]"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["34"]],["(\\d{2})(\\d{4,5})(\\d{5})","$1 $2 $3",["[1-3]"]]],0,0,0,0,0,0,[0,["3(?:37\\d\\d|42)\\d{4}|3(?:2|47|7\\d{3})\\d{7}",[7,9,10,12]],0,0,0,0,0,0,["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:(?:285\\d\\d|3(?:45|[69]\\d{3}))\\d|9[89])\\d{6}"]]],"883":["883",0,"51\\d{7}(?:\\d{3})?",[9,12],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["510"]],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["510"]],["(\\d{4})(\\d{4})(\\d{4})","$1 $2 $3",["5"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,["51[013]0\\d{8}|5100\\d{5}"]]],"888":["888",0,"\\d{11}",[11],[["(\\d{3})(\\d{3})(\\d{5})","$1 $2 $3"]],0,0,0,0,0,0,[0,0,0,0,0,0,["\\d{11}"]]],"979":["979",0,"[1359]\\d{8}",[9],[["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[1359]"]]],0,0,0,0,0,0,[0,0,0,["[1359]\\d{8}"]]]}};

// The minimum length of the national significant number.
var MIN_LENGTH_FOR_NSN = 2; // The ITU says the maximum length should be 15,
// but one can find longer numbers in Germany.

var MAX_LENGTH_FOR_NSN = 17; // The maximum length of the country calling code.

var MAX_LENGTH_COUNTRY_CODE = 3; // Digits accepted in phone numbers
// (ascii, fullwidth, arabic-indic, and eastern arabic digits).

var VALID_DIGITS = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9"; // `DASHES` will be right after the opening square bracket of the "character class"

var DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
var SLASHES = "\uFF0F/";
var DOTS = "\uFF0E.";
var WHITESPACE = " \xA0\xAD\u200B\u2060\u3000";
var BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]"; // export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['

var TILDES = "~\u2053\u223C\uFF5E"; // Regular expression of acceptable punctuation found in phone numbers. This
// excludes punctuation found as a leading character only. This consists of dash
// characters, white space characters, full stops, slashes, square brackets,
// parentheses and tildes. Full-width variants are also present.

var VALID_PUNCTUATION = "".concat(DASHES).concat(SLASHES).concat(DOTS).concat(WHITESPACE).concat(BRACKETS).concat(TILDES);
var PLUS_CHARS = "+\uFF0B"; // const LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+')

/**
 * Checks whether the entire input sequence can be matched
 * against the regular expression.
 * @return {boolean}
 */
function matchesEntirely(text, regular_expression) {
  // If assigning the `''` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  text = text || '';
  return new RegExp('^(?:' + regular_expression + ')$').test(text);
}
/**
 * Merges two arrays.
 * @param  {*} a
 * @param  {*} b
 * @return {*}
 */

function mergeArrays(a, b) {
  var merged = a.slice();

  for (var _iterator = b, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var element = _ref;

    if (a.indexOf(element) < 0) {
      merged.push(element);
    }
  }

  return merged.sort(function (a, b) {
    return a - b;
  }); // ES6 version, requires Set polyfill.
  // let merged = new Set(a)
  // for (const element of b)
  // {
  // 	merged.add(i)
  // }
  // return Array.from(merged).sort((a, b) => a - b)
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// https://stackoverflow.com/a/46971044/970769
var ParseError = function ParseError(code) {
  _classCallCheck(this, ParseError);

  this.name = this.constructor.name;
  this.message = code;
  this.stack = new Error(code).stack;
};
ParseError.prototype = Object.create(Error.prototype);
ParseError.prototype.constructor = ParseError;

// Copy-pasted from:
// https://github.com/substack/semver-compare/blob/master/index.js
//
// Inlining this function because some users reported issues with
// importing from `semver-compare` in a browser with ES6 "native" modules.
//
// Fixes `semver-compare` not being able to compare versions with alpha/beta/etc "tags".
// https://github.com/catamphetamine/libphonenumber-js/issues/381
function compare (a, b) {
  a = a.split('-');
  b = b.split('-');
  var pa = a[0].split('.');
  var pb = b[0].split('.');

  for (var i = 0; i < 3; i++) {
    var na = Number(pa[i]);
    var nb = Number(pb[i]);
    if (na > nb) return 1;
    if (nb > na) return -1;
    if (!isNaN(na) && isNaN(nb)) return 1;
    if (isNaN(na) && !isNaN(nb)) return -1;
  }

  if (a[1] && b[1]) {
    return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
  }

  return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
}

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var V3 = '1.2.0'; // Moved `001` country code to "nonGeographic" section of metadata.

var V4 = '1.7.35';
var DEFAULT_EXT_PREFIX = ' ext. ';
/**
 * See: https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md
 */

var Metadata =
/*#__PURE__*/
function () {
  function Metadata(metadata) {
    _classCallCheck$1(this, Metadata);

    validateMetadata(metadata);
    this.metadata = metadata;
    setVersion.call(this, metadata);
  }

  _createClass(Metadata, [{
    key: "getCountries",
    value: function getCountries() {
      return Object.keys(this.metadata.countries).filter(function (_) {
        return _ !== '001';
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function getCountryMetadata(countryCode) {
      return this.metadata.countries[countryCode];
    }
  }, {
    key: "nonGeographic",
    value: function nonGeographic() {
      if (this.v1 || this.v2 || this.v3) return; // `nonGeographical` was a typo.
      // It's present in metadata generated from `1.7.35` to `1.7.37`.

      return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function hasCountry(country) {
      return this.getCountryMetadata(country) !== undefined;
    }
  }, {
    key: "hasCallingCode",
    value: function hasCallingCode(callingCode) {
      if (this.getCountryCodesForCallingCode(callingCode)) {
        return true;
      }

      if (this.nonGeographic()) {
        if (this.nonGeographic()[callingCode]) {
          return true;
        }
      } else {
        // A hacky workaround for old custom metadata (generated before V4).
        var countryCodes = this.countryCallingCodes()[callingCode];

        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') {
          return true;
        }
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function isNonGeographicCallingCode(callingCode) {
      if (this.nonGeographic()) {
        return this.nonGeographic()[callingCode] ? true : false;
      } else {
        return this.getCountryCodesForCallingCode(callingCode) ? false : true;
      }
    } // Deprecated.

  }, {
    key: "country",
    value: function country(countryCode) {
      return this.selectNumberingPlan(countryCode);
    }
  }, {
    key: "selectNumberingPlan",
    value: function selectNumberingPlan(countryCode, callingCode) {
      if (countryCode && countryCode !== '001') {
        if (!this.hasCountry(countryCode)) {
          throw new Error("Unknown country: ".concat(countryCode));
        }

        this.numberingPlan = new NumberingPlan(this.getCountryMetadata(countryCode), this);
      } else if (callingCode) {
        if (!this.hasCallingCode(callingCode)) {
          throw new Error("Unknown calling code: ".concat(callingCode));
        }

        this.numberingPlan = new NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
      } else {
        this.numberingPlan = undefined;
      }

      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function getCountryCodesForCallingCode(callingCode) {
      var countryCodes = this.countryCallingCodes()[callingCode];

      if (countryCodes) {
        // Metadata before V4 included "non-geographic entity" calling codes
        // inside `country_calling_codes` (for example, `"881":["001"]`).
        // Now the semantics of `country_calling_codes` has changed:
        // it's specifically for "countries" now.
        // Older versions of custom metadata will simply skip parsing
        // "non-geographic entity" phone numbers with new versions
        // of this library: it's not considered a bug,
        // because such numbers are extremely rare,
        // and developers extremely rarely use custom metadata.
        if (countryCodes.length === 1 && countryCodes[0].length === 3) {
          return;
        }

        return countryCodes;
      }
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function getCountryCodeForCallingCode(callingCode) {
      var countryCodes = this.getCountryCodesForCallingCode(callingCode);

      if (countryCodes) {
        return countryCodes[0];
      }
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function getNumberingPlanMetadata(callingCode) {
      var countryCode = this.getCountryCodeForCallingCode(callingCode);

      if (countryCode) {
        return this.getCountryMetadata(countryCode);
      }

      if (this.nonGeographic()) {
        var metadata = this.nonGeographic()[callingCode];

        if (metadata) {
          return metadata;
        }
      } else {
        // A hacky workaround for old custom metadata (generated before V4).
        var countryCodes = this.countryCallingCodes()[callingCode];

        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') {
          return this.metadata.countries['001'];
        }
      }
    } // Deprecated.

  }, {
    key: "countryCallingCode",
    value: function countryCallingCode() {
      return this.numberingPlan.callingCode();
    } // Deprecated.

  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      return this.numberingPlan.IDDPrefix();
    } // Deprecated.

  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      return this.numberingPlan.defaultIDDPrefix();
    } // Deprecated.

  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      return this.numberingPlan.nationalNumberPattern();
    } // Deprecated.

  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      return this.numberingPlan.possibleLengths();
    } // Deprecated.

  }, {
    key: "formats",
    value: function formats() {
      return this.numberingPlan.formats();
    } // Deprecated.

  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      return this.numberingPlan.nationalPrefixForParsing();
    } // Deprecated.

  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.numberingPlan.nationalPrefixTransformRule();
    } // Deprecated.

  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.numberingPlan.leadingDigits();
    } // Deprecated.

  }, {
    key: "hasTypes",
    value: function hasTypes() {
      return this.numberingPlan.hasTypes();
    } // Deprecated.

  }, {
    key: "type",
    value: function type(_type) {
      return this.numberingPlan.type(_type);
    } // Deprecated.

  }, {
    key: "ext",
    value: function ext() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function countryCallingCodes() {
      if (this.v1) return this.metadata.country_phone_code_to_countries;
      return this.metadata.country_calling_codes;
    } // Deprecated.

  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function chooseCountryByCountryCallingCode(callingCode) {
      this.selectNumberingPlan(null, callingCode);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function hasSelectedNumberingPlan() {
      return this.numberingPlan !== undefined;
    }
  }]);

  return Metadata;
}();

var NumberingPlan =
/*#__PURE__*/
function () {
  function NumberingPlan(metadata, globalMetadataObject) {
    _classCallCheck$1(this, NumberingPlan);

    this.globalMetadataObject = globalMetadataObject;
    this.metadata = metadata;
    setVersion.call(this, globalMetadataObject.metadata);
  }

  _createClass(NumberingPlan, [{
    key: "callingCode",
    value: function callingCode() {
      return this.metadata[0];
    } // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.

  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function getDefaultCountryMetadataForRegion() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      if (this.v1 || this.v2) return;
      return this.metadata[1];
    }
  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      if (this.v1 || this.v2) return;
      return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      if (this.v1 || this.v2) return this.metadata[1];
      return this.metadata[2];
    }
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.v1) return;
      return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function _getFormats(metadata) {
      return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
    } // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".

  }, {
    key: "formats",
    value: function formats() {
      var _this = this;

      var formats = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return formats.map(function (_) {
        return new Format(_, _this);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function nationalPrefix() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function _getNationalPrefixFormattingRule(metadata) {
      return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
    } // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".

  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function _nationalPrefixForParsing() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      // If `national_prefix_for_parsing` is not set explicitly,
      // then infer it from `national_prefix` (if any)
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function _getNationalPrefixIsOptionalWhenFormatting() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    } // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".

  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function types() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function hasTypes() {
      // Versions 1.2.0 - 1.2.4: can be `[]`.

      /* istanbul ignore next */
      if (this.types() && this.types().length === 0) {
        return false;
      } // Versions <= 1.2.4: can be `undefined`.
      // Version >= 1.2.5: can be `0`.


      return !!this.types();
    }
  }, {
    key: "type",
    value: function type(_type2) {
      if (this.hasTypes() && getType$1(this.types(), _type2)) {
        return new Type(getType$1(this.types(), _type2), this);
      }
    }
  }, {
    key: "ext",
    value: function ext() {
      if (this.v1 || this.v2) return DEFAULT_EXT_PREFIX;
      return this.metadata[13] || DEFAULT_EXT_PREFIX;
    }
  }]);

  return NumberingPlan;
}();

var Format =
/*#__PURE__*/
function () {
  function Format(format, metadata) {
    _classCallCheck$1(this, Format);

    this._format = format;
    this.metadata = metadata;
  }

  _createClass(Format, [{
    key: "pattern",
    value: function pattern() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function format() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function leadingDigitsPatterns() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
      // National prefix is omitted if there's no national prefix formatting rule
      // set for this country, or when the national prefix formatting rule
      // contains no national prefix itself, or when this rule is set but
      // national prefix is optional for this phone number format
      // (and it is not enforced explicitly)
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    } // Checks whether national prefix formatting rule contains national prefix.

  }, {
    key: "usesNationalPrefix",
    value: function usesNationalPrefix() {
      return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()); // Previously, `FIRST_GROUP_ONLY_PREFIX_PATTERN` check was instead done via:
      // // Check that national prefix formatting rule is not a "dummy" one.
      // this.nationalPrefixFormattingRule() !== '$1' &&
      // // Check that national prefix formatting rule actually has national prefix digit(s).
      // // Filters out cases like "($1)".
      // // Is used in place of `libphonenumber`'s `FIRST_GROUP_ONLY_PREFIX_PATTERN_` regexp.
      // /\d/.test(this.nationalPrefixFormattingRule().replace('$1', ''))
    }
  }, {
    key: "internationalFormat",
    value: function internationalFormat() {
      return this._format[5] || this.format();
    }
  }]);

  return Format;
}();
/**
 * A pattern that is used to determine if the national prefix formatting rule
 * has the first group only, i.e., does not start with the national prefix.
 * Note that the pattern explicitly allows for unbalanced parentheses.
 */


var FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;

var Type =
/*#__PURE__*/
function () {
  function Type(type, metadata) {
    _classCallCheck$1(this, Type);

    this.type = type;
    this.metadata = metadata;
  }

  _createClass(Type, [{
    key: "pattern",
    value: function pattern() {
      if (this.metadata.v1) return this.type;
      return this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.metadata.v1) return;
      return this.type[1] || this.metadata.possibleLengths();
    }
  }]);

  return Type;
}();

function getType$1(types, type) {
  switch (type) {
    case 'FIXED_LINE':
      return types[0];

    case 'MOBILE':
      return types[1];

    case 'TOLL_FREE':
      return types[2];

    case 'PREMIUM_RATE':
      return types[3];

    case 'PERSONAL_NUMBER':
      return types[4];

    case 'VOICEMAIL':
      return types[5];

    case 'UAN':
      return types[6];

    case 'PAGER':
      return types[7];

    case 'VOIP':
      return types[8];

    case 'SHARED_COST':
      return types[9];
  }
}

function validateMetadata(metadata) {
  if (!metadata) {
    throw new Error('[libphonenumber-js] `metadata` argument not passed. Check your arguments.');
  } // `country_phone_code_to_countries` was renamed to
  // `country_calling_codes` in `1.0.18`.


  if (!is_object(metadata) || !is_object(metadata.countries)) {
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(is_object(metadata) ? 'an object of shape: { ' + Object.keys(metadata).join(', ') + ' }' : 'a ' + type_of(metadata) + ': ' + metadata, "."));
  }
} // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".

/* istanbul ignore next */

var is_object = function is_object(_) {
  return _typeof(_) === 'object';
}; // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".

/* istanbul ignore next */


var type_of = function type_of(_) {
  return _typeof(_);
};
/**
 * Returns "country calling code" for a country.
 * Throws an error if the country doesn't exist or isn't supported by this library.
 * @param  {string} country
 * @param  {object} metadata
 * @return {string}
 * @example
 * // Returns "44"
 * getCountryCallingCode("GB")
 */

function getCountryCallingCode(country, metadata) {
  metadata = new Metadata(metadata);

  if (metadata.hasCountry(country)) {
    return metadata.country(country).countryCallingCode();
  }

  throw new Error("Unknown country: ".concat(country));
}
function isSupportedCountry(country, metadata) {
  // metadata = new Metadata(metadata)
  // return metadata.hasCountry(country)
  return metadata.countries[country] !== undefined;
}

function setVersion(metadata) {
  this.v1 = !metadata.version;
  this.v2 = metadata.version !== undefined && compare(metadata.version, V3) === -1;
  this.v3 = metadata.version !== undefined && compare(metadata.version, V4) === -1;
  this.v4 = metadata.version !== undefined; // && compare(metadata.version, V5) === -1
} // const ISO_COUNTRY_CODE = /^[A-Z]{2}$/
// function isCountryCode(countryCode) {
// 	return ISO_COUNTRY_CODE.test(countryCodeOrCountryCallingCode)
// }

var RFC3966_EXTN_PREFIX = ';ext='; // Pattern to capture digits used in an extension.
// Places a maximum length of '7' for an extension.

var CAPTURING_EXTN_DIGITS = '([' + VALID_DIGITS + ']{1,7})';
/**
 * Regexp of all possible ways to write extensions, for use when parsing. This
 * will be run as a case-insensitive regexp match. Wide character versions are
 * also provided after each ASCII version. There are three regular expressions
 * here. The first covers RFC 3966 format, where the extension is added using
 * ';ext='. The second more generic one starts with optional white space and
 * ends with an optional full stop (.), followed by zero or more spaces/tabs
 * /commas and then the numbers themselves. The other one covers the special
 * case of American numbers where the extension is written with a hash at the
 * end, such as '- 503#'. Note that the only capturing groups should be around
 * the digits that you want to capture as part of the extension, or else parsing
 * will fail! We allow two options for representing the accented o - the
 * character itself, and one in the unicode decomposed form with the combining
 * acute accent.
 */

function create_extension_pattern(purpose) {
  // One-character symbols that can be used to indicate an extension.
  var single_extension_characters = "x\uFF58#\uFF03~\uFF5E";

  switch (purpose) {
    // For parsing, we are slightly more lenient in our interpretation than for matching. Here we
    // allow "comma" and "semicolon" as possible extension indicators. When matching, these are
    case 'parsing':
      single_extension_characters = ',;' + single_extension_characters;
  }

  return RFC3966_EXTN_PREFIX + CAPTURING_EXTN_DIGITS + '|' + "[ \xA0\\t,]*" + "(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|" + // "доб."
  "\u0434\u043E\u0431|" + '[' + single_extension_characters + "]|int|anexo|\uFF49\uFF4E\uFF54)" + "[:\\.\uFF0E]?[ \xA0\\t,-]*" + CAPTURING_EXTN_DIGITS + '#?|' + '[- ]+([' + VALID_DIGITS + ']{1,5})#';
}
/**
 * Regexp of all possible ways to write extensions, for use when parsing. This
 * will be run as a case-insensitive regexp match. Wide character versions are
 * also provided after each ASCII version. There are three regular expressions
 * here. The first covers RFC 3966 format, where the extension is added using
 * ';ext='. The second more generic one starts with optional white space and
 * ends with an optional full stop (.), followed by zero or more spaces/tabs
 * /commas and then the numbers themselves. The other one covers the special
 * case of American numbers where the extension is written with a hash at the
 * end, such as '- 503#'. Note that the only capturing groups should be around
 * the digits that you want to capture as part of the extension, or else parsing
 * will fail! We allow two options for representing the accented o - the
 * character itself, and one in the unicode decomposed form with the combining
 * acute accent.
 */


var EXTN_PATTERNS_FOR_PARSING = create_extension_pattern('parsing');
var EXTN_PATTERNS_FOR_MATCHING = create_extension_pattern('matching'); // Regexp of all known extension prefixes used by different regions followed by
// 1 or more valid digits, for use when parsing.

var EXTN_PATTERN = new RegExp('(?:' + EXTN_PATTERNS_FOR_PARSING + ')$', 'i'); // Strips any extension (as in, the part of the number dialled after the call is
// connected, usually indicated with extn, ext, x or similar) from the end of
// the number, and returns it.

function extractExtension(number) {
  var start = number.search(EXTN_PATTERN);

  if (start < 0) {
    return {};
  } // If we find a potential extension, and the number preceding this is a viable
  // number, we assume it is an extension.


  var number_without_extension = number.slice(0, start);
  var matches = number.match(EXTN_PATTERN);
  var i = 1;

  while (i < matches.length) {
    if (matches[i] != null && matches[i].length > 0) {
      return {
        number: number_without_extension,
        ext: matches[i]
      };
    }

    i++;
  }
}

//  Checks we have at least three leading digits, and only valid punctuation,
//  alpha characters and digits in the phone number. Does not include extension
//  data. The symbol 'x' is allowed here as valid punctuation since it is often
//  used as a placeholder for carrier codes, for example in Brazilian phone
//  numbers. We also allow multiple '+' characters at the start.
//
//  Corresponds to the following:
//  [digits]{minLengthNsn}|
//  plus_sign*
//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
//
//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
//  they are entered as "15" etc, but only if there is no punctuation in them.
//  The second expression restricts the number of digits to three or more, but
//  then allows them to be in international form, and to have alpha-characters
//  and punctuation. We split up the two reg-exes here and combine them when
//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
//  with ^ and append $ to each branch.
//
//  "Note VALID_PUNCTUATION starts with a -,
//   so must be the first in the range" (c) Google devs.
//  (wtf did they mean by saying that; probably nothing)
//

var MIN_LENGTH_PHONE_NUMBER_PATTERN = '[' + VALID_DIGITS + ']{' + MIN_LENGTH_FOR_NSN + '}'; //
// And this is the second reg-exp:
// (see MIN_LENGTH_PHONE_NUMBER_PATTERN for a full description of this reg-exp)
//

var VALID_PHONE_NUMBER = '[' + PLUS_CHARS + ']{0,1}' + '(?:' + '[' + VALID_PUNCTUATION + ']*' + '[' + VALID_DIGITS + ']' + '){3,}' + '[' + VALID_PUNCTUATION + VALID_DIGITS + ']*'; // The combined regular expression for valid phone numbers:
//

var VALID_PHONE_NUMBER_PATTERN = new RegExp( // Either a short two-digit-only phone number
'^' + MIN_LENGTH_PHONE_NUMBER_PATTERN + '$' + '|' + // Or a longer fully parsed phone number (min 3 characters)
'^' + VALID_PHONE_NUMBER + // Phone number extensions
'(?:' + EXTN_PATTERNS_FOR_PARSING + ')?' + '$', 'i'); // Checks to see if the string of characters could possibly be a phone number at
// all. At the moment, checks to see that the string begins with at least 2
// digits, ignoring any punctuation commonly found in phone numbers. This method
// does not require the number to be normalized in advance - but does assume
// that leading non-number symbols have been removed, such as by the method
// `extract_possible_number`.
//

function isViablePhoneNumber(number) {
  return number.length >= MIN_LENGTH_FOR_NSN && VALID_PHONE_NUMBER_PATTERN.test(number);
}

// These mappings map a character (key) to a specific digit that should
// replace it for normalization purposes. Non-European digits that
// may be used in phone numbers are mapped to a European equivalent.
//
// E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
//
var DIGITS = {
  '0': '0',
  '1': '1',
  '2': '2',
  '3': '3',
  '4': '4',
  '5': '5',
  '6': '6',
  '7': '7',
  '8': '8',
  '9': '9',
  "\uFF10": '0',
  // Fullwidth digit 0
  "\uFF11": '1',
  // Fullwidth digit 1
  "\uFF12": '2',
  // Fullwidth digit 2
  "\uFF13": '3',
  // Fullwidth digit 3
  "\uFF14": '4',
  // Fullwidth digit 4
  "\uFF15": '5',
  // Fullwidth digit 5
  "\uFF16": '6',
  // Fullwidth digit 6
  "\uFF17": '7',
  // Fullwidth digit 7
  "\uFF18": '8',
  // Fullwidth digit 8
  "\uFF19": '9',
  // Fullwidth digit 9
  "\u0660": '0',
  // Arabic-indic digit 0
  "\u0661": '1',
  // Arabic-indic digit 1
  "\u0662": '2',
  // Arabic-indic digit 2
  "\u0663": '3',
  // Arabic-indic digit 3
  "\u0664": '4',
  // Arabic-indic digit 4
  "\u0665": '5',
  // Arabic-indic digit 5
  "\u0666": '6',
  // Arabic-indic digit 6
  "\u0667": '7',
  // Arabic-indic digit 7
  "\u0668": '8',
  // Arabic-indic digit 8
  "\u0669": '9',
  // Arabic-indic digit 9
  "\u06F0": '0',
  // Eastern-Arabic digit 0
  "\u06F1": '1',
  // Eastern-Arabic digit 1
  "\u06F2": '2',
  // Eastern-Arabic digit 2
  "\u06F3": '3',
  // Eastern-Arabic digit 3
  "\u06F4": '4',
  // Eastern-Arabic digit 4
  "\u06F5": '5',
  // Eastern-Arabic digit 5
  "\u06F6": '6',
  // Eastern-Arabic digit 6
  "\u06F7": '7',
  // Eastern-Arabic digit 7
  "\u06F8": '8',
  // Eastern-Arabic digit 8
  "\u06F9": '9' // Eastern-Arabic digit 9

};
function parseDigit(character) {
  return DIGITS[character];
}
/**
 * Parses phone number digits from a string.
 * Drops all punctuation leaving only digits.
 * Also converts wide-ascii and arabic-indic numerals to conventional numerals.
 * E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
 * @param  {string} string
 * @return {string}
 * @example
 * ```js
 * parseDigits('8 (800) 555')
 * // Outputs '8800555'.
 * ```
 */

function parseDigits(string) {
  var result = ''; // Using `.split('')` here instead of normal `for ... of`
  // because the importing application doesn't neccessarily include an ES6 polyfill.
  // The `.split('')` approach discards "exotic" UTF-8 characters
  // (the ones consisting of four bytes) but digits
  // (including non-European ones) don't fall into that range
  // so such "exotic" characters would be discarded anyway.

  for (var _iterator = string.split(''), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var character = _ref;
    var digit = parseDigit(character);

    if (digit) {
      result += digit;
    }
  }

  return result;
}

/**
 * Parses phone number characters from a string.
 * Drops all punctuation leaving only digits and the leading `+` sign (if any).
 * Also converts wide-ascii and arabic-indic numerals to conventional numerals.
 * E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
 * @param  {string} string
 * @return {string}
 * @example
 * ```js
 * // Outputs '8800555'.
 * parseIncompletePhoneNumber('8 (800) 555')
 * // Outputs '+7800555'.
 * parseIncompletePhoneNumber('+7 800 555')
 * ```
 */

function parseIncompletePhoneNumber(string) {
  var result = ''; // Using `.split('')` here instead of normal `for ... of`
  // because the importing application doesn't neccessarily include an ES6 polyfill.
  // The `.split('')` approach discards "exotic" UTF-8 characters
  // (the ones consisting of four bytes) but digits
  // (including non-European ones) don't fall into that range
  // so such "exotic" characters would be discarded anyway.

  for (var _iterator = string.split(''), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var character = _ref;
    result += parsePhoneNumberCharacter(character, result) || '';
  }

  return result;
}
/**
 * `input-format` `parse()` function.
 * https://gitlab.com/catamphetamine/input-format
 * @param  {string} character - Yet another character from raw input string.
 * @param  {string} value - The value parsed so far.
 * @param  {object} meta - Optional custom use-case-specific metadata.
 * @return {string?} The parsed character.
 */

function parsePhoneNumberCharacter(character, value) {
  // Only allow a leading `+`.
  if (character === '+') {
    // If this `+` is not the first parsed character
    // then discard it.
    if (value) {
      return;
    }

    return '+';
  } // Allow digits.


  return parseDigit(character);
}

var NON_FIXED_LINE_PHONE_TYPES = ['MOBILE', 'PREMIUM_RATE', 'TOLL_FREE', 'SHARED_COST', 'VOIP', 'PERSONAL_NUMBER', 'PAGER', 'UAN', 'VOICEMAIL']; // Finds out national phone number type (fixed line, mobile, etc)

function getNumberType(input, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {}; // When `parse()` returned `{}`
  // meaning that the phone number is not a valid one.

  if (!input.country) {
    return;
  }

  metadata = new Metadata(metadata);
  metadata.selectNumberingPlan(input.country, input.countryCallingCode);
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // The following is copy-pasted from the original function:
  // https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835
  // Is this national number even valid for this country

  if (!matchesEntirely(nationalNumber, metadata.nationalNumberPattern())) {
    return;
  } // Is it fixed line number


  if (is_of_type(nationalNumber, 'FIXED_LINE', metadata)) {
    // Because duplicate regular expressions are removed
    // to reduce metadata size, if "mobile" pattern is ""
    // then it means it was removed due to being a duplicate of the fixed-line pattern.
    //
    if (metadata.type('MOBILE') && metadata.type('MOBILE').pattern() === '') {
      return 'FIXED_LINE_OR_MOBILE';
    } // v1 metadata.
    // Legacy.
    // Deprecated.


    if (!metadata.type('MOBILE')) {
      return 'FIXED_LINE_OR_MOBILE';
    } // Check if the number happens to qualify as both fixed line and mobile.
    // (no such country in the minimal metadata set)

    /* istanbul ignore if */


    if (is_of_type(nationalNumber, 'MOBILE', metadata)) {
      return 'FIXED_LINE_OR_MOBILE';
    }

    return 'FIXED_LINE';
  }

  for (var _i = 0, _NON_FIXED_LINE_PHONE = NON_FIXED_LINE_PHONE_TYPES; _i < _NON_FIXED_LINE_PHONE.length; _i++) {
    var _type = _NON_FIXED_LINE_PHONE[_i];

    if (is_of_type(nationalNumber, _type, metadata)) {
      return _type;
    }
  }
}
function is_of_type(nationalNumber, type, metadata) {
  type = metadata.type(type);

  if (!type || !type.pattern()) {
    return false;
  } // Check if any possible number lengths are present;
  // if so, we use them to avoid checking
  // the validation pattern if they don't match.
  // If they are absent, this means they match
  // the general description, which we have
  // already checked before a specific number type.


  if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) {
    return false;
  }

  return matchesEntirely(nationalNumber, type.pattern());
} // Should only be called for the "new" metadata which has "possible lengths".

function checkNumberLengthForType(nationalNumber, type, metadata) {
  var type_info = metadata.type(type); // There should always be "<possiblePengths/>" set for every type element.
  // This is declared in the XML schema.
  // For size efficiency, where a sub-description (e.g. fixed-line)
  // has the same "<possiblePengths/>" as the "general description", this is missing,
  // so we fall back to the "general description". Where no numbers of the type
  // exist at all, there is one possible length (-1) which is guaranteed
  // not to match the length of any real phone number.

  var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths(); // let local_lengths    = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()
  // Metadata before version `1.0.18` didn't contain `possible_lengths`.

  if (!possible_lengths) {
    return 'IS_POSSIBLE';
  }

  if (type === 'FIXED_LINE_OR_MOBILE') {
    // No such country in metadata.

    /* istanbul ignore next */
    if (!metadata.type('FIXED_LINE')) {
      // The rare case has been encountered where no fixedLine data is available
      // (true for some non-geographic entities), so we just check mobile.
      return checkNumberLengthForType(nationalNumber, 'MOBILE', metadata);
    }

    var mobile_type = metadata.type('MOBILE');

    if (mobile_type) {
      // Merge the mobile data in if there was any. "Concat" creates a new
      // array, it doesn't edit possible_lengths in place, so we don't need a copy.
      // Note that when adding the possible lengths from mobile, we have
      // to again check they aren't empty since if they are this indicates
      // they are the same as the general desc and should be obtained from there.
      possible_lengths = mergeArrays(possible_lengths, mobile_type.possibleLengths()); // The current list is sorted; we need to merge in the new list and
      // re-sort (duplicates are okay). Sorting isn't so expensive because
      // the lists are very small.
      // if (local_lengths)
      // {
      // 	local_lengths = mergeArrays(local_lengths, mobile_type.possibleLengthsLocal())
      // }
      // else
      // {
      // 	local_lengths = mobile_type.possibleLengthsLocal()
      // }
    }
  } // If the type doesn't exist then return 'INVALID_LENGTH'.
  else if (type && !type_info) {
      return 'INVALID_LENGTH';
    }

  var actual_length = nationalNumber.length; // In `libphonenumber-js` all "local-only" formats are dropped for simplicity.
  // // This is safe because there is never an overlap beween the possible lengths
  // // and the local-only lengths; this is checked at build time.
  // if (local_lengths && local_lengths.indexOf(nationalNumber.length) >= 0)
  // {
  // 	return 'IS_POSSIBLE_LOCAL_ONLY'
  // }

  var minimum_length = possible_lengths[0];

  if (minimum_length === actual_length) {
    return 'IS_POSSIBLE';
  }

  if (minimum_length > actual_length) {
    return 'TOO_SHORT';
  }

  if (possible_lengths[possible_lengths.length - 1] < actual_length) {
    return 'TOO_LONG';
  } // We skip the first element since we've already checked it.


  return possible_lengths.indexOf(actual_length, 1) >= 0 ? 'IS_POSSIBLE' : 'INVALID_LENGTH';
}

function isPossiblePhoneNumber(input, options, metadata) {
  /* istanbul ignore if */
  if (options === undefined) {
    options = {};
  }

  metadata = new Metadata(metadata);

  if (options.v2) {
    if (!input.countryCallingCode) {
      throw new Error('Invalid phone number object passed');
    }

    metadata.chooseCountryByCountryCallingCode(input.countryCallingCode);
  } else {
    if (!input.phone) {
      return false;
    }

    if (input.country) {
      if (!metadata.hasCountry(input.country)) {
        throw new Error("Unknown country: ".concat(input.country));
      }

      metadata.country(input.country);
    } else {
      if (!input.countryCallingCode) {
        throw new Error('Invalid phone number object passed');
      }

      metadata.chooseCountryByCountryCallingCode(input.countryCallingCode);
    }
  }

  if (metadata.possibleLengths()) {
    return isPossibleNumber(input.phone || input.nationalNumber, undefined, metadata);
  } else {
    // There was a bug between `1.7.35` and `1.7.37` where "possible_lengths"
    // were missing for "non-geographical" numbering plans.
    // Just assume the number is possible in such cases:
    // it's unlikely that anyone generated their custom metadata
    // in that short period of time (one day).
    // This code can be removed in some future major version update.
    if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) {
      // "Non-geographic entities" did't have `possibleLengths`
      // due to a bug in metadata generation process.
      return true;
    } else {
      throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
  }
}
function isPossibleNumber(nationalNumber, isInternational, metadata) {
  switch (checkNumberLengthForType(nationalNumber, undefined, metadata)) {
    case 'IS_POSSIBLE':
      return true;
    // case 'IS_POSSIBLE_LOCAL_ONLY':
    // 	return !isInternational

    default:
      return false;
  }
}

var CAPTURING_DIGIT_PATTERN = new RegExp('([' + VALID_DIGITS + '])');
/**
 * Pattern that makes it easy to distinguish whether a region has a single
 * international dialing prefix or not. If a region has a single international
 * prefix (e.g. 011 in USA), it will be represented as a string that contains
 * a sequence of ASCII digits, and possibly a tilde, which signals waiting for
 * the tone. If there are multiple available international prefixes in a
 * region, they will be represented as a regex string that always contains one
 * or more characters that are not ASCII digits or a tilde.
 */

var SINGLE_IDD_PREFIX = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/; // For regions that have multiple IDD prefixes
// a preferred IDD prefix is returned.

function getIDDPrefix(country, callingCode, metadata) {
  var countryMetadata = new Metadata(metadata);
  countryMetadata.selectNumberingPlan(country, callingCode);

  if (SINGLE_IDD_PREFIX.test(countryMetadata.IDDPrefix())) {
    return countryMetadata.IDDPrefix();
  }

  return countryMetadata.defaultIDDPrefix();
}
function stripIDDPrefix(number, country, callingCode, metadata) {
  if (!country) {
    return;
  } // Check if the number is IDD-prefixed.


  var countryMetadata = new Metadata(metadata);
  countryMetadata.selectNumberingPlan(country, callingCode);
  var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());

  if (number.search(IDDPrefixPattern) !== 0) {
    return;
  } // Strip IDD prefix.


  number = number.slice(number.match(IDDPrefixPattern)[0].length); // Some kind of a weird edge case.
  // No explanation from Google given.

  var matchedGroups = number.match(CAPTURING_DIGIT_PATTERN);
  /* istanbul ignore next */

  if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
    if (matchedGroups[1] === '0') {
      return;
    }
  }

  return number;
}

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * @param  {string} text - Phone URI (RFC 3966).
 * @return {object} `{ ?number, ?ext }`.
 */

function parseRFC3966(text) {
  var number;
  var ext; // Replace "tel:" with "tel=" for parsing convenience.

  text = text.replace(/^tel:/, 'tel=');

  for (var _iterator = text.split(';'), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var part = _ref;

    var _part$split = part.split('='),
        _part$split2 = _slicedToArray(_part$split, 2),
        name = _part$split2[0],
        value = _part$split2[1];

    switch (name) {
      case 'tel':
        number = value;
        break;

      case 'ext':
        ext = value;
        break;

      case 'phone-context':
        // Only "country contexts" are supported.
        // "Domain contexts" are ignored.
        if (value[0] === '+') {
          number = value + number;
        }

        break;
    }
  } // If the phone number is not viable, then abort.


  if (!isViablePhoneNumber(number)) {
    return {};
  }

  var result = {
    number: number
  };

  if (ext) {
    result.ext = ext;
  }

  return result;
}
/**
 * @param  {object} - `{ ?number, ?extension }`.
 * @return {string} Phone URI (RFC 3966).
 */

function formatRFC3966(_ref2) {
  var number = _ref2.number,
      ext = _ref2.ext;

  if (!number) {
    return '';
  }

  if (number[0] !== '+') {
    throw new Error("\"formatRFC3966()\" expects \"number\" to be in E.164 format.");
  }

  return "tel:".concat(number).concat(ext ? ';ext=' + ext : '');
}

/**
 * Checks if a given phone number is valid.
 *
 * If the `number` is a string, it will be parsed to an object,
 * but only if it contains only valid phone number characters (including punctuation).
 * If the `number` is an object, it is used as is.
 *
 * The optional `defaultCountry` argument is the default country.
 * I.e. it does not restrict to just that country,
 * e.g. in those cases where several countries share
 * the same phone numbering rules (NANPA, Britain, etc).
 * For example, even though the number `07624 369230`
 * belongs to the Isle of Man ("IM" country code)
 * calling `isValidNumber('07624369230', 'GB', metadata)`
 * still returns `true` because the country is not restricted to `GB`,
 * it's just that `GB` is the default one for the phone numbering rules.
 * For restricting the country see `isValidNumberForRegion()`
 * though restricting a country might not be a good idea.
 * https://github.com/googlei18n/libphonenumber/blob/master/FAQ.md#when-should-i-use-isvalidnumberforregion
 *
 * Examples:
 *
 * ```js
 * isValidNumber('+78005553535', metadata)
 * isValidNumber('8005553535', 'RU', metadata)
 * isValidNumber('88005553535', 'RU', metadata)
 * isValidNumber({ phone: '8005553535', country: 'RU' }, metadata)
 * ```
 */

function isValidNumber(input, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {};
  metadata = new Metadata(metadata); // This is just to support `isValidNumber({})`
  // for cases when `parseNumber()` returns `{}`.

  if (!input.country) {
    return false;
  }

  metadata.selectNumberingPlan(input.country, input.countryCallingCode); // By default, countries only have type regexps when it's required for
  // distinguishing different countries having the same `countryCallingCode`.

  if (metadata.hasTypes()) {
    return getNumberType(input, options, metadata.metadata) !== undefined;
  } // If there are no type regexps for this country in metadata then use
  // `nationalNumberPattern` as a "better than nothing" replacement.


  var national_number = options.v2 ? input.nationalNumber : input.phone;
  return matchesEntirely(national_number, metadata.nationalNumberPattern());
}

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } return target; }

function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var DEFAULT_OPTIONS = {
  formatExtension: function formatExtension(formattedNumber, extension, metadata) {
    return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
  } // Formats a phone number
  //
  // Example use cases:
  //
  // ```js
  // formatNumber('8005553535', 'RU', 'INTERNATIONAL')
  // formatNumber('8005553535', 'RU', 'INTERNATIONAL', metadata)
  // formatNumber({ phone: '8005553535', country: 'RU' }, 'INTERNATIONAL')
  // formatNumber({ phone: '8005553535', country: 'RU' }, 'INTERNATIONAL', metadata)
  // formatNumber('+78005553535', 'NATIONAL')
  // formatNumber('+78005553535', 'NATIONAL', metadata)
  // ```
  //

};
function formatNumber$1(input, format, options, metadata) {
  // Apply default options.
  if (options) {
    options = _objectSpread({}, DEFAULT_OPTIONS, options);
  } else {
    options = DEFAULT_OPTIONS;
  }

  metadata = new Metadata(metadata);

  if (input.country && input.country !== '001') {
    // Validate `input.country`.
    if (!metadata.hasCountry(input.country)) {
      throw new Error("Unknown country: ".concat(input.country));
    }

    metadata.country(input.country);
  } else if (input.countryCallingCode) {
    metadata.chooseCountryByCountryCallingCode(input.countryCallingCode);
  } else return input.phone || '';

  var countryCallingCode = metadata.countryCallingCode();
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // This variable should have been declared inside `case`s
  // but Babel has a bug and it says "duplicate variable declaration".

  var number;

  switch (format) {
    case 'NATIONAL':
      // Legacy argument support.
      // (`{ country: ..., phone: '' }`)
      if (!nationalNumber) {
        return '';
      }

      number = formatNationalNumber(nationalNumber, 'NATIONAL', metadata, options);
      return addExtension(number, input.ext, metadata, options.formatExtension);

    case 'INTERNATIONAL':
      // Legacy argument support.
      // (`{ country: ..., phone: '' }`)
      if (!nationalNumber) {
        return "+".concat(countryCallingCode);
      }

      number = formatNationalNumber(nationalNumber, 'INTERNATIONAL', metadata, options);
      number = "+".concat(countryCallingCode, " ").concat(number);
      return addExtension(number, input.ext, metadata, options.formatExtension);

    case 'E.164':
      // `E.164` doesn't define "phone number extensions".
      return "+".concat(countryCallingCode).concat(nationalNumber);

    case 'RFC3966':
      return formatRFC3966({
        number: "+".concat(countryCallingCode).concat(nationalNumber),
        ext: input.ext
      });

    case 'IDD':
      if (!options.fromCountry) {
        return; // throw new Error('`fromCountry` option not passed for IDD-prefixed formatting.')
      }

      var IDDPrefix = getIDDPrefix(options.fromCountry, undefined, metadata.metadata);

      if (!IDDPrefix) {
        return;
      }

      if (options.humanReadable) {
        var formattedForSameCountryCallingCode = countryCallingCode && formatIDDSameCountryCallingCodeNumber(nationalNumber, metadata.countryCallingCode(), options.fromCountry, metadata, options);

        if (formattedForSameCountryCallingCode) {
          number = formattedForSameCountryCallingCode;
        } else {
          number = "".concat(IDDPrefix, " ").concat(countryCallingCode, " ").concat(formatNationalNumber(nationalNumber, 'INTERNATIONAL', metadata, options));
        }

        return addExtension(number, input.ext, metadata, options.formatExtension);
      }

      return "".concat(IDDPrefix).concat(countryCallingCode).concat(nationalNumber);

    default:
      throw new Error("Unknown \"format\" argument passed to \"formatNumber()\": \"".concat(format, "\""));
  }
} // This was originally set to $1 but there are some countries for which the
// first group is not used in the national pattern (e.g. Argentina) so the $1
// group does not match correctly.  Therefore, we use \d, so that the first
// group actually used in the pattern will be matched.

var FIRST_GROUP_PATTERN = /(\$\d)/;
function formatNationalNumberUsingFormat(number, format, useInternationalSeparator, useNationalPrefixFormattingRule, metadata) {
  var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalSeparator ? format.internationalFormat() : useNationalPrefixFormattingRule && format.nationalPrefixFormattingRule() ? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule()) : format.format());

  if (useInternationalSeparator) {
    return applyInternationalSeparatorStyle(formattedNumber);
  }

  return formattedNumber;
}

function formatNationalNumber(number, formatAs, metadata, options) {
  var format = chooseFormatForNumber(metadata.formats(), number);

  if (!format) {
    return number;
  }

  return formatNationalNumberUsingFormat(number, format, formatAs === 'INTERNATIONAL', format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options.nationalPrefix === false ? false : true);
}

function chooseFormatForNumber(availableFormats, nationalNnumber) {
  for (var _iterator = availableFormats, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var format = _ref;

    // Validate leading digits
    if (format.leadingDigitsPatterns().length > 0) {
      // The last leading_digits_pattern is used here, as it is the most detailed
      var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1]; // If leading digits don't match then move on to the next phone number format

      if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) {
        continue;
      }
    } // Check that the national number matches the phone number format regular expression


    if (matchesEntirely(nationalNnumber, format.pattern())) {
      return format;
    }
  }
} // Removes brackets and replaces dashes with spaces.
//
// E.g. "(999) 111-22-33" -> "999 111 22 33"
//
// For some reason Google's metadata contains `<intlFormat/>`s with brackets and dashes.
// Meanwhile, there's no single opinion about using punctuation in international phone numbers.
//
// For example, Google's `<intlFormat/>` for USA is `+1 213-373-4253`.
// And here's a quote from WikiPedia's "North American Numbering Plan" page:
// https://en.wikipedia.org/wiki/North_American_Numbering_Plan
//
// "The country calling code for all countries participating in the NANP is 1.
// In international format, an NANP number should be listed as +1 301 555 01 00,
// where 301 is an area code (Maryland)."
//
// I personally prefer the international format without any punctuation.
// For example, brackets are remnants of the old age, meaning that the
// phone number part in brackets (so called "area code") can be omitted
// if dialing within the same "area".
// And hyphens were clearly introduced for splitting local numbers into memorizable groups.
// For example, remembering "5553535" is difficult but "555-35-35" is much simpler.
// Imagine a man taking a bus from home to work and seeing an ad with a phone number.
// He has a couple of seconds to memorize that number until it passes by.
// If it were spaces instead of hyphens the man wouldn't necessarily get it,
// but with hyphens instead of spaces the grouping is more explicit.
// I personally think that hyphens introduce visual clutter,
// so I prefer replacing them with spaces in international numbers.
// In the modern age all output is done on displays where spaces are clearly distinguishable
// so hyphens can be safely replaced with spaces without losing any legibility.
//


function applyInternationalSeparatorStyle(local) {
  return local.replace(new RegExp("[".concat(VALID_PUNCTUATION, "]+"), 'g'), ' ').trim();
}

function addExtension(formattedNumber, ext, metadata, formatExtension) {
  return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
}

function formatIDDSameCountryCallingCodeNumber(number, toCountryCallingCode, fromCountry, toCountryMetadata, options) {
  var fromCountryMetadata = new Metadata(toCountryMetadata.metadata);
  fromCountryMetadata.country(fromCountry); // If calling within the same country calling code.

  if (toCountryCallingCode === fromCountryMetadata.countryCallingCode()) {
    // For NANPA regions, return the national format for these regions
    // but prefix it with the country calling code.
    if (toCountryCallingCode === '1') {
      return toCountryCallingCode + ' ' + formatNationalNumber(number, 'NATIONAL', toCountryMetadata, options);
    } // If regions share a country calling code, the country calling code need
    // not be dialled. This also applies when dialling within a region, so this
    // if clause covers both these cases. Technically this is the case for
    // dialling from La Reunion to other overseas departments of France (French
    // Guiana, Martinique, Guadeloupe), but not vice versa - so we don't cover
    // this edge case for now and for those cases return the version including
    // country calling code. Details here:
    // http://www.petitfute.com/voyage/225-info-pratiques-reunion
    //


    return formatNationalNumber(number, 'NATIONAL', toCountryMetadata, options);
  }
}

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$2(target, key, source[key]); }); } return target; }

function _defineProperty$2(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck$2(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$1(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$1(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$1(Constructor.prototype, protoProps); if (staticProps) _defineProperties$1(Constructor, staticProps); return Constructor; }

var PhoneNumber =
/*#__PURE__*/
function () {
  function PhoneNumber(countryCallingCode, nationalNumber, metadata) {
    _classCallCheck$2(this, PhoneNumber);

    if (!countryCallingCode) {
      throw new TypeError('`country` or `countryCallingCode` not passed');
    }

    if (!nationalNumber) {
      throw new TypeError('`nationalNumber` not passed');
    }

    var _metadata = new Metadata(metadata); // If country code is passed then derive `countryCallingCode` from it.
    // Also store the country code as `.country`.


    if (isCountryCode(countryCallingCode)) {
      this.country = countryCallingCode;

      _metadata.country(countryCallingCode);

      countryCallingCode = _metadata.countryCallingCode();
    }

    this.countryCallingCode = countryCallingCode;
    this.nationalNumber = nationalNumber;
    this.number = '+' + this.countryCallingCode + this.nationalNumber;
    this.metadata = metadata;
  }

  _createClass$1(PhoneNumber, [{
    key: "isPossible",
    value: function isPossible() {
      return isPossiblePhoneNumber(this, {
        v2: true
      }, this.metadata);
    }
  }, {
    key: "isValid",
    value: function isValid() {
      return isValidNumber(this, {
        v2: true
      }, this.metadata);
    }
  }, {
    key: "isNonGeographic",
    value: function isNonGeographic() {
      var metadata = new Metadata(this.metadata);
      return metadata.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function isEqual(phoneNumber) {
      return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
    } // // Is just an alias for `this.isValid() && this.country === country`.
    // // https://github.com/googlei18n/libphonenumber/blob/master/FAQ.md#when-should-i-use-isvalidnumberforregion
    // isValidForRegion(country) {
    // 	return isValidNumberForRegion(this, country, { v2: true }, this.metadata)
    // }

  }, {
    key: "getType",
    value: function getType() {
      return getNumberType(this, {
        v2: true
      }, this.metadata);
    }
  }, {
    key: "format",
    value: function format(_format, options) {
      return formatNumber$1(this, _format, options ? _objectSpread$1({}, options, {
        v2: true
      }) : {
        v2: true
      }, this.metadata);
    }
  }, {
    key: "formatNational",
    value: function formatNational(options) {
      return this.format('NATIONAL', options);
    }
  }, {
    key: "formatInternational",
    value: function formatInternational(options) {
      return this.format('INTERNATIONAL', options);
    }
  }, {
    key: "getURI",
    value: function getURI(options) {
      return this.format('RFC3966', options);
    }
  }]);

  return PhoneNumber;
}();

var isCountryCode = function isCountryCode(value) {
  return /^[A-Z]{2}$/.test(value);
};

// This is a port of Google Android `libphonenumber`'s
// This prevents malicious input from consuming CPU.

var MAX_INPUT_STRING_LENGTH = 250; // This consists of the plus symbol, digits, and arabic-indic digits.

var PHONE_NUMBER_START_PATTERN = new RegExp('[' + PLUS_CHARS + VALID_DIGITS + ']'); // Regular expression of trailing characters that we want to remove.

var AFTER_PHONE_NUMBER_END_PATTERN = new RegExp('[^' + VALID_DIGITS + ']+$');
//  {
//    country:
//    {
//      restrict - (a two-letter country code)
//                 the phone number must be in this country
//
//      default - (a two-letter country code)
//                default country to use for phone number parsing and validation
//                (if no country code could be derived from the phone number)
//    }
//  }
//
// Returns `{ country, number }`
//
// Example use cases:
//
// ```js
// parse('8 (800) 555-35-35', 'RU')
// parse('8 (800) 555-35-35', 'RU', metadata)
// parse('8 (800) 555-35-35', { country: { default: 'RU' } })
// parse('8 (800) 555-35-35', { country: { default: 'RU' } }, metadata)
// parse('+7 800 555 35 35')
// parse('+7 800 555 35 35', metadata)
// ```
//

function parse$2(text, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {};
  metadata = new Metadata(metadata); // Validate `defaultCountry`.

  if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
    if (options.v2) {
      throw new ParseError('INVALID_COUNTRY');
    }

    throw new Error("Unknown country: ".concat(options.defaultCountry));
  } // Parse the phone number.


  var _parseInput = parseInput(text, options.v2),
      formattedPhoneNumber = _parseInput.number,
      ext = _parseInput.ext; // If the phone number is not viable then return nothing.


  if (!formattedPhoneNumber) {
    if (options.v2) {
      throw new ParseError('NOT_A_NUMBER');
    }

    return {};
  }

  var _parsePhoneNumber = parsePhoneNumber(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata),
      country = _parsePhoneNumber.country,
      nationalNumber = _parsePhoneNumber.nationalNumber,
      countryCallingCode = _parsePhoneNumber.countryCallingCode,
      carrierCode = _parsePhoneNumber.carrierCode;

  if (!metadata.hasSelectedNumberingPlan()) {
    if (options.v2) {
      throw new ParseError('INVALID_COUNTRY');
    }

    return {};
  } // Validate national (significant) number length.


  if (!nationalNumber || nationalNumber.length < MIN_LENGTH_FOR_NSN) {
    // Won't throw here because the regexp already demands length > 1.

    /* istanbul ignore if */
    if (options.v2) {
      throw new ParseError('TOO_SHORT');
    } // Google's demo just throws an error in this case.


    return {};
  } // Validate national (significant) number length.
  //
  // A sidenote:
  //
  // They say that sometimes national (significant) numbers
  // can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
  // https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
  // Such numbers will just be discarded.
  //


  if (nationalNumber.length > MAX_LENGTH_FOR_NSN) {
    if (options.v2) {
      throw new ParseError('TOO_LONG');
    } // Google's demo just throws an error in this case.


    return {};
  }

  if (options.v2) {
    var phoneNumber = new PhoneNumber(countryCallingCode, nationalNumber, metadata.metadata);

    if (country) {
      phoneNumber.country = country;
    }

    if (carrierCode) {
      phoneNumber.carrierCode = carrierCode;
    }

    if (ext) {
      phoneNumber.ext = ext;
    }

    return phoneNumber;
  } // Check if national phone number pattern matches the number.
  // National number pattern is different for each country,
  // even for those ones which are part of the "NANPA" group.


  var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? matchesEntirely(nationalNumber, metadata.nationalNumberPattern()) : false;

  if (!options.extended) {
    return valid ? result(country, nationalNumber, ext) : {};
  }

  return {
    country: country,
    countryCallingCode: countryCallingCode,
    carrierCode: carrierCode,
    valid: valid,
    possible: valid ? true : options.extended === true && metadata.possibleLengths() && isPossibleNumber(nationalNumber, countryCallingCode !== undefined, metadata) ? true : false,
    phone: nationalNumber,
    ext: ext
  };
}
/**
 * Extracts a formatted phone number from text.
 * Doesn't guarantee that the extracted phone number
 * is a valid phone number (for example, doesn't validate its length).
 * @param  {string} text
 * @param  {boolean} throwOnError — By default, it won't throw if the text is too long.
 * @return {string}
 * @example
 * // Returns "(213) 373-4253".
 * extractFormattedPhoneNumber("Call (213) 373-4253 for assistance.")
 */

function extractFormattedPhoneNumber(text, throwOnError) {
  if (!text) {
    return;
  }

  if (text.length > MAX_INPUT_STRING_LENGTH) {
    if (throwOnError) {
      throw new ParseError('TOO_LONG');
    }

    return;
  } // Attempt to extract a possible number from the string passed in


  var startsAt = text.search(PHONE_NUMBER_START_PATTERN);

  if (startsAt < 0) {
    return;
  }

  return text // Trim everything to the left of the phone number
  .slice(startsAt) // Remove trailing non-numerical characters
  .replace(AFTER_PHONE_NUMBER_END_PATTERN, '');
}
/**
 * Strips any national prefix (such as 0, 1) present in a
 * (possibly incomplete) number provided.
 * "Carrier codes" are only used  in Colombia and Brazil,
 * and only when dialing within those countries from a mobile phone to a fixed line number.
 * Sometimes it won't actually strip national prefix
 * and will instead prepend some digits to the `number`:
 * for example, when number `2345678` is passed with `VI` country selected,
 * it will return `{ number: "3402345678" }`, because `340` area code is prepended.
 * @param {string} number — National number digits.
 * @param {object} metadata — Metadata with country selected.
 * @return {object} `{ nationalNumber: string, carrierCode: string? }`.
 */

function stripNationalPrefixAndCarrierCode(number, metadata) {
  if (number && metadata.nationalPrefixForParsing()) {
    // See METADATA.md for the description of
    // `national_prefix_for_parsing` and `national_prefix_transform_rule`.
    // Attempt to parse the first digits as a national prefix.
    var prefixPattern = new RegExp('^(?:' + metadata.nationalPrefixForParsing() + ')');
    var prefixMatch = prefixPattern.exec(number);

    if (prefixMatch) {
      var nationalNumber;
      var carrierCode; // If a "capturing group" didn't match
      // then its element in `prefixMatch[]` array will be `undefined`.

      var capturedGroupsCount = prefixMatch.length - 1;

      if (metadata.nationalPrefixTransformRule() && capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount]) {
        nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule()); // Carrier code is the last captured group,
        // but only when there's more than one captured group.

        if (capturedGroupsCount > 1 && prefixMatch[capturedGroupsCount]) {
          carrierCode = prefixMatch[1];
        }
      } // If it's a simple-enough case then just
      // strip the national prefix from the number.
      else {
          // National prefix is the whole substring matched by
          // the `national_prefix_for_parsing` regexp.
          var nationalPrefix = prefixMatch[0];
          nationalNumber = number.slice(nationalPrefix.length); // Carrier code is the last captured group.

          if (capturedGroupsCount > 0) {
            carrierCode = prefixMatch[1];
          }
        } // We require that the national (significant) number remaining after
      // stripping the national prefix and carrier code be long enough
      // to be a possible length for the region. Otherwise, we don't do
      // the stripping, since the original number could be a valid number.
      // For example, in some countries (Russia, Belarus) the same digit
      // could be both a national prefix and a leading digit of a valid
      // national phone number, like `8` is the national prefix for Russia
      // and `800 555 35 35` is a valid national (significant) number.


      if (matchesEntirely(number, metadata.nationalNumberPattern()) && !matchesEntirely(nationalNumber, metadata.nationalNumberPattern())) ; else {
        return {
          nationalNumber: nationalNumber,
          carrierCode: carrierCode
        };
      }
    }
  }

  return {
    nationalNumber: number
  };
}
function findCountryCode(callingCode, nationalPhoneNumber, metadata) {


  var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);

  if (!possibleCountries) {
    return;
  } // If there's just one country corresponding to the country code,
  // then just return it, without further phone number digits validation.


  if (possibleCountries.length === 1) {
    return possibleCountries[0];
  }

  return _findCountryCode(possibleCountries, nationalPhoneNumber, metadata.metadata);
} // Changes `metadata` `country`.

function _findCountryCode(possibleCountries, nationalPhoneNumber, metadata) {
  metadata = new Metadata(metadata);

  for (var _iterator = possibleCountries, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var country = _ref;
    metadata.country(country); // Leading digits check would be the simplest one

    if (metadata.leadingDigits()) {
      if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) {
        return country;
      }
    } // Else perform full validation with all of those
    // fixed-line/mobile/etc regular expressions.
    else if (getNumberType({
        phone: nationalPhoneNumber,
        country: country
      }, undefined, metadata.metadata)) {
        return country;
      }
  }
}
/**
 * @param  {string} text - Input.
 * @return {object} `{ ?number, ?ext }`.
 */


function parseInput(text, v2) {
  // Parse RFC 3966 phone number URI.
  if (text && text.indexOf('tel:') === 0) {
    return parseRFC3966(text);
  }

  var number = extractFormattedPhoneNumber(text, v2); // If the phone number is not viable, then abort.

  if (!number || !isViablePhoneNumber(number)) {
    return {};
  } // Attempt to parse extension first, since it doesn't require region-specific
  // data and we want to have the non-normalised number here.


  var withExtensionStripped = extractExtension(number);

  if (withExtensionStripped.ext) {
    return withExtensionStripped;
  }

  return {
    number: number
  };
}
/**
 * Creates `parse()` result object.
 */


function result(country, nationalNumber, ext) {
  var result = {
    country: country,
    phone: nationalNumber
  };

  if (ext) {
    result.ext = ext;
  }

  return result;
}
/**
 * Parses a viable phone number.
 * @param {string} formattedPhoneNumber — Example: "(213) 373-4253".
 * @param {string} [defaultCountry]
 * @param {string} [defaultCallingCode]
 * @param {Metadata} metadata
 * @return {object} Returns `{ country: string?, countryCallingCode: string?, nationalNumber: string? }`.
 */


function parsePhoneNumber(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
  // Extract calling code from phone number.
  var _extractCountryCallin = extractCountryCallingCode(parseIncompletePhoneNumber(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata.metadata),
      countryCallingCode = _extractCountryCallin.countryCallingCode,
      number = _extractCountryCallin.number; // Choose a country by `countryCallingCode`.


  var country;

  if (countryCallingCode) {
    metadata.chooseCountryByCountryCallingCode(countryCallingCode);
  } // If `formattedPhoneNumber` is in "national" format
  // then `number` is defined and `countryCallingCode` isn't.
  else if (number && (defaultCountry || defaultCallingCode)) {
      metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);

      if (defaultCountry) {
        country = defaultCountry;
      }

      countryCallingCode = defaultCallingCode || getCountryCallingCode(defaultCountry, metadata.metadata);
    } else return {};

  if (!number) {
    return {
      countryCallingCode: countryCallingCode
    };
  }

  var _stripNationalPrefixA = stripNationalPrefixAndCarrierCodeFromCompleteNumber(parseIncompletePhoneNumber(number), metadata),
      nationalNumber = _stripNationalPrefixA.nationalNumber,
      carrierCode = _stripNationalPrefixA.carrierCode; // Sometimes there are several countries
  // corresponding to the same country phone code
  // (e.g. NANPA countries all having `1` country phone code).
  // Therefore, to reliably determine the exact country,
  // national (significant) number should have been parsed first.
  //
  // When `metadata.json` is generated, all "ambiguous" country phone codes
  // get their countries populated with the full set of
  // "phone number type" regular expressions.
  //


  var exactCountry = findCountryCode(countryCallingCode, nationalNumber, metadata);

  if (exactCountry) {
    country = exactCountry;
    /* istanbul ignore if */

    if (exactCountry === '001') ; else {
      metadata.country(country);
    }
  }

  return {
    country: country,
    countryCallingCode: countryCallingCode,
    nationalNumber: nationalNumber,
    carrierCode: carrierCode
  };
}
/**
 * Strips national prefix and carrier code from a complete phone number.
 * The difference from the non-"FromCompleteNumber" function is that
 * it won't extract national prefix if the resultant number is too short
 * to be a complete number for the selected phone numbering plan.
 * @param  {string} number — Complete phone number digits.
 * @param  {Metadata} metadata — Metadata with a phone numbering plan selected.
 * @return {object} `{ nationalNumber: string, carrierCode: string? }`.
 */


function stripNationalPrefixAndCarrierCodeFromCompleteNumber(number, metadata) {
  // Parsing national prefixes and carrier codes
  // is only required for local phone numbers
  // but some people don't understand that
  // and sometimes write international phone numbers
  // with national prefixes (or maybe even carrier codes).
  // http://ucken.blogspot.ru/2016/03/trunk-prefixes-in-skype4b.html
  // Google's original library forgives such mistakes
  // and so does this library, because it has been requested:
  // https://github.com/catamphetamine/libphonenumber-js/issues/127
  var _stripNationalPrefixA2 = stripNationalPrefixAndCarrierCode(parseIncompletePhoneNumber(number), metadata),
      nationalNumber = _stripNationalPrefixA2.nationalNumber,
      carrierCode = _stripNationalPrefixA2.carrierCode; // If a national prefix has been extracted, check to see
  // if the resultant number isn't too short.


  if (nationalNumber.length !== number.length + (carrierCode ? carrierCode.length : 0)) {
    // If not using legacy generated metadata (before version `1.0.18`)
    // then it has "possible lengths", so use those to validate the number length.
    if (metadata.possibleLengths()) {
      // "We require that the NSN remaining after stripping the national prefix and
      // carrier code be long enough to be a possible length for the region.
      // Otherwise, we don't do the stripping, since the original number could be
      // a valid short number."
      // https://github.com/google/libphonenumber/blob/876268eb1ad6cdc1b7b5bef17fc5e43052702d57/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3236-L3250
      switch (checkNumberLengthForType(nationalNumber, undefined, metadata)) {
        case 'TOO_SHORT':
        case 'INVALID_LENGTH':
          // case 'IS_POSSIBLE_LOCAL_ONLY':
          // Don't strip the national prefix.
          return {
            nationalNumber: number
          };
      }
    }
  }

  return {
    nationalNumber: nationalNumber,
    carrierCode: carrierCode
  };
}
/**
 * Converts a phone number digits (possibly with a `+`)
 * into a calling code and the rest phone number digits.
 * The "rest phone number digits" could include
 * a national prefix, carrier code, and national
 * (significant) number.
 * @param  {string} number — Phone number digits (possibly with a `+`).
 * @param  {string} [country] — Default country.
 * @param  {string} [callingCode] — Default calling code (some phone numbering plans are non-geographic).
 * @param  {object} metadata
 * @return {object} `{ countryCallingCode: string?, number: string }`
 * @example
 * // Returns `{ countryCallingCode: "1", number: "2133734253" }`.
 * extractCountryCallingCode('2133734253', 'US', null, metadata)
 * extractCountryCallingCode('2133734253', null, '1', metadata)
 * extractCountryCallingCode('+12133734253', null, null, metadata)
 * extractCountryCallingCode('+12133734253', 'RU', null, metadata)
 */

function extractCountryCallingCode(number, country, callingCode, metadata) {
  if (!number) {
    return {};
  } // If this is not an international phone number,
  // then either extract an "IDD" prefix, or extract a
  // country calling code from a number by autocorrecting it
  // by prepending a leading `+` in cases when it starts
  // with the country calling code.
  // https://wikitravel.org/en/International_dialling_prefix
  // https://github.com/catamphetamine/libphonenumber-js/issues/376


  if (number[0] !== '+') {
    // Convert an "out-of-country" dialing phone number
    // to a proper international phone number.
    var numberWithoutIDD = stripIDDPrefix(number, country, callingCode, metadata); // If an IDD prefix was stripped then
    // convert the number to international one
    // for subsequent parsing.

    if (numberWithoutIDD && numberWithoutIDD !== number) {
      number = '+' + numberWithoutIDD;
    } else {
      // Check to see if the number starts with the country calling code
      // for the default country. If so, we remove the country calling code,
      // and do some checks on the validity of the number before and after.
      // https://github.com/catamphetamine/libphonenumber-js/issues/376
      if (country || callingCode) {
        var _extractCountryCallin2 = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, callingCode, metadata),
            countryCallingCode = _extractCountryCallin2.countryCallingCode,
            shorterNumber = _extractCountryCallin2.number;

        if (countryCallingCode) {
          return {
            countryCallingCode: countryCallingCode,
            number: shorterNumber
          };
        }
      }

      return {
        number: number
      };
    }
  } // Fast abortion: country codes do not begin with a '0'


  if (number[1] === '0') {
    return {};
  }

  metadata = new Metadata(metadata); // The thing with country phone codes
  // is that they are orthogonal to each other
  // i.e. there's no such country phone code A
  // for which country phone code B exists
  // where B starts with A.
  // Therefore, while scanning digits,
  // if a valid country code is found,
  // that means that it is the country code.
  //

  var i = 2;

  while (i - 1 <= MAX_LENGTH_COUNTRY_CODE && i <= number.length) {
    var _countryCallingCode = number.slice(1, i);

    if (metadata.hasCallingCode(_countryCallingCode)) {
      metadata.selectNumberingPlan(undefined, _countryCallingCode);
      return {
        countryCallingCode: _countryCallingCode,
        number: number.slice(i)
      };
    }

    i++;
  }

  return {};
}
/**
 * Sometimes some people incorrectly input international phone numbers
 * without the leading `+`. This function corrects such input.
 * @param  {string} number — Phone number digits.
 * @param  {string?} country
 * @param  {string?} callingCode
 * @param  {object} metadata
 * @return {object} `{ countryCallingCode: string?, number: string }`.
 */

function extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, callingCode, metadata) {
  var countryCallingCode = country ? getCountryCallingCode(country, metadata) : callingCode;

  if (number.indexOf(countryCallingCode) === 0) {
    metadata = new Metadata(metadata);
    metadata.selectNumberingPlan(country, callingCode);
    var possibleShorterNumber = number.slice(countryCallingCode.length);

    var _stripNationalPrefixA3 = stripNationalPrefixAndCarrierCode(possibleShorterNumber, metadata),
        possibleShorterNationalNumber = _stripNationalPrefixA3.nationalNumber;

    var _stripNationalPrefixA4 = stripNationalPrefixAndCarrierCode(number, metadata),
        nationalNumber = _stripNationalPrefixA4.nationalNumber; // If the number was not valid before but is valid now,
    // or if it was too long before, we consider the number
    // with the country calling code stripped to be a better result
    // and keep that instead.
    // For example, in Germany (+49), `49` is a valid area code,
    // so if a number starts with `49`, it could be both a valid
    // national German number or an international number without
    // a leading `+`.


    if (!matchesEntirely(nationalNumber, metadata.nationalNumberPattern()) && matchesEntirely(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || checkNumberLengthForType(nationalNumber, undefined, metadata) === 'TOO_LONG') {
      return {
        countryCallingCode: countryCallingCode,
        number: possibleShorterNumber
      };
    }
  }

  return {
    number: number
  };
}

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$3(target, key, source[key]); }); } return target; }

function _defineProperty$3(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function parsePhoneNumber$1(text, options, metadata) {
  return parse$2(text, _objectSpread$2({}, options, {
    v2: true
  }), metadata);
}

function _typeof$1(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$1 = function _typeof(obj) { return typeof obj; }; } else { _typeof$1 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$1(obj); }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$4(target, key, source[key]); }); } return target; }

function _defineProperty$4(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray$1(arr, i) { return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _nonIterableRest$1(); }

function _nonIterableRest$1() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit$1(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$1(arr) { if (Array.isArray(arr)) return arr; }
function normalizeArguments(args) {
  var _Array$prototype$slic = Array.prototype.slice.call(args),
      _Array$prototype$slic2 = _slicedToArray$1(_Array$prototype$slic, 4),
      arg_1 = _Array$prototype$slic2[0],
      arg_2 = _Array$prototype$slic2[1],
      arg_3 = _Array$prototype$slic2[2],
      arg_4 = _Array$prototype$slic2[3];

  var text;
  var options;
  var metadata; // If the phone number is passed as a string.
  // `parsePhoneNumber('88005553535', ...)`.

  if (typeof arg_1 === 'string') {
    text = arg_1;
  } else throw new TypeError('A text for parsing must be a string.'); // If "default country" argument is being passed then move it to `options`.
  // `parsePhoneNumber('88005553535', 'RU', [options], metadata)`.


  if (!arg_2 || typeof arg_2 === 'string') {
    if (arg_4) {
      options = arg_3;
      metadata = arg_4;
    } else {
      options = undefined;
      metadata = arg_3;
    }

    if (arg_2) {
      options = _objectSpread$3({
        defaultCountry: arg_2
      }, options);
    }
  } // `defaultCountry` is not passed.
  // Example: `parsePhoneNumber('+78005553535', [options], metadata)`.
  else if (isObject$4(arg_2)) {
      if (arg_3) {
        options = arg_2;
        metadata = arg_3;
      } else {
        metadata = arg_2;
      }
    } else throw new Error("Invalid second argument: ".concat(arg_2));

  return {
    text: text,
    options: options,
    metadata: metadata
  };
} // Otherwise istanbul would show this as "branch not covered".

/* istanbul ignore next */

var isObject$4 = function isObject(_) {
  return _typeof$1(_) === 'object';
};

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$5(target, key, source[key]); }); } return target; }

function _defineProperty$5(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function parsePhoneNumberFromString(text, options, metadata) {
  // Validate `defaultCountry`.
  if (options && options.defaultCountry && !isSupportedCountry(options.defaultCountry, metadata)) {
    options = _objectSpread$4({}, options, {
      defaultCountry: undefined
    });
  } // Parse phone number.


  try {
    return parsePhoneNumber$1(text, options, metadata);
  } catch (error) {
    /* istanbul ignore else */
    if (error instanceof ParseError) ; else {
      throw error;
    }
  }
}

function parsePhoneNumberFromString$1() {
  var _normalizeArguments = normalizeArguments(arguments),
      text = _normalizeArguments.text,
      options = _normalizeArguments.options,
      metadata = _normalizeArguments.metadata;

  return parsePhoneNumberFromString(text, options, metadata);
}

/** Returns a regular expression quantifier with an upper and lower limit. */
function limit(lower, upper) {
  if (lower < 0 || upper <= 0 || upper < lower) {
    throw new TypeError();
  }

  return "{".concat(lower, ",").concat(upper, "}");
}
/**
 * Trims away any characters after the first match of {@code pattern} in {@code candidate},
 * returning the trimmed version.
 */

function trimAfterFirstMatch(regexp, string) {
  var index = string.search(regexp);

  if (index >= 0) {
    return string.slice(0, index);
  }

  return string;
}
function startsWith(string, substring) {
  return string.indexOf(substring) === 0;
}
function endsWith(string, substring) {
  return string.indexOf(substring, string.length - substring.length) === string.length - substring.length;
}

// of parsing. This allows us to strip off parts of the number that are actually the start of
// another number, such as for: (530) 583-6985 x302/x2303 -> the second extension here makes this
// actually two phone numbers, (530) 583-6985 x302 and (530) 583-6985 x2303. We remove the second
// extension so that the first number is parsed correctly.
//
// Matches a slash (\ or /) followed by a space followed by an `x`.
//

var SECOND_NUMBER_START_PATTERN = /[\\/] *x/;
function parsePreCandidate(candidate) {
  // Check for extra numbers at the end.
  // TODO: This is the place to start when trying to support extraction of multiple phone number
  // from split notations (+41 79 123 45 67 / 68).
  return trimAfterFirstMatch(SECOND_NUMBER_START_PATTERN, candidate);
}

// Matches strings that look like dates using "/" as a separator.
// Examples: 3/10/2011, 31/10/96 or 08/31/95.
var SLASH_SEPARATED_DATES = /(?:(?:[0-3]?\d\/[01]?\d)|(?:[01]?\d\/[0-3]?\d))\/(?:[12]\d)?\d{2}/; // Matches timestamps.
// Examples: "2012-01-02 08:00".
// Note that the reg-ex does not include the
// trailing ":\d\d" -- that is covered by TIME_STAMPS_SUFFIX.

var TIME_STAMPS = /[12]\d{3}[-/]?[01]\d[-/]?[0-3]\d +[0-2]\d$/;
var TIME_STAMPS_SUFFIX_LEADING = /^:[0-5]\d/;
function isValidPreCandidate(candidate, offset, text) {
  // Skip a match that is more likely to be a date.
  if (SLASH_SEPARATED_DATES.test(candidate)) {
    return false;
  } // Skip potential time-stamps.


  if (TIME_STAMPS.test(candidate)) {
    var followingText = text.slice(offset + candidate.length);

    if (TIME_STAMPS_SUFFIX_LEADING.test(followingText)) {
      return false;
    }
  }

  return true;
}

// Javascript doesn't support UTF-8 regular expressions.
// So mimicking them here.
// Copy-pasted from `PhoneNumberMatcher.js`.

/**
 * "\p{Z}" is any kind of whitespace or invisible separator ("Separator").
 * http://www.regular-expressions.info/unicode.html
 * "\P{Z}" is the reverse of "\p{Z}".
 * "\p{N}" is any kind of numeric character in any script ("Number").
 * "\p{Nd}" is a digit zero through nine in any script except "ideographic scripts" ("Decimal_Digit_Number").
 * "\p{Sc}" is a currency symbol ("Currency_Symbol").
 * "\p{L}" is any kind of letter from any language ("Letter").
 * "\p{Mn}" is "non-spacing mark".
 *
 * Javascript doesn't support Unicode Regular Expressions
 * so substituting it with this explicit set of characters.
 *
 * https://stackoverflow.com/questions/13210194/javascript-regex-equivalent-of-a-za-z-using-pl
 * https://github.com/danielberndt/babel-plugin-utf-8-regex/blob/master/src/transformer.js
 */
var _pZ = " \xA0\u1680\u180E\u2000-\u200A\u2028\u2029\u202F\u205F\u3000";
var pZ = "[".concat(_pZ, "]");
var PZ = "[^".concat(_pZ, "]");
var _pN = "0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19"; // const pN = `[${_pN}]`

var _pNd = "0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19";
var pNd = "[".concat(_pNd, "]");
var _pL = "A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC";
var pL = "[".concat(_pL, "]");
var pL_regexp = new RegExp(pL);
var _pSc = "$\xA2-\xA5\u058F\u060B\u09F2\u09F3\u09FB\u0AF1\u0BF9\u0E3F\u17DB\u20A0-\u20B9\uA838\uFDFC\uFE69\uFF04\uFFE0\uFFE1\uFFE5\uFFE6";
var pSc = "[".concat(_pSc, "]");
var pSc_regexp = new RegExp(pSc);
var _pMn = "\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08E4-\u08FE\u0900-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09C1-\u09C4\u09CD\u09E2\u09E3\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0B01\u0B3C\u0B3F\u0B41-\u0B44\u0B4D\u0B56\u0B62\u0B63\u0B82\u0BC0\u0BCD\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0CBC\u0CBF\u0CC6\u0CCC\u0CCD\u0CE2\u0CE3\u0D41-\u0D44\u0D4D\u0D62\u0D63\u0DCA\u0DD2-\u0DD4\u0DD6\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1B00-\u1B03\u1B34\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1DC0-\u1DE6\u1DFC-\u1DFF\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u3099\u309A\uA66F\uA674-\uA67D\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA8C4\uA8E0-\uA8F1\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE26";
var pMn = "[".concat(_pMn, "]");
var pMn_regexp = new RegExp(pMn);
var _InBasic_Latin = "\0-\x7F";
var _InLatin_1_Supplement = "\x80-\xFF";
var _InLatin_Extended_A = "\u0100-\u017F";
var _InLatin_Extended_Additional = "\u1E00-\u1EFF";
var _InLatin_Extended_B = "\u0180-\u024F";
var _InCombining_Diacritical_Marks = "\u0300-\u036F";
var latinLetterRegexp = new RegExp('[' + _InBasic_Latin + _InLatin_1_Supplement + _InLatin_Extended_A + _InLatin_Extended_Additional + _InLatin_Extended_B + _InCombining_Diacritical_Marks + ']');
/**
 * Helper method to determine if a character is a Latin-script letter or not.
 * For our purposes, combining marks should also return true since we assume
 * they have been added to a preceding Latin character.
 */

function isLatinLetter(letter) {
  // Combining marks are a subset of non-spacing-mark.
  if (!pL_regexp.test(letter) && !pMn_regexp.test(letter)) {
    return false;
  }

  return latinLetterRegexp.test(letter);
}
function isInvalidPunctuationSymbol(character) {
  return character === '%' || pSc_regexp.test(character);
}

// Copy-pasted from `PhoneNumberMatcher.js`.
var OPENING_PARENS = "(\\[\uFF08\uFF3B";
var CLOSING_PARENS = ")\\]\uFF09\uFF3D";
var NON_PARENS = "[^".concat(OPENING_PARENS).concat(CLOSING_PARENS, "]");
var LEAD_CLASS = "[".concat(OPENING_PARENS).concat(PLUS_CHARS, "]"); // Punctuation that may be at the start of a phone number - brackets and plus signs.

var LEAD_CLASS_LEADING = new RegExp('^' + LEAD_CLASS); // Limit on the number of pairs of brackets in a phone number.

var BRACKET_PAIR_LIMIT = limit(0, 3);
/**
 * Pattern to check that brackets match. Opening brackets should be closed within a phone number.
 * This also checks that there is something inside the brackets. Having no brackets at all is also
 * fine.
 *
 * An opening bracket at the beginning may not be closed, but subsequent ones should be.  It's
 * also possible that the leading bracket was dropped, so we shouldn't be surprised if we see a
 * closing bracket first. We limit the sets of brackets in a phone number to four.
 */

var MATCHING_BRACKETS_ENTIRE = new RegExp('^' + "(?:[" + OPENING_PARENS + "])?" + "(?:" + NON_PARENS + "+" + "[" + CLOSING_PARENS + "])?" + NON_PARENS + "+" + "(?:[" + OPENING_PARENS + "]" + NON_PARENS + "+[" + CLOSING_PARENS + "])" + BRACKET_PAIR_LIMIT + NON_PARENS + "*" + '$');
/**
 * Matches strings that look like publication pages. Example:
 * <pre>Computing Complete Answers to Queries in the Presence of Limited Access Patterns.
 * Chen Li. VLDB J. 12(3): 211-227 (2003).</pre>
 *
 * The string "211-227 (2003)" is not a telephone number.
 */

var PUB_PAGES = /\d{1,5}-+\d{1,5}\s{0,4}\(\d{1,4}/;
function isValidCandidate(candidate, offset, text, leniency) {
  // Check the candidate doesn't contain any formatting
  // which would indicate that it really isn't a phone number.
  if (!MATCHING_BRACKETS_ENTIRE.test(candidate) || PUB_PAGES.test(candidate)) {
    return;
  } // If leniency is set to VALID or stricter, we also want to skip numbers that are surrounded
  // by Latin alphabetic characters, to skip cases like abc8005001234 or 8005001234def.


  if (leniency !== 'POSSIBLE') {
    // If the candidate is not at the start of the text,
    // and does not start with phone-number punctuation,
    // check the previous character.
    if (offset > 0 && !LEAD_CLASS_LEADING.test(candidate)) {
      var previousChar = text[offset - 1]; // We return null if it is a latin letter or an invalid punctuation symbol.

      if (isInvalidPunctuationSymbol(previousChar) || isLatinLetter(previousChar)) {
        return false;
      }
    }

    var lastCharIndex = offset + candidate.length;

    if (lastCharIndex < text.length) {
      var nextChar = text[lastCharIndex];

      if (isInvalidPunctuationSymbol(nextChar) || isLatinLetter(nextChar)) {
        return false;
      }
    }
  }

  return true;
}

function _classCallCheck$3(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$2(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$2(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$2(Constructor.prototype, protoProps); if (staticProps) _defineProperties$2(Constructor, staticProps); return Constructor; }

function _defineProperty$6(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var VALID_PHONE_NUMBER$1 = '[' + PLUS_CHARS + ']{0,1}' + '(?:' + '[' + VALID_PUNCTUATION + ']*' + '[' + VALID_DIGITS + ']' + '){3,}' + '[' + VALID_PUNCTUATION + VALID_DIGITS + ']*';
var WHITESPACE_IN_THE_BEGINNING_PATTERN = new RegExp('^[' + WHITESPACE + ']+');
var PUNCTUATION_IN_THE_END_PATTERN = new RegExp('[' + VALID_PUNCTUATION + ']+$'); // // Regular expression for getting opening brackets for a valid number
/**
 * Extracts a parseable phone number including any opening brackets, etc.
 * @param  {string} text - Input.
 * @return {object} `{ ?number, ?startsAt, ?endsAt }`.
 */

var PhoneNumberSearch =
/*#__PURE__*/
function () {
  // Iteration tristate.
  function PhoneNumberSearch(text, options, metadata) {
    _classCallCheck$3(this, PhoneNumberSearch);

    _defineProperty$6(this, "state", 'NOT_READY');

    this.text = text; // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.

    this.options = options || {};
    this.metadata = metadata;
    this.regexp = new RegExp(VALID_PHONE_NUMBER$1 + // Phone number extensions
    '(?:' + EXTN_PATTERNS_FOR_PARSING + ')?', 'ig'); // this.searching_from = 0
  }

  _createClass$2(PhoneNumberSearch, [{
    key: "find",
    value: function find() {
      var matches = this.regexp.exec(this.text);

      if (!matches) {
        return;
      }

      var number = matches[0];
      var startsAt = matches.index;
      number = number.replace(WHITESPACE_IN_THE_BEGINNING_PATTERN, '');
      startsAt += matches[0].length - number.length; // Fixes not parsing numbers with whitespace in the end.
      // Also fixes not parsing numbers with opening parentheses in the end.
      // https://github.com/catamphetamine/libphonenumber-js/issues/252

      number = number.replace(PUNCTUATION_IN_THE_END_PATTERN, '');
      number = parsePreCandidate(number);
      var result = this.parseCandidate(number, startsAt);

      if (result) {
        return result;
      } // Tail recursion.
      // Try the next one if this one is not a valid phone number.


      return this.find();
    }
  }, {
    key: "parseCandidate",
    value: function parseCandidate(number, startsAt) {
      if (!isValidPreCandidate(number, startsAt, this.text)) {
        return;
      } // Don't parse phone numbers which are non-phone numbers
      // due to being part of something else (e.g. a UUID).
      // https://github.com/catamphetamine/libphonenumber-js/issues/213
      // Copy-pasted from Google's `PhoneNumberMatcher.js` (`.parseAndValidate()`).


      if (!isValidCandidate(number, startsAt, this.text, this.options.extended ? 'POSSIBLE' : 'VALID')) {
        return;
      } // // Prepend any opening brackets left behind by the
      // // `PHONE_NUMBER_START_PATTERN` regexp.
      // const text_before_number = text.slice(this.searching_from, startsAt)
      // const full_number_starts_at = text_before_number.search(BEFORE_NUMBER_DIGITS_PUNCTUATION)
      // if (full_number_starts_at >= 0)
      // {
      // 	number   = text_before_number.slice(full_number_starts_at) + number
      // 	startsAt = full_number_starts_at
      // }
      //
      // this.searching_from = matches.lastIndex


      var result = parse$2(number, this.options, this.metadata);

      if (!result.phone) {
        return;
      }

      result.startsAt = startsAt;
      result.endsAt = startsAt + number.length;
      return result;
    }
  }, {
    key: "hasNext",
    value: function hasNext() {
      if (this.state === 'NOT_READY') {
        this.last_match = this.find();

        if (this.last_match) {
          this.state = 'READY';
        } else {
          this.state = 'DONE';
        }
      }

      return this.state === 'READY';
    }
  }, {
    key: "next",
    value: function next() {
      // Check the state and find the next match as a side-effect if necessary.
      if (!this.hasNext()) {
        throw new Error('No next element');
      } // Don't retain that memory any longer than necessary.


      var result = this.last_match;
      this.last_match = null;
      this.state = 'NOT_READY';
      return result;
    }
  }]);

  return PhoneNumberSearch;
}();

function _defineProperties$3(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$3(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$3(Constructor.prototype, protoProps); if (staticProps) _defineProperties$3(Constructor, staticProps); return Constructor; }

function _classCallCheck$4(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// https://medium.com/dsinjs/implementing-lru-cache-in-javascript-94ba6755cda9
var Node$1 = function Node(key, value) {
  var next = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var prev = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  _classCallCheck$4(this, Node);

  this.key = key;
  this.value = value;
  this.next = next;
  this.prev = prev;
};

var LRUCache =
/*#__PURE__*/
function () {
  //set default limit of 10 if limit is not passed.
  function LRUCache() {
    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;

    _classCallCheck$4(this, LRUCache);

    this.size = 0;
    this.limit = limit;
    this.head = null;
    this.tail = null;
    this.cache = {};
  } // Write Node to head of LinkedList
  // update cache with Node key and Node reference


  _createClass$3(LRUCache, [{
    key: "put",
    value: function put(key, value) {
      this.ensureLimit();

      if (!this.head) {
        this.head = this.tail = new Node$1(key, value);
      } else {
        var node = new Node$1(key, value, this.head);
        this.head.prev = node;
        this.head = node;
      } //Update the cache map


      this.cache[key] = this.head;
      this.size++;
    } // Read from cache map and make that node as new Head of LinkedList

  }, {
    key: "get",
    value: function get(key) {
      if (this.cache[key]) {
        var value = this.cache[key].value; // node removed from it's position and cache

        this.remove(key); // write node again to the head of LinkedList to make it most recently used

        this.put(key, value);
        return value;
      }

      console.log("Item not available in cache for key ".concat(key));
    }
  }, {
    key: "ensureLimit",
    value: function ensureLimit() {
      if (this.size === this.limit) {
        this.remove(this.tail.key);
      }
    }
  }, {
    key: "remove",
    value: function remove(key) {
      var node = this.cache[key];

      if (node.prev !== null) {
        node.prev.next = node.next;
      } else {
        this.head = node.next;
      }

      if (node.next !== null) {
        node.next.prev = node.prev;
      } else {
        this.tail = node.prev;
      }

      delete this.cache[key];
      this.size--;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.head = null;
      this.tail = null;
      this.size = 0;
      this.cache = {};
    } // // Invokes the callback function with every node of the chain and the index of the node.
    // forEach(fn) {
    //   let node = this.head;
    //   let counter = 0;
    //   while (node) {
    //     fn(node, counter);
    //     node = node.next;
    //     counter++;
    //   }
    // }
    // // To iterate over LRU with a 'for...of' loop
    // *[Symbol.iterator]() {
    //   let node = this.head;
    //   while (node) {
    //     yield node;
    //     node = node.next;
    //   }
    // }

  }]);

  return LRUCache;
}();

function _classCallCheck$5(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$4(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$4(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$4(Constructor.prototype, protoProps); if (staticProps) _defineProperties$4(Constructor, staticProps); return Constructor; }
// countries being used for the same doc with ~10 patterns for each country. Some pages will have
// a lot more countries in use, but typically fewer numbers for each so expanding the cache for
// that use-case won't have a lot of benefit.

var RegExpCache =
/*#__PURE__*/
function () {
  function RegExpCache(size) {
    _classCallCheck$5(this, RegExpCache);

    this.cache = new LRUCache(size);
  }

  _createClass$4(RegExpCache, [{
    key: "getPatternForRegExp",
    value: function getPatternForRegExp(pattern) {
      var regExp = this.cache.get(pattern);

      if (!regExp) {
        regExp = new RegExp('^' + pattern);
        this.cache.put(pattern, regExp);
      }

      return regExp;
    }
  }]);

  return RegExpCache;
}();

/**
 * Leniency when finding potential phone numbers in text segments
 * The levels here are ordered in increasing strictness.
 */

var Leniency = {
  /**
   * Phone numbers accepted are "possible", but not necessarily "valid".
   */
  POSSIBLE: function POSSIBLE(number, candidate, metadata) {
    return true;
  },

  /**
   * Phone numbers accepted are "possible" and "valid".
   * Numbers written in national format must have their national-prefix
   * present if it is usually written for a number of this type.
   */
  VALID: function VALID(number, candidate, metadata) {
    if (!isValidNumber(number, undefined, metadata) || !containsOnlyValidXChars(number, candidate.toString())) {
      return false;
    } // Skipped for simplicity.
    // return isNationalPrefixPresentIfRequired(number, metadata)


    return true;
  },

  /**
   * Phone numbers accepted are "valid" and
   * are grouped in a possible way for this locale. For example, a US number written as
   * "65 02 53 00 00" and "650253 0000" are not accepted at this leniency level, whereas
   * "650 253 0000", "650 2530000" or "6502530000" are.
   * Numbers with more than one '/' symbol in the national significant number
   * are also dropped at this level.
   *
   * Warning: This level might result in lower coverage especially for regions outside of
   * country code "+1". If you are not sure about which level to use,
   * email the discussion group libphonenumber-discuss@googlegroups.com.
   */
  STRICT_GROUPING: function STRICT_GROUPING(number, candidate, metadata, regExpCache) {
    var candidateString = candidate.toString();

    if (!isValidNumber(number, undefined, metadata) || !containsOnlyValidXChars(number, candidateString) || containsMoreThanOneSlashInNationalNumber(number, candidateString) || !isNationalPrefixPresentIfRequired(number)) {
      return false;
    }

    return checkNumberGroupingIsValid(number, candidate, metadata, allNumberGroupsRemainGrouped, regExpCache);
  },

  /**
   * Phone numbers accepted are {@linkplain PhoneNumberUtil#isValidNumber(PhoneNumber) valid} and
   * are grouped in the same way that we would have formatted it, or as a single block. For
   * example, a US number written as "650 2530000" is not accepted at this leniency level, whereas
   * "650 253 0000" or "6502530000" are.
   * Numbers with more than one '/' symbol are also dropped at this level.
   * <p>
   * Warning: This level might result in lower coverage especially for regions outside of country
   * code "+1". If you are not sure about which level to use, email the discussion group
   * libphonenumber-discuss@googlegroups.com.
   */
  EXACT_GROUPING: function EXACT_GROUPING(number, candidate, metadata, regExpCache) {
    var candidateString = candidate.toString();

    if (!isValidNumber(number, undefined, metadata) || !containsOnlyValidXChars(number, candidateString) || containsMoreThanOneSlashInNationalNumber(number, candidateString) || !isNationalPrefixPresentIfRequired(number)) {
      return false;
    }

    return checkNumberGroupingIsValid(number, candidate, metadata, allNumberGroupsAreExactlyPresent, regExpCache);
  }
};

function containsOnlyValidXChars(number, candidate, metadata) {
  // The characters 'x' and 'X' can be (1) a carrier code, in which case they always precede the
  // national significant number or (2) an extension sign, in which case they always precede the
  // extension number. We assume a carrier code is more than 1 digit, so the first case has to
  // have more than 1 consecutive 'x' or 'X', whereas the second case can only have exactly 1 'x'
  // or 'X'. We ignore the character if it appears as the last character of the string.
  for (var index = 0; index < candidate.length - 1; index++) {
    var charAtIndex = candidate.charAt(index);

    if (charAtIndex === 'x' || charAtIndex === 'X') {
      var charAtNextIndex = candidate.charAt(index + 1);

      if (charAtNextIndex === 'x' || charAtNextIndex === 'X') {
        // This is the carrier code case, in which the 'X's always precede the national
        // significant number.
        index++;

        if (util.isNumberMatch(number, candidate.substring(index)) != MatchType.NSN_MATCH) {
          return false;
        } // This is the extension sign case, in which the 'x' or 'X' should always precede the
        // extension number.

      } else if (parseDigits(candidate.substring(index)) !== number.ext) {
        return false;
      }
    }
  }

  return true;
}

function isNationalPrefixPresentIfRequired(number, _metadata) {
  // First, check how we deduced the country code. If it was written in international format, then
  // the national prefix is not required.
  if (number.getCountryCodeSource() != 'FROM_DEFAULT_COUNTRY') {
    return true;
  }

  var phoneNumberRegion = util.getRegionCodeForCountryCode(number.getCountryCode());
  var metadata = util.getMetadataForRegion(phoneNumberRegion);

  if (metadata == null) {
    return true;
  } // Check if a national prefix should be present when formatting this number.


  var nationalNumber = util.getNationalSignificantNumber(number);
  var formatRule = util.chooseFormattingPatternForNumber(metadata.numberFormats(), nationalNumber); // To do this, we check that a national prefix formatting rule was present
  // and that it wasn't just the first-group symbol ($1) with punctuation.

  if (formatRule && formatRule.getNationalPrefixFormattingRule().length > 0) {
    if (formatRule.getNationalPrefixOptionalWhenFormatting()) {
      // The national-prefix is optional in these cases, so we don't need to check if it was
      // present.
      return true;
    }

    if (PhoneNumberUtil.formattingRuleHasFirstGroupOnly(formatRule.getNationalPrefixFormattingRule())) {
      // National Prefix not needed for this number.
      return true;
    } // Normalize the remainder.


    var rawInputCopy = PhoneNumberUtil.normalizeDigitsOnly(number.getRawInput()); // Check if we found a national prefix and/or carrier code at the start of the raw input, and
    // return the result.

    return util.maybeStripNationalPrefixAndCarrierCode(rawInputCopy, metadata, null);
  }

  return true;
}

function containsMoreThanOneSlashInNationalNumber(number, candidate) {
  var firstSlashInBodyIndex = candidate.indexOf('/');

  if (firstSlashInBodyIndex < 0) {
    // No slashes, this is okay.
    return false;
  } // Now look for a second one.


  var secondSlashInBodyIndex = candidate.indexOf('/', firstSlashInBodyIndex + 1);

  if (secondSlashInBodyIndex < 0) {
    // Only one slash, this is okay.
    return false;
  } // If the first slash is after the country calling code, this is permitted.


  var candidateHasCountryCode = number.getCountryCodeSource() === CountryCodeSource.FROM_NUMBER_WITH_PLUS_SIGN || number.getCountryCodeSource() === CountryCodeSource.FROM_NUMBER_WITHOUT_PLUS_SIGN;

  if (candidateHasCountryCode && PhoneNumberUtil.normalizeDigitsOnly(candidate.substring(0, firstSlashInBodyIndex)) === String(number.getCountryCode())) {
    // Any more slashes and this is illegal.
    return candidate.slice(secondSlashInBodyIndex + 1).indexOf('/') >= 0;
  }

  return true;
}

function checkNumberGroupingIsValid(number, candidate, metadata, checkGroups, regExpCache) {
  var normalizedCandidate = normalizeDigits(candidate, true
  /* keep non-digits */
  );
  var formattedNumberGroups = getNationalNumberGroups(metadata, number, null);

  if (checkGroups(metadata, number, normalizedCandidate, formattedNumberGroups)) {
    return true;
  } // If this didn't pass, see if there are any alternate formats that match, and try them instead.


  var alternateFormats = MetadataManager.getAlternateFormatsForCountry(number.getCountryCode());
  var nationalSignificantNumber = util.getNationalSignificantNumber(number);

  if (alternateFormats) {
    for (var _iterator = alternateFormats.numberFormats(), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var alternateFormat = _ref;

      if (alternateFormat.leadingDigitsPatterns().length > 0) {
        // There is only one leading digits pattern for alternate formats.
        var leadingDigitsRegExp = regExpCache.getPatternForRegExp('^' + alternateFormat.leadingDigitsPatterns()[0]);

        if (!leadingDigitsRegExp.test(nationalSignificantNumber)) {
          // Leading digits don't match; try another one.
          continue;
        }
      }

      formattedNumberGroups = getNationalNumberGroups(metadata, number, alternateFormat);

      if (checkGroups(metadata, number, normalizedCandidate, formattedNumberGroups)) {
        return true;
      }
    }
  }

  return false;
}
/**
 * Helper method to get the national-number part of a number, formatted without any national
 * prefix, and return it as a set of digit blocks that would be formatted together following
 * standard formatting rules.
 */


function getNationalNumberGroups(metadata, number, formattingPattern) {
  if (formattingPattern) {
    // We format the NSN only, and split that according to the separator.
    var nationalSignificantNumber = util.getNationalSignificantNumber(number);
    return util.formatNsnUsingPattern(nationalSignificantNumber, formattingPattern, 'RFC3966', metadata).split('-');
  } // This will be in the format +CC-DG1-DG2-DGX;ext=EXT where DG1..DGX represents groups of digits.


  var rfc3966Format = formatNumber(number, 'RFC3966', metadata); // We remove the extension part from the formatted string before splitting it into different
  // groups.

  var endIndex = rfc3966Format.indexOf(';');

  if (endIndex < 0) {
    endIndex = rfc3966Format.length;
  } // The country-code will have a '-' following it.


  var startIndex = rfc3966Format.indexOf('-') + 1;
  return rfc3966Format.slice(startIndex, endIndex).split('-');
}

function allNumberGroupsAreExactlyPresent(metadata, number, normalizedCandidate, formattedNumberGroups) {
  var candidateGroups = normalizedCandidate.split(NON_DIGITS_PATTERN); // Set this to the last group, skipping it if the number has an extension.

  var candidateNumberGroupIndex = number.hasExtension() ? candidateGroups.length - 2 : candidateGroups.length - 1; // First we check if the national significant number is formatted as a block.
  // We use contains and not equals, since the national significant number may be present with
  // a prefix such as a national number prefix, or the country code itself.

  if (candidateGroups.length == 1 || candidateGroups[candidateNumberGroupIndex].contains(util.getNationalSignificantNumber(number))) {
    return true;
  } // Starting from the end, go through in reverse, excluding the first group, and check the
  // candidate and number groups are the same.


  var formattedNumberGroupIndex = formattedNumberGroups.length - 1;

  while (formattedNumberGroupIndex > 0 && candidateNumberGroupIndex >= 0) {
    if (candidateGroups[candidateNumberGroupIndex] !== formattedNumberGroups[formattedNumberGroupIndex]) {
      return false;
    }

    formattedNumberGroupIndex--;
    candidateNumberGroupIndex--;
  } // Now check the first group. There may be a national prefix at the start, so we only check
  // that the candidate group ends with the formatted number group.


  return candidateNumberGroupIndex >= 0 && endsWith(candidateGroups[candidateNumberGroupIndex], formattedNumberGroups[0]);
}

function allNumberGroupsRemainGrouped(metadata, number, normalizedCandidate, formattedNumberGroups) {
  var fromIndex = 0;

  if (number.getCountryCodeSource() !== CountryCodeSource.FROM_DEFAULT_COUNTRY) {
    // First skip the country code if the normalized candidate contained it.
    var countryCode = String(number.getCountryCode());
    fromIndex = normalizedCandidate.indexOf(countryCode) + countryCode.length();
  } // Check each group of consecutive digits are not broken into separate groupings in the
  // {@code normalizedCandidate} string.


  for (var i = 0; i < formattedNumberGroups.length; i++) {
    // Fails if the substring of {@code normalizedCandidate} starting from {@code fromIndex}
    // doesn't contain the consecutive digits in formattedNumberGroups[i].
    fromIndex = normalizedCandidate.indexOf(formattedNumberGroups[i], fromIndex);

    if (fromIndex < 0) {
      return false;
    } // Moves {@code fromIndex} forward.


    fromIndex += formattedNumberGroups[i].length();

    if (i == 0 && fromIndex < normalizedCandidate.length()) {
      // We are at the position right after the NDC. We get the region used for formatting
      // information based on the country code in the phone number, rather than the number itself,
      // as we do not need to distinguish between different countries with the same country
      // calling code and this is faster.
      var region = util.getRegionCodeForCountryCode(number.getCountryCode());

      if (util.getNddPrefixForRegion(region, true) != null && Character.isDigit(normalizedCandidate.charAt(fromIndex))) {
        // This means there is no formatting symbol after the NDC. In this case, we only
        // accept the number if there is no formatting symbol at all in the number, except
        // for extensions. This is only important for countries with national prefixes.
        var nationalSignificantNumber = util.getNationalSignificantNumber(number);
        return startsWith(normalizedCandidate.slice(fromIndex - formattedNumberGroups[i].length), nationalSignificantNumber);
      }
    }
  } // The check here makes sure that we haven't mistakenly already used the extension to
  // match the last group of the subscriber number. Note the extension cannot have
  // formatting in-between digits.


  return normalizedCandidate.slice(fromIndex).contains(number.getExtension());
}

function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty$7(target, key, source[key]); }); } return target; }

function _classCallCheck$6(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$5(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$5(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$5(Constructor.prototype, protoProps); if (staticProps) _defineProperties$5(Constructor, staticProps); return Constructor; }

function _defineProperty$7(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
/**
 * Patterns used to extract phone numbers from a larger phone-number-like pattern. These are
 * ordered according to specificity. For example, white-space is last since that is frequently
 * used in numbers, not just to separate two numbers. We have separate patterns since we don't
 * want to break up the phone-number-like text on more than one different kind of symbol at one
 * time, although symbols of the same type (e.g. space) can be safely grouped together.
 *
 * Note that if there is a match, we will always check any text found up to the first match as
 * well.
 */

var INNER_MATCHES = [// Breaks on the slash - e.g. "651-234-2345/332-445-1234"
'\\/+(.*)/', // Note that the bracket here is inside the capturing group, since we consider it part of the
// phone number. Will match a pattern like "(650) 223 3345 (754) 223 3321".
'(\\([^(]*)', // Breaks on a hyphen - e.g. "12345 - 332-445-1234 is my number."
// We require a space on either side of the hyphen for it to be considered a separator.
"(?:".concat(pZ, "-|-").concat(pZ, ")").concat(pZ, "*(.+)"), // Various types of wide hyphens. Note we have decided not to enforce a space here, since it's
// possible that it's supposed to be used to break two numbers without spaces, and we haven't
// seen many instances of it used within a number.
"[\u2012-\u2015\uFF0D]".concat(pZ, "*(.+)"), // Breaks on a full stop - e.g. "12345. 332-445-1234 is my number."
"\\.+".concat(pZ, "*([^.]+)"), // Breaks on space - e.g. "3324451234 8002341234"
"".concat(pZ, "+(").concat(PZ, "+)")]; // Limit on the number of leading (plus) characters.

var leadLimit = limit(0, 2); // Limit on the number of consecutive punctuation characters.

var punctuationLimit = limit(0, 4);
/* The maximum number of digits allowed in a digit-separated block. As we allow all digits in a
 * single block, set high enough to accommodate the entire national number and the international
 * country code. */

var digitBlockLimit = MAX_LENGTH_FOR_NSN + MAX_LENGTH_COUNTRY_CODE; // Limit on the number of blocks separated by punctuation.
// Uses digitBlockLimit since some formats use spaces to separate each digit.

var blockLimit = limit(0, digitBlockLimit);
/* A punctuation sequence allowing white space. */

var punctuation = "[".concat(VALID_PUNCTUATION, "]") + punctuationLimit; // A digits block without punctuation.

var digitSequence = pNd + limit(1, digitBlockLimit);
/**
 * Phone number pattern allowing optional punctuation.
 * The phone number pattern used by `find()`, similar to
 * VALID_PHONE_NUMBER, but with the following differences:
 * <ul>
 *   <li>All captures are limited in order to place an upper bound to the text matched by the
 *       pattern.
 * <ul>
 *   <li>Leading punctuation / plus signs are limited.
 *   <li>Consecutive occurrences of punctuation are limited.
 *   <li>Number of digits is limited.
 * </ul>
 *   <li>No whitespace is allowed at the start or end.
 *   <li>No alpha digits (vanity numbers such as 1-800-SIX-FLAGS) are currently supported.
 * </ul>
 */

var PATTERN = '(?:' + LEAD_CLASS + punctuation + ')' + leadLimit + digitSequence + '(?:' + punctuation + digitSequence + ')' + blockLimit + '(?:' + EXTN_PATTERNS_FOR_MATCHING + ')?'; // Regular expression of trailing characters that we want to remove.
// We remove all characters that are not alpha or numerical characters.
// The hash character is retained here, as it may signify
// the previous block was an extension.
//
// // Don't know what does '&&' mean here.
// const UNWANTED_END_CHAR_PATTERN = new RegExp(`[[\\P{N}&&\\P{L}]&&[^#]]+$`)
//

var UNWANTED_END_CHAR_PATTERN = new RegExp("[^".concat(_pN).concat(_pL, "#]+$"));
var MAX_SAFE_INTEGER$1 = Number.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1;
/**
 * A stateful class that finds and extracts telephone numbers from {@linkplain CharSequence text}.
 * Instances can be created using the {@linkplain PhoneNumberUtil#findNumbers factory methods} in
 * {@link PhoneNumberUtil}.
 *
 * <p>Vanity numbers (phone numbers using alphabetic digits such as <tt>1-800-SIX-FLAGS</tt> are
 * not found.
 *
 * <p>This class is not thread-safe.
 */

var PhoneNumberMatcher =
/*#__PURE__*/
function () {
  /** The iteration tristate. */

  /** The next index to start searching at. Undefined in {@link State#DONE}. */
  // A cache for frequently used country-specific regular expressions. Set to 32 to cover ~2-3
  // countries being used for the same doc with ~10 patterns for each country. Some pages will have
  // a lot more countries in use, but typically fewer numbers for each so expanding the cache for
  // that use-case won't have a lot of benefit.

  /**
   * Creates a new instance. See the factory methods in {@link PhoneNumberUtil} on how to obtain a
   * new instance.
   *
   * @param util  the phone number util to use
   * @param text  the character sequence that we will search, null for no text
   * @param country  the country to assume for phone numbers not written in international format
   *     (with a leading plus, or with the international dialing prefix of the specified region).
   *     May be null or "ZZ" if only numbers with a leading plus should be
   *     considered.
   * @param leniency  the leniency to use when evaluating candidate phone numbers
   * @param maxTries  the maximum number of invalid numbers to try before giving up on the text.
   *     This is to cover degenerate cases where the text has a lot of false positives in it. Must
   *     be {@code >= 0}.
   */
  function PhoneNumberMatcher() {
    var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var metadata = arguments.length > 2 ? arguments[2] : undefined;

    _classCallCheck$6(this, PhoneNumberMatcher);

    _defineProperty$7(this, "state", 'NOT_READY');

    _defineProperty$7(this, "searchIndex", 0);

    _defineProperty$7(this, "regExpCache", new RegExpCache(32));

    options = _objectSpread$5({}, options, {
      defaultCallingCode: options.defaultCallingCode,
      defaultCountry: options.defaultCountry && isSupportedCountry(options.defaultCountry, metadata) ? options.defaultCountry : undefined,
      leniency: options.leniency || options.extended ? 'POSSIBLE' : 'VALID',
      maxTries: options.maxTries || MAX_SAFE_INTEGER$1
    });

    if (!options.leniency) {
      throw new TypeError('`Leniency` not supplied');
    }

    if (options.maxTries < 0) {
      throw new TypeError('`maxTries` not supplied');
    }

    this.text = text;
    this.options = options;
    this.metadata = metadata;
    /** The degree of validation requested. */

    this.leniency = Leniency[options.leniency];

    if (!this.leniency) {
      throw new TypeError("Unknown leniency: ".concat(options.leniency, "."));
    }
    /** The maximum number of retries after matching an invalid number. */


    this.maxTries = options.maxTries;
    this.PATTERN = new RegExp(PATTERN, 'ig');
  }
  /**
   * Attempts to find the next subsequence in the searched sequence on or after {@code searchIndex}
   * that represents a phone number. Returns the next match, null if none was found.
   *
   * @param index  the search index to start searching at
   * @return  the phone number match found, null if none can be found
   */


  _createClass$5(PhoneNumberMatcher, [{
    key: "find",
    value: function find() // (index)
    {
      // // Reset the regular expression.
      // this.PATTERN.lastIndex = index
      var matches;

      while (this.maxTries > 0 && (matches = this.PATTERN.exec(this.text)) !== null) {
        var candidate = matches[0];
        var offset = matches.index;
        candidate = parsePreCandidate(candidate);

        if (isValidPreCandidate(candidate, offset, this.text)) {
          var match = // Try to come up with a valid match given the entire candidate.
          this.parseAndVerify(candidate, offset, this.text) // If that failed, try to find an "inner match" -
          // there might be a phone number within this candidate.
          || this.extractInnerMatch(candidate, offset, this.text);

          if (match) {
            if (this.options.v2) {
              var phoneNumber = new PhoneNumber(match.country || match.countryCallingCode, match.phone, this.metadata);

              if (match.ext) {
                phoneNumber.ext = match.ext;
              }

              return {
                startsAt: match.startsAt,
                endsAt: match.endsAt,
                number: phoneNumber
              };
            }

            return match;
          }
        }

        this.maxTries--;
      }
    }
    /**
     * Attempts to extract a match from `candidate`
     * if the whole candidate does not qualify as a match.
     */

  }, {
    key: "extractInnerMatch",
    value: function extractInnerMatch(candidate, offset, text) {
      for (var _i = 0, _INNER_MATCHES = INNER_MATCHES; _i < _INNER_MATCHES.length; _i++) {
        var innerMatchPattern = _INNER_MATCHES[_i];
        var isFirstMatch = true;
        var matches = void 0;
        var possibleInnerMatch = new RegExp(innerMatchPattern, 'g');

        while ((matches = possibleInnerMatch.exec(candidate)) !== null && this.maxTries > 0) {
          if (isFirstMatch) {
            // We should handle any group before this one too.
            var _group = trimAfterFirstMatch(UNWANTED_END_CHAR_PATTERN, candidate.slice(0, matches.index));

            var _match = this.parseAndVerify(_group, offset, text);

            if (_match) {
              return _match;
            }

            this.maxTries--;
            isFirstMatch = false;
          }

          var group = trimAfterFirstMatch(UNWANTED_END_CHAR_PATTERN, matches[1]); // Java code does `groupMatcher.start(1)` here,
          // but there's no way in javascript to get a group match start index,
          // therefore using the overall match start index `matches.index`.

          var match = this.parseAndVerify(group, offset + matches.index, text);

          if (match) {
            return match;
          }

          this.maxTries--;
        }
      }
    }
    /**
     * Parses a phone number from the `candidate` using `parseNumber` and
     * verifies it matches the requested `leniency`. If parsing and verification succeed,
     * a corresponding `PhoneNumberMatch` is returned, otherwise this method returns `null`.
     *
     * @param candidate  the candidate match
     * @param offset  the offset of {@code candidate} within {@link #text}
     * @return  the parsed and validated phone number match, or null
     */

  }, {
    key: "parseAndVerify",
    value: function parseAndVerify(candidate, offset, text) {
      if (!isValidCandidate(candidate, offset, text, this.options.leniency)) {
        return;
      }

      var number = parse$2(candidate, {
        extended: true,
        defaultCountry: this.options.defaultCountry,
        defaultCallingCode: this.options.defaultCallingCode
      }, this.metadata);

      if (!number.possible) {
        return;
      }

      if (this.leniency(number, candidate, this.metadata, this.regExpCache)) {
        // // We used parseAndKeepRawInput to create this number,
        // // but for now we don't return the extra values parsed.
        // // TODO: stop clearing all values here and switch all users over
        // // to using rawInput() rather than the rawString() of PhoneNumberMatch.
        // number.clearCountryCodeSource()
        // number.clearRawInput()
        // number.clearPreferredDomesticCarrierCode()
        var result = {
          startsAt: offset,
          endsAt: offset + candidate.length,
          phone: number.phone
        };

        if (number.country && number.country !== '001') {
          result.country = number.country;
        } else {
          result.countryCallingCode = number.countryCallingCode;
        }

        if (number.ext) {
          result.ext = number.ext;
        }

        return result;
      }
    }
  }, {
    key: "hasNext",
    value: function hasNext() {
      if (this.state === 'NOT_READY') {
        this.lastMatch = this.find(); // (this.searchIndex)

        if (this.lastMatch) {
          // this.searchIndex = this.lastMatch.endsAt
          this.state = 'READY';
        } else {
          this.state = 'DONE';
        }
      }

      return this.state === 'READY';
    }
  }, {
    key: "next",
    value: function next() {
      // Check the state and find the next match as a side-effect if necessary.
      if (!this.hasNext()) {
        throw new Error('No next element');
      } // Don't retain that memory any longer than necessary.


      var result = this.lastMatch;
      this.lastMatch = null;
      this.state = 'NOT_READY';
      return result;
    }
  }]);

  return PhoneNumberMatcher;
}();

function _typeof$2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$2 = function _typeof(obj) { return typeof obj; }; } else { _typeof$2 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$2(obj); }

function _classCallCheck$7(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$6(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$6(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$6(Constructor.prototype, protoProps); if (staticProps) _defineProperties$6(Constructor, staticProps); return Constructor; }

function _defineProperty$8(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
// Could be any digit, I guess.

var DUMMY_DIGIT = '9'; // I don't know why is it exactly `15`

var LONGEST_NATIONAL_PHONE_NUMBER_LENGTH = 15; // Create a phone number consisting only of the digit 9 that matches the
// `number_pattern` by applying the pattern to the "longest phone number" string.

var LONGEST_DUMMY_PHONE_NUMBER = repeat$1(DUMMY_DIGIT, LONGEST_NATIONAL_PHONE_NUMBER_LENGTH); // The digits that have not been entered yet will be represented by a \u2008,
// the punctuation space.

var DIGIT_PLACEHOLDER = 'x'; // '\u2008' (punctuation space)

var DIGIT_PLACEHOLDER_MATCHER = new RegExp(DIGIT_PLACEHOLDER); // A set of characters that, if found in a national prefix formatting rules, are an indicator to
// us that we should separate the national prefix from the number when formatting.

var NATIONAL_PREFIX_SEPARATORS_PATTERN = /[- ]/; // Deprecated: Google has removed some formatting pattern related code from their repo.
// An example of a character class is "[1-4]".

var CREATE_CHARACTER_CLASS_PATTERN =  function () {
  return /\[([^\[\]])*\]/g;
}; // Any digit in a regular expression that actually denotes a digit. For
// example, in the regular expression "80[0-2]\d{6,10}", the first 2 digits
// (8 and 0) are standalone digits, but the rest are not.
// Two look-aheads are needed because the number following \\d could be a
// two-digit number, since the phone number can be as long as 15 digits.


var CREATE_STANDALONE_DIGIT_PATTERN =  function () {
  return /\d(?=[^,}][^,}])/g;
}; // A pattern that is used to determine if a `format` is eligible
// to be used by the "as you type formatter".
// It is eligible when the `format` contains groups of the dollar sign
// followed by a single digit, separated by valid phone number punctuation.
// This prevents invalid punctuation (such as the star sign in Israeli star numbers)
// getting into the output of the "as you type formatter".


var ELIGIBLE_FORMAT_PATTERN = new RegExp('^' + '[' + VALID_PUNCTUATION + ']*' + '(\\$\\d[' + VALID_PUNCTUATION + ']*)+' + '$'); // This is the minimum length of the leading digits of a phone number
// to guarantee the first "leading digits pattern" for a phone number format
// to be preemptive.

var MIN_LEADING_DIGITS_LENGTH = 3;
var VALID_FORMATTED_PHONE_NUMBER_PART = '[' + VALID_PUNCTUATION + VALID_DIGITS + ']+';
var VALID_FORMATTED_PHONE_NUMBER_PART_PATTERN = new RegExp('^' + VALID_FORMATTED_PHONE_NUMBER_PART + '$', 'i');
var VALID_PHONE_NUMBER$2 = '(?:' + '[' + PLUS_CHARS + ']' + '[' + VALID_PUNCTUATION + VALID_DIGITS + ']*' + '|' + '[' + VALID_PUNCTUATION + VALID_DIGITS + ']+' + ')';
var AFTER_PHONE_NUMBER_DIGITS_END_PATTERN = new RegExp('[^' + VALID_PUNCTUATION + VALID_DIGITS + ']+' + '.*' + '$');

var AsYouType =
/*#__PURE__*/
function () {
  // Not setting `options` to a constructor argument
  // not to break backwards compatibility
  // for older versions of the library.

  /**
   * @param {(string|object)?} [optionsOrDefaultCountry] - The default country used for parsing non-international phone numbers. Can also be an `options` object.
   * @param {Object} metadata
   */
  function AsYouType(optionsOrDefaultCountry, metadata) {
    _classCallCheck$7(this, AsYouType);

    _defineProperty$8(this, "options", {});

    this.metadata = new Metadata(metadata); // Set `defaultCountry` and `defaultCallingCode` options.

    var defaultCountry;
    var defaultCallingCode; // Turns out `null` also has type "object". Weird.

    if (optionsOrDefaultCountry) {
      if (_typeof$2(optionsOrDefaultCountry) === 'object') {
        defaultCountry = optionsOrDefaultCountry.defaultCountry;
        defaultCallingCode = optionsOrDefaultCountry.defaultCallingCode;
      } else {
        defaultCountry = optionsOrDefaultCountry;
      }
    }

    if (defaultCountry && this.metadata.hasCountry(defaultCountry)) {
      this.defaultCountry = defaultCountry;
    }

    if (defaultCallingCode) {

      this.defaultCallingCode = defaultCallingCode;
    } // Reset.


    this.reset();
  }

  _createClass$6(AsYouType, [{
    key: "reset",
    value: function reset() {
      this.formattedOutput = '';
      this.international = false;
      this.internationalPrefix = undefined;
      this.countryCallingCode = undefined;
      this.digits = '';
      this.nationalNumberDigits = '';
      this.nationalPrefix = '';
      this.carrierCode = '';
      this.setCountry(this.defaultCountry, this.defaultCallingCode);
      return this;
    }
  }, {
    key: "resetFormat",
    value: function resetFormat() {
      this.chosenFormat = undefined;
      this.template = undefined;
      this.populatedNationalNumberTemplate = undefined;
      this.populatedNationalNumberTemplatePosition = -1;
    }
    /**
     * Returns `true` if the phone number is being input in international format.
     * In other words, returns `true` if and only if the parsed phone number starts with a `"+"`.
     * @return {boolean}
     */

  }, {
    key: "isInternational",
    value: function isInternational() {
      return this.international;
    }
    /**
     * Returns the "country calling code" part of the phone number.
     * Returns `undefined` if the number is not being input in international format.
     * Returns "country calling code" for "non-geographic" phone numbering plans too.
     * @return {string} [countryCallingCode]
     */

  }, {
    key: "getCountryCallingCode",
    value: function getCountryCallingCode() {
      return this.countryCallingCode;
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * Returns `undefined` if no phone number has been input yet.
     * @return {string} [country]
     */

  }, {
    key: "getCountry",
    value: function getCountry() {
      // If no digits have been input yet,
      // then `this.country` is the `defaultCountry`.
      // Won't return the `defaultCountry` in such case.
      if (!this.digits) {
        return;
      }

      var countryCode = this.country;

      return countryCode;
    }
  }, {
    key: "setCountry",
    value: function setCountry(country, callingCode) {
      this.country = country;
      this.metadata.selectNumberingPlan(country, callingCode);

      if (this.metadata.hasSelectedNumberingPlan()) {
        this.initializePhoneNumberFormatsForCountry();
      } else {
        this.matchingFormats = [];
      }

      this.resetFormat();
    }
    /**
     * Inputs "next" phone number characters.
     * @param  {string} text
     * @return {string} Formatted phone number characters that have been input so far.
     */

  }, {
    key: "input",
    value: function input(text) {
      var formattedDigits = this.extractFormattedDigits(text); // If the extracted phone number part
      // can possibly be a part of some valid phone number
      // then parse phone number characters from a formatted phone number.

      if (VALID_FORMATTED_PHONE_NUMBER_PART_PATTERN.test(formattedDigits)) {
        this.formattedOutput = this.getFullNumber(this.inputDigits(parseDigits(formattedDigits)) || this.getNonFormattedNationalNumber());
      }

      return this.formattedOutput;
    }
    /**
     * Extracts formatted phone number digits from text (if there're any).
     * @param  {string} text
     * @return {string}
     */

  }, {
    key: "extractFormattedDigits",
    value: function extractFormattedDigits(text) {
      // Extract a formatted phone number part from text.
      var extractedNumber = extractFormattedPhoneNumber$1(text) || ''; // Trim a `+`.

      if (extractedNumber[0] === '+') {
        // Trim the `+`.
        extractedNumber = extractedNumber.slice('+'.length);

        if (this.digits) ; else {
          this.formattedOutput = '+';
          this.startInternationalNumber();
        }
      }

      return extractedNumber;
    }
  }, {
    key: "startInternationalNumber",
    value: function startInternationalNumber() {
      // Prepend the `+` to parsed input.
      this.international = true; // If a default country was set then reset it
      // because an explicitly international phone
      // number is being entered.

      this.setCountry();
    }
    /**
     * Inputs "next" phone number digits.
     * @param  {string} digits
     * @return {string} [formattedNumber] Formatted national phone number (if it can be formatted at this stage). Returning `undefined` means "don't format the national phone number at this stage".
     */

  }, {
    key: "inputDigits",
    value: function inputDigits(nextDigits) {
      // Some users input their phone number in "out-of-country"
      // dialing format instead of using the leading `+`.
      // https://github.com/catamphetamine/libphonenumber-js/issues/185
      // Detect such numbers.
      if (!this.digits) {
        var numberWithoutIDD = stripIDDPrefix(nextDigits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);

        if (numberWithoutIDD && numberWithoutIDD !== nextDigits) {
          // If an IDD prefix was stripped then
          // convert the number to international one
          // for subsequent parsing.
          this.internationalPrefix = nextDigits.slice(0, nextDigits.length - numberWithoutIDD.length);
          nextDigits = numberWithoutIDD;
          this.startInternationalNumber();
        }
      } // Append phone number digits.


      this.digits += nextDigits; // Try to format the parsed input

      if (this.isInternational()) {
        if (this.countryCallingCode) {
          this.nationalNumberDigits += nextDigits; // `this.country` could be `undefined`, for example, when there is
          // ambiguity in a form of several different countries,
          // each corresponding to the same country phone code
          // (e.g. NANPA: USA, Canada, etc), and there's not enough digits
          // to reliably determine the country the phone number belongs to.
          // Therefore, in cases of such ambiguity, each time something is input,
          // try to determine the country (if it hasn't been determined yet).

          if (!this.country || this.isCountryCallingCodeAmbiguous()) {
            this.determineTheCountry();
          }
        } else {
          // Extract country calling code from the digits entered so far.
          // There must be some digits in order to extract anything from them.
          //
          // If one looks at country phone codes
          // then they can notice that no one country phone code
          // is ever a (leftmost) substring of another country phone code.
          // So if a valid country code is extracted so far
          // then it means that this is the country code.
          //
          // If no country phone code could be extracted so far,
          // then don't format the phone number.
          //
          if (!this.extractCountryCallingCode()) {
            // Don't format the phone number.
            return;
          } // Possibly extract a national prefix.
          // Some people incorrectly input national prefix
          // in an international phone number.
          // For example, some people write British phone numbers as `+44(0)...`.
          // Also, mobile phone numbers in Mexico are supposed to be dialled
          // internationally using a `15` national prefix.
          //
          // https://www.mexperience.com/dialing-cell-phones-in-mexico/
          //
          // "Dialing a Mexican cell phone from abroad
          // When you are calling a cell phone number in Mexico from outside Mexico,
          // it’s necessary to dial an additional “1” after Mexico’s country code
          // (which is “52”) and before the area code.
          // You also ignore the 045, and simply dial the area code and the
          // cell phone’s number.
          //
          // If you don’t add the “1”, you’ll receive a recorded announcement
          // asking you to redial using it.
          //
          // For example, if you are calling from the USA to a cell phone
          // in Mexico City, you would dial +52 – 1 – 55 – 1234 5678.
          // (Note that this is different to calling a land line in Mexico City
          // from abroad, where the number dialed would be +52 – 55 – 1234 5678)".
          //


          this.nationalNumberDigits = this.digits.slice(this.countryCallingCode.length); // this.extractNationalPrefix()
          //
          // Determine the country from country calling code and national number.

          this.determineTheCountry();
        }
      } else {
        this.nationalNumberDigits += nextDigits; // If `defaultCallingCode` is set,
        // see if the `country` could be derived.

        if (!this.country) {
          this.determineTheCountry();
        } // Some national prefixes are substrings of other national prefixes
        // (for the same country), therefore try to extract national prefix each time
        // because a longer national prefix might be available at some point in time.


        var previousNationalPrefix = this.nationalPrefix;
        this.nationalNumberDigits = this.nationalPrefix + this.nationalNumberDigits; // Re-extract national prefix.

        this.extractNationalPrefix(); // If another national prefix has been extracted.

        if (this.nationalPrefix !== previousNationalPrefix) {
          // National number has changed
          // (due to another national prefix been extracted)
          // therefore national number has changed
          // therefore reset all previous formatting data.
          // (and leading digits matching state)
          this.initializePhoneNumberFormatsForCountry();
          this.resetFormat();
        }
      }

      if (this.nationalNumberDigits) {
        // Match the available formats by the currently available leading digits.
        this.matchFormats(this.nationalNumberDigits);
      } // Format the phone number (given the next digits)


      return this.formatNationalNumberWithNextDigits(nextDigits);
    }
  }, {
    key: "formatNationalNumberWithNextDigits",
    value: function formatNationalNumberWithNextDigits(nextDigits) {
      // See if the phone number digits can be formatted as a complete phone number.
      // If not, use the results from `formatNextNationalNumberDigits()`,
      // which formats based on the chosen formatting pattern.
      // Attempting to format complete phone number first is how it's done
      // in Google's `libphonenumber`.
      var formattedNumber = this.attemptToFormatCompletePhoneNumber(); // Just because a phone number doesn't have a suitable format
      // that doesn't mean that the phone number is invalid,
      // because phone number formats only format phone numbers,
      // they don't validate them and some (rare) phone numbers
      // are meant to stay non-formatted.

      if (formattedNumber) {
        return formattedNumber;
      } // Format the next phone number digits
      // using the previously chosen phone number format.
      //
      // This is done here because if `attemptToFormatCompletePhoneNumber`
      // was placed before this call then the `template`
      // wouldn't reflect the situation correctly (and would therefore be inconsistent)
      //


      var previouslyChosenFormat = this.chosenFormat; // Choose a format from the list of matching ones.

      var newlyChosenFormat = this.chooseFormat();

      if (newlyChosenFormat) {
        if (newlyChosenFormat === previouslyChosenFormat) {
          // If could format the next (current) digit
          // using the previously chosen phone number format
          // then return the formatted number so far.
          //
          // If no new phone number format could be chosen,
          // and couldn't format the supplied national number
          // using the previously chosen phone number pattern,
          // then return `undefined`.
          //
          return this.formatNextNationalNumberDigits(nextDigits);
        } else {
          // If a more appropriate phone number format
          // has been chosen for these "leading digits",
          // then format the national phone number (so far)
          // using the newly selected format.
          //
          // Will return `undefined` if it couldn't format
          // the supplied national number
          // using the selected phone number pattern.
          //
          return this.reformatNationalNumber();
        }
      }
    }
  }, {
    key: "chooseFormat",
    value: function chooseFormat() {
      // When there are multiple available formats, the formatter uses the first
      // format where a formatting template could be created.
      for (var _iterator = this.matchingFormats, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var format = _ref;

        // If this format is currently being used
        // and is still possible, then stick to it.
        if (this.chosenFormat === format) {
          break;
        }

        if (!this.createFormattingTemplate(format)) {
          continue;
        }

        this.chosenFormat = format; // With a new formatting template, the matched position
        // using the old template needs to be reset.

        this.populatedNationalNumberTemplatePosition = -1;
        break;
      }

      if (!this.chosenFormat) {
        // No format matches the national phone number entered.
        this.resetFormat();
      }

      return this.chosenFormat;
    } // Formats each digit of the national phone number (so far)
    // using the selected format.

  }, {
    key: "reformatNationalNumber",
    value: function reformatNationalNumber() {
      return this.formatNextNationalNumberDigits(this.nationalPrefix + this.nationalNumberDigits);
    }
  }, {
    key: "initializePhoneNumberFormatsForCountry",
    value: function initializePhoneNumberFormatsForCountry() {
      // Get all "eligible" phone number formats for this country
      this.matchingFormats = this.metadata.formats().filter(function (format) {
        // Compared to `libphonenumber`'s code, the two "Discard a few formats
        // that we know are not relevant based on the presence of the national prefix"
        // checks have changed: the first one has been moved to `.matchFormats()`,
        // and the second one doesn't apply to this library because it doesn't deal with
        // "incomplete" phone numbers (for example, phone numbers, entered without "area code").
        return ELIGIBLE_FORMAT_PATTERN.test(format.internationalFormat());
      });
    }
  }, {
    key: "matchFormats",
    value: function matchFormats(leadingDigits) {
      var _this = this;

      // "leading digits" pattern list starts with a
      // "leading digits" pattern fitting a maximum of 3 leading digits.
      // So, after a user inputs 3 digits of a national (significant) phone number
      // this national (significant) number can already be formatted.
      // The next "leading digits" pattern is for 4 leading digits max,
      // and the "leading digits" pattern after it is for 5 leading digits max, etc.
      // This implementation is different from Google's
      // in that it searches for a fitting format
      // even if the user has entered less than
      // `MIN_LEADING_DIGITS_LENGTH` digits of a national number.
      // Because some leading digit patterns already match for a single first digit.
      var leadingDigitsPatternIndex = leadingDigits.length - MIN_LEADING_DIGITS_LENGTH;

      if (leadingDigitsPatternIndex < 0) {
        leadingDigitsPatternIndex = 0;
      }

      this.matchingFormats = this.matchingFormats.filter(function (format) {
        // If national prefix is mandatory for this phone number format
        // and the user didn't input the national prefix
        // then this phone number format isn't suitable.
        if (!_this.isInternational() && !_this.nationalPrefix && format.nationalPrefixIsMandatoryWhenFormattingInNationalFormat()) {
          return false;
        }

        var leadingDigitsPatternsCount = format.leadingDigitsPatterns().length; // If this format is not restricted to a certain
        // leading digits pattern then it fits.

        if (leadingDigitsPatternsCount === 0) {
          return true;
        } // Start excluding any non-matching formats only when the
        // national number entered so far is at least 3 digits long,
        // otherwise format matching would give false negatives.
        // For example, when the digits entered so far are `2`
        // and the leading digits pattern is `21` –
        // it's quite obvious in this case that the format could be the one
        // but due to the absence of further digits it would give false negative.


        if (leadingDigits.length < MIN_LEADING_DIGITS_LENGTH) {
          return true;
        } // If at least `MIN_LEADING_DIGITS_LENGTH` digits of a national number are available
        // then format matching starts narrowing down the list of possible formats
        // (only previously matched formats are considered for next digits).


        leadingDigitsPatternIndex = Math.min(leadingDigitsPatternIndex, leadingDigitsPatternsCount - 1);
        var leadingDigitsPattern = format.leadingDigitsPatterns()[leadingDigitsPatternIndex]; // Brackets are required for `^` to be applied to
        // all or-ed (`|`) parts, not just the first one.

        return new RegExp("^(".concat(leadingDigitsPattern, ")")).test(leadingDigits);
      }); // If there was a phone number format chosen
      // and it no longer holds given the new leading digits then reset it.
      // The test for this `if` condition is marked as:
      // "Reset a chosen format when it no longer holds given the new leading digits".
      // To construct a valid test case for this one can find a country
      // in `PhoneNumberMetadata.xml` yielding one format for 3 `<leadingDigits>`
      // and yielding another format for 4 `<leadingDigits>` (Australia in this case).

      if (this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1) {
        this.resetFormat();
      }
    }
  }, {
    key: "getSeparatorAfterNationalPrefix",
    value: function getSeparatorAfterNationalPrefix(format) {
      if (this.metadata.countryCallingCode() === '1') {
        return ' ';
      }

      if (format && format.nationalPrefixFormattingRule() && NATIONAL_PREFIX_SEPARATORS_PATTERN.test(format.nationalPrefixFormattingRule())) {
        return ' ';
      }

      return '';
    } // This is in accordance to how Google's `libphonenumber` does it.
    // "Check to see if there is an exact pattern match for these digits.
    // If so, we should use this instead of any other formatting template
    // whose `leadingDigitsPattern` also matches the input."

  }, {
    key: "attemptToFormatCompletePhoneNumber",
    value: function attemptToFormatCompletePhoneNumber() {
      for (var _iterator2 = this.matchingFormats, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
        var _ref2;

        if (_isArray2) {
          if (_i2 >= _iterator2.length) break;
          _ref2 = _iterator2[_i2++];
        } else {
          _i2 = _iterator2.next();
          if (_i2.done) break;
          _ref2 = _i2.value;
        }

        var format = _ref2;
        var matcher = new RegExp("^(?:".concat(format.pattern(), ")$"));

        if (!matcher.test(this.nationalNumberDigits)) {
          continue;
        } // Here, national number is formatted without "national prefix
        // formatting rule", because otherwise there'd be a bug
        // when "area code" is "duplicated" during input:
        // https://github.com/catamphetamine/libphonenumber-js/issues/318


        var formattedNationalNumber = formatNationalNumberUsingFormat(this.nationalNumberDigits, format, this.isInternational(), false, // Don't prepend national prefix (it will be prepended manually).
        this.metadata); // Check if this `format` preserves all digits.
        // This is how it's done in Google's `libphonenumber`.
        // Also, it fixes the bug when "area code" is "duplicated" during input:
        // https://github.com/catamphetamine/libphonenumber-js/issues/318
        //
        // "Check that we didn't remove nor add any extra digits when we matched
        // this formatting pattern. This usually happens after we entered the last
        // digit during AYTF. Eg: In case of MX, we swallow mobile token (1) when
        // formatted but AYTF should retain all the number entered and not change
        // in order to match a format (of same leading digits and length) display
        // in that way."
        // "If it's the same (i.e entered number and format is same), then it's
        // safe to return this in formatted number as nothing is lost / added."
        // Otherwise, don't use this format.
        // https://github.com/google/libphonenumber/commit/3e7c1f04f5e7200f87fb131e6f85c6e99d60f510#diff-9149457fa9f5d608a11bb975c6ef4bc5
        // https://github.com/google/libphonenumber/commit/3ac88c7106e7dcb553bcc794b15f19185928a1c6#diff-2dcb77e833422ee304da348b905cde0b
        //

        if (parseDigits(formattedNationalNumber) !== this.nationalNumberDigits) {
          continue;
        } // Prepend national prefix (if any).


        if (this.nationalPrefix) {
          // Here, national number is formatted with "national prefix
          // formatting rule". The reason is that "national prefix
          // formatting rule" often adds parentheses, and while Google's
          // `libphonenumber` dismisses those preferring simply prepending
          // national prefix followed by a " " character, this library
          // looks if the national prefix could be formatted better.
          var formattedNationalNumberWithNationalPrefix = formatNationalNumberUsingFormat(this.nationalNumberDigits, format, this.isInternational(), true, // Prepend national prefix.
          this.metadata);

          if (parseDigits(formattedNationalNumberWithNationalPrefix) === this.nationalPrefix + this.nationalNumberDigits) {
            formattedNationalNumber = formattedNationalNumberWithNationalPrefix;
          } else {
            formattedNationalNumber = this.nationalPrefix + this.getSeparatorAfterNationalPrefix(format) + formattedNationalNumber;
          }
        } // formats national number (probably) without national prefix.
        // Formatting a national number with national prefix could result in
        // bugs when "area code" is "duplicated" during input:
        // https://github.com/catamphetamine/libphonenumber-js/issues/318
        // The "are all digits preserved" check fixes that type of bug.
        // To leave the formatter in a consistent state


        this.resetFormat();
        this.chosenFormat = format; // Set `this.template` and `this.populatedNationalNumberTemplate`.

        /* istanbul ignore else */

        if (this.createFormattingTemplate(format)) {
          // Populate `this.populatedNationalNumberTemplate` with phone number digits.
          this.reformatNationalNumber();
        } else {
          // If the formatting template couldn't be created for a format,
          // create it manually from the formatted phone number.
          // This case doesn't ever happen with the current metadata.
          this.template = this.getFullNumber(formattedNationalNumber).replace(/[\d\+]/g, DIGIT_PLACEHOLDER);
          this.populatedNationalNumberTemplate = formattedNationalNumber;
          this.populatedNationalNumberTemplatePosition = this.populatedNationalNumberTemplate.length - 1;
        }

        return formattedNationalNumber;
      }
    }
  }, {
    key: "getInternationalPrefix",
    value: function getInternationalPrefix(options) {
      return this.internationalPrefix ? options && options.spacing === false ? this.internationalPrefix : this.internationalPrefix + ' ' : '+';
    } // Prepends `+CountryCode ` in case of an international phone number

  }, {
    key: "getFullNumber",
    value: function getFullNumber(formattedNationalNumber) {
      if (this.isInternational()) {
        var prefix = this.getInternationalPrefix();

        if (!this.countryCallingCode) {
          return "".concat(prefix).concat(this.digits);
        }

        if (!formattedNationalNumber) {
          return "".concat(prefix).concat(this.countryCallingCode);
        }

        return "".concat(prefix).concat(this.countryCallingCode, " ").concat(formattedNationalNumber);
      }

      return formattedNationalNumber;
    }
  }, {
    key: "getNonFormattedNationalNumber",
    value: function getNonFormattedNationalNumber() {
      return this.nationalPrefix + (this.nationalPrefix && this.nationalNumberDigits && this.getSeparatorAfterNationalPrefix()) + this.nationalNumberDigits;
    } // Extracts the country calling code from the beginning
    // of the entered `national_number` (so far),
    // and places the remaining input into the `national_number`.

  }, {
    key: "extractCountryCallingCode",
    value: function extractCountryCallingCode$1() {
      var _extractCountryCallin = extractCountryCallingCode('+' + this.digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata),
          countryCallingCode = _extractCountryCallin.countryCallingCode,
          number = _extractCountryCallin.number;

      if (!countryCallingCode) {
        return;
      }

      this.nationalNumberDigits = number;
      this.countryCallingCode = countryCallingCode;
      this.metadata.chooseCountryByCountryCallingCode(countryCallingCode);
      this.initializePhoneNumberFormatsForCountry();
      this.resetFormat();
      return this.metadata.hasSelectedNumberingPlan();
    }
  }, {
    key: "extractNationalPrefix",
    value: function extractNationalPrefix() {
      this.nationalPrefix = '';

      if (!this.metadata.hasSelectedNumberingPlan()) {
        return;
      } // Only strip national prefixes for non-international phone numbers
      // because national prefixes can't be present in international phone numbers.
      // While `parseNumber()` is forgiving is such cases, `AsYouType` is not.


      var _stripNationalPrefixA = stripNationalPrefixAndCarrierCode(this.nationalNumberDigits, this.metadata),
          nationalNumber = _stripNationalPrefixA.nationalNumber,
          carrierCode = _stripNationalPrefixA.carrierCode; // Sometimes `stripNationalPrefixAndCarrierCode()` won't actually
      // strip national prefix and will instead prepend some digits to the `number`:
      // for example, when number `2345678` is passed with `VI` country selected,
      // it will return `{ number: "3402345678" }`, because `340` area code is prepended.
      // So check if the `nationalNumber` is actually at the end of `this.nationalNumberDigits`.


      if (nationalNumber) {
        var index = this.nationalNumberDigits.indexOf(nationalNumber);

        if (index < 0 || index !== this.nationalNumberDigits.length - nationalNumber.length) {
          return;
        }
      }

      if (carrierCode) {
        this.carrierCode = carrierCode;
      }

      this.nationalPrefix = this.nationalNumberDigits.slice(0, this.nationalNumberDigits.length - nationalNumber.length);
      this.nationalNumberDigits = nationalNumber;
      return this.nationalPrefix;
    } // isPossibleNumber(number) {
    // 	switch (checkNumberLengthForType(number, undefined, this.metadata)) {
    // 		case 'IS_POSSIBLE':
    // 			return true
    // 		// case 'IS_POSSIBLE_LOCAL_ONLY':
    // 		// 	return !this.isInternational()
    // 		default:
    // 			return false
    // 	}
    // }

  }, {
    key: "isCountryCallingCodeAmbiguous",
    value: function isCountryCallingCodeAmbiguous() {
      var countryCodes = this.metadata.getCountryCodesForCallingCode(this.countryCallingCode);
      return countryCodes && countryCodes.length > 1;
    }
  }, {
    key: "createFormattingTemplate",
    value: function createFormattingTemplate(format) {
      // The formatter doesn't format numbers when numberPattern contains '|', e.g.
      // (20|3)\d{4}. In those cases we quickly return.
      // (Though there's no such format in current metadata)

      /* istanbul ignore if */
      if ( format.pattern().indexOf('|') >= 0) {
        return;
      } // Get formatting template for this phone number format


      var template = this.getTemplateForNumberFormatPattern(format, this.nationalPrefix); // If the national number entered is too long
      // for any phone number format, then abort.

      if (!template) {
        return;
      }

      this.template = template;
      this.populatedNationalNumberTemplate = template; // For convenience, the public `.template` property
      // contains the whole international number
      // if the phone number being input is international:
      // 'x' for the '+' sign, 'x'es for the country phone code,
      // a spacebar and then the template for the formatted national number.

      if (this.isInternational()) {
        this.template = this.getInternationalPrefix().replace(/[\d\+]/g, DIGIT_PLACEHOLDER) + repeat$1(DIGIT_PLACEHOLDER, this.countryCallingCode.length) + ' ' + template;
      }

      return this.template;
    }
    /**
     * Generates formatting template for a national phone number,
     * optionally containing a national prefix, for a format.
     * @param  {Format} format
     * @param  {string} nationalPrefix
     * @return {string}
     */

  }, {
    key: "getTemplateForNumberFormatPattern",
    value: function getTemplateForNumberFormatPattern(format, nationalPrefix) {
      var pattern = format.pattern();
      /* istanbul ignore else */

      {
        pattern = pattern // Replace anything in the form of [..] with \d
        .replace(CREATE_CHARACTER_CLASS_PATTERN(), '\\d') // Replace any standalone digit (not the one in `{}`) with \d
        .replace(CREATE_STANDALONE_DIGIT_PATTERN(), '\\d');
      } // Generate a dummy national number (consisting of `9`s)
      // that fits this format's `pattern`.
      //
      // This match will always succeed,
      // because the "longest dummy phone number"
      // has enough length to accomodate any possible
      // national phone number format pattern.
      //


      var digits = LONGEST_DUMMY_PHONE_NUMBER.match(pattern)[0]; // If the national number entered is too long
      // for any phone number format, then abort.

      if (this.nationalNumberDigits.length > digits.length) {
        return;
      } // Get a formatting template which can be used to efficiently format
      // a partial number where digits are added one by one.
      // Below `strictPattern` is used for the
      // regular expression (with `^` and `$`).
      // This wasn't originally in Google's `libphonenumber`
      // and I guess they don't really need it
      // because they're not using "templates" to format phone numbers
      // but I added `strictPattern` after encountering
      // South Korean phone number formatting bug.
      //
      // Non-strict regular expression bug demonstration:
      //
      // this.nationalNumberDigits : `111111111` (9 digits)
      //
      // pattern : (\d{2})(\d{3,4})(\d{4})
      // format : `$1 $2 $3`
      // digits : `9999999999` (10 digits)
      //
      // '9999999999'.replace(new RegExp(/(\d{2})(\d{3,4})(\d{4})/g), '$1 $2 $3') = "99 9999 9999"
      //
      // template : xx xxxx xxxx
      //
      // But the correct template in this case is `xx xxx xxxx`.
      // The template was generated incorrectly because of the
      // `{3,4}` variability in the `pattern`.
      //
      // The fix is, if `this.nationalNumberDigits` has already sufficient length
      // to satisfy the `pattern` completely then `this.nationalNumberDigits`
      // is used instead of `digits`.


      var strictPattern = new RegExp('^' + pattern + '$');
      var nationalNumberDummyDigits = this.nationalNumberDigits.replace(/\d/g, DUMMY_DIGIT); // If `this.nationalNumberDigits` has already sufficient length
      // to satisfy the `pattern` completely then use it
      // instead of `digits`.

      if (strictPattern.test(nationalNumberDummyDigits)) {
        digits = nationalNumberDummyDigits;
      }

      var numberFormat = this.getFormatFormat(format);
      var includesNationalPrefix;

      if (nationalPrefix) {
        if (format.nationalPrefixFormattingRule()) {
          var numberFormatWithNationalPrefix = numberFormat.replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule());

          if (parseDigits(numberFormatWithNationalPrefix) === nationalPrefix + parseDigits(numberFormat)) {
            numberFormat = numberFormatWithNationalPrefix;
            includesNationalPrefix = true;
            var i = nationalPrefix.length;

            while (i > 0) {
              numberFormat = numberFormat.replace(/\d/, DIGIT_PLACEHOLDER);
              i--;
            }
          }
        }
      } // Generate formatting template for this phone number format.


      var template = digits // Format the dummy phone number according to the format.
      .replace(new RegExp(pattern), numberFormat) // Replace each dummy digit with a DIGIT_PLACEHOLDER.
      .replace(new RegExp(DUMMY_DIGIT, 'g'), DIGIT_PLACEHOLDER);

      if (nationalPrefix) {
        if (!includesNationalPrefix) {
          // Prepend national prefix to the template manually.
          template = repeat$1(DIGIT_PLACEHOLDER, nationalPrefix.length) + this.getSeparatorAfterNationalPrefix(format) + template;
        }
      }

      return template;
    }
  }, {
    key: "formatNextNationalNumberDigits",
    value: function formatNextNationalNumberDigits(digits) {
      // Using `.split('')` to iterate through a string here
      // to avoid requiring `Symbol.iterator` polyfill.
      // `.split('')` is generally not safe for Unicode,
      // but in this particular case for `digits` it is safe.
      // for (const digit of digits)
      for (var _iterator3 = digits.split(''), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
        var _ref3;

        if (_isArray3) {
          if (_i3 >= _iterator3.length) break;
          _ref3 = _iterator3[_i3++];
        } else {
          _i3 = _iterator3.next();
          if (_i3.done) break;
          _ref3 = _i3.value;
        }

        var digit = _ref3;

        // If there is room for more digits in current `template`,
        // then set the next digit in the `template`,
        // and return the formatted digits so far.
        // If more digits are entered than the current format could handle.
        if (this.populatedNationalNumberTemplate.slice(this.populatedNationalNumberTemplatePosition + 1).search(DIGIT_PLACEHOLDER_MATCHER) < 0) {
          // Reset the format.
          this.resetFormat();
          return;
        }

        this.populatedNationalNumberTemplatePosition = this.populatedNationalNumberTemplate.search(DIGIT_PLACEHOLDER_MATCHER);
        this.populatedNationalNumberTemplate = this.populatedNationalNumberTemplate.replace(DIGIT_PLACEHOLDER_MATCHER, digit);
      } // Return the formatted phone number so far.


      return cutAndStripNonPairedParens(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1); // The old way which was good for `input-format` but is not so good
      // for `react-phone-number-input`'s default input (`InputBasic`).
      // return closeNonPairedParens(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1)
      // 	.replace(new RegExp(DIGIT_PLACEHOLDER, 'g'), ' ')
    }
  }, {
    key: "getFormatFormat",
    value: function getFormatFormat(format) {
      if (this.isInternational()) {
        return applyInternationalSeparatorStyle(format.internationalFormat());
      }

      return format.format();
    } // Determines the country of the phone number
    // entered so far based on the country phone code
    // and the national phone number.

  }, {
    key: "determineTheCountry",
    value: function determineTheCountry() {
      this.country = findCountryCode(this.isInternational() ? this.countryCallingCode : this.defaultCallingCode, this.nationalNumberDigits, this.metadata);
    }
    /**
     * Returns an instance of `PhoneNumber` class.
     * Will return `undefined` if no national (significant) number
     * digits have been entered so far, or if no `defaultCountry` has been
     * set and the user enters a phone number not in international format.
     */

  }, {
    key: "getNumber",
    value: function getNumber() {
      if (this.isInternational()) {
        if (!this.countryCallingCode) {
          return;
        }
      } else {
        if (!this.country && !this.defaultCallingCode) {
          return;
        }
      }

      if (!this.nationalNumberDigits) {
        return undefined;
      }

      var countryCode = this.getCountry();
      var callingCode = this.getCountryCallingCode() || this.defaultCallingCode;
      var nationalNumber = this.nationalNumberDigits;
      var carrierCode = this.carrierCode; // When an international number without a leading `+` has been autocorrected,
      // extract country calling code, because normally it's only extracted
      // for international numbers with a leading `+`.
      // Could also just use `parsePhoneNumberFromString()` here
      // instead of hacking around this single case.

      if (!this.isInternational() && this.nationalNumberDigits === this.digits) {
        var _extractCountryCallin2 = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(this.digits, countryCode, callingCode, this.metadata.metadata),
            countryCallingCode = _extractCountryCallin2.countryCallingCode,
            number = _extractCountryCallin2.number;

        if (countryCallingCode) {
          var _stripNationalPrefixA2 = stripNationalPrefixAndCarrierCodeFromCompleteNumber(number, this.metadata),
              shorterNationalNumber = _stripNationalPrefixA2.nationalNumber,
              newCarrierCode = _stripNationalPrefixA2.carrierCode;

          nationalNumber = shorterNationalNumber;
          carrierCode = newCarrierCode;
        }
      }

      var phoneNumber = new PhoneNumber(countryCode || callingCode, nationalNumber, this.metadata.metadata);

      if (carrierCode) {
        phoneNumber.carrierCode = carrierCode;
      } // Phone number extensions are not supported by "As You Type" formatter.


      return phoneNumber;
    }
    /**
     * Returns `true` if the phone number is "possible".
     * Is just a shortcut for `PhoneNumber.isPossible()`.
     * @return {boolean}
     */

  }, {
    key: "isPossible",
    value: function isPossible() {
      var phoneNumber = this.getNumber();

      if (!phoneNumber) {
        return false;
      }

      return phoneNumber.isPossible();
    }
    /**
     * Returns `true` if the phone number is "valid".
     * Is just a shortcut for `PhoneNumber.isValid()`.
     * @return {boolean}
     */

  }, {
    key: "isValid",
    value: function isValid() {
      var phoneNumber = this.getNumber();

      if (!phoneNumber) {
        return false;
      }

      return phoneNumber.isValid();
    }
    /**
     * @deprecated
     * This method is used in `react-phone-number-input/source/input-control.js`
     * in versions before `3.0.16`.
     */

  }, {
    key: "getNationalNumber",
    value: function getNationalNumber() {
      return this.nationalNumberDigits;
    }
  }, {
    key: "getNonFormattedTemplate",
    value: function getNonFormattedTemplate() {
      return this.getFullNumber(this.getNonFormattedNationalNumber()).replace(/[\+\d]/g, DIGIT_PLACEHOLDER);
    }
    /**
     * Returns formatted phone number template.
     * @return {string} [template]
     */

  }, {
    key: "getTemplate",
    value: function getTemplate() {
      if (!this.template) {
        return this.getNonFormattedTemplate();
      }

      var index = -1;
      var i = 0;

      while (i < (this.isInternational() ? this.getInternationalPrefix({
        spacing: false
      }).length : 0) + this.digits.length) {
        index = this.template.indexOf(DIGIT_PLACEHOLDER, index + 1);
        i++;
      }

      return cutAndStripNonPairedParens(this.template, index + 1);
    }
  }]);

  return AsYouType;
}();
function stripNonPairedParens(string) {
  var dangling_braces = [];
  var i = 0;

  while (i < string.length) {
    if (string[i] === '(') {
      dangling_braces.push(i);
    } else if (string[i] === ')') {
      dangling_braces.pop();
    }

    i++;
  }

  var start = 0;
  var cleared_string = '';
  dangling_braces.push(string.length);

  for (var _i4 = 0, _dangling_braces = dangling_braces; _i4 < _dangling_braces.length; _i4++) {
    var index = _dangling_braces[_i4];
    cleared_string += string.slice(start, index);
    start = index + 1;
  }

  return cleared_string;
}
function cutAndStripNonPairedParens(string, cutBeforeIndex) {
  if (string[cutBeforeIndex] === ')') {
    cutBeforeIndex++;
  }

  return stripNonPairedParens(string.slice(0, cutBeforeIndex));
}
// http://stackoverflow.com/questions/202605/repeat-string-javascript

function repeat$1(string, times) {
  if (times < 1) {
    return '';
  }

  var result = '';

  while (times > 1) {
    if (times & 1) {
      result += string;
    }

    times >>= 1;
    string += string;
  }

  return result + string;
}
/**
 * Extracts formatted phone number from text (if there's any).
 * @param  {string} text
 * @return {string} [formattedPhoneNumber]
 */

function extractFormattedPhoneNumber$1(text) {
  // Attempt to extract a possible number from the string passed in.
  var startsAt = text.search(VALID_PHONE_NUMBER$2);

  if (startsAt < 0) {
    return;
  } // Trim everything to the left of the phone number.


  text = text.slice(startsAt); // Trim the `+`.

  var hasPlus;

  if (text[0] === '+') {
    hasPlus = true;
    text = text.slice('+'.length);
  } // Trim everything to the right of the phone number.


  text = text.replace(AFTER_PHONE_NUMBER_DIGITS_END_PATTERN, ''); // Re-add the previously trimmed `+`.

  if (hasPlus) {
    text = '+' + text;
  }

  return text;
}

// Deprecated.

function parsePhoneNumberFromString$2()
{
	var parameters = Array.prototype.slice.call(arguments);
	parameters.push(metadata);
	return parsePhoneNumberFromString$1.apply(this, parameters)
}

// Deprecated.
function PhoneNumberSearch$1(text, options)
{
	PhoneNumberSearch.call(this, text, options, metadata);
}

// Deprecated.
PhoneNumberSearch$1.prototype = Object.create(PhoneNumberSearch.prototype, {});
PhoneNumberSearch$1.prototype.constructor = PhoneNumberSearch$1;

function PhoneNumberMatcher$1(text, options)
{
	PhoneNumberMatcher.call(this, text, options, metadata);
}

PhoneNumberMatcher$1.prototype = Object.create(PhoneNumberMatcher.prototype, {});
PhoneNumberMatcher$1.prototype.constructor = PhoneNumberMatcher$1;

function AsYouType$1(country)
{
	AsYouType.call(this, country, metadata);
}

AsYouType$1.prototype = Object.create(AsYouType.prototype, {});
AsYouType$1.prototype.constructor = AsYouType$1;

var format = function format(number) {
  var strNumber = number.toString();

  if (strNumber.startsWith('55')) {
    var phoneNumber = parsePhoneNumberFromString$2('+ ' + strNumber);
    return phoneNumber.formatNational();
  } else {
    return "+".concat(number);
  }
};
var equals = function equals(p1, p2) {
  return p1.number === p2.number;
};

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
var stringTrimForced = function (METHOD_NAME) {
  return fails(function () {
    return !!whitespaces[METHOD_NAME]() || non[METHOD_NAME]() != non || whitespaces[METHOD_NAME].name !== METHOD_NAME;
  });
};

var $trim = stringTrim.trim;


// `String.prototype.trim` method
// https://tc39.github.io/ecma262/#sec-string.prototype.trim
_export({ target: 'String', proto: true, forced: stringTrimForced('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});

/**
  * vee-validate v3.4.5
  * (c) 2020 Abdelrahman Awad
  * @license MIT
  */

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign$1 = function() {
    __assign$1 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function isNaN$1(value) {
    // NaN is the one value that does not equal itself.
    // eslint-disable-next-line
    return value !== value;
}
function isNullOrUndefined(value) {
    return value === null || value === undefined;
}
function isEmptyArray(arr) {
    return Array.isArray(arr) && arr.length === 0;
}
var isObject$5 = function (obj) {
    return obj !== null && obj && typeof obj === 'object' && !Array.isArray(obj);
};
/**
 * A reference comparison function with NaN support
 */
function isRefEqual(lhs, rhs) {
    if (isNaN$1(lhs) && isNaN$1(rhs)) {
        return true;
    }
    return lhs === rhs;
}
/**
 * Shallow object comparison.
 */
function isEqual(lhs, rhs) {
    if (lhs instanceof RegExp && rhs instanceof RegExp) {
        return isEqual(lhs.source, rhs.source) && isEqual(lhs.flags, rhs.flags);
    }
    if (Array.isArray(lhs) && Array.isArray(rhs)) {
        if (lhs.length !== rhs.length)
            return false;
        for (var i = 0; i < lhs.length; i++) {
            if (!isEqual(lhs[i], rhs[i])) {
                return false;
            }
        }
        return true;
    }
    // if both are objects, compare each key recursively.
    if (isObject$5(lhs) && isObject$5(rhs)) {
        return (Object.keys(lhs).every(function (key) {
            return isEqual(lhs[key], rhs[key]);
        }) &&
            Object.keys(rhs).every(function (key) {
                return isEqual(lhs[key], rhs[key]);
            }));
    }
    return isRefEqual(lhs, rhs);
}
// Checks if a given value is not an empty string or null or undefined.
function isSpecified(val) {
    if (val === '') {
        return false;
    }
    return !isNullOrUndefined(val);
}
function isCallable(fn) {
    return typeof fn === 'function';
}
function isLocator(value) {
    return isCallable(value) && !!value.__locatorRef;
}

function findIndex(arrayLike, predicate) {
    var array = Array.isArray(arrayLike) ? arrayLike : toArray$1(arrayLike);
    if (isCallable(array.findIndex)) {
        return array.findIndex(predicate);
    }
    /* istanbul ignore next */
    for (var i = 0; i < array.length; i++) {
        if (predicate(array[i], i)) {
            return i;
        }
    }
    /* istanbul ignore next */
    return -1;
}
/**
 * finds the first element that satisfies the predicate callback, polyfills array.find
 */
function find$1(arrayLike, predicate) {
    var array = Array.isArray(arrayLike) ? arrayLike : toArray$1(arrayLike);
    var idx = findIndex(array, predicate);
    return idx === -1 ? undefined : array[idx];
}
function includes$1(collection, item) {
    return collection.indexOf(item) !== -1;
}
/**
 * Converts an array-like object to array, provides a simple polyfill for Array.from
 */
function toArray$1(arrayLike) {
    if (isCallable(Array.from)) {
        return Array.from(arrayLike);
    }
    /* istanbul ignore next */
    return _copyArray(arrayLike);
}
/* istanbul ignore next */
function _copyArray(arrayLike) {
    var array = [];
    var length = arrayLike.length;
    for (var i = 0; i < length; i++) {
        array.push(arrayLike[i]);
    }
    return array;
}
function values(obj) {
    if (isCallable(Object.values)) {
        return Object.values(obj);
    }
    // fallback to keys()
    /* istanbul ignore next */
    return Object.keys(obj).map(function (k) { return obj[k]; });
}
function merge$1(target, source) {
    Object.keys(source).forEach(function (key) {
        if (isObject$5(source[key])) {
            if (!target[key]) {
                target[key] = {};
            }
            merge$1(target[key], source[key]);
            return;
        }
        target[key] = source[key];
    });
    return target;
}

function createFlags() {
    return {
        untouched: true,
        touched: false,
        dirty: false,
        pristine: true,
        valid: false,
        invalid: false,
        validated: false,
        pending: false,
        required: false,
        changed: false,
        passed: false,
        failed: false
    };
}
function debounce(fn, wait, token) {
    if (wait === void 0) { wait = 0; }
    if (token === void 0) { token = { cancelled: false }; }
    if (wait === 0) {
        return fn;
    }
    var timeout;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var later = function () {
            timeout = undefined;
            // check if the fn call was cancelled.
            if (!token.cancelled)
                fn.apply(void 0, args);
        };
        // because we might want to use Node.js setTimout for SSR.
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

/**
 * Emits a warning to the console
 */
function warn$2(message) {
    console.warn("[vee-validate] " + message);
}
/**
 * Replaces placeholder values in a string with their actual values
 */
function interpolate(template, values) {
    return template.replace(/{([^}]+)}/g, function (_, p) {
        return p in values ? values[p] : "{" + p + "}";
    });
}

var RULES = {};
function normalizeSchema(schema) {
    var _a;
    if ((_a = schema.params) === null || _a === void 0 ? void 0 : _a.length) {
        schema.params = schema.params.map(function (param) {
            if (typeof param === 'string') {
                return { name: param };
            }
            return param;
        });
    }
    return schema;
}
var RuleContainer = /** @class */ (function () {
    function RuleContainer() {
    }
    RuleContainer.extend = function (name, schema) {
        // if rule already exists, overwrite it.
        var rule = normalizeSchema(schema);
        if (RULES[name]) {
            RULES[name] = merge$1(RULES[name], schema);
            return;
        }
        RULES[name] = __assign$1({ lazy: false, computesRequired: false }, rule);
    };
    RuleContainer.isLazy = function (name) {
        var _a;
        return !!((_a = RULES[name]) === null || _a === void 0 ? void 0 : _a.lazy);
    };
    RuleContainer.isRequireRule = function (name) {
        var _a;
        return !!((_a = RULES[name]) === null || _a === void 0 ? void 0 : _a.computesRequired);
    };
    RuleContainer.getRuleDefinition = function (ruleName) {
        return RULES[ruleName];
    };
    return RuleContainer;
}());
/**
 * Adds a custom validator to the list of validation rules.
 */
function extend$2(name, schema) {
    // makes sure new rules are properly formatted.
    guardExtend(name, schema);
    // Full schema object.
    if (typeof schema === 'object') {
        RuleContainer.extend(name, schema);
        return;
    }
    RuleContainer.extend(name, {
        validate: schema
    });
}
/**
 * Guards from extension violations.
 */
function guardExtend(name, validator) {
    if (isCallable(validator)) {
        return;
    }
    if (isCallable(validator.validate)) {
        return;
    }
    if (RuleContainer.getRuleDefinition(name)) {
        return;
    }
    throw new Error("Extension Error: The validator '" + name + "' must be a function or have a 'validate' method.");
}

var DEFAULT_CONFIG = {
    defaultMessage: "{_field_} is not valid.",
    skipOptional: true,
    classes: {
        touched: 'touched',
        untouched: 'untouched',
        valid: 'valid',
        invalid: 'invalid',
        pristine: 'pristine',
        dirty: 'dirty' // control has been interacted with
    },
    bails: true,
    mode: 'aggressive',
    useConstraintAttrs: true
};
var currentConfig = __assign$1({}, DEFAULT_CONFIG);
var getConfig = function () { return currentConfig; };

/**
 * Normalizes the given rules expression.
 */
function normalizeRules(rules) {
    // if falsy value return an empty object.
    var acc = {};
    Object.defineProperty(acc, '_$$isNormalized', {
        value: true,
        writable: false,
        enumerable: false,
        configurable: false
    });
    if (!rules) {
        return acc;
    }
    // Object is already normalized, skip.
    if (isObject$5(rules) && rules._$$isNormalized) {
        return rules;
    }
    if (isObject$5(rules)) {
        return Object.keys(rules).reduce(function (prev, curr) {
            var params = [];
            if (rules[curr] === true) {
                params = [];
            }
            else if (Array.isArray(rules[curr])) {
                params = rules[curr];
            }
            else if (isObject$5(rules[curr])) {
                params = rules[curr];
            }
            else {
                params = [rules[curr]];
            }
            if (rules[curr] !== false) {
                prev[curr] = buildParams(curr, params);
            }
            return prev;
        }, acc);
    }
    /* istanbul ignore if */
    if (typeof rules !== 'string') {
        warn$2('rules must be either a string or an object.');
        return acc;
    }
    return rules.split('|').reduce(function (prev, rule) {
        var parsedRule = parseRule(rule);
        if (!parsedRule.name) {
            return prev;
        }
        prev[parsedRule.name] = buildParams(parsedRule.name, parsedRule.params);
        return prev;
    }, acc);
}
function buildParams(ruleName, provided) {
    var ruleSchema = RuleContainer.getRuleDefinition(ruleName);
    if (!ruleSchema) {
        return provided;
    }
    var params = {};
    if (!ruleSchema.params && !Array.isArray(provided)) {
        throw new Error('You provided an object params to a rule that has no defined schema.');
    }
    // Rule probably uses an array for their args, keep it as is.
    if (Array.isArray(provided) && !ruleSchema.params) {
        return provided;
    }
    var definedParams;
    // collect the params schema.
    if (!ruleSchema.params || (ruleSchema.params.length < provided.length && Array.isArray(provided))) {
        var lastDefinedParam_1;
        // collect any additional parameters in the last item.
        definedParams = provided.map(function (_, idx) {
            var _a;
            var param = (_a = ruleSchema.params) === null || _a === void 0 ? void 0 : _a[idx];
            lastDefinedParam_1 = param || lastDefinedParam_1;
            if (!param) {
                param = lastDefinedParam_1;
            }
            return param;
        });
    }
    else {
        definedParams = ruleSchema.params;
    }
    // Match the provided array length with a temporary schema.
    for (var i = 0; i < definedParams.length; i++) {
        var options = definedParams[i];
        var value = options.default;
        // if the provided is an array, map element value.
        if (Array.isArray(provided)) {
            if (i in provided) {
                value = provided[i];
            }
        }
        else {
            // If the param exists in the provided object.
            if (options.name in provided) {
                value = provided[options.name];
                // if the provided is the first param value.
            }
            else if (definedParams.length === 1) {
                value = provided;
            }
        }
        // if the param is a target, resolve the target value.
        if (options.isTarget) {
            value = createLocator(value, options.cast);
        }
        // A target param using interpolation
        if (typeof value === 'string' && value[0] === '@') {
            value = createLocator(value.slice(1), options.cast);
        }
        // If there is a transformer defined.
        if (!isLocator(value) && options.cast) {
            value = options.cast(value);
        }
        // already been set, probably multiple values.
        if (params[options.name]) {
            params[options.name] = Array.isArray(params[options.name]) ? params[options.name] : [params[options.name]];
            params[options.name].push(value);
        }
        else {
            // set the value.
            params[options.name] = value;
        }
    }
    return params;
}
/**
 * Parses a rule string expression.
 */
var parseRule = function (rule) {
    var params = [];
    var name = rule.split(':')[0];
    if (includes$1(rule, ':')) {
        params = rule
            .split(':')
            .slice(1)
            .join(':')
            .split(',');
    }
    return { name: name, params: params };
};
function createLocator(value, castFn) {
    var locator = function (crossTable) {
        var val = crossTable[value];
        return castFn ? castFn(val) : val;
    };
    locator.__locatorRef = value;
    return locator;
}
function extractLocators(params) {
    if (Array.isArray(params)) {
        return params.filter(function (param) {
            return isLocator(param) || (typeof param === 'string' && param[0] === '@');
        });
    }
    return Object.keys(params)
        .filter(function (key) { return isLocator(params[key]); })
        .map(function (key) { return params[key]; });
}

/**
 * Validates a value against the rules.
 */
function validate(value, rules, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var shouldBail, skipIfEmpty, field, result, errors, failedRules, regenerateMap;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    shouldBail = options === null || options === void 0 ? void 0 : options.bails;
                    skipIfEmpty = options === null || options === void 0 ? void 0 : options.skipIfEmpty;
                    field = {
                        name: (options === null || options === void 0 ? void 0 : options.name) || '{field}',
                        rules: normalizeRules(rules),
                        bails: shouldBail !== null && shouldBail !== void 0 ? shouldBail : true,
                        skipIfEmpty: skipIfEmpty !== null && skipIfEmpty !== void 0 ? skipIfEmpty : true,
                        forceRequired: false,
                        crossTable: (options === null || options === void 0 ? void 0 : options.values) || {},
                        names: (options === null || options === void 0 ? void 0 : options.names) || {},
                        customMessages: (options === null || options === void 0 ? void 0 : options.customMessages) || {}
                    };
                    return [4 /*yield*/, _validate(field, value, options)];
                case 1:
                    result = _a.sent();
                    errors = [];
                    failedRules = {};
                    regenerateMap = {};
                    result.errors.forEach(function (e) {
                        var msg = e.msg();
                        errors.push(msg);
                        failedRules[e.rule] = msg;
                        regenerateMap[e.rule] = e.msg;
                    });
                    return [2 /*return*/, {
                            valid: result.valid,
                            errors: errors,
                            failedRules: failedRules,
                            regenerateMap: regenerateMap
                        }];
            }
        });
    });
}
/**
 * Starts the validation process.
 */
function _validate(field, value, _a) {
    var _b = (_a === void 0 ? {} : _a).isInitial, isInitial = _b === void 0 ? false : _b;
    return __awaiter(this, void 0, void 0, function () {
        var _c, shouldSkip, errors, rules, length, i, rule, result;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4 /*yield*/, _shouldSkip(field, value)];
                case 1:
                    _c = _d.sent(), shouldSkip = _c.shouldSkip, errors = _c.errors;
                    if (shouldSkip) {
                        return [2 /*return*/, {
                                valid: !errors.length,
                                errors: errors
                            }];
                    }
                    rules = Object.keys(field.rules).filter(function (rule) { return !RuleContainer.isRequireRule(rule); });
                    length = rules.length;
                    i = 0;
                    _d.label = 2;
                case 2:
                    if (!(i < length)) return [3 /*break*/, 5];
                    if (isInitial && RuleContainer.isLazy(rules[i])) {
                        return [3 /*break*/, 4];
                    }
                    rule = rules[i];
                    return [4 /*yield*/, _test(field, value, {
                            name: rule,
                            params: field.rules[rule]
                        })];
                case 3:
                    result = _d.sent();
                    if (!result.valid && result.error) {
                        errors.push(result.error);
                        if (field.bails) {
                            return [2 /*return*/, {
                                    valid: false,
                                    errors: errors
                                }];
                        }
                    }
                    _d.label = 4;
                case 4:
                    i++;
                    return [3 /*break*/, 2];
                case 5: return [2 /*return*/, {
                        valid: !errors.length,
                        errors: errors
                    }];
            }
        });
    });
}
function _shouldSkip(field, value) {
    return __awaiter(this, void 0, void 0, function () {
        var requireRules, length, errors, isEmpty, isEmptyAndOptional, isRequired, i, rule, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requireRules = Object.keys(field.rules).filter(RuleContainer.isRequireRule);
                    length = requireRules.length;
                    errors = [];
                    isEmpty = isNullOrUndefined(value) || value === '' || isEmptyArray(value);
                    isEmptyAndOptional = isEmpty && field.skipIfEmpty;
                    isRequired = false;
                    i = 0;
                    _a.label = 1;
                case 1:
                    if (!(i < length)) return [3 /*break*/, 4];
                    rule = requireRules[i];
                    return [4 /*yield*/, _test(field, value, {
                            name: rule,
                            params: field.rules[rule]
                        })];
                case 2:
                    result = _a.sent();
                    if (!isObject$5(result)) {
                        throw new Error('Require rules has to return an object (see docs)');
                    }
                    if (result.required) {
                        isRequired = true;
                    }
                    if (!result.valid && result.error) {
                        errors.push(result.error);
                        // Exit early as the field is required and failed validation.
                        if (field.bails) {
                            return [2 /*return*/, {
                                    shouldSkip: true,
                                    errors: errors
                                }];
                        }
                    }
                    _a.label = 3;
                case 3:
                    i++;
                    return [3 /*break*/, 1];
                case 4:
                    if (isEmpty && !isRequired && !field.skipIfEmpty) {
                        return [2 /*return*/, {
                                shouldSkip: false,
                                errors: errors
                            }];
                    }
                    // field is configured to run through the pipeline regardless
                    if (!field.bails && !isEmptyAndOptional) {
                        return [2 /*return*/, {
                                shouldSkip: false,
                                errors: errors
                            }];
                    }
                    // skip if the field is not required and has an empty value.
                    return [2 /*return*/, {
                            shouldSkip: !isRequired && isEmpty,
                            errors: errors
                        }];
            }
        });
    });
}
/**
 * Tests a single input value against a rule.
 */
function _test(field, value, rule) {
    return __awaiter(this, void 0, void 0, function () {
        var ruleSchema, normalizedValue, params, result, values_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    ruleSchema = RuleContainer.getRuleDefinition(rule.name);
                    if (!ruleSchema || !ruleSchema.validate) {
                        throw new Error("No such validator '" + rule.name + "' exists.");
                    }
                    normalizedValue = ruleSchema.castValue ? ruleSchema.castValue(value) : value;
                    params = fillTargetValues(rule.params, field.crossTable);
                    return [4 /*yield*/, ruleSchema.validate(normalizedValue, params)];
                case 1:
                    result = _a.sent();
                    if (typeof result === 'string') {
                        values_1 = __assign$1(__assign$1({}, (params || {})), { _field_: field.name, _value_: value, _rule_: rule.name });
                        return [2 /*return*/, {
                                valid: false,
                                error: { rule: rule.name, msg: function () { return interpolate(result, values_1); } }
                            }];
                    }
                    if (!isObject$5(result)) {
                        result = { valid: result };
                    }
                    return [2 /*return*/, {
                            valid: result.valid,
                            required: result.required,
                            error: result.valid ? undefined : _generateFieldError(field, value, ruleSchema, rule.name, params)
                        }];
            }
        });
    });
}
/**
 * Generates error messages.
 */
function _generateFieldError(field, value, ruleSchema, ruleName, params) {
    var _a;
    var message = (_a = field.customMessages[ruleName]) !== null && _a !== void 0 ? _a : ruleSchema.message;
    var ruleTargets = _getRuleTargets(field, ruleSchema, ruleName);
    var _b = _getUserTargets(field, ruleSchema, ruleName, message), userTargets = _b.userTargets, userMessage = _b.userMessage;
    var values = __assign$1(__assign$1(__assign$1(__assign$1({}, (params || {})), { _field_: field.name, _value_: value, _rule_: ruleName }), ruleTargets), userTargets);
    return {
        msg: function () { return _normalizeMessage(userMessage || getConfig().defaultMessage, field.name, values); },
        rule: ruleName
    };
}
function _getRuleTargets(field, ruleSchema, ruleName) {
    var params = ruleSchema.params;
    if (!params) {
        return {};
    }
    var numTargets = params.filter(function (param) { return param.isTarget; }).length;
    if (numTargets <= 0) {
        return {};
    }
    var names = {};
    var ruleConfig = field.rules[ruleName];
    if (!Array.isArray(ruleConfig) && isObject$5(ruleConfig)) {
        ruleConfig = params.map(function (param) {
            return ruleConfig[param.name];
        });
    }
    for (var index = 0; index < params.length; index++) {
        var param = params[index];
        var key = ruleConfig[index];
        if (!isLocator(key)) {
            continue;
        }
        key = key.__locatorRef;
        var name_1 = field.names[key] || key;
        names[param.name] = name_1;
        names["_" + param.name + "_"] = field.crossTable[key];
    }
    return names;
}
function _getUserTargets(field, ruleSchema, ruleName, userMessage) {
    var userTargets = {};
    var rules = field.rules[ruleName];
    var params = ruleSchema.params || [];
    // early return if no rules
    if (!rules) {
        return {};
    }
    // check all rules to convert targets
    Object.keys(rules).forEach(function (key, index) {
        // get the rule
        var rule = rules[key];
        if (!isLocator(rule)) {
            return {};
        }
        // get associated parameter
        var param = params[index];
        if (!param) {
            return {};
        }
        // grab the name of the target
        var name = rule.__locatorRef;
        userTargets[param.name] = field.names[name] || name;
        userTargets["_" + param.name + "_"] = field.crossTable[name];
    });
    return {
        userTargets: userTargets,
        userMessage: userMessage
    };
}
function _normalizeMessage(template, field, values) {
    if (typeof template === 'function') {
        return template(field, values);
    }
    return interpolate(template, __assign$1(__assign$1({}, values), { _field_: field }));
}
function fillTargetValues(params, crossTable) {
    if (Array.isArray(params)) {
        return params.map(function (param) {
            var targetPart = typeof param === 'string' && param[0] === '@' ? param.slice(1) : param;
            if (targetPart in crossTable) {
                return crossTable[targetPart];
            }
            return param;
        });
    }
    var values = {};
    var normalize = function (value) {
        if (isLocator(value)) {
            return value(crossTable);
        }
        return value;
    };
    Object.keys(params).forEach(function (param) {
        values[param] = normalize(params[param]);
    });
    return values;
}

var aggressive = function () { return ({
    on: ['input', 'blur']
}); };
var lazy = function () { return ({
    on: ['change', 'blur']
}); };
var eager = function (_a) {
    var errors = _a.errors;
    if (errors.length) {
        return {
            on: ['input', 'change']
        };
    }
    return {
        on: ['change', 'blur']
    };
};
var passive = function () { return ({
    on: []
}); };
var modes = {
    aggressive: aggressive,
    eager: eager,
    passive: passive,
    lazy: lazy
};

var EVENT_BUS = new Vue$1();

var isEvent = function (evt) {
    if (!evt) {
        return false;
    }
    if (typeof Event !== 'undefined' && isCallable(Event) && evt instanceof Event) {
        return true;
    }
    // this is for IE
    /* istanbul ignore next */
    if (evt && evt.srcElement) {
        return true;
    }
    return false;
};
function normalizeEventValue(value) {
    var _a, _b;
    if (!isEvent(value)) {
        return value;
    }
    var input = value.target;
    if (input.type === 'file' && input.files) {
        return toArray$1(input.files);
    }
    // If the input has a `v-model.number` modifier applied.
    if ((_a = input._vModifiers) === null || _a === void 0 ? void 0 : _a.number) {
        // as per the spec the v-model.number uses parseFloat
        var valueAsNumber = parseFloat(input.value);
        if (isNaN$1(valueAsNumber)) {
            return input.value;
        }
        return valueAsNumber;
    }
    if ((_b = input._vModifiers) === null || _b === void 0 ? void 0 : _b.trim) {
        var trimmedValue = typeof input.value === 'string' ? input.value.trim() : input.value;
        return trimmedValue;
    }
    return input.value;
}

var isTextInput = function (vnode) {
    var _a;
    var attrs = ((_a = vnode.data) === null || _a === void 0 ? void 0 : _a.attrs) || vnode.elm;
    // it will fallback to being a text input per browsers spec.
    if (vnode.tag === 'input' && (!attrs || !attrs.type)) {
        return true;
    }
    if (vnode.tag === 'textarea') {
        return true;
    }
    return includes$1(['text', 'password', 'search', 'email', 'tel', 'url', 'number'], attrs === null || attrs === void 0 ? void 0 : attrs.type);
};
// export const isCheckboxOrRadioInput = (vnode: VNode): boolean => {
//   const attrs = (vnode.data && vnode.data.attrs) || vnode.elm;
//   return includes(['radio', 'checkbox'], attrs && attrs.type);
// };
// Gets the model object on the vnode.
function findModel(vnode) {
    if (!vnode.data) {
        return undefined;
    }
    // Component Model
    // THIS IS NOT TYPED IN OFFICIAL VUE TYPINGS
    // eslint-disable-next-line
    var nonStandardVNodeData = vnode.data;
    if ('model' in nonStandardVNodeData) {
        return nonStandardVNodeData.model;
    }
    if (!vnode.data.directives) {
        return undefined;
    }
    return find$1(vnode.data.directives, function (d) { return d.name === 'model'; });
}
function findValue(vnode) {
    var _a, _b;
    var model = findModel(vnode);
    if (model) {
        return { value: model.value };
    }
    var config = findModelConfig(vnode);
    var prop = (config === null || config === void 0 ? void 0 : config.prop) || 'value';
    if (((_a = vnode.componentOptions) === null || _a === void 0 ? void 0 : _a.propsData) && prop in vnode.componentOptions.propsData) {
        var propsDataWithValue = vnode.componentOptions.propsData;
        return { value: propsDataWithValue[prop] };
    }
    if (((_b = vnode.data) === null || _b === void 0 ? void 0 : _b.domProps) && 'value' in vnode.data.domProps) {
        return { value: vnode.data.domProps.value };
    }
    return undefined;
}
function extractChildren(vnode) {
    if (Array.isArray(vnode)) {
        return vnode;
    }
    if (Array.isArray(vnode.children)) {
        return vnode.children;
    }
    /* istanbul ignore next */
    if (vnode.componentOptions && Array.isArray(vnode.componentOptions.children)) {
        return vnode.componentOptions.children;
    }
    return [];
}
function findInputNodes(vnode) {
    if (!Array.isArray(vnode) && findValue(vnode) !== undefined) {
        return [vnode];
    }
    var children = extractChildren(vnode);
    return children.reduce(function (nodes, node) {
        var candidates = findInputNodes(node);
        if (candidates.length) {
            nodes.push.apply(nodes, candidates);
        }
        return nodes;
    }, []);
}
// Resolves v-model config if exists.
function findModelConfig(vnode) {
    /* istanbul ignore next */
    if (!vnode.componentOptions)
        return null;
    // This is also not typed in the standard Vue TS.
    return vnode.componentOptions.Ctor.options.model;
}
// Adds a listener to vnode listener object.
function mergeVNodeListeners(obj, eventName, handler) {
    // no listener at all.
    if (isNullOrUndefined(obj[eventName])) {
        obj[eventName] = [handler];
        return;
    }
    // Is an invoker.
    if (isCallable(obj[eventName]) && obj[eventName].fns) {
        var invoker = obj[eventName];
        invoker.fns = Array.isArray(invoker.fns) ? invoker.fns : [invoker.fns];
        if (!includes$1(invoker.fns, handler)) {
            invoker.fns.push(handler);
        }
        return;
    }
    if (isCallable(obj[eventName])) {
        var prev = obj[eventName];
        obj[eventName] = [prev];
    }
    if (Array.isArray(obj[eventName]) && !includes$1(obj[eventName], handler)) {
        obj[eventName].push(handler);
    }
}
// Adds a listener to a native HTML vnode.
function addNativeNodeListener(node, eventName, handler) {
    /* istanbul ignore next */
    if (!node.data) {
        node.data = {};
    }
    if (isNullOrUndefined(node.data.on)) {
        node.data.on = {};
    }
    mergeVNodeListeners(node.data.on, eventName, handler);
}
// Adds a listener to a Vue component vnode.
function addComponentNodeListener(node, eventName, handler) {
    /* istanbul ignore next */
    if (!node.componentOptions) {
        return;
    }
    /* istanbul ignore next */
    if (!node.componentOptions.listeners) {
        node.componentOptions.listeners = {};
    }
    mergeVNodeListeners(node.componentOptions.listeners, eventName, handler);
}
function addVNodeListener(vnode, eventName, handler) {
    if (vnode.componentOptions) {
        addComponentNodeListener(vnode, eventName, handler);
        return;
    }
    addNativeNodeListener(vnode, eventName, handler);
}
// Determines if `change` should be used over `input` for listeners.
function getInputEventName(vnode, model) {
    var _a;
    // Is a component.
    if (vnode.componentOptions) {
        var event_1 = (findModelConfig(vnode) || { event: 'input' }).event;
        return event_1;
    }
    // Lazy Models typically use change event
    if ((_a = model === null || model === void 0 ? void 0 : model.modifiers) === null || _a === void 0 ? void 0 : _a.lazy) {
        return 'change';
    }
    // is a textual-type input.
    if (isTextInput(vnode)) {
        return 'input';
    }
    return 'change';
}
function isHTMLNode(node) {
    return includes$1(['input', 'select', 'textarea'], node.tag);
}
function resolveTextualRules(vnode) {
    var _a;
    var attrs = (_a = vnode.data) === null || _a === void 0 ? void 0 : _a.attrs;
    var rules = {};
    if (!attrs)
        return rules;
    if (attrs.type === 'email' && RuleContainer.getRuleDefinition('email')) {
        rules.email = ['multiple' in attrs];
    }
    if (attrs.pattern && RuleContainer.getRuleDefinition('regex')) {
        rules.regex = attrs.pattern;
    }
    if (attrs.maxlength >= 0 && RuleContainer.getRuleDefinition('max')) {
        rules.max = attrs.maxlength;
    }
    if (attrs.minlength >= 0 && RuleContainer.getRuleDefinition('min')) {
        rules.min = attrs.minlength;
    }
    if (attrs.type === 'number') {
        if (isSpecified(attrs.min) && RuleContainer.getRuleDefinition('min_value')) {
            rules.min_value = Number(attrs.min);
        }
        if (isSpecified(attrs.max) && RuleContainer.getRuleDefinition('max_value')) {
            rules.max_value = Number(attrs.max);
        }
    }
    return rules;
}
function resolveRules(vnode) {
    var _a;
    var htmlTags = ['input', 'select', 'textarea'];
    var attrs = (_a = vnode.data) === null || _a === void 0 ? void 0 : _a.attrs;
    if (!includes$1(htmlTags, vnode.tag) || !attrs) {
        return {};
    }
    var rules = {};
    if ('required' in attrs && attrs.required !== false && RuleContainer.getRuleDefinition('required')) {
        rules.required = attrs.type === 'checkbox' ? [true] : true;
    }
    if (isTextInput(vnode)) {
        return normalizeRules(__assign$1(__assign$1({}, rules), resolveTextualRules(vnode)));
    }
    return normalizeRules(rules);
}
function normalizeChildren$1(context, slotProps) {
    if (context.$scopedSlots.default) {
        return context.$scopedSlots.default(slotProps) || [];
    }
    return context.$slots.default || [];
}

/**
 * Determines if a provider needs to run validation.
 */
function shouldValidate(ctx, value) {
    // when an immediate/initial validation is needed and wasn't done before.
    if (!ctx._ignoreImmediate && ctx.immediate) {
        return true;
    }
    // when the value changes for whatever reason.
    if (!isRefEqual(ctx.value, value) && ctx.normalizedEvents.length) {
        return true;
    }
    // when it needs validation due to props/cross-fields changes.
    if (ctx._needsValidation) {
        return true;
    }
    // when the initial value is undefined and the field wasn't rendered yet.
    if (!ctx.initialized && value === undefined) {
        return true;
    }
    return false;
}
function createValidationCtx(ctx) {
    return __assign$1(__assign$1({}, ctx.flags), { errors: ctx.errors, classes: ctx.classes, failedRules: ctx.failedRules, reset: function () { return ctx.reset(); }, validate: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return ctx.validate.apply(ctx, args);
        }, ariaInput: {
            'aria-invalid': ctx.flags.invalid ? 'true' : 'false',
            'aria-required': ctx.isRequired ? 'true' : 'false',
            'aria-errormessage': "vee_" + ctx.id
        }, ariaMsg: {
            id: "vee_" + ctx.id,
            'aria-live': ctx.errors.length ? 'assertive' : 'off'
        } });
}
function onRenderUpdate(vm, value) {
    if (!vm.initialized) {
        vm.initialValue = value;
    }
    var validateNow = shouldValidate(vm, value);
    vm._needsValidation = false;
    vm.value = value;
    vm._ignoreImmediate = true;
    if (!validateNow) {
        return;
    }
    var validate = function () {
        if (vm.immediate || vm.flags.validated) {
            return triggerThreadSafeValidation(vm);
        }
        vm.validateSilent();
    };
    if (vm.initialized) {
        validate();
        return;
    }
    vm.$once('hook:mounted', function () { return validate(); });
}
function computeModeSetting(ctx) {
    var compute = (isCallable(ctx.mode) ? ctx.mode : modes[ctx.mode]);
    return compute(ctx);
}
function triggerThreadSafeValidation(vm) {
    var pendingPromise = vm.validateSilent();
    // avoids race conditions between successive validations.
    vm._pendingValidation = pendingPromise;
    return pendingPromise.then(function (result) {
        if (pendingPromise === vm._pendingValidation) {
            vm.applyResult(result);
            vm._pendingValidation = undefined;
        }
        return result;
    });
}
// Creates the common handlers for a validatable context.
function createCommonHandlers(vm) {
    if (!vm.$veeOnInput) {
        vm.$veeOnInput = function (e) {
            vm.syncValue(e); // track and keep the value updated.
            vm.setFlags({ dirty: true, pristine: false });
        };
    }
    var onInput = vm.$veeOnInput;
    if (!vm.$veeOnBlur) {
        vm.$veeOnBlur = function () {
            vm.setFlags({ touched: true, untouched: false });
        };
    }
    // Blur event listener.
    var onBlur = vm.$veeOnBlur;
    var onValidate = vm.$veeHandler;
    var mode = computeModeSetting(vm);
    // Handle debounce changes.
    if (!onValidate || vm.$veeDebounce !== vm.debounce) {
        onValidate = debounce(function () {
            vm.$nextTick(function () {
                if (!vm._pendingReset) {
                    triggerThreadSafeValidation(vm);
                }
                vm._pendingReset = false;
            });
        }, mode.debounce || vm.debounce);
        // Cache the handler so we don't create it each time.
        vm.$veeHandler = onValidate;
        // cache the debounce value so we detect if it was changed.
        vm.$veeDebounce = vm.debounce;
    }
    return { onInput: onInput, onBlur: onBlur, onValidate: onValidate };
}
// Adds all plugin listeners to the vnode.
function addListeners(vm, node) {
    var value = findValue(node);
    // cache the input eventName.
    vm._inputEventName = vm._inputEventName || getInputEventName(node, findModel(node));
    onRenderUpdate(vm, value === null || value === void 0 ? void 0 : value.value);
    var _a = createCommonHandlers(vm), onInput = _a.onInput, onBlur = _a.onBlur, onValidate = _a.onValidate;
    addVNodeListener(node, vm._inputEventName, onInput);
    addVNodeListener(node, 'blur', onBlur);
    // add the validation listeners.
    vm.normalizedEvents.forEach(function (evt) {
        addVNodeListener(node, evt, onValidate);
    });
    vm.initialized = true;
}

var PROVIDER_COUNTER = 0;
function data$1() {
    var errors = [];
    var fieldName = '';
    var defaultValues = {
        errors: errors,
        value: undefined,
        initialized: false,
        initialValue: undefined,
        flags: createFlags(),
        failedRules: {},
        isActive: true,
        fieldName: fieldName,
        id: ''
    };
    return defaultValues;
}
var ValidationProvider = Vue$1.extend({
    inject: {
        $_veeObserver: {
            from: '$_veeObserver',
            default: function () {
                if (!this.$vnode.context.$_veeObserver) {
                    this.$vnode.context.$_veeObserver = createObserver();
                }
                return this.$vnode.context.$_veeObserver;
            }
        }
    },
    props: {
        vid: {
            type: String,
            default: ''
        },
        name: {
            type: String,
            default: null
        },
        mode: {
            type: [String, Function],
            default: function () {
                return getConfig().mode;
            }
        },
        rules: {
            type: [Object, String],
            default: null
        },
        immediate: {
            type: Boolean,
            default: false
        },
        bails: {
            type: Boolean,
            default: function () { return getConfig().bails; }
        },
        skipIfEmpty: {
            type: Boolean,
            default: function () { return getConfig().skipOptional; }
        },
        debounce: {
            type: Number,
            default: 0
        },
        tag: {
            type: String,
            default: 'span'
        },
        slim: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        customMessages: {
            type: Object,
            default: function () {
                return {};
            }
        },
        detectInput: {
            type: Boolean,
            default: true
        }
    },
    watch: {
        rules: {
            deep: true,
            handler: function (val, oldVal) {
                this._needsValidation = !isEqual(val, oldVal);
            }
        }
    },
    data: data$1,
    computed: {
        fieldDeps: function () {
            var _this = this;
            return Object.keys(this.normalizedRules).reduce(function (acc, rule) {
                var deps = extractLocators(_this.normalizedRules[rule]).map(function (dep) {
                    return isLocator(dep) ? dep.__locatorRef : dep.slice(1);
                });
                acc.push.apply(acc, deps);
                deps.forEach(function (depName) {
                    watchCrossFieldDep(_this, depName);
                });
                return acc;
            }, []);
        },
        normalizedEvents: function () {
            var _this = this;
            var on = computeModeSetting(this).on;
            return (on || []).map(function (e) {
                if (e === 'input') {
                    return _this._inputEventName;
                }
                return e;
            });
        },
        isRequired: function () {
            var rules = __assign$1(__assign$1({}, this._resolvedRules), this.normalizedRules);
            var isRequired = Object.keys(rules).some(RuleContainer.isRequireRule);
            this.flags.required = !!isRequired;
            return isRequired;
        },
        classes: function () {
            var names = getConfig().classes;
            return computeClassObj(names, this.flags);
        },
        normalizedRules: function () {
            return normalizeRules(this.rules);
        }
    },
    mounted: function () {
        var _this = this;
        var onLocaleChanged = function () {
            if (!_this.flags.validated) {
                return;
            }
            var regenerateMap = _this._regenerateMap;
            if (regenerateMap) {
                var errors_1 = [];
                var failedRules_1 = {};
                Object.keys(regenerateMap).forEach(function (rule) {
                    var msg = regenerateMap[rule]();
                    errors_1.push(msg);
                    failedRules_1[rule] = msg;
                });
                _this.applyResult({ errors: errors_1, failedRules: failedRules_1, regenerateMap: regenerateMap });
                return;
            }
            _this.validate();
        };
        EVENT_BUS.$on('change:locale', onLocaleChanged);
        this.$on('hook:beforeDestroy', function () {
            EVENT_BUS.$off('change:locale', onLocaleChanged);
        });
    },
    render: function (h) {
        var _this = this;
        this.registerField();
        var ctx = createValidationCtx(this);
        var children = normalizeChildren$1(this, ctx);
        // Automatic v-model detection
        if (this.detectInput) {
            var inputs = findInputNodes(children);
            if (inputs.length) {
                inputs.forEach(function (input, idx) {
                    var _a, _b, _c, _d, _e, _f;
                    // If the elements are not checkboxes and there are more input nodes
                    if (!includes$1(['checkbox', 'radio'], (_b = (_a = input.data) === null || _a === void 0 ? void 0 : _a.attrs) === null || _b === void 0 ? void 0 : _b.type) && idx > 0) {
                        return;
                    }
                    var resolved = getConfig().useConstraintAttrs ? resolveRules(input) : {};
                    if (!isEqual(_this._resolvedRules, resolved)) {
                        _this._needsValidation = true;
                    }
                    if (isHTMLNode(input)) {
                        _this.fieldName = ((_d = (_c = input.data) === null || _c === void 0 ? void 0 : _c.attrs) === null || _d === void 0 ? void 0 : _d.name) || ((_f = (_e = input.data) === null || _e === void 0 ? void 0 : _e.attrs) === null || _f === void 0 ? void 0 : _f.id);
                    }
                    _this._resolvedRules = resolved;
                    addListeners(_this, input);
                });
            }
        }
        return this.slim && children.length <= 1 ? children[0] : h(this.tag, children);
    },
    beforeDestroy: function () {
        // cleanup reference.
        this.$_veeObserver.unobserve(this.id);
    },
    activated: function () {
        this.isActive = true;
    },
    deactivated: function () {
        this.isActive = false;
    },
    methods: {
        setFlags: function (flags) {
            var _this = this;
            Object.keys(flags).forEach(function (flag) {
                _this.flags[flag] = flags[flag];
            });
        },
        syncValue: function (v) {
            var value = normalizeEventValue(v);
            this.value = value;
            this.flags.changed = this.initialValue !== value;
        },
        reset: function () {
            var _this = this;
            this.errors = [];
            this.initialValue = this.value;
            var flags = createFlags();
            flags.required = this.isRequired;
            this.setFlags(flags);
            this.failedRules = {};
            this.validateSilent();
            this._pendingValidation = undefined;
            this._pendingReset = true;
            setTimeout(function () {
                _this._pendingReset = false;
            }, this.debounce);
        },
        validate: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    if (args.length > 0) {
                        this.syncValue(args[0]);
                    }
                    return [2 /*return*/, triggerThreadSafeValidation(this)];
                });
            });
        },
        validateSilent: function () {
            return __awaiter(this, void 0, void 0, function () {
                var rules, result;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.setFlags({ pending: true });
                            rules = __assign$1(__assign$1({}, this._resolvedRules), this.normalizedRules);
                            Object.defineProperty(rules, '_$$isNormalized', {
                                value: true,
                                writable: false,
                                enumerable: false,
                                configurable: false
                            });
                            return [4 /*yield*/, validate(this.value, rules, __assign$1(__assign$1({ name: this.name || this.fieldName }, createLookup(this)), { bails: this.bails, skipIfEmpty: this.skipIfEmpty, isInitial: !this.initialized, customMessages: this.customMessages }))];
                        case 1:
                            result = _a.sent();
                            this.setFlags({
                                pending: false,
                                valid: result.valid,
                                invalid: !result.valid
                            });
                            return [2 /*return*/, result];
                    }
                });
            });
        },
        setErrors: function (errors) {
            this.applyResult({ errors: errors, failedRules: {} });
        },
        applyResult: function (_a) {
            var errors = _a.errors, failedRules = _a.failedRules, regenerateMap = _a.regenerateMap;
            this.errors = errors;
            this._regenerateMap = regenerateMap;
            this.failedRules = __assign$1({}, (failedRules || {}));
            this.setFlags({
                valid: !errors.length,
                passed: !errors.length,
                invalid: !!errors.length,
                failed: !!errors.length,
                validated: true,
                changed: this.value !== this.initialValue
            });
        },
        registerField: function () {
            updateRenderingContextRefs(this);
        }
    }
});
function computeClassObj(names, flags) {
    var acc = {};
    var keys = Object.keys(flags);
    var length = keys.length;
    var _loop_1 = function (i) {
        var flag = keys[i];
        var className = (names && names[flag]) || flag;
        var value = flags[flag];
        if (isNullOrUndefined(value)) {
            return "continue";
        }
        if ((flag === 'valid' || flag === 'invalid') && !flags.validated) {
            return "continue";
        }
        if (typeof className === 'string') {
            acc[className] = value;
        }
        else if (Array.isArray(className)) {
            className.forEach(function (cls) {
                acc[cls] = value;
            });
        }
    };
    for (var i = 0; i < length; i++) {
        _loop_1(i);
    }
    return acc;
}
function createLookup(vm) {
    var providers = vm.$_veeObserver.refs;
    var reduced = {
        names: {},
        values: {}
    };
    return vm.fieldDeps.reduce(function (acc, depName) {
        if (!providers[depName]) {
            return acc;
        }
        acc.values[depName] = providers[depName].value;
        acc.names[depName] = providers[depName].name;
        return acc;
    }, reduced);
}
function extractId(vm) {
    if (vm.vid) {
        return vm.vid;
    }
    if (vm.name) {
        return vm.name;
    }
    if (vm.id) {
        return vm.id;
    }
    if (vm.fieldName) {
        return vm.fieldName;
    }
    PROVIDER_COUNTER++;
    return "_vee_" + PROVIDER_COUNTER;
}
function updateRenderingContextRefs(vm) {
    var providedId = extractId(vm);
    var id = vm.id;
    // Nothing has changed.
    if (!vm.isActive || (id === providedId && vm.$_veeObserver.refs[id])) {
        return;
    }
    // vid was changed.
    if (id !== providedId && vm.$_veeObserver.refs[id] === vm) {
        vm.$_veeObserver.unobserve(id);
    }
    vm.id = providedId;
    vm.$_veeObserver.observe(vm);
}
function createObserver() {
    return {
        refs: {},
        observe: function (vm) {
            this.refs[vm.id] = vm;
        },
        unobserve: function (id) {
            delete this.refs[id];
        }
    };
}
function watchCrossFieldDep(ctx, depName, withHooks) {
    if (withHooks === void 0) { withHooks = true; }
    var providers = ctx.$_veeObserver.refs;
    if (!ctx._veeWatchers) {
        ctx._veeWatchers = {};
    }
    if (!providers[depName] && withHooks) {
        return ctx.$once('hook:mounted', function () {
            watchCrossFieldDep(ctx, depName, false);
        });
    }
    if (!isCallable(ctx._veeWatchers[depName]) && providers[depName]) {
        ctx._veeWatchers[depName] = providers[depName].$watch('value', function () {
            if (ctx.flags.validated) {
                ctx._needsValidation = true;
                ctx.validate();
            }
        });
    }
}

var FLAGS_STRATEGIES = [
    ['pristine', 'every'],
    ['dirty', 'some'],
    ['touched', 'some'],
    ['untouched', 'every'],
    ['valid', 'every'],
    ['invalid', 'some'],
    ['pending', 'some'],
    ['validated', 'every'],
    ['changed', 'some'],
    ['passed', 'every'],
    ['failed', 'some']
];
var OBSERVER_COUNTER = 0;
function data$1$1() {
    var refs = {};
    var errors = {};
    var flags = createObserverFlags();
    var fields = {};
    // FIXME: Not sure of this one can be typed, circular type reference.
    var observers = [];
    return {
        id: '',
        refs: refs,
        observers: observers,
        errors: errors,
        flags: flags,
        fields: fields
    };
}
function provideSelf() {
    return {
        $_veeObserver: this
    };
}
var ValidationObserver = Vue$1.extend({
    name: 'ValidationObserver',
    provide: provideSelf,
    inject: {
        $_veeObserver: {
            from: '$_veeObserver',
            default: function () {
                if (!this.$vnode.context.$_veeObserver) {
                    return null;
                }
                return this.$vnode.context.$_veeObserver;
            }
        }
    },
    props: {
        tag: {
            type: String,
            default: 'span'
        },
        vid: {
            type: String,
            default: function () {
                return "obs_" + OBSERVER_COUNTER++;
            }
        },
        slim: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data: data$1$1,
    created: function () {
        var _this = this;
        this.id = this.vid;
        register(this);
        var onChange = debounce(function (_a) {
            var errors = _a.errors, flags = _a.flags, fields = _a.fields;
            _this.errors = errors;
            _this.flags = flags;
            _this.fields = fields;
        }, 16);
        this.$watch(computeObserverState, onChange);
    },
    activated: function () {
        register(this);
    },
    deactivated: function () {
        unregister(this);
    },
    beforeDestroy: function () {
        unregister(this);
    },
    render: function (h) {
        var children = normalizeChildren$1(this, prepareSlotProps(this));
        return this.slim && children.length <= 1 ? children[0] : h(this.tag, { on: this.$listeners }, children);
    },
    methods: {
        observe: function (subscriber, kind) {
            var _a;
            if (kind === void 0) { kind = 'provider'; }
            if (kind === 'observer') {
                this.observers.push(subscriber);
                return;
            }
            this.refs = __assign$1(__assign$1({}, this.refs), (_a = {}, _a[subscriber.id] = subscriber, _a));
        },
        unobserve: function (id, kind) {
            if (kind === void 0) { kind = 'provider'; }
            if (kind === 'provider') {
                var provider = this.refs[id];
                if (!provider) {
                    return;
                }
                this.$delete(this.refs, id);
                return;
            }
            var idx = findIndex(this.observers, function (o) { return o.id === id; });
            if (idx !== -1) {
                this.observers.splice(idx, 1);
            }
        },
        validateWithInfo: function (_a) {
            var _b = (_a === void 0 ? {} : _a).silent, silent = _b === void 0 ? false : _b;
            return __awaiter(this, void 0, void 0, function () {
                var results, isValid, _c, errors, flags, fields;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, Promise.all(__spreadArrays(values(this.refs)
                                .filter(function (r) { return !r.disabled; })
                                .map(function (ref) { return ref[silent ? 'validateSilent' : 'validate']().then(function (r) { return r.valid; }); }), this.observers.filter(function (o) { return !o.disabled; }).map(function (obs) { return obs.validate({ silent: silent }); })))];
                        case 1:
                            results = _d.sent();
                            isValid = results.every(function (r) { return r; });
                            _c = computeObserverState.call(this), errors = _c.errors, flags = _c.flags, fields = _c.fields;
                            this.errors = errors;
                            this.flags = flags;
                            this.fields = fields;
                            return [2 /*return*/, {
                                    errors: errors,
                                    flags: flags,
                                    fields: fields,
                                    isValid: isValid
                                }];
                    }
                });
            });
        },
        validate: function (_a) {
            var _b = (_a === void 0 ? {} : _a).silent, silent = _b === void 0 ? false : _b;
            return __awaiter(this, void 0, void 0, function () {
                var isValid;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0: return [4 /*yield*/, this.validateWithInfo({ silent: silent })];
                        case 1:
                            isValid = (_c.sent()).isValid;
                            return [2 /*return*/, isValid];
                    }
                });
            });
        },
        handleSubmit: function (cb) {
            return __awaiter(this, void 0, void 0, function () {
                var isValid;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.validate()];
                        case 1:
                            isValid = _a.sent();
                            if (!isValid || !cb) {
                                return [2 /*return*/];
                            }
                            return [2 /*return*/, cb()];
                    }
                });
            });
        },
        reset: function () {
            return __spreadArrays(values(this.refs), this.observers).forEach(function (ref) { return ref.reset(); });
        },
        setErrors: function (errors) {
            var _this = this;
            Object.keys(errors).forEach(function (key) {
                var provider = _this.refs[key];
                if (!provider)
                    return;
                var errorArr = errors[key] || [];
                errorArr = typeof errorArr === 'string' ? [errorArr] : errorArr;
                provider.setErrors(errorArr);
            });
            this.observers.forEach(function (observer) {
                observer.setErrors(errors);
            });
        }
    }
});
function unregister(vm) {
    if (vm.$_veeObserver) {
        vm.$_veeObserver.unobserve(vm.id, 'observer');
    }
}
function register(vm) {
    if (vm.$_veeObserver) {
        vm.$_veeObserver.observe(vm, 'observer');
    }
}
function prepareSlotProps(vm) {
    return __assign$1(__assign$1({}, vm.flags), { errors: vm.errors, fields: vm.fields, validate: vm.validate, validateWithInfo: vm.validateWithInfo, passes: vm.handleSubmit, handleSubmit: vm.handleSubmit, reset: vm.reset });
}
// Creates a modified version of validation flags
function createObserverFlags() {
    return __assign$1(__assign$1({}, createFlags()), { valid: true, invalid: false });
}
function computeObserverState() {
    var vms = __spreadArrays(values(this.refs), this.observers.filter(function (o) { return !o.disabled; }));
    var errors = {};
    var flags = createObserverFlags();
    var fields = {};
    var length = vms.length;
    for (var i = 0; i < length; i++) {
        var vm = vms[i];
        // validation provider
        if (Array.isArray(vm.errors)) {
            errors[vm.id] = vm.errors;
            fields[vm.id] = __assign$1({ id: vm.id, name: vm.name, failedRules: vm.failedRules }, vm.flags);
            continue;
        }
        // Nested observer, merge errors and fields
        errors = __assign$1(__assign$1({}, errors), vm.errors);
        fields = __assign$1(__assign$1({}, fields), vm.fields);
    }
    FLAGS_STRATEGIES.forEach(function (_a) {
        var flag = _a[0], method = _a[1];
        flags[flag] = vms[method](function (vm) { return vm.flags[flag]; });
    });
    return { errors: errors, flags: flags, fields: fields };
}

/**
  * vee-validate v3.4.5
  * (c) 2020 Abdelrahman Awad
  * @license MIT
  */

var validate$8 = function (value, _a) {
    var multiple = (_a === void 0 ? {} : _a).multiple;
    // eslint-disable-next-line
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (multiple && !Array.isArray(value)) {
        value = String(value)
            .split(',')
            .map(function (emailStr) { return emailStr.trim(); });
    }
    if (Array.isArray(value)) {
        return value.every(function (val) { return re.test(String(val)); });
    }
    return re.test(String(value));
};
var params$8 = [
    {
        name: 'multiple',
        default: false
    }
];
var email = {
    validate: validate$8,
    params: params$8
};

function isNullOrUndefined$1(value) {
    return value === null || value === undefined;
}
function isEmptyArray$1(arr) {
    return Array.isArray(arr) && arr.length === 0;
}

var validate$h = function (value, _a) {
    var length = _a.length;
    if (isNullOrUndefined$1(value)) {
        return length >= 0;
    }
    if (Array.isArray(value)) {
        return value.every(function (val) { return validate$h(val, { length: length }); });
    }
    return String(value).length <= length;
};
var params$c = [
    {
        name: 'length',
        cast: function (value) {
            return Number(value);
        }
    }
];
var max$2 = {
    validate: validate$h,
    params: params$c
};

var validate$o = function (value, _a) {
    var allowFalse = (_a === void 0 ? { allowFalse: true } : _a).allowFalse;
    var result = {
        valid: false,
        required: true
    };
    if (isNullOrUndefined$1(value) || isEmptyArray$1(value)) {
        return result;
    }
    // incase a field considers `false` as an empty value like checkboxes.
    if (value === false && !allowFalse) {
        return result;
    }
    result.valid = !!String(value).trim().length;
    return result;
};
var computesRequired = true;
var params$h = [
    {
        name: 'allowFalse',
        default: true
    }
];
var required = {
    validate: validate$o,
    params: params$h,
    computesRequired: computesRequired
};

var isValidUrl = function isValidUrl(url) {
  var regexp = /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;
  var candidate = url.replace(/ /g, '').trim();
  return regexp.test(candidate);
};
extend$2('required', required);
extend$2('max', max$2);
extend$2('email', email);
extend$2('validUrl', isValidUrl);
var isValidField = function isValidField(value, rules) {
  return validate(value, rules).then(function (result) {
    return result.valid;
  }).catch(function (err) {
    console.error(err);
    return false;
  });
};

var whatsappConnectionStatus = {
  connecting: -1,
  disconnected: 1,
  connected: 2,
  recentConnected: 2
};

var _types$CAN_SHOW_BAR$t;
var mutations$1 = (_types$CAN_SHOW_BAR$t = {}, _defineProperty(_types$CAN_SHOW_BAR$t, CAN_SHOW_BAR, function (state, barState) {
  state.canShowBar = barState;
}), _defineProperty(_types$CAN_SHOW_BAR$t, SET_LOADER_SHOW_BAR, function (state, loaderState) {
  state.inLoaderShowBar = loaderState;
}), _defineProperty(_types$CAN_SHOW_BAR$t, DISABLE_REOPEN, function (state, disableReopen) {
  state.disableReconnectingReOpen = disableReopen;
}), _defineProperty(_types$CAN_SHOW_BAR$t, REMOVE_FROM_SOCKET_QUEUE, function (state, number) {
  var shallow = _objectSpread2({}, state.socketEventsQueue);

  delete shallow[number.id];
  state.socketEventsQueue = _objectSpread2({}, shallow);
}), _defineProperty(_types$CAN_SHOW_BAR$t, REMOVE_NUMBER, function (state, _ref) {
  var number = _ref.number,
      queue = _ref.queue,
      queues = _ref.queues;
  queues = queues || [];

  if (queue) {
    queues.push(queue);
  }

  queues.forEach(function (queue) {
    var queueName = "".concat(queue, "Numbers");

    if (state[queueName]) {
      state[queueName] = state[queueName].filter(function (item) {
        return !equals(item, number);
      });
    }
  });
}), _defineProperty(_types$CAN_SHOW_BAR$t, ADD_NUMBER, function (state, _ref2) {
  var number = _ref2.number,
      queue = _ref2.queue;
  var queueName = "".concat(queue, "Numbers");

  if (state[queueName]) {
    var others = state[queueName].filter(function (item) {
      return !equals(item, number);
    });
    state[queueName] = [].concat(_toConsumableArray(others), [number]).sort(function (a, b) {
      return a.number > b.number ? 1 : -1;
    });
  }
}), _types$CAN_SHOW_BAR$t);

var $every = arrayIteration.every;



var STRICT_METHOD$3 = arrayMethodIsStrict('every');
var USES_TO_LENGTH$5 = arrayMethodUsesToLength('every');

// `Array.prototype.every` method
// https://tc39.github.io/ecma262/#sec-array.prototype.every
_export({ target: 'Array', proto: true, forced: !STRICT_METHOD$3 || !USES_TO_LENGTH$5 }, {
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

function _typeof$3(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$3 = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$3 = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof$3(obj);
}

var ConsumerConnectionStatus;

(function (ConsumerConnectionStatus) {
  ConsumerConnectionStatus[ConsumerConnectionStatus["Creating"] = 0] = "Creating";
  ConsumerConnectionStatus[ConsumerConnectionStatus["Inactive"] = 1] = "Inactive";
  ConsumerConnectionStatus[ConsumerConnectionStatus["Active"] = 2] = "Active";
  ConsumerConnectionStatus[ConsumerConnectionStatus["NotFound"] = 3] = "NotFound";
})(ConsumerConnectionStatus || (ConsumerConnectionStatus = {}));

var StateNumberQueues = {
  Disconnected: 'disconnected',
  RecentConnected: 'recentConnected',
  Connecting: 'connecting'
};

var DEFAULT_BAR_TIMING = 7000;
var tryConnect = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref, clientNumber) {
    var getters, dispatch, triedReconnect, number;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            getters = _ref.getters, dispatch = _ref.dispatch;
            _context.prev = 1;
            _context.next = 4;
            return enableNumber(clientNumber.id);

          case 4:
            triedReconnect = (clientNumber.triedReconnect || 0) + 1;
            number = _objectSpread2(_objectSpread2({}, clientNumber), {}, {
              isEnabled: true,
              triedReconnect: triedReconnect,
              userTryingReconnect: true
            });
            dispatch('orchestrateClientNumber', {
              number: number
            });
            _context.next = 12;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](1);
            getters.isDebug && console.log(_context.t0);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 9]]);
  }));

  return function tryConnect(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();
var barShow = function barShow(_ref3, barState) {
  var commit = _ref3.commit,
      dispatch = _ref3.dispatch,
      getters = _ref3.getters;
  var connectingNumbers = getters.connectingNumbers,
      disconnectedNumbers = getters.disconnectedNumbers,
      inLoaderShowBar = getters.inLoaderShowBar;

  if (inLoaderShowBar === false) {
    commit(CAN_SHOW_BAR, barState.show);
  }

  if (connectingNumbers.length && !disconnectedNumbers.length) {
    commit(DISABLE_REOPEN, true);
  }

  var timeoutSeconds = 5 * 60 * 1000;

  if (barState.manualClose && !inLoaderShowBar) {
    dispatch('loaderShowBar', true);
    window.setTimeout(function () {
      dispatch('loaderShowBar', false);
      dispatch('tryCloseBar');
    }, timeoutSeconds);
  }
};
var loaderShowBar = function loaderShowBar(_ref4, isLoader) {
  var commit = _ref4.commit;
  commit(SET_LOADER_SHOW_BAR, isLoader);
};
var tryCloseBar = function tryCloseBar(_ref5) {
  var getters = _ref5.getters,
      dispatch = _ref5.dispatch;
  var connectingNumbers = getters.connectingNumbers,
      disconnectedNumbers = getters.disconnectedNumbers,
      recentConnectedNumbers = getters.recentConnectedNumbers;
  var allEmpties = [connectingNumbers, disconnectedNumbers, recentConnectedNumbers].every(function (arr) {
    return !arr.length;
  });
  dispatch('barShow', {
    show: allEmpties ? false : true,
    manualClose: false
  });
};
var removeNumber = function removeNumber(_ref6, _ref7) {
  var commit = _ref6.commit,
      dispatch = _ref6.dispatch;
  var number = _ref7.number,
      queue = _ref7.queue,
      queues = _ref7.queues;
  commit(REMOVE_NUMBER, {
    number: number,
    queue: queue,
    queues: queues
  });
  dispatch('tryCloseBar');
};
var addConnectingNumber = function addConnectingNumber(_ref8, number) {
  var dispatch = _ref8.dispatch,
      getters = _ref8.getters,
      commit = _ref8.commit;
  dispatch('removeNumber', {
    number: number,
    queues: [StateNumberQueues.Connecting, StateNumberQueues.Disconnected, StateNumberQueues.RecentConnected]
  });

  if (!getters.disableReconnectingReOpen) {
    dispatch('barShow', {
      show: true,
      manualClose: false
    });
  }

  commit(ADD_NUMBER, {
    number: number,
    queue: StateNumberQueues.Connecting
  });
  dispatch('updateWhatsappNumbersStatus', {
    number: number,
    queue: StateNumberQueues.Connecting
  });
};
var addRecentConnectedNumbers = function addRecentConnectedNumbers(_ref9, number) {
  var dispatch = _ref9.dispatch,
      commit = _ref9.commit;
  dispatch('removeNumber', {
    number: number,
    queues: [StateNumberQueues.RecentConnected, StateNumberQueues.Connecting, StateNumberQueues.Disconnected]
  });
  commit(ADD_NUMBER, {
    number: number,
    queue: StateNumberQueues.RecentConnected
  });
  dispatch('updateWhatsappNumbersStatus', {
    number: number,
    queue: StateNumberQueues.RecentConnected
  });
  dispatch('barShow', {
    show: true,
    manualClose: false
  });
  window.setTimeout(function () {
    var isPlugged = number.consumer && number.consumer.numberInfo && number.consumer.numberInfo.plugged;

    if (isPlugged) {
      dispatch('removeNumber', {
        number: number,
        queue: StateNumberQueues.RecentConnected
      });
    } else {
      var plugMessaged = _objectSpread2(_objectSpread2({}, number), {}, {
        plugMessage: true
      });

      commit(ADD_NUMBER, {
        number: plugMessaged,
        queue: StateNumberQueues.RecentConnected
      });
      dispatch('updateWhatsappNumbersStatus', {
        number: number,
        queue: StateNumberQueues.RecentConnected
      });
      window.setTimeout(function () {
        dispatch('removeNumber', {
          number: number,
          queue: StateNumberQueues.RecentConnected
        });
      }, DEFAULT_BAR_TIMING);
    }
  }, DEFAULT_BAR_TIMING);
};
var addDisconnectedNumber = function addDisconnectedNumber(_ref10, number) {
  var dispatch = _ref10.dispatch,
      commit = _ref10.commit;
  dispatch('removeNumber', {
    number: number,
    queue: StateNumberQueues.Disconnected
  });
  commit(ADD_NUMBER, {
    number: number,
    queue: StateNumberQueues.Disconnected
  });
  dispatch('updateWhatsappNumbersStatus', {
    number: number,
    queue: StateNumberQueues.Disconnected
  });
  dispatch('barShow', {
    show: true,
    manualClose: false
  });
  dispatch('removeNumber', {
    number: number,
    queues: [StateNumberQueues.RecentConnected, StateNumberQueues.Connecting]
  });
};
var orchestrateClientNumber = function orchestrateClientNumber(_ref11, _ref12) {
  var getters = _ref11.getters,
      dispatch = _ref11.dispatch;
  var number = _ref12.number,
      origin = _ref12.origin;
  var isDisconnectedNumber = getters.discoverNumberByState(number, StateNumberQueues.Disconnected);
  var isConnectingNumber = getters.discoverNumberByState(number, StateNumberQueues.Connecting);
  number.currentOrigin = origin || 'socket';
  number.requeueTries = 0;
  number.formattedNumber = format(number.number);
  number.translate = translateName(number.name);

  var connect = function connect() {
    if (_typeof$3(number.integrator) === undefined) {
      setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var getNumber$1;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return getNumber(number);

              case 2:
                getNumber$1 = _context2.sent;

                if (!getNumber$1.isEnabled && !isLostQRCodeError(getNumber$1.lastInactiveCause)) {
                  dispatch('tryConnect', number);
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })), Math.random() * (5000 - 1000) + 1000);
    }
  };

  if (number.currentOrigin === 'socket') {
    if (number.isEnabled) {
      if (!number.consumer) {
        dispatch('addConnectingNumber', number);
      } else if (number.consumer.connectionStatus === ConsumerConnectionStatus.Inactive) {
        if (isLostQRCodeError(number.lastInactiveCause)) {
          dispatch('addDisconnectedNumber', number);
        } else {
          dispatch('addConnectingNumber', number);
        }
      } else if (number.consumer.connectionStatus === ConsumerConnectionStatus.Active) {
        if (isDisconnectedNumber || isConnectingNumber) {
          dispatch('addRecentConnectedNumbers', number);
        } else {
          dispatch('updateWhatsappNumbersStatus', {
            number: number,
            queue: StateNumberQueues.RecentConnected
          });
        }
      }
    } else {
      if (isLostQRCodeError(number.lastInactiveCause)) {
        dispatch('addDisconnectedNumber', number);
      } else {
        dispatch('addConnectingNumber', number);
        connect();
      }
    }
  } else if (number.id) {
    if (!number.isEnabled) {
      connect();
    }

    if (!number.isEnabled || number.status === ConsumerConnectionStatus.Inactive) {
      if (isLostQRCodeError(number.lastInactiveCause)) {
        dispatch('addDisconnectedNumber', number);
      } else {
        dispatch('addConnectingNumber', number);
      }
    } else if (number.status === ConsumerConnectionStatus.Active && (isDisconnectedNumber || isConnectingNumber)) {
      dispatch('addRecentConnectedNumbers', number);
    }
  }
};
var startMonitoring = /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(context) {
    var options,
        whatsAppNumbers,
        subDomainStatus,
        _args3 = arguments;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            options = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
            _context3.next = 3;
            return context.dispatch('getWhatsappNumbers', options);

          case 3:
            whatsAppNumbers = _context3.sent;
            whatsAppNumbers.forEach(function (number) {
              context.dispatch('orchestrateClientNumber', {
                number: number,
                origin: 'http'
              });
            });
            subDomainStatus = context.getters.wppSubDomainStatus;
            connectSocket(subDomainStatus.subDomain, context);

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function startMonitoring(_x3) {
    return _ref14.apply(this, arguments);
  };
}();

var ConnectionStatus = /*#__PURE__*/Object.freeze({
  __proto__: null,
  tryConnect: tryConnect,
  barShow: barShow,
  loaderShowBar: loaderShowBar,
  tryCloseBar: tryCloseBar,
  removeNumber: removeNumber,
  addConnectingNumber: addConnectingNumber,
  addRecentConnectedNumbers: addRecentConnectedNumbers,
  addDisconnectedNumber: addDisconnectedNumber,
  orchestrateClientNumber: orchestrateClientNumber,
  startMonitoring: startMonitoring
});

var socketWaNumberConnected = function socketWaNumberConnected(_ref, number) {
  var dispatch = _ref.dispatch,
      getters = _ref.getters;
  getters.isDebug && console.log('waNumberConnected.socket', number);
  dispatch('orchestrateClientNumber', {
    number: number,
    origin: 'socket'
  });
};
var socketWaNumberEnabled = function socketWaNumberEnabled(_ref2, number) {
  var dispatch = _ref2.dispatch,
      getters = _ref2.getters;
  getters.isDebug && console.log('waNumberEnabled.socket', number);
  dispatch('orchestrateClientNumber', {
    number: number,
    origin: 'socket'
  });
};
var socketWaNumberDisconnected = function socketWaNumberDisconnected(_ref3, number) {
  var dispatch = _ref3.dispatch,
      getters = _ref3.getters;
  getters.isDebug && console.log('waNumberDisconnected.socket', number);
  dispatch('orchestrateClientNumber', {
    number: number,
    origin: 'socket'
  });
};
var socketWaNumberInactived = function socketWaNumberInactived(_ref4, number) {
  var dispatch = _ref4.dispatch,
      getters = _ref4.getters;
  getters.isDebug && console.log('waNumberInactived.socket', number);

  var modifiedNumber = _objectSpread2(_objectSpread2({}, number), {}, {
    userTryingReconnect: false
  });

  dispatch('orchestrateClientNumber', {
    number: modifiedNumber,
    origin: 'socket'
  });
};
var socketWaNumberRemoved = function socketWaNumberRemoved(_ref5, number) {
  var dispatch = _ref5.dispatch,
      getters = _ref5.getters;
  getters.isDebug && console.log('socketWaNumberRemoved.socket', number);
  dispatch('removeNumber', {
    number: number,
    queues: [StateNumberQueues.Connecting, StateNumberQueues.Disconnected, StateNumberQueues.RecentConnected]
  });
};
var waNumberConnected = socketWaNumberConnected;
var waNumberEnabled = socketWaNumberEnabled;
var waNumberDisconnected = socketWaNumberDisconnected;
var waNumberInactived = socketWaNumberInactived;
var waNumberRemoved = socketWaNumberRemoved;

var ConnectionStatusSocket = /*#__PURE__*/Object.freeze({
  __proto__: null,
  socketWaNumberConnected: socketWaNumberConnected,
  socketWaNumberEnabled: socketWaNumberEnabled,
  socketWaNumberDisconnected: socketWaNumberDisconnected,
  socketWaNumberInactived: socketWaNumberInactived,
  socketWaNumberRemoved: socketWaNumberRemoved,
  waNumberConnected: waNumberConnected,
  waNumberEnabled: waNumberEnabled,
  waNumberDisconnected: waNumberDisconnected,
  waNumberInactived: waNumberInactived,
  waNumberRemoved: waNumberRemoved
});

var actions$1 = _objectSpread2(_objectSpread2({}, ConnectionStatus), ConnectionStatusSocket);

var connectingNumbers = function connectingNumbers(_ref) {
  var connectingNumbers = _ref.connectingNumbers;
  return connectingNumbers;
};
var disconnectedNumbers = function disconnectedNumbers(_ref2) {
  var disconnectedNumbers = _ref2.disconnectedNumbers;
  return disconnectedNumbers;
};
var recentConnectedNumbers = function recentConnectedNumbers(_ref3) {
  var recentConnectedNumbers = _ref3.recentConnectedNumbers;
  return recentConnectedNumbers;
};
var disableReconnectingReOpen = function disableReconnectingReOpen(_ref4) {
  var disableReconnectingReOpen = _ref4.disableReconnectingReOpen;
  return disableReconnectingReOpen;
};
var canShowBar = function canShowBar(_ref5) {
  var canShowBar = _ref5.canShowBar;
  return canShowBar;
};
var canVerifyConfigurations = function canVerifyConfigurations() {
  return false;
};
var socketEventsQueue = function socketEventsQueue(_ref6) {
  var socketEventsQueue = _ref6.socketEventsQueue;
  return socketEventsQueue;
};
var discoverNumberByState = function discoverNumberByState(_ref7) {
  var disconnectedNumbers = _ref7.disconnectedNumbers,
      connectingNumbers = _ref7.connectingNumbers,
      recentConnectedNumbers = _ref7.recentConnectedNumbers;
  return function (number, state) {
    if (state === 'disconnected') {
      return disconnectedNumbers.find(function (n) {
        return equals(n, number);
      });
    } else if (state === 'connecting') {
      return connectingNumbers.find(function (n) {
        return equals(n, number);
      });
    } else if (state === 'recent-connected') {
      return recentConnectedNumbers.find(function (n) {
        return equals(n, number);
      });
    }

    return null;
  };
};
var inLoaderShowBar = function inLoaderShowBar(_ref8) {
  var inLoaderShowBar = _ref8.inLoaderShowBar;
  return inLoaderShowBar;
};

var getters$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  connectingNumbers: connectingNumbers,
  disconnectedNumbers: disconnectedNumbers,
  recentConnectedNumbers: recentConnectedNumbers,
  disableReconnectingReOpen: disableReconnectingReOpen,
  canShowBar: canShowBar,
  canVerifyConfigurations: canVerifyConfigurations,
  socketEventsQueue: socketEventsQueue,
  discoverNumberByState: discoverNumberByState,
  inLoaderShowBar: inLoaderShowBar
});

var bar = {
  state: state$1,
  mutations: mutations$1,
  actions: actions$1,
  getters: getters$1,
  types: types$1
};

var state$2 = {
  whatsappNumbers: undefined
};

var $findIndex = arrayIteration.findIndex;



var FIND_INDEX = 'findIndex';
var SKIPS_HOLES$1 = true;

var USES_TO_LENGTH$6 = arrayMethodUsesToLength(FIND_INDEX);

// Shouldn't skip holes
if (FIND_INDEX in []) Array(1)[FIND_INDEX](function () { SKIPS_HOLES$1 = false; });

// `Array.prototype.findIndex` method
// https://tc39.github.io/ecma262/#sec-array.prototype.findindex
_export({ target: 'Array', proto: true, forced: SKIPS_HOLES$1 || !USES_TO_LENGTH$6 }, {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND_INDEX);

var $map = arrayIteration.map;



var HAS_SPECIES_SUPPORT$1 = arrayMethodHasSpeciesSupport('map');
// FF49- issue
var USES_TO_LENGTH$7 = arrayMethodUsesToLength('map');

// `Array.prototype.map` method
// https://tc39.github.io/ecma262/#sec-array.prototype.map
// with adding support of @@species
_export({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT$1 || !USES_TO_LENGTH$7 }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var SET_WHATSAPP_NUMBERS = 'whatsapp/set/numbers';
var UPDATE_WHATSAPP_NUMBERS_STATUS = 'whatsapp/update/numbers/status';
var UPDATE_WHATSAPP_NAME = 'whatsapp/update/name';
var ENABLE_WHATSAPP_NUMBER = 'whatsapp/enable/number';
var DISABLE_WHATSAPP_NUMBER = 'whatsapp/enable/number';
var SET_NUMBER_STATUS = 'whatsapp/set/number/status';
var REMOVE_WHATSAPP_NUMBER = 'whatsapp/remove/number';

var types$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  SET_WHATSAPP_NUMBERS: SET_WHATSAPP_NUMBERS,
  UPDATE_WHATSAPP_NUMBERS_STATUS: UPDATE_WHATSAPP_NUMBERS_STATUS,
  UPDATE_WHATSAPP_NAME: UPDATE_WHATSAPP_NAME,
  ENABLE_WHATSAPP_NUMBER: ENABLE_WHATSAPP_NUMBER,
  DISABLE_WHATSAPP_NUMBER: DISABLE_WHATSAPP_NUMBER,
  SET_NUMBER_STATUS: SET_NUMBER_STATUS,
  REMOVE_WHATSAPP_NUMBER: REMOVE_WHATSAPP_NUMBER
});

var _types$SET_WHATSAPP_N;
var mutations$2 = (_types$SET_WHATSAPP_N = {}, _defineProperty(_types$SET_WHATSAPP_N, SET_WHATSAPP_NUMBERS, function (state, numbers) {
  state.whatsappNumbers = numbers.map(function (n, index) {
    return _objectSpread2(_objectSpread2({}, n), {}, {
      index: index,
      valid: true,
      translate: translateName(n.name)
    });
  });
}), _defineProperty(_types$SET_WHATSAPP_N, UPDATE_WHATSAPP_NUMBERS_STATUS, function (state, payload) {
  var updatedNumbers = state.whatsappNumbers.map(function (item) {
    if (item.number === payload.number.number) {
      return _objectSpread2(_objectSpread2({}, item), {}, {
        status: whatsappConnectionStatus[payload.queue],
        consumer: payload.number.consumer
      });
    } else {
      return item;
    }
  });
  state.whatsappNumbers = updatedNumbers;
}), _defineProperty(_types$SET_WHATSAPP_N, UPDATE_WHATSAPP_NAME, function (state, _ref) {
  var id = _ref.id,
      name = _ref.name;
  var currentIndex = state.whatsappNumbers.findIndex(function (number) {
    return number.id === id;
  });

  if (currentIndex >= 0) {
    var updatedNumbers = _toConsumableArray(state.whatsappNumbers);

    updatedNumbers[currentIndex].name = name;
    updatedNumbers[currentIndex].translate = translateName(name);
    state.whatsappNumbers = updatedNumbers;
  }
}), _defineProperty(_types$SET_WHATSAPP_N, ENABLE_WHATSAPP_NUMBER, function (state, numberId) {
  var currentIndex = state.whatsappNumbers.findIndex(function (number) {
    return number.id === numberId;
  });

  if (currentIndex >= 0) {
    var updatedNumbers = _toConsumableArray(state.whatsappNumbers);

    updatedNumbers[currentIndex].isEnabled = true;
    state.whatsappNumbers = updatedNumbers;
  }
}), _defineProperty(_types$SET_WHATSAPP_N, DISABLE_WHATSAPP_NUMBER, function (state, numberId) {
  var currentIndex = state.whatsappNumbers.findIndex(function (number) {
    return number.id === numberId;
  });

  if (currentIndex >= 0) {
    var updatedNumbers = _toConsumableArray(state.whatsappNumbers);

    updatedNumbers[currentIndex].isEnabled = false;
    state.whatsappNumbers = updatedNumbers;
  }
}), _defineProperty(_types$SET_WHATSAPP_N, REMOVE_WHATSAPP_NUMBER, function (state, numberId) {
  var currentIndex = state.whatsappNumbers.findIndex(function (number) {
    return number.id === numberId;
  });

  if (currentIndex >= 0) {
    var updatedNumbers = state.whatsappNumbers.filter(function (number) {
      return number.id !== numberId;
    });
    state.whatsappNumbers = updatedNumbers;
  }
}), _defineProperty(_types$SET_WHATSAPP_N, SET_NUMBER_STATUS, function (state, _ref2) {
  var id = _ref2.id,
      status = _ref2.status,
      isEnabled = _ref2.isEnabled;
  var currentIndex = state.whatsappNumbers.findIndex(function (number) {
    return number.id === id;
  });

  if (currentIndex >= 0) {
    var updatedNumbers = _toConsumableArray(state.whatsappNumbers);

    updatedNumbers[currentIndex].status = status;
    updatedNumbers[currentIndex].isEnabled = isEnabled;
    state.whatsappNumbers = updatedNumbers;
  }
}), _types$SET_WHATSAPP_N);

var connectingNumbers$1 = {};
var getWhatsappNumbers$1 = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(context) {
    var options,
        fetchIntegrators,
        qrCodeNumbers,
        numbers,
        integratorNumbers,
        _args = arguments;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            fetchIntegrators = options.fetchIntegrators;
            _context.next = 4;
            return getWhatsappNumbers();

          case 4:
            qrCodeNumbers = _context.sent;
            numbers = _toConsumableArray(qrCodeNumbers);

            if (!fetchIntegrators) {
              _context.next = 11;
              break;
            }

            _context.next = 9;
            return getIntegratorWhatsappNumbers();

          case 9:
            integratorNumbers = _context.sent;
            numbers = [].concat(_toConsumableArray(numbers), _toConsumableArray(integratorNumbers));

          case 11:
            context.commit(SET_WHATSAPP_NUMBERS, numbers);
            return _context.abrupt("return", numbers);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getWhatsappNumbers(_x) {
    return _ref.apply(this, arguments);
  };
}();
var updateWhatsappNumbersStatus = function updateWhatsappNumbersStatus(context, payload) {
  context.commit(UPDATE_WHATSAPP_NUMBERS_STATUS, payload);
};
var updateWhatsappName = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(context, number) {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return updateNumberName(number, context.getters.wppUserLogged.id);

          case 2:
            context.dispatch('updateStateWhatsappNumberName', number);

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function updateWhatsappName(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();
var updateStateWhatsappNumberName = function updateStateWhatsappNumberName(context, number) {
  return context.commit(UPDATE_WHATSAPP_NAME, number);
};
var enableWhatsappNumber = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(context, id) {
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return enableNumber(id);

          case 2:
            context.commit(ENABLE_WHATSAPP_NUMBER, id);

          case 3:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function enableWhatsappNumber(_x4, _x5) {
    return _ref3.apply(this, arguments);
  };
}();
var disableWhatsappNumber = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(context, id) {
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return disableNumber(id);

          case 2:
            context.commit(DISABLE_WHATSAPP_NUMBER, id);

          case 3:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function disableWhatsappNumber(_x6, _x7) {
    return _ref4.apply(this, arguments);
  };
}();
var removeWhatsappNumber = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(context, phone) {
    var chatBotFluxes, fluxes;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return getChatBotsFluxes();

          case 2:
            chatBotFluxes = _context5.sent;
            fluxes = chatBotFluxes.filter(function (b) {
              if (b.channel && b.channel === 'whatsapp' && b.conditions.length === 1 && b.conditions[0].value == phone.number) {
                return b;
              }
            }).map(function (b) {
              return {
                id: b.id,
                enabled: false
              };
            });

            if (fluxes) {
              inactivateFluxes(fluxes);
            }

            if (connectingNumbers$1[phone.id]) {
              clearInterval(connectingNumbers$1[phone.id]);
              delete connectingNumbers$1[phone.id];
            }

            _context5.next = 8;
            return deleteNumber(phone.id, context.getters.wppUserLogged.id);

          case 8:
            context.commit(REMOVE_WHATSAPP_NUMBER, phone.id);

          case 9:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function removeWhatsappNumber(_x8, _x9) {
    return _ref5.apply(this, arguments);
  };
}();
var numberConnectInterval = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(context, numberId) {
    var connected, failedConnect, connectAttempts;
    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            if (!connectingNumbers$1[numberId]) {
              _context7.next = 2;
              break;
            }

            return _context7.abrupt("return");

          case 2:
            _context7.next = 4;
            return getNumberStatus(numberId);

          case 4:
            connected = _context7.sent;

            if (connected.status !== 2) {
              failedConnect = {
                id: connected.id,
                status: -1
              };
              context.commit(SET_NUMBER_STATUS, failedConnect);
              connectAttempts = 0;
              connectingNumbers$1[numberId] = setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                var connectRetry, failedRetry;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                  while (1) {
                    switch (_context6.prev = _context6.next) {
                      case 0:
                        _context6.prev = 0;
                        _context6.next = 3;
                        return getNumberStatus(numberId);

                      case 3:
                        connectRetry = _context6.sent;

                        if (connectRetry.status === 2) {
                          context.commit(SET_NUMBER_STATUS, connectRetry);
                          clearInterval(connectingNumbers$1[numberId]);
                          delete connectingNumbers$1[numberId];
                        } else {
                          failedRetry = {
                            id: connectRetry.id,
                            status: -1
                          };
                          context.commit(SET_NUMBER_STATUS, failedRetry);
                        }

                        if (connectAttempts >= 30) {
                          context.commit(SET_NUMBER_STATUS, connectRetry);
                          clearInterval(connectingNumbers$1[numberId]);
                          delete connectingNumbers$1[numberId];
                        }

                        connectAttempts += 1;
                        _context6.next = 14;
                        break;

                      case 9:
                        _context6.prev = 9;
                        _context6.t0 = _context6["catch"](0);
                        console.error('Error at connect interval attemp: ', _context6.t0);
                        connectAttempts += 1;

                        if (connectAttempts >= 30) {
                          context.commit(SET_NUMBER_STATUS, connected);
                          clearInterval(connectingNumbers$1[numberId]);
                          delete connectingNumbers$1[numberId];
                        }

                      case 14:
                      case "end":
                        return _context6.stop();
                    }
                  }
                }, _callee6, null, [[0, 9]]);
              })), 2000);
            } else {
              context.commit(SET_NUMBER_STATUS, connected);
              clearInterval(connectingNumbers$1[numberId]);
              delete connectingNumbers$1[numberId];
            }

          case 6:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function numberConnectInterval(_x10, _x11) {
    return _ref6.apply(this, arguments);
  };
}();

var actions$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getWhatsappNumbers: getWhatsappNumbers$1,
  updateWhatsappNumbersStatus: updateWhatsappNumbersStatus,
  updateWhatsappName: updateWhatsappName,
  updateStateWhatsappNumberName: updateStateWhatsappNumberName,
  enableWhatsappNumber: enableWhatsappNumber,
  disableWhatsappNumber: disableWhatsappNumber,
  removeWhatsappNumber: removeWhatsappNumber,
  numberConnectInterval: numberConnectInterval
});

var whatsappNumbers = function whatsappNumbers(_ref) {
  var whatsappNumbers = _ref.whatsappNumbers;
  return whatsappNumbers;
};

var getters$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  whatsappNumbers: whatsappNumbers
});

var listNumbers$2 = {
  state: state$2,
  mutations: mutations$2,
  actions: actions$2,
  getters: getters$2,
  types: types$2
};

var state$3 = {
  qrcodeError: undefined,
  qrcodeErrorDetails: undefined,
  qrcodeSuccess: undefined,
  qrcodeReading: false,
  qrcode: '',
  maxRetries: 10,
  autoRetries: 0
};

var _types$WHATSAPP_SET_Q;
var mutations$3 = (_types$WHATSAPP_SET_Q = {}, _defineProperty(_types$WHATSAPP_SET_Q, WHATSAPP_SET_QRCODE, function (state, qrcode) {
  state.qrcodeReading = true;
  state.qrcode = qrcode;
}), _defineProperty(_types$WHATSAPP_SET_Q, WHATSAPP_QRCODE_ERROR, function (state, error) {
  state.qrcodeErrorDetails = undefined;
  state.qrcodeReading = false;
  state.qrcodeSuccess = null;
  state.qrcodeLogged = false;
  state.qrcodeError = error;

  try {
    var errorData = JSON.parse(error);

    if (errorData) {
      state.qrcodeError = errorData;

      if (errorData.code === 'NUMBER_CONFLICT') {
        state.qrcodeErrorDetails = i18n$1.t('qrCode.errorDifferentNumber');
      } else if (errorData.code === 'AVAILABLE_CONFLICT') {
        state.qrcodeErrorDetails = errorData.code;
      }
    }
  } catch (err) {
    console.error('err WHATSAPP_QRCODE_ERROR', err);
  }
}), _defineProperty(_types$WHATSAPP_SET_Q, WHATSAPP_QRCODE_LOGGED, function (state) {
  state.qrcodeLogged = true;
  state.qrcode = '';
}), _defineProperty(_types$WHATSAPP_SET_Q, WHATSAPP_QRCODE_SUCCESS, function (state, session) {
  state.qrcodeReading = false;
  state.qrcodeSuccess = session;
}), _defineProperty(_types$WHATSAPP_SET_Q, WHATSAPP_SET_QRCODE_READING, function (state) {
  state.qrcodeReading = true;
  state.qrcodeSuccess = null;
  state.qrcodeLogged = false;
}), _defineProperty(_types$WHATSAPP_SET_Q, WHATSAPP_QRCODE_RESET, function (state) {
  state.qrcodeError = undefined;
  state.qrcodeErrorDetails = undefined;
  state.qrcodeSuccess = undefined;
  state.qrcodeReading = false;
  state.qrcode = '';
}), _defineProperty(_types$WHATSAPP_SET_Q, ADD_AUTO_RETRY, function (state) {
  state.autoRetries += 1;
}), _defineProperty(_types$WHATSAPP_SET_Q, RESET_AUTO_RETRY, function (state) {
  state.autoRetries = 0;
}), _types$WHATSAPP_SET_Q);

var openQRCodeWS$2 = function openQRCodeWS(context, contact) {
  context.commit(WHATSAPP_QRCODE_ERROR, null);
  context.commit(WHATSAPP_QRCODE_SUCCESS, null);
  context.commit(WHATSAPP_SET_QRCODE, '');
  context.commit(WHATSAPP_SET_QRCODE_READING);
  openQRCodeWS$1(contact, context);
  var _context$getters = context.getters,
      autoRetries = _context$getters.autoRetries,
      maxRetries = _context$getters.maxRetries;

  if (autoRetries >= maxRetries) {
    context.dispatch('resetAutoRetry');
  }
};
var confirmQRCodeOverrideWS$2 = function confirmQRCodeOverrideWS(_ref, _ref2) {
  var commit = _ref.commit,
      dispatch = _ref.dispatch;
  var confirmed = _ref2.confirmed;
  commit(WHATSAPP_QRCODE_ERROR, null);
  commit(WHATSAPP_QRCODE_SUCCESS, null);
  confirmQRCodeOverrideWS$1({
    confirmed: confirmed
  });

  if (!confirmed) {
    dispatch('closeQRCodeWS');
  }
};
var closeQRCodeWS$2 = function closeQRCodeWS(context) {
  closeQRCodeWS$1();
  context.commit(WHATSAPP_QRCODE_RESET);
};
var retryQrCode$1 = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(context, contact) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return context.dispatch('closeQRCodeWS');

          case 2:
            _context.next = 4;
            return context.dispatch('openQRCodeWS', contact);

          case 4:
            _context.next = 6;
            return context.dispatch('addAutoRetry');

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function retryQrCode(_x, _x2) {
    return _ref3.apply(this, arguments);
  };
}();
/* eslint-disable @typescript-eslint/camelcase */

var ws_error$1 = function ws_error(context, payload) {
  var _context$getters2 = context.getters,
      autoRetries = _context$getters2.autoRetries,
      maxRetries = _context$getters2.maxRetries;
  var data = payload.data,
      contact = payload.contact;

  if (data && data.match(/error during login: login timed out/) && autoRetries < maxRetries) {
    context.dispatch('retryQrCode', contact);
  } else {
    context.commit(WHATSAPP_QRCODE_ERROR, data);
  }
};
var ws_qrcode$1 = function ws_qrcode(context, payload) {
  context.commit(WHATSAPP_SET_QRCODE, payload.data);
};
var ws_logged$1 = function ws_logged(context, session) {
  context.commit(WHATSAPP_QRCODE_LOGGED, session.data);
};
var ws_creatingSuccess$1 = function ws_creatingSuccess(context, payload) {
  try {
    var client = JSON.parse(payload.data);

    if (client && client.id) {
      context.dispatch('numberConnectInterval', client.id);
    }
  } catch (err) {
    console.error('err ws_creatingSuccess', err);
  }

  context.commit(WHATSAPP_QRCODE_SUCCESS, payload.data);
};
var addAutoRetry$1 = function addAutoRetry(context) {
  context.commit(ADD_AUTO_RETRY);
};
var resetAutoRetry$1 = function resetAutoRetry(context) {
  context.commit(RESET_AUTO_RETRY);
};

var actions$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  openQRCodeWS: openQRCodeWS$2,
  confirmQRCodeOverrideWS: confirmQRCodeOverrideWS$2,
  closeQRCodeWS: closeQRCodeWS$2,
  retryQrCode: retryQrCode$1,
  ws_error: ws_error$1,
  ws_qrcode: ws_qrcode$1,
  ws_logged: ws_logged$1,
  ws_creatingSuccess: ws_creatingSuccess$1,
  addAutoRetry: addAutoRetry$1,
  resetAutoRetry: resetAutoRetry$1
});

var qrcode = function qrcode(_ref) {
  var qrcode = _ref.qrcode;
  return qrcode;
};
var qrcodeError = function qrcodeError(_ref2) {
  var qrcodeError = _ref2.qrcodeError;
  return qrcodeError;
};
var qrcodeErrorDetails = function qrcodeErrorDetails(_ref3) {
  var qrcodeErrorDetails = _ref3.qrcodeErrorDetails;
  return qrcodeErrorDetails;
};
var qrcodeSuccess = function qrcodeSuccess(_ref4) {
  var qrcodeSuccess = _ref4.qrcodeSuccess;
  return qrcodeSuccess;
};
var autoRetries = function autoRetries(_ref5) {
  var autoRetries = _ref5.autoRetries;
  return autoRetries;
};
var maxRetries = function maxRetries(_ref6) {
  var maxRetries = _ref6.maxRetries;
  return maxRetries;
};

var getters$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  qrcode: qrcode,
  qrcodeError: qrcodeError,
  qrcodeErrorDetails: qrcodeErrorDetails,
  qrcodeSuccess: qrcodeSuccess,
  autoRetries: autoRetries,
  maxRetries: maxRetries
});

var qrcode$1 = {
  state: state$3,
  mutations: mutations$3,
  actions: actions$3,
  getters: getters$3,
  types: types
};

var state$4 = {
  wppApiNumber: {
    name: '',
    number: '',
    customFields: {
      aboutDescription: '',
      thumbUrl: '',
      businessProfile: {
        address: '',
        description: '',
        email: '',
        websites: [],
        vertical: ''
      }
    }
  },
  currentState: undefined,
  previousState: undefined
};

var SET_CURRENT_WPP_API_STATE = 'SET_CURRENT_WPP_API_STATE';
var SET_WPP_API_NUMBER = 'SET_WPP_API_NUMBER';
var CLEAR_CURRENT_WPP_API_NUMBER = 'CLEAR_CURRENT_WPP_API_NUMBER';

var types$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  SET_CURRENT_WPP_API_STATE: SET_CURRENT_WPP_API_STATE,
  SET_WPP_API_NUMBER: SET_WPP_API_NUMBER,
  CLEAR_CURRENT_WPP_API_NUMBER: CLEAR_CURRENT_WPP_API_NUMBER
});

var _types$SET_CURRENT_WP;
var mutations$4 = (_types$SET_CURRENT_WP = {}, _defineProperty(_types$SET_CURRENT_WP, SET_CURRENT_WPP_API_STATE, function (state, updatedState) {
  state.previousState = state.currentState;
  state.currentState = updatedState;
}), _defineProperty(_types$SET_CURRENT_WP, SET_WPP_API_NUMBER, function (state, updatedValues) {
  state.wppApiNumber = _objectSpread2(_objectSpread2({}, state.wppApiNumber), updatedValues); // delete state.wppApiNumber.privateCustomFields
}), _defineProperty(_types$SET_CURRENT_WP, CLEAR_CURRENT_WPP_API_NUMBER, function (state) {
  state.wppApiNumber = {
    name: '',
    number: '',
    customFields: {
      aboutDescription: '',
      thumbUrl: '',
      businessProfile: {
        address: '',
        description: '',
        email: '',
        websites: [],
        vertical: ''
      }
    },
    privateCustomFields: {
      apiKey: ''
    }
  };
}), _types$SET_CURRENT_WP);

var addWhatsappApiNumber$1 = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(context) {
    var number;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            number = context.getters.wppApiNumber;
            return _context.abrupt("return", addWhatsappApiNumber(number));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function addWhatsappApiNumber(_x) {
    return _ref.apply(this, arguments);
  };
}();
var updateWhatsappApiNumber$1 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(context) {
    var number, response;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            number = context.getters.wppApiNumber;
            _context2.next = 3;
            return updateWhatsappApiNumber(number);

          case 3:
            response = _context2.sent;

            if (response.data) {
              context.dispatch('updateStateWhatsappNumberName', response.data);
            }

            return _context2.abrupt("return", response);

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function updateWhatsappApiNumber(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
var setCurrentWhatsappApiNumber = function setCurrentWhatsappApiNumber(context, updatedValues) {
  context.commit(SET_WPP_API_NUMBER, updatedValues);
};
var setCurrentWhatsappApiState = function setCurrentWhatsappApiState(context, state) {
  context.commit(SET_CURRENT_WPP_API_STATE, state);
};
var clearCurrentWhatsappApiNumber = function clearCurrentWhatsappApiNumber(context) {
  context.commit(CLEAR_CURRENT_WPP_API_NUMBER);
};

var actions$4 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  addWhatsappApiNumber: addWhatsappApiNumber$1,
  updateWhatsappApiNumber: updateWhatsappApiNumber$1,
  setCurrentWhatsappApiNumber: setCurrentWhatsappApiNumber,
  setCurrentWhatsappApiState: setCurrentWhatsappApiState,
  clearCurrentWhatsappApiNumber: clearCurrentWhatsappApiNumber
});

var wppApiNumber = function wppApiNumber(_ref) {
  var wppApiNumber = _ref.wppApiNumber;
  return wppApiNumber;
};
var currentWppApiState = function currentWppApiState(_ref2) {
  var currentState = _ref2.currentState;
  return currentState;
};
var currentWppApiPreviousState = function currentWppApiPreviousState(_ref3) {
  var previousState = _ref3.previousState;
  return previousState;
};

var getters$4 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  wppApiNumber: wppApiNumber,
  currentWppApiState: currentWppApiState,
  currentWppApiPreviousState: currentWppApiPreviousState
});

var whatsappApi = {
  state: state$4,
  mutations: mutations$4,
  actions: actions$4,
  getters: getters$4,
  types: types$3
};

var appModules = {
  bar: bar,
  listNumbers: listNumbers$2,
  qrcode: qrcode$1,
  whatsappApi: whatsappApi
};

var getCookie = function getCookie(name) {
  if (typeof window !== 'undefined') {
    var value = ";".concat(window.document.cookie);
    var parts = value.split(";".concat(name, "=")).pop();
    var cookie = parts && parts.split(';').shift();
    return cookie;
  }
};
var setCookie = function setCookie(name, value) {
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    document.cookie = "".concat(name, "=").concat(value, ";path=/");
  }
};

var objectId = function objectId() {
  var timestamp = (new Date().getTime() / 1000 | 0).toString(16);
  return timestamp + 'xxxxxxxxxxxxxxxx'.replace(/[x]/g, function () {
    return (Math.random() * 16 | 0).toString(16);
  }).toLowerCase();
};

var getAnonymousId = function getAnonymousId() {
  var cookie = getCookie('octa-anonymous-id');

  if (cookie) {
    return cookie;
  } else {
    var id = objectId();
    setCookie('octa-anonymous-id', id);
    return id;
  }
};

var getParameterByName = function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[[]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
  if (!results) return '';
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

function _classCallCheck$8(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$7(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$7(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$7(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$7(Constructor, staticProps);
  return Constructor;
}

var AnalyticsService = /*#__PURE__*/function () {
  function AnalyticsService() {
    _classCallCheck$8(this, AnalyticsService);

    this.http = createClient({
      baseURL: configs.apis.analytics
    });
  }

  _createClass$7(AnalyticsService, [{
    key: "send",
    value: function () {
      var _send = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(event) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (event) {
                  _context.next = 3;
                  break;
                }

                throw new Error('Error in analytics event: missing event data');

              case 3:
                if (!event.anonymous_id) ;

                _context.next = 6;
                return this.http.post('/events', event);

              case 6:
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);
                throw new Error('Error at analytics send: ' + _context.t0);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 8]]);
      }));

      function send(_x) {
        return _send.apply(this, arguments);
      }

      return send;
    }()
  }]);

  return AnalyticsService;
}();

var DataLayerService = /*#__PURE__*/function () {
  function DataLayerService() {
    _classCallCheck$8(this, DataLayerService);
  }

  _createClass$7(DataLayerService, [{
    key: "insertDataLayerEvent",
    value: function insertDataLayerEvent(event) {
      var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GenericEvent';

      if (!event) {
        throw new Error('missing dataLayer event');
      }

      if (typeof window !== 'undefined' && window.dataLayer && window.dataLayer instanceof Array) {
        window.dataLayer.push(_objectSpread2(_objectSpread2({}, event), {}, {
          event: name
        }));
      }
    }
  }]);

  return DataLayerService;
}();

var trackEvent = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(context, properties) {
    var _context$getters$wppU, _context$getters$wppU2, _context$getters$wppS, _navigator, _context$getters$wppU3;

    var anonymous_id, company_id, user_id, cycle_type, device, gclid, role_type, defaultProperties, event, dataLayerEvent, dataLayerService, analyticsService;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            anonymous_id = getAnonymousId();
            company_id = (_context$getters$wppU = context.getters.wppUserLogged) === null || _context$getters$wppU === void 0 ? void 0 : _context$getters$wppU.subDomain;
            user_id = (_context$getters$wppU2 = context.getters.wppUserLogged) === null || _context$getters$wppU2 === void 0 ? void 0 : _context$getters$wppU2.id;
            cycle_type = (_context$getters$wppS = context.getters.wppSubDomainStatus) === null || _context$getters$wppS === void 0 ? void 0 : _context$getters$wppS.cycleType;
            device = (_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.userAgent;
            gclid = getParameterByName('gclid');
            role_type = (_context$getters$wppU3 = context.getters.wppUserLogged) === null || _context$getters$wppU3 === void 0 ? void 0 : _context$getters$wppU3.roleType;
            defaultProperties = {
              anonymous_id: anonymous_id,
              company_id: company_id,
              user_id: user_id,
              cycle_type: cycle_type,
              role_type: role_type,
              device: device,
              gclid: gclid
            };

            if (properties.new_analytics) {
              defaultProperties.utm_source = getParameterByName('utm_source');
              defaultProperties.utm_campaign = getParameterByName('utm_campaign');
              defaultProperties.utm_medium = getParameterByName('utm_medium');
              defaultProperties.is_mobile = window.innerWidth < 768;
              defaultProperties.event_location = 'setup';
            } else {
              defaultProperties.properties = [];
              defaultProperties.utms = [];
            }

            event = _objectSpread2(_objectSpread2({}, defaultProperties), properties);

            if (!properties.sendToGa) {
              _context.next = 18;
              break;
            }

            _context.next = 14;
            return context.dispatch('parseDataLayerAnalyticsEvent', event);

          case 14:
            dataLayerEvent = _context.sent;
            dataLayerService = new DataLayerService();
            dataLayerService.insertDataLayerEvent(dataLayerEvent, 'AnalyticsEvent');
            delete event.sendToGa;

          case 18:
            analyticsService = new AnalyticsService();
            _context.next = 21;
            return analyticsService.send(event);

          case 21:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function trackEvent(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var parseDataLayerAnalyticsEvent = function parseDataLayerAnalyticsEvent(_, event) {
  var _event$properties;

  var parsedEvent = _objectSpread2({}, event);

  parsedEvent.action = parsedEvent.name;

  if ((_event$properties = event.properties) === null || _event$properties === void 0 ? void 0 : _event$properties.length) {
    parsedEvent.label = '';
    event.properties.forEach(function (property) {
      parsedEvent.label += "".concat(property.name, "=").concat(property.value, ";");
    });
  }

  return parsedEvent;
};

var actions$5 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  trackEvent: trackEvent,
  parseDataLayerAnalyticsEvent: parseDataLayerAnalyticsEvent
});

var analytics = {
  actions: actions$5
};

var modules$1 = {
  analytics: analytics
};

Vue$1.use(index);
var store$2 = new index.Store({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
  modules: _objectSpread2(_objectSpread2({}, appModules), modules$1)
});

var script$7 = {
  store: store$2,
  i18n: i18n,
  data: function data() {
    return {
      unsubscribe: undefined,
      unwatch: undefined
    };
  },
  methods: {
    verifyPrefix: function verifyPrefix(phoneNumber) {
      return phoneNumber && phoneNumber.toString().indexOf('+') !== -1;
    },
    handleParsePhoneNumber: function handleParsePhoneNumber(phoneNumber) {
      var verifiedNumber = this.verifyPrefix(phoneNumber) ? phoneNumber : "+".concat(phoneNumber);
      var parsedNumber = parsePhoneNumberFromString$2(verifiedNumber);
      return "+".concat(parsedNumber.countryCallingCode, " ").concat(parsedNumber.formatNational());
    },
    validationClass: function validationClass(payload) {
      if (payload.errors.length) {
        return 'validation has-error';
      } else if (payload.valid && payload.dirty && payload.value !== '') {
        return 'validation success';
      } else {
        return null;
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }

    if (this.unwatch) {
      this.unwatch();
    }
  }
};

/* script */
var __vue_script__$7 = script$7;
/* template */

/* style */

var __vue_inject_styles__$b = undefined;
/* scoped */

var __vue_scope_id__$b = undefined;
/* module identifier */

var __vue_module_identifier__$b = undefined;
/* functional template */

var __vue_is_functional_template__$b = undefined;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$b = /*#__PURE__*/normalizeComponent({}, __vue_inject_styles__$b, __vue_script__$7, __vue_scope_id__$b, __vue_is_functional_template__$b, __vue_module_identifier__$b, false, undefined, undefined, undefined);

var script$8 = {
  data: function data() {
    return {
      createQRCodeError: false
    };
  },
  methods: _objectSpread2(_objectSpread2({}, mapActions(['openQRCodeWS', 'confirmQRCodeOverrideWS', 'closeQRCodeWS'])), {}, {
    handleGetQrCode: function handleGetQrCode(contact) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.openQRCodeWS(contact);

              case 3:
                return _context.abrupt("return", false);

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", true);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 6]]);
      }))();
    }
  })
};

/* script */
var __vue_script__$8 = script$8;
/* template */

/* style */

var __vue_inject_styles__$c = undefined;
/* scoped */

var __vue_scope_id__$c = undefined;
/* module identifier */

var __vue_module_identifier__$c = undefined;
/* functional template */

var __vue_is_functional_template__$c = undefined;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$c = /*#__PURE__*/normalizeComponent({}, __vue_inject_styles__$c, __vue_script__$8, __vue_scope_id__$c, __vue_is_functional_template__$c, __vue_module_identifier__$c, false, undefined, undefined, undefined);

var script$9 = {
  props: ['contact'],
  components: {
    GenericLoader: __vue_component__$1
  },
  mixins: [__vue_component__$b, __vue_component__$c],
  data: function data() {
    return {
      qrcode: '',
      qrcodeError: undefined,
      qrcodeErrorDetails: undefined,
      limitQrCode: 10,
      totalRetries: 0
    };
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.unsubscribe = _this.$store.subscribe(function (mutation, state) {
                _this.qrcode = state.qrcode.qrcode;
                _this.qrcodeError = state.qrcode.qrcodeError;
                _this.qrcodeErrorDetails = state.qrcode.qrcodeErrorDetails;
              });
              _context.next = 3;
              return _this.handleGetQrCode(_this.contact);

            case 3:
              _this.createQRCodeError = _context.sent;

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    tryAgain: function tryAgain() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.handleGetQrCode(_this2.contact);

              case 2:
                _this2.createQRCodeError = _context2.sent;

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};

const img$3 = "data:image/png;base64,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";

/* script */
var __vue_script__$9 = script$9;

var __vue_render__$b = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.createQRCodeError || _vm.qrcodeError ? _c("div", {
    staticClass: "qr-code-read-error"
  }, [_c("img", {
    attrs: {
      src: img$3,
      alt: "alert"
    }
  }), _vm._v(" "), _c("strong", [_vm._v(_vm._s(_vm.$t("qrCode.errorReadingQRCode.title")))]), _vm._v(" "), _c("p", [_vm.qrcodeErrorDetails ? _c("span", [_vm._v("\n      " + _vm._s(_vm.qrcodeErrorDetails) + "\n      "), _c("br")]) : _vm._e(), _vm._v("\n\n    " + _vm._s(_vm.$t("qrCode.errorReadingQRCode.description")) + "\n  ")]), _vm._v(" "), _c("div", [_c("button", {
    staticClass: "btn btn-outline-primary",
    attrs: {
      type: "button"
    },
    on: {
      click: function click($event) {
        return _vm.$emit("close");
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("qrCode.errorReadingQRCode.button.no")) + "\n    ")]), _vm._v(" "), _c("button", {
    staticClass: "btn btn-primary",
    attrs: {
      type: "button"
    },
    on: {
      click: _vm.tryAgain
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("qrCode.errorReadingQRCode.button.yes")) + "\n    ")])])]) : !_vm.qrcodeError && !_vm.createQRCodeError && _vm.qrcode === "" ? _c("div", {
    staticClass: "wpp-qrcode-container"
  }, [_c("GenericLoader")], 1) : _vm.qrcode != "" ? _c("div", {
    staticClass: "wpp-qrcode-container"
  }, [_c("img", {
    attrs: {
      src: _vm.qrcode,
      alt: "qrcode"
    }
  })]) : _vm._e();
};

var __vue_staticRenderFns__$b = [];
__vue_render__$b._withStripped = true;
/* style */

var __vue_inject_styles__$d = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-54a28a6c_0", {
    source: "div.wpp-qrcode-container[data-v-54a28a6c] {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\ndiv.wpp-qrcode-container img[data-v-54a28a6c] {\n  pointer-events: none;\n}\ndiv.wpp-qrcode-container[data-v-54a28a6c]:not(.has-error) {\n  min-height: 275px;\n}\n\n/*# sourceMappingURL=QrCodeImage.vue.map */",
    map: {
      "version": 3,
      "sources": ["E:\\Octadesk\\octa-whatsapp-client\\src\\app\\qr-code\\components\\QrCodeImage.vue", "QrCodeImage.vue"],
      "names": [],
      "mappings": "AAoFA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;ACnFA;ADoFA;EACA,oBAAA;AClFA;ADoFA;EACA,iBAAA;AClFA;;AAEA,0CAA0C",
      "file": "QrCodeImage.vue",
      "sourcesContent": ["<template>\r\n  <div v-if=\"createQRCodeError || qrcodeError\" class=\"qr-code-read-error\">\r\n    <img :src=\"require('@/assets/images/alert.png')\" alt=\"alert\" />\r\n\r\n    <strong>{{ $t('qrCode.errorReadingQRCode.title') }}</strong>\r\n\r\n    <p>\r\n      <span v-if=\"qrcodeErrorDetails\">\r\n        {{ qrcodeErrorDetails }}\r\n        <br />\r\n      </span>\r\n\r\n      {{ $t('qrCode.errorReadingQRCode.description') }}\r\n    </p>\r\n\r\n    <div>\r\n      <button\r\n        type=\"button\"\r\n        class=\"btn btn-outline-primary\"\r\n        @click=\"$emit('close')\"\r\n      >\r\n        {{ $t('qrCode.errorReadingQRCode.button.no') }}\r\n      </button>\r\n\r\n      <button type=\"button\" class=\"btn btn-primary\" @click=\"tryAgain\">\r\n        {{ $t('qrCode.errorReadingQRCode.button.yes') }}\r\n      </button>\r\n    </div>\r\n  </div>\r\n\r\n  <div\r\n    v-else-if=\"!qrcodeError && !createQRCodeError && qrcode === ''\"\r\n    class=\"wpp-qrcode-container\"\r\n  >\r\n    <GenericLoader />\r\n  </div>\r\n\r\n  <div class=\"wpp-qrcode-container\" v-else-if=\"qrcode != ''\">\r\n    <img :src=\"qrcode\" alt=\"qrcode\" />\r\n  </div>\r\n</template>\r\n\r\n<script>\r\n  import { GenericLoader } from '@/app/shared-components'\r\n\r\n  import GlobalMixins from '@/app/mixins'\r\n\r\n  import QrCodeMixins from '../mixins'\r\n\r\n  export default {\r\n    props: ['contact'],\r\n    components: {\r\n      GenericLoader\r\n    },\r\n    mixins: [GlobalMixins, QrCodeMixins],\r\n    data() {\r\n      return {\r\n        qrcode: '',\r\n        qrcodeError: undefined,\r\n        qrcodeErrorDetails: undefined,\r\n        limitQrCode: 10,\r\n        totalRetries: 0\r\n      }\r\n    },\r\n    async mounted() {\r\n      this.unsubscribe = this.$store.subscribe((mutation, state) => {\r\n        this.qrcode = state.qrcode.qrcode\r\n\r\n        this.qrcodeError = state.qrcode.qrcodeError\r\n\r\n        this.qrcodeErrorDetails = state.qrcode.qrcodeErrorDetails\r\n      })\r\n\r\n      this.createQRCodeError = await this.handleGetQrCode(this.contact)\r\n    },\r\n    methods: {\r\n      async tryAgain() {\r\n        this.createQRCodeError = await this.handleGetQrCode(this.contact)\r\n      }\r\n    }\r\n  }\r\n</script>\r\n\r\n<style lang=\"scss\" scoped>\r\n  div.wpp-qrcode-container {\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    img {\r\n      pointer-events: none;\r\n    }\r\n    &:not(.has-error) {\r\n      min-height: 275px;\r\n    }\r\n  }\r\n</style>\r\n", "div.wpp-qrcode-container {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\ndiv.wpp-qrcode-container img {\n  pointer-events: none;\n}\ndiv.wpp-qrcode-container:not(.has-error) {\n  min-height: 275px;\n}\n\n/*# sourceMappingURL=QrCodeImage.vue.map */"]
    },
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$d = "data-v-54a28a6c";
/* module identifier */

var __vue_module_identifier__$d = undefined;
/* functional template */

var __vue_is_functional_template__$d = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b,
  staticRenderFns: __vue_staticRenderFns__$b
}, __vue_inject_styles__$d, __vue_script__$9, __vue_scope_id__$d, __vue_is_functional_template__$d, __vue_module_identifier__$d, false, createInjector, undefined, undefined);

var script$a = {
  props: ['contact'],
  components: {
    IconTick: __vue_component__$4,
    QrCodeImage: __vue_component__$d
  },
  mixins: [__vue_component__$c, __vue_component__$b],
  data: function data() {
    return {
      qrcodeId: undefined,
      createQRCodeError: false,
      timeout: 15,
      success: false,
      qrcodeError: undefined,
      qrcodeErrorDetails: undefined,
      qrcodeSuccess: undefined,
      wppUserLogged: {},
      wppSubDomainStatus: {}
    };
  },
  watch: {
    qrcodeSuccess: function qrcodeSuccess(success) {
      if (success) {
        this.trackEvent({
          name: 'qrcode successful',
          sendToGa: true,
          properties: [{
            name: 'configLocation',
            value: 'setup'
          }]
        });
        this.trackEvent({
          name: 'qrcode successful',
          new_analytics: true
        });

        if (this.wppUserLogged) {
          if (this.wppSubDomainStatus && this.wppSubDomainStatus.isTrial) {
            var companySubDomain = this.wppUserLogged.subDomain;
            var whatsapp = JSON.parse(success);
            var contactObj = {
              fields: [{
                name: 'email',
                value: this.wppUserLogged.email
              }, {
                name: 'company_subdmain',
                value: companySubDomain
              }, {
                name: 'whatsapp_habilitado',
                value: 'sim'
              }, {
                name: 'whatsapp_numero',
                value: whatsapp.number.toString()
              }]
            };
            submitForm(contactObj);
          }
        }
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.unsubscribe = this.$store.subscribe(function (mutation, state) {
      _this.qrcodeError = state.qrcode.qrcodeError;

      if (_this.qrcodeError) {
        _this.trackEvent({
          name: 'qrcode fail',
          sendToGa: true,
          properties: [{
            name: 'failReason',
            value: _this.qrcodeError.message
          }, {
            name: 'configLocation',
            value: 'setup'
          }]
        });
      }

      _this.qrcodeErrorDetails = state.qrcode.qrcodeErrorDetails;
      _this.qrcodeSuccess = state.qrcode.qrcodeSuccess;
      _this.wppUserLogged = state.wppUserLogged;
      _this.wppSubDomainStatus = state.wppSubDomainStatus;
    });
  },
  methods: _objectSpread2(_objectSpread2({}, mapActions(['trackEvent'])), {}, {
    goToChatList: function goToChatList() {
      this.handleClose();
      window.top.location.href = '/home/appLinks/appLink/adfe05df-0e04-43ec-b196-fb4e07b72f6b/';
    },
    handleClose: function handleClose() {
      this.$emit('close');
    },
    handleCreateNew: function handleCreateNew() {
      this.$emit('createNew');
    },
    handleResolveConflict: function handleResolveConflict(confirmed) {
      this.trackEvent({
        name: 'qrcode in use',
        sendToGa: true,
        properties: [{
          name: 'configLocation',
          value: 'setup'
        }, {
          name: 'changeCompanyOwner',
          value: confirmed.toString()
        }]
      });
      this.confirmQRCodeOverrideWS({
        confirmed: confirmed
      });

      if (!confirmed) {
        this.handleClose();
      }
    }
  })
};

var __vue_script__$a = script$a;

var __vue_render__$c = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return !_vm.qrcodeSuccess ? _c("div", {
    staticClass: "wpp-scan-code-container"
  }, ["AVAILABLE_CONFLICT" === _vm.qrcodeErrorDetails ? _c("div", {
    staticClass: "available-conflict"
  }, [_c("img", {
    attrs: {
      src: img$3,
      alt: "alert"
    }
  }), _vm._v(" "), _c("strong", [_c("span", {
    domProps: {
      innerHTML: _vm._s(_vm.$t("qrCode.availableConflict.title", {
        phoneNumber: _vm.handleParsePhoneNumber(_vm.qrcodeError.data.number)
      }))
    }
  })]), _vm._v(" "), _c("p", [_vm._v("\n      " + _vm._s(_vm.$t("qrCode.availableConflict.description")) + "\n    ")]), _vm._v(" "), _c("div", [_c("button", {
    staticClass: "btn btn-primary",
    attrs: {
      type: "button"
    },
    on: {
      click: function click($event) {
        return _vm.handleResolveConflict(false);
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("qrCode.availableConflict.button.no")) + "\n      ")]), _vm._v(" "), _c("button", {
    staticClass: "btn btn-primary",
    attrs: {
      type: "button"
    },
    on: {
      click: function click($event) {
        return _vm.handleResolveConflict(true);
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("qrCode.availableConflict.button.yes")) + "\n      ")])])]) : [_c("QrCodeImage", {
    attrs: {
      contact: _vm.contact
    },
    on: {
      close: _vm.handleClose
    }
  }), _vm._v(" "), !_vm.qrcodeError && !_vm.createQRCodeError ? _c("h3", {
    domProps: {
      innerHTML: _vm._s(_vm.$t("qrCode.title"))
    }
  }) : _vm._e(), _vm._v(" "), !_vm.qrcodeError && !_vm.createQRCodeError ? _c("h4", [_vm._v("\n      " + _vm._s(_vm.$t("qrCode.weAreAlmostThere")) + "\n\n      "), _vm.contact && _vm.contact.name ? _c("span", [_c("br"), _vm._v(" "), _c("strong", [_vm._v(_vm._s(_vm.contact.translate))]), _vm._v(" "), _c("br"), _vm._v("\n        " + _vm._s(_vm.handleParsePhoneNumber(_vm.contact.number)) + "\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), !_vm.qrcodeError ? _c("div", {
    staticClass: "platforms-terms"
  }, [_c("ul", _vm._l(["1", "2", "3"], function (step) {
    return _c("li", {
      key: step,
      domProps: {
        innerHTML: _vm._s(_vm.$t("qrCode.wppInstructions.step" + step))
      }
    });
  }), 0), _vm._v(" "), _c("p", {
    domProps: {
      innerHTML: _vm._s(_vm.$t("qrCode.wppInstructions.whatsAppTerms"))
    }
  })]) : _vm._e()]], 2) : _c("div", {
    staticClass: "qr-code-success"
  }, [_c("IconTick"), _vm._v(" "), _c("strong", [_vm._v(_vm._s(_vm.$t("qrCode.successReadQrCode.title")))]), _vm._v(" "), _c("p", [_vm._v(_vm._s(_vm.$t("qrCode.successReadQrCode.description")))]), _vm._v(" "), _c("div", [_c("button", {
    staticClass: "btn btn-primary start-use",
    attrs: {
      type: "button"
    },
    on: {
      click: function click($event) {
        return _vm.goToChatList();
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("qrCode.successReadQrCode.button.start")) + "\n    ")])]), _vm._v(" "), _c("div", {
    staticClass: "manage-numbers"
  }, [_c("a", {
    on: {
      click: _vm.handleCreateNew
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("qrCode.successReadQrCode.button.anotherNumber")) + "\n    ")]), _vm._v(" "), _c("a", {
    on: {
      click: _vm.handleClose
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("qrCode.successReadQrCode.button.manageNumbers")) + "\n    ")])])], 1);
};

var __vue_staticRenderFns__$c = [];
__vue_render__$c._withStripped = true;
/* style */

var __vue_inject_styles__$e = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-3fa6dbe6_0", {
    source: "div.available-conflict,\ndiv.qr-code-read-error,\ndiv.qr-code-success {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  text-align: center;\n}\ndiv.available-conflict img,\ndiv.available-conflict svg,\ndiv.qr-code-read-error img,\ndiv.qr-code-read-error svg,\ndiv.qr-code-success img,\ndiv.qr-code-success svg {\n  max-width: 110px;\n}\ndiv.available-conflict strong,\ndiv.available-conflict p,\ndiv.qr-code-read-error strong,\ndiv.qr-code-read-error p,\ndiv.qr-code-success strong,\ndiv.qr-code-success p {\n  color: #484848;\n}\ndiv.available-conflict strong,\ndiv.qr-code-read-error strong,\ndiv.qr-code-success strong {\n  margin-top: 50px;\n  font-size: 28px;\n  line-height: 30px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\ndiv.available-conflict strong small,\ndiv.qr-code-read-error strong small,\ndiv.qr-code-success strong small {\n  font-size: 20px;\n}\ndiv.available-conflict p,\ndiv.qr-code-read-error p,\ndiv.qr-code-success p {\n  font-size: 16px;\n  line-height: 22px;\n  margin: 10px 0px 60px 0px;\n}\ndiv.available-conflict div,\ndiv.qr-code-read-error div,\ndiv.qr-code-success div {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n}\ndiv.available-conflict div button,\ndiv.qr-code-read-error div button,\ndiv.qr-code-success div button {\n  min-width: 140px;\n  margin: 10px;\n  font-size: 13px;\n  padding: 10px 20px;\n  border-radius: 40px;\n}\ndiv.available-conflict div.manage-numbers,\ndiv.qr-code-read-error div.manage-numbers,\ndiv.qr-code-success div.manage-numbers {\n  margin-top: 20px;\n}\ndiv.available-conflict div.manage-numbers a,\ndiv.qr-code-read-error div.manage-numbers a,\ndiv.qr-code-success div.manage-numbers a {\n  margin: 10px;\n  font-size: 14px;\n}\n\n/*# sourceMappingURL=QrCode.vue.map */",
    map: {
      "version": 3,
      "sources": ["E:\\Octadesk\\octa-whatsapp-client\\src\\app\\qr-code\\components\\QrCode.vue", "QrCode.vue"],
      "names": [],
      "mappings": "AAqOA;;;EAGA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;ACpOA;ADqOA;;;;;;EAEA,gBAAA;AC/NA;ADiOA;;;;;;EAEA,cAAA;AC3NA;AD6NA;;;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;ACzNA;AD0NA;;;EACA,eAAA;ACtNA;ADyNA;;;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;ACrNA;ADuNA;;;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;ACnNA;ADoNA;;;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;AChNA;ADkNA;;;EACA,gBAAA;AC9MA;AD+MA;;;EACA,YAAA;EACA,eAAA;AC3MA;;AAEA,qCAAqC",
      "file": "QrCode.vue",
      "sourcesContent": ["<template>\r\n  <div v-if=\"!qrcodeSuccess\" class=\"wpp-scan-code-container\">\r\n    <div\r\n      class=\"available-conflict\"\r\n      v-if=\"'AVAILABLE_CONFLICT' === qrcodeErrorDetails\"\r\n    >\r\n      <img :src=\"require('@/assets/images/alert.png')\" alt=\"alert\" />\r\n\r\n      <strong>\r\n        <span\r\n          v-html=\"\r\n            $t('qrCode.availableConflict.title', {\r\n              phoneNumber: handleParsePhoneNumber(qrcodeError.data.number)\r\n            })\r\n          \"\r\n        />\r\n      </strong>\r\n\r\n      <p>\r\n        {{ $t('qrCode.availableConflict.description') }}\r\n      </p>\r\n\r\n      <div>\r\n        <button\r\n          type=\"button\"\r\n          class=\"btn btn-primary\"\r\n          @click=\"handleResolveConflict(false)\"\r\n        >\r\n          {{ $t('qrCode.availableConflict.button.no') }}\r\n        </button>\r\n\r\n        <button\r\n          type=\"button\"\r\n          class=\"btn btn-primary\"\r\n          @click=\"handleResolveConflict(true)\"\r\n        >\r\n          {{ $t('qrCode.availableConflict.button.yes') }}\r\n        </button>\r\n      </div>\r\n    </div>\r\n\r\n    <template v-else>\r\n      <QrCodeImage @close=\"handleClose\" :contact=\"contact\" />\r\n\r\n      <h3\r\n        v-if=\"!qrcodeError && !createQRCodeError\"\r\n        v-html=\"$t('qrCode.title')\"\r\n      />\r\n\r\n      <h4 v-if=\"!qrcodeError && !createQRCodeError\">\r\n        {{ $t('qrCode.weAreAlmostThere') }}\r\n\r\n        <span v-if=\"contact && contact.name\">\r\n          <br />\r\n          <strong>{{ contact.translate }}</strong>\r\n          <br />\r\n          {{ handleParsePhoneNumber(contact.number) }}\r\n        </span>\r\n      </h4>\r\n\r\n      <div class=\"platforms-terms\" v-if=\"!qrcodeError\">\r\n        <ul>\r\n          <li\r\n            v-for=\"step in ['1', '2', '3']\"\r\n            :key=\"step\"\r\n            v-html=\"$t(`qrCode.wppInstructions.step${step}`)\"\r\n          />\r\n        </ul>\r\n\r\n        <p v-html=\"$t('qrCode.wppInstructions.whatsAppTerms')\" />\r\n      </div>\r\n    </template>\r\n  </div>\r\n\r\n  <div v-else class=\"qr-code-success\">\r\n    <IconTick />\r\n\r\n    <strong>{{ $t('qrCode.successReadQrCode.title') }}</strong>\r\n\r\n    <p>{{ $t('qrCode.successReadQrCode.description') }}</p>\r\n\r\n    <div>\r\n      <button\r\n        type=\"button\"\r\n        class=\"btn btn-primary start-use\"\r\n        @click=\"goToChatList()\"\r\n      >\r\n        {{ $t('qrCode.successReadQrCode.button.start') }}\r\n      </button>\r\n    </div>\r\n\r\n    <div class=\"manage-numbers\">\r\n      <a @click=\"handleCreateNew\">\r\n        {{ $t('qrCode.successReadQrCode.button.anotherNumber') }}\r\n      </a>\r\n\r\n      <a @click=\"handleClose\">\r\n        {{ $t('qrCode.successReadQrCode.button.manageNumbers') }}\r\n      </a>\r\n    </div>\r\n  </div>\r\n</template>\r\n\r\n<script>\r\n  import { mapActions } from 'vuex'\r\n\r\n  import { IconTick } from '@/app/multi-color-icons'\r\n\r\n  import QrCodeImage from './QrCodeImage'\r\n\r\n  import QrCodeMixins from '../mixins'\r\n\r\n  import GlobalMixins from '@/app/mixins'\r\n\r\n  import { hubspot } from '@/services'\r\n\r\n  export default {\r\n    props: ['contact'],\r\n    components: {\r\n      IconTick,\r\n      QrCodeImage\r\n    },\r\n    mixins: [QrCodeMixins, GlobalMixins],\r\n    data() {\r\n      return {\r\n        qrcodeId: undefined,\r\n        createQRCodeError: false,\r\n        timeout: 15,\r\n        success: false,\r\n        qrcodeError: undefined,\r\n        qrcodeErrorDetails: undefined,\r\n        qrcodeSuccess: undefined,\r\n        wppUserLogged: {},\r\n        wppSubDomainStatus: {}\r\n      }\r\n    },\r\n    watch: {\r\n      qrcodeSuccess(success) {\r\n        if (success) {\r\n          this.trackEvent({\r\n            name: 'qrcode successful',\r\n            sendToGa: true,\r\n            properties: [{ name: 'configLocation', value: 'setup' }]\r\n          })\r\n          this.trackEvent({\r\n            name: 'qrcode successful',\r\n            new_analytics: true\r\n          })\r\n\r\n          if (this.wppUserLogged) {\r\n            if (this.wppSubDomainStatus && this.wppSubDomainStatus.isTrial) {\r\n              const companySubDomain = this.wppUserLogged.subDomain\r\n\r\n              const whatsapp = JSON.parse(success)\r\n\r\n              const contactObj = {\r\n                fields: [\r\n                  { name: 'email', value: this.wppUserLogged.email },\r\n                  { name: 'company_subdmain', value: companySubDomain },\r\n                  { name: 'whatsapp_habilitado', value: 'sim' },\r\n                  { name: 'whatsapp_numero', value: whatsapp.number.toString() }\r\n                ]\r\n              }\r\n\r\n              hubspot.submitForm(contactObj)\r\n            }\r\n          }\r\n        }\r\n      }\r\n    },\r\n    mounted() {\r\n      this.unsubscribe = this.$store.subscribe((mutation, state) => {\r\n        this.qrcodeError = state.qrcode.qrcodeError\r\n\r\n        if (this.qrcodeError) {\r\n          this.trackEvent({\r\n            name: 'qrcode fail',\r\n            sendToGa: true,\r\n            properties: [\r\n              { name: 'failReason', value: this.qrcodeError.message },\r\n              { name: 'configLocation', value: 'setup' }\r\n            ]\r\n          })\r\n        }\r\n\r\n        this.qrcodeErrorDetails = state.qrcode.qrcodeErrorDetails\r\n\r\n        this.qrcodeSuccess = state.qrcode.qrcodeSuccess\r\n\r\n        this.wppUserLogged = state.wppUserLogged\r\n\r\n        this.wppSubDomainStatus = state.wppSubDomainStatus\r\n      })\r\n    },\r\n    methods: {\r\n      ...mapActions(['trackEvent']),\r\n      goToChatList() {\r\n        this.handleClose()\r\n\r\n        window.top.location.href =\r\n          '/home/appLinks/appLink/adfe05df-0e04-43ec-b196-fb4e07b72f6b/'\r\n      },\r\n      handleClose() {\r\n        this.$emit('close')\r\n      },\r\n      handleCreateNew() {\r\n        this.$emit('createNew')\r\n      },\r\n      handleResolveConflict(confirmed) {\r\n        this.trackEvent({\r\n          name: 'qrcode in use',\r\n          sendToGa: true,\r\n          properties: [\r\n            { name: 'configLocation', value: 'setup' },\r\n            { name: 'changeCompanyOwner', value: confirmed.toString() }\r\n          ]\r\n        })\r\n\r\n        this.confirmQRCodeOverrideWS({ confirmed })\r\n\r\n        if (!confirmed) {\r\n          this.handleClose()\r\n        }\r\n      }\r\n    }\r\n  }\r\n</script>\r\n\r\n<style lang=\"scss\">\r\n  div.available-conflict,\r\n  div.qr-code-read-error,\r\n  div.qr-code-success {\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex-direction: column;\r\n    text-align: center;\r\n    img,\r\n    svg {\r\n      max-width: 110px;\r\n    }\r\n    strong,\r\n    p {\r\n      color: #484848;\r\n    }\r\n    strong {\r\n      margin-top: 50px;\r\n      font-size: 28px;\r\n      line-height: 30px;\r\n      display: flex;\r\n      justify-content: center;\r\n      align-items: center;\r\n      flex-direction: column;\r\n      small {\r\n        font-size: 20px;\r\n      }\r\n    }\r\n    p {\r\n      font-size: 16px;\r\n      line-height: 22px;\r\n      margin: 10px 0px 60px 0px;\r\n    }\r\n    div {\r\n      width: 100%;\r\n      display: flex;\r\n      justify-content: center;\r\n      align-items: center;\r\n      flex-wrap: wrap;\r\n      button {\r\n        min-width: 140px;\r\n        margin: 10px;\r\n        font-size: 13px;\r\n        padding: 10px 20px;\r\n        border-radius: 40px;\r\n      }\r\n      &.manage-numbers {\r\n        margin-top: 20px;\r\n        a {\r\n          margin: 10px;\r\n          font-size: 14px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n</style>\r\n\r\n<style scoped lang=\"scss\">\r\n  h3,\r\n  h4 {\r\n    width: 100%;\r\n    text-align: center;\r\n    color: #484848;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex-direction: column;\r\n    svg {\r\n      width: 70px;\r\n      height: 70px;\r\n    }\r\n  }\r\n  h3 {\r\n    font-size: 30px;\r\n    line-height: 49px;\r\n    margin: 0px;\r\n    font-weight: bold;\r\n  }\r\n  h4 {\r\n    font-size: 16px;\r\n    line-height: 20px;\r\n    margin: 0px 0px 20px 0px;\r\n    font-weight: normal;\r\n  }\r\n  div.wpp-scan-code-container div.platforms-terms {\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: flex-start;\r\n    flex-wrap: wrap;\r\n    ul {\r\n      width: 100%;\r\n      text-align: center;\r\n      list-style: none;\r\n      margin-bottom: 20px;\r\n      li {\r\n        font-size: 14px;\r\n        line-height: 22px;\r\n        text-align: center;\r\n        color: #666;\r\n        margin-bottom: 5px;\r\n        &:first-child {\r\n          font-weight: bold;\r\n        }\r\n      }\r\n    }\r\n    & > p {\r\n      width: 100%;\r\n      text-align: center;\r\n      font-size: 14px;\r\n      line-height: 22px;\r\n      margin-bottom: 0px;\r\n    }\r\n  }\r\n  div.number-modal-success-container {\r\n    height: 645px;\r\n    max-height: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    button {\r\n      padding: 7px 10px;\r\n      color: #ffffff;\r\n      box-shadow: 0 0 8px rgba(0, 0, 0, 0.14);\r\n      border-radius: 25px;\r\n      min-width: 135px;\r\n      height: 40px;\r\n      font-size: 14px;\r\n      line-height: 16px;\r\n      font-weight: 700;\r\n      border: none;\r\n      cursor: pointer;\r\n      margin-bottom: 25px;\r\n      background-color: #3393d4;\r\n    }\r\n    a {\r\n      color: #328dcb;\r\n      font-size: 15px;\r\n      cursor: pointer;\r\n      text-decoration: none;\r\n      &:hover {\r\n        color: #235579;\r\n      }\r\n    }\r\n  }\r\n</style>\r\n", "div.available-conflict,\ndiv.qr-code-read-error,\ndiv.qr-code-success {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  text-align: center;\n}\ndiv.available-conflict img,\ndiv.available-conflict svg,\ndiv.qr-code-read-error img,\ndiv.qr-code-read-error svg,\ndiv.qr-code-success img,\ndiv.qr-code-success svg {\n  max-width: 110px;\n}\ndiv.available-conflict strong,\ndiv.available-conflict p,\ndiv.qr-code-read-error strong,\ndiv.qr-code-read-error p,\ndiv.qr-code-success strong,\ndiv.qr-code-success p {\n  color: #484848;\n}\ndiv.available-conflict strong,\ndiv.qr-code-read-error strong,\ndiv.qr-code-success strong {\n  margin-top: 50px;\n  font-size: 28px;\n  line-height: 30px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\ndiv.available-conflict strong small,\ndiv.qr-code-read-error strong small,\ndiv.qr-code-success strong small {\n  font-size: 20px;\n}\ndiv.available-conflict p,\ndiv.qr-code-read-error p,\ndiv.qr-code-success p {\n  font-size: 16px;\n  line-height: 22px;\n  margin: 10px 0px 60px 0px;\n}\ndiv.available-conflict div,\ndiv.qr-code-read-error div,\ndiv.qr-code-success div {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n}\ndiv.available-conflict div button,\ndiv.qr-code-read-error div button,\ndiv.qr-code-success div button {\n  min-width: 140px;\n  margin: 10px;\n  font-size: 13px;\n  padding: 10px 20px;\n  border-radius: 40px;\n}\ndiv.available-conflict div.manage-numbers,\ndiv.qr-code-read-error div.manage-numbers,\ndiv.qr-code-success div.manage-numbers {\n  margin-top: 20px;\n}\ndiv.available-conflict div.manage-numbers a,\ndiv.qr-code-read-error div.manage-numbers a,\ndiv.qr-code-success div.manage-numbers a {\n  margin: 10px;\n  font-size: 14px;\n}\n\n/*# sourceMappingURL=QrCode.vue.map */"]
    },
    media: undefined
  }), inject("data-v-3fa6dbe6_1", {
    source: "h3[data-v-3fa6dbe6],\nh4[data-v-3fa6dbe6] {\n  width: 100%;\n  text-align: center;\n  color: #484848;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\nh3 svg[data-v-3fa6dbe6],\nh4 svg[data-v-3fa6dbe6] {\n  width: 70px;\n  height: 70px;\n}\nh3[data-v-3fa6dbe6] {\n  font-size: 30px;\n  line-height: 49px;\n  margin: 0px;\n  font-weight: bold;\n}\nh4[data-v-3fa6dbe6] {\n  font-size: 16px;\n  line-height: 20px;\n  margin: 0px 0px 20px 0px;\n  font-weight: normal;\n}\ndiv.wpp-scan-code-container div.platforms-terms[data-v-3fa6dbe6] {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  flex-wrap: wrap;\n}\ndiv.wpp-scan-code-container div.platforms-terms ul[data-v-3fa6dbe6] {\n  width: 100%;\n  text-align: center;\n  list-style: none;\n  margin-bottom: 20px;\n}\ndiv.wpp-scan-code-container div.platforms-terms ul li[data-v-3fa6dbe6] {\n  font-size: 14px;\n  line-height: 22px;\n  text-align: center;\n  color: #666;\n  margin-bottom: 5px;\n}\ndiv.wpp-scan-code-container div.platforms-terms ul li[data-v-3fa6dbe6]:first-child {\n  font-weight: bold;\n}\ndiv.wpp-scan-code-container div.platforms-terms > p[data-v-3fa6dbe6] {\n  width: 100%;\n  text-align: center;\n  font-size: 14px;\n  line-height: 22px;\n  margin-bottom: 0px;\n}\ndiv.number-modal-success-container[data-v-3fa6dbe6] {\n  height: 645px;\n  max-height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\ndiv.number-modal-success-container button[data-v-3fa6dbe6] {\n  padding: 7px 10px;\n  color: #ffffff;\n  box-shadow: 0 0 8px rgba(0, 0, 0, 0.14);\n  border-radius: 25px;\n  min-width: 135px;\n  height: 40px;\n  font-size: 14px;\n  line-height: 16px;\n  font-weight: 700;\n  border: none;\n  cursor: pointer;\n  margin-bottom: 25px;\n  background-color: #3393d4;\n}\ndiv.number-modal-success-container a[data-v-3fa6dbe6] {\n  color: #328dcb;\n  font-size: 15px;\n  cursor: pointer;\n  text-decoration: none;\n}\ndiv.number-modal-success-container a[data-v-3fa6dbe6]:hover {\n  color: #235579;\n}\n\n/*# sourceMappingURL=QrCode.vue.map */",
    map: {
      "version": 3,
      "sources": ["E:\\Octadesk\\octa-whatsapp-client\\src\\app\\qr-code\\components\\QrCode.vue", "QrCode.vue"],
      "names": [],
      "mappings": "AAgSA;;EAEA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AC/RA;ADgSA;;EACA,WAAA;EACA,YAAA;AC7RA;ADgSA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,iBAAA;AC7RA;AD+RA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,mBAAA;AC5RA;AD8RA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,eAAA;AC3RA;AD4RA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AC1RA;AD2RA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;ACzRA;AD0RA;EACA,iBAAA;ACxRA;AD4RA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AC1RA;AD6RA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AC1RA;AD2RA;EACA,iBAAA;EACA,cAAA;EACA,uCAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;ACzRA;AD2RA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,qBAAA;ACzRA;AD0RA;EACA,cAAA;ACxRA;;AAEA,qCAAqC",
      "file": "QrCode.vue",
      "sourcesContent": ["<template>\r\n  <div v-if=\"!qrcodeSuccess\" class=\"wpp-scan-code-container\">\r\n    <div\r\n      class=\"available-conflict\"\r\n      v-if=\"'AVAILABLE_CONFLICT' === qrcodeErrorDetails\"\r\n    >\r\n      <img :src=\"require('@/assets/images/alert.png')\" alt=\"alert\" />\r\n\r\n      <strong>\r\n        <span\r\n          v-html=\"\r\n            $t('qrCode.availableConflict.title', {\r\n              phoneNumber: handleParsePhoneNumber(qrcodeError.data.number)\r\n            })\r\n          \"\r\n        />\r\n      </strong>\r\n\r\n      <p>\r\n        {{ $t('qrCode.availableConflict.description') }}\r\n      </p>\r\n\r\n      <div>\r\n        <button\r\n          type=\"button\"\r\n          class=\"btn btn-primary\"\r\n          @click=\"handleResolveConflict(false)\"\r\n        >\r\n          {{ $t('qrCode.availableConflict.button.no') }}\r\n        </button>\r\n\r\n        <button\r\n          type=\"button\"\r\n          class=\"btn btn-primary\"\r\n          @click=\"handleResolveConflict(true)\"\r\n        >\r\n          {{ $t('qrCode.availableConflict.button.yes') }}\r\n        </button>\r\n      </div>\r\n    </div>\r\n\r\n    <template v-else>\r\n      <QrCodeImage @close=\"handleClose\" :contact=\"contact\" />\r\n\r\n      <h3\r\n        v-if=\"!qrcodeError && !createQRCodeError\"\r\n        v-html=\"$t('qrCode.title')\"\r\n      />\r\n\r\n      <h4 v-if=\"!qrcodeError && !createQRCodeError\">\r\n        {{ $t('qrCode.weAreAlmostThere') }}\r\n\r\n        <span v-if=\"contact && contact.name\">\r\n          <br />\r\n          <strong>{{ contact.translate }}</strong>\r\n          <br />\r\n          {{ handleParsePhoneNumber(contact.number) }}\r\n        </span>\r\n      </h4>\r\n\r\n      <div class=\"platforms-terms\" v-if=\"!qrcodeError\">\r\n        <ul>\r\n          <li\r\n            v-for=\"step in ['1', '2', '3']\"\r\n            :key=\"step\"\r\n            v-html=\"$t(`qrCode.wppInstructions.step${step}`)\"\r\n          />\r\n        </ul>\r\n\r\n        <p v-html=\"$t('qrCode.wppInstructions.whatsAppTerms')\" />\r\n      </div>\r\n    </template>\r\n  </div>\r\n\r\n  <div v-else class=\"qr-code-success\">\r\n    <IconTick />\r\n\r\n    <strong>{{ $t('qrCode.successReadQrCode.title') }}</strong>\r\n\r\n    <p>{{ $t('qrCode.successReadQrCode.description') }}</p>\r\n\r\n    <div>\r\n      <button\r\n        type=\"button\"\r\n        class=\"btn btn-primary start-use\"\r\n        @click=\"goToChatList()\"\r\n      >\r\n        {{ $t('qrCode.successReadQrCode.button.start') }}\r\n      </button>\r\n    </div>\r\n\r\n    <div class=\"manage-numbers\">\r\n      <a @click=\"handleCreateNew\">\r\n        {{ $t('qrCode.successReadQrCode.button.anotherNumber') }}\r\n      </a>\r\n\r\n      <a @click=\"handleClose\">\r\n        {{ $t('qrCode.successReadQrCode.button.manageNumbers') }}\r\n      </a>\r\n    </div>\r\n  </div>\r\n</template>\r\n\r\n<script>\r\n  import { mapActions } from 'vuex'\r\n\r\n  import { IconTick } from '@/app/multi-color-icons'\r\n\r\n  import QrCodeImage from './QrCodeImage'\r\n\r\n  import QrCodeMixins from '../mixins'\r\n\r\n  import GlobalMixins from '@/app/mixins'\r\n\r\n  import { hubspot } from '@/services'\r\n\r\n  export default {\r\n    props: ['contact'],\r\n    components: {\r\n      IconTick,\r\n      QrCodeImage\r\n    },\r\n    mixins: [QrCodeMixins, GlobalMixins],\r\n    data() {\r\n      return {\r\n        qrcodeId: undefined,\r\n        createQRCodeError: false,\r\n        timeout: 15,\r\n        success: false,\r\n        qrcodeError: undefined,\r\n        qrcodeErrorDetails: undefined,\r\n        qrcodeSuccess: undefined,\r\n        wppUserLogged: {},\r\n        wppSubDomainStatus: {}\r\n      }\r\n    },\r\n    watch: {\r\n      qrcodeSuccess(success) {\r\n        if (success) {\r\n          this.trackEvent({\r\n            name: 'qrcode successful',\r\n            sendToGa: true,\r\n            properties: [{ name: 'configLocation', value: 'setup' }]\r\n          })\r\n          this.trackEvent({\r\n            name: 'qrcode successful',\r\n            new_analytics: true\r\n          })\r\n\r\n          if (this.wppUserLogged) {\r\n            if (this.wppSubDomainStatus && this.wppSubDomainStatus.isTrial) {\r\n              const companySubDomain = this.wppUserLogged.subDomain\r\n\r\n              const whatsapp = JSON.parse(success)\r\n\r\n              const contactObj = {\r\n                fields: [\r\n                  { name: 'email', value: this.wppUserLogged.email },\r\n                  { name: 'company_subdmain', value: companySubDomain },\r\n                  { name: 'whatsapp_habilitado', value: 'sim' },\r\n                  { name: 'whatsapp_numero', value: whatsapp.number.toString() }\r\n                ]\r\n              }\r\n\r\n              hubspot.submitForm(contactObj)\r\n            }\r\n          }\r\n        }\r\n      }\r\n    },\r\n    mounted() {\r\n      this.unsubscribe = this.$store.subscribe((mutation, state) => {\r\n        this.qrcodeError = state.qrcode.qrcodeError\r\n\r\n        if (this.qrcodeError) {\r\n          this.trackEvent({\r\n            name: 'qrcode fail',\r\n            sendToGa: true,\r\n            properties: [\r\n              { name: 'failReason', value: this.qrcodeError.message },\r\n              { name: 'configLocation', value: 'setup' }\r\n            ]\r\n          })\r\n        }\r\n\r\n        this.qrcodeErrorDetails = state.qrcode.qrcodeErrorDetails\r\n\r\n        this.qrcodeSuccess = state.qrcode.qrcodeSuccess\r\n\r\n        this.wppUserLogged = state.wppUserLogged\r\n\r\n        this.wppSubDomainStatus = state.wppSubDomainStatus\r\n      })\r\n    },\r\n    methods: {\r\n      ...mapActions(['trackEvent']),\r\n      goToChatList() {\r\n        this.handleClose()\r\n\r\n        window.top.location.href =\r\n          '/home/appLinks/appLink/adfe05df-0e04-43ec-b196-fb4e07b72f6b/'\r\n      },\r\n      handleClose() {\r\n        this.$emit('close')\r\n      },\r\n      handleCreateNew() {\r\n        this.$emit('createNew')\r\n      },\r\n      handleResolveConflict(confirmed) {\r\n        this.trackEvent({\r\n          name: 'qrcode in use',\r\n          sendToGa: true,\r\n          properties: [\r\n            { name: 'configLocation', value: 'setup' },\r\n            { name: 'changeCompanyOwner', value: confirmed.toString() }\r\n          ]\r\n        })\r\n\r\n        this.confirmQRCodeOverrideWS({ confirmed })\r\n\r\n        if (!confirmed) {\r\n          this.handleClose()\r\n        }\r\n      }\r\n    }\r\n  }\r\n</script>\r\n\r\n<style lang=\"scss\">\r\n  div.available-conflict,\r\n  div.qr-code-read-error,\r\n  div.qr-code-success {\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex-direction: column;\r\n    text-align: center;\r\n    img,\r\n    svg {\r\n      max-width: 110px;\r\n    }\r\n    strong,\r\n    p {\r\n      color: #484848;\r\n    }\r\n    strong {\r\n      margin-top: 50px;\r\n      font-size: 28px;\r\n      line-height: 30px;\r\n      display: flex;\r\n      justify-content: center;\r\n      align-items: center;\r\n      flex-direction: column;\r\n      small {\r\n        font-size: 20px;\r\n      }\r\n    }\r\n    p {\r\n      font-size: 16px;\r\n      line-height: 22px;\r\n      margin: 10px 0px 60px 0px;\r\n    }\r\n    div {\r\n      width: 100%;\r\n      display: flex;\r\n      justify-content: center;\r\n      align-items: center;\r\n      flex-wrap: wrap;\r\n      button {\r\n        min-width: 140px;\r\n        margin: 10px;\r\n        font-size: 13px;\r\n        padding: 10px 20px;\r\n        border-radius: 40px;\r\n      }\r\n      &.manage-numbers {\r\n        margin-top: 20px;\r\n        a {\r\n          margin: 10px;\r\n          font-size: 14px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n</style>\r\n\r\n<style scoped lang=\"scss\">\r\n  h3,\r\n  h4 {\r\n    width: 100%;\r\n    text-align: center;\r\n    color: #484848;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex-direction: column;\r\n    svg {\r\n      width: 70px;\r\n      height: 70px;\r\n    }\r\n  }\r\n  h3 {\r\n    font-size: 30px;\r\n    line-height: 49px;\r\n    margin: 0px;\r\n    font-weight: bold;\r\n  }\r\n  h4 {\r\n    font-size: 16px;\r\n    line-height: 20px;\r\n    margin: 0px 0px 20px 0px;\r\n    font-weight: normal;\r\n  }\r\n  div.wpp-scan-code-container div.platforms-terms {\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: flex-start;\r\n    flex-wrap: wrap;\r\n    ul {\r\n      width: 100%;\r\n      text-align: center;\r\n      list-style: none;\r\n      margin-bottom: 20px;\r\n      li {\r\n        font-size: 14px;\r\n        line-height: 22px;\r\n        text-align: center;\r\n        color: #666;\r\n        margin-bottom: 5px;\r\n        &:first-child {\r\n          font-weight: bold;\r\n        }\r\n      }\r\n    }\r\n    & > p {\r\n      width: 100%;\r\n      text-align: center;\r\n      font-size: 14px;\r\n      line-height: 22px;\r\n      margin-bottom: 0px;\r\n    }\r\n  }\r\n  div.number-modal-success-container {\r\n    height: 645px;\r\n    max-height: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    button {\r\n      padding: 7px 10px;\r\n      color: #ffffff;\r\n      box-shadow: 0 0 8px rgba(0, 0, 0, 0.14);\r\n      border-radius: 25px;\r\n      min-width: 135px;\r\n      height: 40px;\r\n      font-size: 14px;\r\n      line-height: 16px;\r\n      font-weight: 700;\r\n      border: none;\r\n      cursor: pointer;\r\n      margin-bottom: 25px;\r\n      background-color: #3393d4;\r\n    }\r\n    a {\r\n      color: #328dcb;\r\n      font-size: 15px;\r\n      cursor: pointer;\r\n      text-decoration: none;\r\n      &:hover {\r\n        color: #235579;\r\n      }\r\n    }\r\n  }\r\n</style>\r\n", "h3,\nh4 {\n  width: 100%;\n  text-align: center;\n  color: #484848;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\nh3 svg,\nh4 svg {\n  width: 70px;\n  height: 70px;\n}\n\nh3 {\n  font-size: 30px;\n  line-height: 49px;\n  margin: 0px;\n  font-weight: bold;\n}\n\nh4 {\n  font-size: 16px;\n  line-height: 20px;\n  margin: 0px 0px 20px 0px;\n  font-weight: normal;\n}\n\ndiv.wpp-scan-code-container div.platforms-terms {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  flex-wrap: wrap;\n}\ndiv.wpp-scan-code-container div.platforms-terms ul {\n  width: 100%;\n  text-align: center;\n  list-style: none;\n  margin-bottom: 20px;\n}\ndiv.wpp-scan-code-container div.platforms-terms ul li {\n  font-size: 14px;\n  line-height: 22px;\n  text-align: center;\n  color: #666;\n  margin-bottom: 5px;\n}\ndiv.wpp-scan-code-container div.platforms-terms ul li:first-child {\n  font-weight: bold;\n}\ndiv.wpp-scan-code-container div.platforms-terms > p {\n  width: 100%;\n  text-align: center;\n  font-size: 14px;\n  line-height: 22px;\n  margin-bottom: 0px;\n}\n\ndiv.number-modal-success-container {\n  height: 645px;\n  max-height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\ndiv.number-modal-success-container button {\n  padding: 7px 10px;\n  color: #ffffff;\n  box-shadow: 0 0 8px rgba(0, 0, 0, 0.14);\n  border-radius: 25px;\n  min-width: 135px;\n  height: 40px;\n  font-size: 14px;\n  line-height: 16px;\n  font-weight: 700;\n  border: none;\n  cursor: pointer;\n  margin-bottom: 25px;\n  background-color: #3393d4;\n}\ndiv.number-modal-success-container a {\n  color: #328dcb;\n  font-size: 15px;\n  cursor: pointer;\n  text-decoration: none;\n}\ndiv.number-modal-success-container a:hover {\n  color: #235579;\n}\n\n/*# sourceMappingURL=QrCode.vue.map */"]
    },
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$e = "data-v-3fa6dbe6";
/* module identifier */

var __vue_module_identifier__$e = undefined;
/* functional template */

var __vue_is_functional_template__$e = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$e = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c,
  staticRenderFns: __vue_staticRenderFns__$c
}, __vue_inject_styles__$e, __vue_script__$a, __vue_scope_id__$e, __vue_is_functional_template__$e, __vue_module_identifier__$e, false, createInjector, undefined, undefined);

var script$b = {
  props: ['editingContact'],
  components: {
    Modal: Modal,
    Animation: __vue_component__$a,
    GenericLoader: __vue_component__$1,
    QrCode: __vue_component__$e
  },
  store: store$2,
  i18n: i18n,
  data: function data() {
    return {
      openModal: true,
      contact: undefined,
      showQrcode: true,
      qrcodeSuccess: false,
      whatsAppReady: false
    };
  },
  methods: _objectSpread2(_objectSpread2({}, mapActions(['getWhatsappNumbers', 'closeQRCodeWS'])), {}, {
    handleCreateNew: function handleCreateNew() {
      this.contact = undefined;
      this.showQrcode = true;
      this.closeQRCodeWS();
      this.getNumbers();
    },
    handleClose: function handleClose() {
      this.$emit('close');
    },
    getNumbers: function getNumbers() {
      var _this = this;

      this.getWhatsappNumbers().then(function () {
        _this.whatsAppReady = true;
      }).catch(function (err) {
        console.error('err getWhatsappNumbers', err);
      });
    }
  }),
  created: function created() {
    this.getNumbers();
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.editingContact) {
      this.contact = _objectSpread2({}, this.editingContact);
    }

    this.$store.subscribe(function (mutation, state) {
      _this2.qrcodeSuccess = state.qrcode.qrcodeSuccess;
    });
  }
};

/* script */
var __vue_script__$b = script$b;
/* template */

var __vue_render__$d = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("Modal", {
    staticClass: "wpp-modal",
    attrs: {
      footer: false,
      header: false
    },
    on: {
      hide: _vm.handleClose
    },
    model: {
      value: _vm.openModal,
      callback: function callback($$v) {
        _vm.openModal = $$v;
      },
      expression: "openModal"
    }
  }, [_c("button", {
    staticClass: "wpp-close-btn",
    attrs: {
      type: "button"
    },
    on: {
      click: _vm.handleClose
    }
  }), _vm._v(" "), _c("Animation", {
    attrs: {
      showQrcode: _vm.showQrcode,
      success: _vm.qrcodeSuccess
    }
  }), _vm._v(" "), _c("div", {
    staticClass: "modal-form-container"
  }, [!_vm.whatsAppReady ? _c("div", {
    staticClass: "wpp-loader-numbers"
  }, [_c("GenericLoader")], 1) : _vm._e(), _vm._v(" "), _vm.whatsAppReady ? _c("QrCode", {
    attrs: {
      contact: _vm.contact
    },
    on: {
      close: _vm.handleClose,
      createNew: _vm.handleCreateNew,
      success: function success($event) {
        _vm.success = true;
      }
    }
  }) : _vm._e()], 1)], 1);
};

var __vue_staticRenderFns__$d = [];
__vue_render__$d._withStripped = true;
/* style */

var __vue_inject_styles__$f = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-25b6b154_0", {
    source: "div.wpp-divider {\n  margin-bottom: 30px;\n}\ndiv.wpp-divider span {\n  background: #328dcb;\n  display: inline-block;\n  width: 30px;\n  height: 3px;\n  margin: 0 auto;\n}\n.modal-open .modal {\n  display: flex !important;\n}\ndiv.wpp-modal {\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  z-index: 5000;\n}\ndiv.wpp-modal div.modal-dialog {\n  width: 100%;\n  height: auto;\n  max-width: 1130px;\n  max-height: calc(100vh - 60px);\n  position: relative;\n  border-radius: 6px;\n  box-shadow: 0 3px 9px rgba(0, 0, 0, 0.15);\n  overflow: hidden;\n  background-color: #fff;\n}\ndiv.wpp-modal div.modal-dialog div.modal-content {\n  max-height: calc(100vh - 60px);\n  overflow: auto;\n}\ndiv.wpp-modal div.modal-dialog div.modal-content div.modal-body {\n  padding: 0px;\n  overflow: auto;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  flex-wrap: wrap;\n  min-height: 560px;\n}\ndiv.wpp-modal div.modal-dialog div.modal-content div.modal-body button.wpp-close-btn {\n  right: 15px;\n  width: 24px;\n  height: 24px;\n  position: absolute;\n  z-index: 10;\n  top: 15px;\n  border: none;\n  cursor: pointer;\n  background: none;\n}\ndiv.wpp-modal div.modal-dialog div.modal-content div.modal-body button.wpp-close-btn:before, div.wpp-modal div.modal-dialog div.modal-content div.modal-body button.wpp-close-btn:after {\n  content: \"\";\n  position: absolute;\n  left: 0px;\n  width: 100%;\n  height: 2px;\n  top: 11px;\n  background: #757575;\n}\ndiv.wpp-modal div.modal-dialog div.modal-content div.modal-body button.wpp-close-btn:before {\n  transform: rotate(-45deg);\n}\ndiv.wpp-modal div.modal-dialog div.modal-content div.modal-body button.wpp-close-btn:after {\n  transform: rotate(45deg);\n}\ndiv.wpp-modal div.modal-dialog div.modal-content div.modal-body div.modal-form-container {\n  position: relative;\n  width: calc(100% - 350px);\n  padding: 0px 5% 15px 5%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n}\ndiv.wpp-modal div.modal-dialog div.modal-content div.modal-body div.modal-form-container div.wpp-loader-numbers {\n  position: relative;\n  width: 256px;\n  height: 256px;\n  display: block;\n  margin: 0 auto;\n}\n@media screen and (max-width: 520px) and (max-height: 520px) {\ndiv.wpp-modal div.modal-dialog div.modal-content div.modal-body div.modal-form-container div.modal-form-container {\n    width: 100%;\n    margin: 0 !important;\n}\n}\n@media screen and (max-height: 520px) {\ndiv.wpp-modal div.modal-dialog div.modal-content div.modal-body div.modal-form-container div.modal-form-container {\n    width: 100%;\n    margin: 0 !important;\n}\n}\n\n/*# sourceMappingURL=Modal.vue.map */",
    map: {
      "version": 3,
      "sources": ["E:\\Octadesk\\octa-whatsapp-client\\src\\app\\modal\\components\\Modal.vue", "Modal.vue"],
      "names": [],
      "mappings": "AAsGA;EACA,mBAAA;ACrGA;ADsGA;EACA,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;ACpGA;ADuGA;EACA,wBAAA;ACpGA;ADsGA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;ACnGA;ADoGA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,8BAAA;EACA,kBAAA;EACA,kBAAA;EACA,yCAAA;EACA,gBAAA;EACA,sBAAA;AClGA;ADmGA;EACA,8BAAA;EACA,cAAA;ACjGA;ADkGA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AChGA;ADiGA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AC/FA;ADgGA;EAEA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;AC/FA;ADiGA;EACA,yBAAA;AC/FA;ADiGA;EACA,wBAAA;AC/FA;ADkGA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AChGA;ADkGA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,cAAA;AChGA;ADkGA;AACA;IACA,WAAA;IACA,oBAAA;AChGE;AACF;ADkGA;AACA;IACA,WAAA;IACA,oBAAA;AChGE;AACF;;AAEA,oCAAoC",
      "file": "Modal.vue",
      "sourcesContent": ["<template>\r\n  <Modal\r\n    class=\"wpp-modal\"\r\n    v-model=\"openModal\"\r\n    @hide=\"handleClose\"\r\n    :footer=\"false\"\r\n    :header=\"false\"\r\n  >\r\n    <button @click=\"handleClose\" type=\"button\" class=\"wpp-close-btn\" />\r\n\r\n    <Animation :showQrcode=\"showQrcode\" :success=\"qrcodeSuccess\" />\r\n\r\n    <div class=\"modal-form-container\">\r\n      <div v-if=\"!whatsAppReady\" class=\"wpp-loader-numbers\">\r\n        <GenericLoader />\r\n      </div>\r\n\r\n      <QrCode\r\n        @close=\"handleClose\"\r\n        @createNew=\"handleCreateNew\"\r\n        @success=\"success = true\"\r\n        :contact=\"contact\"\r\n        v-if=\"whatsAppReady\"\r\n      />\r\n    </div>\r\n  </Modal>\r\n</template>\r\n\r\n<script>\r\n  import { mapActions } from 'vuex'\r\n\r\n  import { Modal } from 'uiv'\r\n\r\n  import Animation from './Animation'\r\n\r\n  import { GenericLoader } from '@/app/shared-components'\r\n\r\n  import QrCode from '@/app/qr-code/components/QrCode'\r\n\r\n  import store from '@/store'\r\n\r\n  import i18n from '@/i18n'\r\n\r\n  export default {\r\n    props: ['editingContact'],\r\n    components: {\r\n      Modal,\r\n      Animation,\r\n      GenericLoader,\r\n      QrCode\r\n    },\r\n    store,\r\n    i18n,\r\n    data() {\r\n      return {\r\n        openModal: true,\r\n        contact: undefined,\r\n        showQrcode: true,\r\n        qrcodeSuccess: false,\r\n        whatsAppReady: false\r\n      }\r\n    },\r\n    methods: {\r\n      ...mapActions(['getWhatsappNumbers', 'closeQRCodeWS']),\r\n      handleCreateNew() {\r\n        this.contact = undefined\r\n\r\n        this.showQrcode = true\r\n\r\n        this.closeQRCodeWS()\r\n\r\n        this.getNumbers()\r\n      },\r\n      handleClose() {\r\n        this.$emit('close')\r\n      },\r\n      getNumbers() {\r\n        this.getWhatsappNumbers()\r\n          .then(() => {\r\n            this.whatsAppReady = true\r\n          })\r\n          .catch(err => {\r\n            console.error('err getWhatsappNumbers', err)\r\n          })\r\n      }\r\n    },\r\n    created() {\r\n      this.getNumbers()\r\n    },\r\n    mounted() {\r\n      if (this.editingContact) {\r\n        this.contact = { ...this.editingContact }\r\n      }\r\n\r\n      this.$store.subscribe((mutation, state) => {\r\n        this.qrcodeSuccess = state.qrcode.qrcodeSuccess\r\n      })\r\n    }\r\n  }\r\n</script>\r\n\r\n<style lang=\"scss\">\r\n  div.wpp-divider {\r\n    margin-bottom: 30px;\r\n    span {\r\n      background: #328dcb;\r\n      display: inline-block;\r\n      width: 30px;\r\n      height: 3px;\r\n      margin: 0 auto;\r\n    }\r\n  }\r\n  .modal-open .modal {\r\n    display: flex !important;\r\n  }\r\n  div.wpp-modal {\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 100vh;\r\n    z-index: 5000;\r\n    div.modal-dialog {\r\n      width: 100%;\r\n      height: auto;\r\n      max-width: 1130px;\r\n      max-height: calc(100vh - 60px);\r\n      position: relative;\r\n      border-radius: 6px;\r\n      box-shadow: 0 3px 9px rgba(0, 0, 0, 0.15);\r\n      overflow: hidden;\r\n      background-color: #fff;\r\n      div.modal-content {\r\n        max-height: calc(100vh - 60px);\r\n        overflow: auto;\r\n        div.modal-body {\r\n          padding: 0px;\r\n          overflow: auto;\r\n          display: flex;\r\n          justify-content: flex-end;\r\n          align-items: center;\r\n          flex-wrap: wrap;\r\n          min-height: 560px;\r\n          button.wpp-close-btn {\r\n            right: 15px;\r\n            width: 24px;\r\n            height: 24px;\r\n            position: absolute;\r\n            z-index: 10;\r\n            top: 15px;\r\n            border: none;\r\n            cursor: pointer;\r\n            background: none;\r\n            &:before,\r\n            &:after {\r\n              content: '';\r\n              position: absolute;\r\n              left: 0px;\r\n              width: 100%;\r\n              height: 2px;\r\n              top: 11px;\r\n              background: #757575;\r\n            }\r\n            &:before {\r\n              transform: rotate(-45deg);\r\n            }\r\n            &:after {\r\n              transform: rotate(45deg);\r\n            }\r\n          }\r\n          div.modal-form-container {\r\n            position: relative;\r\n            width: calc(100% - 350px);\r\n            padding: 0px 5% 15px 5%;\r\n            display: flex;\r\n            justify-content: center;\r\n            align-items: center;\r\n            flex-wrap: wrap;\r\n\r\n            div.wpp-loader-numbers {\r\n              position: relative;\r\n              width: 256px;\r\n              height: 256px;\r\n              display: block;\r\n              margin: 0 auto;\r\n            }\r\n            @media screen and (max-width: 520px) and (max-height: 520px) {\r\n              div.modal-form-container {\r\n                width: 100%;\r\n                margin: 0 !important;\r\n              }\r\n            }\r\n            @media screen and (max-height: 520px) {\r\n              div.modal-form-container {\r\n                width: 100%;\r\n                margin: 0 !important;\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n</style>\r\n", "div.wpp-divider {\n  margin-bottom: 30px;\n}\ndiv.wpp-divider span {\n  background: #328dcb;\n  display: inline-block;\n  width: 30px;\n  height: 3px;\n  margin: 0 auto;\n}\n\n.modal-open .modal {\n  display: flex !important;\n}\n\ndiv.wpp-modal {\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  z-index: 5000;\n}\ndiv.wpp-modal div.modal-dialog {\n  width: 100%;\n  height: auto;\n  max-width: 1130px;\n  max-height: calc(100vh - 60px);\n  position: relative;\n  border-radius: 6px;\n  box-shadow: 0 3px 9px rgba(0, 0, 0, 0.15);\n  overflow: hidden;\n  background-color: #fff;\n}\ndiv.wpp-modal div.modal-dialog div.modal-content {\n  max-height: calc(100vh - 60px);\n  overflow: auto;\n}\ndiv.wpp-modal div.modal-dialog div.modal-content div.modal-body {\n  padding: 0px;\n  overflow: auto;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  flex-wrap: wrap;\n  min-height: 560px;\n}\ndiv.wpp-modal div.modal-dialog div.modal-content div.modal-body button.wpp-close-btn {\n  right: 15px;\n  width: 24px;\n  height: 24px;\n  position: absolute;\n  z-index: 10;\n  top: 15px;\n  border: none;\n  cursor: pointer;\n  background: none;\n}\ndiv.wpp-modal div.modal-dialog div.modal-content div.modal-body button.wpp-close-btn:before, div.wpp-modal div.modal-dialog div.modal-content div.modal-body button.wpp-close-btn:after {\n  content: \"\";\n  position: absolute;\n  left: 0px;\n  width: 100%;\n  height: 2px;\n  top: 11px;\n  background: #757575;\n}\ndiv.wpp-modal div.modal-dialog div.modal-content div.modal-body button.wpp-close-btn:before {\n  transform: rotate(-45deg);\n}\ndiv.wpp-modal div.modal-dialog div.modal-content div.modal-body button.wpp-close-btn:after {\n  transform: rotate(45deg);\n}\ndiv.wpp-modal div.modal-dialog div.modal-content div.modal-body div.modal-form-container {\n  position: relative;\n  width: calc(100% - 350px);\n  padding: 0px 5% 15px 5%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n}\ndiv.wpp-modal div.modal-dialog div.modal-content div.modal-body div.modal-form-container div.wpp-loader-numbers {\n  position: relative;\n  width: 256px;\n  height: 256px;\n  display: block;\n  margin: 0 auto;\n}\n@media screen and (max-width: 520px) and (max-height: 520px) {\n  div.wpp-modal div.modal-dialog div.modal-content div.modal-body div.modal-form-container div.modal-form-container {\n    width: 100%;\n    margin: 0 !important;\n  }\n}\n@media screen and (max-height: 520px) {\n  div.wpp-modal div.modal-dialog div.modal-content div.modal-body div.modal-form-container div.modal-form-container {\n    width: 100%;\n    margin: 0 !important;\n  }\n}\n\n/*# sourceMappingURL=Modal.vue.map */"]
    },
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$f = undefined;
/* module identifier */

var __vue_module_identifier__$f = undefined;
/* functional template */

var __vue_is_functional_template__$f = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$f = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$d,
  staticRenderFns: __vue_staticRenderFns__$d
}, __vue_inject_styles__$f, __vue_script__$b, __vue_scope_id__$f, __vue_is_functional_template__$f, __vue_module_identifier__$f, false, createInjector, undefined, undefined);

var FAILS_ON_PRIMITIVES = fails(function () { objectKeys(1); });

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
_export({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return objectKeys(toObject(it));
  }
});

var WhatsappApiStates;

(function (WhatsappApiStates) {
  WhatsappApiStates[WhatsappApiStates["integrationInfo"] = 1] = "integrationInfo";
  WhatsappApiStates[WhatsappApiStates["profileInfo"] = 2] = "profileInfo";
  WhatsappApiStates[WhatsappApiStates["error"] = 3] = "error";
  WhatsappApiStates[WhatsappApiStates["success"] = 4] = "success";
})(WhatsappApiStates || (WhatsappApiStates = {}));

var script$c = {
  i18n: i18n,
  components: {
    ValidationObserver: ValidationObserver,
    ValidationProvider: ValidationProvider
  },
  mixins: [__vue_component__$b],
  data: function data() {
    return {
      integration: {
        apiKey: '',
        phoneName: ''
      },
      loading: false
    };
  },
  directives: {
    tooltip: tooltip
  },
  methods: _objectSpread2(_objectSpread2({}, mapActions(['setCurrentWhatsappApiState', 'setCurrentWhatsappApiNumber', 'addWhatsappApiNumber', 'trackEvent'])), {}, {
    componenteRef: function componenteRef() {
      return this.$_veeObserver ? this.$_veeObserver.refs : this.$refs;
    },
    isValidField: function isValidField$1(key) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var ref, isValid;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                ref = _this.componenteRef();
                _context.next = 3;
                return isValidField(ref[key].value, ref[key].rules);

              case 3:
                isValid = _context.sent;

                if (!isValid) {
                  ref[key].setErrors("".concat(key, " is invalid field"));
                }

                return _context.abrupt("return", isValid);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    submit: function submit() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var isValidForm, formRef, fields, isValidTrue, index, isValid, response, _response, error;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$refs.observer.validate();

              case 2:
                isValidForm = _context2.sent;
                formRef = _this2.componenteRef();
                fields = Object.keys(formRef);
                isValidTrue = true;
                index = 0;

              case 7:
                if (!(index < fields.length)) {
                  _context2.next = 15;
                  break;
                }

                _context2.next = 10;
                return _this2.isValidField(fields[index]);

              case 10:
                isValid = _context2.sent;

                if (!isValid) {
                  isValidTrue = false;
                }

              case 12:
                index++;
                _context2.next = 7;
                break;

              case 15:
                if (!(!isValidForm || !isValidTrue)) {
                  _context2.next = 17;
                  break;
                }

                return _context2.abrupt("return", false);

              case 17:
                _this2.loading = true;
                _context2.prev = 18;
                _context2.next = 21;
                return _this2.addWhatsappApiNumber();

              case 21:
                response = _context2.sent;

                if (response && response.data) {
                  _this2.setCurrentWhatsappApiNumber({
                    id: response.data.id,
                    privateCustomFields: undefined,
                    number: response.data.number
                  });
                }

                _this2.setCurrentWhatsappApiState(WhatsappApiStates.success);

                _this2.trackEvent({
                  name: 'success add whasapp api number'
                });

                _this2.loading = false;
                _context2.next = 34;
                break;

              case 28:
                _context2.prev = 28;
                _context2.t0 = _context2["catch"](18);

                _this2.setCurrentWhatsappApiState(WhatsappApiStates.error);

                _this2.loading = false;
                _response = _context2.t0.response;

                if (_response && _response.data) {
                  error = _response.data.error;

                  _this2.trackEvent({
                    name: 'failed add whasapp api number',
                    properties: [{
                      name: 'reason',
                      value: error
                    }]
                  });
                }

              case 34:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[18, 28]]);
      }))();
    },
    handleClose: function handleClose() {
      this.$emit('close');
    },
    handleUpdate: function handleUpdate(field) {
      switch (field) {
        case 'apiKey':
          {
            var payload = {
              privateCustomFields: {
                apiKey: this.integration.apiKey
              }
            };
            this.setCurrentWhatsappApiNumber(payload);
            break;
          }

        case 'phoneName':
          {
            var _payload = {
              name: this.integration.phoneName
            };
            this.setCurrentWhatsappApiNumber(_payload);
            break;
          }
      }
    }
  })
};

/* script */
var __vue_script__$c = script$c;
/* template */

var __vue_render__$e = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    staticClass: "integration-info-container",
    class: {
      disabled: _vm.loading
    }
  }, [_c("ValidationObserver", {
    ref: "observer",
    attrs: {
      tag: "form"
    }
  }, [_c("h1", {
    domProps: {
      innerHTML: _vm._s(_vm.$t("whatsappApiModal.integrationInfo.title"))
    }
  }), _vm._v(" "), _c("ValidationProvider", {
    ref: "apiKey",
    attrs: {
      name: "apiKey",
      rules: "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(ref) {
        var errors = ref.errors;
        var valid = ref.valid;
        var dirty = ref.dirty;
        return [_c("div", {
          staticClass: "fields-control-wpp",
          class: [_vm.validationClass({
            errors: errors,
            valid: valid,
            dirty: dirty,
            value: _vm.integration.apiKey
          })]
        }, [_c("label", {
          staticClass: "label-control-wpp"
        }, [_vm._v("\n          " + _vm._s(_vm.$t("whatsappApiModal.integrationInfo.form.apiKey.label")) + "\n        ")]), _vm._v(" "), _c("div", [_c("input", {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: _vm.integration.apiKey,
            expression: "integration.apiKey"
          }],
          class: {
            disabled: _vm.loading
          },
          attrs: {
            type: "text",
            placeholder: _vm.$t("whatsappApiModal.integrationInfo.form.apiKey.placeholder"),
            name: "apiKey"
          },
          domProps: {
            value: _vm.integration.apiKey
          },
          on: {
            blur: function blur($event) {
              return _vm.handleUpdate("apiKey");
            },
            input: function input($event) {
              if ($event.target.composing) {
                return;
              }

              _vm.$set(_vm.integration, "apiKey", $event.target.value);
            }
          }
        })]), _vm._v(" "), errors.length ? _c("span", {
          staticClass: "error-message"
        }, [_vm._v("\n          " + _vm._s(_vm.$t("whatsappApiModal.integrationInfo.form.required")) + "\n        ")]) : _vm._e()])];
      }
    }])
  }), _vm._v(" "), _c("ValidationProvider", {
    ref: "phoneName",
    attrs: {
      name: "phoneName",
      rules: "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(ref) {
        var errors = ref.errors;
        var valid = ref.valid;
        var dirty = ref.dirty;
        return [_c("div", {
          staticClass: "fields-control-wpp",
          class: [_vm.validationClass({
            errors: errors,
            valid: valid,
            dirty: dirty,
            value: _vm.integration.phoneName
          })]
        }, [_c("label", {
          staticClass: "label-control-wpp"
        }, [_vm._v("\n          " + _vm._s(_vm.$t("whatsappApiModal.integrationInfo.form.name.label")) + "\n        ")]), _vm._v(" "), _c("span", {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: _vm.$t("whatsappApiModal.integrationInfo.form.name.tooltip"),
            expression: "$t('whatsappApiModal.integrationInfo.form.name.tooltip')"
          }]
        }, [_vm._v("\n          ?\n        ")]), _vm._v(" "), _c("div", [_c("input", {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: _vm.integration.phoneName,
            expression: "integration.phoneName"
          }],
          class: {
            disabled: _vm.loading
          },
          attrs: {
            type: "text",
            placeholder: _vm.$t("whatsappApiModal.integrationInfo.form.name.placeholder"),
            name: "phoneName"
          },
          domProps: {
            value: _vm.integration.phoneName
          },
          on: {
            blur: function blur($event) {
              return _vm.handleUpdate("phoneName");
            },
            input: function input($event) {
              if ($event.target.composing) {
                return;
              }

              _vm.$set(_vm.integration, "phoneName", $event.target.value);
            }
          }
        })]), _vm._v(" "), errors.length ? _c("span", {
          staticClass: "error-message"
        }, [_vm._v("\n          " + _vm._s(_vm.$t("whatsappApiModal.integrationInfo.form.required")) + "\n        ")]) : _vm._e()])];
      }
    }])
  }), _vm._v(" "), _c("a", {
    staticClass: "integration-info-content-help-link",
    attrs: {
      href: "https://help.octadesk.com/kb/article/cadastrar-whatsapp-api",
      target: "_blank"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("whatsappApiModal.integrationInfo.helpLink")) + "\n    ")]), _vm._v(" "), _c("div", {
    staticClass: "integration-info-footer"
  }, [_c("a", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.loading,
      expression: "!loading"
    }],
    staticClass: "btn-control-wpp link",
    on: {
      click: _vm.handleClose
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("whatsappApiModal.integrationInfo.cancel")) + "\n      ")]), _vm._v(" "), _c("button", {
    staticClass: "btn-control-wpp primary",
    attrs: {
      disabled: _vm.loading,
      type: "submit"
    },
    on: {
      click: function click($event) {
        $event.preventDefault();
        return _vm.submit($event);
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("whatsappApiModal.integrationInfo.add")) + "\n      ")])])], 1)], 1);
};

var __vue_staticRenderFns__$e = [];
__vue_render__$e._withStripped = true;
/* style */

var __vue_inject_styles__$g = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-bc7f45d4_0", {
    source: "div.integration-info-container[data-v-bc7f45d4] {\n  width: 100%;\n  padding-top: 40px;\n}\ndiv.integration-info-container.disabled input[data-v-bc7f45d4] {\n  cursor: not-allowed;\n  color: #bfbfbf;\n  pointer-events: none;\n  background: #f0f0f0;\n}\ndiv.integration-info-container form[data-v-bc7f45d4] {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\ndiv.integration-info-container form h1[data-v-bc7f45d4] {\n  font-family: Helvetica !important;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 16px !important;\n  line-height: 22px;\n  text-align: center;\n  margin-top: 0;\n  margin-bottom: 30px;\n}\ndiv.integration-info-container form > span[data-v-bc7f45d4]:not(:last-child) {\n  margin-bottom: 20px;\n}\ndiv.integration-info-container form > span > div[data-v-bc7f45d4] {\n  width: 330px;\n}\ndiv.integration-info-container form > span > div span[data-v-bc7f45d4]:not(.error-message) {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  z-index: 100000000;\n  top: 0;\n  right: 0;\n  width: 14px;\n  height: 14px;\n  border: 1px solid #2775d3;\n  border-radius: 100%;\n  color: #2775d3;\n  font-size: 10px;\n  font-weight: bold;\n  cursor: default;\n}\ndiv.integration-info-container form a.integration-info-content-help-link[data-v-bc7f45d4] {\n  font-family: Helvetica;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 12px;\n  line-height: 22px;\n  text-align: center;\n  margin: 0 auto;\n  display: inline-block;\n  text-decoration-line: underline;\n  color: #2775d3;\n}\ndiv.integration-info-container form div.integration-info-footer[data-v-bc7f45d4] {\n  width: 100%;\n  padding: 22px 16px 20px 16px;\n  margin-top: 22px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  border-top: 1px solid #d7d7d7;\n}\n\n/*# sourceMappingURL=WhatsappApiIntegrationInfo.vue.map */",
    map: {
      "version": 3,
      "sources": ["E:\\Octadesk\\octa-whatsapp-client\\src\\app\\whatsapp-api\\components\\modal\\WhatsappApiIntegrationInfo.vue", "WhatsappApiIntegrationInfo.vue"],
      "names": [],
      "mappings": "AAoQA;EACA,WAAA;EACA,iBAAA;ACnQA;ADoQA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;AClQA;ADoQA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AClQA;ADmQA;EACA,iCAAA;EACA,kBAAA;EACA,mBAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;ACjQA;ADoQA;EACA,mBAAA;AClQA;ADoQA;EACA,YAAA;AClQA;ADmQA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;ACjQA;ADqQA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,qBAAA;EACA,+BAAA;EACA,cAAA;ACnQA;ADqQA;EACA,WAAA;EACA,4BAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,6BAAA;ACnQA;;AAEA,yDAAyD",
      "file": "WhatsappApiIntegrationInfo.vue",
      "sourcesContent": ["<template>\r\n  <div class=\"integration-info-container\" :class=\"{ disabled: loading }\">\r\n    <ValidationObserver ref=\"observer\" tag=\"form\">\r\n      <h1 v-html=\"$t('whatsappApiModal.integrationInfo.title')\" />\r\n\r\n      <ValidationProvider\r\n        v-slot=\"{ errors, valid, dirty }\"\r\n        name=\"apiKey\"\r\n        rules=\"required\"\r\n        ref=\"apiKey\"\r\n      >\r\n        <div\r\n          class=\"fields-control-wpp\"\r\n          :class=\"[\r\n            validationClass({\r\n              errors,\r\n              valid,\r\n              dirty,\r\n              value: integration.apiKey\r\n            })\r\n          ]\"\r\n        >\r\n          <label class=\"label-control-wpp\">\r\n            {{ $t('whatsappApiModal.integrationInfo.form.apiKey.label') }}\r\n          </label>\r\n\r\n          <div>\r\n            <input\r\n              v-model=\"integration.apiKey\"\r\n              type=\"text\"\r\n              :placeholder=\"\r\n                $t('whatsappApiModal.integrationInfo.form.apiKey.placeholder')\r\n              \"\r\n              name=\"apiKey\"\r\n              :class=\"{ disabled: loading }\"\r\n              @blur=\"handleUpdate('apiKey')\"\r\n            />\r\n          </div>\r\n\r\n          <span v-if=\"errors.length\" class=\"error-message\">\r\n            {{ $t('whatsappApiModal.integrationInfo.form.required') }}\r\n          </span>\r\n        </div>\r\n      </ValidationProvider>\r\n\r\n      <ValidationProvider\r\n        v-slot=\"{ errors, valid, dirty }\"\r\n        name=\"phoneName\"\r\n        rules=\"required\"\r\n        ref=\"phoneName\"\r\n      >\r\n        <div\r\n          class=\"fields-control-wpp\"\r\n          :class=\"[\r\n            validationClass({\r\n              errors,\r\n              valid,\r\n              dirty,\r\n              value: integration.phoneName\r\n            })\r\n          ]\"\r\n        >\r\n          <label class=\"label-control-wpp\">\r\n            {{ $t('whatsappApiModal.integrationInfo.form.name.label') }}\r\n          </label>\r\n\r\n          <span\r\n            v-tooltip=\"$t('whatsappApiModal.integrationInfo.form.name.tooltip')\"\r\n          >\r\n            ?\r\n          </span>\r\n\r\n          <div>\r\n            <input\r\n              v-model=\"integration.phoneName\"\r\n              type=\"text\"\r\n              :placeholder=\"\r\n                $t('whatsappApiModal.integrationInfo.form.name.placeholder')\r\n              \"\r\n              name=\"phoneName\"\r\n              :class=\"{ disabled: loading }\"\r\n              @blur=\"handleUpdate('phoneName')\"\r\n            />\r\n          </div>\r\n\r\n          <span v-if=\"errors.length\" class=\"error-message\">\r\n            {{ $t('whatsappApiModal.integrationInfo.form.required') }}\r\n          </span>\r\n        </div>\r\n      </ValidationProvider>\r\n\r\n      <a\r\n        href=\"https://help.octadesk.com/kb/article/cadastrar-whatsapp-api\"\r\n        target=\"_blank\"\r\n        class=\"integration-info-content-help-link\"\r\n      >\r\n        {{ $t('whatsappApiModal.integrationInfo.helpLink') }}\r\n      </a>\r\n\r\n      <div class=\"integration-info-footer\">\r\n        <a class=\"btn-control-wpp link\" v-show=\"!loading\" @click=\"handleClose\">\r\n          {{ $t('whatsappApiModal.integrationInfo.cancel') }}\r\n        </a>\r\n\r\n        <button\r\n          class=\"btn-control-wpp primary\"\r\n          :disabled=\"loading\"\r\n          type=\"submit\"\r\n          @click.prevent=\"submit\"\r\n        >\r\n          {{ $t('whatsappApiModal.integrationInfo.add') }}\r\n        </button>\r\n      </div>\r\n    </ValidationObserver>\r\n  </div>\r\n</template>\r\n\r\n<script>\r\n  import { mapActions } from 'vuex'\r\n\r\n  import GlobalMixins from '@/app/mixins'\r\n\r\n  import { ValidationObserver, ValidationProvider } from 'vee-validate'\r\n\r\n  import { WhatsappApiStates } from '@/helpers/enums'\r\n\r\n  import i18n from '@/i18n'\r\n\r\n  import { tooltip } from 'uiv'\r\n\r\n  import { validations } from '@/helpers'\r\n\r\n  export default {\r\n    i18n,\r\n    components: {\r\n      ValidationObserver,\r\n      ValidationProvider\r\n    },\r\n    mixins: [GlobalMixins],\r\n    data() {\r\n      return {\r\n        integration: {\r\n          apiKey: '',\r\n          phoneName: ''\r\n        },\r\n        loading: false\r\n      }\r\n    },\r\n    directives: {\r\n      tooltip\r\n    },\r\n    methods: {\r\n      ...mapActions([\r\n        'setCurrentWhatsappApiState',\r\n        'setCurrentWhatsappApiNumber',\r\n        'addWhatsappApiNumber',\r\n        'trackEvent'\r\n      ]),\r\n      componenteRef() {\r\n        return this.$_veeObserver ? this.$_veeObserver.refs : this.$refs\r\n      },\r\n      async isValidField(key) {\r\n        const ref = this.componenteRef()\r\n\r\n        const isValid = await validations.isValidField(\r\n          ref[key].value,\r\n          ref[key].rules\r\n        )\r\n\r\n        if (!isValid) {\r\n          ref[key].setErrors(`${key} is invalid field`)\r\n        }\r\n\r\n        return isValid\r\n      },\r\n      async submit() {\r\n        const isValidForm = await this.$refs.observer.validate()\r\n\r\n        const formRef = this.componenteRef()\r\n\r\n        const fields = Object.keys(formRef)\r\n\r\n        let isValidTrue = true\r\n\r\n        for (let index = 0; index < fields.length; index++) {\r\n          const isValid = await this.isValidField(fields[index])\r\n\r\n          if (!isValid) {\r\n            isValidTrue = false\r\n          }\r\n        }\r\n\r\n        if (!isValidForm || !isValidTrue) {\r\n          return false\r\n        }\r\n\r\n        this.loading = true\r\n\r\n        try {\r\n          const response = await this.addWhatsappApiNumber()\r\n\r\n          if (response && response.data) {\r\n            this.setCurrentWhatsappApiNumber({\r\n              id: response.data.id,\r\n              privateCustomFields: undefined,\r\n              number: response.data.number\r\n            })\r\n          }\r\n\r\n          this.setCurrentWhatsappApiState(WhatsappApiStates.success)\r\n\r\n          this.trackEvent({ name: 'success add whasapp api number' })\r\n\r\n          this.loading = false\r\n        } catch (ex) {\r\n          this.setCurrentWhatsappApiState(WhatsappApiStates.error)\r\n\r\n          this.loading = false\r\n\r\n          const { response } = ex\r\n\r\n          if (response && response.data) {\r\n            const { error } = response.data\r\n\r\n            this.trackEvent({\r\n              name: 'failed add whasapp api number',\r\n              properties: [{ name: 'reason', value: error }]\r\n            })\r\n          }\r\n        }\r\n      },\r\n      handleClose() {\r\n        this.$emit('close')\r\n      },\r\n      handleUpdate(field) {\r\n        switch (field) {\r\n          case 'apiKey': {\r\n            const payload = {\r\n              privateCustomFields: { apiKey: this.integration.apiKey }\r\n            }\r\n\r\n            this.setCurrentWhatsappApiNumber(payload)\r\n\r\n            break\r\n          }\r\n\r\n          case 'phoneName': {\r\n            const payload = { name: this.integration.phoneName }\r\n\r\n            this.setCurrentWhatsappApiNumber(payload)\r\n\r\n            break\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n</script>\r\n\r\n<style lang=\"scss\" scoped>\r\n  div.integration-info-container {\r\n    width: 100%;\r\n    padding-top: 40px;\r\n    &.disabled input {\r\n      cursor: not-allowed;\r\n      color: #bfbfbf;\r\n      pointer-events: none;\r\n      background: #f0f0f0;\r\n    }\r\n    form {\r\n      width: 100%;\r\n      display: flex;\r\n      flex-direction: column;\r\n      align-items: center;\r\n      justify-content: center;\r\n      h1 {\r\n        font-family: Helvetica !important;\r\n        font-style: normal;\r\n        font-weight: normal;\r\n        font-size: 16px !important;\r\n        line-height: 22px;\r\n        text-align: center;\r\n        margin-top: 0;\r\n        margin-bottom: 30px;\r\n      }\r\n      & > span {\r\n        &:not(:last-child) {\r\n          margin-bottom: 20px;\r\n        }\r\n        & > div {\r\n          width: 330px;\r\n          span:not(.error-message) {\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n            position: absolute;\r\n            z-index: 100000000;\r\n            top: 0;\r\n            right: 0;\r\n            width: 14px;\r\n            height: 14px;\r\n            border: 1px solid #2775d3;\r\n            border-radius: 100%;\r\n            color: #2775d3;\r\n            font-size: 10px;\r\n            font-weight: bold;\r\n            cursor: default;\r\n          }\r\n        }\r\n      }\r\n      a.integration-info-content-help-link {\r\n        font-family: Helvetica;\r\n        font-style: normal;\r\n        font-weight: normal;\r\n        font-size: 12px;\r\n        line-height: 22px;\r\n        text-align: center;\r\n        margin: 0 auto;\r\n        display: inline-block;\r\n        text-decoration-line: underline;\r\n        color: #2775d3;\r\n      }\r\n      div.integration-info-footer {\r\n        width: 100%;\r\n        padding: 22px 16px 20px 16px;\r\n        margin-top: 22px;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: flex-end;\r\n        border-top: 1px solid #d7d7d7;\r\n      }\r\n    }\r\n  }\r\n</style>\r\n", "div.integration-info-container {\n  width: 100%;\n  padding-top: 40px;\n}\ndiv.integration-info-container.disabled input {\n  cursor: not-allowed;\n  color: #bfbfbf;\n  pointer-events: none;\n  background: #f0f0f0;\n}\ndiv.integration-info-container form {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\ndiv.integration-info-container form h1 {\n  font-family: Helvetica !important;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 16px !important;\n  line-height: 22px;\n  text-align: center;\n  margin-top: 0;\n  margin-bottom: 30px;\n}\ndiv.integration-info-container form > span:not(:last-child) {\n  margin-bottom: 20px;\n}\ndiv.integration-info-container form > span > div {\n  width: 330px;\n}\ndiv.integration-info-container form > span > div span:not(.error-message) {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  z-index: 100000000;\n  top: 0;\n  right: 0;\n  width: 14px;\n  height: 14px;\n  border: 1px solid #2775d3;\n  border-radius: 100%;\n  color: #2775d3;\n  font-size: 10px;\n  font-weight: bold;\n  cursor: default;\n}\ndiv.integration-info-container form a.integration-info-content-help-link {\n  font-family: Helvetica;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 12px;\n  line-height: 22px;\n  text-align: center;\n  margin: 0 auto;\n  display: inline-block;\n  text-decoration-line: underline;\n  color: #2775d3;\n}\ndiv.integration-info-container form div.integration-info-footer {\n  width: 100%;\n  padding: 22px 16px 20px 16px;\n  margin-top: 22px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  border-top: 1px solid #d7d7d7;\n}\n\n/*# sourceMappingURL=WhatsappApiIntegrationInfo.vue.map */"]
    },
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$g = "data-v-bc7f45d4";
/* module identifier */

var __vue_module_identifier__$g = undefined;
/* functional template */

var __vue_is_functional_template__$g = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$g = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$e,
  staticRenderFns: __vue_staticRenderFns__$e
}, __vue_inject_styles__$g, __vue_script__$c, __vue_scope_id__$g, __vue_is_functional_template__$g, __vue_module_identifier__$g, false, createInjector, undefined, undefined);

//
var script$d = {
  mixins: [__vue_component__$b],
  data: function data() {
    return {
      currentWppApiState: undefined,
      currentWppApiPreviousState: undefined
    };
  },
  computed: {
    title: function title() {
      if (this.currentWppApiState === WhatsappApiStates.success) {
        if (this.currentWppApiPreviousState === WhatsappApiStates.integrationInfo) {
          return this.$t('whatsappApiModal.responseStates.success.integrationInfo.title');
        } else if (this.currentWppApiPreviousState === WhatsappApiStates.profileInfo) {
          return this.$t('whatsappApiModal.responseStates.success.profileInfo.title');
        }
      } else {
        if (this.currentWppApiPreviousState === WhatsappApiStates.integrationInfo) {
          return this.$t('whatsappApiModal.responseStates.error.integrationInfo.title');
        } else if (this.currentWppApiPreviousState === WhatsappApiStates.profileInfo) {
          return this.$t('whatsappApiModal.responseStates.error.profileInfo.title');
        }
      }

      return '';
    },
    message: function message() {
      if (this.currentWppApiState === WhatsappApiStates.success) {
        if (this.currentWppApiPreviousState === WhatsappApiStates.integrationInfo) {
          return this.$t('whatsappApiModal.responseStates.success.integrationInfo.message');
        } else if (this.currentWppApiPreviousState === WhatsappApiStates.profileInfo) {
          return this.$t('whatsappApiModal.responseStates.success.profileInfo.message');
        }
      } else {
        return this.$t('whatsappApiModal.responseStates.error.message');
      }

      return '';
    },
    WhatsappApiStates: function WhatsappApiStates$1() {
      return WhatsappApiStates;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.unwatch = this.$store.watch(function (state, getters) {
      _this.currentWppApiState = getters.currentWppApiState;
      _this.currentWppApiPreviousState = getters.currentWppApiPreviousState;
    });
  }
};

/* script */
var __vue_script__$d = script$d;
/* template */

var __vue_render__$f = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    staticClass: "response-state-container"
  }, [_c("button", {
    staticClass: "wpp-close-btn",
    attrs: {
      type: "button"
    },
    on: {
      click: function click($event) {
        return _vm.$emit("close");
      }
    }
  }), _vm._v(" "), _c("div", {
    staticClass: "response-state-content"
  }, [_c("span", {
    class: "icon-wp-" + (_vm.currentWppApiState === _vm.WhatsappApiStates.error ? "error" : "check-circle")
  }), _vm._v(" "), _c("div", [_c("h1", [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]), _vm._v(" "), _c("p", {
    domProps: {
      innerHTML: _vm._s(_vm.message)
    }
  })])]), _vm._v(" "), _vm.currentWppApiState === _vm.WhatsappApiStates.success && _vm.currentWppApiPreviousState === _vm.WhatsappApiStates.integrationInfo ? _c("div", {
    staticClass: "response-state-footer"
  }, [_c("button", {
    staticClass: "btn-control-wpp outline",
    on: {
      click: function click($event) {
        return _vm.$emit("secondary-action");
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("whatsappApiModal.responseStates.success.integrationInfo.footer.secondary")) + "\n    ")]), _vm._v(" "), _c("button", {
    staticClass: "btn-control-wpp primary",
    on: {
      click: function click($event) {
        return _vm.$emit("primary-action");
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("whatsappApiModal.responseStates.success.integrationInfo.footer.primary")) + "\n    ")])]) : _vm.currentWppApiState === _vm.WhatsappApiStates.error ? _c("div", {
    staticClass: "response-state-footer"
  }, [_c("button", {
    staticClass: "btn-control-wpp outline",
    on: {
      click: function click($event) {
        return _vm.$emit("secondary-action");
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("whatsappApiModal.responseStates.error.footer.secondary")) + "\n    ")]), _vm._v(" "), _c("button", {
    staticClass: "btn-control-wpp primary",
    on: {
      click: function click($event) {
        return _vm.$emit("primary-action");
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("whatsappApiModal.responseStates.error.footer.primary")) + "\n    ")])]) : _vm._e()]);
};

var __vue_staticRenderFns__$f = [];
__vue_render__$f._withStripped = true;
/* style */

var __vue_inject_styles__$h = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-32141657_0", {
    source: "div.response-state-container[data-v-32141657] {\n  width: 100%;\n  padding: 50px 40px;\n}\ndiv.response-state-container div.response-state-content[data-v-32141657] {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\ndiv.response-state-container div.response-state-content > span[data-v-32141657] {\n  font-size: 64px;\n  margin-right: 20px;\n}\ndiv.response-state-container div.response-state-content > span.icon-wp-check-circle[data-v-32141657] {\n  color: #1bdd85;\n}\ndiv.response-state-container div.response-state-content > span.icon-wp-error[data-v-32141657] {\n  color: #ef2066;\n}\ndiv.response-state-container div.response-state-content > div[data-v-32141657] {\n  text-align: left;\n}\ndiv.response-state-container div.response-state-content > div h1[data-v-32141657] {\n  font-family: \"Niveau Grotesk\";\n  font-style: normal;\n  font-weight: bold;\n  font-size: 25px;\n  line-height: 29px;\n  color: #072a54;\n}\ndiv.response-state-container div.response-state-content > div p[data-v-32141657] {\n  font-family: Helvetica;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 22px;\n  color: #4c4c4c;\n}\ndiv.response-state-container div.response-state-footer[data-v-32141657] {\n  width: calc(100% + 80px);\n  padding: 18px 40px 0px 0px;\n  margin-top: 60px;\n  margin-left: -40px;\n  margin-bottom: -32px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  border-top: 1px solid #d7d7d7;\n}\ndiv.response-state-container div.response-state-footer button[data-v-32141657]:first-child {\n  margin-right: 15px;\n}\n\n/*# sourceMappingURL=WhatsappApiResponseStates.vue.map */",
    map: {
      "version": 3,
      "sources": ["E:\\Octadesk\\octa-whatsapp-client\\src\\app\\whatsapp-api\\components\\modal\\WhatsappApiResponseStates.vue", "WhatsappApiResponseStates.vue"],
      "names": [],
      "mappings": "AAyJA;EACA,WAAA;EACA,kBAAA;ACxJA;ADyJA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;ACvJA;ADwJA;EACA,eAAA;EACA,kBAAA;ACtJA;ADuJA;EACA,cAAA;ACrJA;ADuJA;EACA,cAAA;ACrJA;ADwJA;EACA,gBAAA;ACtJA;ADuJA;EACA,6BAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACrJA;ADuJA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACrJA;ADyJA;EACA,wBAAA;EACA,0BAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,6BAAA;ACvJA;ADwJA;EACA,kBAAA;ACtJA;;AAEA,wDAAwD",
      "file": "WhatsappApiResponseStates.vue",
      "sourcesContent": ["<template>\r\n  <div class=\"response-state-container\">\r\n    <button @click=\"$emit('close')\" type=\"button\" class=\"wpp-close-btn\" />\r\n\r\n    <div class=\"response-state-content\">\r\n      <span\r\n        :class=\"`icon-wp-${\r\n          currentWppApiState === WhatsappApiStates.error\r\n            ? 'error'\r\n            : 'check-circle'\r\n        }`\"\r\n      />\r\n\r\n      <div>\r\n        <h1>\r\n          {{ title }}\r\n        </h1>\r\n\r\n        <p v-html=\"message\" />\r\n      </div>\r\n    </div>\r\n\r\n    <div\r\n      class=\"response-state-footer\"\r\n      v-if=\"\r\n        currentWppApiState === WhatsappApiStates.success &&\r\n        currentWppApiPreviousState === WhatsappApiStates.integrationInfo\r\n      \"\r\n    >\r\n      <button\r\n        class=\"btn-control-wpp outline\"\r\n        @click=\"$emit('secondary-action')\"\r\n      >\r\n        {{\r\n          $t(\r\n            'whatsappApiModal.responseStates.success.integrationInfo.footer.secondary'\r\n          )\r\n        }}\r\n      </button>\r\n\r\n      <button class=\"btn-control-wpp primary\" @click=\"$emit('primary-action')\">\r\n        {{\r\n          $t(\r\n            'whatsappApiModal.responseStates.success.integrationInfo.footer.primary'\r\n          )\r\n        }}\r\n      </button>\r\n    </div>\r\n\r\n    <div\r\n      class=\"response-state-footer\"\r\n      v-else-if=\"currentWppApiState === WhatsappApiStates.error\"\r\n    >\r\n      <button\r\n        class=\"btn-control-wpp outline\"\r\n        @click=\"$emit('secondary-action')\"\r\n      >\r\n        {{ $t('whatsappApiModal.responseStates.error.footer.secondary') }}\r\n      </button>\r\n\r\n      <button class=\"btn-control-wpp primary\" @click=\"$emit('primary-action')\">\r\n        {{ $t('whatsappApiModal.responseStates.error.footer.primary') }}\r\n      </button>\r\n    </div>\r\n  </div>\r\n</template>\r\n\r\n<script>\r\n  import GlobalMixins from '@/app/mixins'\r\n\r\n  import { WhatsappApiStates } from '@/helpers/enums'\r\n\r\n  export default {\r\n    mixins: [GlobalMixins],\r\n    data() {\r\n      return {\r\n        currentWppApiState: undefined,\r\n        currentWppApiPreviousState: undefined\r\n      }\r\n    },\r\n    computed: {\r\n      title() {\r\n        if (this.currentWppApiState === WhatsappApiStates.success) {\r\n          if (\r\n            this.currentWppApiPreviousState ===\r\n            WhatsappApiStates.integrationInfo\r\n          ) {\r\n            return this.$t(\r\n              'whatsappApiModal.responseStates.success.integrationInfo.title'\r\n            )\r\n          } else if (\r\n            this.currentWppApiPreviousState === WhatsappApiStates.profileInfo\r\n          ) {\r\n            return this.$t(\r\n              'whatsappApiModal.responseStates.success.profileInfo.title'\r\n            )\r\n          }\r\n        } else {\r\n          if (\r\n            this.currentWppApiPreviousState ===\r\n            WhatsappApiStates.integrationInfo\r\n          ) {\r\n            return this.$t(\r\n              'whatsappApiModal.responseStates.error.integrationInfo.title'\r\n            )\r\n          } else if (\r\n            this.currentWppApiPreviousState === WhatsappApiStates.profileInfo\r\n          ) {\r\n            return this.$t(\r\n              'whatsappApiModal.responseStates.error.profileInfo.title'\r\n            )\r\n          }\r\n        }\r\n\r\n        return ''\r\n      },\r\n      message() {\r\n        if (this.currentWppApiState === WhatsappApiStates.success) {\r\n          if (\r\n            this.currentWppApiPreviousState ===\r\n            WhatsappApiStates.integrationInfo\r\n          ) {\r\n            return this.$t(\r\n              'whatsappApiModal.responseStates.success.integrationInfo.message'\r\n            )\r\n          } else if (\r\n            this.currentWppApiPreviousState === WhatsappApiStates.profileInfo\r\n          ) {\r\n            return this.$t(\r\n              'whatsappApiModal.responseStates.success.profileInfo.message'\r\n            )\r\n          }\r\n        } else {\r\n          return this.$t('whatsappApiModal.responseStates.error.message')\r\n        }\r\n\r\n        return ''\r\n      },\r\n      WhatsappApiStates() {\r\n        return WhatsappApiStates\r\n      }\r\n    },\r\n    mounted() {\r\n      this.unwatch = this.$store.watch((state, getters) => {\r\n        this.currentWppApiState = getters.currentWppApiState\r\n\r\n        this.currentWppApiPreviousState = getters.currentWppApiPreviousState\r\n      })\r\n    }\r\n  }\r\n</script>\r\n\r\n<style lang=\"scss\" scoped>\r\n  div.response-state-container {\r\n    width: 100%;\r\n    padding: 50px 40px;\r\n    div.response-state-content {\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: flex-start;\r\n      & > span {\r\n        font-size: 64px;\r\n        margin-right: 20px;\r\n        &.icon-wp-check-circle {\r\n          color: #1bdd85;\r\n        }\r\n        &.icon-wp-error {\r\n          color: #ef2066;\r\n        }\r\n      }\r\n      & > div {\r\n        text-align: left;\r\n        h1 {\r\n          font-family: 'Niveau Grotesk';\r\n          font-style: normal;\r\n          font-weight: bold;\r\n          font-size: 25px;\r\n          line-height: 29px;\r\n          color: #072a54;\r\n        }\r\n        p {\r\n          font-family: Helvetica;\r\n          font-style: normal;\r\n          font-weight: normal;\r\n          font-size: 14px;\r\n          line-height: 22px;\r\n          color: #4c4c4c;\r\n        }\r\n      }\r\n    }\r\n    div.response-state-footer {\r\n      width: calc(100% + 80px);\r\n      padding: 18px 40px 0px 0px;\r\n      margin-top: 60px;\r\n      margin-left: -40px;\r\n      margin-bottom: -32px;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: flex-end;\r\n      border-top: 1px solid #d7d7d7;\r\n      button:first-child {\r\n        margin-right: 15px;\r\n      }\r\n    }\r\n  }\r\n</style>\r\n\"\r\n", "div.response-state-container {\n  width: 100%;\n  padding: 50px 40px;\n}\ndiv.response-state-container div.response-state-content {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\ndiv.response-state-container div.response-state-content > span {\n  font-size: 64px;\n  margin-right: 20px;\n}\ndiv.response-state-container div.response-state-content > span.icon-wp-check-circle {\n  color: #1bdd85;\n}\ndiv.response-state-container div.response-state-content > span.icon-wp-error {\n  color: #ef2066;\n}\ndiv.response-state-container div.response-state-content > div {\n  text-align: left;\n}\ndiv.response-state-container div.response-state-content > div h1 {\n  font-family: \"Niveau Grotesk\";\n  font-style: normal;\n  font-weight: bold;\n  font-size: 25px;\n  line-height: 29px;\n  color: #072a54;\n}\ndiv.response-state-container div.response-state-content > div p {\n  font-family: Helvetica;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 22px;\n  color: #4c4c4c;\n}\ndiv.response-state-container div.response-state-footer {\n  width: calc(100% + 80px);\n  padding: 18px 40px 0px 0px;\n  margin-top: 60px;\n  margin-left: -40px;\n  margin-bottom: -32px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  border-top: 1px solid #d7d7d7;\n}\ndiv.response-state-container div.response-state-footer button:first-child {\n  margin-right: 15px;\n}\n\n/*# sourceMappingURL=WhatsappApiResponseStates.vue.map */"]
    },
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$h = "data-v-32141657";
/* module identifier */

var __vue_module_identifier__$h = undefined;
/* functional template */

var __vue_is_functional_template__$h = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$h = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$f,
  staticRenderFns: __vue_staticRenderFns__$f
}, __vue_inject_styles__$h, __vue_script__$d, __vue_scope_id__$h, __vue_is_functional_template__$h, __vue_module_identifier__$h, false, createInjector, undefined, undefined);

var vue2Dropzone = createCommonjsModule(function (module, exports) {
!function(e,t){module.exports=t();}(commonjsGlobal,function(){var e,t=(function(e){var t=function(){function e(e,t){for(var i=0;i<t.length;i++){var n=t[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n);}}return function(t,i,n){return i&&e(t.prototype,i),n&&e(t,n),t}}();function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return !t||"object"!=typeof t&&"function"!=typeof t?e:t}function n(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}var r=function(){function e(){n(this,e);}return t(e,[{key:"on",value:function(e,t){return this._callbacks=this._callbacks||{},this._callbacks[e]||(this._callbacks[e]=[]),this._callbacks[e].push(t),this}},{key:"emit",value:function(e){this._callbacks=this._callbacks||{};var t=this._callbacks[e];if(t){for(var i=arguments.length,n=Array(i>1?i-1:0),r=1;r<i;r++)n[r-1]=arguments[r];for(var o=0,s=s=t;;){if(o>=s.length)break;s[o++].apply(this,n);}}return this}},{key:"off",value:function(e,t){if(!this._callbacks||0===arguments.length)return this._callbacks={},this;var i=this._callbacks[e];if(!i)return this;if(1===arguments.length)return delete this._callbacks[e],this;for(var n=0;n<i.length;n++){if(i[n]===t){i.splice(n,1);break}}return this}}]),e}(),o=function(e){function o(e,t){n(this,o);var r,s=i(this,(o.__proto__||Object.getPrototypeOf(o)).call(this)),a=void 0;if(s.element=e,s.version=o.version,s.defaultOptions.previewTemplate=s.defaultOptions.previewTemplate.replace(/\n*/g,""),s.clickableElements=[],s.listeners=[],s.files=[],"string"==typeof s.element&&(s.element=document.querySelector(s.element)),!s.element||null==s.element.nodeType)throw new Error("Invalid dropzone element.");if(s.element.dropzone)throw new Error("Dropzone already attached.");o.instances.push(s),s.element.dropzone=s;var l,u=null!=(r=o.optionsForElement(s.element))?r:{};if(s.options=o.extend({},s.defaultOptions,u,null!=t?t:{}),s.options.forceFallback||!o.isBrowserSupported())return l=s.options.fallback.call(s),i(s,l);if(null==s.options.url&&(s.options.url=s.element.getAttribute("action")),!s.options.url)throw new Error("No URL provided.");if(s.options.acceptedFiles&&s.options.acceptedMimeTypes)throw new Error("You can't provide both 'acceptedFiles' and 'acceptedMimeTypes'. 'acceptedMimeTypes' is deprecated.");if(s.options.uploadMultiple&&s.options.chunking)throw new Error("You cannot set both: uploadMultiple and chunking.");return s.options.acceptedMimeTypes&&(s.options.acceptedFiles=s.options.acceptedMimeTypes,delete s.options.acceptedMimeTypes),null!=s.options.renameFilename&&(s.options.renameFile=function(e){return s.options.renameFilename.call(s,e.name,e)}),s.options.method=s.options.method.toUpperCase(),(a=s.getExistingFallback())&&a.parentNode&&a.parentNode.removeChild(a),!1!==s.options.previewsContainer&&(s.options.previewsContainer?s.previewsContainer=o.getElement(s.options.previewsContainer,"previewsContainer"):s.previewsContainer=s.element),s.options.clickable&&(!0===s.options.clickable?s.clickableElements=[s.element]:s.clickableElements=o.getElements(s.options.clickable,"clickable")),s.init(),s}return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t);}(o,r),t(o,null,[{key:"initClass",value:function(){this.prototype.Emitter=r,this.prototype.events=["drop","dragstart","dragend","dragenter","dragover","dragleave","addedfile","addedfiles","removedfile","thumbnail","error","errormultiple","processing","processingmultiple","uploadprogress","totaluploadprogress","sending","sendingmultiple","success","successmultiple","canceled","canceledmultiple","complete","completemultiple","reset","maxfilesexceeded","maxfilesreached","queuecomplete"],this.prototype.defaultOptions={url:null,method:"post",withCredentials:!1,timeout:3e4,parallelUploads:2,uploadMultiple:!1,chunking:!1,forceChunking:!1,chunkSize:2e6,parallelChunkUploads:!1,retryChunks:!1,retryChunksLimit:3,maxFilesize:256,paramName:"file",createImageThumbnails:!0,maxThumbnailFilesize:10,thumbnailWidth:120,thumbnailHeight:120,thumbnailMethod:"crop",resizeWidth:null,resizeHeight:null,resizeMimeType:null,resizeQuality:.8,resizeMethod:"contain",filesizeBase:1e3,maxFiles:null,headers:null,clickable:!0,ignoreHiddenFiles:!0,acceptedFiles:null,acceptedMimeTypes:null,autoProcessQueue:!0,autoQueue:!0,addRemoveLinks:!1,previewsContainer:null,hiddenInputContainer:"body",capture:null,renameFilename:null,renameFile:null,forceFallback:!1,dictDefaultMessage:"Drop files here to upload",dictFallbackMessage:"Your browser does not support drag'n'drop file uploads.",dictFallbackText:"Please use the fallback form below to upload your files like in the olden days.",dictFileTooBig:"File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.",dictInvalidFileType:"You can't upload files of this type.",dictResponseError:"Server responded with {{statusCode}} code.",dictCancelUpload:"Cancel upload",dictUploadCanceled:"Upload canceled.",dictCancelUploadConfirmation:"Are you sure you want to cancel this upload?",dictRemoveFile:"Remove file",dictRemoveFileConfirmation:null,dictMaxFilesExceeded:"You can not upload any more files.",dictFileSizeUnits:{tb:"TB",gb:"GB",mb:"MB",kb:"KB",b:"b"},init:function(){},params:function(e,t,i){if(i)return {dzuuid:i.file.upload.uuid,dzchunkindex:i.index,dztotalfilesize:i.file.size,dzchunksize:this.options.chunkSize,dztotalchunkcount:i.file.upload.totalChunkCount,dzchunkbyteoffset:i.index*this.options.chunkSize}},accept:function(e,t){return t()},chunksUploaded:function(e,t){t();},fallback:function(){var e=void 0;this.element.className=this.element.className+" dz-browser-not-supported";for(var t=0,i=i=this.element.getElementsByTagName("div");;){if(t>=i.length)break;var n=i[t++];if(/(^| )dz-message($| )/.test(n.className)){e=n,n.className="dz-message";break}}e||(e=o.createElement('<div class="dz-message"><span></span></div>'),this.element.appendChild(e));var r=e.getElementsByTagName("span")[0];return r&&(null!=r.textContent?r.textContent=this.options.dictFallbackMessage:null!=r.innerText&&(r.innerText=this.options.dictFallbackMessage)),this.element.appendChild(this.getFallbackForm())},resize:function(e,t,i,n){var r={srcX:0,srcY:0,srcWidth:e.width,srcHeight:e.height},o=e.width/e.height;null==t&&null==i?(t=r.srcWidth,i=r.srcHeight):null==t?t=i*o:null==i&&(i=t/o);var s=(t=Math.min(t,r.srcWidth))/(i=Math.min(i,r.srcHeight));if(r.srcWidth>t||r.srcHeight>i)if("crop"===n)o>s?(r.srcHeight=e.height,r.srcWidth=r.srcHeight*s):(r.srcWidth=e.width,r.srcHeight=r.srcWidth/s);else {if("contain"!==n)throw new Error("Unknown resizeMethod '"+n+"'");o>s?i=t/o:t=i*o;}return r.srcX=(e.width-r.srcWidth)/2,r.srcY=(e.height-r.srcHeight)/2,r.trgWidth=t,r.trgHeight=i,r},transformFile:function(e,t){return (this.options.resizeWidth||this.options.resizeHeight)&&e.type.match(/image.*/)?this.resizeImage(e,this.options.resizeWidth,this.options.resizeHeight,this.options.resizeMethod,t):t(e)},previewTemplate:'<div class="dz-preview dz-file-preview">\n  <div class="dz-image"><img data-dz-thumbnail /></div>\n  <div class="dz-details">\n    <div class="dz-size"><span data-dz-size></span></div>\n    <div class="dz-filename"><span data-dz-name></span></div>\n  </div>\n  <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>\n  <div class="dz-error-message"><span data-dz-errormessage></span></div>\n  <div class="dz-success-mark">\n    <svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns">\n      <title>Check</title>\n      <defs></defs>\n      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">\n        <path d="M23.5,31.8431458 L17.5852419,25.9283877 C16.0248253,24.3679711 13.4910294,24.366835 11.9289322,25.9289322 C10.3700136,27.4878508 10.3665912,30.0234455 11.9283877,31.5852419 L20.4147581,40.0716123 C20.5133999,40.1702541 20.6159315,40.2626649 20.7218615,40.3488435 C22.2835669,41.8725651 24.794234,41.8626202 26.3461564,40.3106978 L43.3106978,23.3461564 C44.8771021,21.7797521 44.8758057,19.2483887 43.3137085,17.6862915 C41.7547899,16.1273729 39.2176035,16.1255422 37.6538436,17.6893022 L23.5,31.8431458 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z" id="Oval-2" stroke-opacity="0.198794158" stroke="#747474" fill-opacity="0.816519475" fill="#FFFFFF" sketch:type="MSShapeGroup"></path>\n      </g>\n    </svg>\n  </div>\n  <div class="dz-error-mark">\n    <svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns">\n      <title>Error</title>\n      <defs></defs>\n      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">\n        <g id="Check-+-Oval-2" sketch:type="MSLayerGroup" stroke="#747474" stroke-opacity="0.198794158" fill="#FFFFFF" fill-opacity="0.816519475">\n          <path d="M32.6568542,29 L38.3106978,23.3461564 C39.8771021,21.7797521 39.8758057,19.2483887 38.3137085,17.6862915 C36.7547899,16.1273729 34.2176035,16.1255422 32.6538436,17.6893022 L27,23.3431458 L21.3461564,17.6893022 C19.7823965,16.1255422 17.2452101,16.1273729 15.6862915,17.6862915 C14.1241943,19.2483887 14.1228979,21.7797521 15.6893022,23.3461564 L21.3431458,29 L15.6893022,34.6538436 C14.1228979,36.2202479 14.1241943,38.7516113 15.6862915,40.3137085 C17.2452101,41.8726271 19.7823965,41.8744578 21.3461564,40.3106978 L27,34.6568542 L32.6538436,40.3106978 C34.2176035,41.8744578 36.7547899,41.8726271 38.3137085,40.3137085 C39.8758057,38.7516113 39.8771021,36.2202479 38.3106978,34.6538436 L32.6568542,29 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z" id="Oval-2" sketch:type="MSShapeGroup"></path>\n        </g>\n      </g>\n    </svg>\n  </div>\n</div>',drop:function(e){return this.element.classList.remove("dz-drag-hover")},dragstart:function(e){},dragend:function(e){return this.element.classList.remove("dz-drag-hover")},dragenter:function(e){return this.element.classList.add("dz-drag-hover")},dragover:function(e){return this.element.classList.add("dz-drag-hover")},dragleave:function(e){return this.element.classList.remove("dz-drag-hover")},paste:function(e){},reset:function(){return this.element.classList.remove("dz-started")},addedfile:function(e){var t=this;if(this.element===this.previewsContainer&&this.element.classList.add("dz-started"),this.previewsContainer){e.previewElement=o.createElement(this.options.previewTemplate.trim()),e.previewTemplate=e.previewElement,this.previewsContainer.appendChild(e.previewElement);for(var i=0,n=n=e.previewElement.querySelectorAll("[data-dz-name]");;){if(i>=n.length)break;var r=n[i++];r.textContent=e.name;}for(var s=0,a=a=e.previewElement.querySelectorAll("[data-dz-size]");!(s>=a.length);)(r=a[s++]).innerHTML=this.filesize(e.size);this.options.addRemoveLinks&&(e._removeLink=o.createElement('<a class="dz-remove" href="javascript:undefined;" data-dz-remove>'+this.options.dictRemoveFile+"</a>"),e.previewElement.appendChild(e._removeLink));for(var l=function(i){return i.preventDefault(),i.stopPropagation(),e.status===o.UPLOADING?o.confirm(t.options.dictCancelUploadConfirmation,function(){return t.removeFile(e)}):t.options.dictRemoveFileConfirmation?o.confirm(t.options.dictRemoveFileConfirmation,function(){return t.removeFile(e)}):t.removeFile(e)},u=0,d=d=e.previewElement.querySelectorAll("[data-dz-remove]");;){if(u>=d.length)break;d[u++].addEventListener("click",l);}}},removedfile:function(e){return null!=e.previewElement&&null!=e.previewElement.parentNode&&e.previewElement.parentNode.removeChild(e.previewElement),this._updateMaxFilesReachedClass()},thumbnail:function(e,t){if(e.previewElement){e.previewElement.classList.remove("dz-file-preview");for(var i=0,n=n=e.previewElement.querySelectorAll("[data-dz-thumbnail]");;){if(i>=n.length)break;var r=n[i++];r.alt=e.name,r.src=t;}return setTimeout(function(){return e.previewElement.classList.add("dz-image-preview")},1)}},error:function(e,t){if(e.previewElement){e.previewElement.classList.add("dz-error"),"String"!=typeof t&&t.error&&(t=t.error);for(var i=0,n=n=e.previewElement.querySelectorAll("[data-dz-errormessage]");;){if(i>=n.length)break;n[i++].textContent=t;}}},errormultiple:function(){},processing:function(e){if(e.previewElement&&(e.previewElement.classList.add("dz-processing"),e._removeLink))return e._removeLink.innerHTML=this.options.dictCancelUpload},processingmultiple:function(){},uploadprogress:function(e,t,i){if(e.previewElement)for(var n=0,r=r=e.previewElement.querySelectorAll("[data-dz-uploadprogress]");;){if(n>=r.length)break;var o=r[n++];"PROGRESS"===o.nodeName?o.value=t:o.style.width=t+"%";}},totaluploadprogress:function(){},sending:function(){},sendingmultiple:function(){},success:function(e){if(e.previewElement)return e.previewElement.classList.add("dz-success")},successmultiple:function(){},canceled:function(e){return this.emit("error",e,this.options.dictUploadCanceled)},canceledmultiple:function(){},complete:function(e){if(e._removeLink&&(e._removeLink.innerHTML=this.options.dictRemoveFile),e.previewElement)return e.previewElement.classList.add("dz-complete")},completemultiple:function(){},maxfilesexceeded:function(){},maxfilesreached:function(){},queuecomplete:function(){},addedfiles:function(){}},this.prototype._thumbnailQueue=[],this.prototype._processingThumbnail=!1;}},{key:"extend",value:function(e){for(var t=arguments.length,i=Array(t>1?t-1:0),n=1;n<t;n++)i[n-1]=arguments[n];for(var r=0,o=o=i;;){if(r>=o.length)break;var s=o[r++];for(var a in s){var l=s[a];e[a]=l;}}return e}}]),t(o,[{key:"getAcceptedFiles",value:function(){return this.files.filter(function(e){return e.accepted}).map(function(e){return e})}},{key:"getRejectedFiles",value:function(){return this.files.filter(function(e){return !e.accepted}).map(function(e){return e})}},{key:"getFilesWithStatus",value:function(e){return this.files.filter(function(t){return t.status===e}).map(function(e){return e})}},{key:"getQueuedFiles",value:function(){return this.getFilesWithStatus(o.QUEUED)}},{key:"getUploadingFiles",value:function(){return this.getFilesWithStatus(o.UPLOADING)}},{key:"getAddedFiles",value:function(){return this.getFilesWithStatus(o.ADDED)}},{key:"getActiveFiles",value:function(){return this.files.filter(function(e){return e.status===o.UPLOADING||e.status===o.QUEUED}).map(function(e){return e})}},{key:"init",value:function(){var e=this;if("form"===this.element.tagName&&this.element.setAttribute("enctype","multipart/form-data"),this.element.classList.contains("dropzone")&&!this.element.querySelector(".dz-message")&&this.element.appendChild(o.createElement('<div class="dz-default dz-message"><span>'+this.options.dictDefaultMessage+"</span></div>")),this.clickableElements.length){!function t(){return e.hiddenFileInput&&e.hiddenFileInput.parentNode.removeChild(e.hiddenFileInput),e.hiddenFileInput=document.createElement("input"),e.hiddenFileInput.setAttribute("type","file"),(null===e.options.maxFiles||e.options.maxFiles>1)&&e.hiddenFileInput.setAttribute("multiple","multiple"),e.hiddenFileInput.className="dz-hidden-input",null!==e.options.acceptedFiles&&e.hiddenFileInput.setAttribute("accept",e.options.acceptedFiles),null!==e.options.capture&&e.hiddenFileInput.setAttribute("capture",e.options.capture),e.hiddenFileInput.style.visibility="hidden",e.hiddenFileInput.style.position="absolute",e.hiddenFileInput.style.top="0",e.hiddenFileInput.style.left="0",e.hiddenFileInput.style.height="0",e.hiddenFileInput.style.width="0",o.getElement(e.options.hiddenInputContainer,"hiddenInputContainer").appendChild(e.hiddenFileInput),e.hiddenFileInput.addEventListener("change",function(){var i=e.hiddenFileInput.files;if(i.length)for(var n=0,r=r=i;!(n>=r.length);){var o=r[n++];e.addFile(o);}return e.emit("addedfiles",i),t()})}();}this.URL=null!==window.URL?window.URL:window.webkitURL;for(var t=0,i=i=this.events;;){if(t>=i.length)break;var n=i[t++];this.on(n,this.options[n]);}this.on("uploadprogress",function(){return e.updateTotalUploadProgress()}),this.on("removedfile",function(){return e.updateTotalUploadProgress()}),this.on("canceled",function(t){return e.emit("complete",t)}),this.on("complete",function(t){if(0===e.getAddedFiles().length&&0===e.getUploadingFiles().length&&0===e.getQueuedFiles().length)return setTimeout(function(){return e.emit("queuecomplete")},0)});var r=function(e){return e.stopPropagation(),e.preventDefault?e.preventDefault():e.returnValue=!1};return this.listeners=[{element:this.element,events:{dragstart:function(t){return e.emit("dragstart",t)},dragenter:function(t){return r(t),e.emit("dragenter",t)},dragover:function(t){var i=void 0;try{i=t.dataTransfer.effectAllowed;}catch(e){}return t.dataTransfer.dropEffect="move"===i||"linkMove"===i?"move":"copy",r(t),e.emit("dragover",t)},dragleave:function(t){return e.emit("dragleave",t)},drop:function(t){return r(t),e.drop(t)},dragend:function(t){return e.emit("dragend",t)}}}],this.clickableElements.forEach(function(t){return e.listeners.push({element:t,events:{click:function(i){return (t!==e.element||i.target===e.element||o.elementInside(i.target,e.element.querySelector(".dz-message")))&&e.hiddenFileInput.click(),!0}}})}),this.enable(),this.options.init.call(this)}},{key:"destroy",value:function(){return this.disable(),this.removeAllFiles(!0),(null!=this.hiddenFileInput?this.hiddenFileInput.parentNode:void 0)&&(this.hiddenFileInput.parentNode.removeChild(this.hiddenFileInput),this.hiddenFileInput=null),delete this.element.dropzone,o.instances.splice(o.instances.indexOf(this),1)}},{key:"updateTotalUploadProgress",value:function(){var e=void 0,t=0,i=0;if(this.getActiveFiles().length){for(var n=0,r=r=this.getActiveFiles();;){if(n>=r.length)break;var o=r[n++];t+=o.upload.bytesSent,i+=o.upload.total;}e=100*t/i;}else e=100;return this.emit("totaluploadprogress",e,i,t)}},{key:"_getParamName",value:function(e){return "function"==typeof this.options.paramName?this.options.paramName(e):this.options.paramName+(this.options.uploadMultiple?"["+e+"]":"")}},{key:"_renameFile",value:function(e){return "function"!=typeof this.options.renameFile?e.name:this.options.renameFile(e)}},{key:"getFallbackForm",value:function(){var e,t=void 0;if(e=this.getExistingFallback())return e;var i='<div class="dz-fallback">';this.options.dictFallbackText&&(i+="<p>"+this.options.dictFallbackText+"</p>"),i+='<input type="file" name="'+this._getParamName(0)+'" '+(this.options.uploadMultiple?'multiple="multiple"':void 0)+' /><input type="submit" value="Upload!"></div>';var n=o.createElement(i);return "FORM"!==this.element.tagName?(t=o.createElement('<form action="'+this.options.url+'" enctype="multipart/form-data" method="'+this.options.method+'"></form>')).appendChild(n):(this.element.setAttribute("enctype","multipart/form-data"),this.element.setAttribute("method",this.options.method)),null!=t?t:n}},{key:"getExistingFallback",value:function(){for(var e=function(e){for(var t=0,i=i=e;;){if(t>=i.length)break;var n=i[t++];if(/(^| )fallback($| )/.test(n.className))return n}},t=["div","form"],i=0;i<t.length;i++){var n,r=t[i];if(n=e(this.element.getElementsByTagName(r)))return n}}},{key:"setupEventListeners",value:function(){return this.listeners.map(function(e){return function(){var t=[];for(var i in e.events){var n=e.events[i];t.push(e.element.addEventListener(i,n,!1));}return t}()})}},{key:"removeEventListeners",value:function(){return this.listeners.map(function(e){return function(){var t=[];for(var i in e.events){var n=e.events[i];t.push(e.element.removeEventListener(i,n,!1));}return t}()})}},{key:"disable",value:function(){var e=this;return this.clickableElements.forEach(function(e){return e.classList.remove("dz-clickable")}),this.removeEventListeners(),this.disabled=!0,this.files.map(function(t){return e.cancelUpload(t)})}},{key:"enable",value:function(){return delete this.disabled,this.clickableElements.forEach(function(e){return e.classList.add("dz-clickable")}),this.setupEventListeners()}},{key:"filesize",value:function(e){var t=0,i="b";if(e>0){for(var n=["tb","gb","mb","kb","b"],r=0;r<n.length;r++){var o=n[r];if(e>=Math.pow(this.options.filesizeBase,4-r)/10){t=e/Math.pow(this.options.filesizeBase,4-r),i=o;break}}t=Math.round(10*t)/10;}return "<strong>"+t+"</strong> "+this.options.dictFileSizeUnits[i]}},{key:"_updateMaxFilesReachedClass",value:function(){return null!=this.options.maxFiles&&this.getAcceptedFiles().length>=this.options.maxFiles?(this.getAcceptedFiles().length===this.options.maxFiles&&this.emit("maxfilesreached",this.files),this.element.classList.add("dz-max-files-reached")):this.element.classList.remove("dz-max-files-reached")}},{key:"drop",value:function(e){if(e.dataTransfer){this.emit("drop",e);for(var t=[],i=0;i<e.dataTransfer.files.length;i++)t[i]=e.dataTransfer.files[i];if(this.emit("addedfiles",t),t.length){var n=e.dataTransfer.items;n&&n.length&&null!=n[0].webkitGetAsEntry?this._addFilesFromItems(n):this.handleFiles(t);}}}},{key:"paste",value:function(e){if(null!=(t=null!=e?e.clipboardData:void 0,i=function(e){return e.items},null!=t?i(t):void 0)){var t,i;this.emit("paste",e);var n=e.clipboardData.items;return n.length?this._addFilesFromItems(n):void 0}}},{key:"handleFiles",value:function(e){for(var t=0,i=i=e;;){if(t>=i.length)break;var n=i[t++];this.addFile(n);}}},{key:"_addFilesFromItems",value:function(e){var t=this;return function(){for(var i=[],n=0,r=r=e;;){if(n>=r.length)break;var o,s=r[n++];null!=s.webkitGetAsEntry&&(o=s.webkitGetAsEntry())?o.isFile?i.push(t.addFile(s.getAsFile())):o.isDirectory?i.push(t._addFilesFromDirectory(o,o.name)):i.push(void 0):null!=s.getAsFile&&(null==s.kind||"file"===s.kind)?i.push(t.addFile(s.getAsFile())):i.push(void 0);}return i}()}},{key:"_addFilesFromDirectory",value:function(e,t){var i=this,n=e.createReader(),r=function(e){return t=console,i="log",n=function(t){return t.log(e)},null!=t&&"function"==typeof t[i]?n(t,i):void 0;var t,i,n;};return function e(){return n.readEntries(function(n){if(n.length>0){for(var r=0,o=o=n;!(r>=o.length);){var s=o[r++];s.isFile?s.file(function(e){if(!i.options.ignoreHiddenFiles||"."!==e.name.substring(0,1))return e.fullPath=t+"/"+e.name,i.addFile(e)}):s.isDirectory&&i._addFilesFromDirectory(s,t+"/"+s.name);}e();}return null},r)}()}},{key:"accept",value:function(e,t){return this.options.maxFilesize&&e.size>1024*this.options.maxFilesize*1024?t(this.options.dictFileTooBig.replace("{{filesize}}",Math.round(e.size/1024/10.24)/100).replace("{{maxFilesize}}",this.options.maxFilesize)):o.isValidFile(e,this.options.acceptedFiles)?null!=this.options.maxFiles&&this.getAcceptedFiles().length>=this.options.maxFiles?(t(this.options.dictMaxFilesExceeded.replace("{{maxFiles}}",this.options.maxFiles)),this.emit("maxfilesexceeded",e)):this.options.accept.call(this,e,t):t(this.options.dictInvalidFileType)}},{key:"addFile",value:function(e){var t=this;return e.upload={uuid:o.uuidv4(),progress:0,total:e.size,bytesSent:0,filename:this._renameFile(e),chunked:this.options.chunking&&(this.options.forceChunking||e.size>this.options.chunkSize),totalChunkCount:Math.ceil(e.size/this.options.chunkSize)},this.files.push(e),e.status=o.ADDED,this.emit("addedfile",e),this._enqueueThumbnail(e),this.accept(e,function(i){return i?(e.accepted=!1,t._errorProcessing([e],i)):(e.accepted=!0,t.options.autoQueue&&t.enqueueFile(e)),t._updateMaxFilesReachedClass()})}},{key:"enqueueFiles",value:function(e){for(var t=0,i=i=e;;){if(t>=i.length)break;var n=i[t++];this.enqueueFile(n);}return null}},{key:"enqueueFile",value:function(e){var t=this;if(e.status!==o.ADDED||!0!==e.accepted)throw new Error("This file can't be queued because it has already been processed or was rejected.");if(e.status=o.QUEUED,this.options.autoProcessQueue)return setTimeout(function(){return t.processQueue()},0)}},{key:"_enqueueThumbnail",value:function(e){var t=this;if(this.options.createImageThumbnails&&e.type.match(/image.*/)&&e.size<=1024*this.options.maxThumbnailFilesize*1024)return this._thumbnailQueue.push(e),setTimeout(function(){return t._processThumbnailQueue()},0)}},{key:"_processThumbnailQueue",value:function(){var e=this;if(!this._processingThumbnail&&0!==this._thumbnailQueue.length){this._processingThumbnail=!0;var t=this._thumbnailQueue.shift();return this.createThumbnail(t,this.options.thumbnailWidth,this.options.thumbnailHeight,this.options.thumbnailMethod,!0,function(i){return e.emit("thumbnail",t,i),e._processingThumbnail=!1,e._processThumbnailQueue()})}}},{key:"removeFile",value:function(e){if(e.status===o.UPLOADING&&this.cancelUpload(e),this.files=s(this.files,e),this.emit("removedfile",e),0===this.files.length)return this.emit("reset")}},{key:"removeAllFiles",value:function(e){null==e&&(e=!1);for(var t=0,i=i=this.files.slice();;){if(t>=i.length)break;var n=i[t++];(n.status!==o.UPLOADING||e)&&this.removeFile(n);}return null}},{key:"resizeImage",value:function(e,t,i,n,r){var s=this;return this.createThumbnail(e,t,i,n,!0,function(t,i){if(null==i)return r(e);var n=s.options.resizeMimeType;null==n&&(n=e.type);var a=i.toDataURL(n,s.options.resizeQuality);return "image/jpeg"!==n&&"image/jpg"!==n||(a=u.restore(e.dataURL,a)),r(o.dataURItoBlob(a))})}},{key:"createThumbnail",value:function(e,t,i,n,r,o){var s=this,a=new FileReader;return a.onload=function(){if(e.dataURL=a.result,"image/svg+xml"!==e.type)return s.createThumbnailFromUrl(e,t,i,n,r,o);null!=o&&o(a.result);},a.readAsDataURL(e)}},{key:"createThumbnailFromUrl",value:function(e,t,i,n,r,o,s){var a=this,u=document.createElement("img");return s&&(u.crossOrigin=s),u.onload=function(){var s=function(e){return e(1)};return "undefined"!=typeof EXIF&&null!==EXIF&&r&&(s=function(e){return EXIF.getData(u,function(){return e(EXIF.getTag(this,"Orientation"))})}),s(function(r){e.width=u.width,e.height=u.height;var s=a.options.resize.call(a,e,t,i,n),d=document.createElement("canvas"),c=d.getContext("2d");switch(d.width=s.trgWidth,d.height=s.trgHeight,r>4&&(d.width=s.trgHeight,d.height=s.trgWidth),r){case 2:c.translate(d.width,0),c.scale(-1,1);break;case 3:c.translate(d.width,d.height),c.rotate(Math.PI);break;case 4:c.translate(0,d.height),c.scale(1,-1);break;case 5:c.rotate(.5*Math.PI),c.scale(1,-1);break;case 6:c.rotate(.5*Math.PI),c.translate(0,-d.width);break;case 7:c.rotate(.5*Math.PI),c.translate(d.height,-d.width),c.scale(-1,1);break;case 8:c.rotate(-.5*Math.PI),c.translate(-d.height,0);}l(c,u,null!=s.srcX?s.srcX:0,null!=s.srcY?s.srcY:0,s.srcWidth,s.srcHeight,null!=s.trgX?s.trgX:0,null!=s.trgY?s.trgY:0,s.trgWidth,s.trgHeight);var p=d.toDataURL("image/png");if(null!=o)return o(p,d)})},null!=o&&(u.onerror=o),u.src=e.dataURL}},{key:"processQueue",value:function(){var e=this.options.parallelUploads,t=this.getUploadingFiles().length,i=t;if(!(t>=e)){var n=this.getQueuedFiles();if(n.length>0){if(this.options.uploadMultiple)return this.processFiles(n.slice(0,e-t));for(;i<e;){if(!n.length)return;this.processFile(n.shift()),i++;}}}}},{key:"processFile",value:function(e){return this.processFiles([e])}},{key:"processFiles",value:function(e){for(var t=0,i=i=e;;){if(t>=i.length)break;var n=i[t++];n.processing=!0,n.status=o.UPLOADING,this.emit("processing",n);}return this.options.uploadMultiple&&this.emit("processingmultiple",e),this.uploadFiles(e)}},{key:"_getFilesWithXhr",value:function(e){return this.files.filter(function(t){return t.xhr===e}).map(function(e){return e})}},{key:"cancelUpload",value:function(e){if(e.status===o.UPLOADING){for(var t=this._getFilesWithXhr(e.xhr),i=0,n=n=t;;){if(i>=n.length)break;n[i++].status=o.CANCELED;}void 0!==e.xhr&&e.xhr.abort();for(var r=0,s=s=t;;){if(r>=s.length)break;var a=s[r++];this.emit("canceled",a);}this.options.uploadMultiple&&this.emit("canceledmultiple",t);}else e.status!==o.ADDED&&e.status!==o.QUEUED||(e.status=o.CANCELED,this.emit("canceled",e),this.options.uploadMultiple&&this.emit("canceledmultiple",[e]));if(this.options.autoProcessQueue)return this.processQueue()}},{key:"resolveOption",value:function(e){if("function"==typeof e){for(var t=arguments.length,i=Array(t>1?t-1:0),n=1;n<t;n++)i[n-1]=arguments[n];return e.apply(this,i)}return e}},{key:"uploadFile",value:function(e){return this.uploadFiles([e])}},{key:"uploadFiles",value:function(e){var t=this;this._transformFiles(e,function(i){if(e[0].upload.chunked){var n=e[0],r=i[0];n.upload.chunks=[];var s=function(){for(var i=0;void 0!==n.upload.chunks[i];)i++;if(!(i>=n.upload.totalChunkCount)){var s=i*t.options.chunkSize,a=Math.min(s+t.options.chunkSize,n.size),l={name:t._getParamName(0),data:r.webkitSlice?r.webkitSlice(s,a):r.slice(s,a),filename:n.upload.filename,chunkIndex:i};n.upload.chunks[i]={file:n,index:i,dataBlock:l,status:o.UPLOADING,progress:0,retries:0},t._uploadData(e,[l]);}};if(n.upload.finishedChunkUpload=function(i){var r=!0;i.status=o.SUCCESS,i.dataBlock=null,i.xhr=null;for(var a=0;a<n.upload.totalChunkCount;a++){if(void 0===n.upload.chunks[a])return s();n.upload.chunks[a].status!==o.SUCCESS&&(r=!1);}r&&t.options.chunksUploaded(n,function(){t._finished(e,"",null);});},t.options.parallelChunkUploads)for(var a=0;a<n.upload.totalChunkCount;a++)s();else s();}else {for(var l=[],u=0;u<e.length;u++)l[u]={name:t._getParamName(u),data:i[u],filename:e[u].upload.filename};t._uploadData(e,l);}});}},{key:"_getChunk",value:function(e,t){for(var i=0;i<e.upload.totalChunkCount;i++)if(void 0!==e.upload.chunks[i]&&e.upload.chunks[i].xhr===t)return e.upload.chunks[i]}},{key:"_uploadData",value:function(e,t){for(var i=this,n=new XMLHttpRequest,r=0,s=s=e;;){if(r>=s.length)break;s[r++].xhr=n;}e[0].upload.chunked&&(e[0].upload.chunks[t[0].chunkIndex].xhr=n);var a=this.resolveOption(this.options.method,e),l=this.resolveOption(this.options.url,e);n.open(a,l,!0),n.timeout=this.resolveOption(this.options.timeout,e),n.withCredentials=!!this.options.withCredentials,n.onload=function(t){i._finishedUploading(e,n,t);},n.onerror=function(){i._handleUploadError(e,n);},(null!=n.upload?n.upload:n).onprogress=function(t){return i._updateFilesUploadProgress(e,n,t)};var u={Accept:"application/json","Cache-Control":"no-cache","X-Requested-With":"XMLHttpRequest"};for(var d in this.options.headers&&o.extend(u,this.options.headers),u){var c=u[d];c&&n.setRequestHeader(d,c);}var p=new FormData;if(this.options.params){var h=this.options.params;for(var f in "function"==typeof h&&(h=h.call(this,e,n,e[0].upload.chunked?this._getChunk(e[0],n):null)),h){var m=h[f];p.append(f,m);}}for(var v=0,g=g=e;;){if(v>=g.length)break;var k=g[v++];this.emit("sending",k,n,p);}this.options.uploadMultiple&&this.emit("sendingmultiple",e,n,p),this._addFormElementData(p);for(var y=0;y<t.length;y++){var b=t[y];p.append(b.name,b.data,b.filename);}this.submitRequest(n,p,e);}},{key:"_transformFiles",value:function(e,t){for(var i=this,n=[],r=0,o=function(o){i.options.transformFile.call(i,e[o],function(i){n[o]=i,++r===e.length&&t(n);});},s=0;s<e.length;s++)o(s);}},{key:"_addFormElementData",value:function(e){if("FORM"===this.element.tagName)for(var t=0,i=i=this.element.querySelectorAll("input, textarea, select, button");;){if(t>=i.length)break;var n=i[t++],r=n.getAttribute("name"),o=n.getAttribute("type");if(o&&(o=o.toLowerCase()),null!=r)if("SELECT"===n.tagName&&n.hasAttribute("multiple"))for(var s=0,a=a=n.options;;){if(s>=a.length)break;var l=a[s++];l.selected&&e.append(r,l.value);}else (!o||"checkbox"!==o&&"radio"!==o||n.checked)&&e.append(r,n.value);}}},{key:"_updateFilesUploadProgress",value:function(e,t,i){var n=void 0;if(void 0!==i){if(n=100*i.loaded/i.total,e[0].upload.chunked){var r=e[0],o=this._getChunk(r,t);o.progress=n,o.total=i.total,o.bytesSent=i.loaded,r.upload.progress=0,r.upload.total=0,r.upload.bytesSent=0;for(var s=0;s<r.upload.totalChunkCount;s++)void 0!==r.upload.chunks[s]&&void 0!==r.upload.chunks[s].progress&&(r.upload.progress+=r.upload.chunks[s].progress,r.upload.total+=r.upload.chunks[s].total,r.upload.bytesSent+=r.upload.chunks[s].bytesSent);r.upload.progress=r.upload.progress/r.upload.totalChunkCount;}else for(var a=0,l=l=e;;){if(a>=l.length)break;var u=l[a++];u.upload.progress=n,u.upload.total=i.total,u.upload.bytesSent=i.loaded;}for(var d=0,c=c=e;;){if(d>=c.length)break;var p=c[d++];this.emit("uploadprogress",p,p.upload.progress,p.upload.bytesSent);}}else {var h=!0;n=100;for(var f=0,m=m=e;;){if(f>=m.length)break;var v=m[f++];100===v.upload.progress&&v.upload.bytesSent===v.upload.total||(h=!1),v.upload.progress=n,v.upload.bytesSent=v.upload.total;}if(h)return;for(var g=0,k=k=e;;){if(g>=k.length)break;var y=k[g++];this.emit("uploadprogress",y,n,y.upload.bytesSent);}}}},{key:"_finishedUploading",value:function(e,t,i){var n=void 0;if(e[0].status!==o.CANCELED&&4===t.readyState){if("arraybuffer"!==t.responseType&&"blob"!==t.responseType&&(n=t.responseText,t.getResponseHeader("content-type")&&~t.getResponseHeader("content-type").indexOf("application/json")))try{n=JSON.parse(n);}catch(e){i=e,n="Invalid JSON response from server.";}this._updateFilesUploadProgress(e),200<=t.status&&t.status<300?e[0].upload.chunked?e[0].upload.finishedChunkUpload(this._getChunk(e[0],t)):this._finished(e,n,i):this._handleUploadError(e,t,n);}}},{key:"_handleUploadError",value:function(e,t,i){if(e[0].status!==o.CANCELED){if(e[0].upload.chunked&&this.options.retryChunks){var n=this._getChunk(e[0],t);if(n.retries++<this.options.retryChunksLimit)return void this._uploadData(e,[n.dataBlock]);console.warn("Retried this chunk too often. Giving up.");}for(var r=0,s=s=e;;){if(r>=s.length)break;s[r++],this._errorProcessing(e,i||this.options.dictResponseError.replace("{{statusCode}}",t.status),t);}}}},{key:"submitRequest",value:function(e,t,i){e.send(t);}},{key:"_finished",value:function(e,t,i){for(var n=0,r=r=e;;){if(n>=r.length)break;var s=r[n++];s.status=o.SUCCESS,this.emit("success",s,t,i),this.emit("complete",s);}if(this.options.uploadMultiple&&(this.emit("successmultiple",e,t,i),this.emit("completemultiple",e)),this.options.autoProcessQueue)return this.processQueue()}},{key:"_errorProcessing",value:function(e,t,i){for(var n=0,r=r=e;;){if(n>=r.length)break;var s=r[n++];s.status=o.ERROR,this.emit("error",s,t,i),this.emit("complete",s);}if(this.options.uploadMultiple&&(this.emit("errormultiple",e,t,i),this.emit("completemultiple",e)),this.options.autoProcessQueue)return this.processQueue()}}],[{key:"uuidv4",value:function(){return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,function(e){var t=16*Math.random()|0;return ("x"===e?t:3&t|8).toString(16)})}}]),o}();o.initClass(),o.version="5.5.1",o.options={},o.optionsForElement=function(e){return e.getAttribute("id")?o.options[a(e.getAttribute("id"))]:void 0},o.instances=[],o.forElement=function(e){if("string"==typeof e&&(e=document.querySelector(e)),null==(null!=e?e.dropzone:void 0))throw new Error("No Dropzone found for given element. This is probably because you're trying to access it before Dropzone had the time to initialize. Use the `init` option to setup any additional observers on your Dropzone.");return e.dropzone},o.autoDiscover=!0,o.discover=function(){var e=void 0;if(document.querySelectorAll)e=document.querySelectorAll(".dropzone");else {e=[];var t=function(t){return function(){for(var i=[],n=0,r=r=t;;){if(n>=r.length)break;var o=r[n++];/(^| )dropzone($| )/.test(o.className)?i.push(e.push(o)):i.push(void 0);}return i}()};t(document.getElementsByTagName("div")),t(document.getElementsByTagName("form"));}return function(){for(var t=[],i=0,n=n=e;;){if(i>=n.length)break;var r=n[i++];!1!==o.optionsForElement(r)?t.push(new o(r)):t.push(void 0);}return t}()},o.blacklistedBrowsers=[/opera.*(Macintosh|Windows Phone).*version\/12/i],o.isBrowserSupported=function(){var e=!0;if(window.File&&window.FileReader&&window.FileList&&window.Blob&&window.FormData&&document.querySelector)if("classList"in document.createElement("a"))for(var t=0,i=i=o.blacklistedBrowsers;;){if(t>=i.length)break;i[t++].test(navigator.userAgent)&&(e=!1);}else e=!1;else e=!1;return e},o.dataURItoBlob=function(e){for(var t=atob(e.split(",")[1]),i=e.split(",")[0].split(":")[1].split(";")[0],n=new ArrayBuffer(t.length),r=new Uint8Array(n),o=0,s=t.length,a=0<=s;a?o<=s:o>=s;a?o++:o--)r[o]=t.charCodeAt(o);return new Blob([n],{type:i})};var s=function(e,t){return e.filter(function(e){return e!==t}).map(function(e){return e})},a=function(e){return e.replace(/[\-_](\w)/g,function(e){return e.charAt(1).toUpperCase()})};o.createElement=function(e){var t=document.createElement("div");return t.innerHTML=e,t.childNodes[0]},o.elementInside=function(e,t){if(e===t)return !0;for(;e=e.parentNode;)if(e===t)return !0;return !1},o.getElement=function(e,t){var i=void 0;if("string"==typeof e?i=document.querySelector(e):null!=e.nodeType&&(i=e),null==i)throw new Error("Invalid `"+t+"` option provided. Please provide a CSS selector or a plain HTML element.");return i},o.getElements=function(e,t){var i=void 0,n=void 0;if(e instanceof Array){n=[];try{for(var r=0,o=o=e;!(r>=o.length);)i=o[r++],n.push(this.getElement(i,t));}catch(e){n=null;}}else if("string"==typeof e){n=[];for(var s=0,a=a=document.querySelectorAll(e);!(s>=a.length);)i=a[s++],n.push(i);}else null!=e.nodeType&&(n=[e]);if(null==n||!n.length)throw new Error("Invalid `"+t+"` option provided. Please provide a CSS selector, a plain HTML element or a list of those.");return n},o.confirm=function(e,t,i){return window.confirm(e)?t():null!=i?i():void 0},o.isValidFile=function(e,t){if(!t)return !0;t=t.split(",");for(var i=e.type,n=i.replace(/\/.*$/,""),r=0,o=o=t;;){if(r>=o.length)break;var s=o[r++];if("."===(s=s.trim()).charAt(0)){if(-1!==e.name.toLowerCase().indexOf(s.toLowerCase(),e.name.length-s.length))return !0}else if(/\/\*$/.test(s)){if(n===s.replace(/\/.*$/,""))return !0}else if(i===s)return !0}return !1},"undefined"!=typeof jQuery&&null!==jQuery&&(jQuery.fn.dropzone=function(e){return this.each(function(){return new o(this,e)})}),null!==e?e.exports=o:window.Dropzone=o,o.ADDED="added",o.QUEUED="queued",o.ACCEPTED=o.QUEUED,o.UPLOADING="uploading",o.PROCESSING=o.UPLOADING,o.CANCELED="canceled",o.ERROR="error",o.SUCCESS="success";var l=function(e,t,i,n,r,o,s,a,l,u){var d=function(e){e.naturalWidth;var t=e.naturalHeight,i=document.createElement("canvas");i.width=1,i.height=t;var n=i.getContext("2d");n.drawImage(e,0,0);for(var r=n.getImageData(1,0,1,t).data,o=0,s=t,a=t;a>o;)0===r[4*(a-1)+3]?s=a:o=a,a=s+o>>1;var l=a/t;return 0===l?1:l}(t);return e.drawImage(t,i,n,r,o,s,a,l,u/d)},u=function(){function e(){n(this,e);}return t(e,null,[{key:"initClass",value:function(){this.KEY_STR="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";}},{key:"encode64",value:function(e){for(var t="",i=void 0,n=void 0,r="",o=void 0,s=void 0,a=void 0,l="",u=0;o=(i=e[u++])>>2,s=(3&i)<<4|(n=e[u++])>>4,a=(15&n)<<2|(r=e[u++])>>6,l=63&r,isNaN(n)?a=l=64:isNaN(r)&&(l=64),t=t+this.KEY_STR.charAt(o)+this.KEY_STR.charAt(s)+this.KEY_STR.charAt(a)+this.KEY_STR.charAt(l),i=n=r="",o=s=a=l="",u<e.length;);return t}},{key:"restore",value:function(e,t){if(!e.match("data:image/jpeg;base64,"))return t;var i=this.decode64(e.replace("data:image/jpeg;base64,","")),n=this.slice2Segments(i),r=this.exifManipulation(t,n);return "data:image/jpeg;base64,"+this.encode64(r)}},{key:"exifManipulation",value:function(e,t){var i=this.getExifArray(t),n=this.insertExif(e,i);return new Uint8Array(n)}},{key:"getExifArray",value:function(e){for(var t=void 0,i=0;i<e.length;){if(255===(t=e[i])[0]&225===t[1])return t;i++;}return []}},{key:"insertExif",value:function(e,t){var i=e.replace("data:image/jpeg;base64,",""),n=this.decode64(i),r=n.indexOf(255,3),o=n.slice(0,r),s=n.slice(r),a=o;return a=(a=a.concat(t)).concat(s)}},{key:"slice2Segments",value:function(e){for(var t=0,i=[];;){if(255===e[t]&218===e[t+1])break;if(255===e[t]&216===e[t+1])t+=2;else {var n=t+(256*e[t+2]+e[t+3])+2,r=e.slice(t,n);i.push(r),t=n;}if(t>e.length)break}return i}},{key:"decode64",value:function(e){var t=void 0,i=void 0,n="",r=void 0,o=void 0,s="",a=0,l=[];for(/[^A-Za-z0-9\+\/\=]/g.exec(e)&&console.warn("There were invalid base64 characters in the input text.\nValid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='\nExpect errors in decoding."),e=e.replace(/[^A-Za-z0-9\+\/\=]/g,"");t=this.KEY_STR.indexOf(e.charAt(a++))<<2|(r=this.KEY_STR.indexOf(e.charAt(a++)))>>4,i=(15&r)<<4|(o=this.KEY_STR.indexOf(e.charAt(a++)))>>2,n=(3&o)<<6|(s=this.KEY_STR.indexOf(e.charAt(a++))),l.push(t),64!==o&&l.push(i),64!==s&&l.push(n),t=i=n="",r=o=s="",a<e.length;);return l}}]),e}();u.initClass(),o._autoDiscoverFunction=function(){if(o.autoDiscover)return o.discover()},function(e,t){var i=!1,n=!0,r=e.document,o=r.documentElement,s=r.addEventListener?"addEventListener":"attachEvent",a=r.addEventListener?"removeEventListener":"detachEvent",l=r.addEventListener?"":"on",u=function n(o){if("readystatechange"!==o.type||"complete"===r.readyState)return ("load"===o.type?e:r)[a](l+o.type,n,!1),!i&&(i=!0)?t.call(e,o.type||o):void 0};if("complete"!==r.readyState){if(r.createEventObject&&o.doScroll){try{n=!e.frameElement;}catch(e){}n&&function e(){try{o.doScroll("left");}catch(t){return void setTimeout(e,50)}return u("poll")}();}r[s](l+"DOMContentLoaded",u,!1),r[s](l+"readystatechange",u,!1),e[s](l+"load",u,!1);}}(window,o._autoDiscoverFunction);}(e={exports:{}},e.exports),e.exports),i={getSignedURL(e,t){let i={filePath:e.name,contentType:e.type};return new Promise((n,r)=>{var o=new FormData;let s=new XMLHttpRequest,a="function"==typeof t.signingURL?t.signingURL(e):t.signingURL;s.open("POST",a),s.onload=function(){200==s.status?n(JSON.parse(s.response)):r(s.statusText);},s.onerror=function(e){console.error("Network Error : Could not send request to AWS (Maybe CORS errors)"),r(e);},!0===t.withCredentials&&(s.withCredentials=!0),Object.entries(t.headers||{}).forEach(([e,t])=>{s.setRequestHeader(e,t);}),i=Object.assign(i,t.params||{}),Object.entries(i).forEach(([e,t])=>{o.append(e,t);}),s.send(o);})},sendFile(e,t,i){var n=i?this.setResponseHandler:this.sendS3Handler;return this.getSignedURL(e,t).then(t=>n(t,e)).catch(e=>e)},setResponseHandler(e,t){t.s3Signature=e.signature,t.s3Url=e.postEndpoint;},sendS3Handler(e,t){let i=new FormData,n=e.signature;return Object.keys(n).forEach(function(e){i.append(e,n[e]);}),i.append("file",t),new Promise((t,n)=>{let r=new XMLHttpRequest;r.open("POST",e.postEndpoint),r.onload=function(){if(201==r.status){var e=(new window.DOMParser).parseFromString(r.response,"text/xml").firstChild.children[0].innerHTML;t({success:!0,message:e});}else {var i=(new window.DOMParser).parseFromString(r.response,"text/xml").firstChild.children[0].innerHTML;n({success:!1,message:i+". Request is marked as resolved when returns as status 201"});}},r.onerror=function(e){var t=(new window.DOMParser).parseFromString(r.response,"text/xml").firstChild.children[1].innerHTML;n({success:!1,message:t});},r.send(i);})}};t.autoDiscover=!1;return function(e,t,i,n,r,o,s,a,l,u){"boolean"!=typeof s&&(l=a,a=s,s=!1);var d,c="function"==typeof i?i.options:i;if(e&&e.render&&(c.render=e.render,c.staticRenderFns=e.staticRenderFns,c._compiled=!0,r&&(c.functional=!0)),n&&(c._scopeId=n),o?(d=function(e){(e=e||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext)||"undefined"==typeof __VUE_SSR_CONTEXT__||(e=__VUE_SSR_CONTEXT__),t&&t.call(this,l(e)),e&&e._registeredComponents&&e._registeredComponents.add(o);},c._ssrRegister=d):t&&(d=s?function(){t.call(this,u(this.$root.$options.shadowRoot));}:function(e){t.call(this,a(e));}),d)if(c.functional){var p=c.render;c.render=function(e,t){return d.call(t),p(e,t)};}else {var h=c.beforeCreate;c.beforeCreate=h?[].concat(h,d):[d];}return i}({render:function(){var e=this.$createElement,t=this._self._c||e;return t("div",{ref:"dropzoneElement",class:{"vue-dropzone dropzone":this.includeStyling},attrs:{id:this.id}},[this.useCustomSlot?t("div",{staticClass:"dz-message"},[this._t("default",[this._v("Drop files here to upload")])],2):this._e()])},staticRenderFns:[]},void 0,{props:{id:{type:String,required:!0,default:"dropzone"},options:{type:Object,required:!0},includeStyling:{type:Boolean,default:!0,required:!1},awss3:{type:Object,required:!1,default:null},destroyDropzone:{type:Boolean,default:!0,required:!1},duplicateCheck:{type:Boolean,default:!1,required:!1},useCustomSlot:{type:Boolean,default:!1,required:!1}},data:()=>({isS3:!1,isS3OverridesServerPropagation:!1,wasQueueAutoProcess:!0}),computed:{dropzoneSettings(){let e={thumbnailWidth:200,thumbnailHeight:200};return Object.keys(this.options).forEach(function(t){e[t]=this.options[t];},this),null!==this.awss3&&(e.autoProcessQueue=!1,this.isS3=!0,this.isS3OverridesServerPropagation=!1===this.awss3.sendFileToServer,void 0!==this.options.autoProcessQueue&&(this.wasQueueAutoProcess=this.options.autoProcessQueue),this.isS3OverridesServerPropagation&&(e.url=(e=>e[0].s3Url))),e}},mounted(){if(this.$isServer&&this.hasBeenMounted)return;this.hasBeenMounted=!0,this.dropzone=new t(this.$refs.dropzoneElement,this.dropzoneSettings);let e=this;this.dropzone.on("thumbnail",function(t,i){e.$emit("vdropzone-thumbnail",t,i);}),this.dropzone.on("addedfile",function(t){var i,n;if(e.duplicateCheck&&this.files.length)for(i=0,n=this.files.length;i<n-1;i++)this.files[i].name===t.name&&this.files[i].size===t.size&&this.files[i].lastModifiedDate.toString()===t.lastModifiedDate.toString()&&(this.removeFile(t),e.$emit("vdropzone-duplicate-file",t));e.$emit("vdropzone-file-added",t),e.isS3&&e.wasQueueAutoProcess&&!t.manuallyAdded&&e.getSignedAndUploadToS3(t);}),this.dropzone.on("addedfiles",function(t){e.$emit("vdropzone-files-added",t);}),this.dropzone.on("removedfile",function(t){e.$emit("vdropzone-removed-file",t),t.manuallyAdded&&null!==e.dropzone.options.maxFiles&&e.dropzone.options.maxFiles++;}),this.dropzone.on("success",function(t,i){if(e.$emit("vdropzone-success",t,i),e.isS3){if(e.isS3OverridesServerPropagation){var n=(new window.DOMParser).parseFromString(i,"text/xml").firstChild.children[0].innerHTML;e.$emit("vdropzone-s3-upload-success",n);}e.wasQueueAutoProcess&&e.setOption("autoProcessQueue",!1);}}),this.dropzone.on("successmultiple",function(t,i){e.$emit("vdropzone-success-multiple",t,i);}),this.dropzone.on("error",function(t,i,n){e.$emit("vdropzone-error",t,i,n),this.isS3&&e.$emit("vdropzone-s3-upload-error");}),this.dropzone.on("errormultiple",function(t,i,n){e.$emit("vdropzone-error-multiple",t,i,n);}),this.dropzone.on("sending",function(t,i,n){if(e.isS3)if(e.isS3OverridesServerPropagation){let e=t.s3Signature;Object.keys(e).forEach(function(t){n.append(t,e[t]);});}else n.append("s3ObjectLocation",t.s3ObjectLocation);e.$emit("vdropzone-sending",t,i,n);}),this.dropzone.on("sendingmultiple",function(t,i,n){e.$emit("vdropzone-sending-multiple",t,i,n);}),this.dropzone.on("complete",function(t){e.$emit("vdropzone-complete",t);}),this.dropzone.on("completemultiple",function(t){e.$emit("vdropzone-complete-multiple",t);}),this.dropzone.on("canceled",function(t){e.$emit("vdropzone-canceled",t);}),this.dropzone.on("canceledmultiple",function(t){e.$emit("vdropzone-canceled-multiple",t);}),this.dropzone.on("maxfilesreached",function(t){e.$emit("vdropzone-max-files-reached",t);}),this.dropzone.on("maxfilesexceeded",function(t){e.$emit("vdropzone-max-files-exceeded",t);}),this.dropzone.on("processing",function(t){e.$emit("vdropzone-processing",t);}),this.dropzone.on("processingmultiple",function(t){e.$emit("vdropzone-processing-multiple",t);}),this.dropzone.on("uploadprogress",function(t,i,n){e.$emit("vdropzone-upload-progress",t,i,n);}),this.dropzone.on("totaluploadprogress",function(t,i,n){e.$emit("vdropzone-total-upload-progress",t,i,n);}),this.dropzone.on("reset",function(){e.$emit("vdropzone-reset");}),this.dropzone.on("queuecomplete",function(){e.$emit("vdropzone-queue-complete");}),this.dropzone.on("drop",function(t){e.$emit("vdropzone-drop",t);}),this.dropzone.on("dragstart",function(t){e.$emit("vdropzone-drag-start",t);}),this.dropzone.on("dragend",function(t){e.$emit("vdropzone-drag-end",t);}),this.dropzone.on("dragenter",function(t){e.$emit("vdropzone-drag-enter",t);}),this.dropzone.on("dragover",function(t){e.$emit("vdropzone-drag-over",t);}),this.dropzone.on("dragleave",function(t){e.$emit("vdropzone-drag-leave",t);}),e.$emit("vdropzone-mounted");},beforeDestroy(){this.destroyDropzone&&this.dropzone.destroy();},methods:{manuallyAddFile:function(e,t){e.manuallyAdded=!0,this.dropzone.emit("addedfile",e);let i=!1;if((t.indexOf(".svg")>-1||t.indexOf(".png")>-1||t.indexOf(".jpg")>-1||t.indexOf(".jpeg")>-1||t.indexOf(".gif")>-1||t.indexOf(".webp")>-1)&&(i=!0),this.dropzone.options.createImageThumbnails&&i&&e.size<=1024*this.dropzone.options.maxThumbnailFilesize*1024){t&&this.dropzone.emit("thumbnail",e,t);for(var n=e.previewElement.querySelectorAll("[data-dz-thumbnail]"),r=0;r<n.length;r++)n[r].style.width=this.dropzoneSettings.thumbnailWidth+"px",n[r].style.height=this.dropzoneSettings.thumbnailHeight+"px",n[r].style["object-fit"]="contain";}this.dropzone.emit("complete",e),this.dropzone.options.maxFiles&&this.dropzone.options.maxFiles--,this.dropzone.files.push(e),this.$emit("vdropzone-file-added-manually",e);},setOption:function(e,t){this.dropzone.options[e]=t;},removeAllFiles:function(e){this.dropzone.removeAllFiles(e);},processQueue:function(){let e=this.dropzone;this.isS3&&!this.wasQueueAutoProcess?this.getQueuedFiles().forEach(e=>{this.getSignedAndUploadToS3(e);}):this.dropzone.processQueue(),this.dropzone.on("success",function(){e.options.autoProcessQueue=!0;}),this.dropzone.on("queuecomplete",function(){e.options.autoProcessQueue=!1;});},init:function(){return this.dropzone.init()},destroy:function(){return this.dropzone.destroy()},updateTotalUploadProgress:function(){return this.dropzone.updateTotalUploadProgress()},getFallbackForm:function(){return this.dropzone.getFallbackForm()},getExistingFallback:function(){return this.dropzone.getExistingFallback()},setupEventListeners:function(){return this.dropzone.setupEventListeners()},removeEventListeners:function(){return this.dropzone.removeEventListeners()},disable:function(){return this.dropzone.disable()},enable:function(){return this.dropzone.enable()},filesize:function(e){return this.dropzone.filesize(e)},accept:function(e,t){return this.dropzone.accept(e,t)},addFile:function(e){return this.dropzone.addFile(e)},removeFile:function(e){this.dropzone.removeFile(e);},getAcceptedFiles:function(){return this.dropzone.getAcceptedFiles()},getRejectedFiles:function(){return this.dropzone.getRejectedFiles()},getFilesWithStatus:function(){return this.dropzone.getFilesWithStatus()},getQueuedFiles:function(){return this.dropzone.getQueuedFiles()},getUploadingFiles:function(){return this.dropzone.getUploadingFiles()},getAddedFiles:function(){return this.dropzone.getAddedFiles()},getActiveFiles:function(){return this.dropzone.getActiveFiles()},getSignedAndUploadToS3(e){var t=i.sendFile(e,this.awss3,this.isS3OverridesServerPropagation);this.isS3OverridesServerPropagation?t.then(()=>{setTimeout(()=>this.dropzone.processFile(e));}):t.then(t=>{t.success?(e.s3ObjectLocation=t.message,setTimeout(()=>this.dropzone.processFile(e)),this.$emit("vdropzone-s3-upload-success",t.message)):void 0!==t.message?this.$emit("vdropzone-s3-upload-error",t.message):this.$emit("vdropzone-s3-upload-error","Network Error : Could not send request to AWS. (Maybe CORS error)");}),t.catch(e=>{alert(e);});},setAWSSigningURL(e){this.isS3&&(this.awss3.signingURL=e);}}},void 0,!1,void 0,void 0,void 0)});

});

var script$e = {
  components: {
    vue2Dropzone: vue2Dropzone,
    ValidationProvider: ValidationProvider
  },
  mixins: [__vue_component__$b],
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      dropzoneOptions: undefined,
      canRemove: true,
      maxFilesize: 5,
      alertUpload: {
        text: this.$t('newChatBot.actions.edit.media.alertFileSizeExtension', {
          maxFilesize: 1
        }),
        type: ''
      },
      aboutDescription: '',
      thumbUrl: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.dropzoneOptions = {
      url: "".concat(window.octadesk.apis.chatUrl, "/upload"),
      maxFilesize: this.maxFilesize,
      maxFiles: 1,
      dictDefaultMessage: "<i class=\"icon-wp-camera\"></i>",
      dictFileTooBig: this.$t('whatsappApiModal.profileInfo.personaInfo.profilePicture.dropzone.dictFileTooBig', {
        maxFilesize: this.maxFilesize
      }),
      dictResponseError: this.$t('whatsappApiModal.profileInfo.personaInfo.profilePicture.dropzone.dictResponseError'),
      dictCancelUpload: '',
      dictCancelUploadConfirmation: this.$t('whatsappApiModal.profileInfo.personaInfo.profilePicture.dropzone.dictCancelUploadConfirmation'),
      dictRemoveFile: '',
      dictInvalidFileType: this.$t('whatsappApiModal.profileInfo.personaInfo.profilePicture.dropzone.dictInvalidFileType'),
      dictMaxFilesExceeded: this.$t('whatsappApiModal.profileInfo.personaInfo.profilePicture.dropzone.dictMaxFilesExceeded', {
        maxFiles: 1
      }),
      addRemoveLinks: false,
      clickable: true,
      headers: {
        AppSubDomain: Storage.getItem('company'),
        'X-Requested-With': null
      },
      acceptedFiles: 'image/jpeg, image/png',
      destroyDropzone: false
    };
    this.unwatch = this.$store.watch(function (state, getters) {
      _this.wppApiNumber = getters.wppApiNumber;

      if (_this.wppApiNumber && _this.wppApiNumber.customFields) {
        if (_this.wppApiNumber.customFields.thumbUrl) {
          _this.thumbUrl = _this.wppApiNumber.customFields.thumbUrl;
        }

        if (_this.wppApiNumber.customFields.aboutDescription) {
          _this.aboutDescription = _this.wppApiNumber.customFields.aboutDescription;
        }
      }
    });
  },
  beforeMount: function beforeMount() {
    document.addEventListener('click', this.handleErrorClickDropZone);
  },
  beforeDestroy: function beforeDestroy() {
    document.addEventListener('click', this.handleErrorClickDropZone);
    this.canRemove = false;
    this.$refs.dropzoneWppApi.destroy();
  },
  methods: _objectSpread2(_objectSpread2({}, mapActions(['handleUpdate', 'setCurrentWhatsappApiNumber'])), {}, {
    onAddSuccess: function onAddSuccess(file, response) {
      this.thumbUrl = response.url;
      this.handleUpdate('thumbUrl');
    },
    onDropzoneMounted: function onDropzoneMounted() {
      if (this.thumbUrl) {
        var fileName = this.thumbUrl.split('/').pop();
        var fileType = this.thumbUrl.split('.').pop();
        this.$refs.dropzoneWppApi.manuallyAddFile({
          size: 123,
          name: fileName.replace(".".concat(fileType), ''),
          type: "image/".concat(fileType)
        }, this.thumbUrl);
      }
    },
    onUploadProgress: function onUploadProgress(file, progress) {
      if (!document.querySelector('.dz-progress span.dz-number')) {
        document.querySelector('.dz-progress').innerHTML += '<span class="dz-number"></span>';
      }

      document.querySelector('.dz-progress span.dz-number').innerText = "".concat(parseInt(progress, 10), "%");
    },
    handleUploadFile: function handleUploadFile() {
      this.handleRemovePicture();
      document.querySelector('#dropzone-bot').click();
    },
    handleRemovePicture: function handleRemovePicture() {
      this.$refs.dropzoneWppApi.removeAllFiles();
      this.thumbUrl = '';
      this.handleUpdate('thumbUrl');
    },
    handleErrorClickDropZone: function handleErrorClickDropZone(e) {
      if (e.srcElement.className === 'dz-error-message') {
        this.handleUploadFile();
      }
    },
    handleUpdate: function handleUpdate(field) {
      // eslint-disable-next-line
      var updatedNumber = {
        customFields: _objectSpread2({}, this.wppApiNumber.customFields)
      };
      updatedNumber.customFields[field] = this[field];
      this.setCurrentWhatsappApiNumber(updatedNumber);
    }
  })
};

/* script */
var __vue_script__$e = script$e;
/* template */

var __vue_render__$g = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    staticClass: "persona-info-container"
  }, [_c("div", {
    staticClass: "profile-picture"
  }, [_c("div", {
    staticClass: "content-item"
  }, [_c("h3", [_vm._v("\n        " + _vm._s(_vm.$t("whatsappApiModal.profileInfo.personaInfo.profilePicture.title")) + "\n      ")]), _vm._v(" "), _c("p", [_vm._v("\n        " + _vm._s(_vm.$t("whatsappApiModal.profileInfo.personaInfo.profilePicture.description")) + "\n      ")])]), _vm._v(" "), _c("div", {
    staticClass: "picture-upload"
  }, [_vm.thumbUrl !== "" ? _c("div", {
    staticClass: "picture-actions"
  }, [_c("div", [_c("button", {
    on: {
      click: _vm.handleUploadFile
    }
  }, [_c("i", {
    staticClass: "icon-wp-edit"
  })]), _vm._v(" "), _c("button", {
    on: {
      click: _vm.handleRemovePicture
    }
  }, [_c("i", {
    staticClass: "icon-wp-delete"
  })])]), _vm._v(" "), _c("p", [_vm._v("\n          " + _vm._s(_vm.$t("whatsappApiModal.profileInfo.personaInfo.profilePicture.editPicture")) + "\n        ")])]) : _vm._e(), _vm._v(" "), _vm.dropzoneOptions ? _c("vue2Dropzone", {
    ref: "dropzoneWppApi",
    staticClass: "attachment-preview octadesk-app-attachment-preview",
    attrs: {
      id: "dropzone-bot",
      options: _vm.dropzoneOptions
    },
    on: {
      "vdropzone-success": _vm.onAddSuccess,
      "vdropzone-mounted": _vm.onDropzoneMounted,
      "vdropzone-upload-progress": _vm.onUploadProgress
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c("div", {
    staticClass: "business-description"
  }, [_c("div", {
    staticClass: "content-item"
  }, [_c("h3", [_vm._v("\n        " + _vm._s(_vm.$t("whatsappApiModal.profileInfo.personaInfo.aboutDescription.title")) + "\n      ")]), _vm._v(" "), _c("p", [_vm._v("\n        " + _vm._s(_vm.$t("whatsappApiModal.profileInfo.personaInfo.aboutDescription.description")) + "\n      ")]), _vm._v(" "), _c("div", {
    class: {
      disabled: _vm.loading
    }
  }, [_c("ValidationProvider", {
    ref: "aboutDescriptionProvider",
    attrs: {
      name: "aboutDescription",
      rules: "max:256"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(ref) {
        var errors = ref.errors;
        var valid = ref.valid;
        var dirty = ref.dirty;
        return [_c("div", {
          staticClass: "fields-control-wpp",
          class: [_vm.validationClass({
            errors: errors,
            valid: valid,
            dirty: dirty,
            value: _vm.aboutDescription
          })]
        }, [_c("div", [_c("textarea", {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: _vm.aboutDescription,
            expression: "aboutDescription"
          }],
          attrs: {
            placeholder: _vm.$t("whatsappApiModal.profileInfo.personaInfo.aboutDescription.placeholder"),
            disabled: _vm.loading
          },
          domProps: {
            value: _vm.aboutDescription
          },
          on: {
            blur: function blur($event) {
              return _vm.handleUpdate("aboutDescription");
            },
            input: function input($event) {
              if ($event.target.composing) {
                return;
              }

              _vm.aboutDescription = $event.target.value;
            }
          }
        })]), _vm._v(" "), errors.length ? _c("span", {
          staticClass: "error-message"
        }, [_vm._v("\n              " + _vm._s(_vm.$t("whatsappApiModal.profileInfo.personaInfo.aboutDescription.error")) + "\n            ")]) : _vm._e()])];
      }
    }])
  })], 1)])])]);
};

var __vue_staticRenderFns__$g = [];
__vue_render__$g._withStripped = true;
/* style */

var __vue_inject_styles__$i = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-9ab75e14_0", {
    source: "@charset \"UTF-8\";\n.persona-info-container {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n}\n.persona-info-container div.profile-picture {\n  width: 50%;\n  padding: 0 56px 0 53px;\n  text-align: center;\n}\n.persona-info-container div.profile-picture div.picture-upload {\n  width: 140px;\n  height: 140px;\n  display: inline-block;\n  margin: 0 auto;\n  border-radius: 100%;\n  box-sizing: border-box;\n  position: relative;\n}\n.persona-info-container div.profile-picture div.picture-upload div.picture-actions {\n  opacity: 0;\n  transition: 0.5s;\n  position: absolute;\n  z-index: 20;\n  top: 0px;\n  left: 0px;\n  width: 100%;\n  height: 100%;\n  border-radius: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  background: rgba(212, 231, 255, 0.9);\n}\n.persona-info-container div.profile-picture div.picture-upload div.picture-actions div {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.persona-info-container div.profile-picture div.picture-upload div.picture-actions div button {\n  width: 25px;\n  height: 25px;\n  margin: 0px 5px;\n  border-radius: 50%;\n  border: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #4b9bfc;\n}\n.persona-info-container div.profile-picture div.picture-upload div.picture-actions div button i {\n  font-size: 10px;\n  color: #ffffff;\n}\n.persona-info-container div.profile-picture div.picture-upload div.picture-actions div button i.icon-wp-edit {\n  font-size: 12px;\n  margin: -2px 0px 0px 2px;\n}\n.persona-info-container div.profile-picture div.picture-upload div.picture-actions p {\n  width: 100%;\n  font-size: 13px;\n  line-height: 15px;\n  text-align: center;\n  color: #4b9bfc;\n  margin-top: 5px;\n}\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  z-index: 10;\n  padding: 0px;\n  min-height: auto;\n  border-radius: 50%;\n  border: none;\n  background: #d4e7ff;\n}\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview > div {\n  width: 100%;\n  height: 100%;\n  margin: 0px;\n  min-height: auto;\n  border-radius: 50%;\n}\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview div.dz-default {\n  border: 1px solid #0074ff;\n}\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview div.dz-default span {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview div.dz-default span i {\n  font-size: 27px;\n  color: #2689ff;\n}\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview div.dz-preview {\n  border: 1px solid #0074ff;\n  background: #d4e7ff;\n}\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview div.dz-preview > div:not(.dz-progress) {\n  width: 100%;\n  height: 100%;\n  padding: 10px;\n  border-radius: 50% !important;\n  top: 0px;\n  left: 0px;\n  margin: 0px;\n  display: flex !important;\n  justify-content: center;\n  align-items: center;\n  background: none;\n}\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview div.dz-preview div.dz-details,\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview div.dz-preview div.dz-success-mark,\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview div.dz-preview div.dz-error-mark {\n  display: none !important;\n}\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview div.dz-preview div.dz-progress {\n  width: 100px;\n  height: 10px;\n  border: 1px solid #0074ff;\n  border-radius: 100px;\n  margin: 5px 0px 0px 0px;\n  transform: translate(-50%, -50%);\n  overflow: unset;\n  background: #ffffff;\n}\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview div.dz-preview div.dz-progress span.dz-upload {\n  background: #0074ff;\n}\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview div.dz-preview div.dz-progress span.dz-number {\n  position: absolute;\n  top: -25px;\n  left: 0px;\n  width: 100%;\n  text-align: center;\n  font-size: 13px;\n  font-weight: bold;\n  color: #0074ff;\n}\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview div.dz-preview div.dz-image {\n  opacity: 0;\n  padding: 0px;\n}\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview div.dz-preview div.dz-image:before {\n  content: \"\";\n  font-family: \"icomoonWp\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  font-size: 27px;\n  transform: translate(-50%, -50%);\n  color: #2689ff;\n}\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview div.dz-preview div.dz-image img {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  width: auto !important;\n  height: 100% !important;\n  transform: translate(-50%, -50%) scale(1, 1);\n  filter: blur(0px);\n}\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview div.dz-preview div.dz-error-message {\n  cursor: pointer;\n  background: #fcf2d1;\n}\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview div.dz-preview div.dz-error-message span {\n  width: 100%;\n  color: #f6c216;\n  font-size: 13px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  pointer-events: none;\n}\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview div.dz-preview div.dz-error-message span:before {\n  font-family: \"icomoonWp\";\n  content: \"\";\n  font-size: 24px;\n}\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview div.dz-preview div.dz-error-message:hover span:before {\n  content: \"\";\n}\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview div.dz-preview a.dz-remove {\n  display: none;\n  top: -10px;\n  right: 0px;\n  bottom: auto;\n  opacity: 0;\n  margin: 0px;\n  padding: 0px;\n  text-decoration: none;\n  border: none;\n  transition: 0.5s;\n}\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview div.dz-preview a.dz-remove:before {\n  font-family: \"icomoonWp\";\n  content: \"\";\n  color: #ef2066;\n  font-size: 18px;\n}\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview div.dz-preview:hover a.dz-remove {\n  opacity: 1;\n}\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview div.dz-preview.dz-error {\n  border: 1px solid #f6c216;\n}\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview div.dz-preview.dz-error div.dz-error-message {\n  opacity: 1;\n}\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview div.dz-preview.dz-complete div.dz-image {\n  opacity: 1;\n}\n.persona-info-container div.profile-picture div.picture-upload:hover div.picture-actions {\n  opacity: 1;\n}\n.persona-info-container div.business-description {\n  width: 50%;\n  padding: 0 26px 0 48px;\n  border-left: 1px solid #d7d7d7;\n}\n.persona-info-container div.business-description textarea {\n  height: 170px;\n}\n.persona-info-container div.content-item {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  text-align: left;\n}\n.persona-info-container div.content-item h3,\n.persona-info-container div.content-item p {\n  font-family: Helvetica;\n  font-style: normal;\n}\n.persona-info-container div.content-item h3 {\n  font-weight: bold;\n  font-size: 12px;\n  line-height: 14px;\n  color: #0074ff;\n  margin-top: 0;\n}\n.persona-info-container div.content-item p {\n  font-weight: normal;\n  font-size: 10px;\n  line-height: 16px;\n  color: #575757;\n  margin-bottom: 18px;\n}\n.persona-info-container div.content-item > div {\n  width: 100%;\n}\n.persona-info-container div.content-item > div.disabled textarea {\n  cursor: not-allowed;\n  color: #bfbfbf;\n  pointer-events: none;\n  background: #f0f0f0;\n}\n\n/*# sourceMappingURL=WhatsappApiPersonaInfo.vue.map */",
    map: {
      "version": 3,
      "sources": ["WhatsappApiPersonaInfo.vue", "E:\\Octadesk\\octa-whatsapp-client\\src\\app\\whatsapp-api\\components\\modal\\WhatsappApiPersonaInfo.vue"],
      "names": [],
      "mappings": "AAAA,gBAAgB;ACmShB;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;ADjSA;ACkSA;EACA,UAAA;EACA,sBAAA;EACA,kBAAA;ADhSA;ACiSA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;AD/RA;ACgSA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,oCAAA;AD9RA;AC+RA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AD7RA;AC8RA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AD5RA;AC6RA;EACA,eAAA;EACA,cAAA;AD3RA;AC4RA;EACA,eAAA;EACA,wBAAA;AD1RA;AC+RA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AD7RA;ACgSA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;AD9RA;AC+RA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AD7RA;AC+RA;EACA,yBAAA;AD7RA;AC8RA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AD5RA;AC6RA;EACA,eAAA;EACA,cAAA;AD3RA;AC+RA;EACA,yBAAA;EACA,mBAAA;AD7RA;AC8RA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,6BAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,wBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AD5RA;AC8RA;;;EAGA,wBAAA;AD5RA;AC8RA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,oBAAA;EACA,uBAAA;EACA,gCAAA;EACA,eAAA;EACA,mBAAA;AD5RA;AC6RA;EACA,mBAAA;AD3RA;AC6RA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AD3RA;AC8RA;EACA,UAAA;EACA,YAAA;AD5RA;AC6RA;EACA,YAAA;EACA,wBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,gCAAA;EACA,cAAA;AD3RA;AC6RA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,sBAAA;EACA,uBAAA;EACA,4CAAA;EACA,iBAAA;AD3RA;AC8RA;EACA,eAAA;EACA,mBAAA;AD5RA;AC6RA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,oBAAA;AD3RA;AC4RA;EACA,wBAAA;EACA,YAAA;EACA,eAAA;AD1RA;AC+RA;EACA,YAAA;AD7RA;ACkSA;EACA,aAAA;EACA,UAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,gBAAA;ADhSA;ACiSA;EACA,wBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AD/RA;ACmSA;EACA,UAAA;ADjSA;ACoSA;EACA,yBAAA;ADlSA;ACmSA;EACA,UAAA;ADjSA;ACoSA;EACA,UAAA;ADlSA;ACsSA;EACA,UAAA;ADpSA;ACwSA;EACA,UAAA;EACA,sBAAA;EACA,8BAAA;ADtSA;ACuSA;EACA,aAAA;ADrSA;ACwSA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;ADtSA;ACuSA;;EAEA,sBAAA;EACA,kBAAA;ADrSA;ACuSA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;ADrSA;ACuSA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;ADrSA;ACuSA;EACA,WAAA;ADrSA;ACsSA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;ADpSA;;AAEA,qDAAqD",
      "file": "WhatsappApiPersonaInfo.vue",
      "sourcesContent": ["@charset \"UTF-8\";\n.persona-info-container {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n}\n.persona-info-container div.profile-picture {\n  width: 50%;\n  padding: 0 56px 0 53px;\n  text-align: center;\n}\n.persona-info-container div.profile-picture div.picture-upload {\n  width: 140px;\n  height: 140px;\n  display: inline-block;\n  margin: 0 auto;\n  border-radius: 100%;\n  box-sizing: border-box;\n  position: relative;\n}\n.persona-info-container div.profile-picture div.picture-upload div.picture-actions {\n  opacity: 0;\n  transition: 0.5s;\n  position: absolute;\n  z-index: 20;\n  top: 0px;\n  left: 0px;\n  width: 100%;\n  height: 100%;\n  border-radius: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  background: rgba(212, 231, 255, 0.9);\n}\n.persona-info-container div.profile-picture div.picture-upload div.picture-actions div {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.persona-info-container div.profile-picture div.picture-upload div.picture-actions div button {\n  width: 25px;\n  height: 25px;\n  margin: 0px 5px;\n  border-radius: 50%;\n  border: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #4b9bfc;\n}\n.persona-info-container div.profile-picture div.picture-upload div.picture-actions div button i {\n  font-size: 10px;\n  color: #ffffff;\n}\n.persona-info-container div.profile-picture div.picture-upload div.picture-actions div button i.icon-wp-edit {\n  font-size: 12px;\n  margin: -2px 0px 0px 2px;\n}\n.persona-info-container div.profile-picture div.picture-upload div.picture-actions p {\n  width: 100%;\n  font-size: 13px;\n  line-height: 15px;\n  text-align: center;\n  color: #4b9bfc;\n  margin-top: 5px;\n}\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  z-index: 10;\n  padding: 0px;\n  min-height: auto;\n  border-radius: 50%;\n  border: none;\n  background: #d4e7ff;\n}\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview > div {\n  width: 100%;\n  height: 100%;\n  margin: 0px;\n  min-height: auto;\n  border-radius: 50%;\n}\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview div.dz-default {\n  border: 1px solid #0074ff;\n}\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview div.dz-default span {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview div.dz-default span i {\n  font-size: 27px;\n  color: #2689ff;\n}\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview div.dz-preview {\n  border: 1px solid #0074ff;\n  background: #d4e7ff;\n}\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview div.dz-preview > div:not(.dz-progress) {\n  width: 100%;\n  height: 100%;\n  padding: 10px;\n  border-radius: 50% !important;\n  top: 0px;\n  left: 0px;\n  margin: 0px;\n  display: flex !important;\n  justify-content: center;\n  align-items: center;\n  background: none;\n}\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview div.dz-preview div.dz-details,\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview div.dz-preview div.dz-success-mark,\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview div.dz-preview div.dz-error-mark {\n  display: none !important;\n}\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview div.dz-preview div.dz-progress {\n  width: 100px;\n  height: 10px;\n  border: 1px solid #0074ff;\n  border-radius: 100px;\n  margin: 5px 0px 0px 0px;\n  transform: translate(-50%, -50%);\n  overflow: unset;\n  background: #ffffff;\n}\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview div.dz-preview div.dz-progress span.dz-upload {\n  background: #0074ff;\n}\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview div.dz-preview div.dz-progress span.dz-number {\n  position: absolute;\n  top: -25px;\n  left: 0px;\n  width: 100%;\n  text-align: center;\n  font-size: 13px;\n  font-weight: bold;\n  color: #0074ff;\n}\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview div.dz-preview div.dz-image {\n  opacity: 0;\n  padding: 0px;\n}\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview div.dz-preview div.dz-image:before {\n  content: \"\";\n  font-family: \"icomoonWp\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  font-size: 27px;\n  transform: translate(-50%, -50%);\n  color: #2689ff;\n}\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview div.dz-preview div.dz-image img {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  width: auto !important;\n  height: 100% !important;\n  transform: translate(-50%, -50%) scale(1, 1);\n  filter: blur(0px);\n}\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview div.dz-preview div.dz-error-message {\n  cursor: pointer;\n  background: #fcf2d1;\n}\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview div.dz-preview div.dz-error-message span {\n  width: 100%;\n  color: #f6c216;\n  font-size: 13px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  pointer-events: none;\n}\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview div.dz-preview div.dz-error-message span:before {\n  font-family: \"icomoonWp\";\n  content: \"\";\n  font-size: 24px;\n}\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview div.dz-preview div.dz-error-message:hover span:before {\n  content: \"\";\n}\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview div.dz-preview a.dz-remove {\n  display: none;\n  top: -10px;\n  right: 0px;\n  bottom: auto;\n  opacity: 0;\n  margin: 0px;\n  padding: 0px;\n  text-decoration: none;\n  border: none;\n  transition: 0.5s;\n}\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview div.dz-preview a.dz-remove:before {\n  font-family: \"icomoonWp\";\n  content: \"\";\n  color: #ef2066;\n  font-size: 18px;\n}\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview div.dz-preview:hover a.dz-remove {\n  opacity: 1;\n}\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview div.dz-preview.dz-error {\n  border: 1px solid #f6c216;\n}\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview div.dz-preview.dz-error div.dz-error-message {\n  opacity: 1;\n}\n.persona-info-container div.profile-picture div.picture-upload div.octadesk-app-attachment-preview div.dz-preview.dz-complete div.dz-image {\n  opacity: 1;\n}\n.persona-info-container div.profile-picture div.picture-upload:hover div.picture-actions {\n  opacity: 1;\n}\n.persona-info-container div.business-description {\n  width: 50%;\n  padding: 0 26px 0 48px;\n  border-left: 1px solid #d7d7d7;\n}\n.persona-info-container div.business-description textarea {\n  height: 170px;\n}\n.persona-info-container div.content-item {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  text-align: left;\n}\n.persona-info-container div.content-item h3,\n.persona-info-container div.content-item p {\n  font-family: Helvetica;\n  font-style: normal;\n}\n.persona-info-container div.content-item h3 {\n  font-weight: bold;\n  font-size: 12px;\n  line-height: 14px;\n  color: #0074ff;\n  margin-top: 0;\n}\n.persona-info-container div.content-item p {\n  font-weight: normal;\n  font-size: 10px;\n  line-height: 16px;\n  color: #575757;\n  margin-bottom: 18px;\n}\n.persona-info-container div.content-item > div {\n  width: 100%;\n}\n.persona-info-container div.content-item > div.disabled textarea {\n  cursor: not-allowed;\n  color: #bfbfbf;\n  pointer-events: none;\n  background: #f0f0f0;\n}\n\n/*# sourceMappingURL=WhatsappApiPersonaInfo.vue.map */", "<template>\r\n  <div class=\"persona-info-container\">\r\n    <div class=\"profile-picture\">\r\n      <div class=\"content-item\">\r\n        <h3>\r\n          {{\r\n            $t('whatsappApiModal.profileInfo.personaInfo.profilePicture.title')\r\n          }}\r\n        </h3>\r\n\r\n        <p>\r\n          {{\r\n            $t(\r\n              'whatsappApiModal.profileInfo.personaInfo.profilePicture.description'\r\n            )\r\n          }}\r\n        </p>\r\n      </div>\r\n\r\n      <div class=\"picture-upload\">\r\n        <div class=\"picture-actions\" v-if=\"thumbUrl !== ''\">\r\n          <div>\r\n            <button @click=\"handleUploadFile\">\r\n              <i class=\"icon-wp-edit\"></i>\r\n            </button>\r\n\r\n            <button @click=\"handleRemovePicture\">\r\n              <i class=\"icon-wp-delete\"></i>\r\n            </button>\r\n          </div>\r\n\r\n          <p>\r\n            {{\r\n              $t(\r\n                'whatsappApiModal.profileInfo.personaInfo.profilePicture.editPicture'\r\n              )\r\n            }}\r\n          </p>\r\n        </div>\r\n\r\n        <vue2Dropzone\r\n          v-if=\"dropzoneOptions\"\r\n          id=\"dropzone-bot\"\r\n          ref=\"dropzoneWppApi\"\r\n          class=\"attachment-preview octadesk-app-attachment-preview\"\r\n          :options=\"dropzoneOptions\"\r\n          @vdropzone-success=\"onAddSuccess\"\r\n          @vdropzone-mounted=\"onDropzoneMounted\"\r\n          @vdropzone-upload-progress=\"onUploadProgress\"\r\n        ></vue2Dropzone>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"business-description\">\r\n      <div class=\"content-item\">\r\n        <h3>\r\n          {{\r\n            $t(\r\n              'whatsappApiModal.profileInfo.personaInfo.aboutDescription.title'\r\n            )\r\n          }}\r\n        </h3>\r\n\r\n        <p>\r\n          {{\r\n            $t(\r\n              'whatsappApiModal.profileInfo.personaInfo.aboutDescription.description'\r\n            )\r\n          }}\r\n        </p>\r\n\r\n        <div :class=\"{ disabled: loading }\">\r\n          <ValidationProvider\r\n            v-slot=\"{ errors, valid, dirty }\"\r\n            name=\"aboutDescription\"\r\n            rules=\"max:256\"\r\n            ref=\"aboutDescriptionProvider\"\r\n          >\r\n            <div\r\n              class=\"fields-control-wpp\"\r\n              :class=\"[\r\n                validationClass({\r\n                  errors,\r\n                  valid,\r\n                  dirty,\r\n                  value: aboutDescription\r\n                })\r\n              ]\"\r\n            >\r\n              <div>\r\n                <textarea\r\n                  :placeholder=\"\r\n                    $t(\r\n                      'whatsappApiModal.profileInfo.personaInfo.aboutDescription.placeholder'\r\n                    )\r\n                  \"\r\n                  v-model=\"aboutDescription\"\r\n                  @blur=\"handleUpdate('aboutDescription')\"\r\n                  :disabled=\"loading\"\r\n                />\r\n              </div>\r\n\r\n              <span v-if=\"errors.length\" class=\"error-message\">\r\n                {{\r\n                  $t(\r\n                    'whatsappApiModal.profileInfo.personaInfo.aboutDescription.error'\r\n                  )\r\n                }}\r\n              </span>\r\n            </div>\r\n          </ValidationProvider>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</template>\r\n\r\n<script>\r\n  import vue2Dropzone from 'vue2-dropzone'\r\n\r\n  import 'vue2-dropzone/dist/vue2Dropzone.min.css'\r\n\r\n  import Storage from '@octadesk/storage'\r\n\r\n  import { mapActions } from 'vuex'\r\n\r\n  import GlobalMixins from '@/app/mixins'\r\n\r\n  import { ValidationProvider } from 'vee-validate'\r\n\r\n  import '@/helpers/validations'\r\n\r\n  export default {\r\n    components: {\r\n      vue2Dropzone,\r\n      ValidationProvider\r\n    },\r\n    mixins: [GlobalMixins],\r\n    props: {\r\n      loading: {\r\n        type: Boolean,\r\n        required: false,\r\n        default: false\r\n      }\r\n    },\r\n    data() {\r\n      return {\r\n        dropzoneOptions: undefined,\r\n        canRemove: true,\r\n        maxFilesize: 5,\r\n        alertUpload: {\r\n          text: this.$t(\r\n            'newChatBot.actions.edit.media.alertFileSizeExtension',\r\n            {\r\n              maxFilesize: 1\r\n            }\r\n          ),\r\n          type: ''\r\n        },\r\n        aboutDescription: '',\r\n        thumbUrl: ''\r\n      }\r\n    },\r\n    mounted() {\r\n      this.dropzoneOptions = {\r\n        url: `${window.octadesk.apis.chatUrl}/upload`,\r\n        maxFilesize: this.maxFilesize,\r\n        maxFiles: 1,\r\n        dictDefaultMessage: `<i class=\"icon-wp-camera\"></i>`,\r\n        dictFileTooBig: this.$t(\r\n          'whatsappApiModal.profileInfo.personaInfo.profilePicture.dropzone.dictFileTooBig',\r\n          {\r\n            maxFilesize: this.maxFilesize\r\n          }\r\n        ),\r\n        dictResponseError: this.$t(\r\n          'whatsappApiModal.profileInfo.personaInfo.profilePicture.dropzone.dictResponseError'\r\n        ),\r\n        dictCancelUpload: '',\r\n        dictCancelUploadConfirmation: this.$t(\r\n          'whatsappApiModal.profileInfo.personaInfo.profilePicture.dropzone.dictCancelUploadConfirmation'\r\n        ),\r\n        dictRemoveFile: '',\r\n        dictInvalidFileType: this.$t(\r\n          'whatsappApiModal.profileInfo.personaInfo.profilePicture.dropzone.dictInvalidFileType'\r\n        ),\r\n        dictMaxFilesExceeded: this.$t(\r\n          'whatsappApiModal.profileInfo.personaInfo.profilePicture.dropzone.dictMaxFilesExceeded',\r\n          { maxFiles: 1 }\r\n        ),\r\n        addRemoveLinks: false,\r\n        clickable: true,\r\n        headers: {\r\n          AppSubDomain: Storage.getItem('company'),\r\n          'X-Requested-With': null\r\n        },\r\n        acceptedFiles: 'image/jpeg, image/png',\r\n        destroyDropzone: false\r\n      }\r\n\r\n      this.unwatch = this.$store.watch((state, getters) => {\r\n        this.wppApiNumber = getters.wppApiNumber\r\n\r\n        if (this.wppApiNumber && this.wppApiNumber.customFields) {\r\n          if (this.wppApiNumber.customFields.thumbUrl) {\r\n            this.thumbUrl = this.wppApiNumber.customFields.thumbUrl\r\n          }\r\n\r\n          if (this.wppApiNumber.customFields.aboutDescription) {\r\n            this.aboutDescription = this.wppApiNumber.customFields.aboutDescription\r\n          }\r\n        }\r\n      })\r\n    },\r\n    beforeMount() {\r\n      document.addEventListener('click', this.handleErrorClickDropZone)\r\n    },\r\n    beforeDestroy() {\r\n      document.addEventListener('click', this.handleErrorClickDropZone)\r\n\r\n      this.canRemove = false\r\n\r\n      this.$refs.dropzoneWppApi.destroy()\r\n    },\r\n    methods: {\r\n      ...mapActions(['handleUpdate', 'setCurrentWhatsappApiNumber']),\r\n      onAddSuccess(file, response) {\r\n        this.thumbUrl = response.url\r\n\r\n        this.handleUpdate('thumbUrl')\r\n      },\r\n      onDropzoneMounted() {\r\n        if (this.thumbUrl) {\r\n          const fileName = this.thumbUrl.split('/').pop()\r\n\r\n          const fileType = this.thumbUrl.split('.').pop()\r\n\r\n          this.$refs.dropzoneWppApi.manuallyAddFile(\r\n            {\r\n              size: 123,\r\n              name: fileName.replace(`.${fileType}`, ''),\r\n              type: `image/${fileType}`\r\n            },\r\n            this.thumbUrl\r\n          )\r\n        }\r\n      },\r\n      onUploadProgress(file, progress) {\r\n        if (!document.querySelector('.dz-progress span.dz-number')) {\r\n          document.querySelector('.dz-progress').innerHTML +=\r\n            '<span class=\"dz-number\"></span>'\r\n        }\r\n\r\n        document.querySelector(\r\n          '.dz-progress span.dz-number'\r\n        ).innerText = `${parseInt(progress, 10)}%`\r\n      },\r\n      handleUploadFile() {\r\n        this.handleRemovePicture()\r\n\r\n        document.querySelector('#dropzone-bot').click()\r\n      },\r\n      handleRemovePicture() {\r\n        this.$refs.dropzoneWppApi.removeAllFiles()\r\n\r\n        this.thumbUrl = ''\r\n\r\n        this.handleUpdate('thumbUrl')\r\n      },\r\n      handleErrorClickDropZone(e) {\r\n        if (e.srcElement.className === 'dz-error-message') {\r\n          this.handleUploadFile()\r\n        }\r\n      },\r\n      handleUpdate(field) {\r\n        // eslint-disable-next-line\r\n        let updatedNumber = {\r\n          customFields: {\r\n            ...this.wppApiNumber.customFields\r\n          }\r\n        }\r\n\r\n        updatedNumber.customFields[field] = this[field]\r\n\r\n        this.setCurrentWhatsappApiNumber(updatedNumber)\r\n      }\r\n    }\r\n  }\r\n</script>\r\n\r\n<style lang=\"scss\">\r\n  .persona-info-container {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    align-items: flex-start;\r\n    justify-content: center;\r\n    div.profile-picture {\r\n      width: 50%;\r\n      padding: 0 56px 0 53px;\r\n      text-align: center;\r\n      div.picture-upload {\r\n        width: 140px;\r\n        height: 140px;\r\n        display: inline-block;\r\n        margin: 0 auto;\r\n        border-radius: 100%;\r\n        box-sizing: border-box;\r\n        position: relative;\r\n        div.picture-actions {\r\n          opacity: 0;\r\n          transition: 0.5s;\r\n          position: absolute;\r\n          z-index: 20;\r\n          top: 0px;\r\n          left: 0px;\r\n          width: 100%;\r\n          height: 100%;\r\n          border-radius: 100%;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n          flex-direction: column;\r\n          background: rgba(212, 231, 255, 0.9);\r\n          div {\r\n            width: 100%;\r\n            display: flex;\r\n            justify-content: center;\r\n            align-items: center;\r\n            button {\r\n              width: 25px;\r\n              height: 25px;\r\n              margin: 0px 5px;\r\n              border-radius: 50%;\r\n              border: none;\r\n              display: flex;\r\n              justify-content: center;\r\n              align-items: center;\r\n              background: #4b9bfc;\r\n              i {\r\n                font-size: 10px;\r\n                color: #ffffff;\r\n                &.icon-wp-edit {\r\n                  font-size: 12px;\r\n                  margin: -2px 0px 0px 2px;\r\n                }\r\n              }\r\n            }\r\n          }\r\n          p {\r\n            width: 100%;\r\n            font-size: 13px;\r\n            line-height: 15px;\r\n            text-align: center;\r\n            color: #4b9bfc;\r\n            margin-top: 5px;\r\n          }\r\n        }\r\n        div.octadesk-app-attachment-preview {\r\n          width: 100%;\r\n          height: 100%;\r\n          position: relative;\r\n          z-index: 10;\r\n          padding: 0px;\r\n          min-height: auto;\r\n          border-radius: 50%;\r\n          border: none;\r\n          background: #d4e7ff;\r\n          & > div {\r\n            width: 100%;\r\n            height: 100%;\r\n            margin: 0px;\r\n            min-height: auto;\r\n            border-radius: 50%;\r\n          }\r\n          div.dz-default {\r\n            border: 1px solid #0074ff;\r\n            span {\r\n              width: 100%;\r\n              height: 100%;\r\n              display: flex;\r\n              justify-content: center;\r\n              align-items: center;\r\n              i {\r\n                font-size: 27px;\r\n                color: #2689ff;\r\n              }\r\n            }\r\n          }\r\n          div.dz-preview {\r\n            border: 1px solid #0074ff;\r\n            background: #d4e7ff;\r\n            & > div:not(.dz-progress) {\r\n              width: 100%;\r\n              height: 100%;\r\n              padding: 10px;\r\n              border-radius: 50% !important;\r\n              top: 0px;\r\n              left: 0px;\r\n              margin: 0px;\r\n              display: flex !important;\r\n              justify-content: center;\r\n              align-items: center;\r\n              background: none;\r\n            }\r\n            div.dz-details,\r\n            div.dz-success-mark,\r\n            div.dz-error-mark {\r\n              display: none !important;\r\n            }\r\n            div.dz-progress {\r\n              width: 100px;\r\n              height: 10px;\r\n              border: 1px solid #0074ff;\r\n              border-radius: 100px;\r\n              margin: 5px 0px 0px 0px;\r\n              transform: translate(-50%, -50%);\r\n              overflow: unset;\r\n              background: #ffffff;\r\n              span.dz-upload {\r\n                background: #0074ff;\r\n              }\r\n              span.dz-number {\r\n                position: absolute;\r\n                top: -25px;\r\n                left: 0px;\r\n                width: 100%;\r\n                text-align: center;\r\n                font-size: 13px;\r\n                font-weight: bold;\r\n                color: #0074ff;\r\n              }\r\n            }\r\n            div.dz-image {\r\n              opacity: 0;\r\n              padding: 0px;\r\n              &:before {\r\n                content: '\\e90e';\r\n                font-family: 'icomoonWp';\r\n                position: absolute;\r\n                top: 50%;\r\n                left: 50%;\r\n                font-size: 27px;\r\n                transform: translate(-50%, -50%);\r\n                color: #2689ff;\r\n              }\r\n              img {\r\n                position: absolute;\r\n                left: 50%;\r\n                top: 50%;\r\n                width: auto !important;\r\n                height: 100% !important;\r\n                transform: translate(-50%, -50%) scale(1, 1);\r\n                filter: blur(0px);\r\n              }\r\n            }\r\n            div.dz-error-message {\r\n              cursor: pointer;\r\n              background: #fcf2d1;\r\n              span {\r\n                width: 100%;\r\n                color: #f6c216;\r\n                font-size: 13px;\r\n                display: flex;\r\n                justify-content: center;\r\n                align-items: center;\r\n                flex-direction: column;\r\n                pointer-events: none;\r\n                &:before {\r\n                  font-family: 'icomoonWp';\r\n                  content: '\\e90d';\r\n                  font-size: 24px;\r\n                }\r\n              }\r\n              &:hover {\r\n                span {\r\n                  &:before {\r\n                    content: '\\e910';\r\n                  }\r\n                }\r\n              }\r\n            }\r\n            a.dz-remove {\r\n              display: none;\r\n              top: -10px;\r\n              right: 0px;\r\n              bottom: auto;\r\n              opacity: 0;\r\n              margin: 0px;\r\n              padding: 0px;\r\n              text-decoration: none;\r\n              border: none;\r\n              transition: 0.5s;\r\n              &:before {\r\n                font-family: 'icomoonWp';\r\n                content: '\\e913';\r\n                color: #ef2066;\r\n                font-size: 18px;\r\n              }\r\n            }\r\n            &:hover {\r\n              a.dz-remove {\r\n                opacity: 1;\r\n              }\r\n            }\r\n            &.dz-error {\r\n              border: 1px solid #f6c216;\r\n              div.dz-error-message {\r\n                opacity: 1;\r\n              }\r\n            }\r\n            &.dz-complete div.dz-image {\r\n              opacity: 1;\r\n            }\r\n          }\r\n        }\r\n        &:hover div.picture-actions {\r\n          opacity: 1;\r\n        }\r\n      }\r\n    }\r\n    div.business-description {\r\n      width: 50%;\r\n      padding: 0 26px 0 48px;\r\n      border-left: 1px solid #d7d7d7;\r\n      textarea {\r\n        height: 170px;\r\n      }\r\n    }\r\n    div.content-item {\r\n      display: flex;\r\n      flex-direction: column;\r\n      align-items: flex-start;\r\n      text-align: left;\r\n      h3,\r\n      p {\r\n        font-family: Helvetica;\r\n        font-style: normal;\r\n      }\r\n      h3 {\r\n        font-weight: bold;\r\n        font-size: 12px;\r\n        line-height: 14px;\r\n        color: #0074ff;\r\n        margin-top: 0;\r\n      }\r\n      p {\r\n        font-weight: normal;\r\n        font-size: 10px;\r\n        line-height: 16px;\r\n        color: #575757;\r\n        margin-bottom: 18px;\r\n      }\r\n      & > div {\r\n        width: 100%;\r\n        &.disabled textarea {\r\n          cursor: not-allowed;\r\n          color: #bfbfbf;\r\n          pointer-events: none;\r\n          background: #f0f0f0;\r\n        }\r\n      }\r\n    }\r\n  }\r\n</style>\r\n"]
    },
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$i = undefined;
/* module identifier */

var __vue_module_identifier__$i = undefined;
/* functional template */

var __vue_is_functional_template__$i = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$i = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$g,
  staticRenderFns: __vue_staticRenderFns__$g
}, __vue_inject_styles__$i, __vue_script__$e, __vue_scope_id__$i, __vue_is_functional_template__$i, __vue_module_identifier__$i, false, createInjector, undefined, undefined);

var propertyIsEnumerable = objectPropertyIsEnumerable.f;

// `Object.{ entries, values }` methods implementation
var createMethod$4 = function (TO_ENTRIES) {
  return function (it) {
    var O = toIndexedObject(it);
    var keys = objectKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!descriptors || propertyIsEnumerable.call(O, key)) {
        result.push(TO_ENTRIES ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

var objectToArray = {
  // `Object.entries` method
  // https://tc39.github.io/ecma262/#sec-object.entries
  entries: createMethod$4(true),
  // `Object.values` method
  // https://tc39.github.io/ecma262/#sec-object.values
  values: createMethod$4(false)
};

var $entries = objectToArray.entries;

// `Object.entries` method
// https://tc39.github.io/ecma262/#sec-object.entries
_export({ target: 'Object', stat: true }, {
  entries: function entries(O) {
    return $entries(O);
  }
});

function _arrayWithHoles$2(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit$2(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest$2() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray$2(arr, i) {
  return _arrayWithHoles$2(arr) || _iterableToArrayLimit$2(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest$2();
}

var vueSelect = createCommonjsModule(function (module, exports) {
!function(t,e){module.exports=e();}("undefined"!=typeof self?self:commonjsGlobal,(function(){return function(t){var e={};function n(o){if(e[o])return e[o].exports;var i=e[o]={i:o,l:!1,exports:{}};return t[o].call(i.exports,i,i.exports,n),i.l=!0,i.exports}return n.m=t,n.c=e,n.d=function(t,e,o){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:o});},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0});},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var o=Object.create(null);if(n.r(o),Object.defineProperty(o,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var i in t)n.d(o,i,function(e){return t[e]}.bind(null,i));return o},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="/",n(n.s=8)}([function(t,e,n){var o=n(4),i=n(5),r=n(6);t.exports=function(t){return o(t)||i(t)||r()};},function(t,e){function n(e){return "function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?t.exports=n=function(t){return typeof t}:t.exports=n=function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},n(e)}t.exports=n;},function(t,e,n){},function(t,e){t.exports=function(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t};},function(t,e){t.exports=function(t){if(Array.isArray(t)){for(var e=0,n=new Array(t.length);e<t.length;e++)n[e]=t[e];return n}};},function(t,e){t.exports=function(t){if(Symbol.iterator in Object(t)||"[object Arguments]"===Object.prototype.toString.call(t))return Array.from(t)};},function(t,e){t.exports=function(){throw new TypeError("Invalid attempt to spread non-iterable instance")};},function(t,e,n){var o=n(2);n.n(o).a;},function(t,e,n){n.r(e);var o=n(0),i=n.n(o),r=n(1),s=n.n(r),a=n(3),l=n.n(a),c={props:{autoscroll:{type:Boolean,default:!0}},watch:{typeAheadPointer:function(){this.autoscroll&&this.maybeAdjustScroll();}},methods:{maybeAdjustScroll:function(){var t,e=(null===(t=this.$refs.dropdownMenu)||void 0===t?void 0:t.children[this.typeAheadPointer])||!1;if(e){var n=this.getDropdownViewport(),o=e.getBoundingClientRect(),i=o.top,r=o.bottom,s=o.height;if(i<n.top)return this.$refs.dropdownMenu.scrollTop=e.offsetTop;if(r>n.bottom)return this.$refs.dropdownMenu.scrollTop=e.offsetTop-(n.height-s)}},getDropdownViewport:function(){return this.$refs.dropdownMenu?this.$refs.dropdownMenu.getBoundingClientRect():{height:0,top:0,bottom:0}}}},u={data:function(){return {typeAheadPointer:-1}},watch:{filteredOptions:function(){for(var t=0;t<this.filteredOptions.length;t++)if(this.selectable(this.filteredOptions[t])){this.typeAheadPointer=t;break}}},methods:{typeAheadUp:function(){for(var t=this.typeAheadPointer-1;t>=0;t--)if(this.selectable(this.filteredOptions[t])){this.typeAheadPointer=t;break}},typeAheadDown:function(){for(var t=this.typeAheadPointer+1;t<this.filteredOptions.length;t++)if(this.selectable(this.filteredOptions[t])){this.typeAheadPointer=t;break}},typeAheadSelect:function(){var t=this.filteredOptions[this.typeAheadPointer];t&&this.select(t);}}},p={props:{loading:{type:Boolean,default:!1}},data:function(){return {mutableLoading:!1}},watch:{search:function(){this.$emit("search",this.search,this.toggleLoading);},loading:function(t){this.mutableLoading=t;}},methods:{toggleLoading:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null;return this.mutableLoading=null==t?!this.mutableLoading:t}}};function h(t,e,n,o,i,r,s,a){var l,c="function"==typeof t?t.options:t;if(e&&(c.render=e,c.staticRenderFns=n,c._compiled=!0),o&&(c.functional=!0),r&&(c._scopeId="data-v-"+r),s?(l=function(t){(t=t||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext)||"undefined"==typeof __VUE_SSR_CONTEXT__||(t=__VUE_SSR_CONTEXT__),i&&i.call(this,t),t&&t._registeredComponents&&t._registeredComponents.add(s);},c._ssrRegister=l):i&&(l=a?function(){i.call(this,this.$root.$options.shadowRoot);}:i),l)if(c.functional){c._injectStyles=l;var u=c.render;c.render=function(t,e){return l.call(e),u(t,e)};}else {var p=c.beforeCreate;c.beforeCreate=p?[].concat(p,l):[l];}return {exports:t,options:c}}var d={Deselect:h({},(function(){var t=this.$createElement,e=this._self._c||t;return e("svg",{attrs:{xmlns:"http://www.w3.org/2000/svg",width:"10",height:"10"}},[e("path",{attrs:{d:"M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z"}})])}),[],!1,null,null,null).exports,OpenIndicator:h({},(function(){var t=this.$createElement,e=this._self._c||t;return e("svg",{attrs:{xmlns:"http://www.w3.org/2000/svg",width:"14",height:"10"}},[e("path",{attrs:{d:"M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"}})])}),[],!1,null,null,null).exports},f={inserted:function(t,e,n){var o=n.context;if(o.appendToBody){var i=o.$refs.toggle.getBoundingClientRect(),r=i.height,s=i.top,a=i.left,l=i.width,c=window.scrollX||window.pageXOffset,u=window.scrollY||window.pageYOffset;t.unbindPosition=o.calculatePosition(t,o,{width:l+"px",left:c+a+"px",top:u+s+r+"px"}),document.body.appendChild(t);}},unbind:function(t,e,n){n.context.appendToBody&&(t.unbindPosition&&"function"==typeof t.unbindPosition&&t.unbindPosition(),t.parentNode&&t.parentNode.removeChild(t));}};var y=function(t){var e={};return Object.keys(t).sort().forEach((function(n){e[n]=t[n];})),JSON.stringify(e)},b=0;var g=function(){return ++b};function v(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(t);e&&(o=o.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,o);}return n}function m(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?v(Object(n),!0).forEach((function(e){l()(t,e,n[e]);})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):v(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e));}));}return t}var _={components:m({},d),mixins:[c,u,p],directives:{appendToBody:f},props:{value:{},components:{type:Object,default:function(){return {}}},options:{type:Array,default:function(){return []}},disabled:{type:Boolean,default:!1},clearable:{type:Boolean,default:!0},searchable:{type:Boolean,default:!0},multiple:{type:Boolean,default:!1},placeholder:{type:String,default:""},transition:{type:String,default:"vs__fade"},clearSearchOnSelect:{type:Boolean,default:!0},closeOnSelect:{type:Boolean,default:!0},label:{type:String,default:"label"},autocomplete:{type:String,default:"off"},reduce:{type:Function,default:function(t){return t}},selectable:{type:Function,default:function(t){return !0}},getOptionLabel:{type:Function,default:function(t){return "object"===s()(t)?t.hasOwnProperty(this.label)?t[this.label]:console.warn('[vue-select warn]: Label key "option.'.concat(this.label,'" does not')+" exist in options object ".concat(JSON.stringify(t),".\n")+"https://vue-select.org/api/props.html#getoptionlabel"):t}},getOptionKey:{type:Function,default:function(t){if("object"!==s()(t))return t;try{return t.hasOwnProperty("id")?t.id:y(t)}catch(e){return console.warn("[vue-select warn]: Could not stringify this option to generate unique key. Please provide'getOptionKey' prop to return a unique key for each option.\nhttps://vue-select.org/api/props.html#getoptionkey",t,e)}}},onTab:{type:Function,default:function(){this.selectOnTab&&!this.isComposing&&this.typeAheadSelect();}},taggable:{type:Boolean,default:!1},tabindex:{type:Number,default:null},pushTags:{type:Boolean,default:!1},filterable:{type:Boolean,default:!0},filterBy:{type:Function,default:function(t,e,n){return (e||"").toLowerCase().indexOf(n.toLowerCase())>-1}},filter:{type:Function,default:function(t,e){var n=this;return t.filter((function(t){var o=n.getOptionLabel(t);return "number"==typeof o&&(o=o.toString()),n.filterBy(t,o,e)}))}},createOption:{type:Function,default:function(t){return "object"===s()(this.optionList[0])?l()({},this.label,t):t}},resetOnOptionsChange:{default:!1,validator:function(t){return ["function","boolean"].includes(s()(t))}},clearSearchOnBlur:{type:Function,default:function(t){var e=t.clearSearchOnSelect,n=t.multiple;return e&&!n}},noDrop:{type:Boolean,default:!1},inputId:{type:String},dir:{type:String,default:"auto"},selectOnTab:{type:Boolean,default:!1},selectOnKeyCodes:{type:Array,default:function(){return [13]}},searchInputQuerySelector:{type:String,default:"[type=search]"},mapKeydown:{type:Function,default:function(t,e){return t}},appendToBody:{type:Boolean,default:!1},calculatePosition:{type:Function,default:function(t,e,n){var o=n.width,i=n.top,r=n.left;t.style.top=i,t.style.left=r,t.style.width=o;}}},data:function(){return {uid:g(),search:"",open:!1,isComposing:!1,pushedTags:[],_value:[]}},watch:{options:function(t,e){var n=this;!this.taggable&&("function"==typeof n.resetOnOptionsChange?n.resetOnOptionsChange(t,e,n.selectedValue):n.resetOnOptionsChange)&&this.clearSelection(),this.value&&this.isTrackingValues&&this.setInternalValueFromOptions(this.value);},value:function(t){this.isTrackingValues&&this.setInternalValueFromOptions(t);},multiple:function(){this.clearSelection();},open:function(t){this.$emit(t?"open":"close");}},created:function(){this.mutableLoading=this.loading,void 0!==this.value&&this.isTrackingValues&&this.setInternalValueFromOptions(this.value),this.$on("option:created",this.pushTag);},methods:{setInternalValueFromOptions:function(t){var e=this;Array.isArray(t)?this.$data._value=t.map((function(t){return e.findOptionFromReducedValue(t)})):this.$data._value=this.findOptionFromReducedValue(t);},select:function(t){this.isOptionSelected(t)||(this.taggable&&!this.optionExists(t)&&this.$emit("option:created",t),this.multiple&&(t=this.selectedValue.concat(t)),this.updateValue(t)),this.onAfterSelect(t);},deselect:function(t){var e=this;this.updateValue(this.selectedValue.filter((function(n){return !e.optionComparator(n,t)})));},clearSelection:function(){this.updateValue(this.multiple?[]:null);},onAfterSelect:function(t){this.closeOnSelect&&(this.open=!this.open,this.searchEl.blur()),this.clearSearchOnSelect&&(this.search="");},updateValue:function(t){var e=this;void 0===this.value&&(this.$data._value=t),null!==t&&(t=Array.isArray(t)?t.map((function(t){return e.reduce(t)})):this.reduce(t)),this.$emit("input",t);},toggleDropdown:function(t){var e=t.target!==this.$refs.search;e&&t.preventDefault(),[].concat(i()(this.$refs.deselectButtons||[]),i()([this.$refs.clearButton]||!1)).some((function(e){return e.contains(t.target)||e===t.target}))?t.preventDefault():this.open&&e?this.searchEl.blur():this.disabled||(this.open=!0,this.searchEl.focus());},isOptionSelected:function(t){var e=this;return this.selectedValue.some((function(n){return e.optionComparator(n,t)}))},optionComparator:function(t,e){return this.getOptionKey(t)===this.getOptionKey(e)},findOptionFromReducedValue:function(t){var e=this,n=[].concat(i()(this.options),i()(this.pushedTags)).filter((function(n){return JSON.stringify(e.reduce(n))===JSON.stringify(t)}));return 1===n.length?n[0]:n.find((function(t){return e.optionComparator(t,e.$data._value)}))||t},closeSearchOptions:function(){this.open=!1,this.$emit("search:blur");},maybeDeleteValue:function(){if(!this.searchEl.value.length&&this.selectedValue&&this.selectedValue.length&&this.clearable){var t=null;this.multiple&&(t=i()(this.selectedValue.slice(0,this.selectedValue.length-1))),this.updateValue(t);}},optionExists:function(t){var e=this;return this.optionList.some((function(n){return e.optionComparator(n,t)}))},normalizeOptionForSlot:function(t){return "object"===s()(t)?t:l()({},this.label,t)},pushTag:function(t){this.pushedTags.push(t);},onEscape:function(){this.search.length?this.search="":this.searchEl.blur();},onSearchBlur:function(){if(!this.mousedown||this.searching){var t=this.clearSearchOnSelect,e=this.multiple;return this.clearSearchOnBlur({clearSearchOnSelect:t,multiple:e})&&(this.search=""),void this.closeSearchOptions()}this.mousedown=!1,0!==this.search.length||0!==this.options.length||this.closeSearchOptions();},onSearchFocus:function(){this.open=!0,this.$emit("search:focus");},onMousedown:function(){this.mousedown=!0;},onMouseUp:function(){this.mousedown=!1;},onSearchKeyDown:function(t){var e=this,n=function(t){return t.preventDefault(),!e.isComposing&&e.typeAheadSelect()},o={8:function(t){return e.maybeDeleteValue()},9:function(t){return e.onTab()},27:function(t){return e.onEscape()},38:function(t){return t.preventDefault(),e.typeAheadUp()},40:function(t){return t.preventDefault(),e.typeAheadDown()}};this.selectOnKeyCodes.forEach((function(t){return o[t]=n}));var i=this.mapKeydown(o,this);if("function"==typeof i[t.keyCode])return i[t.keyCode](t)}},computed:{isTrackingValues:function(){return void 0===this.value||this.$options.propsData.hasOwnProperty("reduce")},selectedValue:function(){var t=this.value;return this.isTrackingValues&&(t=this.$data._value),t?[].concat(t):[]},optionList:function(){return this.options.concat(this.pushTags?this.pushedTags:[])},searchEl:function(){return this.$scopedSlots.search?this.$refs.selectedOptions.querySelector(this.searchInputQuerySelector):this.$refs.search},scope:function(){var t=this,e={search:this.search,loading:this.loading,searching:this.searching,filteredOptions:this.filteredOptions};return {search:{attributes:m({disabled:this.disabled,placeholder:this.searchPlaceholder,tabindex:this.tabindex,readonly:!this.searchable,id:this.inputId,"aria-autocomplete":"list","aria-labelledby":"vs".concat(this.uid,"__combobox"),"aria-controls":"vs".concat(this.uid,"__listbox"),ref:"search",type:"search",autocomplete:this.autocomplete,value:this.search},this.dropdownOpen&&this.filteredOptions[this.typeAheadPointer]?{"aria-activedescendant":"vs".concat(this.uid,"__option-").concat(this.typeAheadPointer)}:{}),events:{compositionstart:function(){return t.isComposing=!0},compositionend:function(){return t.isComposing=!1},keydown:this.onSearchKeyDown,blur:this.onSearchBlur,focus:this.onSearchFocus,input:function(e){return t.search=e.target.value}}},spinner:{loading:this.mutableLoading},noOptions:{search:this.search,loading:this.loading,searching:this.searching},openIndicator:{attributes:{ref:"openIndicator",role:"presentation",class:"vs__open-indicator"}},listHeader:e,listFooter:e,header:m({},e,{deselect:this.deselect}),footer:m({},e,{deselect:this.deselect})}},childComponents:function(){return m({},d,{},this.components)},stateClasses:function(){return {"vs--open":this.dropdownOpen,"vs--single":!this.multiple,"vs--searching":this.searching&&!this.noDrop,"vs--searchable":this.searchable&&!this.noDrop,"vs--unsearchable":!this.searchable,"vs--loading":this.mutableLoading,"vs--disabled":this.disabled}},searching:function(){return !!this.search},dropdownOpen:function(){return !this.noDrop&&(this.open&&!this.mutableLoading)},searchPlaceholder:function(){if(this.isValueEmpty&&this.placeholder)return this.placeholder},filteredOptions:function(){var t=[].concat(this.optionList);if(!this.filterable&&!this.taggable)return t;var e=this.search.length?this.filter(t,this.search,this):t;if(this.taggable&&this.search.length){var n=this.createOption(this.search);this.optionExists(n)||e.unshift(n);}return e},isValueEmpty:function(){return 0===this.selectedValue.length},showClearButton:function(){return !this.multiple&&this.clearable&&!this.open&&!this.isValueEmpty}}},O=(n(7),h(_,(function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"v-select",class:t.stateClasses,attrs:{dir:t.dir}},[t._t("header",null,null,t.scope.header),t._v(" "),n("div",{ref:"toggle",staticClass:"vs__dropdown-toggle",attrs:{id:"vs"+t.uid+"__combobox",role:"combobox","aria-expanded":t.dropdownOpen.toString(),"aria-owns":"vs"+t.uid+"__listbox","aria-label":"Search for option"},on:{mousedown:function(e){return t.toggleDropdown(e)}}},[n("div",{ref:"selectedOptions",staticClass:"vs__selected-options"},[t._l(t.selectedValue,(function(e){return t._t("selected-option-container",[n("span",{key:t.getOptionKey(e),staticClass:"vs__selected"},[t._t("selected-option",[t._v("\n            "+t._s(t.getOptionLabel(e))+"\n          ")],null,t.normalizeOptionForSlot(e)),t._v(" "),t.multiple?n("button",{ref:"deselectButtons",refInFor:!0,staticClass:"vs__deselect",attrs:{disabled:t.disabled,type:"button",title:"Deselect "+t.getOptionLabel(e),"aria-label":"Deselect "+t.getOptionLabel(e)},on:{click:function(n){return t.deselect(e)}}},[n(t.childComponents.Deselect,{tag:"component"})],1):t._e()],2)],{option:t.normalizeOptionForSlot(e),deselect:t.deselect,multiple:t.multiple,disabled:t.disabled})})),t._v(" "),t._t("search",[n("input",t._g(t._b({staticClass:"vs__search"},"input",t.scope.search.attributes,!1),t.scope.search.events))],null,t.scope.search)],2),t._v(" "),n("div",{ref:"actions",staticClass:"vs__actions"},[n("button",{directives:[{name:"show",rawName:"v-show",value:t.showClearButton,expression:"showClearButton"}],ref:"clearButton",staticClass:"vs__clear",attrs:{disabled:t.disabled,type:"button",title:"Clear Selected","aria-label":"Clear Selected"},on:{click:t.clearSelection}},[n(t.childComponents.Deselect,{tag:"component"})],1),t._v(" "),t._t("open-indicator",[t.noDrop?t._e():n(t.childComponents.OpenIndicator,t._b({tag:"component"},"component",t.scope.openIndicator.attributes,!1))],null,t.scope.openIndicator),t._v(" "),t._t("spinner",[n("div",{directives:[{name:"show",rawName:"v-show",value:t.mutableLoading,expression:"mutableLoading"}],staticClass:"vs__spinner"},[t._v("Loading...")])],null,t.scope.spinner)],2)]),t._v(" "),n("transition",{attrs:{name:t.transition}},[t.dropdownOpen?n("ul",{directives:[{name:"append-to-body",rawName:"v-append-to-body"}],key:"vs"+t.uid+"__listbox",ref:"dropdownMenu",staticClass:"vs__dropdown-menu",attrs:{id:"vs"+t.uid+"__listbox",role:"listbox"},on:{mousedown:function(e){return e.preventDefault(),t.onMousedown(e)},mouseup:t.onMouseUp}},[t._t("list-header",null,null,t.scope.listHeader),t._v(" "),t._l(t.filteredOptions,(function(e,o){return n("li",{key:t.getOptionKey(e),staticClass:"vs__dropdown-option",class:{"vs__dropdown-option--selected":t.isOptionSelected(e),"vs__dropdown-option--highlight":o===t.typeAheadPointer,"vs__dropdown-option--disabled":!t.selectable(e)},attrs:{role:"option",id:"vs"+t.uid+"__option-"+o,"aria-selected":o===t.typeAheadPointer||null},on:{mouseover:function(n){t.selectable(e)&&(t.typeAheadPointer=o);},mousedown:function(n){n.preventDefault(),n.stopPropagation(),t.selectable(e)&&t.select(e);}}},[t._t("option",[t._v("\n          "+t._s(t.getOptionLabel(e))+"\n        ")],null,t.normalizeOptionForSlot(e))],2)})),t._v(" "),0===t.filteredOptions.length?n("li",{staticClass:"vs__no-options"},[t._t("no-options",[t._v("Sorry, no matching options.")],null,t.scope.noOptions)],2):t._e(),t._v(" "),t._t("list-footer",null,null,t.scope.listFooter)],2):n("ul",{staticStyle:{display:"none",visibility:"hidden"},attrs:{id:"vs"+t.uid+"__listbox",role:"listbox"}})]),t._v(" "),t._t("footer",null,null,t.scope.footer)],2)}),[],!1,null,null,null).exports),w={ajax:p,pointer:u,pointerScroll:c};n.d(e,"VueSelect",(function(){return O})),n.d(e,"mixins",(function(){return w}));e.default=O;}])}));

});

var vSelect = /*@__PURE__*/unwrapExports(vueSelect);

var script$f = {
  components: {
    'v-select': vSelect,
    ValidationProvider: ValidationProvider
  },
  mixins: [__vue_component__$b],
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      wppApiNumber: undefined,
      address: '',
      vertical: '',
      email: '',
      websites: '',
      verticalSuccess: false
    };
  },
  computed: {
    businessOptions: function businessOptions() {
      var optionsI18n = this.$t('whatsappApiModal.profileInfo.businessInfo.vertical.options');
      var options = [];
      Object.entries(optionsI18n).forEach(function (_ref) {
        var _ref2 = _slicedToArray$2(_ref, 2),
            value = _ref2[0],
            label = _ref2[1];

        options.push({
          label: label,
          value: value
        });
      });
      return options;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.unwatch = this.$store.watch(function (state, getters) {
      _this.wppApiNumber = getters.wppApiNumber;

      if (_this.wppApiNumber && _this.wppApiNumber.customFields && _this.wppApiNumber.customFields.businessProfile) {
        var _this$wppApiNumber$cu = _this.wppApiNumber.customFields.businessProfile,
            address = _this$wppApiNumber$cu.address,
            email = _this$wppApiNumber$cu.email,
            websites = _this$wppApiNumber$cu.websites,
            vertical = _this$wppApiNumber$cu.vertical;
        if (address) _this.address = address;
        if (email) _this.email = email;
        if (websites.length) _this.websites = websites[0];

        if (vertical) {
          var parsedVertical = _this.businessOptions.find(function (option) {
            return option.value === vertical;
          });

          if (parsedVertical) {
            _this.vertical = parsedVertical;
          }
        }
      }
    });
  },
  methods: _objectSpread2(_objectSpread2({}, mapActions(['setCurrentWhatsappApiNumber'])), {}, {
    handleUpdate: function handleUpdate(field) {
      // eslint-disable-next-line
      var updatedNumber = {
        customFields: _objectSpread2(_objectSpread2({}, this.wppApiNumber.customFields), {}, {
          businessProfile: _objectSpread2({}, this.wppApiNumber.customFields.businessProfile)
        })
      };

      if (field === 'vertical') {
        updatedNumber.customFields.businessProfile[field] = this.vertical.value;
        this.verticalSuccess = true;
      } else {
        updatedNumber.customFields.businessProfile[field] = field === 'websites' ? [this[field]] : this[field];
      }

      this.setCurrentWhatsappApiNumber(updatedNumber);
    }
  })
};

/* script */
var __vue_script__$f = script$f;
/* template */

var __vue_render__$h = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    staticClass: "business-info-container",
    class: {
      disabled: _vm.loading
    }
  }, [_c("div", {
    staticClass: "address"
  }, [_c("ValidationProvider", {
    ref: "addressProvider",
    attrs: {
      name: "address",
      rules: "max:256"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(ref) {
        var errors = ref.errors;
        var valid = ref.valid;
        var dirty = ref.dirty;
        return [_c("div", {
          staticClass: "fields-control-wpp",
          class: [_vm.validationClass({
            errors: errors,
            valid: valid,
            dirty: dirty,
            value: _vm.address
          })]
        }, [_c("label", [_vm._v("\n          " + _vm._s(_vm.$t("whatsappApiModal.profileInfo.businessInfo.address.label")) + "\n        ")]), _vm._v(" "), _c("div", [_c("textarea", {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: _vm.address,
            expression: "address"
          }],
          attrs: {
            placeholder: _vm.$t("whatsappApiModal.profileInfo.businessInfo.address.placeholder"),
            disabled: _vm.loading
          },
          domProps: {
            value: _vm.address
          },
          on: {
            blur: function blur($event) {
              return _vm.handleUpdate("address");
            },
            input: function input($event) {
              if ($event.target.composing) {
                return;
              }

              _vm.address = $event.target.value;
            }
          }
        })]), _vm._v(" "), errors.length ? _c("span", {
          staticClass: "error-message"
        }, [_vm._v("\n          " + _vm._s(_vm.$t("whatsappApiModal.profileInfo.businessInfo.address.error")) + "\n        ")]) : _vm._e()])];
      }
    }])
  })], 1), _vm._v(" "), _c("div", {
    staticClass: "form"
  }, [_c("div", {
    staticClass: "container-field fields-control-wpp"
  }, [_c("label", [_vm._v("\n        " + _vm._s(_vm.$t("whatsappApiModal.profileInfo.businessInfo.vertical.label")) + "\n      ")]), _vm._v(" "), _c("v-select", {
    ref: "businessInfoSelect",
    staticClass: "select-control-wpp",
    class: {
      success: _vm.verticalSuccess
    },
    attrs: {
      options: _vm.businessOptions,
      filterable: false,
      searchable: false,
      placeholder: _vm.$t("whatsappApiModal.profileInfo.businessInfo.vertical.label"),
      disabled: _vm.loading
    },
    on: {
      input: function input($event) {
        return _vm.handleUpdate("vertical");
      }
    },
    model: {
      value: _vm.vertical,
      callback: function callback($$v) {
        _vm.vertical = $$v;
      },
      expression: "vertical"
    }
  })], 1), _vm._v(" "), _c("div", {
    staticClass: "container-field"
  }, [_c("ValidationProvider", {
    ref: "emailProvider",
    attrs: {
      name: "email",
      rules: "email|max:128"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(ref) {
        var errors = ref.errors;
        var valid = ref.valid;
        var dirty = ref.dirty;
        return [_c("div", {
          staticClass: "fields-control-wpp",
          class: [_vm.validationClass({
            errors: errors,
            valid: valid,
            dirty: dirty,
            value: _vm.email
          })]
        }, [_c("label", [_vm._v("\n            " + _vm._s(_vm.$t("whatsappApiModal.profileInfo.businessInfo.email.label")) + "\n          ")]), _vm._v(" "), _c("div", [_c("input", {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: _vm.email,
            expression: "email"
          }],
          attrs: {
            placeholder: _vm.$t("whatsappApiModal.profileInfo.businessInfo.email.placeholder"),
            type: "text",
            disabled: _vm.loading
          },
          domProps: {
            value: _vm.email
          },
          on: {
            blur: function blur($event) {
              return _vm.handleUpdate("email");
            },
            input: function input($event) {
              if ($event.target.composing) {
                return;
              }

              _vm.email = $event.target.value;
            }
          }
        })]), _vm._v(" "), errors.length ? _c("span", {
          staticClass: "error-message"
        }, [_vm._v("\n            " + _vm._s(_vm.$t("whatsappApiModal.profileInfo.businessInfo.email.error")) + "\n          ")]) : _vm._e()])];
      }
    }])
  })], 1), _vm._v(" "), _c("div", {
    staticClass: "container-field"
  }, [_c("ValidationProvider", {
    ref: "websitesProvider",
    attrs: {
      name: "websites",
      rules: "max:256|validUrl"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(ref) {
        var errors = ref.errors;
        var valid = ref.valid;
        var dirty = ref.dirty;
        return [_c("div", {
          staticClass: "fields-control-wpp",
          class: [_vm.validationClass({
            errors: errors,
            valid: valid,
            dirty: dirty,
            value: _vm.websites
          })]
        }, [_c("label", [_vm._v("\n            " + _vm._s(_vm.$t("whatsappApiModal.profileInfo.businessInfo.websites.label")) + "\n          ")]), _vm._v(" "), _c("div", [_c("input", {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: _vm.websites,
            expression: "websites"
          }],
          attrs: {
            placeholder: _vm.$t("whatsappApiModal.profileInfo.businessInfo.websites.placeholder"),
            type: "text",
            disabled: _vm.loading
          },
          domProps: {
            value: _vm.websites
          },
          on: {
            blur: function blur($event) {
              return _vm.handleUpdate("websites");
            },
            input: function input($event) {
              if ($event.target.composing) {
                return;
              }

              _vm.websites = $event.target.value;
            }
          }
        })]), _vm._v(" "), errors.length ? _c("span", {
          staticClass: "error-message"
        }, [_vm._v("\n            " + _vm._s(_vm.$t("whatsappApiModal.profileInfo.businessInfo.websites.error")) + "\n          ")]) : _vm._e()])];
      }
    }])
  })], 1)])]);
};

var __vue_staticRenderFns__$h = [];
__vue_render__$h._withStripped = true;
/* style */

var __vue_inject_styles__$j = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-4a7fec12_0", {
    source: "div.business-info-container[data-v-4a7fec12] {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 0 52px;\n}\ndiv.business-info-container.disabled textarea[data-v-4a7fec12],\ndiv.business-info-container.disabled input[data-v-4a7fec12] {\n  cursor: not-allowed;\n  color: #bfbfbf;\n  pointer-events: none;\n  background: #f0f0f0;\n}\ndiv.business-info-container div.address[data-v-4a7fec12] {\n  width: 50%;\n  display: flex;\n  flex-direction: column;\n}\ndiv.business-info-container div.address textarea[data-v-4a7fec12] {\n  min-height: 193px;\n}\ndiv.business-info-container div.form[data-v-4a7fec12] {\n  width: 50%;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n}\ndiv.business-info-container div.container-field[data-v-4a7fec12] {\n  width: 100%;\n  padding-left: 28px;\n  margin-bottom: 15px;\n}\n\n/*# sourceMappingURL=WhatsappApiBusinessInfo.vue.map */",
    map: {
      "version": 3,
      "sources": ["E:\\Octadesk\\octa-whatsapp-client\\src\\app\\whatsapp-api\\components\\modal\\WhatsappApiBusinessInfo.vue", "WhatsappApiBusinessInfo.vue"],
      "names": [],
      "mappings": "AAoRA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,eAAA;ACnRA;ADqRA;;EAEA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;ACnRA;ADsRA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;ACpRA;ADqRA;EACA,iBAAA;ACnRA;ADsRA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;ACpRA;ADsRA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;ACpRA;;AAEA,sDAAsD",
      "file": "WhatsappApiBusinessInfo.vue",
      "sourcesContent": ["<template>\r\n  <div class=\"business-info-container\" :class=\"{ disabled: loading }\">\r\n    <div class=\"address\">\r\n      <ValidationProvider\r\n        v-slot=\"{ errors, valid, dirty }\"\r\n        name=\"address\"\r\n        rules=\"max:256\"\r\n        ref=\"addressProvider\"\r\n      >\r\n        <div\r\n          class=\"fields-control-wpp\"\r\n          :class=\"[\r\n            validationClass({\r\n              errors,\r\n              valid,\r\n              dirty,\r\n              value: address\r\n            })\r\n          ]\"\r\n        >\r\n          <label>\r\n            {{ $t('whatsappApiModal.profileInfo.businessInfo.address.label') }}\r\n          </label>\r\n\r\n          <div>\r\n            <textarea\r\n              :placeholder=\"\r\n                $t(\r\n                  'whatsappApiModal.profileInfo.businessInfo.address.placeholder'\r\n                )\r\n              \"\r\n              v-model=\"address\"\r\n              @blur=\"handleUpdate('address')\"\r\n              :disabled=\"loading\"\r\n            />\r\n          </div>\r\n\r\n          <span v-if=\"errors.length\" class=\"error-message\">\r\n            {{ $t('whatsappApiModal.profileInfo.businessInfo.address.error') }}\r\n          </span>\r\n        </div>\r\n      </ValidationProvider>\r\n    </div>\r\n\r\n    <div class=\"form\">\r\n      <div class=\"container-field fields-control-wpp\">\r\n        <label>\r\n          {{ $t('whatsappApiModal.profileInfo.businessInfo.vertical.label') }}\r\n        </label>\r\n\r\n        <v-select\r\n          class=\"select-control-wpp\"\r\n          :class=\"{ success: verticalSuccess }\"\r\n          :options=\"businessOptions\"\r\n          :filterable=\"false\"\r\n          :searchable=\"false\"\r\n          :placeholder=\"\r\n            $t('whatsappApiModal.profileInfo.businessInfo.vertical.label')\r\n          \"\r\n          v-model=\"vertical\"\r\n          @input=\"handleUpdate('vertical')\"\r\n          :disabled=\"loading\"\r\n          ref=\"businessInfoSelect\"\r\n        />\r\n      </div>\r\n\r\n      <div class=\"container-field\">\r\n        <ValidationProvider\r\n          v-slot=\"{ errors, valid, dirty }\"\r\n          name=\"email\"\r\n          rules=\"email|max:128\"\r\n          ref=\"emailProvider\"\r\n        >\r\n          <div\r\n            class=\"fields-control-wpp\"\r\n            :class=\"[\r\n              validationClass({\r\n                errors,\r\n                valid,\r\n                dirty,\r\n                value: email\r\n              })\r\n            ]\"\r\n          >\r\n            <label>\r\n              {{ $t('whatsappApiModal.profileInfo.businessInfo.email.label') }}\r\n            </label>\r\n\r\n            <div>\r\n              <input\r\n                :placeholder=\"\r\n                  $t(\r\n                    'whatsappApiModal.profileInfo.businessInfo.email.placeholder'\r\n                  )\r\n                \"\r\n                type=\"text\"\r\n                v-model=\"email\"\r\n                @blur=\"handleUpdate('email')\"\r\n                :disabled=\"loading\"\r\n              />\r\n            </div>\r\n\r\n            <span v-if=\"errors.length\" class=\"error-message\">\r\n              {{ $t('whatsappApiModal.profileInfo.businessInfo.email.error') }}\r\n            </span>\r\n          </div>\r\n        </ValidationProvider>\r\n      </div>\r\n\r\n      <div class=\"container-field\">\r\n        <ValidationProvider\r\n          v-slot=\"{ errors, valid, dirty }\"\r\n          name=\"websites\"\r\n          rules=\"max:256|validUrl\"\r\n          ref=\"websitesProvider\"\r\n        >\r\n          <div\r\n            class=\"fields-control-wpp\"\r\n            :class=\"[\r\n              validationClass({\r\n                errors,\r\n                valid,\r\n                dirty,\r\n                value: websites\r\n              })\r\n            ]\"\r\n          >\r\n            <label>\r\n              {{\r\n                $t('whatsappApiModal.profileInfo.businessInfo.websites.label')\r\n              }}\r\n            </label>\r\n\r\n            <div>\r\n              <input\r\n                :placeholder=\"\r\n                  $t(\r\n                    'whatsappApiModal.profileInfo.businessInfo.websites.placeholder'\r\n                  )\r\n                \"\r\n                type=\"text\"\r\n                v-model=\"websites\"\r\n                @blur=\"handleUpdate('websites')\"\r\n                :disabled=\"loading\"\r\n              />\r\n            </div>\r\n\r\n            <span v-if=\"errors.length\" class=\"error-message\">\r\n              {{\r\n                $t('whatsappApiModal.profileInfo.businessInfo.websites.error')\r\n              }}\r\n            </span>\r\n          </div>\r\n        </ValidationProvider>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</template>\r\n\r\n<script>\r\n  import { mapActions } from 'vuex'\r\n\r\n  import vSelect from 'vue-select'\r\n\r\n  import GlobalMixins from '@/app/mixins'\r\n\r\n  import { ValidationProvider } from 'vee-validate'\r\n\r\n  import '@/helpers/validations'\r\n\r\n  export default {\r\n    components: {\r\n      'v-select': vSelect,\r\n      ValidationProvider\r\n    },\r\n    mixins: [GlobalMixins],\r\n    props: {\r\n      loading: {\r\n        type: Boolean,\r\n        required: false,\r\n        default: false\r\n      }\r\n    },\r\n    data() {\r\n      return {\r\n        wppApiNumber: undefined,\r\n        address: '',\r\n        vertical: '',\r\n        email: '',\r\n        websites: '',\r\n        verticalSuccess: false\r\n      }\r\n    },\r\n    computed: {\r\n      businessOptions() {\r\n        const optionsI18n = this.$t(\r\n          'whatsappApiModal.profileInfo.businessInfo.vertical.options'\r\n        )\r\n\r\n        const options = []\r\n\r\n        Object.entries(optionsI18n).forEach(([value, label]) => {\r\n          options.push({\r\n            label,\r\n            value\r\n          })\r\n        })\r\n\r\n        return options\r\n      }\r\n    },\r\n    mounted() {\r\n      this.unwatch = this.$store.watch((state, getters) => {\r\n        this.wppApiNumber = getters.wppApiNumber\r\n\r\n        if (\r\n          this.wppApiNumber &&\r\n          this.wppApiNumber.customFields &&\r\n          this.wppApiNumber.customFields.businessProfile\r\n        ) {\r\n          const {\r\n            address,\r\n            email,\r\n            websites,\r\n            vertical\r\n          } = this.wppApiNumber.customFields.businessProfile\r\n\r\n          if (address) this.address = address\r\n\r\n          if (email) this.email = email\r\n\r\n          if (websites.length) this.websites = websites[0]\r\n\r\n          if (vertical) {\r\n            const parsedVertical = this.businessOptions.find(\r\n              option => option.value === vertical\r\n            )\r\n\r\n            if (parsedVertical) {\r\n              this.vertical = parsedVertical\r\n            }\r\n          }\r\n        }\r\n      })\r\n    },\r\n    methods: {\r\n      ...mapActions(['setCurrentWhatsappApiNumber']),\r\n      handleUpdate(field) {\r\n        // eslint-disable-next-line\r\n        let updatedNumber = {\r\n          customFields: {\r\n            ...this.wppApiNumber.customFields,\r\n            businessProfile: {\r\n              ...this.wppApiNumber.customFields.businessProfile\r\n            }\r\n          }\r\n        }\r\n\r\n        if (field === 'vertical') {\r\n          updatedNumber.customFields.businessProfile[\r\n            field\r\n          ] = this.vertical.value\r\n\r\n          this.verticalSuccess = true\r\n        } else {\r\n          updatedNumber.customFields.businessProfile[field] =\r\n            field === 'websites' ? [this[field]] : this[field]\r\n        }\r\n\r\n        this.setCurrentWhatsappApiNumber(updatedNumber)\r\n      }\r\n    }\r\n  }\r\n</script>\r\n\r\n<style lang=\"scss\" scoped>\r\n  div.business-info-container {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    align-items: flex-start;\r\n    justify-content: center;\r\n    padding: 0 52px;\r\n    &.disabled {\r\n      textarea,\r\n      input {\r\n        cursor: not-allowed;\r\n        color: #bfbfbf;\r\n        pointer-events: none;\r\n        background: #f0f0f0;\r\n      }\r\n    }\r\n    div.address {\r\n      width: 50%;\r\n      display: flex;\r\n      flex-direction: column;\r\n      textarea {\r\n        min-height: 193px;\r\n      }\r\n    }\r\n    div.form {\r\n      width: 50%;\r\n      display: flex;\r\n      align-items: center;\r\n      flex-direction: column;\r\n    }\r\n    div.container-field {\r\n      width: 100%;\r\n      padding-left: 28px;\r\n      margin-bottom: 15px;\r\n    }\r\n  }\r\n</style>\r\n", "div.business-info-container {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 0 52px;\n}\ndiv.business-info-container.disabled textarea,\ndiv.business-info-container.disabled input {\n  cursor: not-allowed;\n  color: #bfbfbf;\n  pointer-events: none;\n  background: #f0f0f0;\n}\ndiv.business-info-container div.address {\n  width: 50%;\n  display: flex;\n  flex-direction: column;\n}\ndiv.business-info-container div.address textarea {\n  min-height: 193px;\n}\ndiv.business-info-container div.form {\n  width: 50%;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n}\ndiv.business-info-container div.container-field {\n  width: 100%;\n  padding-left: 28px;\n  margin-bottom: 15px;\n}\n\n/*# sourceMappingURL=WhatsappApiBusinessInfo.vue.map */"]
    },
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$j = "data-v-4a7fec12";
/* module identifier */

var __vue_module_identifier__$j = undefined;
/* functional template */

var __vue_is_functional_template__$j = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$j = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$h,
  staticRenderFns: __vue_staticRenderFns__$h
}, __vue_inject_styles__$j, __vue_script__$f, __vue_scope_id__$j, __vue_is_functional_template__$j, __vue_module_identifier__$j, false, createInjector, undefined, undefined);

var script$g = {
  components: {
    WhatsappApiPersonaInfo: __vue_component__$i,
    WhatsappApiBusinessInfo: __vue_component__$j,
    ValidationObserver: ValidationObserver
  },
  i18n: i18n,
  data: function data() {
    return {
      loading: false,
      currentStep: 'personaInfo',
      steps: {
        personaInfo: 'personaInfo',
        businessInfo: 'businessInfo'
      }
    };
  },
  methods: _objectSpread2(_objectSpread2({}, mapActions(['setCurrentWhatsappApiState', 'updateWhatsappApiNumber', 'trackEvent', 'setCurrentWhatsappApiNumber'])), {}, {
    isCompleted: function isCompleted() {
      return this.currentStep === this.steps.businessInfo;
    },
    handleClose: function handleClose() {
      this.$emit('close');
    },
    handleAdvance: function handleAdvance() {
      this.currentStep = this.steps.businessInfo;
    },
    handleReturn: function handleReturn() {
      this.currentStep = this.steps.personaInfo;
    },
    componenteRef: function componenteRef(fieldKey) {
      if (this.$children.length === 1) {
        return this.$children[0].refs;
      } else if (fieldKey === 'aboutDescription' || fieldKey === 'thumbUrl') {
        return this.$children[1].$_veeObserver.refs;
      } else {
        return this.$children[2].$_veeObserver.refs;
      }
    },
    tryUpdate: function tryUpdate() {
      if (this.$refs.observer.errors && this.$refs.observer.errors.aboutDescription && this.$refs.observer.errors.aboutDescription.length) {
        this.handleReturn();
      }
    },
    isValidField: function isValidField$1(key) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var ref, isValid;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                ref = _this.componenteRef(key);
                _context.next = 3;
                return isValidField(ref[key].value, ref[key].rules);

              case 3:
                isValid = _context.sent;

                if (!isValid) {
                  ref[key].setErrors("".concat(key, " is invalid field"));
                }

                return _context.abrupt("return", isValid);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleFinish: function handleFinish() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var isValidForm, formRef, fields, isValidTrue, index, isValid, response, error;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.tryUpdate();

                _context2.next = 3;
                return _this2.$refs.observer.validate();

              case 3:
                isValidForm = _context2.sent;
                formRef = _this2.componenteRef();
                fields = Object.keys(formRef);
                isValidTrue = true;
                index = 0;

              case 8:
                if (!(index < fields.length)) {
                  _context2.next = 16;
                  break;
                }

                _context2.next = 11;
                return _this2.isValidField(fields[index]);

              case 11:
                isValid = _context2.sent;

                if (!isValid) {
                  isValidTrue = false;
                }

              case 13:
                index++;
                _context2.next = 8;
                break;

              case 16:
                if (!(!isValidForm || !isValidTrue)) {
                  _context2.next = 18;
                  break;
                }

                return _context2.abrupt("return", false);

              case 18:
                _this2.loading = true;
                _context2.prev = 19;
                _context2.next = 22;
                return _this2.updateWhatsappApiNumber();

              case 22:
                _this2.setCurrentWhatsappApiState(WhatsappApiStates.success);

                _this2.trackEvent({
                  name: 'success update whasapp api number'
                });

                _this2.loading = false;
                _context2.next = 33;
                break;

              case 27:
                _context2.prev = 27;
                _context2.t0 = _context2["catch"](19);

                _this2.setCurrentWhatsappApiState(WhatsappApiStates.error);

                _this2.loading = false;
                response = _context2.t0.response;

                if (response && response.data) {
                  error = response.data.error;

                  _this2.trackEvent({
                    name: 'failed update whasapp api number',
                    properties: [{
                      name: 'reason',
                      value: error
                    }]
                  });
                }

              case 33:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[19, 27]]);
      }))();
    }
  })
};

/* script */
var __vue_script__$g = script$g;
/* template */

var __vue_render__$i = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    staticClass: "profile-info-container"
  }, [_c("div", {
    staticClass: "header"
  }, [_c("h1", [_vm._v("\n      " + _vm._s(_vm.$t("whatsappApiModal.profileInfo.headerTitle")) + "\n    ")]), _vm._v(" "), _c("div", [_c("div", {
    staticClass: "item space-right-md"
  }, [_c("div", [_vm.isCompleted() ? _c("span", {
    staticClass: "icon-wp-check-circle"
  }) : _c("span", [_vm._v("1")])]), _vm._v(" "), _c("span", {
    class: {
      completed: _vm.isCompleted()
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("whatsappApiModal.profileInfo.steps.first")) + "\n        ")])]), _vm._v(" "), _c("div", {
    staticClass: "item"
  }, [_c("div", [_vm._v("2")]), _vm._v(" "), _c("span", [_vm._v("\n          " + _vm._s(_vm.$t("whatsappApiModal.profileInfo.steps.second")) + "\n        ")])])])]), _vm._v(" "), _c("div", {
    staticClass: "description"
  }, [_vm.currentStep === _vm.steps.personaInfo ? _c("p", [_vm._v("\n      " + _vm._s(_vm.$t("whatsappApiModal.profileInfo.personaInfo.description")) + "\n    ")]) : _vm.currentStep === _vm.steps.businessInfo ? _c("p", [_vm._v("\n      " + _vm._s(_vm.$t("whatsappApiModal.profileInfo.businessInfo.description")) + "\n    ")]) : _vm._e(), _vm._v(" "), _c("a", {
    attrs: {
      href: "https://help.octadesk.com/kb/article/cadastrar-whatsapp-api",
      target: "_blank"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("whatsappApiModal.profileInfo.helpLink")) + "\n    ")])]), _vm._v(" "), _c("ValidationObserver", {
    ref: "observer",
    attrs: {
      tag: "form"
    }
  }, [_c("div", {
    staticClass: "content"
  }, [_c("WhatsappApiPersonaInfo", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.currentStep === _vm.steps.personaInfo,
      expression: "currentStep === steps.personaInfo"
    }],
    attrs: {
      loading: _vm.loading
    }
  }), _vm._v(" "), _c("WhatsappApiBusinessInfo", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.currentStep === _vm.steps.businessInfo,
      expression: "currentStep === steps.businessInfo"
    }],
    attrs: {
      loading: _vm.loading
    }
  })], 1), _vm._v(" "), _c("div", {
    staticClass: "footer"
  }, [_c("a", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.loading,
      expression: "!loading"
    }],
    staticClass: "btn-control-wpp link",
    on: {
      click: _vm.handleClose
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("whatsappApiModal.profileInfo.footer.cancel")) + "\n      ")]), _vm._v(" "), _vm.currentStep === _vm.steps.personaInfo ? _c("a", {
    staticClass: "btn-control-wpp primary",
    attrs: {
      disabled: _vm.loading
    },
    on: {
      click: _vm.handleAdvance
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("whatsappApiModal.profileInfo.footer.advance")) + "\n      ")]) : _vm._e(), _vm._v(" "), _vm.currentStep === _vm.steps.businessInfo && !_vm.loading ? _c("a", {
    staticClass: "btn-control-wpp outline",
    attrs: {
      disabled: _vm.loading
    },
    on: {
      click: _vm.handleReturn
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("whatsappApiModal.profileInfo.footer.return")) + "\n      ")]) : _vm._e(), _vm._v(" "), _vm.currentStep === _vm.steps.businessInfo ? _c("button", {
    staticClass: "btn-control-wpp primary",
    attrs: {
      type: "submit",
      disabled: _vm.loading
    },
    on: {
      click: function click($event) {
        $event.preventDefault();
        return _vm.handleFinish($event);
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("whatsappApiModal.profileInfo.footer.finish")) + "\n      ")]) : _vm._e()])])], 1);
};

var __vue_staticRenderFns__$i = [];
__vue_render__$i._withStripped = true;
/* style */

var __vue_inject_styles__$k = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-68139908_0", {
    source: "div.profile-info-container[data-v-68139908] {\n  width: 100%;\n}\ndiv.profile-info-container div.header[data-v-68139908] {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  padding: 22px 26px;\n}\ndiv.profile-info-container div.header h1[data-v-68139908] {\n  font-family: \"Niveau Grotesk\";\n  font-style: normal;\n  font-weight: bold;\n  font-size: 25px;\n  line-height: 29px;\n  color: #072a54;\n  margin-bottom: 10px;\n}\ndiv.profile-info-container div.header > div[data-v-68139908] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 10px;\n}\ndiv.profile-info-container div.header > div div.item[data-v-68139908] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\ndiv.profile-info-container div.header > div div.item > div[data-v-68139908] {\n  width: 25px;\n  height: 25px;\n  border-radius: 100%;\n  border: 1px solid #4b9bfc;\n  color: #4b9bfc;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\ndiv.profile-info-container div.header > div div.item > div span.icon-wp-check-circle[data-v-68139908] {\n  font-size: 25px;\n  color: #1bdd85;\n}\ndiv.profile-info-container div.header > div div.item > span[data-v-68139908] {\n  font-family: Helvetica;\n  font-style: normal;\n  font-weight: bold;\n  font-size: 12px;\n  line-height: 22px;\n  color: #707070;\n  margin-left: 5px;\n}\ndiv.profile-info-container div.header > div div.item > span.completed[data-v-68139908] {\n  color: #d7d7d7 !important;\n}\ndiv.profile-info-container div.description[data-v-68139908] {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\ndiv.profile-info-container div.description p[data-v-68139908],\ndiv.profile-info-container div.description a[data-v-68139908] {\n  font-family: Helvetica;\n  font-style: normal;\n  font-weight: normal;\n  line-height: 22px;\n  text-align: center;\n  margin: 0px;\n}\ndiv.profile-info-container div.description p[data-v-68139908] {\n  font-size: 13px;\n  color: #999999;\n}\ndiv.profile-info-container div.description a[data-v-68139908] {\n  font-size: 12px;\n  text-decoration-line: underline;\n  color: #2775d3;\n}\ndiv.profile-info-container div.content[data-v-68139908] {\n  margin: 33px 0px;\n}\ndiv.profile-info-container div.footer[data-v-68139908] {\n  width: 100%;\n  padding: 22px 26px 20px 26px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  border-top: 1px solid #d7d7d7;\n}\ndiv.profile-info-container div.footer a[data-v-68139908] {\n  font-weight: normal;\n}\ndiv.profile-info-container div.footer a.outline[data-v-68139908] {\n  margin-right: 15px;\n  font-weight: bold;\n}\n\n/*# sourceMappingURL=WhatsappApiProfileInfo.vue.map */",
    map: {
      "version": 3,
      "sources": ["E:\\Octadesk\\octa-whatsapp-client\\src\\app\\whatsapp-api\\components\\modal\\WhatsappApiProfileInfo.vue", "WhatsappApiProfileInfo.vue"],
      "names": [],
      "mappings": "AA2OA;EACA,WAAA;AC1OA;AD2OA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,kBAAA;ACzOA;AD0OA;EACA,6BAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;ACxOA;AD0OA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;ACxOA;ADyOA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;ACvOA;ADwOA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;ACtOA;ADuOA;EACA,eAAA;EACA,cAAA;ACrOA;ADwOA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;ACtOA;ADwOA;EACA,yBAAA;ACtOA;AD4OA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AC1OA;AD2OA;;EAEA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;ACzOA;AD2OA;EACA,eAAA;EACA,cAAA;ACzOA;AD2OA;EACA,eAAA;EACA,+BAAA;EACA,cAAA;ACzOA;AD4OA;EACA,gBAAA;AC1OA;AD4OA;EACA,WAAA;EACA,4BAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,6BAAA;AC1OA;AD2OA;EACA,mBAAA;ACzOA;AD0OA;EACA,kBAAA;EACA,iBAAA;ACxOA;;AAEA,qDAAqD",
      "file": "WhatsappApiProfileInfo.vue",
      "sourcesContent": ["<template>\r\n  <div class=\"profile-info-container\">\r\n    <div class=\"header\">\r\n      <h1>\r\n        {{ $t('whatsappApiModal.profileInfo.headerTitle') }}\r\n      </h1>\r\n\r\n      <div>\r\n        <div class=\"item space-right-md\">\r\n          <div>\r\n            <span class=\"icon-wp-check-circle\" v-if=\"isCompleted()\" />\r\n\r\n            <span v-else>1</span>\r\n          </div>\r\n\r\n          <span :class=\"{ completed: isCompleted() }\">\r\n            {{ $t('whatsappApiModal.profileInfo.steps.first') }}\r\n          </span>\r\n        </div>\r\n\r\n        <div class=\"item\">\r\n          <div>2</div>\r\n\r\n          <span>\r\n            {{ $t('whatsappApiModal.profileInfo.steps.second') }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"description\">\r\n      <p v-if=\"currentStep === steps.personaInfo\">\r\n        {{ $t('whatsappApiModal.profileInfo.personaInfo.description') }}\r\n      </p>\r\n\r\n      <p v-else-if=\"currentStep === steps.businessInfo\">\r\n        {{ $t('whatsappApiModal.profileInfo.businessInfo.description') }}\r\n      </p>\r\n\r\n      <a\r\n        href=\"https://help.octadesk.com/kb/article/cadastrar-whatsapp-api\"\r\n        target=\"_blank\"\r\n      >\r\n        {{ $t('whatsappApiModal.profileInfo.helpLink') }}\r\n      </a>\r\n    </div>\r\n\r\n    <ValidationObserver ref=\"observer\" tag=\"form\">\r\n      <div class=\"content\">\r\n        <WhatsappApiPersonaInfo\r\n          :loading=\"loading\"\r\n          v-show=\"currentStep === steps.personaInfo\"\r\n        />\r\n\r\n        <WhatsappApiBusinessInfo\r\n          :loading=\"loading\"\r\n          v-show=\"currentStep === steps.businessInfo\"\r\n        />\r\n      </div>\r\n\r\n      <div class=\"footer\">\r\n        <a class=\"btn-control-wpp link\" @click=\"handleClose\" v-show=\"!loading\">\r\n          {{ $t('whatsappApiModal.profileInfo.footer.cancel') }}\r\n        </a>\r\n\r\n        <a\r\n          class=\"btn-control-wpp primary\"\r\n          @click=\"handleAdvance\"\r\n          v-if=\"currentStep === steps.personaInfo\"\r\n          :disabled=\"loading\"\r\n        >\r\n          {{ $t('whatsappApiModal.profileInfo.footer.advance') }}\r\n        </a>\r\n\r\n        <a\r\n          v-if=\"currentStep === steps.businessInfo && !loading\"\r\n          class=\"btn-control-wpp outline\"\r\n          @click=\"handleReturn\"\r\n          :disabled=\"loading\"\r\n        >\r\n          {{ $t('whatsappApiModal.profileInfo.footer.return') }}\r\n        </a>\r\n\r\n        <button\r\n          class=\"btn-control-wpp primary\"\r\n          type=\"submit\"\r\n          v-if=\"currentStep === steps.businessInfo\"\r\n          :disabled=\"loading\"\r\n          @click.prevent=\"handleFinish\"\r\n        >\r\n          {{ $t('whatsappApiModal.profileInfo.footer.finish') }}\r\n        </button>\r\n      </div>\r\n    </ValidationObserver>\r\n  </div>\r\n</template>\r\n\r\n<script>\r\n  import i18n from '@/i18n'\r\n\r\n  import { mapActions } from 'vuex'\r\n\r\n  import WhatsappApiPersonaInfo from './WhatsappApiPersonaInfo'\r\n\r\n  import WhatsappApiBusinessInfo from './WhatsappApiBusinessInfo'\r\n\r\n  import { WhatsappApiStates } from '@/helpers/enums'\r\n\r\n  import { ValidationObserver } from 'vee-validate'\r\n\r\n  import { validations } from '@/helpers'\r\n\r\n  export default {\r\n    components: {\r\n      WhatsappApiPersonaInfo,\r\n      WhatsappApiBusinessInfo,\r\n      ValidationObserver\r\n    },\r\n    i18n,\r\n    data() {\r\n      return {\r\n        loading: false,\r\n        currentStep: 'personaInfo',\r\n        steps: {\r\n          personaInfo: 'personaInfo',\r\n          businessInfo: 'businessInfo'\r\n        }\r\n      }\r\n    },\r\n    methods: {\r\n      ...mapActions([\r\n        'setCurrentWhatsappApiState',\r\n        'updateWhatsappApiNumber',\r\n        'trackEvent',\r\n        'setCurrentWhatsappApiNumber'\r\n      ]),\r\n      isCompleted() {\r\n        return this.currentStep === this.steps.businessInfo\r\n      },\r\n      handleClose() {\r\n        this.$emit('close')\r\n      },\r\n      handleAdvance() {\r\n        this.currentStep = this.steps.businessInfo\r\n      },\r\n      handleReturn() {\r\n        this.currentStep = this.steps.personaInfo\r\n      },\r\n      componenteRef(fieldKey) {\r\n        if (this.$children.length === 1) {\r\n          return this.$children[0].refs\r\n        } else if (fieldKey === 'aboutDescription' || fieldKey === 'thumbUrl') {\r\n          return this.$children[1].$_veeObserver.refs\r\n        } else {\r\n          return this.$children[2].$_veeObserver.refs\r\n        }\r\n      },\r\n      tryUpdate() {\r\n        if (\r\n          this.$refs.observer.errors &&\r\n          this.$refs.observer.errors.aboutDescription &&\r\n          this.$refs.observer.errors.aboutDescription.length\r\n        ) {\r\n          this.handleReturn()\r\n        }\r\n      },\r\n      async isValidField(key) {\r\n        const ref = this.componenteRef(key)\r\n\r\n        const isValid = await validations.isValidField(\r\n          ref[key].value,\r\n          ref[key].rules\r\n        )\r\n\r\n        if (!isValid) {\r\n          ref[key].setErrors(`${key} is invalid field`)\r\n        }\r\n\r\n        return isValid\r\n      },\r\n      async handleFinish() {\r\n        this.tryUpdate()\r\n\r\n        const isValidForm = await this.$refs.observer.validate()\r\n\r\n        const formRef = this.componenteRef()\r\n\r\n        const fields = Object.keys(formRef)\r\n\r\n        let isValidTrue = true\r\n\r\n        for (let index = 0; index < fields.length; index++) {\r\n          const isValid = await this.isValidField(fields[index])\r\n\r\n          if (!isValid) {\r\n            isValidTrue = false\r\n          }\r\n        }\r\n\r\n        if (!isValidForm || !isValidTrue) {\r\n          return false\r\n        }\r\n\r\n        this.loading = true\r\n\r\n        try {\r\n          await this.updateWhatsappApiNumber()\r\n\r\n          this.setCurrentWhatsappApiState(WhatsappApiStates.success)\r\n\r\n          this.trackEvent({ name: 'success update whasapp api number' })\r\n\r\n          this.loading = false\r\n        } catch (ex) {\r\n          this.setCurrentWhatsappApiState(WhatsappApiStates.error)\r\n\r\n          this.loading = false\r\n\r\n          const { response } = ex\r\n\r\n          if (response && response.data) {\r\n            const { error } = response.data\r\n\r\n            this.trackEvent({\r\n              name: 'failed update whasapp api number',\r\n              properties: [{ name: 'reason', value: error }]\r\n            })\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n</script>\r\n\r\n<style lang=\"scss\" scoped>\r\n  div.profile-info-container {\r\n    width: 100%;\r\n    div.header {\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: space-between;\r\n      flex-wrap: wrap;\r\n      padding: 22px 26px;\r\n      h1 {\r\n        font-family: 'Niveau Grotesk';\r\n        font-style: normal;\r\n        font-weight: bold;\r\n        font-size: 25px;\r\n        line-height: 29px;\r\n        color: #072a54;\r\n        margin-bottom: 10px;\r\n      }\r\n      & > div {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        margin-bottom: 10px;\r\n        div.item {\r\n          display: flex;\r\n          align-items: center;\r\n          justify-content: center;\r\n          & > div {\r\n            width: 25px;\r\n            height: 25px;\r\n            border-radius: 100%;\r\n            border: 1px solid #4b9bfc;\r\n            color: #4b9bfc;\r\n            font-size: 12px;\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n            span.icon-wp-check-circle {\r\n              font-size: 25px;\r\n              color: #1bdd85;\r\n            }\r\n          }\r\n          & > span {\r\n            font-family: Helvetica;\r\n            font-style: normal;\r\n            font-weight: bold;\r\n            font-size: 12px;\r\n            line-height: 22px;\r\n            color: #707070;\r\n            margin-left: 5px;\r\n\r\n            &.completed {\r\n              color: #d7d7d7 !important;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n    div.description {\r\n      width: 100%;\r\n      display: flex;\r\n      justify-content: center;\r\n      align-items: center;\r\n      flex-direction: column;\r\n      p,\r\n      a {\r\n        font-family: Helvetica;\r\n        font-style: normal;\r\n        font-weight: normal;\r\n        line-height: 22px;\r\n        text-align: center;\r\n        margin: 0px;\r\n      }\r\n      p {\r\n        font-size: 13px;\r\n        color: #999999;\r\n      }\r\n      a {\r\n        font-size: 12px;\r\n        text-decoration-line: underline;\r\n        color: #2775d3;\r\n      }\r\n    }\r\n    div.content {\r\n      margin: 33px 0px;\r\n    }\r\n    div.footer {\r\n      width: 100%;\r\n      padding: 22px 26px 20px 26px;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: flex-end;\r\n      border-top: 1px solid #d7d7d7;\r\n      a {\r\n        font-weight: normal;\r\n        &.outline {\r\n          margin-right: 15px;\r\n          font-weight: bold;\r\n        }\r\n      }\r\n    }\r\n  }\r\n</style>\r\n", "div.profile-info-container {\n  width: 100%;\n}\ndiv.profile-info-container div.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  padding: 22px 26px;\n}\ndiv.profile-info-container div.header h1 {\n  font-family: \"Niveau Grotesk\";\n  font-style: normal;\n  font-weight: bold;\n  font-size: 25px;\n  line-height: 29px;\n  color: #072a54;\n  margin-bottom: 10px;\n}\ndiv.profile-info-container div.header > div {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 10px;\n}\ndiv.profile-info-container div.header > div div.item {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\ndiv.profile-info-container div.header > div div.item > div {\n  width: 25px;\n  height: 25px;\n  border-radius: 100%;\n  border: 1px solid #4b9bfc;\n  color: #4b9bfc;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\ndiv.profile-info-container div.header > div div.item > div span.icon-wp-check-circle {\n  font-size: 25px;\n  color: #1bdd85;\n}\ndiv.profile-info-container div.header > div div.item > span {\n  font-family: Helvetica;\n  font-style: normal;\n  font-weight: bold;\n  font-size: 12px;\n  line-height: 22px;\n  color: #707070;\n  margin-left: 5px;\n}\ndiv.profile-info-container div.header > div div.item > span.completed {\n  color: #d7d7d7 !important;\n}\ndiv.profile-info-container div.description {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\ndiv.profile-info-container div.description p,\ndiv.profile-info-container div.description a {\n  font-family: Helvetica;\n  font-style: normal;\n  font-weight: normal;\n  line-height: 22px;\n  text-align: center;\n  margin: 0px;\n}\ndiv.profile-info-container div.description p {\n  font-size: 13px;\n  color: #999999;\n}\ndiv.profile-info-container div.description a {\n  font-size: 12px;\n  text-decoration-line: underline;\n  color: #2775d3;\n}\ndiv.profile-info-container div.content {\n  margin: 33px 0px;\n}\ndiv.profile-info-container div.footer {\n  width: 100%;\n  padding: 22px 26px 20px 26px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  border-top: 1px solid #d7d7d7;\n}\ndiv.profile-info-container div.footer a {\n  font-weight: normal;\n}\ndiv.profile-info-container div.footer a.outline {\n  margin-right: 15px;\n  font-weight: bold;\n}\n\n/*# sourceMappingURL=WhatsappApiProfileInfo.vue.map */"]
    },
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$k = "data-v-68139908";
/* module identifier */

var __vue_module_identifier__$k = undefined;
/* functional template */

var __vue_is_functional_template__$k = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$k = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$i,
  staticRenderFns: __vue_staticRenderFns__$i
}, __vue_inject_styles__$k, __vue_script__$g, __vue_scope_id__$k, __vue_is_functional_template__$k, __vue_module_identifier__$k, false, createInjector, undefined, undefined);

var script$h = {
  props: {
    isNew: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  mixins: [__vue_component__$b],
  components: {
    Modal: Modal,
    WhatsappApiIntegrationInfo: __vue_component__$g,
    WhatsappApiResponseStates: __vue_component__$h,
    WhatsappApiProfileInfo: __vue_component__$k
  },
  data: function data() {
    return {
      show: true,
      currentWppApiState: WhatsappApiStates.integrationInfo,
      currentWppApiPreviousState: undefined
    };
  },
  computed: {
    WhatsappApiStates: function WhatsappApiStates$1() {
      return WhatsappApiStates;
    },
    isResponseStates: function isResponseStates() {
      return this.currentWppApiState === WhatsappApiStates.error || this.currentWppApiState === WhatsappApiStates.success;
    },
    modalSize: function modalSize() {
      return this.currentWppApiState === WhatsappApiStates.success && this.currentWppApiPreviousState !== WhatsappApiStates.integrationInfo ? 'sm' : 'lg';
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.unwatch = this.$store.watch(function (state, getters) {
      if (!getters.currentWppApiState) {
        _this.setCurrentWhatsappApiState(WhatsappApiStates.integrationInfo);
      }

      _this.currentWppApiState = getters.currentWppApiState;
      _this.currentWppApiPreviousState = getters.currentWppApiPreviousState;
    });
  },
  methods: _objectSpread2(_objectSpread2({}, mapActions(['setCurrentWhatsappApiState'])), {}, {
    handleClose: function handleClose() {
      this.$emit('close');
    },
    handlePrimaryActionResponse: function handlePrimaryActionResponse() {
      if (this.currentWppApiPreviousState === WhatsappApiStates.integrationInfo) {
        if (this.currentWppApiState === WhatsappApiStates.success) {
          this.setCurrentWhatsappApiState(WhatsappApiStates.profileInfo);
        } else if (this.currentWppApiState === WhatsappApiStates.error) {
          this.setCurrentWhatsappApiState(WhatsappApiStates.integrationInfo);
        }
      } else {
        if (this.currentWppApiState === WhatsappApiStates.error) {
          this.setCurrentWhatsappApiState(WhatsappApiStates.profileInfo);
        }
      }
    },
    handleSecondaryActionResponse: function handleSecondaryActionResponse() {
      if (this.currentWppApiPreviousState === WhatsappApiStates.integrationInfo) {
        if (this.currentWppApiState === WhatsappApiStates.success) {
          this.setCurrentWhatsappApiState(WhatsappApiStates.integrationInfo);
        } else if (this.currentWppApiState === WhatsappApiStates.error) {
          this.handleClose();
        }
      } else {
        if (this.currentWppApiState === WhatsappApiStates.error) {
          this.handleClose();
        }
      }
    }
  })
};

/* script */
var __vue_script__$h = script$h;
/* template */

var __vue_render__$j = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("Modal", {
    staticClass: "wpp-api-modal",
    attrs: {
      footer: false,
      header: false,
      size: _vm.modalSize
    },
    on: {
      hide: _vm.handleClose
    },
    model: {
      value: _vm.show,
      callback: function callback($$v) {
        _vm.show = $$v;
      },
      expression: "show"
    }
  }, [_vm.currentWppApiState === _vm.WhatsappApiStates.integrationInfo ? _c("WhatsappApiIntegrationInfo", {
    on: {
      close: _vm.handleClose
    }
  }) : _vm.currentWppApiState === _vm.WhatsappApiStates.profileInfo ? _c("WhatsappApiProfileInfo", {
    on: {
      close: _vm.handleClose
    }
  }) : _vm.isResponseStates ? _c("WhatsappApiResponseStates", {
    on: {
      "primary-action": _vm.handlePrimaryActionResponse,
      "secondary-action": _vm.handleSecondaryActionResponse,
      close: _vm.handleClose
    }
  }) : _vm._e()], 1);
};

var __vue_staticRenderFns__$j = [];
__vue_render__$j._withStripped = true;
/* style */

var __vue_inject_styles__$l = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-e78ee65a_0", {
    source: ".wpp-api-modal div.modal-dialog {\n  margin: 10px auto;\n}\n@media (min-width: 768px) {\n.wpp-api-modal div.modal-dialog {\n    width: 680px;\n    margin: 30px auto;\n}\n}\n.wpp-api-modal div.modal-dialog div.modal-content {\n  border-radius: 6px;\n  box-shadow: 0 3px 9px rgba(0, 0, 0, 0.15);\n}\n.wpp-api-modal div.modal-dialog div.modal-content div.modal-body {\n  padding: 0px;\n  overflow: auto;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  flex-wrap: wrap;\n  height: auto;\n}\n.wpp-api-modal div.modal-dialog div.modal-content div.modal-body button.wpp-close-btn {\n  width: 30px;\n  height: 30px;\n  position: absolute;\n  z-index: 10;\n  top: 15px;\n  right: 15px;\n  border: none;\n  cursor: pointer;\n  border-radius: 50%;\n  transition: 0.5s;\n  background: #f0f0f0;\n}\n.wpp-api-modal div.modal-dialog div.modal-content div.modal-body button.wpp-close-btn:before, .wpp-api-modal div.modal-dialog div.modal-content div.modal-body button.wpp-close-btn:after {\n  content: \"\";\n  position: absolute;\n  left: 8px;\n  width: 15px;\n  height: 2px;\n  top: 14px;\n  transition: 0.5s;\n  border-radius: 10px;\n  background: #999999;\n}\n.wpp-api-modal div.modal-dialog div.modal-content div.modal-body button.wpp-close-btn:before {\n  transform: rotate(-45deg);\n}\n.wpp-api-modal div.modal-dialog div.modal-content div.modal-body button.wpp-close-btn:after {\n  transform: rotate(45deg);\n}\n.wpp-api-modal div.modal-dialog div.modal-content div.modal-body button.wpp-close-btn:hover {\n  opacity: 0.5;\n  background: #999999;\n}\n.wpp-api-modal div.modal-dialog div.modal-content div.modal-body button.wpp-close-btn:hover:before, .wpp-api-modal div.modal-dialog div.modal-content div.modal-body button.wpp-close-btn:hover:after {\n  background: #f0f0f0;\n}\n@media (min-width: 768px) {\n.wpp-api-modal div.modal-dialog.modal-sm {\n    width: 525px;\n    margin: 30px auto;\n}\n}\n\n/*# sourceMappingURL=WhatsappApiModal.vue.map */",
    map: {
      "version": 3,
      "sources": ["E:\\Octadesk\\octa-whatsapp-client\\src\\app\\whatsapp-api\\components\\modal\\WhatsappApiModal.vue", "WhatsappApiModal.vue"],
      "names": [],
      "mappings": "AAsIA;EACA,iBAAA;ACrIA;ADsIA;AAFA;IAGA,YAAA;IACA,iBAAA;ACnIE;AACF;ADoIA;EACA,kBAAA;EACA,yCAAA;AClIA;ADmIA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;ACjIA;ADkIA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AChIA;ADiIA;EAEA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AChIA;ADkIA;EACA,yBAAA;AChIA;ADkIA;EACA,wBAAA;AChIA;ADkIA;EACA,YAAA;EACA,mBAAA;AChIA;ADiIA;EAEA,mBAAA;AChIA;ADuIA;AADA;IAEA,YAAA;IACA,iBAAA;ACpIE;AACF;;AAEA,+CAA+C",
      "file": "WhatsappApiModal.vue",
      "sourcesContent": ["<template>\r\n  <Modal\r\n    v-model=\"show\"\r\n    class=\"wpp-api-modal\"\r\n    @hide=\"handleClose\"\r\n    :footer=\"false\"\r\n    :header=\"false\"\r\n    :size=\"modalSize\"\r\n  >\r\n    <WhatsappApiIntegrationInfo\r\n      v-if=\"currentWppApiState === WhatsappApiStates.integrationInfo\"\r\n      @close=\"handleClose\"\r\n    />\r\n\r\n    <WhatsappApiProfileInfo\r\n      v-else-if=\"currentWppApiState === WhatsappApiStates.profileInfo\"\r\n      @close=\"handleClose\"\r\n    />\r\n\r\n    <WhatsappApiResponseStates\r\n      v-else-if=\"isResponseStates\"\r\n      @primary-action=\"handlePrimaryActionResponse\"\r\n      @secondary-action=\"handleSecondaryActionResponse\"\r\n      @close=\"handleClose\"\r\n    />\r\n  </Modal>\r\n</template>\r\n\r\n<script>\r\n  import { Modal } from 'uiv'\r\n\r\n  import { mapActions } from 'vuex'\r\n\r\n  import WhatsappApiIntegrationInfo from './WhatsappApiIntegrationInfo'\r\n\r\n  import WhatsappApiResponseStates from './WhatsappApiResponseStates'\r\n\r\n  import WhatsappApiProfileInfo from './WhatsappApiProfileInfo'\r\n\r\n  import { WhatsappApiStates } from '@/helpers/enums'\r\n\r\n  import GlobalMixins from '@/app/mixins'\r\n\r\n  export default {\r\n    props: {\r\n      isNew: {\r\n        type: Boolean,\r\n        required: false,\r\n        default: true\r\n      }\r\n    },\r\n    mixins: [GlobalMixins],\r\n    components: {\r\n      Modal,\r\n      WhatsappApiIntegrationInfo,\r\n      WhatsappApiResponseStates,\r\n      WhatsappApiProfileInfo\r\n    },\r\n    data() {\r\n      return {\r\n        show: true,\r\n        currentWppApiState: WhatsappApiStates.integrationInfo,\r\n        currentWppApiPreviousState: undefined\r\n      }\r\n    },\r\n    computed: {\r\n      WhatsappApiStates() {\r\n        return WhatsappApiStates\r\n      },\r\n      isResponseStates() {\r\n        return (\r\n          this.currentWppApiState === WhatsappApiStates.error ||\r\n          this.currentWppApiState === WhatsappApiStates.success\r\n        )\r\n      },\r\n      modalSize() {\r\n        return this.currentWppApiState === WhatsappApiStates.success &&\r\n          this.currentWppApiPreviousState !== WhatsappApiStates.integrationInfo\r\n          ? 'sm'\r\n          : 'lg'\r\n      }\r\n    },\r\n    mounted() {\r\n      this.unwatch = this.$store.watch((state, getters) => {\r\n        if (!getters.currentWppApiState) {\r\n          this.setCurrentWhatsappApiState(WhatsappApiStates.integrationInfo)\r\n        }\r\n\r\n        this.currentWppApiState = getters.currentWppApiState\r\n\r\n        this.currentWppApiPreviousState = getters.currentWppApiPreviousState\r\n      })\r\n    },\r\n    methods: {\r\n      ...mapActions(['setCurrentWhatsappApiState']),\r\n      handleClose() {\r\n        this.$emit('close')\r\n      },\r\n      handlePrimaryActionResponse() {\r\n        if (\r\n          this.currentWppApiPreviousState === WhatsappApiStates.integrationInfo\r\n        ) {\r\n          if (this.currentWppApiState === WhatsappApiStates.success) {\r\n            this.setCurrentWhatsappApiState(WhatsappApiStates.profileInfo)\r\n          } else if (this.currentWppApiState === WhatsappApiStates.error) {\r\n            this.setCurrentWhatsappApiState(WhatsappApiStates.integrationInfo)\r\n          }\r\n        } else {\r\n          if (this.currentWppApiState === WhatsappApiStates.error) {\r\n            this.setCurrentWhatsappApiState(WhatsappApiStates.profileInfo)\r\n          }\r\n        }\r\n      },\r\n      handleSecondaryActionResponse() {\r\n        if (\r\n          this.currentWppApiPreviousState === WhatsappApiStates.integrationInfo\r\n        ) {\r\n          if (this.currentWppApiState === WhatsappApiStates.success) {\r\n            this.setCurrentWhatsappApiState(WhatsappApiStates.integrationInfo)\r\n          } else if (this.currentWppApiState === WhatsappApiStates.error) {\r\n            this.handleClose()\r\n          }\r\n        } else {\r\n          if (this.currentWppApiState === WhatsappApiStates.error) {\r\n            this.handleClose()\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n</script>\r\n\r\n<style lang=\"scss\">\r\n  .wpp-api-modal {\r\n    div.modal-dialog {\r\n      margin: 10px auto;\r\n      @media (min-width: 768px) {\r\n        width: 680px;\r\n        margin: 30px auto;\r\n      }\r\n      div.modal-content {\r\n        border-radius: 6px;\r\n        box-shadow: 0 3px 9px rgba(0, 0, 0, 0.15);\r\n        div.modal-body {\r\n          padding: 0px;\r\n          overflow: auto;\r\n          display: flex;\r\n          justify-content: flex-end;\r\n          align-items: center;\r\n          flex-wrap: wrap;\r\n          height: auto;\r\n          button.wpp-close-btn {\r\n            width: 30px;\r\n            height: 30px;\r\n            position: absolute;\r\n            z-index: 10;\r\n            top: 15px;\r\n            right: 15px;\r\n            border: none;\r\n            cursor: pointer;\r\n            border-radius: 50%;\r\n            transition: 0.5s;\r\n            background: #f0f0f0;\r\n            &:before,\r\n            &:after {\r\n              content: '';\r\n              position: absolute;\r\n              left: 8px;\r\n              width: 15px;\r\n              height: 2px;\r\n              top: 14px;\r\n              transition: 0.5s;\r\n              border-radius: 10px;\r\n              background: #999999;\r\n            }\r\n            &:before {\r\n              transform: rotate(-45deg);\r\n            }\r\n            &:after {\r\n              transform: rotate(45deg);\r\n            }\r\n            &:hover {\r\n              opacity: 0.5;\r\n              background: #999999;\r\n              &:before,\r\n              &:after {\r\n                background: #f0f0f0;\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n      &.modal-sm {\r\n        @media (min-width: 768px) {\r\n          width: 525px;\r\n          margin: 30px auto;\r\n        }\r\n      }\r\n    }\r\n  }\r\n</style>\r\n", ".wpp-api-modal div.modal-dialog {\n  margin: 10px auto;\n}\n@media (min-width: 768px) {\n  .wpp-api-modal div.modal-dialog {\n    width: 680px;\n    margin: 30px auto;\n  }\n}\n.wpp-api-modal div.modal-dialog div.modal-content {\n  border-radius: 6px;\n  box-shadow: 0 3px 9px rgba(0, 0, 0, 0.15);\n}\n.wpp-api-modal div.modal-dialog div.modal-content div.modal-body {\n  padding: 0px;\n  overflow: auto;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  flex-wrap: wrap;\n  height: auto;\n}\n.wpp-api-modal div.modal-dialog div.modal-content div.modal-body button.wpp-close-btn {\n  width: 30px;\n  height: 30px;\n  position: absolute;\n  z-index: 10;\n  top: 15px;\n  right: 15px;\n  border: none;\n  cursor: pointer;\n  border-radius: 50%;\n  transition: 0.5s;\n  background: #f0f0f0;\n}\n.wpp-api-modal div.modal-dialog div.modal-content div.modal-body button.wpp-close-btn:before, .wpp-api-modal div.modal-dialog div.modal-content div.modal-body button.wpp-close-btn:after {\n  content: \"\";\n  position: absolute;\n  left: 8px;\n  width: 15px;\n  height: 2px;\n  top: 14px;\n  transition: 0.5s;\n  border-radius: 10px;\n  background: #999999;\n}\n.wpp-api-modal div.modal-dialog div.modal-content div.modal-body button.wpp-close-btn:before {\n  transform: rotate(-45deg);\n}\n.wpp-api-modal div.modal-dialog div.modal-content div.modal-body button.wpp-close-btn:after {\n  transform: rotate(45deg);\n}\n.wpp-api-modal div.modal-dialog div.modal-content div.modal-body button.wpp-close-btn:hover {\n  opacity: 0.5;\n  background: #999999;\n}\n.wpp-api-modal div.modal-dialog div.modal-content div.modal-body button.wpp-close-btn:hover:before, .wpp-api-modal div.modal-dialog div.modal-content div.modal-body button.wpp-close-btn:hover:after {\n  background: #f0f0f0;\n}\n@media (min-width: 768px) {\n  .wpp-api-modal div.modal-dialog.modal-sm {\n    width: 525px;\n    margin: 30px auto;\n  }\n}\n\n/*# sourceMappingURL=WhatsappApiModal.vue.map */"]
    },
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$l = undefined;
/* module identifier */

var __vue_module_identifier__$l = undefined;
/* functional template */

var __vue_is_functional_template__$l = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$l = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$j,
  staticRenderFns: __vue_staticRenderFns__$j
}, __vue_inject_styles__$l, __vue_script__$h, __vue_scope_id__$l, __vue_is_functional_template__$l, __vue_module_identifier__$l, false, createInjector, undefined, undefined);

var UNSUPPORTED_Y$3 = regexpStickyHelpers.UNSUPPORTED_Y;

// `RegExp.prototype.flags` getter
// https://tc39.github.io/ecma262/#sec-get-regexp.prototype.flags
if (descriptors && (/./g.flags != 'g' || UNSUPPORTED_Y$3)) {
  objectDefineProperty.f(RegExp.prototype, 'flags', {
    configurable: true,
    get: regexpFlags
  });
}

const img$4 = "data:image/png;base64,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";

var BR = {
	name: "Brasil",
	masks: [
		"(##) ####-####",
		"(##) #####-####"
	],
	code: "55"
};
var US = {
	name: "Estados Unidos",
	masks: [
		"(###) ###-####"
	],
	code: "1"
};
var CA = {
	name: "Canadá",
	masks: [
	],
	code: "1"
};
var GB = {
	name: "Reino Unido",
	"masks:": [
	],
	code: "44"
};
var DE = {
	name: "Alemanha",
	"masks:": [
	],
	code: "49"
};
var FR = {
	name: "França",
	"masks:": [
	],
	code: "33"
};
var JP = {
	name: "Japão",
	"masks:": [
	],
	code: "81"
};
var IT = {
	name: "Italia",
	"masks:": [
	],
	code: "39"
};
var CN = {
	name: "China",
	"masks:": [
	],
	code: "86"
};
var AR = {
	name: "Argentina",
	"masks:": [
	],
	code: "54"
};
var CL = {
	name: "Chile",
	"masks:": [
	],
	code: "56"
};
var countrys = {
	BR: BR,
	US: US,
	CA: CA,
	GB: GB,
	DE: DE,
	FR: FR,
	JP: JP,
	IT: IT,
	CN: CN,
	AR: AR,
	CL: CL
};

var dist = createCommonjsModule(function (module, exports) {
(function webpackUniversalModuleDefinition(root, factory) {
	module.exports = factory();
})(commonjsGlobal, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(8);

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(1),
  /* template */
  __webpack_require__(7),
  /* scopeId */
  "data-v-25adc6c0",
  /* cssModules */
  null
);

module.exports = Component.exports;


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(3);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var DEFAULT_COLOR_CHECKED = '#75c791';
var DEFAULT_COLOR_UNCHECKED = '#bfcbd9';
var DEFAULT_LABEL_CHECKED = 'on';
var DEFAULT_LABEL_UNCHECKED = 'off';
var DEFAULT_SWITCH_COLOR = '#fff';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ToggleButton',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    name: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tag: {
      type: String
    },
    sync: {
      type: Boolean,
      default: false
    },
    speed: {
      type: Number,
      default: 300
    },
    color: {
      type: [String, Object],
      validator: function validator(value) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* isString */])(value) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* has */])(value, 'checked') || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* has */])(value, 'unchecked') || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* has */])(value, 'disabled');
      }
    },
    switchColor: {
      type: [String, Object],
      validator: function validator(value) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* isString */])(value) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* has */])(value, 'checked') || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* has */])(value, 'unchecked');
      }
    },
    cssColors: {
      type: Boolean,
      default: false
    },
    labels: {
      type: [Boolean, Object],
      default: false,
      validator: function validator(value) {
        return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' ? value.checked || value.unchecked : typeof value === 'boolean';
      }
    },
    height: {
      type: Number,
      default: 22
    },
    width: {
      type: Number,
      default: 50
    },
    margin: {
      type: Number,
      default: 3
    },
    fontSize: {
      type: Number
    }
  },
  computed: {
    className: function className() {
      var toggled = this.toggled,
          disabled = this.disabled;


      return ['vue-js-switch', {
        toggled: toggled,
        disabled: disabled
      }];
    },
    coreStyle: function coreStyle() {
      return {
        width: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* px */])(this.width),
        height: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* px */])(this.height),
        backgroundColor: this.cssColors ? null : this.disabled ? this.colorDisabled : this.colorCurrent,
        borderRadius: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* px */])(Math.round(this.height / 2))
      };
    },
    buttonRadius: function buttonRadius() {
      return this.height - this.margin * 2;
    },
    distance: function distance() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* px */])(this.width - this.height + this.margin);
    },
    buttonStyle: function buttonStyle() {
      var transition = 'transform ' + this.speed + 'ms';
      var margin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* px */])(this.margin);

      var transform = this.toggled ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* translate3d */])(this.distance, margin) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* translate3d */])(margin, margin);

      var background = this.switchColor ? this.switchColorCurrent : null;

      return {
        width: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* px */])(this.buttonRadius),
        height: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* px */])(this.buttonRadius),
        transition: transition,
        transform: transform,
        background: background
      };
    },
    labelStyle: function labelStyle() {
      return {
        lineHeight: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* px */])(this.height),
        fontSize: this.fontSize ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* px */])(this.fontSize) : null
      };
    },
    colorChecked: function colorChecked() {
      var color = this.color;


      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["e" /* isObject */])(color)) {
        return color || DEFAULT_COLOR_CHECKED;
      }

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["f" /* get */])(color, 'checked', DEFAULT_COLOR_CHECKED);
    },
    colorUnchecked: function colorUnchecked() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["f" /* get */])(this.color, 'unchecked', DEFAULT_COLOR_UNCHECKED);
    },
    colorDisabled: function colorDisabled() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["f" /* get */])(this.color, 'disabled', this.colorCurrent);
    },
    colorCurrent: function colorCurrent() {
      return this.toggled ? this.colorChecked : this.colorUnchecked;
    },
    labelChecked: function labelChecked() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["f" /* get */])(this.labels, 'checked', DEFAULT_LABEL_CHECKED);
    },
    labelUnchecked: function labelUnchecked() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["f" /* get */])(this.labels, 'unchecked', DEFAULT_LABEL_UNCHECKED);
    },
    switchColorChecked: function switchColorChecked() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["f" /* get */])(this.switchColor, 'checked', DEFAULT_SWITCH_COLOR);
    },
    switchColorUnchecked: function switchColorUnchecked() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["f" /* get */])(this.switchColor, 'unchecked', DEFAULT_SWITCH_COLOR);
    },
    switchColorCurrent: function switchColorCurrent() {
      var switchColor = this.switchColor;


      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["e" /* isObject */])(this.switchColor)) {
        return this.switchColor || DEFAULT_SWITCH_COLOR;
      }

      return this.toggled ? this.switchColorChecked : this.switchColorUnchecked;
    }
  },
  watch: {
    value: function value(_value) {
      if (this.sync) {
        this.toggled = !!_value;
      }
    }
  },
  data: function data() {
    return {
      toggled: !!this.value
    };
  },

  methods: {
    toggle: function toggle(event) {
      var toggled = !this.toggled;

      if (!this.sync) {
        this.toggled = toggled;
      }

      this.$emit('input', toggled);
      this.$emit('change', {
        value: toggled,
        tag: this.tag,
        srcEvent: event
      });
    }
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Button_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Button_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Button_vue__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ToggleButton", function() { return __WEBPACK_IMPORTED_MODULE_0__Button_vue___default.a; });


var installed = false;

/* harmony default export */ __webpack_exports__["default"] = ({
  install: function install(Vue) {
    if (installed) {
      return;
    }

    Vue.component('ToggleButton', __WEBPACK_IMPORTED_MODULE_0__Button_vue___default.a);
    installed = true;
  }
});



/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isString; });
/* unused harmony export isBoolean */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return has; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return get; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return px; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return translate3d; });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isString = function isString(value) {
  return typeof value === 'string';
};

var isObject = function isObject(value) {
  return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object';
};

var has = function has(object, key) {
  return isObject(object) && object.hasOwnProperty(key);
};

var get = function get(object, key, defaultValue) {
  return has(object, key) ? object[key] : defaultValue;
};

var px = function px(value) {
  return value + 'px';
};

var translate3d = function translate3d(x, y) {
  var z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '0px';

  return 'translate3d(' + x + ', ' + y + ', ' + z + ')';
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".vue-js-switch[data-v-25adc6c0]{display:inline-block;position:relative;vertical-align:middle;user-select:none;font-size:10px;cursor:pointer}.vue-js-switch .v-switch-input[data-v-25adc6c0]{opacity:0;position:absolute;width:1px;height:1px}.vue-js-switch .v-switch-label[data-v-25adc6c0]{position:absolute;top:0;font-weight:600;color:#fff;z-index:1}.vue-js-switch .v-switch-label.v-left[data-v-25adc6c0]{left:10px}.vue-js-switch .v-switch-label.v-right[data-v-25adc6c0]{right:10px}.vue-js-switch .v-switch-core[data-v-25adc6c0]{display:block;position:relative;box-sizing:border-box;outline:0;margin:0;transition:border-color .3s,background-color .3s;user-select:none}.vue-js-switch .v-switch-core .v-switch-button[data-v-25adc6c0]{display:block;position:absolute;overflow:hidden;top:0;left:0;border-radius:100%;background-color:#fff;z-index:2}.vue-js-switch.disabled[data-v-25adc6c0]{pointer-events:none;opacity:.6}", ""]);

// exports


/***/ }),
/* 5 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),
/* 6 */
/***/ (function(module, exports) {

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  scopeId,
  cssModules
) {
  var esModule;
  var scriptExports = rawScriptExports = rawScriptExports || {};

  // ES6 modules interop
  var type = typeof rawScriptExports.default;
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports;
    scriptExports = rawScriptExports.default;
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports;

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render;
    options.staticRenderFns = compiledTemplate.staticRenderFns;
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId;
  }

  // inject cssModules
  if (cssModules) {
    var computed = Object.create(options.computed || null);
    Object.keys(cssModules).forEach(function (key) {
      var module = cssModules[key];
      computed[key] = function () { return module };
    });
    options.computed = computed;
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
};


/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    class: _vm.className
  }, [_c('input', {
    staticClass: "v-switch-input",
    attrs: {
      "type": "checkbox",
      "name": _vm.name,
      "disabled": _vm.disabled
    },
    domProps: {
      "checked": _vm.value
    },
    on: {
      "change": function($event) {
        $event.stopPropagation();
        return _vm.toggle($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "v-switch-core",
    style: (_vm.coreStyle)
  }, [_c('div', {
    staticClass: "v-switch-button",
    style: (_vm.buttonStyle)
  })]), _vm._v(" "), (_vm.labels) ? [(_vm.toggled) ? _c('span', {
    staticClass: "v-switch-label v-left",
    style: (_vm.labelStyle)
  }, [_vm._t("checked", [
    [_vm._v(_vm._s(_vm.labelChecked))]
  ])], 2) : _c('span', {
    staticClass: "v-switch-label v-right",
    style: (_vm.labelStyle)
  }, [_vm._t("unchecked", [
    [_vm._v(_vm._s(_vm.labelUnchecked))]
  ])], 2)] : _vm._e()], 2)
},staticRenderFns: []};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("2283861f", content, true);

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined';

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(10);

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/};

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0]);
var singletonElement = null;
var singletonCounter = 0;
var isProduction = false;
var noop = function () {};

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase());

module.exports = function (parentId, list, _isProduction) {
  isProduction = _isProduction;

  var styles = listToStyles(parentId, list);
  addStylesToDom(styles);

  return function update (newList) {
    var mayRemove = [];
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i];
      var domStyle = stylesInDom[item.id];
      domStyle.refs--;
      mayRemove.push(domStyle);
    }
    if (newList) {
      styles = listToStyles(parentId, newList);
      addStylesToDom(styles);
    } else {
      styles = [];
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i];
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]();
        }
        delete stylesInDom[domStyle.id];
      }
    }
  }
};

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i];
    var domStyle = stylesInDom[item.id];
    if (domStyle) {
      domStyle.refs++;
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j]);
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]));
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length;
      }
    } else {
      var parts = [];
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]));
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts };
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style');
  styleElement.type = 'text/css';
  head.appendChild(styleElement);
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove;
  var styleElement = document.querySelector('style[data-vue-ssr-id~="' + obj.id + '"]');

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement);
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++;
    styleElement = singletonElement || (singletonElement = createStyleElement());
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement();
    update = applyToTag.bind(null, styleElement);
    remove = function () {
      styleElement.parentNode.removeChild(styleElement);
    };
  }

  update(obj);

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj);
    } else {
      remove();
    }
  }
}

var replaceText = (function () {
  var textStore = [];

  return function (index, replacement) {
    textStore[index] = replacement;
    return textStore.filter(Boolean).join('\n')
  }
})();

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css;

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css);
  } else {
    var cssNode = document.createTextNode(css);
    var childNodes = styleElement.childNodes;
    if (childNodes[index]) styleElement.removeChild(childNodes[index]);
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index]);
    } else {
      styleElement.appendChild(cssNode);
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css;
  var media = obj.media;
  var sourceMap = obj.sourceMap;

  if (media) {
    styleElement.setAttribute('media', media);
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */';
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */';
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css;
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild);
    }
    styleElement.appendChild(document.createTextNode(css));
  }
}


/***/ }),
/* 10 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = [];
  var newStyles = {};
  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = item[0];
    var css = item[1];
    var media = item[2];
    var sourceMap = item[3];
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    };
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] });
    } else {
      newStyles[id].parts.push(part);
    }
  }
  return styles
};


/***/ })
/******/ ]);
});

});

var index$3 = /*@__PURE__*/unwrapExports(dist);

var script$i = {
  props: {
    phone: {
      type: Object,
      required: true
    },
    n2Team: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    GenericLoader: __vue_component__$1,
    Popover: Popover,
    'toggle-button': index$3.ToggleButton,
    IconWhatsApp: __vue_component__$9
  },
  directives: {
    tooltip: tooltip
  },
  mixins: [__vue_component__$b],
  data: function data() {
    return {
      waiting: false,
      removing: false,
      showConfirmPopover: false,
      editingPhone: false,
      editingPhoneName: '',
      updatedNumberName: undefined,
      flags: img$4
    };
  },
  computed: _objectSpread2(_objectSpread2({}, mapGetters(['isDebug'])), {}, {
    numberTooltip: function numberTooltip() {
      if (this.isDisconectedNumber) {
        return this.$t('listNumbers.item.unplugged');
      } else if (!this.phone.integrator && this.phone.status === whatsappConnectionStatus.connecting || !this.phone.status) {
        return this.$t('listNumbers.item.connecting');
      } else {
        return this.$t('listNumbers.item.connected');
      }
    },
    statusCircleColor: function statusCircleColor() {
      if (this.isDisconectedNumber) {
        return '#fe766e';
      } else if (!this.phone.integrator && (this.phone.status === whatsappConnectionStatus.connecting || !this.phone.status)) {
        return '#eaa607';
      } else {
        return '#4da094';
      }
    },
    isDisconectedNumber: function isDisconectedNumber() {
      return this.phone.status === whatsappConnectionStatus.disconnected;
    },
    consumerNumberInfo: function consumerNumberInfo() {
      return this.phone && this.phone.consumer && this.phone.consumer.numberInfo;
    },
    isPlugged: function isPlugged() {
      return this.consumerNumberInfo && this.consumerNumberInfo.plugged || false;
    },
    battery: function battery() {
      if (!this.consumerNumberInfo) {
        return '';
      } else {
        return this.consumerNumberInfo.battery;
      }
    },
    resolveBatteryIconClass: function resolveBatteryIconClass() {
      return this.resolveBattery().icon;
    },
    resolveBatteryTooltip: function resolveBatteryTooltip() {
      return this.resolveBattery().tooltip;
    }
  }),
  mounted: function mounted() {
    this.editingPhoneName = this.phone.translate;
  },
  methods: _objectSpread2(_objectSpread2({}, mapActions(['updateWhatsappName', 'removeWhatsappNumber', 'disableWhatsappNumber', 'enableWhatsappNumber', 'setCurrentWhatsappApiNumber', 'updateWhatsappApiNumber'])), {}, {
    resolveBattery: function resolveBattery() {
      var pluggedIcon = this.isPlugged ? '-charge' : '';
      var pluggedTooltip = this.isPlugged ? 'charge' : 'notCharging';

      if (typeof this.battery !== 'number') {
        return {
          icon: "icon-wp-battery-unknown".concat(pluggedIcon),
          tooltip: this.$t('listNumbers.battery.unknown')
        };
      } else if (this.battery <= 20) {
        return {
          icon: "icon-wp-battery-1-20".concat(pluggedIcon),
          tooltip: this.$t("listNumbers.battery.less-than-20.".concat(pluggedTooltip))
        };
      } else if (this.battery > 20 && this.battery <= 80) {
        return {
          icon: "icon-wp-battery-21-80".concat(pluggedIcon),
          tooltip: this.$t("listNumbers.battery.between-20-80.".concat(pluggedTooltip))
        };
      } else if (this.battery > 80 && this.battery <= 99) {
        return {
          icon: "icon-wp-battery-81-99".concat(pluggedIcon),
          tooltip: this.$t("listNumbers.battery.between-80-99.".concat(pluggedTooltip))
        };
      } else {
        return {
          icon: "icon-wp-battery-100".concat(pluggedIcon),
          tooltip: this.$t("listNumbers.battery.bt-100.".concat(pluggedTooltip))
        };
      }
    },
    handleReconnect: function handleReconnect() {
      this.$emit('recconect', this.phone);
    },
    handleEdit: function handleEdit() {
      this.$emit('edit', this.phone);
    },
    handleEnableChange: function handleEnableChange() {
      var _this = this;

      this.waiting = true;

      if (this.phone.isEnabled) {
        this.disableWhatsappNumber(this.phone.id).then(function () {
          _this.waiting = false;
        }).catch(function (error) {
          _this.waiting = false;
          console.error('Error at disablening number: ', error);
        });
      } else {
        this.enableWhatsappNumber(this.phone.id).then(function () {
          _this.waiting = false;
        }).catch(function (error) {
          _this.waiting = false;
          console.error('Error at enablening number: ', error);
        });
      }
    },
    handleParsePhoneFlag: function handleParsePhoneFlag(phoneNumber) {
      var verifiedNumber = this.verifyPrefix(phoneNumber) ? phoneNumber : "+".concat(phoneNumber);
      var parsedNumber = parsePhoneNumberFromString$2(verifiedNumber);
      return "flag-".concat(parsedNumber.country.toLowerCase());
    },
    handleParsePhoneCountry: function handleParsePhoneCountry(phoneNumber) {
      var verifiedNumber = this.verifyPrefix(phoneNumber) ? phoneNumber : "+".concat(phoneNumber);
      var parsedNumber = parsePhoneNumberFromString$2(verifiedNumber);

      if (countrys[parsedNumber.country]) {
        return countrys[parsedNumber.country].name;
      }
    },
    handleConfirmRemove: function handleConfirmRemove() {
      var _this2 = this;

      this.removing = true;
      this.removeWhatsappNumber(this.phone).then(function () {
        _this2.removing = false;
        _this2.showConfirmPopover = false;
      }).catch(function (err) {
        _this2.removing = false;
        console.error('Error at removing whatsappnumber: ', err);
      });
    },
    editNumberName: function editNumberName() {
      var _this3 = this;

      this.editingPhone = true;
      this.updatedNumberName = undefined;
      var id = this.phone.id;
      setTimeout(function () {
        _this3.$refs["phone".concat(id)].focus();
      }, 10);
    },
    updateQrCodeNumber: function updateQrCodeNumber() {
      var _this4 = this;

      var number = {
        id: this.phone.id,
        name: this.editingPhoneName || this.phone.name
      };
      this.updateWhatsappName(number).then(function () {
        _this4.updatedNumberName = 'success';
      }).catch(function (error) {
        _this4.updatedNumberName = 'error';
        console.error('Error at update number name: ', error);
      });
    },
    updateApiNumber: function updateApiNumber() {
      var _this5 = this;

      this.setCurrentWhatsappApiNumber({
        id: this.phone.id,
        customFields: this.phone.customFields,
        number: this.phone.number,
        name: this.editingPhoneName
      });
      this.updateWhatsappApiNumber().then(function () {
        _this5.updatedNumberName = 'success';
      }).catch(function (error) {
        _this5.updatedNumberName = 'error';
        console.error('Error at update number name: ', error);
      });
    },
    handleClosePhoneNameEdit: function handleClosePhoneNameEdit() {
      var _this6 = this;

      if (this.editingPhoneName !== this.phone.translate) {
        if (this.phone.integrator) {
          this.updateApiNumber();
        } else {
          this.updateQrCodeNumber();
        }
      }

      setTimeout(function () {
        _this6.updatedNumberName = undefined;
      }, 4000);
      this.editingPhone = false;
    },
    handleDeleteWppApi: function handleDeleteWppApi(numberId) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return deleteWhatsappApiNumber(numberId);

              case 2:
                document.location.reload(true);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  })
};

var __vue_script__$i = script$i;
/* template */

var __vue_render__$k = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("li", {
    staticClass: "row wpp-numbers-item"
  }, [_vm.n2Team ? _c("toggle-button", {
    attrs: {
      value: _vm.phone.isEnabled,
      width: 65,
      labels: {
        unchecked: _vm.$t("listNumbers.item.inactive"),
        checked: _vm.$t("listNumbers.item.active")
      }
    },
    on: {
      change: _vm.handleEnableChange
    }
  }) : _vm._e(), _vm._v(" "), _c("div", {
    staticClass: "col-sm-1"
  }, [_c("span", {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: _vm.numberTooltip,
      expression: "numberTooltip"
    }],
    staticClass: "status--circle--container"
  }, [_c("svg", {
    staticClass: "status--circle",
    attrs: {
      expanded: "true",
      height: "40px",
      width: "40px"
    }
  }, [_c("circle", {
    attrs: {
      fill: _vm.statusCircleColor,
      stroke: _vm.statusCircleColor,
      cx: "50%",
      cy: "50%",
      r: "5px"
    }
  }), _vm._v(" "), _c("circle", {
    staticClass: "pulse",
    attrs: {
      stroke: _vm.statusCircleColor,
      fill: _vm.statusCircleColor,
      cx: "50%",
      cy: "50%",
      r: "10px"
    }
  })])])]), _vm._v(" "), _c("div", {
    staticClass: "col-sm-1"
  }, [_vm.isDisconectedNumber ? _c("a", {
    staticClass: "wpp-reconnect-button",
    on: {
      click: _vm.handleReconnect
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("listNumbers.readQrCode")) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c("div", {
    staticClass: "col-sm-1"
  }, [!_vm.phone.integrator ? _c("div", {
    staticClass: "space-top-xs"
  }, [_c("IconWhatsApp"), _vm._v("\n      " + _vm._s(_vm.$t("listNumbers.types.web")) + "\n    ")], 1) : _c("div", {
    staticClass: "space-top-xs"
  }, [_c("span", {
    staticClass: "icon-wp-wapp-api"
  }), _vm._v("\n      " + _vm._s(_vm.$t("listNumbers.types.api")) + "\n    ")])]), _vm._v(" "), _c("div", {
    staticClass: "col-sm-2 phone-name"
  }, [_c("span", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.editingPhone,
      expression: "!editingPhone"
    }],
    attrs: {
      title: _vm.$t("listNumbers.item.rename")
    },
    on: {
      click: function click($event) {
        return _vm.editNumberName(_vm.phone);
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.phone.translate) + "\n    ")]), _vm._v(" "), _c("input", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.editingPhone,
      expression: "editingPhone"
    }, {
      name: "model",
      rawName: "v-model",
      value: _vm.editingPhoneName,
      expression: "editingPhoneName"
    }],
    ref: "phone" + _vm.phone.id,
    attrs: {
      type: "text",
      maxlength: "35"
    },
    domProps: {
      value: _vm.editingPhoneName
    },
    on: {
      focusout: _vm.handleClosePhoneNameEdit,
      input: function input($event) {
        if ($event.target.composing) {
          return;
        }

        _vm.editingPhoneName = $event.target.value;
      }
    }
  }), _vm._v(" "), _vm.updatedNumberName ? _c("div", {
    staticClass: "feedback-update-name",
    class: _vm.updatedNumberName
  }, [_c("span", {
    class: {
      "icon-wp-check-circle": _vm.updatedNumberName === "success",
      "icon-wp-msg-error": _vm.updatedNumberName === "error"
    }
  }), _vm._v(" "), _c("span", [_vm._v("\n        " + _vm._s(_vm.$t("listNumbers.item.changeName." + _vm.updatedNumberName)) + "\n      ")])]) : _vm._e()]), _vm._v(" "), _c("div", {
    staticClass: "col-sm-1"
  }, [_c("span", {
    staticClass: "flag",
    class: _vm.handleParsePhoneFlag(_vm.phone.number.toString()),
    style: "background-image: url(" + _vm.flags + ")"
  }), _vm._v("\n\n    " + _vm._s(_vm.handleParsePhoneCountry(_vm.phone.number.toString())) + "\n  ")]), _vm._v(" "), _c("div", {
    staticClass: "col-sm-3"
  }, [_vm._v("\n    " + _vm._s(_vm.handleParsePhoneNumber(_vm.phone.number.toString())) + "\n  ")]), _vm._v(" "), !_vm.phone.integrator ? _c("div", {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: this.battery ? _vm.resolveBatteryTooltip : _vm.$t("listNumbers.battery.unknown"),
      expression: "\n      this.battery ? resolveBatteryTooltip : $t('listNumbers.battery.unknown')\n    "
    }],
    staticClass: "col-sm-2 battery"
  }, [this.battery ? [_c("span", [_vm._v(_vm._s(this.battery + "%"))]), _vm._v(" "), _c("i", {
    class: _vm.resolveBatteryIconClass
  })] : _c("i", {
    staticClass: "icon-wp-battery-unknown"
  })], 2) : _c("div", {
    staticClass: "col-sm-2 battery"
  }, [_vm._v("-")]), _vm._v(" "), _c("div", {
    staticClass: "col-sm-1 actions"
  }, [_vm.phone.integrator ? _c("button", {
    staticClass: "icon-wp-edit",
    on: {
      click: _vm.handleEdit
    }
  }) : _vm._e(), _vm._v(" "), _vm.phone.integrator && _vm.isDebug ? _c("button", {
    staticClass: "icon-wp-trash-can wpp-api",
    on: {
      click: function click($event) {
        return _vm.handleDeleteWppApi(_vm.phone.id);
      }
    }
  }) : _vm._e(), _vm._v(" "), !_vm.phone.integrator ? _c("Popover", {
    attrs: {
      title: ""
    },
    model: {
      value: _vm.showConfirmPopover,
      callback: function callback($$v) {
        _vm.showConfirmPopover = $$v;
      },
      expression: "showConfirmPopover"
    }
  }, [_c("button", {
    staticClass: "icon-wp-trash-can"
  }), _vm._v(" "), _c("template", {
    slot: "popover"
  }, [_c("div", {
    staticClass: "text-center",
    staticStyle: {
      position: "relative",
      "min-height": "50px",
      "min-width": "228px"
    }
  }, [!_vm.removing ? _c("div", [_c("p", [_vm._v(_vm._s(_vm.$t("listNumbers.item.deleteNumber.title")))]), _vm._v(" "), _c("button", {
    staticClass: "btn btn-sm btn-primary",
    on: {
      click: _vm.handleConfirmRemove
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t("listNumbers.item.deleteNumber.yes")) + "\n            ")]), _vm._v(" "), _c("button", {
    staticClass: "btn btn-sm btn-primary-outline",
    on: {
      click: function click($event) {
        _vm.showConfirmPopover = false;
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t("listNumbers.item.deleteNumber.no")) + "\n            ")])]) : _c("GenericLoader")], 1)])], 2) : _vm._e()], 1)], 1);
};

var __vue_staticRenderFns__$k = [];
__vue_render__$k._withStripped = true;
/* style */

var __vue_inject_styles__$m = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-4cac9bd0_0", {
    source: "@keyframes pulse {\nfrom {\n    stroke-width: 3px;\n    stroke-opacity: 1;\n    transform: scale(0.3);\n}\nto {\n    stroke-width: 0;\n    stroke-opacity: 0;\n    transform: scale(2);\n}\n}\nli.wpp-numbers-item {\n  color: #757575;\n  border-bottom: 1px solid rgba(195, 195, 195, 0.48);\n  padding-bottom: 25px;\n  margin-top: 25px;\n  font-size: 16px;\n}\nli.wpp-numbers-item > div button.wpp-reconnect-button {\n  font-size: 16px;\n  cursor: pointer;\n  border: none;\n  position: absolute;\n  left: calc(50% - 16px);\n  top: 3px;\n}\nli.wpp-numbers-item > div span.status--circle--container {\n  position: relative;\n  left: 0;\n  top: 50%;\n  width: 16px;\n  height: 16px;\n  display: inline-block;\n}\nli.wpp-numbers-item > div span.status--circle--container svg {\n  position: absolute;\n  top: -12px;\n  left: -12px;\n}\nli.wpp-numbers-item > div span.status--circle--container circle {\n  stroke-width: 2px;\n  stroke-opacity: 1;\n}\nli.wpp-numbers-item > div span.status--circle--container circle.pulse {\n  fill: inherit;\n  fill-opacity: 0;\n  transform-origin: 50% 50%;\n  animation-duration: 2s;\n  animation-name: pulse;\n  animation-iteration-count: infinite;\n}\nli.wpp-numbers-item > div.phone-name {\n  text-align: left;\n  display: flex;\n}\nli.wpp-numbers-item > div.phone-name div.feedback-update-name {\n  position: absolute;\n  bottom: -20px;\n  left: 10px;\n  font-size: 12px;\n  line-height: 22px;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\nli.wpp-numbers-item > div.phone-name div.feedback-update-name span:first-child {\n  margin-right: 5px;\n}\nli.wpp-numbers-item > div.phone-name div.feedback-update-name.success {\n  color: #32ba7c;\n}\nli.wpp-numbers-item > div.phone-name div.feedback-update-name.error {\n  color: #ff0000;\n}\nli.wpp-numbers-item > div.phone-name > span,\nli.wpp-numbers-item > div.phone-name input {\n  width: 90%;\n  padding: 5px;\n  font-size: 16px;\n}\nli.wpp-numbers-item > div.phone-name > span {\n  cursor: pointer;\n}\nli.wpp-numbers-item > div.phone-name input {\n  border: 1px solid #ddd;\n  border-radius: 5px;\n}\nli.wpp-numbers-item > div.battery {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\nli.wpp-numbers-item > div.battery > span {\n  margin-right: 6px;\n  line-height: 18px;\n  padding-top: 4px;\n}\nli.wpp-numbers-item > div.actions {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\nli.wpp-numbers-item > div.actions button {\n  font-size: 18px;\n  cursor: pointer;\n  border: none;\n}\nli.wpp-numbers-item > div.actions button:before {\n  color: #7d8f9c;\n  transition: 0.5s;\n}\nli.wpp-numbers-item > div.actions button.icon-wp-edit:hover:before {\n  color: #005dcc;\n}\nli.wpp-numbers-item > div.actions button.icon-wp-trash-can.wpp-api {\n  margin-left: 15px;\n}\nli.wpp-numbers-item > div.actions button.icon-wp-trash-can:hover:before {\n  color: #f00;\n}\nli.wpp-numbers-item > div.actions > span {\n  position: relative;\n  top: 3px;\n}\n\n/*# sourceMappingURL=NumberItem.vue.map */",
    map: {
      "version": 3,
      "sources": ["E:\\Octadesk\\octa-whatsapp-client\\src\\app\\list-numbers\\components\\NumberItem.vue", "NumberItem.vue"],
      "names": [],
      "mappings": "AA0dA;AACA;IACA,iBAAA;IACA,iBAAA;IACA,qBAAA;ACzdE;AD2dF;IACA,eAAA;IACA,iBAAA;IACA,mBAAA;ACzdE;AACF;AD4dA;EACA,cAAA;EACA,kDAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;AC1dA;AD4dA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,QAAA;AC1dA;AD4dA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;AC1dA;AD2dA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;ACzdA;AD2dA;EACA,iBAAA;EACA,iBAAA;ACzdA;AD0dA;EACA,aAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,mCAAA;ACxdA;AD4dA;EACA,gBAAA;EACA,aAAA;AC1dA;AD2dA;EACA,kBAAA;EACA,aAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;ACzdA;AD0dA;EACA,iBAAA;ACxdA;AD0dA;EACA,cAAA;ACxdA;AD0dA;EACA,cAAA;ACxdA;AD2dA;;EAEA,UAAA;EACA,YAAA;EACA,eAAA;ACzdA;AD2dA;EACA,eAAA;ACzdA;AD2dA;EACA,sBAAA;EACA,kBAAA;ACzdA;AD4dA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AC1dA;AD2dA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;ACzdA;AD4dA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;AC1dA;AD2dA;EACA,eAAA;EACA,eAAA;EACA,YAAA;ACzdA;AD0dA;EACA,cAAA;EACA,gBAAA;ACxdA;AD0dA;EACA,cAAA;ACxdA;AD2dA;EACA,iBAAA;ACzdA;AD2dA;EACA,WAAA;ACzdA;AD6dA;EACA,kBAAA;EACA,QAAA;AC3dA;;AAEA,yCAAyC",
      "file": "NumberItem.vue",
      "sourcesContent": ["<template>\r\n  <li class=\"row wpp-numbers-item\">\r\n    <toggle-button\r\n      :value=\"phone.isEnabled\"\r\n      :width=\"65\"\r\n      :labels=\"{\r\n        unchecked: $t('listNumbers.item.inactive'),\r\n        checked: $t('listNumbers.item.active')\r\n      }\"\r\n      @change=\"handleEnableChange\"\r\n      v-if=\"n2Team\"\r\n    />\r\n\r\n    <div class=\"col-sm-1\">\r\n      <span v-tooltip=\"numberTooltip\" class=\"status--circle--container\">\r\n        <svg class=\"status--circle\" expanded=\"true\" height=\"40px\" width=\"40px\">\r\n          <circle\r\n            :fill=\"statusCircleColor\"\r\n            :stroke=\"statusCircleColor\"\r\n            cx=\"50%\"\r\n            cy=\"50%\"\r\n            r=\"5px\"\r\n          />\r\n\r\n          <circle\r\n            :stroke=\"statusCircleColor\"\r\n            :fill=\"statusCircleColor\"\r\n            class=\"pulse\"\r\n            cx=\"50%\"\r\n            cy=\"50%\"\r\n            r=\"10px\"\r\n          />\r\n        </svg>\r\n      </span>\r\n    </div>\r\n\r\n    <div class=\"col-sm-1\">\r\n      <a\r\n        v-if=\"isDisconectedNumber\"\r\n        class=\"wpp-reconnect-button\"\r\n        @click=\"handleReconnect\"\r\n      >\r\n        {{ $t('listNumbers.readQrCode') }}\r\n      </a>\r\n    </div>\r\n\r\n    <div class=\"col-sm-1\">\r\n      <div v-if=\"!phone.integrator\" class=\"space-top-xs\">\r\n        <IconWhatsApp />\r\n        {{ $t('listNumbers.types.web') }}\r\n      </div>\r\n\r\n      <div v-else class=\"space-top-xs\">\r\n        <span class=\"icon-wp-wapp-api\"></span>\r\n        {{ $t('listNumbers.types.api') }}\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"col-sm-2 phone-name\">\r\n      <span\r\n        :title=\"$t('listNumbers.item.rename')\"\r\n        v-show=\"!editingPhone\"\r\n        @click=\"editNumberName(phone)\"\r\n      >\r\n        {{ phone.translate }}\r\n      </span>\r\n\r\n      <input\r\n        v-show=\"editingPhone\"\r\n        type=\"text\"\r\n        v-model=\"editingPhoneName\"\r\n        maxlength=\"35\"\r\n        :ref=\"`phone${phone.id}`\"\r\n        @focusout=\"handleClosePhoneNameEdit\"\r\n      />\r\n\r\n      <div\r\n        class=\"feedback-update-name\"\r\n        v-if=\"updatedNumberName\"\r\n        :class=\"updatedNumberName\"\r\n      >\r\n        <span\r\n          :class=\"{\r\n            'icon-wp-check-circle': updatedNumberName === 'success',\r\n            'icon-wp-msg-error': updatedNumberName === 'error'\r\n          }\"\r\n        ></span>\r\n\r\n        <span>\r\n          {{ $t(`listNumbers.item.changeName.${updatedNumberName}`) }}\r\n        </span>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"col-sm-1\">\r\n      <span\r\n        class=\"flag\"\r\n        :class=\"handleParsePhoneFlag(phone.number.toString())\"\r\n        :style=\"`background-image: url(${flags})`\"\r\n      ></span>\r\n\r\n      {{ handleParsePhoneCountry(phone.number.toString()) }}\r\n    </div>\r\n\r\n    <div class=\"col-sm-3\">\r\n      {{ handleParsePhoneNumber(phone.number.toString()) }}\r\n    </div>\r\n\r\n    <div\r\n      class=\"col-sm-2 battery\"\r\n      v-if=\"!phone.integrator\"\r\n      v-tooltip=\"\r\n        this.battery ? resolveBatteryTooltip : $t('listNumbers.battery.unknown')\r\n      \"\r\n    >\r\n      <template v-if=\"this.battery\">\r\n        <span>{{ this.battery + '%' }}</span>\r\n\r\n        <i :class=\"resolveBatteryIconClass\" />\r\n      </template>\r\n\r\n      <i class=\"icon-wp-battery-unknown\" v-else />\r\n    </div>\r\n\r\n    <div class=\"col-sm-2 battery\" v-else>-</div>\r\n\r\n    <div class=\"col-sm-1 actions\">\r\n      <button\r\n        class=\"icon-wp-edit\"\r\n        v-if=\"phone.integrator\"\r\n        @click=\"handleEdit\"\r\n      />\r\n\r\n      <button\r\n        v-if=\"phone.integrator && isDebug\"\r\n        class=\"icon-wp-trash-can wpp-api\"\r\n        @click=\"handleDeleteWppApi(phone.id)\"\r\n      />\r\n\r\n      <Popover\r\n        :title=\"''\"\r\n        v-model=\"showConfirmPopover\"\r\n        v-if=\"!phone.integrator\"\r\n      >\r\n        <button class=\"icon-wp-trash-can\" />\r\n\r\n        <template slot=\"popover\">\r\n          <div\r\n            class=\"text-center\"\r\n            style=\"position: relative; min-height: 50px; min-width: 228px;\"\r\n          >\r\n            <div v-if=\"!removing\">\r\n              <p>{{ $t('listNumbers.item.deleteNumber.title') }}</p>\r\n\r\n              <button\r\n                class=\"btn btn-sm btn-primary\"\r\n                @click=\"handleConfirmRemove\"\r\n              >\r\n                {{ $t('listNumbers.item.deleteNumber.yes') }}\r\n              </button>\r\n\r\n              <button\r\n                class=\"btn btn-sm btn-primary-outline\"\r\n                @click=\"showConfirmPopover = false\"\r\n              >\r\n                {{ $t('listNumbers.item.deleteNumber.no') }}\r\n              </button>\r\n            </div>\r\n\r\n            <GenericLoader v-else />\r\n          </div>\r\n        </template>\r\n      </Popover>\r\n    </div>\r\n  </li>\r\n</template>\r\n\r\n<script>\r\n  import flags from '@/assets/images/flags.png'\r\n\r\n  import { mapActions, mapGetters } from 'vuex'\r\n\r\n  import { parsePhoneNumberFromString } from 'libphonenumber-js'\r\n\r\n  import { GenericLoader } from '@/app/shared-components'\r\n\r\n  import countrys from './countrys.json'\r\n\r\n  import { Popover, tooltip } from 'uiv'\r\n\r\n  import { ToggleButton } from 'vue-js-toggle-button'\r\n\r\n  import GlobalMixins from '@/app/mixins'\r\n\r\n  import { whatsappConnectionStatus } from '@/helpers'\r\n\r\n  import { IconWhatsApp } from '@/app/multi-color-icons'\r\n\r\n  import { integrator } from '@/services'\r\n\r\n  export default {\r\n    props: {\r\n      phone: {\r\n        type: Object,\r\n        required: true\r\n      },\r\n      n2Team: {\r\n        type: Boolean,\r\n        required: false,\r\n        default: false\r\n      }\r\n    },\r\n    components: {\r\n      GenericLoader,\r\n      Popover,\r\n      'toggle-button': ToggleButton,\r\n      IconWhatsApp\r\n    },\r\n    directives: {\r\n      tooltip\r\n    },\r\n    mixins: [GlobalMixins],\r\n    data() {\r\n      return {\r\n        waiting: false,\r\n        removing: false,\r\n        showConfirmPopover: false,\r\n        editingPhone: false,\r\n        editingPhoneName: '',\r\n        updatedNumberName: undefined,\r\n        flags\r\n      }\r\n    },\r\n    computed: {\r\n      ...mapGetters(['isDebug']),\r\n      numberTooltip() {\r\n        if (this.isDisconectedNumber) {\r\n          return this.$t('listNumbers.item.unplugged')\r\n        } else if (\r\n          (!this.phone.integrator &&\r\n            this.phone.status === whatsappConnectionStatus.connecting) ||\r\n          !this.phone.status\r\n        ) {\r\n          return this.$t('listNumbers.item.connecting')\r\n        } else {\r\n          return this.$t('listNumbers.item.connected')\r\n        }\r\n      },\r\n      statusCircleColor() {\r\n        if (this.isDisconectedNumber) {\r\n          return '#fe766e'\r\n        } else if (\r\n          !this.phone.integrator &&\r\n          (this.phone.status === whatsappConnectionStatus.connecting ||\r\n            !this.phone.status)\r\n        ) {\r\n          return '#eaa607'\r\n        } else {\r\n          return '#4da094'\r\n        }\r\n      },\r\n      isDisconectedNumber() {\r\n        return this.phone.status === whatsappConnectionStatus.disconnected\r\n      },\r\n      consumerNumberInfo() {\r\n        return (\r\n          this.phone && this.phone.consumer && this.phone.consumer.numberInfo\r\n        )\r\n      },\r\n      isPlugged() {\r\n        return (\r\n          (this.consumerNumberInfo && this.consumerNumberInfo.plugged) || false\r\n        )\r\n      },\r\n      battery() {\r\n        if (!this.consumerNumberInfo) {\r\n          return ''\r\n        } else {\r\n          return this.consumerNumberInfo.battery\r\n        }\r\n      },\r\n      resolveBatteryIconClass() {\r\n        return this.resolveBattery().icon\r\n      },\r\n      resolveBatteryTooltip() {\r\n        return this.resolveBattery().tooltip\r\n      }\r\n    },\r\n    mounted() {\r\n      this.editingPhoneName = this.phone.translate\r\n    },\r\n    methods: {\r\n      ...mapActions([\r\n        'updateWhatsappName',\r\n        'removeWhatsappNumber',\r\n        'disableWhatsappNumber',\r\n        'enableWhatsappNumber',\r\n        'setCurrentWhatsappApiNumber',\r\n        'updateWhatsappApiNumber'\r\n      ]),\r\n      resolveBattery() {\r\n        const pluggedIcon = this.isPlugged ? '-charge' : ''\r\n\r\n        const pluggedTooltip = this.isPlugged ? 'charge' : 'notCharging'\r\n\r\n        if (typeof this.battery !== 'number') {\r\n          return {\r\n            icon: `icon-wp-battery-unknown${pluggedIcon}`,\r\n            tooltip: this.$t('listNumbers.battery.unknown')\r\n          }\r\n        } else if (this.battery <= 20) {\r\n          return {\r\n            icon: `icon-wp-battery-1-20${pluggedIcon}`,\r\n            tooltip: this.$t(\r\n              `listNumbers.battery.less-than-20.${pluggedTooltip}`\r\n            )\r\n          }\r\n        } else if (this.battery > 20 && this.battery <= 80) {\r\n          return {\r\n            icon: `icon-wp-battery-21-80${pluggedIcon}`,\r\n            tooltip: this.$t(\r\n              `listNumbers.battery.between-20-80.${pluggedTooltip}`\r\n            )\r\n          }\r\n        } else if (this.battery > 80 && this.battery <= 99) {\r\n          return {\r\n            icon: `icon-wp-battery-81-99${pluggedIcon}`,\r\n            tooltip: this.$t(\r\n              `listNumbers.battery.between-80-99.${pluggedTooltip}`\r\n            )\r\n          }\r\n        } else {\r\n          return {\r\n            icon: `icon-wp-battery-100${pluggedIcon}`,\r\n            tooltip: this.$t(`listNumbers.battery.bt-100.${pluggedTooltip}`)\r\n          }\r\n        }\r\n      },\r\n      handleReconnect() {\r\n        this.$emit('recconect', this.phone)\r\n      },\r\n      handleEdit() {\r\n        this.$emit('edit', this.phone)\r\n      },\r\n      handleEnableChange() {\r\n        this.waiting = true\r\n\r\n        if (this.phone.isEnabled) {\r\n          this.disableWhatsappNumber(this.phone.id)\r\n            .then(() => {\r\n              this.waiting = false\r\n            })\r\n            .catch(error => {\r\n              this.waiting = false\r\n\r\n              console.error('Error at disablening number: ', error)\r\n            })\r\n        } else {\r\n          this.enableWhatsappNumber(this.phone.id)\r\n            .then(() => {\r\n              this.waiting = false\r\n            })\r\n            .catch(error => {\r\n              this.waiting = false\r\n\r\n              console.error('Error at enablening number: ', error)\r\n            })\r\n        }\r\n      },\r\n      handleParsePhoneFlag(phoneNumber) {\r\n        const verifiedNumber = this.verifyPrefix(phoneNumber)\r\n          ? phoneNumber\r\n          : `+${phoneNumber}`\r\n\r\n        const parsedNumber = parsePhoneNumberFromString(verifiedNumber)\r\n\r\n        return `flag-${parsedNumber.country.toLowerCase()}`\r\n      },\r\n      handleParsePhoneCountry(phoneNumber) {\r\n        const verifiedNumber = this.verifyPrefix(phoneNumber)\r\n          ? phoneNumber\r\n          : `+${phoneNumber}`\r\n\r\n        const parsedNumber = parsePhoneNumberFromString(verifiedNumber)\r\n\r\n        if (countrys[parsedNumber.country]) {\r\n          return countrys[parsedNumber.country].name\r\n        }\r\n      },\r\n      handleConfirmRemove() {\r\n        this.removing = true\r\n\r\n        this.removeWhatsappNumber(this.phone)\r\n          .then(() => {\r\n            this.removing = false\r\n\r\n            this.showConfirmPopover = false\r\n          })\r\n          .catch(err => {\r\n            this.removing = false\r\n\r\n            console.error('Error at removing whatsappnumber: ', err)\r\n          })\r\n      },\r\n      editNumberName() {\r\n        this.editingPhone = true\r\n\r\n        this.updatedNumberName = undefined\r\n\r\n        const id = this.phone.id\r\n\r\n        setTimeout(() => {\r\n          this.$refs[`phone${id}`].focus()\r\n        }, 10)\r\n      },\r\n      updateQrCodeNumber() {\r\n        const number = {\r\n          id: this.phone.id,\r\n          name: this.editingPhoneName || this.phone.name\r\n        }\r\n\r\n        this.updateWhatsappName(number)\r\n          .then(() => {\r\n            this.updatedNumberName = 'success'\r\n          })\r\n          .catch(error => {\r\n            this.updatedNumberName = 'error'\r\n\r\n            console.error('Error at update number name: ', error)\r\n          })\r\n      },\r\n      updateApiNumber() {\r\n        this.setCurrentWhatsappApiNumber({\r\n          id: this.phone.id,\r\n          customFields: this.phone.customFields,\r\n          number: this.phone.number,\r\n          name: this.editingPhoneName\r\n        })\r\n\r\n        this.updateWhatsappApiNumber()\r\n          .then(() => {\r\n            this.updatedNumberName = 'success'\r\n          })\r\n          .catch(error => {\r\n            this.updatedNumberName = 'error'\r\n\r\n            console.error('Error at update number name: ', error)\r\n          })\r\n      },\r\n      handleClosePhoneNameEdit() {\r\n        if (this.editingPhoneName !== this.phone.translate) {\r\n          if (this.phone.integrator) {\r\n            this.updateApiNumber()\r\n          } else {\r\n            this.updateQrCodeNumber()\r\n          }\r\n        }\r\n\r\n        setTimeout(() => {\r\n          this.updatedNumberName = undefined\r\n        }, 4000)\r\n\r\n        this.editingPhone = false\r\n      },\r\n      async handleDeleteWppApi(numberId) {\r\n        await integrator.deleteWhatsappApiNumber(numberId)\r\n\r\n        document.location.reload(true)\r\n      }\r\n    }\r\n  }\r\n</script>\r\n\r\n<style lang=\"scss\">\r\n  @keyframes pulse {\r\n    from {\r\n      stroke-width: 3px;\r\n      stroke-opacity: 1;\r\n      transform: scale(0.3);\r\n    }\r\n    to {\r\n      stroke-width: 0;\r\n      stroke-opacity: 0;\r\n      transform: scale(2);\r\n    }\r\n  }\r\n\r\n  li.wpp-numbers-item {\r\n    color: #757575;\r\n    border-bottom: 1px solid rgba(195, 195, 195, 0.48);\r\n    padding-bottom: 25px;\r\n    margin-top: 25px;\r\n    font-size: 16px;\r\n    & > div {\r\n      button.wpp-reconnect-button {\r\n        font-size: 16px;\r\n        cursor: pointer;\r\n        border: none;\r\n        position: absolute;\r\n        left: calc(50% - 16px);\r\n        top: 3px;\r\n      }\r\n      span.status--circle--container {\r\n        position: relative;\r\n        left: 0;\r\n        top: 50%;\r\n        width: 16px;\r\n        height: 16px;\r\n        display: inline-block;\r\n        svg {\r\n          position: absolute;\r\n          top: -12px;\r\n          left: -12px;\r\n        }\r\n        circle {\r\n          stroke-width: 2px;\r\n          stroke-opacity: 1;\r\n          &.pulse {\r\n            fill: inherit;\r\n            fill-opacity: 0;\r\n            transform-origin: 50% 50%;\r\n            animation-duration: 2s;\r\n            animation-name: pulse;\r\n            animation-iteration-count: infinite;\r\n          }\r\n        }\r\n      }\r\n      &.phone-name {\r\n        text-align: left;\r\n        display: flex;\r\n        div.feedback-update-name {\r\n          position: absolute;\r\n          bottom: -20px;\r\n          left: 10px;\r\n          font-size: 12px;\r\n          line-height: 22px;\r\n          display: flex;\r\n          justify-content: flex-start;\r\n          align-items: center;\r\n          span:first-child {\r\n            margin-right: 5px;\r\n          }\r\n          &.success {\r\n            color: #32ba7c;\r\n          }\r\n          &.error {\r\n            color: #ff0000;\r\n          }\r\n        }\r\n        & > span,\r\n        input {\r\n          width: 90%;\r\n          padding: 5px;\r\n          font-size: 16px;\r\n        }\r\n        & > span {\r\n          cursor: pointer;\r\n        }\r\n        input {\r\n          border: 1px solid #ddd;\r\n          border-radius: 5px;\r\n        }\r\n      }\r\n      &.battery {\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        & > span {\r\n          margin-right: 6px;\r\n          line-height: 18px;\r\n          padding-top: 4px;\r\n        }\r\n      }\r\n      &.actions {\r\n        display: flex;\r\n        justify-content: flex-end;\r\n        align-items: center;\r\n        button {\r\n          font-size: 18px;\r\n          cursor: pointer;\r\n          border: none;\r\n          &:before {\r\n            color: #7d8f9c;\r\n            transition: 0.5s;\r\n          }\r\n          &.icon-wp-edit:hover:before {\r\n            color: #005dcc;\r\n          }\r\n          &.icon-wp-trash-can {\r\n            &.wpp-api {\r\n              margin-left: 15px;\r\n            }\r\n            &:hover:before {\r\n              color: #f00;\r\n            }\r\n          }\r\n        }\r\n        & > span {\r\n          position: relative;\r\n          top: 3px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n</style>\r\n", "@keyframes pulse {\n  from {\n    stroke-width: 3px;\n    stroke-opacity: 1;\n    transform: scale(0.3);\n  }\n  to {\n    stroke-width: 0;\n    stroke-opacity: 0;\n    transform: scale(2);\n  }\n}\nli.wpp-numbers-item {\n  color: #757575;\n  border-bottom: 1px solid rgba(195, 195, 195, 0.48);\n  padding-bottom: 25px;\n  margin-top: 25px;\n  font-size: 16px;\n}\nli.wpp-numbers-item > div button.wpp-reconnect-button {\n  font-size: 16px;\n  cursor: pointer;\n  border: none;\n  position: absolute;\n  left: calc(50% - 16px);\n  top: 3px;\n}\nli.wpp-numbers-item > div span.status--circle--container {\n  position: relative;\n  left: 0;\n  top: 50%;\n  width: 16px;\n  height: 16px;\n  display: inline-block;\n}\nli.wpp-numbers-item > div span.status--circle--container svg {\n  position: absolute;\n  top: -12px;\n  left: -12px;\n}\nli.wpp-numbers-item > div span.status--circle--container circle {\n  stroke-width: 2px;\n  stroke-opacity: 1;\n}\nli.wpp-numbers-item > div span.status--circle--container circle.pulse {\n  fill: inherit;\n  fill-opacity: 0;\n  transform-origin: 50% 50%;\n  animation-duration: 2s;\n  animation-name: pulse;\n  animation-iteration-count: infinite;\n}\nli.wpp-numbers-item > div.phone-name {\n  text-align: left;\n  display: flex;\n}\nli.wpp-numbers-item > div.phone-name div.feedback-update-name {\n  position: absolute;\n  bottom: -20px;\n  left: 10px;\n  font-size: 12px;\n  line-height: 22px;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\nli.wpp-numbers-item > div.phone-name div.feedback-update-name span:first-child {\n  margin-right: 5px;\n}\nli.wpp-numbers-item > div.phone-name div.feedback-update-name.success {\n  color: #32ba7c;\n}\nli.wpp-numbers-item > div.phone-name div.feedback-update-name.error {\n  color: #ff0000;\n}\nli.wpp-numbers-item > div.phone-name > span,\nli.wpp-numbers-item > div.phone-name input {\n  width: 90%;\n  padding: 5px;\n  font-size: 16px;\n}\nli.wpp-numbers-item > div.phone-name > span {\n  cursor: pointer;\n}\nli.wpp-numbers-item > div.phone-name input {\n  border: 1px solid #ddd;\n  border-radius: 5px;\n}\nli.wpp-numbers-item > div.battery {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\nli.wpp-numbers-item > div.battery > span {\n  margin-right: 6px;\n  line-height: 18px;\n  padding-top: 4px;\n}\nli.wpp-numbers-item > div.actions {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\nli.wpp-numbers-item > div.actions button {\n  font-size: 18px;\n  cursor: pointer;\n  border: none;\n}\nli.wpp-numbers-item > div.actions button:before {\n  color: #7d8f9c;\n  transition: 0.5s;\n}\nli.wpp-numbers-item > div.actions button.icon-wp-edit:hover:before {\n  color: #005dcc;\n}\nli.wpp-numbers-item > div.actions button.icon-wp-trash-can.wpp-api {\n  margin-left: 15px;\n}\nli.wpp-numbers-item > div.actions button.icon-wp-trash-can:hover:before {\n  color: #f00;\n}\nli.wpp-numbers-item > div.actions > span {\n  position: relative;\n  top: 3px;\n}\n\n/*# sourceMappingURL=NumberItem.vue.map */"]
    },
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$m = undefined;
/* module identifier */

var __vue_module_identifier__$m = undefined;
/* functional template */

var __vue_is_functional_template__$m = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$m = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$k,
  staticRenderFns: __vue_staticRenderFns__$k
}, __vue_inject_styles__$m, __vue_script__$i, __vue_scope_id__$m, __vue_is_functional_template__$m, __vue_module_identifier__$m, false, createInjector, undefined, undefined);

var nativeGetOwnPropertyNames = objectGetOwnPropertyNames.f;

var toString$3 = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return nativeGetOwnPropertyNames(it);
  } catch (error) {
    return windowNames.slice();
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var f$5 = function getOwnPropertyNames(it) {
  return windowNames && toString$3.call(it) == '[object Window]'
    ? getWindowNames(it)
    : nativeGetOwnPropertyNames(toIndexedObject(it));
};

var objectGetOwnPropertyNamesExternal = {
	f: f$5
};

var f$6 = wellKnownSymbol;

var wellKnownSymbolWrapped = {
	f: f$6
};

var defineProperty$5 = objectDefineProperty.f;

var defineWellKnownSymbol = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!has(Symbol, NAME)) defineProperty$5(Symbol, NAME, {
    value: wellKnownSymbolWrapped.f(NAME)
  });
};

var defineProperty$6 = objectDefineProperty.f;



var TO_STRING_TAG$2 = wellKnownSymbol('toStringTag');

var setToStringTag = function (it, TAG, STATIC) {
  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG$2)) {
    defineProperty$6(it, TO_STRING_TAG$2, { configurable: true, value: TAG });
  }
};

var $forEach$1 = arrayIteration.forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE$1 = 'prototype';
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var setInternalState$1 = internalState.set;
var getInternalState = internalState.getterFor(SYMBOL);
var ObjectPrototype = Object[PROTOTYPE$1];
var $Symbol = global_1.Symbol;
var $stringify = getBuiltIn('JSON', 'stringify');
var nativeGetOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
var nativeDefineProperty$1 = objectDefineProperty.f;
var nativeGetOwnPropertyNames$1 = objectGetOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable$1 = objectPropertyIsEnumerable.f;
var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');
var WellKnownSymbolsStore$1 = shared('wks');
var QObject = global_1.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE$1] || !QObject[PROTOTYPE$1].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = descriptors && fails(function () {
  return objectCreate(nativeDefineProperty$1({}, 'a', {
    get: function () { return nativeDefineProperty$1(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor$1(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty$1(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty$1(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty$1;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = objectCreate($Symbol[PROTOTYPE$1]);
  setInternalState$1(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!descriptors) symbol.description = description;
  return symbol;
};

var isSymbol = useSymbolAsUid ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return Object(it) instanceof $Symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPrimitive(P, true);
  anObject(Attributes);
  if (has(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!has(O, HIDDEN)) nativeDefineProperty$1(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (has(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = objectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty$1(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach$1(keys, function (key) {
    if (!descriptors || $propertyIsEnumerable.call(properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? objectCreate(O) : $defineProperties(objectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPrimitive(V, true);
  var enumerable = nativePropertyIsEnumerable$1.call(this, P);
  if (this === ObjectPrototype && has(AllSymbols, P) && !has(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !has(this, P) || !has(AllSymbols, P) || has(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPrimitive(P, true);
  if (it === ObjectPrototype && has(AllSymbols, key) && !has(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor$1(it, key);
  if (descriptor && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames$1(toIndexedObject(O));
  var result = [];
  $forEach$1(names, function (key) {
    if (!has(AllSymbols, key) && !has(hiddenKeys, key)) result.push(key);
  });
  return result;
};

var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames$1(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach$1(names, function (key) {
    if (has(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has(ObjectPrototype, key))) {
      result.push(AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.github.io/ecma262/#sec-symbol-constructor
if (!nativeSymbol) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : String(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) setter.call(ObjectPrototypeSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (descriptors && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  redefine($Symbol[PROTOTYPE$1], 'toString', function toString() {
    return getInternalState(this).tag;
  });

  redefine($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  objectPropertyIsEnumerable.f = $propertyIsEnumerable;
  objectDefineProperty.f = $defineProperty;
  objectGetOwnPropertyDescriptor.f = $getOwnPropertyDescriptor;
  objectGetOwnPropertyNames.f = objectGetOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  objectGetOwnPropertySymbols.f = $getOwnPropertySymbols;

  wellKnownSymbolWrapped.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (descriptors) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty$1($Symbol[PROTOTYPE$1], 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    {
      redefine(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

_export({ global: true, wrap: true, forced: !nativeSymbol, sham: !nativeSymbol }, {
  Symbol: $Symbol
});

$forEach$1(objectKeys(WellKnownSymbolsStore$1), function (name) {
  defineWellKnownSymbol(name);
});

_export({ target: SYMBOL, stat: true, forced: !nativeSymbol }, {
  // `Symbol.for` method
  // https://tc39.github.io/ecma262/#sec-symbol.for
  'for': function (key) {
    var string = String(key);
    if (has(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = $Symbol(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  },
  // `Symbol.keyFor` method
  // https://tc39.github.io/ecma262/#sec-symbol.keyfor
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
    if (has(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  },
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

_export({ target: 'Object', stat: true, forced: !nativeSymbol, sham: !descriptors }, {
  // `Object.create` method
  // https://tc39.github.io/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.github.io/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.github.io/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

_export({ target: 'Object', stat: true, forced: !nativeSymbol }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames,
  // `Object.getOwnPropertySymbols` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertysymbols
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
_export({ target: 'Object', stat: true, forced: fails(function () { objectGetOwnPropertySymbols.f(1); }) }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return objectGetOwnPropertySymbols.f(toObject(it));
  }
});

// `JSON.stringify` method behavior with symbols
// https://tc39.github.io/ecma262/#sec-json.stringify
if ($stringify) {
  var FORCED_JSON_STRINGIFY = !nativeSymbol || fails(function () {
    var symbol = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    return $stringify([symbol]) != '[null]'
      // WebKit converts symbol values to JSON as null
      || $stringify({ a: symbol }) != '{}'
      // V8 throws on boxed symbols
      || $stringify(Object(symbol)) != '{}';
  });

  _export({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY }, {
    // eslint-disable-next-line no-unused-vars
    stringify: function stringify(it, replacer, space) {
      var args = [it];
      var index = 1;
      var $replacer;
      while (arguments.length > index) args.push(arguments[index++]);
      $replacer = replacer;
      if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
      if (!isArray(replacer)) replacer = function (key, value) {
        if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return $stringify.apply(null, args);
    }
  });
}

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.github.io/ecma262/#sec-symbol.prototype-@@toprimitive
if (!$Symbol[PROTOTYPE$1][TO_PRIMITIVE]) {
  createNonEnumerableProperty($Symbol[PROTOTYPE$1], TO_PRIMITIVE, $Symbol[PROTOTYPE$1].valueOf);
}
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.github.io/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;

var defineProperty$7 = objectDefineProperty.f;


var NativeSymbol = global_1.Symbol;

if (descriptors && typeof NativeSymbol == 'function' && (!('description' in NativeSymbol.prototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : String(arguments[0]);
    var result = this instanceof SymbolWrapper
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };
  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  var symbolPrototype = SymbolWrapper.prototype = NativeSymbol.prototype;
  symbolPrototype.constructor = SymbolWrapper;

  var symbolToString = symbolPrototype.toString;
  var native = String(NativeSymbol('test')) == 'Symbol(test)';
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  defineProperty$7(symbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = isObject(this) ? this.valueOf() : this;
      var string = symbolToString.call(symbol);
      if (has(EmptyStringDescriptionStore, symbol)) return '';
      var desc = native ? string.slice(7, -1) : string.replace(regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  _export({ global: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}

var vClickOutside_umd = createCommonjsModule(function (module, exports) {
!function(e,n){module.exports=n();}(commonjsGlobal,function(){var e="undefined"!=typeof window,n="undefined"!=typeof navigator,t=e&&("ontouchstart"in window||n&&navigator.msMaxTouchPoints>0)?["touchstart"]:["click"];function i(e){var n=e.event,t=e.handler;(0, e.middleware)(n)&&t(n);}function r(e,n){var r=function(e){var n="function"==typeof e;if(!n&&"object"!=typeof e)throw new Error("v-click-outside: Binding value must be a function or an object");return {handler:n?e:e.handler,middleware:e.middleware||function(e){return e},events:e.events||t,isActive:!(!1===e.isActive),detectIframe:!(!1===e.detectIframe)}}(n.value),d=r.handler,o=r.middleware,a=r.detectIframe;if(r.isActive){if(e["__v-click-outside"]=r.events.map(function(n){return {event:n,srcTarget:document.documentElement,handler:function(n){return function(e){var n=e.el,t=e.event,r=e.handler,d=e.middleware,o=t.path||t.composedPath&&t.composedPath();(o?o.indexOf(n)<0:!n.contains(t.target))&&i({event:t,handler:r,middleware:d});}({el:e,event:n,handler:d,middleware:o})}}}),a){var c={event:"blur",srcTarget:window,handler:function(n){return function(e){var n=e.el,t=e.event,r=e.handler,d=e.middleware;setTimeout(function(){var e=document.activeElement;e&&"IFRAME"===e.tagName&&!n.contains(e)&&i({event:t,handler:r,middleware:d});},0);}({el:e,event:n,handler:d,middleware:o})}};e["__v-click-outside"]=[].concat(e["__v-click-outside"],[c]);}e["__v-click-outside"].forEach(function(n){var t=n.event,i=n.srcTarget,r=n.handler;return setTimeout(function(){e["__v-click-outside"]&&i.addEventListener(t,r,!1);},0)});}}function d(e){(e["__v-click-outside"]||[]).forEach(function(e){return e.srcTarget.removeEventListener(e.event,e.handler,!1)}),delete e["__v-click-outside"];}var o=e?{bind:r,update:function(e,n){var t=n.value,i=n.oldValue;JSON.stringify(t)!==JSON.stringify(i)&&(d(e),r(e,{value:t}));},unbind:d}:{};return {install:function(e){e.directive("click-outside",o);},directive:o}});

});

var script$j = {
  components: {
    collapse: Collapse,
    IconWhatsApp: __vue_component__$9
  },
  directives: {
    clickOutside: vClickOutside_umd.directive
  },
  mixins: [__vue_component__$b],
  data: function data() {
    return {
      availableFeatures: undefined,
      showOptions: false,
      clickOutsideConfig: {
        handler: this.handleCloseOptions,
        events: ['click'],
        isActive: true
      }
    };
  },
  computed: {
    integrations: function integrations() {
      var integrations = ['qrcode'];

      if (this.availableFeatures && this.availableFeatures['whatsappBusinessApi']) {
        integrations.push('whatsappApi');
      }

      return integrations;
    }
  },
  created: function created() {
    var _this = this;

    this.unsubscribe = this.$store.subscribe(function (mutation, state) {
      var _state$company, _state$company$compan;

      _this.availableFeatures = (_state$company = state.company) === null || _state$company === void 0 ? void 0 : (_state$company$compan = _state$company.companyDTO) === null || _state$company$compan === void 0 ? void 0 : _state$company$compan.features;
    });
  },
  methods: _objectSpread2(_objectSpread2({}, mapActions(['clearCurrentWhatsappApiNumber', 'setCurrentWhatsappApiState'])), {}, {
    handleClick: function handleClick() {
      this.showOptions = !this.showOptions;
    },
    handleCloseOptions: function handleCloseOptions() {
      this.showOptions = false;
    },
    handleAddNumber: function handleAddNumber(type) {
      if (type === 'whatsappApi') {
        this.clearCurrentWhatsappApiNumber();
        this.setCurrentWhatsappApiState(WhatsappApiStates.integrationInfo);
      }

      this.$emit('click', type);
    }
  })
};

/* script */
var __vue_script__$j = script$j;
/* template */

var __vue_render__$l = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.integrations.length === 1 ? _c("button", {
    staticClass: "btn btn-add-number",
    attrs: {
      type: "button"
    },
    on: {
      click: function click($event) {
        return _vm.$emit("click");
      }
    }
  }, [_vm._v("\n  " + _vm._s(_vm.$t("listNumbers.addNewNumber")) + "\n")]) : _c("div", {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.clickOutsideConfig,
      expression: "clickOutsideConfig"
    }],
    staticClass: "number-container"
  }, [_c("button", {
    staticClass: "btn btn-add-number",
    class: {
      active: _vm.showOptions
    },
    attrs: {
      type: "button"
    },
    on: {
      click: _vm.handleClick
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t("listNumbers.addNewNumber")) + "\n  ")]), _vm._v(" "), _c("collapse", {
    staticClass: "btn-add-number-options",
    model: {
      value: _vm.showOptions,
      callback: function callback($$v) {
        _vm.showOptions = $$v;
      },
      expression: "showOptions"
    }
  }, [_c("li", {
    on: {
      click: function click($event) {
        return _vm.handleAddNumber("whatsappApi");
      }
    }
  }, [_c("span", [_c("span", {
    staticClass: "icon-wp-wapp-api"
  }), _vm._v("\n        " + _vm._s(_vm.$t("integrations.api.label")) + "\n      ")])]), _vm._v(" "), _c("li", {
    on: {
      click: function click($event) {
        return _vm.$emit("click", "qrcode");
      }
    }
  }, [_c("span", [_c("IconWhatsApp"), _vm._v("\n        " + _vm._s(_vm.$t("integrations.web.label")) + "\n      ")], 1)])])], 1);
};

var __vue_staticRenderFns__$l = [];
__vue_render__$l._withStripped = true;
/* style */

var __vue_inject_styles__$n = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-13dc699f_0", {
    source: "button.btn-add-number[data-v-13dc699f] {\n  border-radius: 25px;\n  display: block;\n  padding: 8px 12px;\n  margin: 0 auto;\n  margin-bottom: 101px;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 16px;\n  line-height: 19px;\n  text-align: center;\n  height: 39px;\n  background: #0074ff;\n  color: #fff !important;\n  position: relative;\n  z-index: 1;\n  transition: 0.5s;\n}\nbutton.btn-add-number strong[data-v-13dc699f] {\n  margin-right: 5px;\n}\nbutton.btn-add-number[data-v-13dc699f]:hover {\n  background: #005dcc;\n}\ndiv.number-container[data-v-13dc699f] {\n  position: relative;\n}\ndiv.number-container div.btn-add-number-options[data-v-13dc699f] {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 0;\n  padding-top: calc(39px + 3px);\n  padding-bottom: 6px;\n  border: 1px solid #d7d7d7;\n  box-sizing: border-box;\n  border-radius: 22px;\n}\ndiv.number-container div.btn-add-number-options li[data-v-13dc699f] {\n  width: calc(100% - 20px);\n  margin-left: 10px;\n  padding: 4px 0px;\n  cursor: pointer;\n  list-style: none;\n  font-family: Helvetica;\n  font-style: normal;\n  font-weight: normal;\n  color: #999;\n  font-size: 13px;\n}\ndiv.number-container div.btn-add-number-options li > span[data-v-13dc699f] {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  width: 100%;\n  padding: 5px 10px;\n  transition: 0.5s;\n}\ndiv.number-container div.btn-add-number-options li > span span[data-v-13dc699f] {\n  margin-right: 8px;\n}\ndiv.number-container div.btn-add-number-options li:hover > span[data-v-13dc699f] {\n  border-radius: 22px;\n  background: #f0f0f0;\n}\ndiv.number-container div.btn-add-number-options li[data-v-13dc699f]:first-child {\n  border-bottom: 1px solid #d7d7d7;\n}\n\n/*# sourceMappingURL=AddNumberButton.vue.map */",
    map: {
      "version": 3,
      "sources": ["E:\\Octadesk\\octa-whatsapp-client\\src\\app\\list-numbers\\components\\AddNumberButton.vue", "AddNumberButton.vue"],
      "names": [],
      "mappings": "AA2HA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,cAAA;EACA,oBARA;EASA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAnBA;EAoBA,mBAlBA;EAmBA,sBAAA;EACA,kBAAA;EACA,UApBA;EAqBA,gBAAA;AC1HA;AD2HA;EACA,iBAAA;ACzHA;AD2HA;EACA,mBAAA;ACzHA;AD4HA;EACA,kBAAA;ACzHA;AD0HA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,UAjCA;EAkCA,6BAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;ACxHA;ADyHA;EACA,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;ACvHA;ADwHA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;ACtHA;ADuHA;EACA,iBAAA;ACrHA;ADwHA;EACA,mBAAA;EACA,mBAAA;ACtHA;ADwHA;EACA,gCAAA;ACtHA;;AAEA,8CAA8C",
      "file": "AddNumberButton.vue",
      "sourcesContent": ["<template>\r\n  <button\r\n    class=\"btn btn-add-number\"\r\n    type=\"button\"\r\n    @click=\"$emit('click')\"\r\n    v-if=\"integrations.length === 1\"\r\n  >\r\n    {{ $t('listNumbers.addNewNumber') }}\r\n  </button>\r\n\r\n  <div v-else class=\"number-container\" v-click-outside=\"clickOutsideConfig\">\r\n    <button\r\n      class=\"btn btn-add-number\"\r\n      :class=\"{ active: showOptions }\"\r\n      type=\"button\"\r\n      @click=\"handleClick\"\r\n    >\r\n      {{ $t('listNumbers.addNewNumber') }}\r\n    </button>\r\n\r\n    <collapse v-model=\"showOptions\" class=\"btn-add-number-options\">\r\n      <li @click=\"handleAddNumber('whatsappApi')\">\r\n        <span>\r\n          <span class=\"icon-wp-wapp-api\" />\r\n          {{ $t('integrations.api.label') }}\r\n        </span>\r\n      </li>\r\n\r\n      <li @click=\"$emit('click', 'qrcode')\">\r\n        <span>\r\n          <IconWhatsApp />\r\n          {{ $t('integrations.web.label') }}\r\n        </span>\r\n      </li>\r\n    </collapse>\r\n  </div>\r\n</template>\r\n\r\n<script>\r\n  import vClickOutside from 'v-click-outside'\r\n\r\n  import { Collapse } from 'uiv'\r\n\r\n  import { mapActions } from 'vuex'\r\n\r\n  import { IconWhatsApp } from '@/app/multi-color-icons'\r\n\r\n  import { WhatsappApiStates } from '@/helpers/enums'\r\n\r\n  import GlobalMixins from '@/app/mixins'\r\n\r\n  export default {\r\n    components: {\r\n      collapse: Collapse,\r\n      IconWhatsApp\r\n    },\r\n    directives: {\r\n      clickOutside: vClickOutside.directive\r\n    },\r\n    mixins: [GlobalMixins],\r\n    data() {\r\n      return {\r\n        availableFeatures: undefined,\r\n        showOptions: false,\r\n        clickOutsideConfig: {\r\n          handler: this.handleCloseOptions,\r\n          events: ['click'],\r\n          isActive: true\r\n        }\r\n      }\r\n    },\r\n    computed: {\r\n      integrations() {\r\n        const integrations = ['qrcode']\r\n\r\n        if (\r\n          this.availableFeatures &&\r\n          this.availableFeatures['whatsappBusinessApi']\r\n        ) {\r\n          integrations.push('whatsappApi')\r\n        }\r\n\r\n        return integrations\r\n      }\r\n    },\r\n    created() {\r\n      this.unsubscribe = this.$store.subscribe((mutation, state) => {\r\n        this.availableFeatures = state.company?.companyDTO?.features\r\n      })\r\n    },\r\n    methods: {\r\n      ...mapActions([\r\n        'clearCurrentWhatsappApiNumber',\r\n        'setCurrentWhatsappApiState'\r\n      ]),\r\n      handleClick() {\r\n        this.showOptions = !this.showOptions\r\n      },\r\n      handleCloseOptions() {\r\n        this.showOptions = false\r\n      },\r\n      handleAddNumber(type) {\r\n        if (type === 'whatsappApi') {\r\n          this.clearCurrentWhatsappApiNumber()\r\n\r\n          this.setCurrentWhatsappApiState(WhatsappApiStates.integrationInfo)\r\n        }\r\n\r\n        this.$emit('click', type)\r\n      }\r\n    }\r\n  }\r\n</script>\r\n\r\n<style lang=\"scss\" scoped>\r\n  $btn-height: 39px;\r\n  $btn-color: #fff;\r\n  $btn-bg: #0074ff;\r\n  $btn-z-index: 1;\r\n  $btn-active-border: 3px;\r\n  $collapse-height: 101px;\r\n  $collapse-z-index: 0;\r\n\r\n  button.btn-add-number {\r\n    border-radius: 25px;\r\n    display: block;\r\n    padding: 8px 12px;\r\n    margin: 0 auto;\r\n    margin-bottom: $collapse-height;\r\n    font-style: normal;\r\n    font-weight: normal;\r\n    font-size: 16px;\r\n    line-height: 19px;\r\n    text-align: center;\r\n    height: $btn-height;\r\n    background: $btn-bg;\r\n    color: $btn-color !important;\r\n    position: relative;\r\n    z-index: $btn-z-index;\r\n    transition: 0.5s;\r\n    strong {\r\n      margin-right: 5px;\r\n    }\r\n    &:hover {\r\n      background: darken($color: $btn-bg, $amount: 10%);\r\n    }\r\n  }\r\n  div.number-container {\r\n    position: relative;\r\n    div.btn-add-number-options {\r\n      position: absolute;\r\n      top: 0;\r\n      right: 0;\r\n      left: 0;\r\n      z-index: $collapse-z-index;\r\n      padding-top: calc(#{$btn-height} + #{$btn-active-border});\r\n      padding-bottom: 6px;\r\n      border: 1px solid #d7d7d7;\r\n      box-sizing: border-box;\r\n      border-radius: 22px;\r\n      li {\r\n        width: calc(100% - 20px);\r\n        margin-left: 10px;\r\n        padding: 4px 0px;\r\n        cursor: pointer;\r\n        list-style: none;\r\n        font-family: Helvetica;\r\n        font-style: normal;\r\n        font-weight: normal;\r\n        color: #999;\r\n        font-size: 13px;\r\n        & > span {\r\n          display: flex;\r\n          justify-content: flex-start;\r\n          align-items: center;\r\n          width: 100%;\r\n          padding: 5px 10px;\r\n          transition: 0.5s;\r\n          span {\r\n            margin-right: 8px;\r\n          }\r\n        }\r\n        &:hover > span {\r\n          border-radius: 22px;\r\n          background: #f0f0f0;\r\n        }\r\n        &:first-child {\r\n          border-bottom: 1px solid #d7d7d7;\r\n        }\r\n      }\r\n    }\r\n  }\r\n</style>\r\n", "button.btn-add-number {\n  border-radius: 25px;\n  display: block;\n  padding: 8px 12px;\n  margin: 0 auto;\n  margin-bottom: 101px;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 16px;\n  line-height: 19px;\n  text-align: center;\n  height: 39px;\n  background: #0074ff;\n  color: #fff !important;\n  position: relative;\n  z-index: 1;\n  transition: 0.5s;\n}\nbutton.btn-add-number strong {\n  margin-right: 5px;\n}\nbutton.btn-add-number:hover {\n  background: #005dcc;\n}\n\ndiv.number-container {\n  position: relative;\n}\ndiv.number-container div.btn-add-number-options {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 0;\n  padding-top: calc(39px + 3px);\n  padding-bottom: 6px;\n  border: 1px solid #d7d7d7;\n  box-sizing: border-box;\n  border-radius: 22px;\n}\ndiv.number-container div.btn-add-number-options li {\n  width: calc(100% - 20px);\n  margin-left: 10px;\n  padding: 4px 0px;\n  cursor: pointer;\n  list-style: none;\n  font-family: Helvetica;\n  font-style: normal;\n  font-weight: normal;\n  color: #999;\n  font-size: 13px;\n}\ndiv.number-container div.btn-add-number-options li > span {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  width: 100%;\n  padding: 5px 10px;\n  transition: 0.5s;\n}\ndiv.number-container div.btn-add-number-options li > span span {\n  margin-right: 8px;\n}\ndiv.number-container div.btn-add-number-options li:hover > span {\n  border-radius: 22px;\n  background: #f0f0f0;\n}\ndiv.number-container div.btn-add-number-options li:first-child {\n  border-bottom: 1px solid #d7d7d7;\n}\n\n/*# sourceMappingURL=AddNumberButton.vue.map */"]
    },
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$n = "data-v-13dc699f";
/* module identifier */

var __vue_module_identifier__$n = undefined;
/* functional template */

var __vue_is_functional_template__$n = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$n = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$l,
  staticRenderFns: __vue_staticRenderFns__$l
}, __vue_inject_styles__$n, __vue_script__$j, __vue_scope_id__$n, __vue_is_functional_template__$n, __vue_module_identifier__$n, false, createInjector, undefined, undefined);

var script$k = {
  components: {
    AddNumberButton: __vue_component__$n,
    QrCodeModal: __vue_component__$f,
    WhatsappApiModal: __vue_component__$l
  },
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    button: {
      type: String,
      required: true
    },
    hasWhatsappIntegration: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      showModal: false,
      modalType: 'QrCodeModal'
    };
  },
  computed: {
    modalTypes: function modalTypes() {
      return {
        whatsappApi: 'WhatsappApiModal',
        qrcode: 'QrCodeModal'
      };
    }
  },
  methods: _objectSpread2(_objectSpread2({}, mapActions(['closeQRCodeWS', 'trackEvent', 'getWhatsappNumbers'])), {}, {
    handleAddNumber: function handleAddNumber(type) {
      if (type && this.modalTypes[type]) {
        this.modalType = this.modalTypes[type];
      }

      this.showModal = true;
      this.editingContact = undefined;
      this.trackEvent({
        name: 'connect number started',
        properties: [{
          name: 'type',
          value: type || 'qrcode'
        }]
      });
    },
    handleCloseModal: function handleCloseModal() {
      var _this = this;

      this.showModal = false;
      this.closeQRCodeWS();
      this.getWhatsappNumbers({
        fetchIntegrators: true
      }).then(function () {
        _this.whatsAppReady = true;
      }).catch(function (err) {
        console.error('error getWhatsappNumbers', err);
      });
    }
  })
};

var __vue_script__$k = script$k;
/* template */

var __vue_render__$m = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    staticClass: "text-center empty-state"
  }, [_c("h3", {
    domProps: {
      innerHTML: _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c("h4", {
    domProps: {
      innerHTML: _vm._s(_vm.description)
    }
  }), _vm._v(" "), _vm.hasWhatsappIntegration ? _c("AddNumberButton", {
    on: {
      click: _vm.handleAddNumber
    }
  }) : _vm._e(), _vm._v(" "), _vm.showModal ? _c(_vm.modalType, {
    tag: "component",
    on: {
      close: _vm.handleCloseModal
    }
  }) : _vm._e()], 1);
};

var __vue_staticRenderFns__$m = [];
__vue_render__$m._withStripped = true;
/* style */

var __vue_inject_styles__$o = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-f4cb6842_0", {
    source: "div.empty-state[data-v-f4cb6842] {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\ndiv.empty-state h3[data-v-f4cb6842] {\n  font-family: \"Niveau Grotesk\";\n  color: #575757;\n  font-weight: bold;\n  font-size: 20px;\n  line-height: 30px;\n  margin-bottom: 8px;\n  margin-top: 0px;\n}\ndiv.empty-state h4[data-v-f4cb6842] {\n  color: #707070;\n  font-size: 16px;\n  font-weight: normal;\n  line-height: 130%;\n  margin-bottom: 48px;\n  max-width: 440px;\n  margin-top: 0px;\n}\ndiv.empty-state button[data-v-f4cb6842] {\n  border-radius: 50px;\n  height: 49px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  font-size: 16px;\n  line-height: 18px;\n  width: 194px;\n}\n\n/*# sourceMappingURL=Empty.vue.map */",
    map: {
      "version": 3,
      "sources": ["E:\\Octadesk\\octa-whatsapp-client\\src\\app\\list-numbers\\components\\Empty.vue", "Empty.vue"],
      "names": [],
      "mappings": "AA6FA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AC5FA;AD6FA;EACA,6BAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AC3FA;AD6FA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AC3FA;AD6FA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;AC3FA;;AAEA,oCAAoC",
      "file": "Empty.vue",
      "sourcesContent": ["<template>\r\n  <div class=\"text-center empty-state\">\r\n    <h3 v-html=\"title\" />\r\n\r\n    <h4 v-html=\"description\" />\r\n\r\n    <AddNumberButton v-if=\"hasWhatsappIntegration\" @click=\"handleAddNumber\" />\r\n\r\n    <component :is=\"modalType\" v-if=\"showModal\" @close=\"handleCloseModal\" />\r\n  </div>\r\n</template>\r\n\r\n<script>\r\n  import AddNumberButton from './AddNumberButton'\r\n\r\n  import QrCodeModal from '@/app/modal/components/Modal.vue'\r\n\r\n  import WhatsappApiModal from '@/app/whatsapp-api/components/modal/WhatsappApiModal'\r\n\r\n  import { mapActions } from 'vuex'\r\n\r\n  export default {\r\n    components: {\r\n      AddNumberButton,\r\n      QrCodeModal,\r\n      WhatsappApiModal\r\n    },\r\n    props: {\r\n      title: {\r\n        type: String,\r\n        required: true\r\n      },\r\n      description: {\r\n        type: String,\r\n        required: true\r\n      },\r\n      button: {\r\n        type: String,\r\n        required: true\r\n      },\r\n      hasWhatsappIntegration: {\r\n        type: Boolean,\r\n        required: true\r\n      }\r\n    },\r\n    data() {\r\n      return {\r\n        showModal: false,\r\n        modalType: 'QrCodeModal'\r\n      }\r\n    },\r\n    computed: {\r\n      modalTypes() {\r\n        return {\r\n          whatsappApi: 'WhatsappApiModal',\r\n          qrcode: 'QrCodeModal'\r\n        }\r\n      }\r\n    },\r\n    methods: {\r\n      ...mapActions(['closeQRCodeWS', 'trackEvent', 'getWhatsappNumbers']),\r\n      handleAddNumber(type) {\r\n        if (type && this.modalTypes[type]) {\r\n          this.modalType = this.modalTypes[type]\r\n        }\r\n\r\n        this.showModal = true\r\n\r\n        this.editingContact = undefined\r\n\r\n        this.trackEvent({\r\n          name: 'connect number started',\r\n          properties: [{ name: 'type', value: type || 'qrcode' }]\r\n        })\r\n      },\r\n      handleCloseModal() {\r\n        this.showModal = false\r\n\r\n        this.closeQRCodeWS()\r\n\r\n        this.getWhatsappNumbers({ fetchIntegrators: true })\r\n          .then(() => {\r\n            this.whatsAppReady = true\r\n          })\r\n          .catch(err => {\r\n            console.error('error getWhatsappNumbers', err)\r\n          })\r\n      }\r\n    }\r\n  }\r\n</script>\r\n\r\n<style lang=\"scss\" scoped>\r\n  div.empty-state {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex-direction: column;\r\n    h3 {\r\n      font-family: 'Niveau Grotesk';\r\n      color: #575757;\r\n      font-weight: bold;\r\n      font-size: 20px;\r\n      line-height: 30px;\r\n      margin-bottom: 8px;\r\n      margin-top: 0px;\r\n    }\r\n    h4 {\r\n      color: #707070;\r\n      font-size: 16px;\r\n      font-weight: normal;\r\n      line-height: 130%;\r\n      margin-bottom: 48px;\r\n      max-width: 440px;\r\n      margin-top: 0px;\r\n    }\r\n    button {\r\n      border-radius: 50px;\r\n      height: 49px;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      font-weight: bold;\r\n      font-size: 16px;\r\n      line-height: 18px;\r\n      width: 194px;\r\n    }\r\n  }\r\n</style>\r\n", "div.empty-state {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\ndiv.empty-state h3 {\n  font-family: \"Niveau Grotesk\";\n  color: #575757;\n  font-weight: bold;\n  font-size: 20px;\n  line-height: 30px;\n  margin-bottom: 8px;\n  margin-top: 0px;\n}\ndiv.empty-state h4 {\n  color: #707070;\n  font-size: 16px;\n  font-weight: normal;\n  line-height: 130%;\n  margin-bottom: 48px;\n  max-width: 440px;\n  margin-top: 0px;\n}\ndiv.empty-state button {\n  border-radius: 50px;\n  height: 49px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  font-size: 16px;\n  line-height: 18px;\n  width: 194px;\n}\n\n/*# sourceMappingURL=Empty.vue.map */"]
    },
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$o = "data-v-f4cb6842";
/* module identifier */

var __vue_module_identifier__$o = undefined;
/* functional template */

var __vue_is_functional_template__$o = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$o = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$m,
  staticRenderFns: __vue_staticRenderFns__$m
}, __vue_inject_styles__$o, __vue_script__$k, __vue_scope_id__$o, __vue_is_functional_template__$o, __vue_module_identifier__$o, false, createInjector, undefined, undefined);

var localizedFormat = createCommonjsModule(function (module, exports) {
!function(e,t){module.exports=t();}(commonjsGlobal,function(){return function(e,t,o){var n=t.prototype,r=n.format,M={LTS:"h:mm:ss A",LT:"h:mm A",L:"MM/DD/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"};o.en.formats=M;n.format=function(e){void 0===e&&(e="YYYY-MM-DDTHH:mm:ssZ");var t=this.$locale().formats,o=void 0===t?{}:t,n=e.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g,function(e,t,n){var r=n&&n.toUpperCase();return t||o[n]||M[n]||o[r].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g,function(e,t,o){return t||o.slice(1)})});return r.call(this,n)};}});
});

dayjs_min.extend(localizedFormat);
var script$l = {
  components: {
    HeaderMenu: __vue_component__$2,
    QrCodeModal: __vue_component__$f,
    NumberItem: __vue_component__$m,
    GenericLoader: __vue_component__$1,
    Empty: __vue_component__$o,
    AddNumberButton: __vue_component__$n,
    WhatsappApiModal: __vue_component__$l
  },
  mixins: [__vue_component__$b],
  props: {
    n2Team: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  directives: {
    tooltip: tooltip
  },
  data: function data() {
    return {
      whatsAppReady: false,
      showModal: false,
      editingContact: undefined,
      waiting: false,
      refreshListInterval: undefined,
      wppUserLogged: {},
      whatsappNumbers: undefined,
      settings: {},
      disconnectedNumbers: undefined,
      hasSettings: false,
      fetchError: false,
      modalType: 'QrCodeModal'
    };
  },
  computed: {
    modalTypes: function modalTypes() {
      return {
        whatsappApi: 'WhatsappApiModal',
        qrcode: 'QrCodeModal'
      };
    },
    isReady: function isReady() {
      return this.whatsAppReady && this.whatsappNumbers && this.whatsappNumbers.length && this.hasWhatsappIntegration;
    },
    lastUpdatedDate: function lastUpdatedDate() {
      var updatedNumbers = this.whatsappNumbers.filter(function (number) {
        return number.consumer;
      });
      if (!updatedNumbers.length) return null;
      updatedNumbers.sort(function (a, b) {
        return a.consumer.lastUpdate > b.consumer.lastUpdate ? -1 : 1;
      });
      return dayjs_min(updatedNumbers[0].consumer.lastUpdate).format('LLL');
    },
    sortedWhatsappNumbers: function sortedWhatsappNumbers() {
      var _this = this;

      var aux = _toConsumableArray(this.whatsappNumbers);

      return aux.sort(function (a, b) {
        var remappedStatusA = _this.remapStatus(a.status);

        var remappedStatusB = _this.remapStatus(b.status);

        if (remappedStatusA > remappedStatusB) return 1;
        if (remappedStatusA < remappedStatusB) return -1;
        if (a.translate > b.translate) return 1;
        if (a.translate < b.translate) return -1;
      });
    },
    hasWhatsappIntegration: function hasWhatsappIntegration() {
      return this.settings && this.settings.integrations && this.settings.integrations.whatsapp;
    },
    hasDisconectedsNumbers: function hasDisconectedsNumbers() {
      return this.disconnectedNumbers.length;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.unsubscribe = this.$store.subscribe(function (mutation, state) {
      _this2.wppUserLogged = state.wppUserLogged;
      _this2.whatsappNumbers = state.listNumbers.whatsappNumbers;
      _this2.settings = state.settings;
      _this2.disconnectedNumbers = state.bar.disconnectedNumbers;
    });
    var interval = setInterval(function () {
      if (_this2.wppUserLogged) {
        clearInterval(interval);

        _this2.fetchSettings().then(function () {
          return _this2.hasSettings = true;
        }).catch(function () {
          _this2.hasSettings = false;
          _this2.fetchError = true;
        });
      }
    });
  },
  created: function created() {
    this.setCompany();
    this.getNumbers();
    this.startMonitoring({
      fetchIntegrators: true
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.refreshListInterval) {
      clearInterval(this.refreshListInterval);
    }
  },
  methods: _objectSpread2(_objectSpread2({}, mapActions(['getWhatsappNumbers', 'closeQRCodeWS', 'fetchSettings', 'trackEvent', 'startMonitoring', 'setCompany', 'setCurrentWhatsappApiNumber', 'setCurrentWhatsappApiState'])), {}, {
    handleCloseModal: function handleCloseModal() {
      this.showModal = false;
      this.closeQRCodeWS();
      this.getNumbers();
    },
    handleEditContact: function handleEditContact(contact) {
      if (contact && contact.integrator === '360dialog') {
        this.handleEditIntegratorNumber(contact);
      }

      this.showModal = true;
      this.editingContact = _objectSpread2({}, contact);
    },
    handleEditIntegratorNumber: function handleEditIntegratorNumber(phone) {
      if (phone && phone.integrator === '360dialog') {
        this.setCurrentWhatsappApiNumber({
          id: phone.id,
          customFields: phone.customFields,
          number: phone.number,
          name: phone.name
        });
        this.setCurrentWhatsappApiState(WhatsappApiStates.profileInfo);
        this.modalType = this.modalTypes['whatsappApi'];
      }
    },
    handleReconnect: function handleReconnect(phone) {
      this.modalType = this.modalTypes['qrcode'];
      this.showModal = true;
      this.editingContact = _objectSpread2(_objectSpread2({}, phone), {}, {
        reconnect: true
      });
    },
    handleAddNumber: function handleAddNumber(type) {
      if (type && this.modalTypes[type]) {
        this.modalType = this.modalTypes[type];
      }

      this.showModal = true;
      this.editingContact = undefined;
      this.trackEvent({
        name: 'connect number started',
        properties: [{
          name: 'type',
          value: type || 'qrcode'
        }]
      });
    },
    getNumbers: function getNumbers() {
      var _this3 = this;

      this.getWhatsappNumbers({
        fetchIntegrators: true
      }).then(function () {
        _this3.whatsAppReady = true;
      }).catch(function (err) {
        console.error('error getWhatsappNumbers', err);
      });
    },
    remapStatus: function remapStatus(status) {
      if (status === whatsappConnectionStatus.connecting) {
        return 1;
      } else if (status === whatsappConnectionStatus.disconnected) {
        return 0;
      } else {
        return 2;
      }
    }
  })
};

/* script */
var __vue_script__$l = script$l;
/* template */

var __vue_render__$n = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.hasSettings ? _c("section", {
    staticClass: "page h-100",
    staticStyle: {
      overflow: "hidden"
    }
  }, [_vm.isReady ? [_c("HeaderMenu"), _vm._v(" "), _c("div", {
    staticClass: "box-content text-center wpp-container"
  }, [_c("h2", {
    staticClass: "text-center wpp-title"
  }, [_vm._v(_vm._s(_vm.$t("listNumbers.title")))]), _vm._v(" "), _c("AddNumberButton", {
    on: {
      click: _vm.handleAddNumber
    }
  }), _vm._v(" "), _vm.lastUpdatedDate ? _c("div", {
    staticClass: "updated"
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("listNumbers.updated")) + " " + _vm._s(_vm.lastUpdatedDate))])]) : _vm._e(), _vm._v(" "), _c("div", {
    staticClass: "wpp-numbers-container"
  }, [_c("div", {
    staticClass: "row wpp-numbers-header"
  }, [_c("div", {
    staticClass: "col-sm-1"
  }, [_vm._v(_vm._s(_vm.$t("listNumbers.status")))]), _vm._v(" "), _c("div", {
    staticClass: "col-sm-1"
  }), _vm._v(" "), _c("div", {
    staticClass: "col-sm-1"
  }, [_vm._v("\n            " + _vm._s(_vm.$t("listNumbers.type")) + "\n          ")]), _vm._v(" "), _c("div", {
    staticClass: "col-sm-2 text-left"
  }, [_vm._v("\n            " + _vm._s(_vm.$t("listNumbers.nameNickname")) + "\n          ")]), _vm._v(" "), _c("div", {
    staticClass: "col-sm-1"
  }, [_vm._v(_vm._s(_vm.$t("listNumbers.country")))]), _vm._v(" "), _c("div", {
    staticClass: "col-sm-3"
  }, [_vm._v(_vm._s(_vm.$t("listNumbers.number")))]), _vm._v(" "), _c("div", {
    staticClass: "col-sm-2"
  }, [_vm._v("\n            " + _vm._s(_vm.$t("listNumbers.battery.title")) + "\n\n            "), _c("i", {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: _vm.$t("listNumbers.battery.updated"),
      expression: "$t('listNumbers.battery.updated')"
    }],
    staticClass: "icon-wp-help"
  })]), _vm._v(" "), _c("div", {
    staticClass: "col-sm-1"
  })]), _vm._v(" "), _c("ul", {
    staticClass: "wpp-numbers-list"
  }, _vm._l(_vm.sortedWhatsappNumbers, function (phone) {
    return _c("NumberItem", {
      key: phone.id,
      attrs: {
        phone: phone,
        n2Team: _vm.n2Team
      },
      on: {
        edit: _vm.handleEditContact,
        recconect: _vm.handleReconnect
      }
    });
  }), 1)])], 1)] : !_vm.whatsAppReady ? _c("div", {
    staticClass: "wpp-list-loader"
  }, [_c("GenericLoader")], 1) : !_vm.hasWhatsappIntegration ? _c("Empty", {
    attrs: {
      title: _vm.$t("listNumbers.integrationWhatsAppNotEnabled"),
      description: _vm.$t("listNumbers.integrationNotEnabled"),
      hasWhatsappIntegration: _vm.hasWhatsappIntegration
    }
  }) : _c("Empty", {
    attrs: {
      title: _vm.$t("listNumbers.addWhatsApp"),
      description: _vm.$t("listNumbers.description"),
      button: _vm.$t("listNumbers.startNow"),
      hasWhatsappIntegration: _vm.hasWhatsappIntegration
    },
    on: {
      buttonClick: _vm.handleAddNumber
    }
  }), _vm._v(" "), _vm.showModal ? _c(_vm.modalType, {
    tag: "component",
    attrs: {
      editingContact: _vm.editingContact
    },
    on: {
      close: _vm.handleCloseModal
    }
  }) : _vm._e()], 2) : _vm.fetchError ? _c("div", {
    staticClass: "no-data-content"
  }, [_vm._m(0), _vm._v(" "), _c("p", {
    domProps: {
      innerHTML: _vm._s(_vm.$t("errorRecoverData"))
    }
  })]) : _vm._e();
};

var __vue_staticRenderFns__$n = [function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", [_c("i", {
    staticClass: "icon icon-wp-octa-settings text-primary"
  })]);
}];
__vue_render__$n._withStripped = true;
/* style */

var __vue_inject_styles__$p = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-73ce6004_0", {
    source: "\n@import url('https://p.typekit.net/p.css?s=1&k=zlc3fpz&ht=tk&f=27042&a=24999598&app=typekit&e=css');\n@font-face {\n  font-family: 'marydale';\n  src: url('https://use.typekit.net/af/2f1a2e/00000000000000003b9b14fb/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3')\n      format('woff2'),\n    url('https://use.typekit.net/af/2f1a2e/00000000000000003b9b14fb/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3')\n      format('woff'),\n    url('https://use.typekit.net/af/2f1a2e/00000000000000003b9b14fb/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3')\n      format('opentype');\n  font-display: auto;\n  font-style: normal;\n  font-weight: 700;\n}\ndiv.updated {\n  width: 80%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  margin-top: 40px;\n  border-bottom: 1px solid #5da9dd;\n}\ndiv.updated span {\n  color: #757575;\n  font-size: 14px;\n}\n.wpp-list-loader {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  display: block;\n  margin: 0 auto;\n}\n.wpp-btn-primary {\n  background: #328dcb;\n  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.14);\n  border-radius: 25px;\n  min-width: 135px;\n  height: 40px;\n  font-size: 14px;\n  line-height: 16px;\n  margin: 0 auto;\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n  color: #ffffff;\n  display: block;\n}\n.wpp-btn-primary:disabled {\n  background: #d2d2d2;\n  border: 1px solid #d2d2d2;\n  cursor: not-allowed !important;\n  color: rgba(0, 0, 0, 0.26);\n}\n.wpp-btn-primary-outline {\n  background: #328dcb;\n  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.14);\n  border-radius: 25px;\n  min-width: 135px;\n  height: 40px;\n  font-size: 14px;\n  line-height: 16px;\n  margin: 0 auto;\n  margin-top: 1rem;\n  margin-bottom: 2rem;\n  background: #ffffff;\n  color: #328dcb;\n  border: 1px solid #328dcb;\n  display: block;\n}\n.wpp-btn-primary-outline:disabled {\n  background: #d2d2d2;\n  border: 1px solid #d2d2d2;\n  cursor: not-allowed !important;\n  color: rgba(0, 0, 0, 0.26);\n}\n.wpp-primary-text {\n  text-decoration: none !important;\n  color: #328dcb;\n}\n.wpp-container {\n  height: calc(100% - 124px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n.wpp-title {\n  color: #484848;\n  font-size: 22px;\n  line-height: 27px;\n  margin-top: 27px;\n  margin-bottom: 42px;\n}\n.wpp-subtitle {\n  font-size: 16px;\n  line-height: 20px;\n  color: #484848;\n  font-weight: normal;\n  text-align: center;\n  margin-bottom: 1rem;\n  margin-top: 0.5rem;\n  display: block;\n}\n.wpp-empty-state-title {\n  color: #333333;\n  font-size: 30px;\n  line-height: 37px;\n  margin-top: 0;\n  display: block;\n  margin-bottom: 12px;\n}\n.wpp-empty-state-subtitle {\n  color: #757575;\n  font-size: 16px;\n  line-height: 24px;\n  font-style: normal;\n  font-weight: normal;\n  display: block;\n  margin-bottom: 0;\n}\n.wpp-empty-state-icon {\n  width: 100%;\n  display: inline-block;\n  margin-top: 0;\n  font-size: 100px;\n}\n.wpp-numbers-container {\n  width: 80%;\n  margin: 45px 10% 0;\n  text-align: center;\n  height: calc(100% - 216px);\n}\n.wpp-numbers-header {\n  color: #333333;\n  border-bottom: 1px solid rgba(195, 195, 195, 0.48);\n  padding-bottom: 25px;\n  font-size: 14px;\n}\n.wpp-numbers-header > div i {\n  color: #bfbfbf;\n}\n.wpp-numbers-list {\n  overflow-y: auto;\n  overflow-x: hidden;\n  height: calc(100% - 44px);\n  margin: 0;\n  padding: 0;\n}\n.empty-state-scroll {\n  height: calc(100% - 139px);\n  overflow-y: auto;\n}\n@media screen and (max-width: 1080px) {\n.wpp-numbers-container {\n    width: 90%;\n    margin: 45px 5% 0;\n}\n}\n@media screen and (max-width: 972px) {\n.empty-state-scroll {\n    height: calc(100% - 197px);\n}\n.wpp-empty-state-icon {\n    margin-top: 0;\n    font-size: 100px;\n}\n.wpp-empty-state-title {\n    margin-top: 0;\n}\n.wpp-empty-state-subtitle {\n    margin-bottom: 0;\n}\n}\n@media screen and (max-height: 600px) {\n.wpp-title {\n    margin-top: 27px;\n}\n.wpp-subtitle {\n    margin-bottom: 1rem;\n    margin-top: 0.5rem;\n}\n.wpp-empty-state-icon {\n    margin-top: 0;\n    font-size: 100px;\n}\n.wpp-empty-state-title {\n    margin-top: 0;\n}\n.wpp-empty-state-subtitle {\n    margin-bottom: 0;\n}\n}\n",
    map: {
      "version": 3,
      "sources": ["E:\\Octadesk\\octa-whatsapp-client\\src\\app\\list-numbers\\components\\List.vue"],
      "names": [],
      "mappings": ";AAiVA,mGAAA;AAEA;EACA,uBAAA;EACA;;;;;wBAKA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AACA;AACA;EACA,UAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gCAAA;AACA;AACA;EACA,cAAA;EACA,eAAA;AACA;AAEA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AACA;AACA;EACA,mBAAA;EACA,2CAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;AACA;AACA;EACA,mBAAA;EACA,yBAAA;EACA,8BAAA;EACA,0BAAA;AACA;AACA;EACA,mBAAA;EACA,2CAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,cAAA;AACA;AACA;EACA,mBAAA;EACA,yBAAA;EACA,8BAAA;EACA,0BAAA;AACA;AACA;EACA,gCAAA;EACA,cAAA;AACA;AACA;EACA,0BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AACA;AACA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AACA;AACA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AACA;AACA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;AACA;AACA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AACA;AACA;EACA,WAAA;EACA,qBAAA;EACA,aAAA;EACA,gBAAA;AACA;AACA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,0BAAA;AACA;AACA;EACA,cAAA;EACA,kDAAA;EACA,oBAAA;EACA,eAAA;AACA;AACA;EACA,cAAA;AACA;AACA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,SAAA;EACA,UAAA;AACA;AACA;EACA,0BAAA;EACA,gBAAA;AACA;AACA;AACA;IACA,UAAA;IACA,iBAAA;AACA;AACA;AACA;AACA;IACA,0BAAA;AACA;AACA;IACA,aAAA;IACA,gBAAA;AACA;AACA;IACA,aAAA;AACA;AACA;IACA,gBAAA;AACA;AACA;AACA;AACA;IACA,gBAAA;AACA;AACA;IACA,mBAAA;IACA,kBAAA;AACA;AACA;IACA,aAAA;IACA,gBAAA;AACA;AACA;IACA,aAAA;AACA;AACA;IACA,gBAAA;AACA;AACA",
      "file": "List.vue",
      "sourcesContent": ["<template>\r\n  <section class=\"page h-100\" style=\"overflow: hidden;\" v-if=\"hasSettings\">\r\n    <template v-if=\"isReady\">\r\n      <HeaderMenu />\r\n\r\n      <div class=\"box-content text-center wpp-container\">\r\n        <h2 class=\"text-center wpp-title\">{{ $t('listNumbers.title') }}</h2>\r\n\r\n        <AddNumberButton @click=\"handleAddNumber\" />\r\n\r\n        <div class=\"updated\" v-if=\"lastUpdatedDate\">\r\n          <span>{{ $t('listNumbers.updated') }} {{ lastUpdatedDate }}</span>\r\n        </div>\r\n\r\n        <div class=\"wpp-numbers-container\">\r\n          <div class=\"row wpp-numbers-header\">\r\n            <div class=\"col-sm-1\">{{ $t('listNumbers.status') }}</div>\r\n\r\n            <div class=\"col-sm-1\" />\r\n\r\n            <div class=\"col-sm-1\">\r\n              {{ $t('listNumbers.type') }}\r\n            </div>\r\n\r\n            <div class=\"col-sm-2 text-left\">\r\n              {{ $t('listNumbers.nameNickname') }}\r\n            </div>\r\n\r\n            <div class=\"col-sm-1\">{{ $t('listNumbers.country') }}</div>\r\n\r\n            <div class=\"col-sm-3\">{{ $t('listNumbers.number') }}</div>\r\n\r\n            <div class=\"col-sm-2\">\r\n              {{ $t('listNumbers.battery.title') }}\r\n\r\n              <i\r\n                class=\"icon-wp-help\"\r\n                v-tooltip=\"$t('listNumbers.battery.updated')\"\r\n              ></i>\r\n            </div>\r\n\r\n            <div class=\"col-sm-1\"></div>\r\n          </div>\r\n\r\n          <ul class=\"wpp-numbers-list\">\r\n            <NumberItem\r\n              v-for=\"phone in sortedWhatsappNumbers\"\r\n              :key=\"phone.id\"\r\n              :phone=\"phone\"\r\n              :n2Team=\"n2Team\"\r\n              @edit=\"handleEditContact\"\r\n              @recconect=\"handleReconnect\"\r\n            />\r\n          </ul>\r\n        </div>\r\n      </div>\r\n    </template>\r\n\r\n    <div v-else-if=\"!whatsAppReady\" class=\"wpp-list-loader\">\r\n      <GenericLoader />\r\n    </div>\r\n\r\n    <Empty\r\n      v-else-if=\"!hasWhatsappIntegration\"\r\n      :title=\"$t('listNumbers.integrationWhatsAppNotEnabled')\"\r\n      :description=\"$t('listNumbers.integrationNotEnabled')\"\r\n      :hasWhatsappIntegration=\"hasWhatsappIntegration\"\r\n    />\r\n\r\n    <Empty\r\n      v-else\r\n      :title=\"$t('listNumbers.addWhatsApp')\"\r\n      :description=\"$t('listNumbers.description')\"\r\n      :button=\"$t('listNumbers.startNow')\"\r\n      :hasWhatsappIntegration=\"hasWhatsappIntegration\"\r\n      @buttonClick=\"handleAddNumber\"\r\n    />\r\n\r\n    <component\r\n      :is=\"modalType\"\r\n      v-if=\"showModal\"\r\n      :editingContact=\"editingContact\"\r\n      @close=\"handleCloseModal\"\r\n    />\r\n  </section>\r\n\r\n  <div class=\"no-data-content\" v-else-if=\"fetchError\">\r\n    <div>\r\n      <i class=\"icon icon-wp-octa-settings text-primary\" />\r\n    </div>\r\n\r\n    <p v-html=\"$t('errorRecoverData')\" />\r\n  </div>\r\n</template>\r\n\r\n<script>\r\n  import { mapActions } from 'vuex'\r\n\r\n  import { GenericLoader, HeaderMenu } from '@/app/shared-components'\r\n\r\n  import QrCodeModal from '@/app/modal/components/Modal.vue'\r\n\r\n  import WhatsappApiModal from '@/app/whatsapp-api/components/modal/WhatsappApiModal'\r\n\r\n  import NumberItem from './NumberItem'\r\n\r\n  import Empty from './Empty'\r\n\r\n  import AddNumberButton from './AddNumberButton'\r\n\r\n  import { whatsappConnectionStatus } from '@/helpers'\r\n\r\n  import { WhatsappApiStates } from '@/helpers/enums'\r\n\r\n  import GlobalMixins from '@/app/mixins'\r\n\r\n  import { tooltip } from 'uiv'\r\n\r\n  import dayjs from 'dayjs'\r\n\r\n  import localizedFormat from 'dayjs/plugin/localizedFormat'\r\n\r\n  dayjs.extend(localizedFormat)\r\n\r\n  export default {\r\n    components: {\r\n      HeaderMenu,\r\n      QrCodeModal,\r\n      NumberItem,\r\n      GenericLoader,\r\n      Empty,\r\n      AddNumberButton,\r\n      WhatsappApiModal\r\n    },\r\n    mixins: [GlobalMixins],\r\n    props: {\r\n      n2Team: {\r\n        type: Boolean,\r\n        required: false,\r\n        default: false\r\n      }\r\n    },\r\n    directives: {\r\n      tooltip\r\n    },\r\n    data() {\r\n      return {\r\n        whatsAppReady: false,\r\n        showModal: false,\r\n        editingContact: undefined,\r\n        waiting: false,\r\n        refreshListInterval: undefined,\r\n        wppUserLogged: {},\r\n        whatsappNumbers: undefined,\r\n        settings: {},\r\n        disconnectedNumbers: undefined,\r\n        hasSettings: false,\r\n        fetchError: false,\r\n        modalType: 'QrCodeModal'\r\n      }\r\n    },\r\n    computed: {\r\n      modalTypes() {\r\n        return {\r\n          whatsappApi: 'WhatsappApiModal',\r\n          qrcode: 'QrCodeModal'\r\n        }\r\n      },\r\n      isReady() {\r\n        return (\r\n          this.whatsAppReady &&\r\n          this.whatsappNumbers &&\r\n          this.whatsappNumbers.length &&\r\n          this.hasWhatsappIntegration\r\n        )\r\n      },\r\n      lastUpdatedDate() {\r\n        const updatedNumbers = this.whatsappNumbers.filter(\r\n          number => number.consumer\r\n        )\r\n\r\n        if (!updatedNumbers.length) return null\r\n\r\n        updatedNumbers.sort((a, b) =>\r\n          a.consumer.lastUpdate > b.consumer.lastUpdate ? -1 : 1\r\n        )\r\n\r\n        return dayjs(updatedNumbers[0].consumer.lastUpdate).format('LLL')\r\n      },\r\n      sortedWhatsappNumbers() {\r\n        const aux = [...this.whatsappNumbers]\r\n\r\n        return aux.sort((a, b) => {\r\n          const remappedStatusA = this.remapStatus(a.status)\r\n\r\n          const remappedStatusB = this.remapStatus(b.status)\r\n\r\n          if (remappedStatusA > remappedStatusB) return 1\r\n          if (remappedStatusA < remappedStatusB) return -1\r\n\r\n          if (a.translate > b.translate) return 1\r\n          if (a.translate < b.translate) return -1\r\n        })\r\n      },\r\n      hasWhatsappIntegration() {\r\n        return (\r\n          this.settings &&\r\n          this.settings.integrations &&\r\n          this.settings.integrations.whatsapp\r\n        )\r\n      },\r\n      hasDisconectedsNumbers() {\r\n        return this.disconnectedNumbers.length\r\n      }\r\n    },\r\n    mounted() {\r\n      this.unsubscribe = this.$store.subscribe((mutation, state) => {\r\n        this.wppUserLogged = state.wppUserLogged\r\n\r\n        this.whatsappNumbers = state.listNumbers.whatsappNumbers\r\n\r\n        this.settings = state.settings\r\n\r\n        this.disconnectedNumbers = state.bar.disconnectedNumbers\r\n      })\r\n\r\n      const interval = setInterval(() => {\r\n        if (this.wppUserLogged) {\r\n          clearInterval(interval)\r\n\r\n          this.fetchSettings()\r\n            .then(() => (this.hasSettings = true))\r\n            .catch(() => {\r\n              this.hasSettings = false\r\n\r\n              this.fetchError = true\r\n            })\r\n        }\r\n      })\r\n    },\r\n    created() {\r\n      this.setCompany()\r\n\r\n      this.getNumbers()\r\n\r\n      this.startMonitoring({ fetchIntegrators: true })\r\n    },\r\n    beforeDestroy() {\r\n      if (this.refreshListInterval) {\r\n        clearInterval(this.refreshListInterval)\r\n      }\r\n    },\r\n    methods: {\r\n      ...mapActions([\r\n        'getWhatsappNumbers',\r\n        'closeQRCodeWS',\r\n        'fetchSettings',\r\n        'trackEvent',\r\n        'startMonitoring',\r\n        'setCompany',\r\n        'setCurrentWhatsappApiNumber',\r\n        'setCurrentWhatsappApiState'\r\n      ]),\r\n      handleCloseModal() {\r\n        this.showModal = false\r\n\r\n        this.closeQRCodeWS()\r\n\r\n        this.getNumbers()\r\n      },\r\n      handleEditContact(contact) {\r\n        if (contact && contact.integrator === '360dialog') {\r\n          this.handleEditIntegratorNumber(contact)\r\n        }\r\n\r\n        this.showModal = true\r\n\r\n        this.editingContact = { ...contact }\r\n      },\r\n      handleEditIntegratorNumber(phone) {\r\n        if (phone && phone.integrator === '360dialog') {\r\n          this.setCurrentWhatsappApiNumber({\r\n            id: phone.id,\r\n            customFields: phone.customFields,\r\n            number: phone.number,\r\n            name: phone.name\r\n          })\r\n\r\n          this.setCurrentWhatsappApiState(WhatsappApiStates.profileInfo)\r\n\r\n          this.modalType = this.modalTypes['whatsappApi']\r\n        }\r\n      },\r\n      handleReconnect(phone) {\r\n        this.modalType = this.modalTypes['qrcode']\r\n\r\n        this.showModal = true\r\n\r\n        this.editingContact = { ...phone, reconnect: true }\r\n      },\r\n      handleAddNumber(type) {\r\n        if (type && this.modalTypes[type]) {\r\n          this.modalType = this.modalTypes[type]\r\n        }\r\n\r\n        this.showModal = true\r\n\r\n        this.editingContact = undefined\r\n\r\n        this.trackEvent({\r\n          name: 'connect number started',\r\n          properties: [{ name: 'type', value: type || 'qrcode' }]\r\n        })\r\n      },\r\n      getNumbers() {\r\n        this.getWhatsappNumbers({ fetchIntegrators: true })\r\n          .then(() => {\r\n            this.whatsAppReady = true\r\n          })\r\n          .catch(err => {\r\n            console.error('error getWhatsappNumbers', err)\r\n          })\r\n      },\r\n      remapStatus(status) {\r\n        if (status === whatsappConnectionStatus.connecting) {\r\n          return 1\r\n        } else if (status === whatsappConnectionStatus.disconnected) {\r\n          return 0\r\n        } else {\r\n          return 2\r\n        }\r\n      }\r\n    }\r\n  }\r\n</script>\r\n\r\n<style>\r\n  @import url('https://p.typekit.net/p.css?s=1&k=zlc3fpz&ht=tk&f=27042&a=24999598&app=typekit&e=css');\r\n\r\n  @font-face {\r\n    font-family: 'marydale';\r\n    src: url('https://use.typekit.net/af/2f1a2e/00000000000000003b9b14fb/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3')\r\n        format('woff2'),\r\n      url('https://use.typekit.net/af/2f1a2e/00000000000000003b9b14fb/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3')\r\n        format('woff'),\r\n      url('https://use.typekit.net/af/2f1a2e/00000000000000003b9b14fb/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3')\r\n        format('opentype');\r\n    font-display: auto;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n  }\r\n  div.updated {\r\n    width: 80%;\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    align-items: center;\r\n    margin-top: 40px;\r\n    border-bottom: 1px solid #5da9dd;\r\n  }\r\n  div.updated span {\r\n    color: #757575;\r\n    font-size: 14px;\r\n  }\r\n\r\n  .wpp-list-loader {\r\n    position: relative;\r\n    width: 100%;\r\n    height: 100%;\r\n    display: block;\r\n    margin: 0 auto;\r\n  }\r\n  .wpp-btn-primary {\r\n    background: #328dcb;\r\n    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.14);\r\n    border-radius: 25px;\r\n    min-width: 135px;\r\n    height: 40px;\r\n    font-size: 14px;\r\n    line-height: 16px;\r\n    margin: 0 auto;\r\n    margin-top: 1rem;\r\n    margin-bottom: 1rem;\r\n    color: #ffffff;\r\n    display: block;\r\n  }\r\n  .wpp-btn-primary:disabled {\r\n    background: #d2d2d2;\r\n    border: 1px solid #d2d2d2;\r\n    cursor: not-allowed !important;\r\n    color: rgba(0, 0, 0, 0.26);\r\n  }\r\n  .wpp-btn-primary-outline {\r\n    background: #328dcb;\r\n    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.14);\r\n    border-radius: 25px;\r\n    min-width: 135px;\r\n    height: 40px;\r\n    font-size: 14px;\r\n    line-height: 16px;\r\n    margin: 0 auto;\r\n    margin-top: 1rem;\r\n    margin-bottom: 2rem;\r\n    background: #ffffff;\r\n    color: #328dcb;\r\n    border: 1px solid #328dcb;\r\n    display: block;\r\n  }\r\n  .wpp-btn-primary-outline:disabled {\r\n    background: #d2d2d2;\r\n    border: 1px solid #d2d2d2;\r\n    cursor: not-allowed !important;\r\n    color: rgba(0, 0, 0, 0.26);\r\n  }\r\n  .wpp-primary-text {\r\n    text-decoration: none !important;\r\n    color: #328dcb;\r\n  }\r\n  .wpp-container {\r\n    height: calc(100% - 124px);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex-direction: column;\r\n  }\r\n  .wpp-title {\r\n    color: #484848;\r\n    font-size: 22px;\r\n    line-height: 27px;\r\n    margin-top: 27px;\r\n    margin-bottom: 42px;\r\n  }\r\n  .wpp-subtitle {\r\n    font-size: 16px;\r\n    line-height: 20px;\r\n    color: #484848;\r\n    font-weight: normal;\r\n    text-align: center;\r\n    margin-bottom: 1rem;\r\n    margin-top: 0.5rem;\r\n    display: block;\r\n  }\r\n  .wpp-empty-state-title {\r\n    color: #333333;\r\n    font-size: 30px;\r\n    line-height: 37px;\r\n    margin-top: 0;\r\n    display: block;\r\n    margin-bottom: 12px;\r\n  }\r\n  .wpp-empty-state-subtitle {\r\n    color: #757575;\r\n    font-size: 16px;\r\n    line-height: 24px;\r\n    font-style: normal;\r\n    font-weight: normal;\r\n    display: block;\r\n    margin-bottom: 0;\r\n  }\r\n  .wpp-empty-state-icon {\r\n    width: 100%;\r\n    display: inline-block;\r\n    margin-top: 0;\r\n    font-size: 100px;\r\n  }\r\n  .wpp-numbers-container {\r\n    width: 80%;\r\n    margin: 45px 10% 0;\r\n    text-align: center;\r\n    height: calc(100% - 216px);\r\n  }\r\n  .wpp-numbers-header {\r\n    color: #333333;\r\n    border-bottom: 1px solid rgba(195, 195, 195, 0.48);\r\n    padding-bottom: 25px;\r\n    font-size: 14px;\r\n  }\r\n  .wpp-numbers-header > div i {\r\n    color: #bfbfbf;\r\n  }\r\n  .wpp-numbers-list {\r\n    overflow-y: auto;\r\n    overflow-x: hidden;\r\n    height: calc(100% - 44px);\r\n    margin: 0;\r\n    padding: 0;\r\n  }\r\n  .empty-state-scroll {\r\n    height: calc(100% - 139px);\r\n    overflow-y: auto;\r\n  }\r\n  @media screen and (max-width: 1080px) {\r\n    .wpp-numbers-container {\r\n      width: 90%;\r\n      margin: 45px 5% 0;\r\n    }\r\n  }\r\n  @media screen and (max-width: 972px) {\r\n    .empty-state-scroll {\r\n      height: calc(100% - 197px);\r\n    }\r\n    .wpp-empty-state-icon {\r\n      margin-top: 0;\r\n      font-size: 100px;\r\n    }\r\n    .wpp-empty-state-title {\r\n      margin-top: 0;\r\n    }\r\n    .wpp-empty-state-subtitle {\r\n      margin-bottom: 0;\r\n    }\r\n  }\r\n  @media screen and (max-height: 600px) {\r\n    .wpp-title {\r\n      margin-top: 27px;\r\n    }\r\n    .wpp-subtitle {\r\n      margin-bottom: 1rem;\r\n      margin-top: 0.5rem;\r\n    }\r\n    .wpp-empty-state-icon {\r\n      margin-top: 0;\r\n      font-size: 100px;\r\n    }\r\n    .wpp-empty-state-title {\r\n      margin-top: 0;\r\n    }\r\n    .wpp-empty-state-subtitle {\r\n      margin-bottom: 0;\r\n    }\r\n  }\r\n</style>\r\n"]
    },
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$p = undefined;
/* module identifier */

var __vue_module_identifier__$p = undefined;
/* functional template */

var __vue_is_functional_template__$p = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$p = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$n,
  staticRenderFns: __vue_staticRenderFns__$n
}, __vue_inject_styles__$p, __vue_script__$l, __vue_scope_id__$p, __vue_is_functional_template__$p, __vue_module_identifier__$p, false, createInjector, undefined, undefined);

var script$m = {
  components: {
    Modal: __vue_component__$f,
    'v-select': vSelect,
    Toasts: __vue_component__$3
  },
  mixins: [__vue_component__$b],
  data: function data() {
    return {
      connectingNumbers: [],
      disconnectedNumbers: [],
      recentConnectedNumbers: [],
      canShowBar: false,
      phoneId: '',
      modal: {
        show: false,
        contact: undefined
      }
    };
  },
  watch: {
    disconnectedNumbers: function disconnectedNumbers(disconnecteds) {
      if (disconnecteds.length === 1) {
        this.phoneId = disconnecteds[0].id;
        this.modal = _objectSpread2(_objectSpread2({}, this.modal), {}, {
          contact: disconnecteds[0]
        });
      } else {
        this.phoneId = '';
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.unsubscribe = this.$store.subscribe(function (mutation, state) {
      _this.connectingNumbers = state.bar.connectingNumbers.filter(function (number) {
        return !number.integrator;
      });
      _this.disconnectedNumbers = state.bar.disconnectedNumbers.filter(function (number) {
        return !number.integrator;
      });
      _this.recentConnectedNumbers = state.bar.recentConnectedNumbers.filter(function (number) {
        return !number.integrator;
      });
      _this.canShowBar = state.bar.canShowBar;
    });
  },
  created: function created() {
    this.startMonitoring();
  },
  methods: _objectSpread2(_objectSpread2({}, mapActions(['barShow', 'startMonitoring'])), {}, {
    handleOpenWhatsAppConfig: function handleOpenWhatsAppConfig() {
      return;
    },
    handleReadQrCode: function handleReadQrCode() {
      if (this.phoneId || !this.phoneId && this.disconnectedNumbers.length === 1) {
        if (this.disconnectedNumbers.length === 1) {
          this.phoneId = this.disconnectedNumbers[0].id;
        }

        this.modal = _objectSpread2(_objectSpread2({}, this.modal), {}, {
          show: true
        });
      } else if (this.disconnectedNumbers.length >= 2) {
        alert('Selecione um número');
      }
    },
    handleChangeSelectNumbers: function handleChangeSelectNumbers(number) {
      var phone = this.disconnectedNumbers.find(function (phone) {
        return phone.id === number.id;
      });

      if (phone) {
        this.phoneId = phone.id;
        this.modal = {
          show: false,
          contact: phone
        };
      }
    },
    handleCloseModal: function handleCloseModal() {
      this.modal = {
        show: false,
        contact: undefined
      };
      this.phoneId = '';
      this.$refs.disconnectedNumbers.clearSelection();
    }
  })
};

/* script */
var __vue_script__$m = script$m;
/* template */

var __vue_render__$o = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", [_vm.canShowBar && (_vm.disconnectedNumbers.length || _vm.connectingNumbers.length) ? _c("div", {
    staticClass: "whatsapp-connection-bar",
    class: {
      disconnected: _vm.disconnectedNumbers.length,
      connecting: _vm.connectingNumbers.length
    }
  }, [_c("div", [_vm.disconnectedNumbers.length === 1 ? [_c("p", {
    domProps: {
      innerHTML: _vm._s(_vm.$t("connectionBar.disconnectedNumbers.onlyNumber", {
        name: _vm.disconnectedNumbers[0].translate
      }))
    }
  }), _vm._v(" "), _c("div", [_c("button", {
    staticClass: "single-number",
    on: {
      click: _vm.handleReadQrCode
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t("connectionBar.disconnectedNumbers.button")) + "\n          ")])])] : _vm.disconnectedNumbers.length >= 2 ? [_c("p", {
    domProps: {
      innerHTML: _vm._s(_vm.$t("connectionBar.disconnectedNumbers.multipleNumbers"))
    }
  }), _vm._v(" "), _c("div", [_c("v-select", {
    ref: "disconnectedNumbers",
    staticClass: "bar",
    attrs: {
      options: _vm.disconnectedNumbers,
      label: "translate",
      filterable: false,
      searchable: false,
      placeholder: _vm.$t("connectionBar.selectPlaceholder")
    },
    on: {
      input: _vm.handleChangeSelectNumbers
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_vm._v("\n              " + _vm._s(option.translate) + "\n\n              "), _c("small", [_vm._v(_vm._s(_vm.handleParsePhoneNumber(option.number)))])];
      }
    }], null, false, 1975145515)
  }), _vm._v(" "), _c("button", {
    attrs: {
      disabled: _vm.phoneId === ""
    },
    on: {
      click: _vm.handleReadQrCode
    }
  }, [_c("span", {
    staticClass: "text-read"
  }, [_vm._v("\n              " + _vm._s(_vm.$t("connectionBar.disconnectedNumbers.button")) + "\n            ")]), _vm._v(" "), _c("span", {
    staticClass: "text-ok"
  }, [_vm._v("Ok")])])], 1)] : _vm.connectingNumbers.length === 1 ? [_c("p", {
    domProps: {
      innerHTML: _vm._s(_vm.$t("connectionBar.connectingNumbers.onlyNumber", {
        name: _vm.connectingNumbers[0].translate,
        number: _vm.handleParsePhoneNumber(_vm.connectingNumbers[0].number)
      }))
    }
  })] : _vm.connectingNumbers.length >= 2 ? [_c("p", {
    domProps: {
      innerHTML: _vm._s(_vm.$t("connectionBar.connectingNumbers.multipleNumbers"))
    }
  }), _vm._v(" "), _c("div", [_c("v-select", {
    ref: "selectConnectingNumbers",
    staticClass: "bar disabled-cursor",
    attrs: {
      options: _vm.connectingNumbers,
      label: "translate",
      filterable: false,
      searchable: false,
      placeholder: _vm.$t("connectionBar.selectPlaceholder")
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_vm._v("\n              " + _vm._s(option.translate) + "\n\n              "), _c("small", [_vm._v(_vm._s(_vm.handleParsePhoneNumber(option.number)))])];
      }
    }], null, false, 1975145515)
  })], 1)] : _vm._e()], 2), _vm._v(" "), _c("button", {
    staticClass: "close",
    attrs: {
      type: "button",
      "aria-label": "Fechar"
    },
    on: {
      click: function click($event) {
        return _vm.barShow({
          show: false,
          manualClose: true
        });
      }
    }
  })]) : _vm._e(), _vm._v(" "), _vm._l(_vm.recentConnectedNumbers, function (phone) {
    return _c("Toasts", {
      key: phone.number,
      staticStyle: {
        display: "none"
      },
      attrs: {
        type: "success",
        time: 6000
      }
    }, [_c("i", {
      staticClass: "icon-wp-check-circle"
    }), _vm._v("\n\n    " + _vm._s(phone.translate) + " " + _vm._s(_vm.$t("connectionBar.connected")) + "!\n  ")]);
  }), _vm._v(" "), _vm.modal.show ? _c("Modal", {
    attrs: {
      editingContact: _vm.modal.contact
    },
    on: {
      close: _vm.handleCloseModal
    }
  }) : _vm._e()], 2);
};

var __vue_staticRenderFns__$o = [];
__vue_render__$o._withStripped = true;
/* style */

var __vue_inject_styles__$q = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-04979c64_0", {
    source: ".v-select {\n  position: relative;\n  font-family: inherit;\n}\n.v-select,\n.v-select * {\n  box-sizing: border-box;\n}\n\n/* KeyFrames */\n@-webkit-keyframes vSelectSpinner {\n0% {\n    transform: rotate(0deg);\n}\n100% {\n    transform: rotate(360deg);\n}\n}\n@keyframes vSelectSpinner {\n0% {\n    transform: rotate(0deg);\n}\n100% {\n    transform: rotate(360deg);\n}\n}\n/* Dropdown Default Transition */\n.vs__fade-enter-active,\n.vs__fade-leave-active {\n  pointer-events: none;\n  transition: opacity 0.15s cubic-bezier(1, 0.5, 0.8, 1);\n}\n.vs__fade-enter,\n.vs__fade-leave-to {\n  opacity: 0;\n}\n\n/** Component States */\n/*\n * Disabled\n *\n * When the component is disabled, all interaction\n * should be prevented. Here we modify the bg color,\n * and change the cursor displayed on the interactive\n * components.\n */\n.vs--disabled .vs__dropdown-toggle,\n.vs--disabled .vs__clear,\n.vs--disabled .vs__search,\n.vs--disabled .vs__selected,\n.vs--disabled .vs__open-indicator {\n  cursor: not-allowed;\n  background-color: #f8f8f8;\n}\n\n/*\n *  RTL - Right to Left Support\n *\n *  Because we're using a flexbox layout, the `dir=\"rtl\"`\n *  HTML attribute does most of the work for us by\n *  rearranging the child elements visually.\n */\n.v-select[dir=rtl] .vs__actions {\n  padding: 0 3px 0 6px;\n}\n.v-select[dir=rtl] .vs__clear {\n  margin-left: 6px;\n  margin-right: 0;\n}\n.v-select[dir=rtl] .vs__deselect {\n  margin-left: 0;\n  margin-right: 2px;\n}\n.v-select[dir=rtl] .vs__dropdown-menu {\n  text-align: right;\n}\n\n/**\n    Dropdown Toggle\n\n    The dropdown toggle is the primary wrapper of the component. It\n    has two direct descendants: .vs__selected-options, and .vs__actions.\n\n    .vs__selected-options holds the .vs__selected's as well as the\n    main search input.\n\n    .vs__actions holds the clear button and dropdown toggle.\n */\n.vs__dropdown-toggle {\n  appearance: none;\n  display: flex;\n  padding: 0 0 4px 0;\n  background: none;\n  border: 1px solid rgba(60, 60, 60, 0.26);\n  border-radius: 4px;\n  white-space: normal;\n}\n.vs__selected-options {\n  display: flex;\n  flex-basis: 100%;\n  flex-grow: 1;\n  flex-wrap: wrap;\n  padding: 0 2px;\n  position: relative;\n}\n.vs__actions {\n  display: flex;\n  align-items: center;\n  padding: 4px 6px 0 3px;\n}\n\n/* Dropdown Toggle States */\n.vs--searchable .vs__dropdown-toggle {\n  cursor: text;\n}\n.vs--unsearchable .vs__dropdown-toggle {\n  cursor: pointer;\n}\n.vs--open .vs__dropdown-toggle {\n  border-bottom-color: transparent;\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.vs__open-indicator {\n  fill: rgba(60, 60, 60, 0.5);\n  transform: scale(1);\n  transition: transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);\n  transition-timing-function: cubic-bezier(1, -0.115, 0.975, 0.855);\n}\n.vs--open .vs__open-indicator {\n  transform: rotate(180deg) scale(1);\n}\n.vs--loading .vs__open-indicator {\n  opacity: 0;\n}\n\n/* Clear Button */\n.vs__clear {\n  fill: rgba(60, 60, 60, 0.5);\n  padding: 0;\n  border: 0;\n  background-color: transparent;\n  cursor: pointer;\n  margin-right: 8px;\n}\n\n/* Dropdown Menu */\n.vs__dropdown-menu {\n  display: block;\n  box-sizing: border-box;\n  position: absolute;\n  top: calc(100% - 1px);\n  left: 0;\n  z-index: 1000;\n  padding: 5px 0;\n  margin: 0;\n  width: 100%;\n  max-height: 350px;\n  min-width: 160px;\n  overflow-y: auto;\n  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.15);\n  border: 1px solid rgba(60, 60, 60, 0.26);\n  border-top-style: none;\n  border-radius: 0 0 4px 4px;\n  text-align: left;\n  list-style: none;\n  background: #fff;\n}\n.vs__no-options {\n  text-align: center;\n}\n\n/* List Items */\n.vs__dropdown-option {\n  line-height: 1.42857143;\n  /* Normalize line height */\n  display: block;\n  padding: 3px 20px;\n  clear: both;\n  color: #333;\n  /* Overrides most CSS frameworks */\n  white-space: nowrap;\n}\n.vs__dropdown-option:hover {\n  cursor: pointer;\n}\n.vs__dropdown-option--highlight {\n  background: #5897fb;\n  color: #fff;\n}\n.vs__dropdown-option--disabled {\n  background: inherit;\n  color: rgba(60, 60, 60, 0.5);\n}\n.vs__dropdown-option--disabled:hover {\n  cursor: inherit;\n}\n\n/* Selected Tags */\n.vs__selected {\n  display: flex;\n  align-items: center;\n  background-color: #f0f0f0;\n  border: 1px solid rgba(60, 60, 60, 0.26);\n  border-radius: 4px;\n  color: #333;\n  line-height: 1.4;\n  margin: 4px 2px 0px 2px;\n  padding: 0 0.25em;\n  z-index: 0;\n}\n.vs__deselect {\n  display: inline-flex;\n  appearance: none;\n  margin-left: 4px;\n  padding: 0;\n  border: 0;\n  cursor: pointer;\n  background: none;\n  fill: rgba(60, 60, 60, 0.5);\n  text-shadow: 0 1px 0 #fff;\n}\n\n/* States */\n.vs--single .vs__selected {\n  background-color: transparent;\n  border-color: transparent;\n}\n.vs--single.vs--open .vs__selected {\n  position: absolute;\n  opacity: 0.4;\n}\n.vs--single.vs--searching .vs__selected {\n  display: none;\n}\n\n/* Search Input */\n/**\n * Super weird bug... If this declaration is grouped\n * below, the cancel button will still appear in chrome.\n * If it's up here on it's own, it'll hide it.\n */\n.vs__search::-webkit-search-cancel-button {\n  display: none;\n}\n.vs__search::-webkit-search-decoration,\n.vs__search::-webkit-search-results-button,\n.vs__search::-webkit-search-results-decoration,\n.vs__search::-ms-clear {\n  display: none;\n}\n.vs__search,\n.vs__search:focus {\n  appearance: none;\n  line-height: 1.4;\n  font-size: 1em;\n  border: 1px solid transparent;\n  border-left: none;\n  outline: none;\n  margin: 4px 0 0 0;\n  padding: 0 7px;\n  background: none;\n  box-shadow: none;\n  width: 0;\n  max-width: 100%;\n  flex-grow: 1;\n  z-index: 1;\n}\n.vs__search::placeholder {\n  color: inherit;\n}\n\n/**\n    States\n */\n.vs--unsearchable .vs__search {\n  opacity: 1;\n}\n.vs--unsearchable:not(.vs--disabled) .vs__search:hover {\n  cursor: pointer;\n}\n.vs--single.vs--searching:not(.vs--open):not(.vs--loading) .vs__search {\n  opacity: 0.2;\n}\n\n/* Loading Spinner */\n.vs__spinner {\n  align-self: center;\n  opacity: 0;\n  font-size: 5px;\n  text-indent: -9999em;\n  overflow: hidden;\n  border-top: 0.9em solid rgba(100, 100, 100, 0.1);\n  border-right: 0.9em solid rgba(100, 100, 100, 0.1);\n  border-bottom: 0.9em solid rgba(100, 100, 100, 0.1);\n  border-left: 0.9em solid rgba(60, 60, 60, 0.45);\n  transform: translateZ(0);\n  animation: vSelectSpinner 1.1s infinite linear;\n  transition: opacity 0.1s;\n}\n.vs__spinner,\n.vs__spinner:after {\n  border-radius: 50%;\n  width: 5em;\n  height: 5em;\n}\n\n/* Loading Spinner States */\n.vs--loading .vs__spinner {\n  opacity: 1;\n}\ndiv.whatsapp-connection-bar {\n  width: fit-content;\n  min-height: 60px;\n  max-width: calc(100% - 2rem);\n  border-radius: 60px;\n  position: fixed;\n  z-index: 150;\n  top: 70px;\n  left: 50%;\n  transform: translate(-50%, 0px);\n  padding: 10px 60px 10px 30px;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\ndiv.whatsapp-connection-bar > div {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\ndiv.whatsapp-connection-bar > div p {\n  font-size: 15px;\n  line-height: 24px;\n  padding-right: 20px;\n  margin-bottom: 0px;\n}\ndiv.whatsapp-connection-bar > div p strong {\n  font-weight: bold;\n}\ndiv.whatsapp-connection-bar > div p a {\n  text-decoration: underline;\n}\n@media (max-width: 992px) {\ndiv.whatsapp-connection-bar > div p {\n    font-size: 16px;\n    line-height: 20px;\n    margin-bottom: 15px;\n    text-align: center;\n    padding: 0px;\n    white-space: normal;\n}\n}\ndiv.whatsapp-connection-bar > div > div {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\ndiv.whatsapp-connection-bar > div > div div.v-select,\ndiv.whatsapp-connection-bar > div > div button {\n  height: 40px;\n}\n@media (max-width: 992px) {\ndiv.whatsapp-connection-bar > div > div div.v-select,\ndiv.whatsapp-connection-bar > div > div button {\n    height: 35px;\n}\n}\ndiv.whatsapp-connection-bar > div > div div.v-select {\n  width: 230px;\n  margin-right: 15px;\n  transition: 0.5s;\n  cursor: pointer;\n}\ndiv.whatsapp-connection-bar > div > div div.v-select div.vs__dropdown-toggle {\n  width: 100%;\n  height: 100%;\n  border-radius: 50px;\n  padding: 0px;\n  border: 1px solid #d7d7d7;\n  background-color: #ffffff;\n}\ndiv.whatsapp-connection-bar > div > div div.v-select div.vs__dropdown-toggle div.vs__selected-options {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\ndiv.whatsapp-connection-bar > div > div div.v-select div.vs__dropdown-toggle div.vs__selected-options span,\ndiv.whatsapp-connection-bar > div > div div.v-select div.vs__dropdown-toggle div.vs__selected-options input {\n  width: calc(100% - 50px);\n  max-height: 42px;\n  padding: 0px 0px 0px 20px;\n  margin: 0px;\n  color: #999999;\n  font-size: 14px;\n  line-height: 19px;\n  overflow: hidden;\n  opacity: 1;\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n}\n@media (max-width: 992px) {\ndiv.whatsapp-connection-bar > div > div div.v-select div.vs__dropdown-toggle div.vs__selected-options span,\ndiv.whatsapp-connection-bar > div > div div.v-select div.vs__dropdown-toggle div.vs__selected-options input {\n    font-size: 14px;\n    max-height: 23px;\n}\n}\ndiv.whatsapp-connection-bar > div > div div.v-select div.vs__dropdown-toggle div.vs__selected-options input {\n  position: absolute;\n  pointer-events: none;\n}\ndiv.whatsapp-connection-bar > div > div div.v-select div.vs__dropdown-toggle div.vs__actions {\n  width: 27px;\n  height: 27px;\n  position: absolute;\n  padding: 0px;\n  top: 50%;\n  right: 10px;\n  transform: translate(0px, -50%);\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #f1f1f1;\n}\ndiv.whatsapp-connection-bar > div > div div.v-select div.vs__dropdown-toggle div.vs__actions button.vs__clear {\n  display: none;\n}\n@media (max-width: 992px) {\ndiv.whatsapp-connection-bar > div > div div.v-select div.vs__dropdown-toggle div.vs__actions {\n    width: 27px;\n    height: 27px;\n}\n}\ndiv.whatsapp-connection-bar > div > div div.v-select ul {\n  top: 20px;\n  padding: 25px 20px 10px 20px;\n  z-index: -1;\n  border-radius: 0px 0px 20px 20px;\n  outline: none;\n  border: 1px solid #d7d7d7;\n  box-shadow: none;\n}\ndiv.whatsapp-connection-bar > div > div div.v-select ul li {\n  padding: 10px 0px;\n  font-size: 16px;\n  color: #999999;\n  transition: 0.5s;\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  flex-direction: column;\n  position: relative;\n  background: none !important;\n}\ndiv.whatsapp-connection-bar > div > div div.v-select ul li small {\n  font-size: 11px;\n}\ndiv.whatsapp-connection-bar > div > div div.v-select ul li:not(:last-child) {\n  border-bottom: 1px solid #d7d7d7;\n}\ndiv.whatsapp-connection-bar > div > div div.v-select ul li.vs__dropdown-option--selected {\n  font-weight: bold;\n}\ndiv.whatsapp-connection-bar > div > div div.v-select.vs--disabled {\n  opacity: 0.9;\n  cursor: not-allowed;\n}\ndiv.whatsapp-connection-bar > div > div div.v-select.vs--disabled div.vs__dropdown-toggle {\n  cursor: not-allowed;\n}\ndiv.whatsapp-connection-bar > div > div div.v-select.vs--disabled div.vs__dropdown-toggle div.vs__selected-options input {\n  background: transparent;\n}\ndiv.whatsapp-connection-bar > div > div div.v-select.disabled-cursor ul li {\n  cursor: default;\n}\n@media (max-width: 576px) {\ndiv.whatsapp-connection-bar > div > div div.v-select {\n    width: calc(90% - 15px - 35px);\n}\n}\ndiv.whatsapp-connection-bar > div > div button {\n  transition: 0.5s;\n  border-radius: 50px;\n  border: none;\n  cursor: pointer;\n  color: #ffffff;\n  position: relative;\n  overflow: hidden;\n  font-size: 14px;\n  white-space: nowrap;\n  padding: 0px 20px;\n}\ndiv.whatsapp-connection-bar > div > div button span.text-ok {\n  display: none;\n}\ndiv.whatsapp-connection-bar > div > div button div.loader-container {\n  top: 0px;\n}\ndiv.whatsapp-connection-bar > div > div button div.loader-container div.loader {\n  max-height: 23px;\n}\ndiv.whatsapp-connection-bar > div > div button[disabled] {\n  opacity: 0.8;\n  cursor: not-allowed;\n}\ndiv.whatsapp-connection-bar > div > div button.loader {\n  width: 100px;\n  padding: 0px;\n}\n@media (max-width: 992px) {\ndiv.whatsapp-connection-bar > div > div button {\n    font-size: 16px;\n}\ndiv.whatsapp-connection-bar > div > div button div.loader-container {\n    top: 3px;\n}\n}\n@media (max-width: 576px) {\ndiv.whatsapp-connection-bar > div > div button:not(.single-number) {\n    width: 35px !important;\n    padding: 0px;\n    border-radius: 50%;\n}\ndiv.whatsapp-connection-bar > div > div button span.text-read {\n    display: none;\n}\ndiv.whatsapp-connection-bar > div > div button span.text-ok {\n    display: block;\n}\ndiv.whatsapp-connection-bar > div > div button div.loader-container {\n    top: 0px;\n}\ndiv.whatsapp-connection-bar > div > div button div.loader-container div.v-pulse {\n    width: 6px !important;\n    height: 6px !important;\n}\n}\n@media (max-width: 992px) {\ndiv.whatsapp-connection-bar > div > div {\n    width: 100%;\n}\n}\n@media (max-width: 992px) {\ndiv.whatsapp-connection-bar > div {\n    flex-direction: column;\n    padding: 15px 0px;\n}\n}\ndiv.whatsapp-connection-bar button.close {\n  position: absolute;\n  top: 50%;\n  right: 20px;\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  border: none;\n  text-indent: -9999px;\n  cursor: pointer;\n  transition: 0.5s;\n  transform: translate(0px, -50%);\n}\ndiv.whatsapp-connection-bar button.close:before, div.whatsapp-connection-bar button.close:after {\n  content: \"\";\n  position: absolute;\n  top: 14px;\n  left: 6px;\n  width: 60%;\n  height: 3px;\n  border-radius: 20px;\n}\ndiv.whatsapp-connection-bar button.close:before {\n  transform: rotate(45deg);\n}\ndiv.whatsapp-connection-bar button.close:after {\n  transform: rotate(-45deg);\n}\n@media (max-width: 992px) {\ndiv.whatsapp-connection-bar button.close {\n    top: 5px;\n    right: 5px;\n    transform: translate(0px, 0px);\n    width: 25px;\n    height: 25px;\n}\ndiv.whatsapp-connection-bar button.close:before, div.whatsapp-connection-bar button.close:after {\n    top: 11px;\n    left: 4px;\n}\n}\ndiv.whatsapp-connection-bar.connecting {\n  background: #ffcf3a;\n}\ndiv.whatsapp-connection-bar.connecting > div p,\ndiv.whatsapp-connection-bar.connecting > div p a {\n  color: #575757;\n}\ndiv.whatsapp-connection-bar.connecting > div > div div.v-select div.vs__dropdown-toggle div.vs__actions svg {\n  fill: #ffcf3a;\n}\ndiv.whatsapp-connection-bar.connecting > div button {\n  color: #575757;\n  background: #fce8aa;\n}\ndiv.whatsapp-connection-bar.connecting > div button div.v-pulse {\n  background: #ffcf3a !important;\n}\ndiv.whatsapp-connection-bar.connecting > div button:hover {\n  background-color: #fbd86f;\n}\ndiv.whatsapp-connection-bar.connecting button.close {\n  background: #fce8aa;\n}\ndiv.whatsapp-connection-bar.connecting button.close:after, div.whatsapp-connection-bar.connecting button.close:before {\n  background-color: #575757;\n}\ndiv.whatsapp-connection-bar.connecting button.close:hover {\n  background: #fbd86f;\n}\ndiv.whatsapp-connection-bar.disconnected {\n  background: #ef2066;\n}\ndiv.whatsapp-connection-bar.disconnected > div p,\ndiv.whatsapp-connection-bar.disconnected > div p a {\n  color: #ffffff;\n}\ndiv.whatsapp-connection-bar.disconnected > div > div div.v-select div.vs__dropdown-toggle div.vs__actions svg {\n  fill: #ef2066;\n}\ndiv.whatsapp-connection-bar.disconnected > div > div button {\n  color: #ffffff;\n  background: #ff9abc;\n}\ndiv.whatsapp-connection-bar.disconnected > div > div button:hover {\n  background-color: #f9528b;\n}\ndiv.whatsapp-connection-bar.disconnected button.close {\n  background: #f9528b;\n}\ndiv.whatsapp-connection-bar.disconnected button.close:after, div.whatsapp-connection-bar.disconnected button.close:before {\n  background-color: #ef2066;\n}\ndiv.whatsapp-connection-bar.disconnected button.close:hover {\n  background: #ff9abc;\n}\n@media (max-width: 992px) {\ndiv.whatsapp-connection-bar {\n    top: 0px;\n    left: 0px;\n    transform: translate(0px, 0px);\n    width: 100%;\n    max-width: 100%;\n    height: auto;\n    padding: 0px 35px;\n    border-radius: 0px;\n}\n}\n\n/*# sourceMappingURL=Bar.vue.map */",
    map: {
      "version": 3,
      "sources": ["Bar.vue", "E:\\Octadesk\\octa-whatsapp-client\\src\\app\\bar\\components\\Bar.vue"],
      "names": [],
      "mappings": "AAAA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AAEA;;EAEE,sBAAsB;AACxB;;AAEA,cAAc;AACd;AACE;IACE,uBAAuB;AACzB;AACA;IACE,yBAAyB;AAC3B;AACF;AACA;AACE;IACE,uBAAuB;AACzB;AACA;IACE,yBAAyB;AAC3B;AACF;AACA,gCAAgC;AAChC;;EAEE,oBAAoB;EACpB,sDAAsD;AACxD;AAEA;;EAEE,UAAU;AACZ;;AAEA,sBAAsB;AACtB;;;;;;;EAOE;AACF;;;;;EAKE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;;;;;EAME;AACF;EACE,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;;AAEA;;;;;;;;;;EAUE;AACF;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,kBAAkB;EAClB,mBAAmB;AACrB;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,2BAA2B;AAC3B;EACE,YAAY;AACd;AAEA;EACE,eAAe;AACjB;AAEA;EACE,gCAAgC;EAChC,4BAA4B;EAC5B,6BAA6B;AAC/B;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,iEAAiE;EACjE,iEAAiE;AACnE;AAEA;EACE,kCAAkC;AACpC;AAEA;EACE,UAAU;AACZ;;AAEA,iBAAiB;AACjB;EACE,2BAA2B;EAC3B,UAAU;EACV,SAAS;EACT,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,aAAa;EACb,cAAc;EACd,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,+CAA+C;EAC/C,wCAAwC;EACxC,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;AAEA;EACE,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,WAAW;EACX,kCAAkC;EAClC,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;AACA;EACE,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,wCAAwC;EACxC,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,UAAU;AACZ;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA,WAAW;AACX;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,aAAa;AACf;;AAEA,iBAAiB;AACjB;;;;EAIE;AACF;EACE,aAAa;AACf;AAEA;;;;EAIE,aAAa;AACf;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,iBAAiB;EACjB,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,UAAU;AACZ;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE;AACF;EACE,UAAU;AACZ;AACA;EACE,eAAe;AACjB;AAEA;EACE,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,gDAAgD;EAChD,kDAAkD;EAClD,mDAAmD;EACnD,+CAA+C;EAC/C,wBAAwB;EACxB,8CAA8C;EAC9C,wBAAwB;AAC1B;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA,2BAA2B;AAC3B;EACE,UAAU;AACZ;ACxFA;EACA,kBAAA;EACA,gBAAA;EACA,4BAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;EACA,SAAA;EACA,+BAAA;EACA,4BAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;AD2FA;AC1FA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AD4FA;AC3FA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AD6FA;AC5FA;EACA,iBAAA;AD8FA;AC5FA;EACA,0BAAA;AD8FA;AC5FA;AAXA;IAYA,eAAA;IACA,iBAAA;IACA,mBAAA;IACA,kBAAA;IACA,YAAA;IACA,mBAAA;AD+FE;AACF;AC7FA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AD+FA;AC9FA;;EAEA,YAAA;ADgGA;AC/FA;AAHA;;IAIA,YAAA;ADmGE;AACF;ACjGA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;ADmGA;AClGA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;ADoGA;ACnGA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;ADqGA;ACpGA;;EAEA,wBAAA;EACA,gBAAA;EACA,yBAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;EACA,aAAA;EACA,2BAAA;EACA,uBAAA;ADsGA;ACrGA;AAdA;;IAeA,eAAA;IACA,gBAAA;ADyGE;AACF;ACvGA;EACA,kBAAA;EACA,oBAAA;ADyGA;ACtGA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;EACA,WAAA;EACA,+BAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;ADwGA;ACvGA;EACA,aAAA;ADyGA;ACvGA;AAhBA;IAiBA,WAAA;IACA,YAAA;AD0GE;AACF;ACvGA;EACA,SAAA;EACA,4BAAA;EACA,WAAA;EACA,gCAAA;EACA,aAAA;EACA,yBAAA;EACA,gBAAA;ADyGA;ACxGA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,2BAAA;AD0GA;ACzGA;EACA,eAAA;AD2GA;ACzGA;EACA,gCAAA;AD2GA;ACzGA;EACA,iBAAA;AD2GA;ACvGA;EACA,YAAA;EACA,mBAAA;ADyGA;ACxGA;EACA,mBAAA;AD0GA;ACzGA;EACA,uBAAA;AD2GA;ACtGA;EACA,eAAA;ADwGA;ACrGA;AA3GA;IA4GA,8BAAA;ADwGE;AACF;ACtGA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;ADwGA;ACvGA;EACA,aAAA;ADyGA;ACvGA;EACA,QAAA;ADyGA;ACxGA;EACA,gBAAA;AD0GA;ACvGA;EACA,YAAA;EACA,mBAAA;ADyGA;ACvGA;EACA,YAAA;EACA,YAAA;ADyGA;ACvGA;AA5BA;IA6BA,eAAA;AD0GE;ACzGF;IACA,QAAA;AD2GE;AACF;ACzGA;AACA;IACA,sBAAA;IACA,YAAA;IACA,kBAAA;AD2GE;ACzGF;IACA,aAAA;AD2GE;ACzGF;IACA,cAAA;AD2GE;ACzGF;IACA,QAAA;AD2GE;AC1GF;IACA,qBAAA;IACA,sBAAA;AD4GE;AACF;ACxGA;AAjLA;IAkLA,WAAA;AD2GE;AACF;ACzGA;AA/MA;IAgNA,sBAAA;IACA,iBAAA;AD4GE;AACF;AC1GA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,+BAAA;AD4GA;AC3GA;EAEA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;AD4GA;AC1GA;EACA,wBAAA;AD4GA;AC1GA;EACA,yBAAA;AD4GA;AC1GA;AA5BA;IA6BA,QAAA;IACA,UAAA;IACA,8BAAA;IACA,WAAA;IACA,YAAA;AD6GE;AC5GF;IAEA,SAAA;IACA,SAAA;AD6GE;AACF;AC1GA;EACA,mBAAA;AD4GA;AC1GA;;EAEA,cAAA;AD4GA;ACzGA;EACA,aAAA;AD2GA;ACxGA;EACA,cAAA;EACA,mBAAA;AD0GA;ACzGA;EACA,8BAAA;AD2GA;ACzGA;EACA,yBAAA;AD2GA;ACvGA;EACA,mBAAA;ADyGA;ACxGA;EAEA,yBAAA;ADyGA;ACvGA;EACA,mBAAA;ADyGA;ACrGA;EACA,mBAAA;ADuGA;ACrGA;;EAEA,cAAA;ADuGA;ACpGA;EACA,aAAA;ADsGA;ACpGA;EACA,cAAA;EACA,mBAAA;ADsGA;ACrGA;EACA,yBAAA;ADuGA;AClGA;EACA,mBAAA;ADoGA;ACnGA;EAEA,yBAAA;ADoGA;AClGA;EACA,mBAAA;ADoGA;AChGA;AA5UA;IA6UA,QAAA;IACA,SAAA;IACA,8BAAA;IACA,WAAA;IACA,eAAA;IACA,YAAA;IACA,iBAAA;IACA,kBAAA;ADmGE;AACF;;AAEA,kCAAkC",
      "file": "Bar.vue",
      "sourcesContent": [".v-select {\n  position: relative;\n  font-family: inherit;\n}\n\n.v-select,\n.v-select * {\n  box-sizing: border-box;\n}\n\n/* KeyFrames */\n@-webkit-keyframes vSelectSpinner {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n@keyframes vSelectSpinner {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n/* Dropdown Default Transition */\n.vs__fade-enter-active,\n.vs__fade-leave-active {\n  pointer-events: none;\n  transition: opacity 0.15s cubic-bezier(1, 0.5, 0.8, 1);\n}\n\n.vs__fade-enter,\n.vs__fade-leave-to {\n  opacity: 0;\n}\n\n/** Component States */\n/*\n * Disabled\n *\n * When the component is disabled, all interaction\n * should be prevented. Here we modify the bg color,\n * and change the cursor displayed on the interactive\n * components.\n */\n.vs--disabled .vs__dropdown-toggle,\n.vs--disabled .vs__clear,\n.vs--disabled .vs__search,\n.vs--disabled .vs__selected,\n.vs--disabled .vs__open-indicator {\n  cursor: not-allowed;\n  background-color: #f8f8f8;\n}\n\n/*\n *  RTL - Right to Left Support\n *\n *  Because we're using a flexbox layout, the `dir=\"rtl\"`\n *  HTML attribute does most of the work for us by\n *  rearranging the child elements visually.\n */\n.v-select[dir=rtl] .vs__actions {\n  padding: 0 3px 0 6px;\n}\n.v-select[dir=rtl] .vs__clear {\n  margin-left: 6px;\n  margin-right: 0;\n}\n.v-select[dir=rtl] .vs__deselect {\n  margin-left: 0;\n  margin-right: 2px;\n}\n.v-select[dir=rtl] .vs__dropdown-menu {\n  text-align: right;\n}\n\n/**\n    Dropdown Toggle\n\n    The dropdown toggle is the primary wrapper of the component. It\n    has two direct descendants: .vs__selected-options, and .vs__actions.\n\n    .vs__selected-options holds the .vs__selected's as well as the\n    main search input.\n\n    .vs__actions holds the clear button and dropdown toggle.\n */\n.vs__dropdown-toggle {\n  appearance: none;\n  display: flex;\n  padding: 0 0 4px 0;\n  background: none;\n  border: 1px solid rgba(60, 60, 60, 0.26);\n  border-radius: 4px;\n  white-space: normal;\n}\n\n.vs__selected-options {\n  display: flex;\n  flex-basis: 100%;\n  flex-grow: 1;\n  flex-wrap: wrap;\n  padding: 0 2px;\n  position: relative;\n}\n\n.vs__actions {\n  display: flex;\n  align-items: center;\n  padding: 4px 6px 0 3px;\n}\n\n/* Dropdown Toggle States */\n.vs--searchable .vs__dropdown-toggle {\n  cursor: text;\n}\n\n.vs--unsearchable .vs__dropdown-toggle {\n  cursor: pointer;\n}\n\n.vs--open .vs__dropdown-toggle {\n  border-bottom-color: transparent;\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.vs__open-indicator {\n  fill: rgba(60, 60, 60, 0.5);\n  transform: scale(1);\n  transition: transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);\n  transition-timing-function: cubic-bezier(1, -0.115, 0.975, 0.855);\n}\n\n.vs--open .vs__open-indicator {\n  transform: rotate(180deg) scale(1);\n}\n\n.vs--loading .vs__open-indicator {\n  opacity: 0;\n}\n\n/* Clear Button */\n.vs__clear {\n  fill: rgba(60, 60, 60, 0.5);\n  padding: 0;\n  border: 0;\n  background-color: transparent;\n  cursor: pointer;\n  margin-right: 8px;\n}\n\n/* Dropdown Menu */\n.vs__dropdown-menu {\n  display: block;\n  box-sizing: border-box;\n  position: absolute;\n  top: calc(100% - 1px);\n  left: 0;\n  z-index: 1000;\n  padding: 5px 0;\n  margin: 0;\n  width: 100%;\n  max-height: 350px;\n  min-width: 160px;\n  overflow-y: auto;\n  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.15);\n  border: 1px solid rgba(60, 60, 60, 0.26);\n  border-top-style: none;\n  border-radius: 0 0 4px 4px;\n  text-align: left;\n  list-style: none;\n  background: #fff;\n}\n\n.vs__no-options {\n  text-align: center;\n}\n\n/* List Items */\n.vs__dropdown-option {\n  line-height: 1.42857143;\n  /* Normalize line height */\n  display: block;\n  padding: 3px 20px;\n  clear: both;\n  color: #333;\n  /* Overrides most CSS frameworks */\n  white-space: nowrap;\n}\n.vs__dropdown-option:hover {\n  cursor: pointer;\n}\n\n.vs__dropdown-option--highlight {\n  background: #5897fb;\n  color: #fff;\n}\n\n.vs__dropdown-option--disabled {\n  background: inherit;\n  color: rgba(60, 60, 60, 0.5);\n}\n.vs__dropdown-option--disabled:hover {\n  cursor: inherit;\n}\n\n/* Selected Tags */\n.vs__selected {\n  display: flex;\n  align-items: center;\n  background-color: #f0f0f0;\n  border: 1px solid rgba(60, 60, 60, 0.26);\n  border-radius: 4px;\n  color: #333;\n  line-height: 1.4;\n  margin: 4px 2px 0px 2px;\n  padding: 0 0.25em;\n  z-index: 0;\n}\n\n.vs__deselect {\n  display: inline-flex;\n  appearance: none;\n  margin-left: 4px;\n  padding: 0;\n  border: 0;\n  cursor: pointer;\n  background: none;\n  fill: rgba(60, 60, 60, 0.5);\n  text-shadow: 0 1px 0 #fff;\n}\n\n/* States */\n.vs--single .vs__selected {\n  background-color: transparent;\n  border-color: transparent;\n}\n.vs--single.vs--open .vs__selected {\n  position: absolute;\n  opacity: 0.4;\n}\n.vs--single.vs--searching .vs__selected {\n  display: none;\n}\n\n/* Search Input */\n/**\n * Super weird bug... If this declaration is grouped\n * below, the cancel button will still appear in chrome.\n * If it's up here on it's own, it'll hide it.\n */\n.vs__search::-webkit-search-cancel-button {\n  display: none;\n}\n\n.vs__search::-webkit-search-decoration,\n.vs__search::-webkit-search-results-button,\n.vs__search::-webkit-search-results-decoration,\n.vs__search::-ms-clear {\n  display: none;\n}\n\n.vs__search,\n.vs__search:focus {\n  appearance: none;\n  line-height: 1.4;\n  font-size: 1em;\n  border: 1px solid transparent;\n  border-left: none;\n  outline: none;\n  margin: 4px 0 0 0;\n  padding: 0 7px;\n  background: none;\n  box-shadow: none;\n  width: 0;\n  max-width: 100%;\n  flex-grow: 1;\n  z-index: 1;\n}\n\n.vs__search::placeholder {\n  color: inherit;\n}\n\n/**\n    States\n */\n.vs--unsearchable .vs__search {\n  opacity: 1;\n}\n.vs--unsearchable:not(.vs--disabled) .vs__search:hover {\n  cursor: pointer;\n}\n\n.vs--single.vs--searching:not(.vs--open):not(.vs--loading) .vs__search {\n  opacity: 0.2;\n}\n\n/* Loading Spinner */\n.vs__spinner {\n  align-self: center;\n  opacity: 0;\n  font-size: 5px;\n  text-indent: -9999em;\n  overflow: hidden;\n  border-top: 0.9em solid rgba(100, 100, 100, 0.1);\n  border-right: 0.9em solid rgba(100, 100, 100, 0.1);\n  border-bottom: 0.9em solid rgba(100, 100, 100, 0.1);\n  border-left: 0.9em solid rgba(60, 60, 60, 0.45);\n  transform: translateZ(0);\n  animation: vSelectSpinner 1.1s infinite linear;\n  transition: opacity 0.1s;\n}\n\n.vs__spinner,\n.vs__spinner:after {\n  border-radius: 50%;\n  width: 5em;\n  height: 5em;\n}\n\n/* Loading Spinner States */\n.vs--loading .vs__spinner {\n  opacity: 1;\n}\n\ndiv.whatsapp-connection-bar {\n  width: fit-content;\n  min-height: 60px;\n  max-width: calc(100% - 2rem);\n  border-radius: 60px;\n  position: fixed;\n  z-index: 150;\n  top: 70px;\n  left: 50%;\n  transform: translate(-50%, 0px);\n  padding: 10px 60px 10px 30px;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\ndiv.whatsapp-connection-bar > div {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\ndiv.whatsapp-connection-bar > div p {\n  font-size: 15px;\n  line-height: 24px;\n  padding-right: 20px;\n  margin-bottom: 0px;\n}\ndiv.whatsapp-connection-bar > div p strong {\n  font-weight: bold;\n}\ndiv.whatsapp-connection-bar > div p a {\n  text-decoration: underline;\n}\n@media (max-width: 992px) {\n  div.whatsapp-connection-bar > div p {\n    font-size: 16px;\n    line-height: 20px;\n    margin-bottom: 15px;\n    text-align: center;\n    padding: 0px;\n    white-space: normal;\n  }\n}\ndiv.whatsapp-connection-bar > div > div {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\ndiv.whatsapp-connection-bar > div > div div.v-select,\ndiv.whatsapp-connection-bar > div > div button {\n  height: 40px;\n}\n@media (max-width: 992px) {\n  div.whatsapp-connection-bar > div > div div.v-select,\ndiv.whatsapp-connection-bar > div > div button {\n    height: 35px;\n  }\n}\ndiv.whatsapp-connection-bar > div > div div.v-select {\n  width: 230px;\n  margin-right: 15px;\n  transition: 0.5s;\n  cursor: pointer;\n}\ndiv.whatsapp-connection-bar > div > div div.v-select div.vs__dropdown-toggle {\n  width: 100%;\n  height: 100%;\n  border-radius: 50px;\n  padding: 0px;\n  border: 1px solid #d7d7d7;\n  background-color: #ffffff;\n}\ndiv.whatsapp-connection-bar > div > div div.v-select div.vs__dropdown-toggle div.vs__selected-options {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\ndiv.whatsapp-connection-bar > div > div div.v-select div.vs__dropdown-toggle div.vs__selected-options span,\ndiv.whatsapp-connection-bar > div > div div.v-select div.vs__dropdown-toggle div.vs__selected-options input {\n  width: calc(100% - 50px);\n  max-height: 42px;\n  padding: 0px 0px 0px 20px;\n  margin: 0px;\n  color: #999999;\n  font-size: 14px;\n  line-height: 19px;\n  overflow: hidden;\n  opacity: 1;\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n}\n@media (max-width: 992px) {\n  div.whatsapp-connection-bar > div > div div.v-select div.vs__dropdown-toggle div.vs__selected-options span,\ndiv.whatsapp-connection-bar > div > div div.v-select div.vs__dropdown-toggle div.vs__selected-options input {\n    font-size: 14px;\n    max-height: 23px;\n  }\n}\ndiv.whatsapp-connection-bar > div > div div.v-select div.vs__dropdown-toggle div.vs__selected-options input {\n  position: absolute;\n  pointer-events: none;\n}\ndiv.whatsapp-connection-bar > div > div div.v-select div.vs__dropdown-toggle div.vs__actions {\n  width: 27px;\n  height: 27px;\n  position: absolute;\n  padding: 0px;\n  top: 50%;\n  right: 10px;\n  transform: translate(0px, -50%);\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #f1f1f1;\n}\ndiv.whatsapp-connection-bar > div > div div.v-select div.vs__dropdown-toggle div.vs__actions button.vs__clear {\n  display: none;\n}\n@media (max-width: 992px) {\n  div.whatsapp-connection-bar > div > div div.v-select div.vs__dropdown-toggle div.vs__actions {\n    width: 27px;\n    height: 27px;\n  }\n}\ndiv.whatsapp-connection-bar > div > div div.v-select ul {\n  top: 20px;\n  padding: 25px 20px 10px 20px;\n  z-index: -1;\n  border-radius: 0px 0px 20px 20px;\n  outline: none;\n  border: 1px solid #d7d7d7;\n  box-shadow: none;\n}\ndiv.whatsapp-connection-bar > div > div div.v-select ul li {\n  padding: 10px 0px;\n  font-size: 16px;\n  color: #999999;\n  transition: 0.5s;\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  flex-direction: column;\n  position: relative;\n  background: none !important;\n}\ndiv.whatsapp-connection-bar > div > div div.v-select ul li small {\n  font-size: 11px;\n}\ndiv.whatsapp-connection-bar > div > div div.v-select ul li:not(:last-child) {\n  border-bottom: 1px solid #d7d7d7;\n}\ndiv.whatsapp-connection-bar > div > div div.v-select ul li.vs__dropdown-option--selected {\n  font-weight: bold;\n}\ndiv.whatsapp-connection-bar > div > div div.v-select.vs--disabled {\n  opacity: 0.9;\n  cursor: not-allowed;\n}\ndiv.whatsapp-connection-bar > div > div div.v-select.vs--disabled div.vs__dropdown-toggle {\n  cursor: not-allowed;\n}\ndiv.whatsapp-connection-bar > div > div div.v-select.vs--disabled div.vs__dropdown-toggle div.vs__selected-options input {\n  background: transparent;\n}\ndiv.whatsapp-connection-bar > div > div div.v-select.disabled-cursor ul li {\n  cursor: default;\n}\n@media (max-width: 576px) {\n  div.whatsapp-connection-bar > div > div div.v-select {\n    width: calc(90% - 15px - 35px);\n  }\n}\ndiv.whatsapp-connection-bar > div > div button {\n  transition: 0.5s;\n  border-radius: 50px;\n  border: none;\n  cursor: pointer;\n  color: #ffffff;\n  position: relative;\n  overflow: hidden;\n  font-size: 14px;\n  white-space: nowrap;\n  padding: 0px 20px;\n}\ndiv.whatsapp-connection-bar > div > div button span.text-ok {\n  display: none;\n}\ndiv.whatsapp-connection-bar > div > div button div.loader-container {\n  top: 0px;\n}\ndiv.whatsapp-connection-bar > div > div button div.loader-container div.loader {\n  max-height: 23px;\n}\ndiv.whatsapp-connection-bar > div > div button[disabled] {\n  opacity: 0.8;\n  cursor: not-allowed;\n}\ndiv.whatsapp-connection-bar > div > div button.loader {\n  width: 100px;\n  padding: 0px;\n}\n@media (max-width: 992px) {\n  div.whatsapp-connection-bar > div > div button {\n    font-size: 16px;\n  }\n  div.whatsapp-connection-bar > div > div button div.loader-container {\n    top: 3px;\n  }\n}\n@media (max-width: 576px) {\n  div.whatsapp-connection-bar > div > div button:not(.single-number) {\n    width: 35px !important;\n    padding: 0px;\n    border-radius: 50%;\n  }\n  div.whatsapp-connection-bar > div > div button span.text-read {\n    display: none;\n  }\n  div.whatsapp-connection-bar > div > div button span.text-ok {\n    display: block;\n  }\n  div.whatsapp-connection-bar > div > div button div.loader-container {\n    top: 0px;\n  }\n  div.whatsapp-connection-bar > div > div button div.loader-container div.v-pulse {\n    width: 6px !important;\n    height: 6px !important;\n  }\n}\n@media (max-width: 992px) {\n  div.whatsapp-connection-bar > div > div {\n    width: 100%;\n  }\n}\n@media (max-width: 992px) {\n  div.whatsapp-connection-bar > div {\n    flex-direction: column;\n    padding: 15px 0px;\n  }\n}\ndiv.whatsapp-connection-bar button.close {\n  position: absolute;\n  top: 50%;\n  right: 20px;\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  border: none;\n  text-indent: -9999px;\n  cursor: pointer;\n  transition: 0.5s;\n  transform: translate(0px, -50%);\n}\ndiv.whatsapp-connection-bar button.close:before, div.whatsapp-connection-bar button.close:after {\n  content: \"\";\n  position: absolute;\n  top: 14px;\n  left: 6px;\n  width: 60%;\n  height: 3px;\n  border-radius: 20px;\n}\ndiv.whatsapp-connection-bar button.close:before {\n  transform: rotate(45deg);\n}\ndiv.whatsapp-connection-bar button.close:after {\n  transform: rotate(-45deg);\n}\n@media (max-width: 992px) {\n  div.whatsapp-connection-bar button.close {\n    top: 5px;\n    right: 5px;\n    transform: translate(0px, 0px);\n    width: 25px;\n    height: 25px;\n  }\n  div.whatsapp-connection-bar button.close:before, div.whatsapp-connection-bar button.close:after {\n    top: 11px;\n    left: 4px;\n  }\n}\ndiv.whatsapp-connection-bar.connecting {\n  background: #ffcf3a;\n}\ndiv.whatsapp-connection-bar.connecting > div p,\ndiv.whatsapp-connection-bar.connecting > div p a {\n  color: #575757;\n}\ndiv.whatsapp-connection-bar.connecting > div > div div.v-select div.vs__dropdown-toggle div.vs__actions svg {\n  fill: #ffcf3a;\n}\ndiv.whatsapp-connection-bar.connecting > div button {\n  color: #575757;\n  background: #fce8aa;\n}\ndiv.whatsapp-connection-bar.connecting > div button div.v-pulse {\n  background: #ffcf3a !important;\n}\ndiv.whatsapp-connection-bar.connecting > div button:hover {\n  background-color: #fbd86f;\n}\ndiv.whatsapp-connection-bar.connecting button.close {\n  background: #fce8aa;\n}\ndiv.whatsapp-connection-bar.connecting button.close:after, div.whatsapp-connection-bar.connecting button.close:before {\n  background-color: #575757;\n}\ndiv.whatsapp-connection-bar.connecting button.close:hover {\n  background: #fbd86f;\n}\ndiv.whatsapp-connection-bar.disconnected {\n  background: #ef2066;\n}\ndiv.whatsapp-connection-bar.disconnected > div p,\ndiv.whatsapp-connection-bar.disconnected > div p a {\n  color: #ffffff;\n}\ndiv.whatsapp-connection-bar.disconnected > div > div div.v-select div.vs__dropdown-toggle div.vs__actions svg {\n  fill: #ef2066;\n}\ndiv.whatsapp-connection-bar.disconnected > div > div button {\n  color: #ffffff;\n  background: #ff9abc;\n}\ndiv.whatsapp-connection-bar.disconnected > div > div button:hover {\n  background-color: #f9528b;\n}\ndiv.whatsapp-connection-bar.disconnected button.close {\n  background: #f9528b;\n}\ndiv.whatsapp-connection-bar.disconnected button.close:after, div.whatsapp-connection-bar.disconnected button.close:before {\n  background-color: #ef2066;\n}\ndiv.whatsapp-connection-bar.disconnected button.close:hover {\n  background: #ff9abc;\n}\n@media (max-width: 992px) {\n  div.whatsapp-connection-bar {\n    top: 0px;\n    left: 0px;\n    transform: translate(0px, 0px);\n    width: 100%;\n    max-width: 100%;\n    height: auto;\n    padding: 0px 35px;\n    border-radius: 0px;\n  }\n}\n\n/*# sourceMappingURL=Bar.vue.map */", "<template>\r\n  <div>\r\n    <div\r\n      class=\"whatsapp-connection-bar\"\r\n      :class=\"{\r\n        disconnected: disconnectedNumbers.length,\r\n        connecting: connectingNumbers.length\r\n      }\"\r\n      v-if=\"\r\n        canShowBar && (disconnectedNumbers.length || connectingNumbers.length)\r\n      \"\r\n    >\r\n      <div>\r\n        <template v-if=\"disconnectedNumbers.length === 1\">\r\n          <p\r\n            v-html=\"\r\n              $t('connectionBar.disconnectedNumbers.onlyNumber', {\r\n                name: disconnectedNumbers[0].translate\r\n              })\r\n            \"\r\n          />\r\n\r\n          <div>\r\n            <button class=\"single-number\" @click=\"handleReadQrCode\">\r\n              {{ $t('connectionBar.disconnectedNumbers.button') }}\r\n            </button>\r\n          </div>\r\n        </template>\r\n\r\n        <template v-else-if=\"disconnectedNumbers.length >= 2\">\r\n          <p v-html=\"$t('connectionBar.disconnectedNumbers.multipleNumbers')\" />\r\n\r\n          <div>\r\n            <v-select\r\n              ref=\"disconnectedNumbers\"\r\n              :options=\"disconnectedNumbers\"\r\n              label=\"translate\"\r\n              class=\"bar\"\r\n              :filterable=\"false\"\r\n              :searchable=\"false\"\r\n              @input=\"handleChangeSelectNumbers\"\r\n              :placeholder=\"$t('connectionBar.selectPlaceholder')\"\r\n            >\r\n              <template v-slot:option=\"option\">\r\n                {{ option.translate }}\r\n\r\n                <small>{{ handleParsePhoneNumber(option.number) }}</small>\r\n              </template>\r\n            </v-select>\r\n\r\n            <button @click=\"handleReadQrCode\" :disabled=\"phoneId === ''\">\r\n              <span class=\"text-read\">\r\n                {{ $t('connectionBar.disconnectedNumbers.button') }}\r\n              </span>\r\n\r\n              <span class=\"text-ok\">Ok</span>\r\n            </button>\r\n          </div>\r\n        </template>\r\n\r\n        <template v-else-if=\"connectingNumbers.length === 1\">\r\n          <p\r\n            v-html=\"\r\n              $t('connectionBar.connectingNumbers.onlyNumber', {\r\n                name: connectingNumbers[0].translate,\r\n                number: handleParsePhoneNumber(connectingNumbers[0].number)\r\n              })\r\n            \"\r\n          />\r\n        </template>\r\n\r\n        <template v-else-if=\"connectingNumbers.length >= 2\">\r\n          <p v-html=\"$t('connectionBar.connectingNumbers.multipleNumbers')\" />\r\n\r\n          <div>\r\n            <v-select\r\n              :options=\"connectingNumbers\"\r\n              label=\"translate\"\r\n              class=\"bar disabled-cursor\"\r\n              :filterable=\"false\"\r\n              :searchable=\"false\"\r\n              :placeholder=\"$t('connectionBar.selectPlaceholder')\"\r\n              ref=\"selectConnectingNumbers\"\r\n            >\r\n              <template v-slot:option=\"option\">\r\n                {{ option.translate }}\r\n\r\n                <small>{{ handleParsePhoneNumber(option.number) }}</small>\r\n              </template>\r\n            </v-select>\r\n          </div>\r\n        </template>\r\n      </div>\r\n\r\n      <button\r\n        type=\"button\"\r\n        class=\"close\"\r\n        aria-label=\"Fechar\"\r\n        @click=\"barShow({ show: false, manualClose: true })\"\r\n      />\r\n    </div>\r\n\r\n    <Toasts\r\n      type=\"success\"\r\n      :time=\"6000\"\r\n      v-for=\"phone in recentConnectedNumbers\"\r\n      :key=\"phone.number\"\r\n      style=\"display: none;\"\r\n    >\r\n      <i class=\"icon-wp-check-circle\"></i>\r\n\r\n      {{ phone.translate }} {{ $t('connectionBar.connected') }}!\r\n    </Toasts>\r\n\r\n    <Modal\r\n      v-if=\"modal.show\"\r\n      :editingContact=\"modal.contact\"\r\n      @close=\"handleCloseModal\"\r\n    />\r\n  </div>\r\n</template>\r\n\r\n<script>\r\n  import { mapActions } from 'vuex'\r\n\r\n  import Modal from '@/app/modal/components/Modal.vue'\r\n\r\n  import vSelect from 'vue-select'\r\n\r\n  import { Toasts } from '@/app/shared-components'\r\n\r\n  import GlobalMixins from '@/app/mixins'\r\n\r\n  export default {\r\n    components: {\r\n      Modal,\r\n      'v-select': vSelect,\r\n      Toasts\r\n    },\r\n    mixins: [GlobalMixins],\r\n    data() {\r\n      return {\r\n        connectingNumbers: [],\r\n        disconnectedNumbers: [],\r\n        recentConnectedNumbers: [],\r\n        canShowBar: false,\r\n        phoneId: '',\r\n        modal: {\r\n          show: false,\r\n          contact: undefined\r\n        }\r\n      }\r\n    },\r\n    watch: {\r\n      disconnectedNumbers(disconnecteds) {\r\n        if (disconnecteds.length === 1) {\r\n          this.phoneId = disconnecteds[0].id\r\n\r\n          this.modal = {\r\n            ...this.modal,\r\n            contact: disconnecteds[0]\r\n          }\r\n        } else {\r\n          this.phoneId = ''\r\n        }\r\n      }\r\n    },\r\n    mounted() {\r\n      this.unsubscribe = this.$store.subscribe((mutation, state) => {\r\n        this.connectingNumbers = state.bar.connectingNumbers.filter(\r\n          number => !number.integrator\r\n        )\r\n\r\n        this.disconnectedNumbers = state.bar.disconnectedNumbers.filter(\r\n          number => !number.integrator\r\n        )\r\n\r\n        this.recentConnectedNumbers = state.bar.recentConnectedNumbers.filter(\r\n          number => !number.integrator\r\n        )\r\n\r\n        this.canShowBar = state.bar.canShowBar\r\n      })\r\n    },\r\n    created() {\r\n      this.startMonitoring()\r\n    },\r\n    methods: {\r\n      ...mapActions(['barShow', 'startMonitoring']),\r\n      handleOpenWhatsAppConfig() {\r\n        return\r\n      },\r\n      handleReadQrCode() {\r\n        if (\r\n          this.phoneId ||\r\n          (!this.phoneId && this.disconnectedNumbers.length === 1)\r\n        ) {\r\n          if (this.disconnectedNumbers.length === 1) {\r\n            this.phoneId = this.disconnectedNumbers[0].id\r\n          }\r\n\r\n          this.modal = {\r\n            ...this.modal,\r\n            show: true\r\n          }\r\n        } else if (this.disconnectedNumbers.length >= 2) {\r\n          alert('Selecione um número')\r\n        }\r\n      },\r\n      handleChangeSelectNumbers(number) {\r\n        const phone = this.disconnectedNumbers.find(\r\n          phone => phone.id === number.id\r\n        )\r\n\r\n        if (phone) {\r\n          this.phoneId = phone.id\r\n\r\n          this.modal = {\r\n            show: false,\r\n            contact: phone\r\n          }\r\n        }\r\n      },\r\n      handleCloseModal() {\r\n        this.modal = {\r\n          show: false,\r\n          contact: undefined\r\n        }\r\n\r\n        this.phoneId = ''\r\n\r\n        this.$refs.disconnectedNumbers.clearSelection()\r\n      }\r\n    }\r\n  }\r\n</script>\r\n\r\n<style lang=\"scss\">\r\n  @import 'node_modules/vue-select/src/scss/vue-select.scss';\r\n\r\n  div.whatsapp-connection-bar {\r\n    width: fit-content;\r\n    min-height: 60px;\r\n    max-width: calc(100% - 2rem);\r\n    border-radius: 60px;\r\n    position: fixed;\r\n    z-index: 150;\r\n    top: 70px;\r\n    left: 50%;\r\n    transform: translate(-50%, 0px);\r\n    padding: 10px 60px 10px 30px;\r\n    display: flex;\r\n    justify-content: flex-start;\r\n    align-items: center;\r\n    & > div {\r\n      width: 100%;\r\n      height: 100%;\r\n      display: flex;\r\n      justify-content: space-between;\r\n      align-items: center;\r\n      p {\r\n        font-size: 15px;\r\n        line-height: 24px;\r\n        padding-right: 20px;\r\n        margin-bottom: 0px;\r\n        strong {\r\n          font-weight: bold;\r\n        }\r\n        a {\r\n          text-decoration: underline;\r\n        }\r\n        @media (max-width: 992px) {\r\n          font-size: 16px;\r\n          line-height: 20px;\r\n          margin-bottom: 15px;\r\n          text-align: center;\r\n          padding: 0px;\r\n          white-space: normal;\r\n        }\r\n      }\r\n      & > div {\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        div.v-select,\r\n        button {\r\n          height: 40px;\r\n          @media (max-width: 992px) {\r\n            height: 35px;\r\n          }\r\n        }\r\n        div.v-select {\r\n          width: 230px;\r\n          margin-right: 15px;\r\n          transition: 0.5s;\r\n          cursor: pointer;\r\n          div.vs__dropdown-toggle {\r\n            width: 100%;\r\n            height: 100%;\r\n            border-radius: 50px;\r\n            padding: 0px;\r\n            border: 1px solid #d7d7d7;\r\n            background-color: #ffffff;\r\n            div.vs__selected-options {\r\n              display: flex;\r\n              justify-content: flex-start;\r\n              align-items: center;\r\n              span,\r\n              input {\r\n                width: calc(100% - 50px);\r\n                max-height: 42px;\r\n                padding: 0px 0px 0px 20px;\r\n                margin: 0px;\r\n                color: #999999;\r\n                font-size: 14px;\r\n                line-height: 19px;\r\n                overflow: hidden;\r\n                opacity: 1;\r\n                display: flex;\r\n                justify-content: flex-start;\r\n                align-items: flex-start;\r\n                @media (max-width: 992px) {\r\n                  font-size: 14px;\r\n                  max-height: 23px;\r\n                }\r\n              }\r\n              input {\r\n                position: absolute;\r\n                pointer-events: none;\r\n              }\r\n            }\r\n            div.vs__actions {\r\n              width: 27px;\r\n              height: 27px;\r\n              position: absolute;\r\n              padding: 0px;\r\n              top: 50%;\r\n              right: 10px;\r\n              transform: translate(0px, -50%);\r\n              border-radius: 50%;\r\n              display: flex;\r\n              justify-content: center;\r\n              align-items: center;\r\n              background: #f1f1f1;\r\n              button.vs__clear {\r\n                display: none;\r\n              }\r\n              @media (max-width: 992px) {\r\n                width: 27px;\r\n                height: 27px;\r\n              }\r\n            }\r\n          }\r\n          ul {\r\n            top: 20px;\r\n            padding: 25px 20px 10px 20px;\r\n            z-index: -1;\r\n            border-radius: 0px 0px 20px 20px;\r\n            outline: none;\r\n            border: 1px solid #d7d7d7;\r\n            box-shadow: none;\r\n            li {\r\n              padding: 10px 0px;\r\n              font-size: 16px;\r\n              color: #999999;\r\n              transition: 0.5s;\r\n              display: flex;\r\n              justify-content: flex-start;\r\n              align-items: flex-start;\r\n              flex-direction: column;\r\n              position: relative;\r\n              background: none !important;\r\n              small {\r\n                font-size: 11px;\r\n              }\r\n              &:not(:last-child) {\r\n                border-bottom: 1px solid #d7d7d7;\r\n              }\r\n              &.vs__dropdown-option--selected {\r\n                font-weight: bold;\r\n              }\r\n            }\r\n          }\r\n          &.vs--disabled {\r\n            opacity: 0.9;\r\n            cursor: not-allowed;\r\n            div.vs__dropdown-toggle {\r\n              cursor: not-allowed;\r\n              div.vs__selected-options input {\r\n                background: transparent;\r\n              }\r\n            }\r\n          }\r\n          &.disabled-cursor {\r\n            ul li {\r\n              cursor: default;\r\n            }\r\n          }\r\n          @media (max-width: 576px) {\r\n            width: calc(90% - 15px - 35px);\r\n          }\r\n        }\r\n        button {\r\n          transition: 0.5s;\r\n          border-radius: 50px;\r\n          border: none;\r\n          cursor: pointer;\r\n          color: #ffffff;\r\n          position: relative;\r\n          overflow: hidden;\r\n          font-size: 14px;\r\n          white-space: nowrap;\r\n          padding: 0px 20px;\r\n          span.text-ok {\r\n            display: none;\r\n          }\r\n          div.loader-container {\r\n            top: 0px;\r\n            div.loader {\r\n              max-height: 23px;\r\n            }\r\n          }\r\n          &[disabled] {\r\n            opacity: 0.8;\r\n            cursor: not-allowed;\r\n          }\r\n          &.loader {\r\n            width: 100px;\r\n            padding: 0px;\r\n          }\r\n          @media (max-width: 992px) {\r\n            font-size: 16px;\r\n            div.loader-container {\r\n              top: 3px;\r\n            }\r\n          }\r\n          @media (max-width: 576px) {\r\n            &:not(.single-number) {\r\n              width: 35px !important;\r\n              padding: 0px;\r\n              border-radius: 50%;\r\n            }\r\n            span.text-read {\r\n              display: none;\r\n            }\r\n            span.text-ok {\r\n              display: block;\r\n            }\r\n            div.loader-container {\r\n              top: 0px;\r\n              div.v-pulse {\r\n                width: 6px !important;\r\n                height: 6px !important;\r\n              }\r\n            }\r\n          }\r\n        }\r\n        @media (max-width: 992px) {\r\n          width: 100%;\r\n        }\r\n      }\r\n      @media (max-width: 992px) {\r\n        flex-direction: column;\r\n        padding: 15px 0px;\r\n      }\r\n    }\r\n    button.close {\r\n      position: absolute;\r\n      top: 50%;\r\n      right: 20px;\r\n      width: 30px;\r\n      height: 30px;\r\n      border-radius: 50%;\r\n      border: none;\r\n      text-indent: -9999px;\r\n      cursor: pointer;\r\n      transition: 0.5s;\r\n      transform: translate(0px, -50%);\r\n      &:before,\r\n      &:after {\r\n        content: '';\r\n        position: absolute;\r\n        top: 14px;\r\n        left: 6px;\r\n        width: 60%;\r\n        height: 3px;\r\n        border-radius: 20px;\r\n      }\r\n      &:before {\r\n        transform: rotate(45deg);\r\n      }\r\n      &:after {\r\n        transform: rotate(-45deg);\r\n      }\r\n      @media (max-width: 992px) {\r\n        top: 5px;\r\n        right: 5px;\r\n        transform: translate(0px, 0px);\r\n        width: 25px;\r\n        height: 25px;\r\n        &:before,\r\n        &:after {\r\n          top: 11px;\r\n          left: 4px;\r\n        }\r\n      }\r\n    }\r\n    &.connecting {\r\n      background: #ffcf3a;\r\n      & > div {\r\n        p,\r\n        p a {\r\n          color: #575757;\r\n        }\r\n        & > div {\r\n          div.v-select div.vs__dropdown-toggle div.vs__actions svg {\r\n            fill: #ffcf3a;\r\n          }\r\n        }\r\n        button {\r\n          color: #575757;\r\n          background: #fce8aa;\r\n          div.v-pulse {\r\n            background: #ffcf3a !important;\r\n          }\r\n          &:hover {\r\n            background-color: #fbd86f;\r\n          }\r\n        }\r\n      }\r\n      button.close {\r\n        background: #fce8aa;\r\n        &:after,\r\n        &:before {\r\n          background-color: #575757;\r\n        }\r\n        &:hover {\r\n          background: #fbd86f;\r\n        }\r\n      }\r\n    }\r\n    &.disconnected {\r\n      background: #ef2066;\r\n      & > div {\r\n        p,\r\n        p a {\r\n          color: #ffffff;\r\n        }\r\n        & > div {\r\n          div.v-select div.vs__dropdown-toggle div.vs__actions svg {\r\n            fill: #ef2066;\r\n          }\r\n          button {\r\n            color: #ffffff;\r\n            background: #ff9abc;\r\n            &:hover {\r\n              background-color: #f9528b;\r\n            }\r\n          }\r\n        }\r\n      }\r\n      button.close {\r\n        background: #f9528b;\r\n        &:after,\r\n        &:before {\r\n          background-color: #ef2066;\r\n        }\r\n        &:hover {\r\n          background: #ff9abc;\r\n        }\r\n      }\r\n    }\r\n    @media (max-width: 992px) {\r\n      top: 0px;\r\n      left: 0px;\r\n      transform: translate(0px, 0px);\r\n      width: 100%;\r\n      max-width: 100%;\r\n      height: auto;\r\n      padding: 0px 35px;\r\n      border-radius: 0px;\r\n    }\r\n  }\r\n</style>\r\n"]
    },
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$q = undefined;
/* module identifier */

var __vue_module_identifier__$q = undefined;
/* functional template */

var __vue_is_functional_template__$q = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$o,
  staticRenderFns: __vue_staticRenderFns__$o
}, __vue_inject_styles__$q, __vue_script__$m, __vue_scope_id__$q, __vue_is_functional_template__$q, __vue_module_identifier__$q, false, createInjector, undefined, undefined);

var script$n = {
  name: 'App',
  store: store$2,
  props: {
    name: {
      type: String,
      required: false,
      default: undefined
    },
    n2Team: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    listNumbers: __vue_component__$p,
    whatsappBar: __vue_component__$q
  },
  methods: _objectSpread2({}, mapActions(['wppSetUserLogged', 'wppSetUserToken', 'wppSetSubdomainStatus'])),
  mounted: function mounted() {
    this.wppSetUserLogged();
    this.wppSetUserToken();
    this.wppSetSubdomainStatus();
  }
};

var __vue_script__$n = script$n;
/* template */

var __vue_render__$p = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.name ? _c(_vm.name, {
    tag: "component",
    attrs: {
      n2Team: _vm.n2Team
    }
  }) : _c("router-view");
};

var __vue_staticRenderFns__$p = [];
__vue_render__$p._withStripped = true;
/* style */

var __vue_inject_styles__$r = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-0294d920_0", {
    source: "@charset \"UTF-8\";\n@font-face {\n  font-family: \"Niveau Grotesk\";\n  src: url(\"data:application/font-woff2;charset=utf-8;base64,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\") format(\"woff2\"), url(\"data:application/font-woff;charset=utf-8;base64,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\") format(\"woff\");\n  font-weight: bold;\n  font-style: normal;\n  font-display: swap;\n}\n* {\n  margin: 0px;\n  padding: 0px;\n  box-sizing: border-box;\n}\n@font-face {\n  font-family: \"HelveticaRegular\";\n  src: url(\"~@/assets/fonts/HelveticaRegular/HelveticaRegular.woff\") format(\"woff\"), url(\"~@/assets/fonts/HelveticaRegular/HelveticaRegular.woff2\") format(\"woff2\"), url(\"~@/assets/fonts/HelveticaRegular/HelveticaRegular.svg\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n  font-display: auto;\n}\n@font-face {\n  font-family: \"HelveticaBold\";\n  src: url(\"~@/assets/fonts/HelveticaBold/HelveticaBold.woff\") format(\"woff\"), url(\"~@/assets/fonts/HelveticaBold/HelveticaBold.woff2\") format(\"woff2\"), url(\"~@/assets/fonts/HelveticaBold/HelveticaBold.svg\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n  font-display: auto;\n}\n/*MODAL*/\n.modal {\n  display: none;\n  overflow: hidden;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1070;\n  -webkit-overflow-scrolling: touch;\n  outline: 0;\n}\n.modal.fade .modal-dialog {\n  -webkit-transform: translate3d(0, -25%, 0);\n  transform: translate3d(0, -25%, 0);\n  -webkit-transition: -webkit-transform 0.3s ease-out;\n  -moz-transition: -moz-transform 0.3s ease-out;\n  -o-transition: -o-transform 0.3s ease-out;\n  transition: transform 0.3s ease-out;\n}\n.modal.in .modal-dialog {\n  -webkit-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0);\n}\n.modal-open .modal {\n  overflow-x: hidden;\n  overflow-y: auto;\n  background: rgba(112, 112, 112, 0.8);\n}\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: 10px;\n}\n.modal-content {\n  position: relative;\n  background-color: #fff;\n  border-radius: 6px;\n  -webkit-box-shadow: 0 3px 9px rgba(0, 0, 0, 0.15);\n  box-shadow: 0 3px 9px rgba(0, 0, 0, 0.15);\n  background-clip: padding-box;\n  outline: 0;\n}\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1060;\n  background-color: #fff;\n}\n.modal-backdrop.fade {\n  opacity: 0;\n  filter: alpha(opacity=0);\n}\n.modal-backdrop.in {\n  opacity: 0.5;\n  filter: alpha(opacity=50);\n}\n.modal-icon {\n  width: 100%;\n  display: inline-block;\n  padding-top: 15px;\n}\n.modal-header {\n  padding: 15px;\n  min-height: 16.33px;\n}\n.modal-header .close {\n  margin-top: -2px;\n  float: right;\n  font-size: 24px;\n}\n.modal-title {\n  margin: 0;\n  line-height: 1.33;\n  font-family: Dosis, sans-serif;\n  font-size: 24px;\n}\n.modal-title small {\n  font-size: 14px;\n  display: block;\n  color: inherit;\n}\n.modal-title p {\n  margin: 10px 0 0;\n}\n.h4.modal-title,\nh4.modal-title {\n  font-weight: 300;\n}\n.modal-body {\n  position: relative;\n  padding: 15px;\n}\n.modal-body .list-header {\n  padding: 0 0 10px;\n}\n.modal-footer {\n  padding: 15px;\n}\n.modal-footer .btn + .btn {\n  margin-left: 5px;\n  margin-bottom: 0;\n}\n.modal-footer .btn-group .btn + .btn {\n  margin-left: -1px;\n}\n.modal-footer .btn-block + .btn-block {\n  margin-left: 0;\n}\n.modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll;\n}\n@media (min-width: 768px) {\n.modal-dialog {\n    width: 600px;\n    margin: 30px auto;\n}\n.modal-content {\n    -webkit-box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);\n}\n.modal-sm {\n    width: 400px;\n}\n.modal-xs {\n    width: 300px;\n}\n}\n@media (min-width: 992px) {\n.modal-xl {\n    width: 980px;\n}\n.modal-lg {\n    width: 790px;\n}\n}\n/*MODAL*/\n/* TOOLTIP */\ndiv.tooltip div.tooltip-arrow,\ndiv.tooltip div.tooltip-arrow:after {\n  bottom: -2px !important;\n  border-width: 6px 6px 0 !important;\n  margin-left: -6px !important;\n  border-top-color: #979797 !important;\n}\ndiv.tooltip div.tooltip-arrow:after {\n  bottom: 1px !important;\n  border-top-color: #000000 !important;\n}\ndiv.tooltip div.tooltip-inner {\n  text-align: center;\n  max-width: 280px;\n  box-shadow: none;\n  border: 1px solid #000000;\n  font-size: 12px;\n  line-height: 18px;\n  padding: 5px;\n  color: #ffffff;\n  border-radius: 10px;\n  background: #000000;\n}\n\n/* TOOLTIP */\n/* FORM */\ndiv.fields-control-wpp {\n  width: 100%;\n  position: relative;\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  flex-direction: column;\n}\ndiv.fields-control-wpp span.error-message {\n  font-size: 10px;\n  color: #ef2066;\n  margin: 5px 0px 0px 15px;\n}\ndiv.fields-control-wpp > label {\n  font-family: Helvetica;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 12px;\n  line-height: 14px;\n  color: #999999;\n}\ndiv.fields-control-wpp > div {\n  width: 100%;\n  position: relative;\n}\ndiv.fields-control-wpp > div:before {\n  font-family: \"icomoonWp\";\n  position: absolute;\n  top: 9px;\n  right: 14px;\n  font-size: 15px;\n  transition: 0.5s;\n  opacity: 0;\n  pointer-events: none;\n}\ndiv.fields-control-wpp > div > input, div.fields-control-wpp > div > textarea {\n  width: 100%;\n  padding: 10px;\n  color: #707070;\n  resize: none;\n  border: 1px solid #d7d7d7;\n  box-sizing: border-box;\n  border-radius: 15px;\n  transition: 0.5s;\n  background: #ffffff;\n}\ndiv.fields-control-wpp > div > input:focus, div.fields-control-wpp > div > textarea:focus {\n  border: 1px solid #4b9bfc;\n}\ndiv.fields-control-wpp > div > input:disabled, div.fields-control-wpp > div > input.disabled, div.fields-control-wpp > div > textarea:disabled, div.fields-control-wpp > div > textarea.disabled {\n  cursor: not-allowed;\n  color: #bfbfbf;\n  pointer-events: none;\n  background: #f0f0f0;\n}\ndiv.fields-control-wpp > div > input::placeholder, div.fields-control-wpp > div > textarea::placeholder {\n  color: #bfbfbf;\n}\ndiv.fields-control-wpp > div > input::-webkit-scrollbar, div.fields-control-wpp > div > textarea::-webkit-scrollbar {\n  width: 14px;\n  height: 18px;\n}\ndiv.fields-control-wpp > div > input::-webkit-scrollbar-thumb, div.fields-control-wpp > div > textarea::-webkit-scrollbar-thumb {\n  height: 5px;\n  border: 5px solid rgba(0, 0, 0, 0);\n  background-clip: padding-box;\n  border-radius: 7px;\n  background-color: #2775d3;\n}\ndiv.fields-control-wpp > div > input::-webkit-scrollbar-button, div.fields-control-wpp > div > textarea::-webkit-scrollbar-button {\n  width: 0;\n  height: 0;\n  display: none;\n}\ndiv.fields-control-wpp > div > input::-webkit-scrollbar-corner, div.fields-control-wpp > div > textarea::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\ndiv.fields-control-wpp > div input {\n  border-radius: 24px;\n}\ndiv.fields-control-wpp.validation > div:before {\n  opacity: 1;\n}\ndiv.fields-control-wpp.validation > div input,\ndiv.fields-control-wpp.validation > div textarea {\n  padding-right: 35px;\n}\ndiv.fields-control-wpp.has-error > div:before {\n  content: \"\";\n  color: #ef2066;\n}\ndiv.fields-control-wpp.has-error > div input,\ndiv.fields-control-wpp.has-error > div textarea {\n  border-color: #ef2066;\n}\ndiv.fields-control-wpp.success > div:before {\n  content: \"\";\n  color: #1bdd85;\n}\ndiv.fields-control-wpp.success > div input,\ndiv.fields-control-wpp.success > div textarea {\n  border-color: #1bdd85;\n}\n\n/* FORM */\n/* BUTTONS */\n.btn-control-wpp {\n  padding: 15px 25px;\n  height: 49px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50px;\n  border: 1px solid transparent;\n  font-family: Helvetica;\n  font-style: normal;\n  font-weight: bold;\n  font-size: 16px;\n  line-height: 18px;\n  text-align: center;\n  text-decoration: none !important;\n  transition: 0.5s;\n  background: transparent;\n}\n.btn-control-wpp.primary {\n  color: #ffffff;\n  background: #0074ff;\n}\n.btn-control-wpp.primary:hover:not(:disabled) {\n  background: #005dcc;\n}\n.btn-control-wpp.outline {\n  color: #0074ff;\n  border-color: #0074ff;\n}\n.btn-control-wpp.outline:hover:not(:disabled) {\n  color: #ffffff;\n  background: #0074ff;\n}\n.btn-control-wpp.outline:disabled {\n  color: #fff;\n}\n.btn-control-wpp.link {\n  font-weight: normal;\n  color: #999999;\n}\n.btn-control-wpp:disabled {\n  background: #eee;\n  border-color: transparent;\n  cursor: not-allowed;\n}\n\n/* BUTTONS */\n/* SELECT */\ndiv.v-select.select-control-wpp {\n  width: 100%;\n}\ndiv.v-select.select-control-wpp:before, div.v-select.select-control-wpp:after {\n  content: \"\";\n  width: 1px;\n  height: 24px;\n  position: absolute;\n  top: 16px;\n  opacity: 0;\n  background: #d7d7d7;\n}\ndiv.v-select.select-control-wpp:before {\n  left: 0px;\n}\ndiv.v-select.select-control-wpp:after {\n  right: 0px;\n}\ndiv.v-select.select-control-wpp .vs__search {\n  margin-top: 0;\n}\ndiv.v-select.select-control-wpp div.vs__dropdown-toggle {\n  border-radius: 24px !important;\n  border-bottom-color: rgba(60, 60, 60, 0.26) !important;\n  padding: 0px 10px;\n  height: 39px;\n  position: relative;\n  z-index: 2;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  transition: 0.5s;\n}\ndiv.v-select.select-control-wpp div.vs__dropdown-toggle div.vs__selected-options {\n  flex-basis: auto;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  padding: 0px;\n  width: 100%;\n  height: 100%;\n}\ndiv.v-select.select-control-wpp div.vs__dropdown-toggle div.vs__selected-options span.vs__selected,\ndiv.v-select.select-control-wpp div.vs__dropdown-toggle div.vs__selected-options input {\n  margin: 0px;\n  padding: 0px;\n  width: 100%;\n  height: 18px;\n  overflow: hidden;\n  font-size: 12px;\n  color: #707070;\n  background: transparent;\n}\ndiv.v-select.select-control-wpp div.vs__dropdown-toggle div.vs__selected-options input {\n  position: absolute;\n  top: 50%;\n  left: 0px;\n  transform: translate(0px, -50%);\n}\ndiv.v-select.select-control-wpp div.vs__dropdown-toggle div.vs__selected-options input ::placeholder {\n  color: #f0f0f0;\n}\ndiv.v-select.select-control-wpp div.vs__dropdown-toggle div.vs__actions {\n  padding: 0px;\n  margin-left: 10px;\n  width: 27px;\n  height: 27px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  background: rgba(212, 231, 255, 0.7);\n}\ndiv.v-select.select-control-wpp div.vs__dropdown-toggle div.vs__actions button.vs__clear {\n  display: none;\n}\ndiv.v-select.select-control-wpp div.vs__dropdown-toggle div.vs__actions:before {\n  content: \"\";\n  font-family: \"icomoonWp\";\n  content: \"\";\n  color: #0074ff;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin-top: 1px;\n  transform: translate(-50%, -50%) rotate(180deg);\n  font-size: 7px;\n  transition: 0.5s;\n}\ndiv.v-select.select-control-wpp div.vs__dropdown-toggle div.vs__actions svg {\n  fill: #0074ff;\n  display: none;\n}\ndiv.v-select.select-control-wpp > ul {\n  z-index: 1;\n  position: absolute;\n  top: 1px;\n  left: 0px;\n  max-height: 150px;\n  margin-top: 38px;\n  padding-top: 4px;\n  width: 100%;\n  border-top: none;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #d7d7d7;\n  border-top: none;\n  background: #fff;\n}\ndiv.v-select.select-control-wpp > ul::-webkit-scrollbar {\n  width: 14px;\n  height: 18px;\n}\ndiv.v-select.select-control-wpp > ul::-webkit-scrollbar-thumb {\n  height: 6px;\n  border: 4px solid rgba(0, 0, 0, 0);\n  background-clip: padding-box;\n  border-radius: 7px;\n  background-color: #2775d3;\n}\ndiv.v-select.select-control-wpp > ul::-webkit-scrollbar-button {\n  width: 0;\n  height: 0;\n  display: none;\n}\ndiv.v-select.select-control-wpp > ul::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\ndiv.v-select.select-control-wpp > ul li {\n  width: 100%;\n  font-size: 12px;\n  line-height: 25px;\n  color: #999999;\n  padding: 0px 13px;\n  margin: 6px 0px;\n  position: relative;\n  transition: 0.5s;\n}\ndiv.v-select.select-control-wpp > ul li.vs__dropdown-option--highlight {\n  background: none;\n}\ndiv.v-select.select-control-wpp > ul li:before, div.v-select.select-control-wpp > ul li:after {\n  content: \"\";\n  position: absolute;\n}\ndiv.v-select.select-control-wpp > ul li:before {\n  width: calc(100% - 12px);\n  height: 25px;\n  top: 0px;\n  left: 4px;\n  border-radius: 100px;\n  opacity: 0;\n  z-index: -1;\n  background: #f0f0f0;\n}\ndiv.v-select.select-control-wpp > ul li:not(:last-child):after {\n  bottom: -6px;\n  left: 10px;\n  width: calc(100% - 20px);\n  height: 1px;\n  background: #d7d7d7;\n}\ndiv.v-select.select-control-wpp > ul li.vs__dropdown-option--selected {\n  margin: 8px 0px;\n}\ndiv.v-select.select-control-wpp > ul li.vs__dropdown-option--selected:before {\n  opacity: 1;\n}\ndiv.v-select.select-control-wpp > ul li.vs__dropdown-option--selected:not(:last-child):after {\n  bottom: -8px;\n}\ndiv.v-select.select-control-wpp > ul li:hover:not(.vs__dropdown-option--selected) {\n  color: #0074ff;\n}\ndiv.v-select.select-control-wpp.vs--open div.vs__dropdown-toggle {\n  border: 1px solid #4b9bfc !important;\n}\ndiv.v-select.select-control-wpp.vs--open div.vs__dropdown-toggle div.vs__actions:before {\n  transform: translate(-50%, -50%) rotate(0deg);\n}\ndiv.v-select.select-control-wpp.vs--open:before, div.v-select.select-control-wpp.vs--open:after {\n  opacity: 1;\n}\ndiv.v-select.select-control-wpp.vs--disabled div.vs__dropdown-toggle {\n  cursor: not-allowed;\n  background: #f0f0f0;\n}\ndiv.v-select.select-control-wpp.vs--disabled div.vs__dropdown-toggle div.vs__selected-options span.vs__selected,\ndiv.v-select.select-control-wpp.vs--disabled div.vs__dropdown-toggle div.vs__selected-options input {\n  color: #bfbfbf;\n}\ndiv.v-select.select-control-wpp.success:not(.vs--open) div.vs__dropdown-toggle {\n  border: 1px solid #1bdd85 !important;\n}\n\n/* SELECT */\n/* FLAG */\n.flag {\n  display: inline-block;\n  width: 16px;\n  height: 11px;\n}\n.flag.flag-ws {\n  background-position: -112px -165px;\n}\n.flag.flag-kr {\n  background-position: -144px -77px;\n}\n.flag.flag-tv {\n  background-position: -80px -154px;\n}\n.flag.flag-pe {\n  background-position: -208px -110px;\n}\n.flag.flag-kp {\n  background-position: -128px -77px;\n}\n.flag.flag-bj {\n  background-position: -128px -11px;\n}\n.flag.flag-mc {\n  background-position: -160px -88px;\n}\n.flag.flag-cd {\n  background-position: -80px -22px;\n}\n.flag.flag-jm {\n  background-position: -240px -66px;\n}\n.flag.flag-rw {\n  background-position: -240px -121px;\n}\n.flag.flag-tg {\n  background-position: -160px -143px;\n}\n.flag.flag-mz {\n  background-position: -224px -99px;\n}\n.flag.flag-ic {\n  background-position: -48px -66px;\n}\n.flag.flag-sn {\n  background-position: -208px -132px;\n}\n.flag.flag-an {\n  background-position: -112px 0;\n}\n.flag.flag-sh {\n  background-position: -112px -132px;\n}\n.flag.flag-sg {\n  background-position: -96px -132px;\n}\n.flag.flag-to {\n  background-position: -32px -154px;\n}\n.flag.flag-fr {\n  background-position: -144px -44px;\n}\n.flag.flag-tz {\n  background-position: -112px -154px;\n}\n.flag.flag-nr {\n  background-position: -128px -110px;\n}\n.flag.flag-nz {\n  background-position: -160px -110px;\n}\n.flag.flag-hm {\n  background-position: -224px -55px;\n}\n.flag.flag-cg {\n  background-position: -112px -22px;\n}\n.flag.flag-st {\n  background-position: -32px -143px;\n}\n.flag.flag-cl {\n  background-position: -176px -22px;\n}\n.flag.flag-iq {\n  background-position: -160px -66px;\n}\n.flag.flag-tj {\n  background-position: -208px -143px;\n}\n.flag.flag-ru {\n  background-position: -224px -121px;\n}\n.flag.flag-md {\n  background-position: -176px -88px;\n}\n.flag.flag-cw {\n  background-position: -32px -33px;\n}\n.flag.flag-gt {\n  background-position: -144px -55px;\n}\n.flag.flag-cm {\n  background-position: -192px -22px;\n}\n.flag.flag-pn {\n  background-position: -64px -121px;\n}\n.flag.flag-vi {\n  background-position: -32px -165px;\n}\n.flag.flag-ir {\n  background-position: -176px -66px;\n}\n.flag.flag-se {\n  background-position: -80px -132px;\n}\n.flag.flag-lt {\n  background-position: -80px -88px;\n}\n.flag.flag-gw {\n  background-position: -176px -55px;\n}\n.flag.flag-dm {\n  background-position: -128px -33px;\n}\n.flag.flag-bd {\n  background-position: -32px -11px;\n}\n.flag.flag-kurdistan {\n  background-position: -160px -77px;\n}\n.flag.flag-ae {\n  background-position: -16px 0;\n}\n.flag.flag-zm {\n  background-position: -208px -165px;\n}\n.flag.flag-bn {\n  background-position: -160px -11px;\n}\n.flag.flag-lb {\n  background-position: -240px -77px;\n}\n.flag.flag-zw {\n  background-position: -224px -165px;\n}\n.flag.flag-lu {\n  background-position: -96px -88px;\n}\n.flag.flag-ee {\n  background-position: -192px -33px;\n}\n.flag.flag-ad {\n  background-position: 0 0;\n}\n.flag.flag-gf {\n  background-position: -224px -44px;\n}\n.flag.flag-eg {\n  background-position: -208px -33px;\n}\n.flag.flag-ly {\n  background-position: -128px -88px;\n}\n.flag.flag-ug {\n  background-position: -144px -154px;\n}\n.flag.flag-cf {\n  background-position: -96px -22px;\n}\n.flag.flag-ag {\n  background-position: -48px 0;\n}\n.flag.flag-nl {\n  background-position: -80px -110px;\n}\n.flag.flag-gq {\n  background-position: -96px -55px;\n}\n.flag.flag-sk {\n  background-position: -160px -132px;\n}\n.flag.flag-io {\n  background-position: -144px -66px;\n}\n.flag.flag-ar {\n  background-position: -144px 0;\n}\n.flag.flag-vc {\n  background-position: -240px -154px;\n}\n.flag.flag-ne {\n  background-position: -16px -110px;\n}\n.flag.flag-pa {\n  background-position: -192px -110px;\n}\n.flag.flag-ca {\n  background-position: -48px -22px;\n}\n.flag.flag-dk {\n  background-position: -112px -33px;\n}\n.flag.flag-somaliland {\n  background-position: -240px -132px;\n}\n.flag.flag-co {\n  background-position: -224px -22px;\n}\n.flag.flag-gb {\n  background-position: -176px -44px;\n}\n.flag.flag-af {\n  background-position: -32px 0;\n}\n.flag.flag-ni {\n  background-position: -64px -110px;\n}\n.flag.flag-za {\n  background-position: -176px -165px;\n}\n.flag.flag-jp {\n  background-position: -16px -77px;\n}\n.flag.flag-mv {\n  background-position: -160px -99px;\n}\n.flag.flag-gd {\n  background-position: -192px -44px;\n}\n.flag.flag-bt {\n  background-position: -224px -11px;\n}\n.flag.flag-de {\n  background-position: -80px -33px;\n}\n.flag.flag-scotland {\n  background-position: -48px -132px;\n}\n.flag.flag-kh {\n  background-position: -64px -77px;\n}\n.flag.flag-xk {\n  background-position: -128px -165px;\n}\n.flag.flag-gh {\n  background-position: 0 -55px;\n}\n.flag.flag-lv {\n  background-position: -112px -88px;\n}\n.flag.flag-qa {\n  background-position: -160px -121px;\n}\n.flag.flag-mp {\n  background-position: -64px -99px;\n}\n.flag.flag-ss {\n  background-position: -16px -143px;\n}\n.flag.flag-ga {\n  background-position: -160px -44px;\n}\n.flag.flag-er {\n  background-position: 0 -44px;\n}\n.flag.flag-mo {\n  background-position: -48px -99px;\n}\n.flag.flag-ve {\n  background-position: 0 -165px;\n}\n.flag.flag-ua {\n  background-position: -128px -154px;\n}\n.flag.flag-ls {\n  background-position: -64px -88px;\n}\n.flag.flag-pg {\n  background-position: -240px -110px;\n}\n.flag.flag-wales {\n  background-position: -80px -165px;\n}\n.flag.flag-re {\n  background-position: -176px -121px;\n}\n.flag.flag-gu {\n  background-position: -160px -55px;\n}\n.flag.flag-gs {\n  background-position: -128px -55px;\n}\n.flag.flag-ma {\n  background-position: -144px -88px;\n}\n.flag.flag-bs {\n  background-position: -208px -11px;\n}\n.flag.flag-es {\n  background-position: -16px -44px;\n}\n.flag.flag-pw {\n  background-position: -128px -121px;\n}\n.flag.flag-bw {\n  background-position: 0 -22px;\n}\n.flag.flag-zanzibar {\n  background-position: -192px -165px;\n}\n.flag.flag-li {\n  background-position: -16px -88px;\n}\n.flag.flag-mm {\n  background-position: -16px -99px;\n}\n.flag.flag-ke {\n  background-position: -32px -77px;\n}\n.flag.flag-sa {\n  background-position: 0 -132px;\n}\n.flag.flag-fk {\n  background-position: -96px -44px;\n}\n.flag.flag-bb {\n  background-position: -16px -11px;\n}\n.flag.flag-sl {\n  background-position: -176px -132px;\n}\n.flag.flag-wf {\n  background-position: -96px -165px;\n}\n.flag.flag-ki {\n  background-position: -80px -77px;\n}\n.flag.flag-ht {\n  background-position: -16px -66px;\n}\n.flag.flag-cn {\n  background-position: -208px -22px;\n}\n.flag.flag-uz {\n  background-position: -208px -154px;\n}\n.flag.flag-me {\n  background-position: -192px -88px;\n}\n.flag.flag-lk {\n  background-position: -32px -88px;\n}\n.flag.flag-lc {\n  background-position: 0 -88px;\n}\n.flag.flag-gy {\n  background-position: -192px -55px;\n}\n.flag.flag-lr {\n  background-position: -48px -88px;\n}\n.flag.flag-fj {\n  background-position: -80px -44px;\n}\n.flag.flag-sb {\n  background-position: -16px -132px;\n}\n.flag.flag-pf {\n  background-position: -224px -110px;\n}\n.flag.flag-yt {\n  background-position: -160px -165px;\n}\n.flag.flag-tr {\n  background-position: -48px -154px;\n}\n.flag.flag-vg {\n  background-position: -16px -165px;\n}\n.flag.flag-au {\n  background-position: -192px 0;\n}\n.flag.flag-pr {\n  background-position: -80px -121px;\n}\n.flag.flag-py {\n  background-position: -144px -121px;\n}\n.flag.flag-gl {\n  background-position: -32px -55px;\n}\n.flag.flag-tm {\n  background-position: 0 -154px;\n}\n.flag.flag-sv {\n  background-position: -48px -143px;\n}\n.flag.flag-fo {\n  background-position: -128px -44px;\n}\n.flag.flag-et {\n  background-position: -32px -44px;\n}\n.flag.flag-mw {\n  background-position: -176px -99px;\n}\n.flag.flag-ie {\n  background-position: -80px -66px;\n}\n.flag.flag-do {\n  background-position: -144px -33px;\n}\n.flag.flag-mq {\n  background-position: -80px -99px;\n}\n.flag.flag-as {\n  background-position: -160px 0;\n}\n.flag.flag-ck {\n  background-position: -160px -22px;\n}\n.flag.flag-gn {\n  background-position: -64px -55px;\n}\n.flag.flag-ng {\n  background-position: -48px -110px;\n}\n.flag.flag-ge {\n  background-position: -208px -44px;\n}\n.flag.flag-vu {\n  background-position: -64px -165px;\n}\n.flag.flag-kn {\n  background-position: -112px -77px;\n}\n.flag.flag-ps {\n  background-position: -96px -121px;\n}\n.flag.flag-fi {\n  background-position: -64px -44px;\n}\n.flag.flag-ro {\n  background-position: -192px -121px;\n}\n.flag.flag-mx {\n  background-position: -192px -99px;\n}\n.flag.flag-vn {\n  background-position: -48px -165px;\n}\n.flag.flag-sz {\n  background-position: -96px -143px;\n}\n.flag.flag-ky {\n  background-position: -192px -77px;\n}\n.flag.flag-bg {\n  background-position: -80px -11px;\n}\n.flag.flag-nf {\n  background-position: -32px -110px;\n}\n.flag.flag-pm {\n  background-position: -48px -121px;\n}\n.flag.flag-th {\n  background-position: -176px -143px;\n}\n.flag.flag-tf {\n  background-position: -144px -143px;\n}\n.flag.flag-il {\n  background-position: -96px -66px;\n}\n.flag.flag-br {\n  background-position: -192px -11px;\n}\n.flag.flag-tk {\n  background-position: -224px -143px;\n}\n.flag.flag-eu {\n  background-position: -48px -44px;\n}\n.flag.flag-at {\n  background-position: -176px 0;\n}\n.flag.flag-uy {\n  background-position: -192px -154px;\n}\n.flag.flag-is {\n  background-position: -192px -66px;\n}\n.flag.flag-ai {\n  background-position: -64px 0;\n}\n.flag.flag-gp {\n  background-position: -80px -55px;\n}\n.flag.flag-ao {\n  background-position: -128px 0;\n}\n.flag.flag-nu {\n  background-position: -144px -110px;\n}\n.flag.flag-so {\n  background-position: -224px -132px;\n}\n.flag.flag-nc {\n  background-position: 0 -110px;\n}\n.flag.flag-pk {\n  background-position: -16px -121px;\n}\n.flag.flag-it {\n  background-position: -208px -66px;\n}\n.flag.flag-la {\n  background-position: -224px -77px;\n}\n.flag.flag-aw {\n  background-position: -208px 0;\n}\n.flag.flag-am {\n  background-position: -96px 0;\n}\n.flag.flag-bo {\n  background-position: -176px -11px;\n}\n.flag.flag-bi {\n  background-position: -112px -11px;\n}\n.flag.flag-sx {\n  background-position: -64px -143px;\n}\n.flag.flag-eh {\n  background-position: -224px -33px;\n}\n.flag.flag-ye {\n  background-position: -144px -165px;\n}\n.flag.flag-kw {\n  background-position: -176px -77px;\n}\n.flag.flag-by {\n  background-position: -16px -22px;\n}\n.flag.flag-va {\n  background-position: -224px -154px;\n}\n.flag.flag-cy {\n  background-position: -48px -33px;\n}\n.flag.flag-my {\n  background-position: -208px -99px;\n}\n.flag.flag-jo {\n  background-position: 0 -77px;\n}\n.flag.flag-hk {\n  background-position: -208px -55px;\n}\n.flag.flag-ba {\n  background-position: 0 -11px;\n}\n.flag.flag-be {\n  background-position: -48px -11px;\n}\n.flag.flag-hn {\n  background-position: -240px -55px;\n}\n.flag.flag-mn {\n  background-position: -32px -99px;\n}\n.flag.flag-gg {\n  background-position: -240px -44px;\n}\n.flag.flag-td {\n  background-position: -128px -143px;\n}\n.flag.flag-um {\n  background-position: -160px -154px;\n}\n.flag.flag-dz {\n  background-position: -160px -33px;\n}\n.flag.flag-bm {\n  background-position: -144px -11px;\n}\n.flag.flag-hu {\n  background-position: -32px -66px;\n}\n.flag.flag-fm {\n  background-position: -112px -44px;\n}\n.flag.flag-sj {\n  background-position: -144px -132px;\n}\n.flag.flag-pt {\n  background-position: -112px -121px;\n}\n.flag.flag-hr {\n  background-position: 0 -66px;\n}\n.flag.flag-ch {\n  background-position: -128px -22px;\n}\n.flag.flag-ci {\n  background-position: -144px -22px;\n}\n.flag.flag-kz {\n  background-position: -208px -77px;\n}\n.flag.flag-az {\n  background-position: -240px 0;\n}\n.flag.flag-kg {\n  background-position: -48px -77px;\n}\n.flag.flag-ml {\n  background-position: 0 -99px;\n}\n.flag.flag-bz {\n  background-position: -32px -22px;\n}\n.flag.flag-im {\n  background-position: -112px -66px;\n}\n.flag.flag-ph {\n  background-position: 0 -121px;\n}\n.flag.flag-bv {\n  background-position: -240px -11px;\n}\n.flag.flag-gi {\n  background-position: -16px -55px;\n}\n.flag.flag-mr {\n  background-position: -96px -99px;\n}\n.flag.flag-rs {\n  background-position: -208px -121px;\n}\n.flag.flag-in {\n  background-position: -128px -66px;\n}\n.flag.flag-sd {\n  background-position: -64px -132px;\n}\n.flag.flag-cu {\n  background-position: 0 -33px;\n}\n.flag.flag-ax {\n  background-position: -224px 0;\n}\n.flag.flag-tt {\n  background-position: -64px -154px;\n}\n.flag.flag-mh {\n  background-position: -224px -88px;\n}\n.flag.flag-gm {\n  background-position: -48px -55px;\n}\n.flag.flag-catalonia {\n  background-position: -64px -22px;\n}\n.flag.flag-ms {\n  background-position: -112px -99px;\n}\n.flag.flag-mu {\n  background-position: -144px -99px;\n}\n.flag.flag-tw {\n  background-position: -96px -154px;\n}\n.flag.flag-tl {\n  background-position: -240px -143px;\n}\n.flag.flag-sy {\n  background-position: -80px -143px;\n}\n.flag.flag-na {\n  background-position: -240px -99px;\n}\n.flag.flag-km {\n  background-position: -96px -77px;\n}\n.flag.flag-mt {\n  background-position: -128px -99px;\n}\n.flag.flag-cv {\n  background-position: -16px -33px;\n}\n.flag.flag-sm {\n  background-position: -192px -132px;\n}\n.flag.flag-om {\n  background-position: -176px -110px;\n}\n.flag.flag-id {\n  background-position: -64px -66px;\n}\n.flag.flag-tn {\n  background-position: -16px -154px;\n}\n.flag.flag-mk {\n  background-position: -240px -88px;\n}\n.flag.flag-pl {\n  background-position: -32px -121px;\n}\n.flag.flag-bf {\n  background-position: -64px -11px;\n}\n.flag.flag-al {\n  background-position: -80px 0;\n}\n.flag.flag-england {\n  background-position: -240px -33px;\n}\n.flag.flag-cz {\n  background-position: -64px -33px;\n}\n.flag.flag-np {\n  background-position: -112px -110px;\n}\n.flag.flag-cr {\n  background-position: -240px -22px;\n}\n.flag.flag-si {\n  background-position: -128px -132px;\n}\n.flag.flag-no {\n  background-position: -96px -110px;\n}\n.flag.flag-je {\n  background-position: -224px -66px;\n}\n.flag.flag-mg {\n  background-position: -208px -88px;\n}\n.flag.flag-us {\n  background-position: -176px -154px;\n}\n.flag.flag-tibet {\n  background-position: -192px -143px;\n}\n.flag.flag-ec {\n  background-position: -176px -33px;\n}\n.flag.flag-dj {\n  background-position: -96px -33px;\n}\n.flag.flag-tc {\n  background-position: -112px -143px;\n}\n.flag.flag-sr {\n  background-position: 0 -143px;\n}\n.flag.flag-gr {\n  background-position: -112px -55px;\n}\n.flag.flag-sc {\n  background-position: -32px -132px;\n}\n.flag.flag-bh {\n  background-position: -96px -11px;\n}\n\n/* FLAG */\n@font-face {\n  font-family: \"icomoonWp\";\n  src: url(\"data:application/x-font-ttf;charset=utf-8;base64,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\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n  font-display: block;\n}\n[class^=icon-wp-],\n[class*=\" icon-wp-\"] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: \"icomoonWp\" !important;\n  speak: never;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.icon-wp-help:before {\n  content: \"\";\n}\n.icon-wp-battery-100-charge:before {\n  content: \"\";\n  color: #1bdd85;\n}\n.icon-wp-battery-81-99-charge:before {\n  content: \"\";\n  color: #1bdd85;\n}\n.icon-wp-battery-100:before {\n  content: \"\";\n  color: #1bdd85;\n}\n.icon-wp-battery-1-20-charge:before {\n  content: \"\";\n  color: #ef2066;\n}\n.icon-wp-battery-unknown:before {\n  content: \"\";\n  color: #999;\n}\n.icon-wp-battery-81-99:before {\n  content: \"\";\n  color: #1bdd85;\n}\n.icon-wp-battery-21-80-charge:before {\n  content: \"\";\n  color: #ffcf3a;\n}\n.icon-wp-battery-21-80:before {\n  content: \"\";\n  color: #ffcf3a;\n}\n.icon-wp-battery-1-20:before {\n  content: \"\";\n  color: #ef2066;\n}\n.icon-wp-arrow-select:before {\n  content: \"\";\n  color: #0074ff;\n}\n.icon-wp-trash-can:before {\n  content: \"\";\n  color: #7d8f9c;\n}\n.icon-wp-error:before {\n  content: \"\";\n  color: #ef2066;\n}\n.icon-wp-delete:before {\n  content: \"\";\n  color: #fff;\n}\n.icon-wp-edit:before {\n  content: \"\";\n  color: #fff;\n}\n.icon-wp-camera:before {\n  content: \"\";\n  color: #0074ff;\n}\n.icon-wp-warning-icon:before {\n  content: \"\";\n  color: #f6c216;\n}\n.icon-wp-whatsapp .path1:before {\n  content: \"\";\n  color: #4caf50;\n}\n.icon-wp-whatsapp .path2:before {\n  content: \"\";\n  margin-left: -1em;\n  color: #fafafa;\n}\n.icon-wp-wapp-api:before {\n  content: \"\";\n  color: #5da9dd;\n}\n.icon-wp-cog:before {\n  content: \"\";\n}\n.icon-wp-interactions:before {\n  content: \"\";\n}\n.icon-wp-remove:before {\n  content: \"\";\n}\n.icon-wp-msg-error:before {\n  content: \"\";\n}\n.icon-wp-qr-code_icon:before {\n  content: \"\";\n}\n.icon-wp-octa-settings:before {\n  content: \"\";\n}\n.icon-wp-Seta:before {\n  content: \"\";\n  color: #31a2ff;\n}\n.icon-wp-ninja .path1:before {\n  content: \"\";\n  color: #eaa607;\n}\n.icon-wp-ninja .path2:before {\n  content: \"\";\n  margin-left: -0.9931640625em;\n  color: #10110d;\n}\n.icon-wp-ninja .path3:before {\n  content: \"\";\n  margin-left: -0.9931640625em;\n  color: #efd8d2;\n}\n.icon-wp-ninja .path4:before {\n  content: \"\";\n  margin-left: -0.9931640625em;\n  color: #10110d;\n}\n.icon-wp-ninja .path5:before {\n  content: \"\";\n  margin-left: -0.9931640625em;\n  color: #10110d;\n}\n.icon-wp-ninja .path6:before {\n  content: \"\";\n  margin-left: -0.9931640625em;\n  color: #d32d2d;\n}\n.icon-wp-ninja .path7:before {\n  content: \"\";\n  margin-left: -0.9931640625em;\n  color: #d32d2d;\n}\n.icon-wp-ninja .path8:before {\n  content: \"\";\n  margin-left: -0.9931640625em;\n  color: #d32d2d;\n}\n.icon-wp-ninja .path9:before {\n  content: \"\";\n  margin-left: -0.9931640625em;\n  color: #d32d2d;\n}\n.icon-wp-ninja .path10:before {\n  content: \"\";\n  margin-left: -0.9931640625em;\n  color: #282a2a;\n}\n.icon-wp-ninja .path11:before {\n  content: \"\";\n  margin-left: -0.9931640625em;\n  color: #49494a;\n}\n.icon-wp-ninja .path12:before {\n  content: \"\";\n  margin-left: -0.9931640625em;\n  color: #d7d8da;\n}\n.icon-wp-ninja .path13:before {\n  content: \"\";\n  margin-left: -0.9931640625em;\n  color: #10110d;\n}\n.icon-wp-ninja .path14:before {\n  content: \"\";\n  margin-left: -0.9931640625em;\n  color: #d7d8da;\n}\n.icon-wp-ninja .path15:before {\n  content: \"\";\n  margin-left: -0.9931640625em;\n  color: #10110d;\n}\n.icon-wp-check-circle:before {\n  content: \"\";\n}\n\n/*# sourceMappingURL=App.vue.map */",
    map: {
      "version": 3,
      "sources": ["App.vue", "E:\\Octadesk\\octa-whatsapp-client\\src\\App.vue"],
      "names": [],
      "mappings": "AAAA,gBAAgB;AAChB;EACE,6BAA6B;EAC7B,y0yFAAy0yF;EACz0yF,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;AAEA;EACE,+BAA+B;EAC/B,6OAA6O;EAC7O,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,4BAA4B;EAC5B,2NAA2N;EAC3N,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;AACA,QAAQ;AACR;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;EACb,iCAAiC;EACjC,UAAU;AACZ;AACA;EACE,0CAA0C;EAC1C,kCAAkC;EAClC,mDAAmD;EACnD,6CAA6C;EAC7C,yCAAyC;EACzC,mCAAmC;AACrC;AACA;EACE,uCAAuC;EACvC,+BAA+B;AACjC;AAEA;ECFA,kBAAA;EDIE,gBAAgB;ECFlB,oCAAA;ADIA;ACFA;EDKE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,iDAAiD;EACjD,yCAAyC;EACzC,4BAA4B;EAC5B,UAAU;AACZ;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,iBAAiB;AACnB;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AAEA;;EAEE,gBAAgB;AAClB;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AAEA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AAEA;AACE;IACE,YAAY;IACZ,iBAAiB;AACnB;AAEA;IACE,kDAAkD;IAClD,0CAA0C;AAC5C;AAEA;IACE,YAAY;AACd;AAEA;IACE,YAAY;AACd;AACF;AACA;AACE;IACE,YAAY;AACd;AAEA;IACE,YAAY;AACd;AACF;AACA,QAAQ;AACR,YAAY;AACZ;;EAEE,uBAAuB;EACvB,kCAAkC;EAClC,4BAA4B;EAC5B,oCAAoC;AACtC;AACA;EACE,sBAAsB;EACtB,oCAAoC;AACtC;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,YAAY;AACZ,SAAS;AACT;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,cAAc;EACd,wBAAwB;AAC1B;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,aAAa;EACb,cAAc;EACd,YAAY;EACZ,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,kCAAkC;EAClC,4BAA4B;EAC5B,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,QAAQ;EACR,SAAS;EACT,aAAa;AACf;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,cAAc;AAChB;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,cAAc;AAChB;AACA;;EAEE,qBAAqB;AACvB;;AAEA,SAAS;AACT,YAAY;AACZ;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,YAAY;AACZ,WAAW;AACX;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,8BAA8B;EAC9B,sDAAsD;EACtD,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;AACd;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,+BAA+B;AACjC;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,oCAAoC;AACtC;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,wBAAwB;EACxB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,+CAA+C;EAC/C,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,aAAa;AACf;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,kCAAkC;EAClC,4BAA4B;EAC5B,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,QAAQ;EACR,SAAS;EACT,aAAa;AACf;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,YAAY;EACZ,QAAQ;EACR,SAAS;EACT,oBAAoB;EACpB,UAAU;EACV,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,UAAU;EACV,wBAAwB;EACxB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,oCAAoC;AACtC;;AAEA,WAAW;AACX,SAAS;AACT;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;AACA;EACE,kCAAkC;AACpC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,kCAAkC;AACpC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,kCAAkC;AACpC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,kCAAkC;AACpC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,kCAAkC;AACpC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,kCAAkC;AACpC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,kCAAkC;AACpC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;;AAEA,SAAS;AACT;EACE,wBAAwB;EACxB,4oaAA4oa;EAC5oa,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;EAEE,+EAA+E;EAC/E,mCAAmC;EACnC,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;EACd,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;AACpC;AAEA;EACE,YAAY;AACd;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;AAEA;EACE,YAAY;EACZ,WAAW;AACb;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;AC9zCA;EDi0CE,YAAY;EC/zCd,cAAA;ADi0CA;AC/zCA;EDk0CE,YAAY;EACZ,cAAc;AAChB;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;AAEA;EACE,YAAY;EACZ,WAAW;AACb;AAEA;EACE,YAAY;EACZ,WAAW;AACb;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;AAEA;EACE,YAAY;AACd;AAEA;EACE,YAAY;AACd;AAEA;EACE,YAAY;AACd;AAEA;EACE,YAAY;AACd;AAEA;EACE,YAAY;AACd;AAEA;EACE,YAAY;AACd;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,cAAc;AAChB;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,cAAc;AAChB;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,cAAc;AAChB;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,cAAc;AAChB;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,cAAc;AAChB;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,cAAc;AAChB;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,cAAc;AAChB;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,cAAc;AAChB;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,cAAc;AAChB;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,cAAc;AAChB;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,cAAc;AAChB;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,cAAc;AAChB;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,cAAc;AAChB;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,cAAc;AAChB;AAEA;EACE,YAAY;AACd;;AAEA,kCAAkC",
      "file": "App.vue",
      "sourcesContent": ["@charset \"UTF-8\";\n@font-face {\n  font-family: \"Niveau Grotesk\";\n  src: url(\"data:application/font-woff2;charset=utf-8;base64,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\") format(\"woff2\"), url(\"data:application/font-woff;charset=utf-8;base64,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\") format(\"woff\");\n  font-weight: bold;\n  font-style: normal;\n  font-display: swap;\n}\n* {\n  margin: 0px;\n  padding: 0px;\n  box-sizing: border-box;\n}\n\n@font-face {\n  font-family: \"HelveticaRegular\";\n  src: url(\"~@/assets/fonts/HelveticaRegular/HelveticaRegular.woff\") format(\"woff\"), url(\"~@/assets/fonts/HelveticaRegular/HelveticaRegular.woff2\") format(\"woff2\"), url(\"~@/assets/fonts/HelveticaRegular/HelveticaRegular.svg\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n  font-display: auto;\n}\n@font-face {\n  font-family: \"HelveticaBold\";\n  src: url(\"~@/assets/fonts/HelveticaBold/HelveticaBold.woff\") format(\"woff\"), url(\"~@/assets/fonts/HelveticaBold/HelveticaBold.woff2\") format(\"woff2\"), url(\"~@/assets/fonts/HelveticaBold/HelveticaBold.svg\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n  font-display: auto;\n}\n/*MODAL*/\n.modal {\n  display: none;\n  overflow: hidden;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1070;\n  -webkit-overflow-scrolling: touch;\n  outline: 0;\n}\n.modal.fade .modal-dialog {\n  -webkit-transform: translate3d(0, -25%, 0);\n  transform: translate3d(0, -25%, 0);\n  -webkit-transition: -webkit-transform 0.3s ease-out;\n  -moz-transition: -moz-transform 0.3s ease-out;\n  -o-transition: -o-transform 0.3s ease-out;\n  transition: transform 0.3s ease-out;\n}\n.modal.in .modal-dialog {\n  -webkit-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0);\n}\n\n.modal-open .modal {\n  overflow-x: hidden;\n  overflow-y: auto;\n  background: rgba(112, 112, 112, 0.8);\n}\n\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: 10px;\n}\n\n.modal-content {\n  position: relative;\n  background-color: #fff;\n  border-radius: 6px;\n  -webkit-box-shadow: 0 3px 9px rgba(0, 0, 0, 0.15);\n  box-shadow: 0 3px 9px rgba(0, 0, 0, 0.15);\n  background-clip: padding-box;\n  outline: 0;\n}\n\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1060;\n  background-color: #fff;\n}\n.modal-backdrop.fade {\n  opacity: 0;\n  filter: alpha(opacity=0);\n}\n.modal-backdrop.in {\n  opacity: 0.5;\n  filter: alpha(opacity=50);\n}\n\n.modal-icon {\n  width: 100%;\n  display: inline-block;\n  padding-top: 15px;\n}\n\n.modal-header {\n  padding: 15px;\n  min-height: 16.33px;\n}\n.modal-header .close {\n  margin-top: -2px;\n  float: right;\n  font-size: 24px;\n}\n\n.modal-title {\n  margin: 0;\n  line-height: 1.33;\n  font-family: Dosis, sans-serif;\n  font-size: 24px;\n}\n.modal-title small {\n  font-size: 14px;\n  display: block;\n  color: inherit;\n}\n.modal-title p {\n  margin: 10px 0 0;\n}\n\n.h4.modal-title,\nh4.modal-title {\n  font-weight: 300;\n}\n\n.modal-body {\n  position: relative;\n  padding: 15px;\n}\n.modal-body .list-header {\n  padding: 0 0 10px;\n}\n\n.modal-footer {\n  padding: 15px;\n}\n.modal-footer .btn + .btn {\n  margin-left: 5px;\n  margin-bottom: 0;\n}\n.modal-footer .btn-group .btn + .btn {\n  margin-left: -1px;\n}\n.modal-footer .btn-block + .btn-block {\n  margin-left: 0;\n}\n\n.modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll;\n}\n\n@media (min-width: 768px) {\n  .modal-dialog {\n    width: 600px;\n    margin: 30px auto;\n  }\n\n  .modal-content {\n    -webkit-box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);\n  }\n\n  .modal-sm {\n    width: 400px;\n  }\n\n  .modal-xs {\n    width: 300px;\n  }\n}\n@media (min-width: 992px) {\n  .modal-xl {\n    width: 980px;\n  }\n\n  .modal-lg {\n    width: 790px;\n  }\n}\n/*MODAL*/\n/* TOOLTIP */\ndiv.tooltip div.tooltip-arrow,\ndiv.tooltip div.tooltip-arrow:after {\n  bottom: -2px !important;\n  border-width: 6px 6px 0 !important;\n  margin-left: -6px !important;\n  border-top-color: #979797 !important;\n}\ndiv.tooltip div.tooltip-arrow:after {\n  bottom: 1px !important;\n  border-top-color: #000000 !important;\n}\ndiv.tooltip div.tooltip-inner {\n  text-align: center;\n  max-width: 280px;\n  box-shadow: none;\n  border: 1px solid #000000;\n  font-size: 12px;\n  line-height: 18px;\n  padding: 5px;\n  color: #ffffff;\n  border-radius: 10px;\n  background: #000000;\n}\n\n/* TOOLTIP */\n/* FORM */\ndiv.fields-control-wpp {\n  width: 100%;\n  position: relative;\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  flex-direction: column;\n}\ndiv.fields-control-wpp span.error-message {\n  font-size: 10px;\n  color: #ef2066;\n  margin: 5px 0px 0px 15px;\n}\ndiv.fields-control-wpp > label {\n  font-family: Helvetica;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 12px;\n  line-height: 14px;\n  color: #999999;\n}\ndiv.fields-control-wpp > div {\n  width: 100%;\n  position: relative;\n}\ndiv.fields-control-wpp > div:before {\n  font-family: \"icomoonWp\";\n  position: absolute;\n  top: 9px;\n  right: 14px;\n  font-size: 15px;\n  transition: 0.5s;\n  opacity: 0;\n  pointer-events: none;\n}\ndiv.fields-control-wpp > div > input, div.fields-control-wpp > div > textarea {\n  width: 100%;\n  padding: 10px;\n  color: #707070;\n  resize: none;\n  border: 1px solid #d7d7d7;\n  box-sizing: border-box;\n  border-radius: 15px;\n  transition: 0.5s;\n  background: #ffffff;\n}\ndiv.fields-control-wpp > div > input:focus, div.fields-control-wpp > div > textarea:focus {\n  border: 1px solid #4b9bfc;\n}\ndiv.fields-control-wpp > div > input:disabled, div.fields-control-wpp > div > input.disabled, div.fields-control-wpp > div > textarea:disabled, div.fields-control-wpp > div > textarea.disabled {\n  cursor: not-allowed;\n  color: #bfbfbf;\n  pointer-events: none;\n  background: #f0f0f0;\n}\ndiv.fields-control-wpp > div > input::placeholder, div.fields-control-wpp > div > textarea::placeholder {\n  color: #bfbfbf;\n}\ndiv.fields-control-wpp > div > input::-webkit-scrollbar, div.fields-control-wpp > div > textarea::-webkit-scrollbar {\n  width: 14px;\n  height: 18px;\n}\ndiv.fields-control-wpp > div > input::-webkit-scrollbar-thumb, div.fields-control-wpp > div > textarea::-webkit-scrollbar-thumb {\n  height: 5px;\n  border: 5px solid rgba(0, 0, 0, 0);\n  background-clip: padding-box;\n  border-radius: 7px;\n  background-color: #2775d3;\n}\ndiv.fields-control-wpp > div > input::-webkit-scrollbar-button, div.fields-control-wpp > div > textarea::-webkit-scrollbar-button {\n  width: 0;\n  height: 0;\n  display: none;\n}\ndiv.fields-control-wpp > div > input::-webkit-scrollbar-corner, div.fields-control-wpp > div > textarea::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\ndiv.fields-control-wpp > div input {\n  border-radius: 24px;\n}\ndiv.fields-control-wpp.validation > div:before {\n  opacity: 1;\n}\ndiv.fields-control-wpp.validation > div input,\ndiv.fields-control-wpp.validation > div textarea {\n  padding-right: 35px;\n}\ndiv.fields-control-wpp.has-error > div:before {\n  content: \"\";\n  color: #ef2066;\n}\ndiv.fields-control-wpp.has-error > div input,\ndiv.fields-control-wpp.has-error > div textarea {\n  border-color: #ef2066;\n}\ndiv.fields-control-wpp.success > div:before {\n  content: \"\";\n  color: #1bdd85;\n}\ndiv.fields-control-wpp.success > div input,\ndiv.fields-control-wpp.success > div textarea {\n  border-color: #1bdd85;\n}\n\n/* FORM */\n/* BUTTONS */\n.btn-control-wpp {\n  padding: 15px 25px;\n  height: 49px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50px;\n  border: 1px solid transparent;\n  font-family: Helvetica;\n  font-style: normal;\n  font-weight: bold;\n  font-size: 16px;\n  line-height: 18px;\n  text-align: center;\n  text-decoration: none !important;\n  transition: 0.5s;\n  background: transparent;\n}\n.btn-control-wpp.primary {\n  color: #ffffff;\n  background: #0074ff;\n}\n.btn-control-wpp.primary:hover:not(:disabled) {\n  background: #005dcc;\n}\n.btn-control-wpp.outline {\n  color: #0074ff;\n  border-color: #0074ff;\n}\n.btn-control-wpp.outline:hover:not(:disabled) {\n  color: #ffffff;\n  background: #0074ff;\n}\n.btn-control-wpp.outline:disabled {\n  color: #fff;\n}\n.btn-control-wpp.link {\n  font-weight: normal;\n  color: #999999;\n}\n.btn-control-wpp:disabled {\n  background: #eee;\n  border-color: transparent;\n  cursor: not-allowed;\n}\n\n/* BUTTONS */\n/* SELECT */\ndiv.v-select.select-control-wpp {\n  width: 100%;\n}\ndiv.v-select.select-control-wpp:before, div.v-select.select-control-wpp:after {\n  content: \"\";\n  width: 1px;\n  height: 24px;\n  position: absolute;\n  top: 16px;\n  opacity: 0;\n  background: #d7d7d7;\n}\ndiv.v-select.select-control-wpp:before {\n  left: 0px;\n}\ndiv.v-select.select-control-wpp:after {\n  right: 0px;\n}\ndiv.v-select.select-control-wpp .vs__search {\n  margin-top: 0;\n}\ndiv.v-select.select-control-wpp div.vs__dropdown-toggle {\n  border-radius: 24px !important;\n  border-bottom-color: rgba(60, 60, 60, 0.26) !important;\n  padding: 0px 10px;\n  height: 39px;\n  position: relative;\n  z-index: 2;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  transition: 0.5s;\n}\ndiv.v-select.select-control-wpp div.vs__dropdown-toggle div.vs__selected-options {\n  flex-basis: auto;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  padding: 0px;\n  width: 100%;\n  height: 100%;\n}\ndiv.v-select.select-control-wpp div.vs__dropdown-toggle div.vs__selected-options span.vs__selected,\ndiv.v-select.select-control-wpp div.vs__dropdown-toggle div.vs__selected-options input {\n  margin: 0px;\n  padding: 0px;\n  width: 100%;\n  height: 18px;\n  overflow: hidden;\n  font-size: 12px;\n  color: #707070;\n  background: transparent;\n}\ndiv.v-select.select-control-wpp div.vs__dropdown-toggle div.vs__selected-options input {\n  position: absolute;\n  top: 50%;\n  left: 0px;\n  transform: translate(0px, -50%);\n}\ndiv.v-select.select-control-wpp div.vs__dropdown-toggle div.vs__selected-options input ::placeholder {\n  color: #f0f0f0;\n}\ndiv.v-select.select-control-wpp div.vs__dropdown-toggle div.vs__actions {\n  padding: 0px;\n  margin-left: 10px;\n  width: 27px;\n  height: 27px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  background: rgba(212, 231, 255, 0.7);\n}\ndiv.v-select.select-control-wpp div.vs__dropdown-toggle div.vs__actions button.vs__clear {\n  display: none;\n}\ndiv.v-select.select-control-wpp div.vs__dropdown-toggle div.vs__actions:before {\n  content: \"\";\n  font-family: \"icomoonWp\";\n  content: \"\";\n  color: #0074ff;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin-top: 1px;\n  transform: translate(-50%, -50%) rotate(180deg);\n  font-size: 7px;\n  transition: 0.5s;\n}\ndiv.v-select.select-control-wpp div.vs__dropdown-toggle div.vs__actions svg {\n  fill: #0074ff;\n  display: none;\n}\ndiv.v-select.select-control-wpp > ul {\n  z-index: 1;\n  position: absolute;\n  top: 1px;\n  left: 0px;\n  max-height: 150px;\n  margin-top: 38px;\n  padding-top: 4px;\n  width: 100%;\n  border-top: none;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #d7d7d7;\n  border-top: none;\n  background: #fff;\n}\ndiv.v-select.select-control-wpp > ul::-webkit-scrollbar {\n  width: 14px;\n  height: 18px;\n}\ndiv.v-select.select-control-wpp > ul::-webkit-scrollbar-thumb {\n  height: 6px;\n  border: 4px solid rgba(0, 0, 0, 0);\n  background-clip: padding-box;\n  border-radius: 7px;\n  background-color: #2775d3;\n}\ndiv.v-select.select-control-wpp > ul::-webkit-scrollbar-button {\n  width: 0;\n  height: 0;\n  display: none;\n}\ndiv.v-select.select-control-wpp > ul::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\ndiv.v-select.select-control-wpp > ul li {\n  width: 100%;\n  font-size: 12px;\n  line-height: 25px;\n  color: #999999;\n  padding: 0px 13px;\n  margin: 6px 0px;\n  position: relative;\n  transition: 0.5s;\n}\ndiv.v-select.select-control-wpp > ul li.vs__dropdown-option--highlight {\n  background: none;\n}\ndiv.v-select.select-control-wpp > ul li:before, div.v-select.select-control-wpp > ul li:after {\n  content: \"\";\n  position: absolute;\n}\ndiv.v-select.select-control-wpp > ul li:before {\n  width: calc(100% - 12px);\n  height: 25px;\n  top: 0px;\n  left: 4px;\n  border-radius: 100px;\n  opacity: 0;\n  z-index: -1;\n  background: #f0f0f0;\n}\ndiv.v-select.select-control-wpp > ul li:not(:last-child):after {\n  bottom: -6px;\n  left: 10px;\n  width: calc(100% - 20px);\n  height: 1px;\n  background: #d7d7d7;\n}\ndiv.v-select.select-control-wpp > ul li.vs__dropdown-option--selected {\n  margin: 8px 0px;\n}\ndiv.v-select.select-control-wpp > ul li.vs__dropdown-option--selected:before {\n  opacity: 1;\n}\ndiv.v-select.select-control-wpp > ul li.vs__dropdown-option--selected:not(:last-child):after {\n  bottom: -8px;\n}\ndiv.v-select.select-control-wpp > ul li:hover:not(.vs__dropdown-option--selected) {\n  color: #0074ff;\n}\ndiv.v-select.select-control-wpp.vs--open div.vs__dropdown-toggle {\n  border: 1px solid #4b9bfc !important;\n}\ndiv.v-select.select-control-wpp.vs--open div.vs__dropdown-toggle div.vs__actions:before {\n  transform: translate(-50%, -50%) rotate(0deg);\n}\ndiv.v-select.select-control-wpp.vs--open:before, div.v-select.select-control-wpp.vs--open:after {\n  opacity: 1;\n}\ndiv.v-select.select-control-wpp.vs--disabled div.vs__dropdown-toggle {\n  cursor: not-allowed;\n  background: #f0f0f0;\n}\ndiv.v-select.select-control-wpp.vs--disabled div.vs__dropdown-toggle div.vs__selected-options span.vs__selected,\ndiv.v-select.select-control-wpp.vs--disabled div.vs__dropdown-toggle div.vs__selected-options input {\n  color: #bfbfbf;\n}\ndiv.v-select.select-control-wpp.success:not(.vs--open) div.vs__dropdown-toggle {\n  border: 1px solid #1bdd85 !important;\n}\n\n/* SELECT */\n/* FLAG */\n.flag {\n  display: inline-block;\n  width: 16px;\n  height: 11px;\n}\n.flag.flag-ws {\n  background-position: -112px -165px;\n}\n.flag.flag-kr {\n  background-position: -144px -77px;\n}\n.flag.flag-tv {\n  background-position: -80px -154px;\n}\n.flag.flag-pe {\n  background-position: -208px -110px;\n}\n.flag.flag-kp {\n  background-position: -128px -77px;\n}\n.flag.flag-bj {\n  background-position: -128px -11px;\n}\n.flag.flag-mc {\n  background-position: -160px -88px;\n}\n.flag.flag-cd {\n  background-position: -80px -22px;\n}\n.flag.flag-jm {\n  background-position: -240px -66px;\n}\n.flag.flag-rw {\n  background-position: -240px -121px;\n}\n.flag.flag-tg {\n  background-position: -160px -143px;\n}\n.flag.flag-mz {\n  background-position: -224px -99px;\n}\n.flag.flag-ic {\n  background-position: -48px -66px;\n}\n.flag.flag-sn {\n  background-position: -208px -132px;\n}\n.flag.flag-an {\n  background-position: -112px 0;\n}\n.flag.flag-sh {\n  background-position: -112px -132px;\n}\n.flag.flag-sg {\n  background-position: -96px -132px;\n}\n.flag.flag-to {\n  background-position: -32px -154px;\n}\n.flag.flag-fr {\n  background-position: -144px -44px;\n}\n.flag.flag-tz {\n  background-position: -112px -154px;\n}\n.flag.flag-nr {\n  background-position: -128px -110px;\n}\n.flag.flag-nz {\n  background-position: -160px -110px;\n}\n.flag.flag-hm {\n  background-position: -224px -55px;\n}\n.flag.flag-cg {\n  background-position: -112px -22px;\n}\n.flag.flag-st {\n  background-position: -32px -143px;\n}\n.flag.flag-cl {\n  background-position: -176px -22px;\n}\n.flag.flag-iq {\n  background-position: -160px -66px;\n}\n.flag.flag-tj {\n  background-position: -208px -143px;\n}\n.flag.flag-ru {\n  background-position: -224px -121px;\n}\n.flag.flag-md {\n  background-position: -176px -88px;\n}\n.flag.flag-cw {\n  background-position: -32px -33px;\n}\n.flag.flag-gt {\n  background-position: -144px -55px;\n}\n.flag.flag-cm {\n  background-position: -192px -22px;\n}\n.flag.flag-pn {\n  background-position: -64px -121px;\n}\n.flag.flag-vi {\n  background-position: -32px -165px;\n}\n.flag.flag-ir {\n  background-position: -176px -66px;\n}\n.flag.flag-se {\n  background-position: -80px -132px;\n}\n.flag.flag-lt {\n  background-position: -80px -88px;\n}\n.flag.flag-gw {\n  background-position: -176px -55px;\n}\n.flag.flag-dm {\n  background-position: -128px -33px;\n}\n.flag.flag-bd {\n  background-position: -32px -11px;\n}\n.flag.flag-kurdistan {\n  background-position: -160px -77px;\n}\n.flag.flag-ae {\n  background-position: -16px 0;\n}\n.flag.flag-zm {\n  background-position: -208px -165px;\n}\n.flag.flag-bn {\n  background-position: -160px -11px;\n}\n.flag.flag-lb {\n  background-position: -240px -77px;\n}\n.flag.flag-zw {\n  background-position: -224px -165px;\n}\n.flag.flag-lu {\n  background-position: -96px -88px;\n}\n.flag.flag-ee {\n  background-position: -192px -33px;\n}\n.flag.flag-ad {\n  background-position: 0 0;\n}\n.flag.flag-gf {\n  background-position: -224px -44px;\n}\n.flag.flag-eg {\n  background-position: -208px -33px;\n}\n.flag.flag-ly {\n  background-position: -128px -88px;\n}\n.flag.flag-ug {\n  background-position: -144px -154px;\n}\n.flag.flag-cf {\n  background-position: -96px -22px;\n}\n.flag.flag-ag {\n  background-position: -48px 0;\n}\n.flag.flag-nl {\n  background-position: -80px -110px;\n}\n.flag.flag-gq {\n  background-position: -96px -55px;\n}\n.flag.flag-sk {\n  background-position: -160px -132px;\n}\n.flag.flag-io {\n  background-position: -144px -66px;\n}\n.flag.flag-ar {\n  background-position: -144px 0;\n}\n.flag.flag-vc {\n  background-position: -240px -154px;\n}\n.flag.flag-ne {\n  background-position: -16px -110px;\n}\n.flag.flag-pa {\n  background-position: -192px -110px;\n}\n.flag.flag-ca {\n  background-position: -48px -22px;\n}\n.flag.flag-dk {\n  background-position: -112px -33px;\n}\n.flag.flag-somaliland {\n  background-position: -240px -132px;\n}\n.flag.flag-co {\n  background-position: -224px -22px;\n}\n.flag.flag-gb {\n  background-position: -176px -44px;\n}\n.flag.flag-af {\n  background-position: -32px 0;\n}\n.flag.flag-ni {\n  background-position: -64px -110px;\n}\n.flag.flag-za {\n  background-position: -176px -165px;\n}\n.flag.flag-jp {\n  background-position: -16px -77px;\n}\n.flag.flag-mv {\n  background-position: -160px -99px;\n}\n.flag.flag-gd {\n  background-position: -192px -44px;\n}\n.flag.flag-bt {\n  background-position: -224px -11px;\n}\n.flag.flag-de {\n  background-position: -80px -33px;\n}\n.flag.flag-scotland {\n  background-position: -48px -132px;\n}\n.flag.flag-kh {\n  background-position: -64px -77px;\n}\n.flag.flag-xk {\n  background-position: -128px -165px;\n}\n.flag.flag-gh {\n  background-position: 0 -55px;\n}\n.flag.flag-lv {\n  background-position: -112px -88px;\n}\n.flag.flag-qa {\n  background-position: -160px -121px;\n}\n.flag.flag-mp {\n  background-position: -64px -99px;\n}\n.flag.flag-ss {\n  background-position: -16px -143px;\n}\n.flag.flag-ga {\n  background-position: -160px -44px;\n}\n.flag.flag-er {\n  background-position: 0 -44px;\n}\n.flag.flag-mo {\n  background-position: -48px -99px;\n}\n.flag.flag-ve {\n  background-position: 0 -165px;\n}\n.flag.flag-ua {\n  background-position: -128px -154px;\n}\n.flag.flag-ls {\n  background-position: -64px -88px;\n}\n.flag.flag-pg {\n  background-position: -240px -110px;\n}\n.flag.flag-wales {\n  background-position: -80px -165px;\n}\n.flag.flag-re {\n  background-position: -176px -121px;\n}\n.flag.flag-gu {\n  background-position: -160px -55px;\n}\n.flag.flag-gs {\n  background-position: -128px -55px;\n}\n.flag.flag-ma {\n  background-position: -144px -88px;\n}\n.flag.flag-bs {\n  background-position: -208px -11px;\n}\n.flag.flag-es {\n  background-position: -16px -44px;\n}\n.flag.flag-pw {\n  background-position: -128px -121px;\n}\n.flag.flag-bw {\n  background-position: 0 -22px;\n}\n.flag.flag-zanzibar {\n  background-position: -192px -165px;\n}\n.flag.flag-li {\n  background-position: -16px -88px;\n}\n.flag.flag-mm {\n  background-position: -16px -99px;\n}\n.flag.flag-ke {\n  background-position: -32px -77px;\n}\n.flag.flag-sa {\n  background-position: 0 -132px;\n}\n.flag.flag-fk {\n  background-position: -96px -44px;\n}\n.flag.flag-bb {\n  background-position: -16px -11px;\n}\n.flag.flag-sl {\n  background-position: -176px -132px;\n}\n.flag.flag-wf {\n  background-position: -96px -165px;\n}\n.flag.flag-ki {\n  background-position: -80px -77px;\n}\n.flag.flag-ht {\n  background-position: -16px -66px;\n}\n.flag.flag-cn {\n  background-position: -208px -22px;\n}\n.flag.flag-uz {\n  background-position: -208px -154px;\n}\n.flag.flag-me {\n  background-position: -192px -88px;\n}\n.flag.flag-lk {\n  background-position: -32px -88px;\n}\n.flag.flag-lc {\n  background-position: 0 -88px;\n}\n.flag.flag-gy {\n  background-position: -192px -55px;\n}\n.flag.flag-lr {\n  background-position: -48px -88px;\n}\n.flag.flag-fj {\n  background-position: -80px -44px;\n}\n.flag.flag-sb {\n  background-position: -16px -132px;\n}\n.flag.flag-pf {\n  background-position: -224px -110px;\n}\n.flag.flag-yt {\n  background-position: -160px -165px;\n}\n.flag.flag-tr {\n  background-position: -48px -154px;\n}\n.flag.flag-vg {\n  background-position: -16px -165px;\n}\n.flag.flag-au {\n  background-position: -192px 0;\n}\n.flag.flag-pr {\n  background-position: -80px -121px;\n}\n.flag.flag-py {\n  background-position: -144px -121px;\n}\n.flag.flag-gl {\n  background-position: -32px -55px;\n}\n.flag.flag-tm {\n  background-position: 0 -154px;\n}\n.flag.flag-sv {\n  background-position: -48px -143px;\n}\n.flag.flag-fo {\n  background-position: -128px -44px;\n}\n.flag.flag-et {\n  background-position: -32px -44px;\n}\n.flag.flag-mw {\n  background-position: -176px -99px;\n}\n.flag.flag-ie {\n  background-position: -80px -66px;\n}\n.flag.flag-do {\n  background-position: -144px -33px;\n}\n.flag.flag-mq {\n  background-position: -80px -99px;\n}\n.flag.flag-as {\n  background-position: -160px 0;\n}\n.flag.flag-ck {\n  background-position: -160px -22px;\n}\n.flag.flag-gn {\n  background-position: -64px -55px;\n}\n.flag.flag-ng {\n  background-position: -48px -110px;\n}\n.flag.flag-ge {\n  background-position: -208px -44px;\n}\n.flag.flag-vu {\n  background-position: -64px -165px;\n}\n.flag.flag-kn {\n  background-position: -112px -77px;\n}\n.flag.flag-ps {\n  background-position: -96px -121px;\n}\n.flag.flag-fi {\n  background-position: -64px -44px;\n}\n.flag.flag-ro {\n  background-position: -192px -121px;\n}\n.flag.flag-mx {\n  background-position: -192px -99px;\n}\n.flag.flag-vn {\n  background-position: -48px -165px;\n}\n.flag.flag-sz {\n  background-position: -96px -143px;\n}\n.flag.flag-ky {\n  background-position: -192px -77px;\n}\n.flag.flag-bg {\n  background-position: -80px -11px;\n}\n.flag.flag-nf {\n  background-position: -32px -110px;\n}\n.flag.flag-pm {\n  background-position: -48px -121px;\n}\n.flag.flag-th {\n  background-position: -176px -143px;\n}\n.flag.flag-tf {\n  background-position: -144px -143px;\n}\n.flag.flag-il {\n  background-position: -96px -66px;\n}\n.flag.flag-br {\n  background-position: -192px -11px;\n}\n.flag.flag-tk {\n  background-position: -224px -143px;\n}\n.flag.flag-eu {\n  background-position: -48px -44px;\n}\n.flag.flag-at {\n  background-position: -176px 0;\n}\n.flag.flag-uy {\n  background-position: -192px -154px;\n}\n.flag.flag-is {\n  background-position: -192px -66px;\n}\n.flag.flag-ai {\n  background-position: -64px 0;\n}\n.flag.flag-gp {\n  background-position: -80px -55px;\n}\n.flag.flag-ao {\n  background-position: -128px 0;\n}\n.flag.flag-nu {\n  background-position: -144px -110px;\n}\n.flag.flag-so {\n  background-position: -224px -132px;\n}\n.flag.flag-nc {\n  background-position: 0 -110px;\n}\n.flag.flag-pk {\n  background-position: -16px -121px;\n}\n.flag.flag-it {\n  background-position: -208px -66px;\n}\n.flag.flag-la {\n  background-position: -224px -77px;\n}\n.flag.flag-aw {\n  background-position: -208px 0;\n}\n.flag.flag-am {\n  background-position: -96px 0;\n}\n.flag.flag-bo {\n  background-position: -176px -11px;\n}\n.flag.flag-bi {\n  background-position: -112px -11px;\n}\n.flag.flag-sx {\n  background-position: -64px -143px;\n}\n.flag.flag-eh {\n  background-position: -224px -33px;\n}\n.flag.flag-ye {\n  background-position: -144px -165px;\n}\n.flag.flag-kw {\n  background-position: -176px -77px;\n}\n.flag.flag-by {\n  background-position: -16px -22px;\n}\n.flag.flag-va {\n  background-position: -224px -154px;\n}\n.flag.flag-cy {\n  background-position: -48px -33px;\n}\n.flag.flag-my {\n  background-position: -208px -99px;\n}\n.flag.flag-jo {\n  background-position: 0 -77px;\n}\n.flag.flag-hk {\n  background-position: -208px -55px;\n}\n.flag.flag-ba {\n  background-position: 0 -11px;\n}\n.flag.flag-be {\n  background-position: -48px -11px;\n}\n.flag.flag-hn {\n  background-position: -240px -55px;\n}\n.flag.flag-mn {\n  background-position: -32px -99px;\n}\n.flag.flag-gg {\n  background-position: -240px -44px;\n}\n.flag.flag-td {\n  background-position: -128px -143px;\n}\n.flag.flag-um {\n  background-position: -160px -154px;\n}\n.flag.flag-dz {\n  background-position: -160px -33px;\n}\n.flag.flag-bm {\n  background-position: -144px -11px;\n}\n.flag.flag-hu {\n  background-position: -32px -66px;\n}\n.flag.flag-fm {\n  background-position: -112px -44px;\n}\n.flag.flag-sj {\n  background-position: -144px -132px;\n}\n.flag.flag-pt {\n  background-position: -112px -121px;\n}\n.flag.flag-hr {\n  background-position: 0 -66px;\n}\n.flag.flag-ch {\n  background-position: -128px -22px;\n}\n.flag.flag-ci {\n  background-position: -144px -22px;\n}\n.flag.flag-kz {\n  background-position: -208px -77px;\n}\n.flag.flag-az {\n  background-position: -240px 0;\n}\n.flag.flag-kg {\n  background-position: -48px -77px;\n}\n.flag.flag-ml {\n  background-position: 0 -99px;\n}\n.flag.flag-bz {\n  background-position: -32px -22px;\n}\n.flag.flag-im {\n  background-position: -112px -66px;\n}\n.flag.flag-ph {\n  background-position: 0 -121px;\n}\n.flag.flag-bv {\n  background-position: -240px -11px;\n}\n.flag.flag-gi {\n  background-position: -16px -55px;\n}\n.flag.flag-mr {\n  background-position: -96px -99px;\n}\n.flag.flag-rs {\n  background-position: -208px -121px;\n}\n.flag.flag-in {\n  background-position: -128px -66px;\n}\n.flag.flag-sd {\n  background-position: -64px -132px;\n}\n.flag.flag-cu {\n  background-position: 0 -33px;\n}\n.flag.flag-ax {\n  background-position: -224px 0;\n}\n.flag.flag-tt {\n  background-position: -64px -154px;\n}\n.flag.flag-mh {\n  background-position: -224px -88px;\n}\n.flag.flag-gm {\n  background-position: -48px -55px;\n}\n.flag.flag-catalonia {\n  background-position: -64px -22px;\n}\n.flag.flag-ms {\n  background-position: -112px -99px;\n}\n.flag.flag-mu {\n  background-position: -144px -99px;\n}\n.flag.flag-tw {\n  background-position: -96px -154px;\n}\n.flag.flag-tl {\n  background-position: -240px -143px;\n}\n.flag.flag-sy {\n  background-position: -80px -143px;\n}\n.flag.flag-na {\n  background-position: -240px -99px;\n}\n.flag.flag-km {\n  background-position: -96px -77px;\n}\n.flag.flag-mt {\n  background-position: -128px -99px;\n}\n.flag.flag-cv {\n  background-position: -16px -33px;\n}\n.flag.flag-sm {\n  background-position: -192px -132px;\n}\n.flag.flag-om {\n  background-position: -176px -110px;\n}\n.flag.flag-id {\n  background-position: -64px -66px;\n}\n.flag.flag-tn {\n  background-position: -16px -154px;\n}\n.flag.flag-mk {\n  background-position: -240px -88px;\n}\n.flag.flag-pl {\n  background-position: -32px -121px;\n}\n.flag.flag-bf {\n  background-position: -64px -11px;\n}\n.flag.flag-al {\n  background-position: -80px 0;\n}\n.flag.flag-england {\n  background-position: -240px -33px;\n}\n.flag.flag-cz {\n  background-position: -64px -33px;\n}\n.flag.flag-np {\n  background-position: -112px -110px;\n}\n.flag.flag-cr {\n  background-position: -240px -22px;\n}\n.flag.flag-si {\n  background-position: -128px -132px;\n}\n.flag.flag-no {\n  background-position: -96px -110px;\n}\n.flag.flag-je {\n  background-position: -224px -66px;\n}\n.flag.flag-mg {\n  background-position: -208px -88px;\n}\n.flag.flag-us {\n  background-position: -176px -154px;\n}\n.flag.flag-tibet {\n  background-position: -192px -143px;\n}\n.flag.flag-ec {\n  background-position: -176px -33px;\n}\n.flag.flag-dj {\n  background-position: -96px -33px;\n}\n.flag.flag-tc {\n  background-position: -112px -143px;\n}\n.flag.flag-sr {\n  background-position: 0 -143px;\n}\n.flag.flag-gr {\n  background-position: -112px -55px;\n}\n.flag.flag-sc {\n  background-position: -32px -132px;\n}\n.flag.flag-bh {\n  background-position: -96px -11px;\n}\n\n/* FLAG */\n@font-face {\n  font-family: \"icomoonWp\";\n  src: url(\"data:application/x-font-ttf;charset=utf-8;base64,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\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n  font-display: block;\n}\n[class^=icon-wp-],\n[class*=\" icon-wp-\"] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: \"icomoonWp\" !important;\n  speak: never;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.icon-wp-help:before {\n  content: \"\";\n}\n\n.icon-wp-battery-100-charge:before {\n  content: \"\";\n  color: #1bdd85;\n}\n\n.icon-wp-battery-81-99-charge:before {\n  content: \"\";\n  color: #1bdd85;\n}\n\n.icon-wp-battery-100:before {\n  content: \"\";\n  color: #1bdd85;\n}\n\n.icon-wp-battery-1-20-charge:before {\n  content: \"\";\n  color: #ef2066;\n}\n\n.icon-wp-battery-unknown:before {\n  content: \"\";\n  color: #999;\n}\n\n.icon-wp-battery-81-99:before {\n  content: \"\";\n  color: #1bdd85;\n}\n\n.icon-wp-battery-21-80-charge:before {\n  content: \"\";\n  color: #ffcf3a;\n}\n\n.icon-wp-battery-21-80:before {\n  content: \"\";\n  color: #ffcf3a;\n}\n\n.icon-wp-battery-1-20:before {\n  content: \"\";\n  color: #ef2066;\n}\n\n.icon-wp-arrow-select:before {\n  content: \"\";\n  color: #0074ff;\n}\n\n.icon-wp-trash-can:before {\n  content: \"\";\n  color: #7d8f9c;\n}\n\n.icon-wp-error:before {\n  content: \"\";\n  color: #ef2066;\n}\n\n.icon-wp-delete:before {\n  content: \"\";\n  color: #fff;\n}\n\n.icon-wp-edit:before {\n  content: \"\";\n  color: #fff;\n}\n\n.icon-wp-camera:before {\n  content: \"\";\n  color: #0074ff;\n}\n\n.icon-wp-warning-icon:before {\n  content: \"\";\n  color: #f6c216;\n}\n\n.icon-wp-whatsapp .path1:before {\n  content: \"\";\n  color: #4caf50;\n}\n\n.icon-wp-whatsapp .path2:before {\n  content: \"\";\n  margin-left: -1em;\n  color: #fafafa;\n}\n\n.icon-wp-wapp-api:before {\n  content: \"\";\n  color: #5da9dd;\n}\n\n.icon-wp-cog:before {\n  content: \"\";\n}\n\n.icon-wp-interactions:before {\n  content: \"\";\n}\n\n.icon-wp-remove:before {\n  content: \"\";\n}\n\n.icon-wp-msg-error:before {\n  content: \"\";\n}\n\n.icon-wp-qr-code_icon:before {\n  content: \"\";\n}\n\n.icon-wp-octa-settings:before {\n  content: \"\";\n}\n\n.icon-wp-Seta:before {\n  content: \"\";\n  color: #31a2ff;\n}\n\n.icon-wp-ninja .path1:before {\n  content: \"\";\n  color: #eaa607;\n}\n\n.icon-wp-ninja .path2:before {\n  content: \"\";\n  margin-left: -0.9931640625em;\n  color: #10110d;\n}\n\n.icon-wp-ninja .path3:before {\n  content: \"\";\n  margin-left: -0.9931640625em;\n  color: #efd8d2;\n}\n\n.icon-wp-ninja .path4:before {\n  content: \"\";\n  margin-left: -0.9931640625em;\n  color: #10110d;\n}\n\n.icon-wp-ninja .path5:before {\n  content: \"\";\n  margin-left: -0.9931640625em;\n  color: #10110d;\n}\n\n.icon-wp-ninja .path6:before {\n  content: \"\";\n  margin-left: -0.9931640625em;\n  color: #d32d2d;\n}\n\n.icon-wp-ninja .path7:before {\n  content: \"\";\n  margin-left: -0.9931640625em;\n  color: #d32d2d;\n}\n\n.icon-wp-ninja .path8:before {\n  content: \"\";\n  margin-left: -0.9931640625em;\n  color: #d32d2d;\n}\n\n.icon-wp-ninja .path9:before {\n  content: \"\";\n  margin-left: -0.9931640625em;\n  color: #d32d2d;\n}\n\n.icon-wp-ninja .path10:before {\n  content: \"\";\n  margin-left: -0.9931640625em;\n  color: #282a2a;\n}\n\n.icon-wp-ninja .path11:before {\n  content: \"\";\n  margin-left: -0.9931640625em;\n  color: #49494a;\n}\n\n.icon-wp-ninja .path12:before {\n  content: \"\";\n  margin-left: -0.9931640625em;\n  color: #d7d8da;\n}\n\n.icon-wp-ninja .path13:before {\n  content: \"\";\n  margin-left: -0.9931640625em;\n  color: #10110d;\n}\n\n.icon-wp-ninja .path14:before {\n  content: \"\";\n  margin-left: -0.9931640625em;\n  color: #d7d8da;\n}\n\n.icon-wp-ninja .path15:before {\n  content: \"\";\n  margin-left: -0.9931640625em;\n  color: #10110d;\n}\n\n.icon-wp-check-circle:before {\n  content: \"\";\n}\n\n/*# sourceMappingURL=App.vue.map */", "<template>\r\n  <component :is=\"name\" v-if=\"name\" :n2Team=\"n2Team\" />\r\n\r\n  <router-view v-else />\r\n</template>\r\n\r\n<script>\r\n  import listNumbers from '@/app/list-numbers/components/List.vue'\r\n\r\n  import whatsappBar from '@/app/bar/components/Bar.vue'\r\n\r\n  import { mapActions } from 'vuex'\r\n\r\n  import store from '@/store'\r\n\r\n  export default {\r\n    name: 'App',\r\n    store,\r\n    props: {\r\n      name: {\r\n        type: String,\r\n        required: false,\r\n        default: undefined\r\n      },\r\n      n2Team: {\r\n        type: Boolean,\r\n        required: false,\r\n        default: false\r\n      }\r\n    },\r\n    components: {\r\n      listNumbers,\r\n      whatsappBar\r\n    },\r\n    methods: {\r\n      ...mapActions([\r\n        'wppSetUserLogged',\r\n        'wppSetUserToken',\r\n        'wppSetSubdomainStatus'\r\n      ])\r\n    },\r\n    mounted() {\r\n      this.wppSetUserLogged()\r\n\r\n      this.wppSetUserToken()\r\n\r\n      this.wppSetSubdomainStatus()\r\n    }\r\n  }\r\n</script>\r\n\r\n<style lang=\"scss\">\r\n  @import './assets/fonts.scss';\r\n\r\n  @import './assets/style.scss';\r\n\r\n  @import './assets/icons.scss';\r\n</style>\r\n"]
    },
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$r = undefined;
/* module identifier */

var __vue_module_identifier__$r = undefined;
/* functional template */

var __vue_is_functional_template__$r = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$r = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$p,
  staticRenderFns: __vue_staticRenderFns__$p
}, __vue_inject_styles__$r, __vue_script__$n, __vue_scope_id__$r, __vue_is_functional_template__$r, __vue_module_identifier__$r, false, createInjector, undefined, undefined);

export default __vue_component__$r;



//////////////////
// WEBPACK FOOTER
// ./~/octa-whatsapp/dist/whatsapp-modal.esm.js
// module id = bjd2
// module chunks = 1